import { getAddress, solidityKeccak256 } from "ethers/lib/utils";
import { Buffer } from 'buffer';
import React from "react";
import keccak256 from "keccak256"; // Keccak256 hashing
import MerkleTree from "merkletreejs"; // MerkleTree.js
import { toast } from "react-toastify";
import { parseUnits } from "viem";

export const notifySuccess = (text: string) => {
    toast.success(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const notifyError = (text: string) => {
    toast.error(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const notifyInfo = (text: string) => {
    toast.info(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const notifyWarning = (text: string) => {
    toast.warn(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const AIRDROP_USERS_JSON: any = {
    decimals: 18,
    airdrop: {
        "0xF3fA7537fBB6995C2B37049c5637b10938337644": 6128094.67,
        "0xedEd6a22bf714d4B19b7e7bC1CA0BCF88956751c": 3772106.58,
        "0xF5e2c62B7eEcE06957850e25C2cbA336D15dC318": 3225199.55,
        "0x4172b1eBA109b4FA343563E28Fc61dE2D1BE6EC6": 2419076.831497346,
        "0xe439944E07626cdF9BB26789cb56363053ABE51a": 2340448.76,
        "0xCAfc58De1E6A071790eFbB6B83b35397023E1544": 2334476.13,
        "0x137a917dE1E84CdacEEF8E710fB8cfd35E249951": 1879454.59,
        "0xF368d43f148e1803eC793670183b0CA6a07d3898": 1679197.8,
        "0x972698bF61E2377B5c45B3038D85d04981ddb48c": 1676837.99,
        "0x58dfDBeE1d0d157AdeD161c16bd40A61bD15DEaB": 1554083.98,
        "0x88195faa599b09f1252aC6adD1Fa46555E7c7e24": 1387247.51,
        "0x17742fC251c3010022B1A57C8106DBe779eBD5ff": 1353608.74,
        "0x244A4a90e148Ec318a85f8C138A274e16FFE3032": 1249009.62,
        "0x7fc5969655b115BaE4ee6F5DBBbC5bBDF2F2cf05": 1467126.09,
        "0xc89C3F23994A90491972bf98A57E5Ed25BbF632D": 1176550.56,
        "0x948530E6514CF572bcb5D64f56fa9C8176138051": 1133919.02,
        "0x40D1065C4097F297b745A3DB53025e6C2C27729a": 1048815.36,
        "0x84912149f93D963ad5Ddc3c2781B1950d160a4DA": 1043841.54,
        "0x3Bc29A55caB8C3dDA3f55dcF1Df54BdeeEaDe334": 1033982.43,
        "0x791f1910D74D32e48C38Fd4285739ab491809AE5": 1020884.44,
        "0xf7485f62376834169E2ec7A15110e1877C720af9": 1003679.01,
        "0x1E661423fC2a76017ECE0fF91BC1Ea72132b4Af8": 996785.63,
        "0x1feE198A3D28B2419bf0Ab4BBbd6cC8f75368216": 967399.23,
        "0x4b562ce51b27bc70932cB842d6f99b4Da49F6A4A": 874873.29,
        "0x43417516e73eB7ed2F907D95A404Ccc41Ae4a819": 728144.41,
        "0x7371c26b231ff171452cDbE4c811147e911C4853": 727301.71,
        "0x28aa4F9ffe21365473B64C161b566C3CdeAD0108": 645683.66,
        "0x71f6f4b0511E97291076dc8E2C7c3C8F246399DB": 618355.88,
        "0xdFb06147A4Bd5A3D66824a1a717Cc6A06e6aC543": 852517.1825835736,
        "0x07cd1301A2c2aD5539c5AdE5D9De73289b95192D": 570725.57,
        "0x71ae112a1842d0C719185e9b8D0CAaFA4E00789B": 517890.54,
        "0x944F7C1454909EB40689b32c173eB2869e6b4CbE": 509586.57,
        "0x07dcC966Db0ed3b4461db91EAb4b8F89C4493FEa": 499771.22,
        "0x97A86cEC606172B8B3cf933c0457E32a3e485b7b": 496271.27,
        "0x91841c28dA9D90537dA49d8E25A83e64d579cC73": 521301.9171571589,
        "0x6Be841690a241f2A262bfFB1Ca843f3124bbC83f": 491836.52,
        "0xf5841Ccb80c08dfcf85Eb7F260a64528b9B4bC04": 486947.81,
        "0x29e2Fa98D5DBb014Ab212e03A82451d20ea52C6F": 483742.42,
        "0x6B924183307Ef2E529dB662F80200611328A0CbD": 477715.01,
        "0x6d757dA4232541633b211CeC775535331B22DFa0": 475093.34,
        "0xCE29ECB0D2d8c8f0126ED923C50A35cFb0B613A8": 471521.86,
        "0x011b0a055E02425461A1ae95B30F483c4fF05bE7": 462435.04,
        "0x80005199A622F4346C9844F2c88B713b9037dCA9": 462231.14,
        "0xd6f8f76EF075e9B585a847B730C0531C1354671A": 461287.38,
        "0x07892E184A229bFC949F2db4F9D00c9C77B53afd": 447548.5711133463,
        "0x86519a5aBFA7F735f489f43CC977b250aA0a083f": 430468.52,
        "0x00b7bB87840eeC266fb6388eDdADCa60B40965af": 426578.93,
        "0x8D6cCacDe4B6FAD270263C3BF2CFffc716D05C78": 391965.77,
        "0x9fa72884331f729EfDC5c1d5F62E1e2A7BFCbc21": 349286.96,
        "0xD7090ADBE319D7F726D498F647247aF38c20E8ce": 337975.53,
        "0xB3bfB32977cFd6200AB9537E3703e501d8381c9B": 336695.89,
        "0x924caFec4F967BE5df085Ad94d8d50574F9a2BB0": 333157.64,
        "0xcD7D4B564F224B9f856eEaf3Cd76e7577d04B008": 331842.9,
        "0xC61BAE0d509318BF45F31e605277cA2B22302A13": 331009.78,
        "0xAd1545c2969003052F8b9A5817D3240538048214": 320349.61,
        "0xD204E3dC1937d3a30fc6F20ABc48AC5506C94D1E": 317469.88,
        "0x1d1CfD4FfB8cFD0A903A38c3B41D593369B46103": 313633.13,
        "0xCD7ACE4667Be57927140D3B9ec157f0cFA3FD371": 302136.35,
        "0x23E0ddE663c937855FacFFd1453b8F29038F5939": 292709.94,
        "0xC73DF1e68FC203F6E4b6270240D6f82A850e8D38": 284789.5,
        "0xc3344290a92119631f35690e731991E73549368d": 284140.97,
        "0xB17e0788E3841d9DFDdd149b76fe2c02d47B7D5f": 408220.37806921545,
        "0x28A173026FA5B1c8eFBAc54F289cF37280610cC6": 278888.59,
        "0x4e37A2F0719fF64De22c6241c9595A43a019F8B7": 275144.56,
        "0x3D9AabC77cA03A61564223179D28657D6e03F9E3": 267115.98,
        "0xc033B96f8A66787420b780fF2C6af75E89F4464b": 267086.63,
        "0x07494EFB9fc623b74B31714192826c70EbA7423f": 266102.62,
        "0xA70454b78550A5105317fdAA208ca46Eeb1920d4": 258344.68,
        "0xdF7Eca6aF127C4F562B800B38Fbe8fFEfc7df5f0": 495251.94,
        "0x994AdB65C0E779a515aA0bF38cA87d36f5Ffbe20": 648960.2366626267,
        "0x23dEDab98D7828AFBD2B7Ab8C71089f2C517774a": 254513.23,
        "0x6665E62eF6F6Db29D5F8191fBAC472222C2cc80F": 252782.66,
        "0x3C70535b2FB11AE09586aFd0f6eDfcd7b7E8C7c3": 248874.76,
        "0x4444AAAACDBa5580282365e25b16309Bd770ce4a": 246640.26,
        "0x1a993C802f1FE293003C1c7852738237A8BbB146": 239274.69,
        "0xdcA053cCf7f390a520C1F3EfbccB5f05530f9C0e": 238965.25,
        "0x2d2bcd87FdCB2973190d5AaE342e9621FB34980F": 236798.49,
        "0x5743789957849A7B3D00690726D0f7D89583008F": 654489.0602873501,
        "0x2F58aD6678E1AFB3d99E33478DA6CA30A6a3F46C": 231359.71,
        "0x3C992fEe81D32dD09A2149A487d2C2Bcd6f6059E": 468575.74,
        "0xd2C9aBEdCc3766486F115a5290594310470D3300": 230014.29,
        "0xE64944f7D2183e210369EE020c947eEc945C9AE4": 228855.27,
        "0xA1fA722196b39B3A751F54Ca0b308b4231864f80": 228356.5,
        "0x46C4c4781fBCbD501e11eF8D87180c44026a3EC5": 227427.66,
        "0x2159C0584b01E5147a2AE9f5197181913baE7C3a": 225225.39,
        "0x5333D770505c47d57E0a02642faE17cf6a82CCFC": 218544.34,
        "0x36cc7B13029B5DEe4034745FB4F24034f3F2ffc6": 216245.6,
        "0x13AE1730EaddD8Dab80393c570AF0A01629708e3": 214804.84,
        "0xd8a2Cc4ee652625b02B8C2385705527458BDd9F8": 1667825.831748375,
        "0x12478d1a60a910C9CbFFb90648766a2bDD5918f5": 212750.44,
        "0xc6d363BBe16905833e92C4cCB0B5EDbc5699F0cA": 212088.43,
        "0x4026804f0C466126A35AD0471299240D3D6F1F98": 211678.12,
        "0x698Cbc7C6e185D4aAB98950E51c471025802034a": 208833.27,
        "0x1fD40Ff098B8Da2110cDC6D38BBdAaa5Bde2fc92": 208322.87,
        "0xF2Cf9d7513A2F6EAAe9d82b95B3c40D0efebE33B": 207618.29,
        "0x9F9B2b6c8869B8D8EE2eae01a7ee4eBA747331EC": 200328.73,
        "0xE80ac46B75e257E7ee53944a2Aef79F84b3Bc376": 198609.99,
        "0x7F4b94210061703D404114a0395E29d7b3489575": 194569,
        "0x7f4B43D3627a34c9EF01A2CC6D98B6B75c6C0A87": 192301.3075433741,
        "0x52e7633279802211bA4c2CEF1ef0F3129FE596B1": 180121.68,
        "0xd89BCF9a80Cf367174A83F33aa894E002cc63278": 173478.39,
        "0x0A83985E4A6E8Dae2B67beD4f2d9268f6806Ce00": 166059.93,
        "0x836384D63A6bB60c96EDd208748a68A86fE18041": 163639.54,
        "0x1f807412177dcf3c336F1eF4eF5543A4f0416921": 163251.61,
        "0x031F72dEB03C509af42624ddcD1f63fce5eCb220": 161464,
        "0xD60Ba43D5381B359404aa6C1bc3401D58c5915b9": 158405.35,
        "0xCba1A275e2D858EcffaF7a87F606f74B719a8A93": 155626.86,
        "0x08e89BD5a354bd34e15bb3936d87dF3c7601a3bE": 155531.55,
        "0x839f0D8aA6C39516c6Bc834eDfa376Bc92A7C8D8": 153100.36,
        "0xd062aB63Bb4f7af7e59B85DeFc3C90bfA9B81E6E": 151249.83,
        "0xf265702178A66B4b7ce079Fc8a1629e47Cf1bCDe": 150507.72,
        "0x04063BE551982933c2F512A0f116D6ECc445F8eC": 149479.83,
        "0x7E4d9DA2D2c45fb883eF81d9302d81FE23597b6c": 147768.67,
        "0x659dc802a26e7eE7309B1e40cA278E036c8819F6": 146761.3,
        "0x4Ec6e76E113c1Fc9D3cf41757BaC4Cd2547A7FE6": 384500.75,
        "0x202a69e31bDA671be8661168C075a3c2Ab145232": 145958.95,
        "0x424Bdea7365bC7B25D60927c0B48Cf3204C99547": 144840.41,
        "0xFDA1d6115A49adf731570800D35C901ad4e0057B": 143887.42,
        "0x0e8ec57f483DE7e81070ADc2F2349974E0Ea957F": 143535.64,
        "0xC20E143F3dDD3798f513D7A9069ed6f29937E857": 142867.35,
        "0xE2F3c1D62ae751CAf26C77093C143c3507d9Ab6E": 142799.95,
        "0xbe7019f8333b0B3Cfc707ac353Ebc2123140134c": 141738.46,
        "0x60892c8554430542Eede726c033fB58761D1458F": 140533.4,
        "0x46931a27aDa075495CB0A2EB21Bd004a330D4A72": 133237.48,
        "0x68063585be0C6175b28f175FD4758965bdD977cF": 133111.12,
        "0xFEddDDEEED427e58B768be8D83A099D1521A679c": 131239.5,
        "0xbE0030B71e9edED2B417F2a459c0CE24a4e8089A": 125944.18,
        "0x6eaceE278B4995F3182EB5e8f0a6D1e150069331": 125766.06,
        "0x5b38d8094e896FF29DB9889516bf053f5Cf59f60": 125404.77,
        "0x52a1903b9F5e783868aFB27221af1D2208285dEf": 200013.50959789596,
        "0xf9F2754c1995a91C60d51a98B6236A0c7EDE8d87": 124994.76,
        "0xAF92BD13e0ff605ceF65DBA5ABcf6453CBb59B37": 124933.62,
        "0x7455b2b0fA3E38051cc1744b7f4a49d34A7C824c": 124414.51,
        "0x25D0439874C8F14c2241b5b48DE0f8A6284D0Fb2": 124296.46,
        "0x6ddD1CAebbf83aCf28ddd10EBdf4caC460D9F1f9": 119123.21,
        "0x3F48cB78d2E254Ed12ef6c24b7B94e4cc87B24c2": 118892.32,
        "0x28878Aec6b4209d90A40890183E3322f0AE5B2E2": 118248.26,
        "0x205200F825B072921b81c204Bcebf75aF8E864d5": 117030.52,
        "0xF0DD7B83028a17F301a2C9a821E61D4150ce6dd3": 118088.91062231203,
        "0x605a11C3d6D10Da951492f637B734f7FfEA7aFD2": 112864.04,
        "0x90A5824dfc2f7b9D7AB41343129feb4B8081dB20": 112012.6,
        "0xE10aeCaC2f65a20b3AEED6A4298f0B7f4db461B3": 111896.65,
        "0x59815A08e5d7ffF482Abea5a5a5ffe54CF096513": 111324.37,
        "0xeac9bf6481cb008AB82df4E65B7654356d19224D": 111265.16,
        "0x5aaE645293C31FF2b3Db24EAa5abC0c619770100": 111205.57,
        "0xeBF9B5851872bF9E2Ae323CE41c0845b6753dDF8": 109554.14,
        "0xe61D9ed1e5Dc261D1e90a99304fADCef2c76FD10": 108323.25,
        "0x6aa0ae3b73b30DcA351fC640380e87EcEA6bE499": 107608.75,
        "0x94bdf5583EAfFBf843654157F90B98EECe0EfeD3": 107584.61,
        "0xC6B37E25B34EB349f664a23f1b3666C797410577": 106970.46,
        "0x1477f60D8A4666366aa271765ef240BceEEbe8f9": 106755.05,
        "0x6807e08253aE8e18c72347152fb18dA8024DF137": 105072.77,
        "0xB017381B81587ae6A85DDb176E624c95EeD15A5A": 104680.78,
        "0x784Cf4b62655486B405Eb76731885CC9ed56f42f": 104652.94,
        "0x1594b251df6B70Ca9A01d4De0836ab4FD9811241": 104636.82,
        "0x84244d2b664c28925E7BBb72EA4dD128c32B03e6": 103793.95,
        "0x3C95538b1B9f8F7B1E822dE9c8F967A7C03afB34": 101509.33,
        "0x3A8e11579Be8597423D3f9D60a599ad6f4E27467": 101315.46,
        "0x4475Df1309011F85dEF592bcCeAE9F5F97Ea285A": 101162.55,
        "0xbE542eCc53811abfb6a3ec8d722b90fc9EE1366a": 101079.38,
        "0x97D37E8B619cF4C6145da456766CA4FA157292D3": 100590.48,
        "0x8AB0A4FB69c7C8f08caa7Bd3AC407234281AFEB9": 100572.31,
        "0x214Ce1969A841df6bD10A790488aA27EDE9BA62F": 100535.07,
        "0x0F228805C03A693AA964A791E0b2e2c6e6c6513f": 99792.18,
        "0x96E38316343078542214a7a685D0802f63ca756B": 337442.17,
        "0x8757770a19Ce0F4F43C270A299c79A1b0fAE7492": 98263.62,
        "0xa79cd47655156b299762DFE92A67980805ce5a31": 97301.85,
        "0x989aC99c89529105547c8dE8EC9C88e94B00FaAA": 400918.8075125902,
        "0xb19D7Df06c272eC3dc5Bcf70eA95D4CaA6bbd007": 96051.26,
        "0xB32Ffb6e7C0E2A55BE9506Eaca3799d5D10AEe94": 95274.44,
        "0x76aED7187961e26E8E590118B42EA325be026c4e": 93515.3,
        "0x34CaE1d9e2D014B7b9E6295c66c554D7e79713d3": 93149.7,
        "0x21E4105D6927ba4218F501EF808198620313c152": 92641.91,
        "0x4FFe83103f9D871A5a1e2B8bDeB26409293Be7A0": 91519.64,
        "0x206Aa4C31fA4B2a651bBeeb738fF4F34caA76f86": 91488.89,
        "0x8139C9ffFE0030D2309Ac2B7B89a79483FD34398": 90588.58,
        "0x0343Db50405D73278f9A1c6f3182af4acE4339D3": 90185.53,
        "0x0A4A8DaE0a7EF4142C3B4D713aA1d016B0CA3fB3": 89185.03,
        "0x71110E4Ad6Bf3516A6f11C8Fa2219D69E8C76951": 88623.51,
        "0xcee8479ba683e7dAB0A083B67bb6Cdc8bfc0BE85": 87845.24,
        "0xaa1E800b0d1875AdF33709d96b1F8A3C8c470728": 86682.16,
        "0xC7c10871096B36b036E41d45d15b32B0Cc74b806": 86130.1,
        "0x7bb88D7fB34B822E2F799BdEf7e834A4919e8014": 1813871.0903377389,
        "0x029F5cB93F391dd140b03aF7B8D492a17A6A073A": 85449.07,
        "0x5f26cC1c4FD6f9b0DB0722F4E6737bc547352C46": 85207.49,
        "0xb1f28C606ACE30131971A0388DB85dd1309b24eC": 323163,
        "0x5bfF1A68663ff91b0650327D83D4230Cd00023Ad": 84428.09,
        "0xd1A96Da1C2f7cBF1d4875A4E2F8489b393dC2143": 83946.53,
        "0x4A33fd5D091D0169F21f4231bEb6Bd7137cA3bCc": 83921.11,
        "0x94A468FCB53A043Bf5Cd95EF21892E02C71134Be": 82969.8,
        "0x38E23ED81eF2FD2860a69527DeB4431714363b87": 82848.73,
        "0xC232247fcbC3285BAB034FD7286523f1d1530A70": 82631.97,
        "0x098b94ac336BdDe6acb6c067725f368313E07b3A": 82349.24,
        "0x6712B7F12D9D335A15b0CddeeE7A061ee522bDa0": 81957.43,
        "0x4a80b838d6c9004E7C1621ae64410098cFCA757B": 81545.85858242473,
        "0x1Cda6Af915399Fd20d6B253B8CFdbD9FEdA73BaF": 80978.17,
        "0x90eEfEf678e14e2Db237640C887fe1981E9f500B": 79844.98,
        "0xd2782Db8Ec48Bc6729d51A89c4F1c9B1Fa057fde": 79609.38,
        "0x76c94B5e1dE57eFbc9033871a4da842C1a4E53A6": 79520.55,
        "0xbC325c098541f117F4169cEC82749A1FEC1a09dc": 78484.25,
        "0xDf8a74ca9454B8033C8B20BF82C40a74A7Ae062d": 78245.66,
        "0x285fed35cBEA271A711681e84fFd83c68a596A75": 77937.41,
        "0x61c2bb96137B6e354627BA1a5884279ee08dBde5": 77524.31,
        "0x1e4E1d10BA1c34dF8b48d5bC8508D6644431ACc2": 77336.63,
        "0xdABA4e38d3a7838955c75EF59ea9103E8941e871": 77093.91,
        "0xeAdA7A7cbA478a7B949414a255535932A93f1A73": 76611.18,
        "0x4c11F940E2D09eF9D5000668c1C9410f0AaF0833": 76382.34,
        "0x32d6306EC178Bcefe7b8D7302689376b42b047eE": 76187.17,
        "0xc679187F18e95DA556369195330e08fC0ccC9387": 76117.15,
        "0x8Bd7d176DE5dA6E16264ba787cB1a2082399E350": 75615.51,
        "0xD37d007798FD0A878DDa554908B2f8c6178b5581": 75377.55,
        "0x605D9eCc931fd2002e9Ebe66bB3B60394B4f8f6F": 75013.29,
        "0x7629a2C3f396783098A838faf35D2C2A1F33c984": 1055915.606147295,
        "0x85b26b5180718824b646228F9Ce60C5486E76B30": 74033.03,
        "0x6AFa6D09Ec5aEc67141a0D7A6aFc49d33C344f6b": 73596.19,
        "0x99430897F5B9Fd7C6b90A35EcDDf450C873E4E5c": 73595.86,
        "0x1560FfE8A32DBb0974E26cB0a968193B61DdD4F4": 73315.11,
        "0x5C17d63BF484d7aC7203e35791313c58A720903E": 72874.49,
        "0x499145b972EE955b77edbc4A815f437D3C6e71D1": 72762.2,
        "0xdcef18876Ba08e4c18d4BAB29D86CF407DD94aD7": 72750.77,
        "0xe1129C6694e2c60517718dE18BA3358f0299ebAC": 610751.62,
        "0x8039E7746081E880302B9C02B96C31805a9E59b4": 72606.54,
        "0x168E8D263634ef25Ef84a643d231ae39CEB75909": 72529.14,
        "0xf51e5a0A85d29AA0508894405D734BcF044dcb5b": 72272.28,
        "0xFCecC24729bccB72FB3eC5d9BCb25A8051e246FB": 309565.1,
        "0x809cBE23c432E82e9E8bb73dCA73477e52318362": 71376.19,
        "0x8786B9F310C330a825Cd1b26EfF9773af665F358": 71266.19,
        "0xc50d3F0b4fC66Fc71418Bf083B55E74Db4f617de": 71019.1,
        "0xeb7ef5CAd8399D726904f720Ec8c6504710982dE": 70589.24,
        "0x0606bc4e4DC0Aea7A321fa95bB07a0aeacAbA794": 70494.35,
        "0xF29F1B83071022DD352726ba2cc6da86F7752bf7": 70409.44,
        "0x5bd54aed7C308e76B603F88BB6773CF90165114A": 69535.87,
        "0x3021338C74f10CEf1ECe6404Ac1498c2559f7a5c": 69248.79,
        "0x61D4AC515b82D1Ec2f021E63B17519683Ac1cAbD": 69232.57,
        "0xD0E8DfB4E2f188D5545309e88ACcB799561221F7": 69180.81795092285,
        "0x90231231E84225DC7e408875697845759fD90F08": 67578.65,
        "0xd3ff3883b00Bf454F115b9a47FFDAA50016fDAe0": 67516.45,
        "0x39BAFa9F4c4DcE3Eac9333cEB7FEeC03C9DD4682": 67197.73,
        "0xD67A8717DAAE6802d751256b4c08270340d98B2c": 66982.76,
        "0x8CE38Dd849071A39804870D858BB4fB8Bf826aa3": 66880.55,
        "0xc9C384a9E7e28f7Ef55903eb90947fe3ce71D475": 66566.11,
        "0x9C3BdC0225b9c7988247020f27328Dbf28DC076F": 66325.45,
        "0x9Bc758d8bC4590982d06805C82570a554c4D4Bb4": 66203.52,
        "0xfc817f5f14E1e1AF287627BabC8a1bB59aF7e41b": 66020.03,
        "0x888C629949953E30a6fF3748E07225fdd78F043C": 303388.54,
        "0xA3Cbd0c67DeE5142209ff0Cf155Bc2bC51AcF180": 65231.32,
        "0xD7642183d7d6A091D1CDa1928AeA579A9B0e2dD0": 80675.96413822201,
        "0x0172e05392aba65366C4dbBb70D958BbF43304E4": 64625.16,
        "0x22a79cF19ab91F26490285d823Edbd13e5431b2A": 64229.24,
        "0xF5db7500f174Cf40a3c4A21416465e665eD1e925": 63940.55,
        "0xF97Fc8a5eA3a9bCB9634F901bEFa1d7150134BA9": 63588.64,
        "0xaFAA188Ba59D8b7950C6B287Bb11E77759da714A": 816908.5705726551,
        "0x6aB6ae683E8E8caaD601661e5bD753138ed03121": 63410.12,
        "0x90557FAd9EF4465C3713Ed76141C99608DE29b7f": 62863.3,
        "0x473d3a2005499301Dc353AFa9D0C9c5980b5188c": 62762.67,
        "0x1ff9A293214D38EBAd7439C18Fbc8e7F67f4C0e8": 62387.26,
        "0xE3bB042f9Cc751AFAF7C14FC0b2848FAE17CB08a": 62375,
        "0xEB9A20bd8a36af6C480b73E83D94d23328561C12": 61956.6,
        "0x3ef000Bae3e8105be55F76FDa784fD7d69CFf30e": 61900.71,
        "0x041aDa5D64BcE29E66bF03529838F6905FdB75Fc": 61606.2,
        "0xFb36bBC854404738AaE6cdF111Bb872cB0B6192d": 61322.96,
        "0x14775A0ccc2af13B7204E1f84d159e135e1A1D31": 61256.78,
        "0xE3EFCB0e4E6e085bEf038492d6A3b64681B22D90": 61134.94,
        "0xbe7DD82FACD47D3598803F44CB980078466aEBA3": 61022.06,
        "0xAC92Ca542a99BBA473Cbe6E9526CDDfDcc06aA9b": 60621.06,
        "0x2860cE83720bAB73B28E0179F64F2EAF810fD995": 60457.72,
        "0xa6fbe8f447fe74D39C2D904D521a2819C4BA7C33": 60236.78,
        "0x81EAb64E630C4a2E3E849268A6B64cb76D1C8109": 60228.48,
        "0x1c9fbbAe241391fF41dC7211677487064075Fa17": 59979.21,
        "0xC8A1026AFB1eA32C02c367327F911cb77C062CBD": 59758.48,
        "0x6A0c7F84b9900bB2E144356Ab621D06BA7EaB366": 59489.58,
        "0xa43929f8CcFA90096D805B2341a6C9e00a0E6A13": 59288.7625187044,
        "0xeaFEdf51eD0d3911De9d36A2A48aD7F38194Ec50": 59204.43,
        "0x72D4D59F31D0Cb4A4213A5dc81FC0108241eCC71": 58412.75,
        "0xC03282D46293499cDD8914A7BB7D78f793e70A5a": 57910.45,
        "0x9D0Bf91Ac00Ab88dE5F43726a291f4d3c566Ea02": 57652.47,
        "0x41DF1ce92597ac7BfaaE7eC8eD1543B3e1369549": 57490.32,
        "0x1FDF24CB558800576dba31D502C43670eFc3E9aB": 57430.25,
        "0x8371EC1d9B31899e8A7574f43a7864F395C80d00": 57283.71,
        "0x6b9E4F287d44cEa39Cd8CcEDAA42488617AA21A7": 57273.71,
        "0xff1FC55B3B5D2cc62b82d1F77dA88355e8175254": 57244.53,
        "0x5d396a2106694308A40608Ef14A1C0892B6b7fAa": 56378.87,
        "0xF1010eE787Ee588766b441d7cC397b40DdFB17a3": 56370.3,
        "0x24E9cbB9DdDa1247ae4b4eEEE3C569A2190ac401": 56353.17,
        "0x48F5D4ba6141818A677b7374b9feb0299dC4Af93": 56324.96,
        "0x657240bfbfE9e2087a0c09E54e029DfeF42Ba54f": 55794.45,
        "0x9844c3688dAaA98De18fBe52499A6B152236896b": 55552.62,
        "0xB21DFCf420cc7536c7eF5652Ee8018741F17f017": 54565.66,
        "0xa8804d56ae6f2EB68e9e0A0a49BD5cf53AC3dA6f": 54542.45,
        "0x1CDeb63a975394968F87643bf458a4CAb8EF59e4": 54328.86,
        "0xdbD5D31B7f48adC13A0aB0c591F7e3D4f9642e69": 53644.69,
        "0x3b99636439FBA6314C0F52D35FEd2fF442191407": 53194.61,
        "0xA6efac6a6715CcCE780f8D9E7ea174C4d85dbE02": 52677.54,
        "0x4214793221d253482Beb406d1f76b657a0BdB374": 52358.99,
        "0x19B5f4dd903362B5A3Db6Ce8880E89a87fe38F2A": 51917.84,
        "0xcb1331129b6f8fBa6e77bbDcA04502482bba9446": 51710.24,
        "0xdaa0E199E5BdA3b642C9eB49C38Ed2fFD7C01394": 51697.49,
        "0x126FF8faBeC84EF8a96F25dD0C2668fB9b7E7088": 50849.74,
        "0x68885f3a47a04d6c024a99F5a15e251183461a05": 50801.19,
        "0x044F59D46ddE731FF237Bed917aE309D1370D575": 50679.81,
        "0xd2E87cd8F7719047913B446e6B97d7eB4Fc5bCCA": 50672.15,
        "0xFE4c082d320882A4133BB0D951254D6c083cB854": 50579.62,
        "0x0052A34D871ad1B46474b37D9Ed3bE5210af53d4": 50578.62,
        "0xb877Ac2a807FB023EC8B28ab5c70DB0fCF72A2E9": 50575.87,
        "0x068Eb1E5FF9BFA30Ca41C75E22cd4774965F4db8": 50441.99,
        "0x2085d19EBbFA1B1f5B1dC87EBDE8a4CdEe871e9E": 50224.37,
        "0xdE232Ef5C008f615Fc3A8245734B8C8F1E836c58": 50210.947225425305,
        "0x380BA929de57D8F74B418f0c90D0D1Cb19dF914C": 49576.09,
        "0x3878095607c39Ed45044588214e8643bb7Ed3fcE": 49541.25,
        "0x34922627B7244D47729F03B33EB45D8D263D116B": 49535.46,
        "0x27Ea021657F64f7B4beef87C7621BEAD3Cc2FfB8": 49057.01,
        "0xE4393084497014fE7E52AEe26c90Be2BC1275A6c": 48802.31,
        "0x40516765ccb13231aa7Df0824EB9c605aaD19016": 48312.89,
        "0xc549d8dE2e79596d007Ce841502828f9Ea0135d5": 48289.22,
        "0x35D42CaCAA7F8958Ab2427BFBfb29D73cf24DAd6": 47876.07,
        "0x448Ae81d62f4a6eE789f630A4A4Eeda69C0169F3": 47860.22,
        "0x3c1e2653F8c027C24453E46C01aeAcf9cA72aC9d": 50414.10667142892,
        "0x07d79841B8bF0e151f95c984D3bB14F9233122EF": 47418.61,
        "0x93104023EA51f39Ab0E6503855D0ff2584A7a3C1": 47408.25,
        "0x7338afb07db145220849B04A45243956f20B14d9": 47193.4,
        "0x47A53D793b0870734Cf640f3484e926d0904B09E": 46606.46,
        "0xE4b9ed011FdE881650E26AAB05De1BDE419dFb6a": 46580.9,
        "0x2E7a139A3800d78e9A23d44dA2c40a9AA78D6D59": 46577.85,
        "0xF29005E939777919F8384014daAbd1a52b8c3E1D": 46445.75,
        "0x2278A9463774fc0b538B7d52087a00405Ca9e1Ac": 46372.25,
        "0x5115c3832199d35b189038561fDF95B0CeE88eCC": 46307.34,
        "0xA7fAb85434c622F3C68BbB739c21Ec3E564D5499": 46251.78,
        "0x1728603eC857977265c701200a095CA3dEfAe6E2": 46202.91,
        "0x49BbeF62cDf8B26F2D15c0Ec1Ac762058fd9C3c2": 46002.15,
        "0x6261823b37C6Fa374e991a16a8f74B8f756080C7": 49036.482448238916,
        "0x318DC327D73D132717B4C7a868b95b2ff0ff2129": 44441.22,
        "0xCB6222f4Df04385ea08E8DA2A5871131FF5F6cBA": 44266.59,
        "0x680D87a2D8c6ceE458Ff9e019f3fc6cCF5915726": 43930.19,
        "0x0a4043594923025c688f933a45dBd5F7ee10bc9f": 43669.8,
        "0xd356fa245B62562B15309e0C9C6a7bf4A1C72aC7": 43580.62,
        "0xDF755c11D3E2D7e429717Df69cE15c241d65396D": 43447.55,
        "0xb342EA45D9909FF5951E930b78b9F89a09FdeD8C": 43444.7,
        "0x17A4F71319e09b57F3783D1D193E2C2A535A5ca7": 43414.28,
        "0xE344D262A31C9e278E70e611C237666133c4C02B": 43224.65,
        "0x2f49d4a5974A309b03Cf6432C05529Fc7DF21c71": 43128.07,
        "0xDda8901508211dfd3a2A912fEb0b913a6558c113": 43030.32,
        "0xE2449d9AE0fC4b5486Bd588101481b6925B8440a": 42842.1,
        "0x3e99b67643badFf72Ebb67323999F4807733734A": 42634.01,
        "0x77f22D9a94bcC99Ce9A3aDFd6dB27C907f35D1ae": 42513.34,
        "0xC693D87Ea43656Cd5494065A531381338E6d56a3": 42395.87,
        "0x1C56038011D90d8F338bFdB72F679bFF73dAB81c": 42112.57,
        "0xfAE3f80ceaDc688280ed98a332544EE422964347": 41915.45,
        "0x8d5f1738cC5fFD0c822fbBC7B06268A3641F727B": 41745.3,
        "0x02dce079ADe821b8c9Ff62040eF1233319113e39": 41644.2,
        "0xcFD727653C3d5a1B943f675781d3245B884f1d34": 41561.19,
        "0x06aAcfDeeBDcCCa500B98411cC45c8D4A45944ED": 41447.74,
        "0x7C1148C4a528C1459222e546Bb70fc3f4b012505": 41328.74,
        "0xDCB7943F8454A5742b2B881b6eCfc8C7D198F631": 41321.37,
        "0x7Cb552152e2b28F9f6911c51B69B0d8D1FADafe1": 41155.17,
        "0xc3A038cB837fF7CdB038C72d3714951a835e6a36": 41116.13,
        "0x77270c278A58eA2CA34c6dec89f07fE598c26bBd": 40993.21,
        "0x7e58672f8a562Dd0b4bbe490DaBa8F9382be147C": 40987.22,
        "0xda4149C263086c170856F3e2DA586699Aa5e0fB4": 40979.21,
        "0x1f3Dd234d9c904838Db3e165ff15851625b24940": 40979.21,
        "0x21FCc541f553b4Fcec2e1b6F5cc2f1C3aBb64466": 40979.21,
        "0xD4E064e46d6098f5d5E06F0e965770e75b2cdb00": 40979.21,
        "0x9a9826c306906343000Af1c86137a9668A650c61": 40979.21,
        "0x08F06b25eCaD19ae8E6E3bDebaC9bc4B31A3Fe04": 40979.21,
        "0x74c2468dED1e4555eC3cAeE5c458F106A11952de": 40979.21,
        "0xCcFaC75FdeCe34309a4da8449E75B0d7b31100EC": 40979.21,
        "0xe4F3fAfbeB20b44838948Ab27F5bb49401f71065": 40979.21,
        "0xEC2BAB01e183065F38e195C41F8216182E9d0e0a": 40979.21,
        "0x8a3907d3F34b56eb5D014B3Fd90246df5882169F": 40979.21,
        "0x97Addf22Ee50c06A2cfdbf9De26a22aD85178857": 40979.21,
        "0x5E5bdee0Cd42Db4fbB61A4C0908d8d5E9918F502": 40979.21,
        "0x090eA16a48bf0Fb533785aF686Ee6ddd3add1f3e": 40979.21,
        "0xF1F359e7690b0339c2e3C5aC8e8567f72F806d2B": 40979.21,
        "0x0bc93DCCe6397568e291D5A2BC4751f507a541c8": 40979.21,
        "0xF1Ff21eEeFB9e924D7eeC42109c9b1E7c896d683": 40979.21,
        "0x4e1718f1abCc2D533DC43879F4DcFf72802A7dAE": 40979.21,
        "0xAfC3A7380Bb18fddA1A887D674f505d63F0050bC": 40979.21,
        "0x06f7b4FA9f7873953c26D484EbD3220a1CB91132": 40979.21,
        "0xb43259aC2D5ee0f00488280123E29A012E510Aee": 40979.21,
        "0xCcec8821184839F9D05F5E9E38591199113591dD": 40979.21,
        "0xb0DA7d4a43ea078a4024b0370C8C87E29Fc61960": 40979.21,
        "0xeCDF1Dc060B220FC5ada8801a1F9e24Ce2EDC15d": 40979.21,
        "0x49495926D3d3D1C29A323fcC975008f2A150b6cE": 40979.21,
        "0x637615F17cfD5cfF9aA7E1eF788d5D46b730D21A": 40979.21,
        "0x85549A3861bd9F6583c6B12A0Ea716C130D4Af41": 40979.21,
        "0x3B5e089Ffa4d8c40Ba068e361e7b50Bc7Cd69CcA": 40979.21,
        "0x0f9fd3Ce9942b08a565d6f7b3C29dda0880083dE": 40979.21,
        "0x2Fbe8eD4D76526490c6Ee4c1674822770Ad8a4d9": 40979.21,
        "0xD50eDd169341a4b518Cf8700D8d1Bb8a1C2C8970": 40979.21,
        "0x7402376b2ff393FA7F650e60602f196CF7dD8AF0": 40979.21,
        "0x795B456aC0b82D8A18cFb2422fF4C84D4DeAf910": 40979.21,
        "0x8f5E1759c54b95fAc506Cc62fa32f0FA426e4eD6": 40979.21,
        "0xfffe5F59D1C40e83F33de5689E917Db71Ea04235": 40979.21,
        "0x176E015700e619e041E1944888A1fb239c25Dc7A": 40979.21,
        "0xd697348CAb58cE38F72B230d99C94B1145a05D0F": 40979.21,
        "0x7728C618B20266f844E8F88d7C003d535CdB6952": 40979.21,
        "0x17309781588474c7ADdf9b41Cd2E18415273F437": 40979.21,
        "0x8307EFD4aEE54A65001539867eE0a82AE24F529e": 40979.21,
        "0x692e5f9dDe208D6FB214a738659B53D4dDA81D80": 40979.21,
        "0x155BEC0a0F7A6153Dd37A5E39FDA3B6A81Fa8bcE": 40979.21,
        "0x19DEF0f2Cd28b39e0F7e4F5f371034CFd615dFA1": 40979.21,
        "0xd56BB816a0C50f81b9919A719dBd6665aD7384bD": 40979.21,
        "0x960bCF187308b675Db0FD9B5215556E353498831": 40979.21,
        "0x728eEae5351B17916cE7724E6d316A3a80e10A43": 40979.21,
        "0x90350DA8B10e92E14EA7e80aeb1e06eDb04e66E3": 40979.21,
        "0xed53067da444B399b21897f278C23C1FB7436FaB": 40979.21,
        "0x1d0524BC2B240692acF4AeB4013AE2bB2B5B4aA5": 40979.21,
        "0x0b0154cbfaBa8A18CaF5fcbA2b83CE383C1A0095": 40979.21,
        "0x579C0C05B15E9268e33F00a49aEC8b7CDb8c4F27": 40979.21,
        "0x86617BFDd68388445557b8A4f6310ff41678C780": 40979.21,
        "0x0983AccaE22aB0DDef917494DCd18c7ABD75785F": 40979.21,
        "0x54103Fa0c69D65a2ef7A387848C9d27e72a74a99": 40979.21,
        "0xdac2890d408B4C689aBc6E4Da74c0ADf3bf38a66": 40979.21,
        "0x165d471e5451BA8e1512a819988D7868eA4d7cc0": 40979.21,
        "0x44BbB1a6309305ee5d42a1DED96EdD451cE67415": 40979.21,
        "0xB5046A4d2c509a2C96c2C2bB8ccE0e7B4916f495": 40979.21,
        "0x6fa46357116138e0244C07d3E0e84D1153dc0b4D": 40979.21,
        "0x7F121e5e1624915E084c7cDde4e3072403770269": 40979.21,
        "0x0118270f8D13546aE64e3EE9533034653d31a563": 40979.21,
        "0x9c769E858Fa32299bDd500143889b60Fdd761c83": 40979.21,
        "0x946d17072EaC624C3E3fb06108959B7feFBCb8aD": 40979.21,
        "0x554aCc76034CDcF13aa56cA4c3aD21F7cEA7b60e": 40979.21,
        "0x2Ad305a512672E62E19Ef0a0955338F25274fc0b": 40979.21,
        "0x4cFB62921aeB3b025Ac8d946EBA34A27162C0D04": 40979.21,
        "0x4e3F953f8DD6Bc29bB74DB30F3F4809eba502026": 40979.21,
        "0x40de64861882B4BE6BAd61B7beFfaE5A93f92aA7": 40979.21,
        "0xb81B2C2c2dcC00EcD0A15EbBEBE0Dd1cffC19DbE": 40979.21,
        "0x1Dee358853b7640e82FE443ee9D359599C1571eb": 40979.21,
        "0x6Fb966a32bE4C0d10A0329BDB1F01Dd89Ad264c2": 40979.21,
        "0xA7Bd6A10CB7784932dD3a50A3F17Ba2E861698E8": 40979.21,
        "0xAaD6B4BDb85f6D8116BA113143cDfb44f2018f5f": 40979.21,
        "0x381dBCc8888642EF87Da499AEEe039b074768c1e": 40979.21,
        "0xA6b6D854E4E5f2B36E51D1dFf81cAd56e5f286C1": 40979.21,
        "0x2fBE2fD12E2DB06Ed48f5b013cd4D2f3Ca0A48Bc": 40979.21,
        "0xd1Adf5d305A68D561a0eB67e5c307Dfa9aa549E5": 40979.21,
        "0xa47022B1730Ed4f9EF28eF1336763931d46F0497": 40979.21,
        "0x4A76D48414cA323CeC95B6526109c821a73e715e": 40979.21,
        "0xC26795C6C1106AA27dc2a672511cf1332Beb950E": 40979.21,
        "0x10b1036fdA570b3dAdb6adBc51d1f55ae4881A6c": 40979.21,
        "0x2bE5BD3e2E598D1925d4d742bc4C174781A2221F": 40979.21,
        "0xa4739C6134211690602b58bab0d6Cf1cCB1E163a": 40979.21,
        "0xc080b485b91833E4EED8522FD3DA5770F0493fAd": 40979.21,
        "0xa4B0bd08686B2c77a005c196C070C6C0b80BD27a": 278883.29,
        "0xD9E7486DE52edc6efdb1E3c9eCfcE0D546e1A032": 40769.65,
        "0x39ebAD22581049D5C684FB889F9B92D177381E19": 40739.76,
        "0x6bFeBD4962E465be37B25276ee0b26a19dAaBf96": 40688.02,
        "0xB2F830d0f55c73399437F365A2bd8C07b6C8B3F6": 40668.58,
        "0xc89d0Df5c4e281038a529756826e4F2117256EB7": 40668.31,
        "0x13D649ed8f4A7104711E7dD72d6E2Ecc2b313222": 40651.2,
        "0x4B475EAE1c0e950f8361DcC51cE49ad4866575d3": 40208.12,
        "0x58467A701AB42fD8611e1Afb0f4446B3169d7AB3": 40044.91,
        "0xd6c3F847f032c7c29f7Bb573953c77200951cdbe": 39978.96,
        "0x788282E3d597b37EE85C65aBdB1aE1253F9AE29C": 39895.94,
        "0xBa5a4726B8a7F42B5a6dE4e3023F1a86F6c5e252": 39840.36,
        "0xAb2B6B730651fF37eA3D709cE73cFf6973980A1C": 39837.09,
        "0xc5Df8672232f1C2b75310e4f2B80863721705a12": 39759.29,
        "0xAEc5F9D960926C7C0fAd7E4997716bF96aAC1Eb4": 39600.36,
        "0xeE7CFfb7b27F825DdA9E6e5E7AfF507e05F39990": 39339.16,
        "0x62c775d478f4405854feD76bf9Ba45c3d7FD2f93": 39339.16,
        "0xD0e72c1B2eb87e3DC0445b7f689CaDcFc872b293": 38785.82,
        "0x316b7f051bf83478d1c929667bE18a1270989aC1": 38587.61,
        "0xe079BDAcCa7E2D13ACbED6e78e50C3aC537ae139": 38511.15,
        "0x0578fE63A40DD249b853487DaE3C9eB01957628E": 38298.75,
        "0xd87EcC6C74F486B044824a222326A96F696fCfA2": 38273.44,
        "0x9FD3ff3fc4cC336B29D25C36E089a1F81e866D97": 38266.9,
        "0x23B99a09E0e98eCE342080cbC4A1298637bC85B0": 38145.48,
        "0x3087460476279E3E38AefD7BA6501a9297bCEF2A": 38133.09,
        "0x0B4595d33BcB6fc4204eE963f9B10C7AADE68426": 38094.75,
        "0x81B7426326624bf14DDFeeCdF58A053AfEa4f84c": 38077.25,
        "0x8CE17FF2c7376e9aDfe9C63C47a801097fA6C525": 37509.16,
        "0x4688c1B6D1a88b82B122F2391027d70e3BF9631A": 50299.51306063883,
        "0x019700312686B2EE895679A841aB0D6423D9b990": 37380.46,
        "0xBFc57B070b1EDA0FCb9c203EDc1085c626F3A36d": 36821.08,
        "0x6641758A67C1A56914F56F710f428326F4F98189": 36619.66,
        "0xf0a472fae3f921C6810FdC93039B901111A2B61B": 36609.75,
        "0xE9512133e0AeFb8dc40A583d19dfC2E9f31a1940": 36578.06,
        "0x329818B02AfC081e58B0Ee16cAc84747bC37F8BD": 36419.9,
        "0x85d507D4DB3567fb5D73Fa14B8D22b3DF816EA53": 36252.71,
        "0x35A1a7740653b9c99b9b70C37c1C97192585B6BB": 36110.46,
        "0xe8049B4FCd2350292Fa70200CA78a9DFD0036065": 36031.45,
        "0xeC7AFf1e8e16e823aE5F98ADCA0a81A638dd8bdb": 35998.88,
        "0x7C531139016Ca1619aAaF1B1F99dc40e59A22568": 35675.75,
        "0xAc1b80e06f970879BfB8f2b92B59442593f332b6": 35606.31,
        "0xB1d009a27F194Ad430430469c27aadfeA7a0Bd6B": 35537.12,
        "0x276aAd04660cEfA504367e69691f90061E5E5d3e": 35376.76,
        "0x28D1520535CfA6e726A0ca4e484881aFC7741f30": 35190.98,
        "0x712180063C3B8aAedaBC68e73803c3e299614749": 35187.61,
        "0x47f4E5CA3d84348004A531bE3986C850B6E76E08": 35159.03,
        "0x0B5897d201d83a9fCBeEfC086C100a8eAa5aDA9A": 35083.32,
        "0x0291eb432CB4a2613a7415018933E3Db45Bcd769": 34816.8,
        "0x32EEF2e7c9e6988cF2ae4418CC6e324aDD159Aa8": 34715.52,
        "0xc42D210bF8768aC0b23f347943A378E00833e323": 34706.38,
        "0xD96D96a973D920015E130701714f10804156AEA7": 34378.8,
        "0x77cb347ce23d59B40695A734E301a118456186B8": 34298.8,
        "0x08776916eC60d4487C5495544927DDE4b1012e17": 34224.28,
        "0x156c6Fe76700B17D1CA31D03E029D1Cd130b9208": 34182.29,
        "0xd76b833a65367e39F6367B57131185721C3C56F7": 33943.7,
        "0x43d5E0DC6Fe97fc150c8eb651eDd529cAb3225dC": 33832,
        "0xa7AB43295A9bddE0d185049c45ED5FfA1758c190": 33777.66,
        "0xf276289Def98bF32c1f51a9A683eEBC68a938dF5": 33734.87,
        "0xb495023D8Eb9526D8EC346703f2CFf12F2A6963d": 33598.29,
        "0x54eCB3397B0bf31Cb0b81eB2444E2A7b32507d8B": 33516.19,
        "0x16F562fB6587a19E19761654aDb195F8bc879b5d": 33447.55,
        "0x4CFCC2D8A5695e84EDf547A3b32be843998b3be9": 33315.96,
        "0x2C84278AA407886B277bbD96CCF3C0E31A3f8ffD": 33212.67,
        "0x900Ae6f57F70A95Bda1391F08b26EeD053898e78": 32782.97,
        "0x9ded213FeD6A6CD29318720D0B19528d5ec8C458": 270710.63,
        "0x2c482B23322F3e4Ad553441bBB327B86dE7cC42f": 32507.57,
        "0x8dB13904B1e03e09273b09C174aDA3d03719CCC2": 32401.54,
        "0x1ba6B82641C77aB1Fc7Bc734C5C3628199A8967D": 32382.9,
        "0x7F1CA9Fe9C3728f5c632e5564b2BfF5585BE1748": 32338.06,
        "0x0F21e8506FE0D02E84f7a8bB36A7Da51aeD93Dd0": 32271.52,
        "0xEcde6de2CB420A03b76a1f2860Eca4AED1fB1AA9": 32254.93,
        "0x3281071Ac1250c1e879b7A030AC7404d59AC9013": 32231.17,
        "0x9bb7Ea6f2337A17cDD6e828dA85A01b91d8937f4": 31941.22,
        "0x6B879c078Ea4Cc27BbDB486fcAA4FA27e6cbE97A": 31774.29,
        "0x1e03F78b86962019Afa10069ACc030f2a9AED7A9": 31765.83,
        "0xd04bB1F03B38C006927B59D928DbffB9492A56d3": 31598.67,
        "0xcd5cC4dA7E96bF11B3A49a2c45E691d85345E43e": 31440.4,
        "0xa5B3cfEb3B01bB43B9A6F3a7c78174ec2d957Dc6": 31438.03,
        "0x7D63AB461AcbC7811b6e41bC6B073667fe2540F8": 31417.12,
        "0x6d38f3371965ECFdf1D884e57Ea8b5119B79E3e4": 31412.06,
        "0x4A219402d71BF58114F1b699654aCF388E2dA672": 31392.54,
        "0xdabDEea46b7B5D123e5436DEe35F5be7FF4987c0": 31242.44,
        "0x5839fA6E03aAf23b297162714C2Bb0046770C626": 31114.7,
        "0x6D1aca3b20C766fA75C417FB898b5b2D43880215": 30900.59,
        "0xF58D03279bf699b31404CDe9FAC8Dd205744d515": 30856.24,
        "0x2cFb075E8FC0D99837653629B0A3d527f0769a1A": 30716.18,
        "0xf9867278E13c908c08E2dF54966540229FA5FfD8": 30630.58,
        "0xCD8D5a5d105DFb1d5c165eBe6CFa1e25deae1D5E": 30473.92,
        "0x2d40A1F7c25545425f93c5ec338B63cf7D8451A2": 30419.22,
        "0x6f7B0E6e5F9553e6f6DCb047D18d80fA0f817C4E": 30416.25,
        "0x88d4ee6AFf895CC2FD64649dfCa1BD82DBf640A5": 30354.22,
        "0x965A1DFeE89e54901686Cadda7e42Dd6A9E3045F": 30342.52,
        "0x0F45156F109e474295913D78036FA213b1745D5A": 30223.06,
        "0x55AB7C75db76D8341099472349EE5B1543bF293f": 30046.11,
        "0x5602eC64ca2A97BA1e3c58FDA044C9b7e8ec16Ab": 29692.58,
        "0x6887b5852847dD89d4C86dFAefaB5B0B236DCD8a": 29613.58,
        "0x6585E7057b6ca0b436F7Ab32F65dEa3A57935Ac9": 29413.16,
        "0x03da151F75B533177f020B925D7C43F4081eF3c8": 29219.47,
        "0xfE99Cb7011E55F1dD8C376f9134e24EF8a10B14d": 29198.92,
        "0xf37633dDF02ad15fDa6f0a0e98B602621Ea56146": 29179.96,
        "0x239Abb6DF0ae654Bb3984D11E0Eaf8004AE77BfA": 28871.39,
        "0x8bace3A49A375027868CDd34e84521EeD1f1B01D": 28869.83,
        "0x1563C4751Ad2be48Fd17464B73585B6ba8b6A5f0": 28722.06,
        "0x4127143a866Bf5D8AD2AFb6de8e63164B8Ad5bF6": 28717.55,
        "0x329CfE850FF4CF637aa2353ef2D3672156E54d6C": 28686.6,
        "0x0084418C5e9c39907455AA3278da4593b509B06A": 28608.95,
        "0xf5FcAAe203bD5DD81Ef969c3fECC872F38AeCcAb": 28508.44,
        "0xfA9E221a7aF006531a816E98792a3E4B22A01461": 28431.51,
        "0x66553b6D083D69ACA6B9f93293Bf42E60d096104": 28248.74,
        "0xD946E7084d6d273F145090789C75573bc91A3868": 28233.84,
        "0xAC11596F6B35b4dcD22975a7d9048a0f21D4a2Ed": 326339.9239752719,
        "0x0f7E69793A0caf1a1044be8238798cA7e0Af8905": 106998.03362317622,
        "0x39B9280FfDA7e7125F45F87d0e4139737Af4d5a6": 28075.78,
        "0x87729BD7906C7FE45888426cf56c66aBeE36a604": 28070.38,
        "0x34f543A73dCb1a4bCbAE71e5dD41FcC1b5c17BF7": 28024.94,
        "0xeb7846Ad58FBDaC651830d5370a94488c06F282d": 27837.22,
        "0x7e2b9Efe1A76DBE7E6f0af32D2e73c44F35BF504": 27809.5,
        "0x166C794d890dD91bBe71F304ecA660E1c4892CBB": 27796.21,
        "0x727b3a408bc30a769b4239C315d02EdAC26CfE93": 27727.49,
        "0xFB0EF539DE084540d22A3aDFb6695C745EEC322b": 27664.53,
        "0x56592eCAd18Fe1b3438b21d718afd97885350AfC": 27609.8,
        "0xE7b1029e5417Ef31CD9CD3AEB5D1f1f3E7638601": 27605.15,
        "0x5c70B3F22595CAf8314F77DAbC628363AAEe18aD": 27504,
        "0xee7c973192582fa2e1905193ECBb8c84d92E2D27": 27445.05,
        "0x9eBd10B46B43351097caB2D3c03Ccf440957A2a9": 27370.49,
        "0xAE1c38847Fb90A13a2a1D7E5552cCD80c62C6508": 27215.59,
        "0x0C1daA53C2Dad58d2baaDFecB70dF9F49922e0cc": 27153.38,
        "0xF712aB8c4505eB4B36a2Ff9Fa746470be81E6538": 27075.88,
        "0x5c6e54384CADD75Ea6BDF1fB96e1097F079064cd": 27073.7,
        "0x4CcFEb186c61217F05D8756314c600089B27A1c3": 26888.85,
        "0x7b4137f48b62d59044f1a8f51Ac5474f28649eDC": 26866.07,
        "0x40ebC97d296F436AaC1452ae8140E0e9359D9966": 26817.78,
        "0xd0bC0fcd91c501d6dd35e5daF93aCE0B4D958A4e": 26789.09,
        "0xf0598504Ae7736385879D95b25C26294A7A0acDB": 26720.06,
        "0x7de1278f4918c420f714fdDf0372d41D6Cc59677": 26615.27,
        "0x8cBbdF31182d83b932248d36F239a3F7FF1146E9": 1486321.3226757413,
        "0x2B09197141080f9DCFD2976CFDcF4E2A7D9cF483": 26305.94,
        "0x0659E06227Fa9fbc770e591B30CA82F5494CC53C": 26238.96,
        "0x97f4248A880CB2E319570EB5dAFd3156b74CB464": 26226.78,
        "0x0c999f497985f6b045CD75Aef773f324546faA61": 26226.78,
        "0x50a201b8dADF001F4ee6f84A0Bf94f63bE874b99": 26173.44,
        "0xc182f49eb3fE53844Ef70B478d021f33CD637516": 26164.43,
        "0xd770Bf2E3b58A076f4D65cf9B02871a6C920056D": 26126.79,
        "0xC112c0F41c018708e9D98ACFd20BdcF0F5ce5380": 26030.88,
        "0x3D6ec9f7b70c616716Df4C7f5B0230039a1f026a": 25979.9,
        "0x3406b045ab7567ed84596b45f99D02B6F8ABE288": 25945.45,
        "0x11B655A634586ab753b5c43C3D13878F2CC3A50c": 25923.48,
        "0x1036De8C819fd8169511a0A56cb6De4463f54E75": 25772.59,
        "0xF1bB85B4d326bd8743D3fC1FEb440F16DD784CBd": 25538.1,
        "0xbF07c1611c976115a0d1f600C2B5a4fb7EAb3a0E": 25459.17,
        "0x7d3AB1A4cd585F0d3000E024BA3bFf5ef353bf80": 25308.69,
        "0xD93eC7e214C50FE64050d0A88002942f0E242659": 263217.36,
        "0xbAc626F60aEB13D129Cb3fC8a35edC6179216a08": 24980.42,
        "0xF372185AD76C7a9105d051d2b9ff0bC0940526D8": 24829.23,
        "0xCe97CA7D5767f78046C3e156D481aD2E60cD84d6": 24804.38,
        "0xFA8a6Df4449CE740a2Cb4dCc3636e09E6B0610C5": 24793.49,
        "0x049A77fF040133b390e645adc445e05E70e08AbD": 24726.73,
        "0x4835b472cf3578f36fC898172b9ECBbE1782Be8B": 24596.63,
        "0x24ED6029a4365921F1ab4Ae496b2AB565D00Cb85": 24443.28,
        "0x823853455012801Dfa2b9874d95A66c57B7013B1": 24395.49,
        "0x1295c6d02137402a0799C6397A8161c2590805c2": 24322.44,
        "0x9227b5b0267715816d0A3D62b36d60991A4a3f25": 24296.26,
        "0x90C1bD51BA5fcDB359c4970C08A2A4629B1E1E67": 24241.73,
        "0x5d29b68AaFB22c491977EAcf7DFB1661D2832555": 24153.4,
        "0xB747b16321A9CAef88f5Bb03C9C5E796488b2517": 23923.81,
        "0x2Cd019104B3A0C1028B67157D2b6Fa7ef8dDeefD": 23691.45,
        "0x98D1d755807c8E98824f003c402ab40C1A7e1847": 23669.22,
        "0xB43Fb3e80ae805FcB8a76160cD3f10e48eE3a019": 23665.98,
        "0x0f4f626201C508D5F02bA0161A618a6741D1760C": 23634.98,
        "0x44a03946C8e690c6Ecdb254B3744690A42E1ED17": 23625.85,
        "0x39D12116298f3b2B55E53e7B99C0Bf47041761df": 23602.74,
        "0xee91610b6664325B50e7B1De6D46897F9EE305aC": 23517.85,
        "0xb7d8493597453e6Ac5E7a285F071bb8379b3052E": 23438.73,
        "0xfB17d5CD85854B6Bee89e714591DE521F3169dE5": 23421.26,
        "0xdf9A5aEfb310492AA0440F4949E6b0Cbb09C4Ce8": 23401.11,
        "0x8AD498FFF6367B23399952bd7E920144A292B55c": 23386.11,
        "0x7e6a6DeBBbb8A39474CbDd62997d21B73AF87d5b": 23373.06,
        "0xCCc596C589Ed498Ecb32D3f2cFD1672864Cd2160": 23084.88,
        "0xf1C429b0cE94EF9893EF110D2CC100201dce71c8": 23030.67,
        "0x83A4Fb89B5035468B204A2F964D503fAdFe5F6b4": 22987.43,
        "0xD5568c7fFE52ca7E5a7ecE2A0cB0dFe635f77801": 22804.74,
        "0x1aba1Ce48202AbAfcCBB8bc2fA4E72bad1Dae368": 22635.36,
        "0x1284A0dFE579acd9a2b21F3C97f0C99D0A5b0DA9": 22559.71,
        "0xab58779cec2B82A75Ffd103fDc88D7e3aDb13468": 22541.39,
        "0x91C8127aDb19c727e303fF09797f9cE1449F5227": 22479.47,
        "0xa47dE8480dbB7583DAeaac8496258fd8Dca9f3eb": 22447.12,
        "0x8E78a27763ee741f667b5034D97Ba3d7687CC166": 22422.7,
        "0x3592Bfa51e5b05350F15bBF85Fe325563dFFcb59": 22394.94,
        "0xf92b38ed3f3A2f7B5880A57d88d42e50578982A8": 22390.3,
        "0x4A494f72e130Fd72fD91aB1F52376df5b0003b3d": 22320.14,
        "0xB8f55Ff4EEE783A7c9E5FDDca1B645EA930B5A20": 22238.78,
        "0x5050D2563a296C9f1dCA809D1E7650272E59D3e4": 22184.95,
        "0x12C47bEcD985d18bdCDB8EB9366c2627522769Ee": 22119.3,
        "0xA1C6808b8f08D091e2826C9640Be302a310655E1": 22051.29,
        "0x68E4174d3a61e6AE91bF8509535a6E75194e18bD": 22009.23,
        "0xF4F116733d88Ab1c8Aa52f63C0205162a91b202f": 30200.322304085556,
        "0xD1732ea4F7bFc0fdDa3c23295310254224f0Cc92": 21926.79,
        "0x994f20959Ea7cBa7078Cc40278B2505adeF7E8E4": 21870.18,
        "0x5275817b74021E97c980E95EdE6bbAc0D0d6f3a2": 21851.78,
        "0x4Dacd010e15e220bC6C5C3210d166505d2b6c63A": 21821.53,
        "0x3FDaAe850D439443a86CB46942962fBA108E4DE2": 37015.94912748647,
        "0x57622d4c4be22ab9ad3Da104dc281d738e6F5b6a": 21782.23,
        "0x6C01673F991668B98D6119Dc1bcE253270d6eb33": 21725.43,
        "0x2cF57e26129A6f80AC0E3f08EDFcA0F78918B051": 21653.7,
        "0x4764a1C417E340b25f2CD01eB7f9d8Bb4bbeebD2": 49569.88072284144,
        "0x50385b6386ecE0e78fe8ff3EaFDA4020971b0267": 21565.14,
        "0xeA3727cf2938DaE815f69fF797e046FD368C6Cc9": 21554.13,
        "0x423a66a3ce61Eaa3BCd922c4d71b781E01d746F0": 21535.87,
        "0x7B59793aD075e4ce1e35181054759C080B8D965D": 21532.34,
        "0xe2521Ca4F4C56D03c33972d0AfFBa147C02A488B": 21465.73,
        "0x5b299CE9c73b286CcEc2abFA145Cba63fCF724C3": 21426.35,
        "0x321F7a6Ba1DC569b71a639748a985A87c80458cE": 21315.23,
        "0x5Aa0F3d2f5B1B93E0E1E4Ea1682d89fd1EBa0Feb": 21278.17,
        "0x9bdFe6F3D63C24d02ec161C4d43ed4f38E9E44Ea": 21242.92,
        "0xb5Ff09C112F2e631685A95d2946946e291c143f3": 21239.72,
        "0xc444d31e14d5f889879fA28348E25F0B04A9b71F": 21178.46,
        "0x0F9548165C4960624DEbb7e38b504E9Fd524d6Af": 21138.86,
        "0x4E4BD07aD98B674cE111AF5C01f172c1c1F0fE7a": 21015.31,
        "0x0F67ee9F041a681d8e0a2De3220Ffabb6Cc1b2A7": 21009.56,
        "0xF93133E422d2D7684C3efe6C25E1d0B787Ba573A": 20951.83,
        "0xd29d3d42935519a7F7b6ecdb700C63549BBC2D76": 20934.22,
        "0xc036Caff65c1A31eAa53e60F6E17f1E6689937AA": 20783.06,
        "0xe77d26B4Cba1F95aDF2a2dB8d30c231fcd28974E": 20718.61,
        "0x4daC9Bb7C43cE4F35a2eB18715BD72061A8A6C3B": 20691.16,
        "0x2f707265E61300e8290C18E38EbcBd129FB0B0F5": 20673.85,
        "0x7372Ff47026eC4c49EF99b4891b42E2D7bec4D1A": 20637.4,
        "0xE7090015768Ed8f07ada91Bded606f3bc44100B4": 20612.48,
        "0x2C7fb10B8CF82D1EA7288eEF1433E80936c35ee2": 20577.61,
        "0x78EDD595891cf787947888E2e211Ae4D221aaBac": 20570.44,
        "0x9a5a4d8bd1c15C40fe2dd8E1C3eF507E6f356570": 20533.29,
        "0x4350e3d2F78ae7331a76A80c02b4D825BbdE7528": 20480.69,
        "0xd55F61bb91a10921DFb9B0754e1e9b8e3b053b80": 20471.88,
        "0xC593Bb4333DAC717AA202e5b9fE46A7679ecfa59": 56541.29713099984,
        "0x16c27Ac31786A2A9D6ceb9C2b6542ca69b3815a9": 20452.4,
        "0x132552B55F86294ab12549A1b9BC24242A1Ed803": 20448.97,
        "0xc0EF03037Fa42559453740F49E4d2B86c7664349": 20429.37,
        "0x2Ca16EF6C379331ED40f28619f6bf3031b9183C4": 20380.7,
        "0xACDcdd8F69d526F63EE035B8CA881450d4Be371d": 20339.83,
        "0x9DC4acfa8B790Dad0B335a829949321c292994D0": 20325.6,
        "0xA35338638b6C53A80b7B282cA7E195a63B67E992": 20289.02,
        "0xeCF2C68011B46B89B7E70947F5939eB76a164c7D": 20208.84,
        "0xCe6c0bd926A76D715C829bE4965ad064447d754F": 20170.01,
        "0xD8E9ca805237457e7421b805134A9356Ddf7fF74": 20124.46,
        "0x854c829B065b764A331c4334A9649Fb58a342461": 20036.89,
        "0x9C9553CD0c8673651A36e5E11C4989bb629D4067": 19981.71,
        "0x36A69a11A80D1b026142d04104a3C78aD6964a94": 19743.84,
        "0xE583942bF52D0Ed7811A547BDb131CB0819DF815": 19694.65,
        "0xeC90eE791dd2f160D7Db4FB484A5a8dA10602313": 19669.58,
        "0x7d81787cf32263DE005C2ba66f00369E4A99a639": 19669.58,
        "0x8A881FB7bC78796e206BDd61Cba223df44316F90": 19669.58,
        "0x8e6ed79c48944265FE5D004010c11CB28aa105B4": 19669.58,
        "0xD5D66b4718B720B34d80E2f0568b1Ae7761b5F65": 19585.49,
        "0x12C58F57177b8D5832f60Cfa690770c19aC9da19": 19573.99,
        "0x90ca6dfE2E31177520e66E0ADd4DcdAf2d243376": 19526.45,
        "0x9F0f8F07Ec71A6435F1574ec022E98b5445D4988": 19522.14,
        "0x55CcF605fFa7b01418b0A378f1130CA863f58f37": 19501.74,
        "0x662569b2117CA3E8017085c4f507676b3f34e1A7": 19486.87,
        "0xB167ccFdED57D7cc05728268352f59387a28DE69": 19459.16,
        "0x392f975edA2efD17c65E92607D538237dDab0D5D": 19450.27,
        "0x0507eAf766f18790388a03E9199f39e7d34Bfa81": 19404.33,
        "0x231ffD6A226dc0d255205EB544d234Ea52252aF5": 19396,
        "0x8b0473E5f2871d420b7891c01a45eF84eE2d523D": 19394.29,
        "0x143b290f6cfAcdF22A292D6418651C562056Aa8E": 19392.61,
        "0x644f8cFE5D2bDAdd8a1C67794ECdaC915b0b7789": 19392.5,
        "0x939837A9d339d42A25ed052DD773FcAaF903Da35": 19379.54,
        "0xD73602000288e4f22d95e61A5ba2185c6146fB54": 19370.97,
        "0xc2d5904602e2d76D3D04EC28A5A1c52E136C4475": 19369.28,
        "0x0c5cCB06270EE56bEcCaab51627298354437455b": 19368.55,
        "0xb7c9e395fC5392178F1d77320e563fb652df3E97": 19339.98,
        "0x024b14d4054988600e0C1a35e46B5df40157fd59": 19329.5,
        "0x5B370a4EF32f77821ab0D079527c0F5F79AeFEC3": 19316.08,
        "0xD89dCd226f1f902D060B4F5897EDc130D8a7b312": 19314.74,
        "0x0B6C223ef601990e2648b0EE9900268D59d5B7Ab": 19278.6,
        "0x09D4083fFD20D21ACb9118465aD7C52Ac8B548f7": 19257.64,
        "0xdc307a14acae77eaB31e5aAba589E8aA0c0E528d": 19210.77,
        "0x1c2eD7A6C4e3c1146103Fa222181115a72243a06": 19182.57,
        "0xfe8D5Dea7987d101247243D5BbAF7804a1Ff187a": 19051.62,
        "0x02da6e2cbcc167182F7e3FCC9EC05d916DE78f3e": 19014.56,
        "0xB1a702782182Ee47dDa3873dc14B4a008F6BBdA4": 19014.56,
        "0x3Ae55B83bDbd6BbD415a817b765a3f3007ED326C": 18837.67,
        "0x84571A9b96E5F1B887DAaCa74546f4F66e2BD1E7": 18823.35,
        "0xB079bBD8151905a9C5b8eeA388F7D04DD2187a15": 18748.79,
        "0x52e656F95eb9c9B841D81b90C01b53BD51867313": 18743.3,
        "0xEDA45D8563B62f654D403E01fE8d7F8D56B951c3": 18622.33,
        "0xaBBf75A59AC8838FA46bd5260501B68ab28B95f6": 18585.65,
        "0x8832D07a813A17df7275E6B402efD514125605C7": 18571.16,
        "0x8bC7523ce35b3763964cC721d94E58cAC4Dd09De": 18547.78,
        "0xb44930C39281E36708d32f0826BE1973AdD82237": 18465.17,
        "0x9e21b3781a2841f41247D08a7eAEe7d7FEcb36Bc": 18439.34,
        "0x93E0C1Ad46B9bbdF8fbEdde2c268EA331944C535": 18417.3,
        "0xFB9ADa6F22429B2501b5f5B87a5d7ed7181EdF1D": 18373.43,
        "0x6e0f3dceac81e033E9b197E9E5a925e816Cf5E6a": 18358.54,
        "0x39B48F89099347eb9A52004c22f3578972d36E3A": 18320.32,
        "0xD49c998E052F87F961836df339C0612caF654029": 18244.28,
        "0x262ADB1D33B4893aa7C35CD42729410a605A9E6C": 18149.52,
        "0x751715Aa208bdE3dCaAf00480e9F12586dD2202e": 18116.6,
        "0xdd3bA72845D42a9525B891E90C5f7eFF2BDA42B2": 18114.08,
        "0xe2F7Ba22BE7C7a1842cA3ee5D90152AaedA1f98d": 18027.7,
        "0xe823DaB87Dd398b16539756d7e8452FCE036B709": 18016.25,
        "0x615e5022252B31AF496574F00D5519C5d93261AB": 18014.74,
        "0xA486Eab254718D73e0fbFdEa680F1404022F1B85": 17948.29,
        "0x5f4f120D8435ea38F0F4635A910fEe03801BE88d": 17920.02,
        "0x43e51383FD10BD7dDB751e64931CEC0Ca4EfE825": 17908.94,
        "0xd941a61580986DF569c79899DD05b734838aF2eD": 17906.23,
        "0xE7250b214a98F36a78aaff673c40CeE79dcB3f33": 17782.79,
        "0x1290817d15A3497bbD25Eff170E9bc6c92080a52": 17755.2,
        "0x89c5CeacCD783776c5166bd8fDaCE2Dc6a5e1e19": 17728.97,
        "0x9FCb0e9BF251eC474fb47cFFa6698C369ed2CB48": 17724.01,
        "0x54b90990Ce66f6094b6705f5eB2923f97028394F": 17719.68,
        "0x31d71C9F00C4cE70aE78069a3306ac38E263Cbe0": 17713.83,
        "0x21C8dc59f2E9A11c4C1a0C310641968132c6b1Be": 17710.83,
        "0xa8E70CFccCF6A219E673d83e36C1CB9813301932": 17706.15,
        "0x8E29D0E2CA8e92a9f27192616E2E9f170FD2A035": 17697.09,
        "0x837E9c16afB0117193E706EBf51bf72832F44A73": 17694.76,
        "0x78De1F9f2648562ad5938c50f0B4de23925a2a95": 17643.45,
        "0x5C50cd41A08AB920BA4ec2021a7d9cC35A51a040": 17637.64,
        "0xE654ca45c95094b2e53367bcAe95c51603a53006": 17616.22,
        "0x2f45724d7E384b38D5C97206e78470544304887F": 17570.88,
        "0x92B200b674f7E7fbECD6d71d041d079C513D9965": 17562.82,
        "0x30C957fe61b68ED8E106F2ec75FF46BF084F353C": 17534.55,
        "0x31bBDFf724071Ee4B6Ea532EF48b366C59302f00": 17533.86,
        "0xa04275c10f39E8675a34e147E2EF78d35129f2b6": 17464.07,
        "0x029Ae61319e218D3D944f1646AFC9a7dC8Ff1d04": 17452.77,
        "0xa99128687C58b2FE77047DA66abe36216C842257": 17402.56,
        "0xE02Fb5C70aF32F80Aa7F9E8775FE7F12550348ec": 17363.31,
        "0x8f33d3f0D7c735a207e0d347679Ef2e47833Bc1b": 17346.76,
        "0x8CA7683A7Fbe620295e2e0706B9AC41854c46fa2": 17331.65,
        "0x32a9c5902f36d173E040E54f51fcA057b3a8d846": 17306.2,
        "0x7D2FD18d4a21F29520F5Ba0c7261e7706B788E51": 17254.04,
        "0x2bf8395067f00dca7456C83cb89123A77d46a90c": 17228.16,
        "0xD24c39006d9db4e974D073698e24BD0aEcA197c0": 17227.24,
        "0x4285Be4024A011351FcbAa417455F5BA3690fc7B": 17200.58,
        "0x6260F7552aFFF204Df45b5A2965709a111599eD7": 17160.37,
        "0x2d1EF4aCf4cae6a38950971AaAA15f88D9b3f165": 17133.32,
        "0x9887870A0F1399fD4773Ec6bbf1e49A9eE7EF2C4": 17109.95,
        "0xF2CcF51942c4f11570193fFd0C0F5D38F863E084": 17101.51,
        "0x69919784Ed0A769c5C456C192f426d8da92Cd1F6": 17099.82,
        "0x4BF82924c89ab4e10CE9B71Cd005e80bdD635011": 17049.61,
        "0x59120C681e00d89fb70FeCFBc6c5Da9F84bBc863": 17036.34,
        "0x0b72175c5C53852C8C4ba6b42c95aF32fCE8b117": 16965.52,
        "0xA23D810AF41Bd97003Bf066A4B236C59DB252B12": 16950.22,
        "0x342f3002bb6F77441dfA40480Ebb169d6912B464": 16945.65,
        "0xF9ca1CCF1AeF6485644105B923472E84B8F0110f": 254990.95,
        "0xa0Ba0d0D34bC981E44ada879ccd66D6AA36970E4": 16895.85,
        "0xc731cD6741e733A44CC9880D09D32928a75B9EeA": 16848.56,
        "0x9255b1f85D7383cae6Ea340fAfdbD5485E7B669D": 16845.64,
        "0xF674703F604bc6f5E97bf2e773Bce4Cc60F59dA1": 16769.12,
        "0xb73C6c5cE781D7C4ab71d07C8E6d698960a01e33": 16751.76,
        "0xb0F892fd2e3055CDF753bD191B0be5547f9805d6": 16747.82,
        "0xf9c6F2Ac725fD4497DE30d0D3d7c65D578c2d864": 16727.78,
        "0x269D1AF29B51F1edefa0B229ea309756f1d6cF61": 16719.49,
        "0x0aAD9eA1468E2d39d4C1492E66fccBeBd3c93f6c": 16709.37,
        "0xf6657BBCfEB5C2746E8C609e35018A5a8caa13fb": 16700.67,
        "0xA5A333D7B77aD4543202d51a9D3DA93F9e7BABb4": 16657.48,
        "0x2F05Ef527Aed72FB86187f59499AAF8db7805aCd": 16601.26,
        "0xA303d212F5cb38008ac82a3CDE2FEB5b43f4a585": 16582.43,
        "0x5Fa9D99567956e12892c8D02f31bad7B7313F6e4": 254661.82,
        "0xBb942F8503C92184493620A63c082947A22Ec518": 16538.54,
        "0xd66487D456b74f1030778f68A8f6026219D525C1": 16529.51,
        "0xebf2e0b82F63F4a6F9Bbf95A7523Cd2959CEC815": 16516.41,
        "0xb9469d0259EeB748B6192D60917Cf1C7515c6463": 16512.88,
        "0x49a5492FDFe5AcC966dD5f41310dfDfe8dAA349C": 16503.27,
        "0xeA006f77c5859d433Bbc7e870Ee736D3d1173748": 16476.89,
        "0xa8e32Be4CA13b271673f8b01F1eeACFde66FA413": 16476.12,
        "0x5925C5c6843A8F67f7Ef2b55Db1f5491573C85Eb": 16457.39,
        "0xaBFAeCD310BB3455c767f1D10b94fF2A00146e6b": 16407.49,
        "0x05d2838E962299878BF9e8941dD396de4aa998e5": 16404.49,
        "0xdAD29981B5FeeFEeaf3eF92E678e53c5620A1Fd8": 16392.97,
        "0x7ee4E555C4712C415739D062cf84Ac0572342780": 16391.49,
        "0x883ce32E186c69559E94C8BA276BfC4322Fc194a": 16391.49,
        "0x6A320376Cf70da2d49C4aa3d66678c73601Dc493": 16391.49,
        "0x251612075db39256e11f2CE8fD5e91837EC41CD3": 16391.49,
        "0x72f4E8B893527e3884bB4AC5a28d5Fc65172Ec4A": 16391.49,
        "0xBCaC78Fa3Aa7E22741B86968cA25eD2832a217Cd": 16377.36,
        "0xAD1967E8645480f8bdF7b53f944D850278489e35": 16359.58,
        "0x2B4A4fE93639C70Aae55ADf5e63f3CBF10956292": 16322.94,
        "0x120b09EbF1367A5C5A34255c2656ea786cF51b93": 16299.48,
        "0x98C76dB981B22d685FefF0AafBDfeAab61892e8B": 16277.09,
        "0xcC202930867769A83B61cf5053b65D1845E76Aea": 16273.84,
        "0xAd21eb4ac54b3Dc28E89D138a91dc39F8f4f7e97": 16270.9,
        "0x5A3C28d81e05231A41Ce31785e71c9B0c8a4551E": 16249.72,
        "0xC606e3D6C5dd451aB79B554d3A560833FFF2E5Dc": 16240.15,
        "0x01363641168b525ED97e05441EDABF0fc1DDf098": 16210.59,
        "0x72e0c1613fA025219F140ff7de144affa4a2207B": 16186.07,
        "0xf99C8873B972b4192e789F55AB954188D0d9A133": 16174.5,
        "0x876C56e9EDaAa44AF9BC9678784d15ad76393E97": 16169.28,
        "0xeCf9265f48006DdB6EE14060faC59c9429c32db6": 16087.66,
        "0xcE331D9e01aBEe36D97873b0831460a33c9504a7": 28061.005570188958,
        "0xC9209Ea1FDf07337C481329D8920C14412E881e1": 16036.73,
        "0x873D59965b2C97eCd536bE8438153DB432597b9d": 16026.7,
        "0x6bD230ab7AD109249b19ff13802352b70DFf9F2F": 15968.26,
        "0xd697D6237a0BBd246a83AfDc01A89F32F00EfD89": 15966.08,
        "0x7cc2d1D8a364A1Be93756B9a2b391ea7Cb0061ab": 15951.79,
        "0x11737F72C093a3338eEeDB5D4361fb13750B29C5": 15885.82,
        "0xD4A334569623814306170851eC5f1fB32fCD08FE": 15849.87,
        "0x83157591b287Ffe991e1Ca122bE28609aF54015B": 15829.57,
        "0x51d04309554b342C8A53B49B6a16244a727c1164": 15814.98,
        "0xd2B2ed04b2FdBC6BF913BBDfe6DBaA99A2C1F8cc": 15769.46,
        "0x4BBE1A432dd84c0c59eF6891aC6FDff9fBDfE94c": 15748.21,
        "0x13396BEfF4b01d289B56102fc40934802D9fBCBb": 15714.34,
        "0xA4c63A2E8D0556dDB36C6544625284c663642387": 15703.76,
        "0x1849f5421CdE7ed0a6FC04E14bF2Bdb9773aaca5": 15689.53,
        "0x2d1bdC590Cb736097Bc5577c8974e28dc48F5ECc": 15515.26,
        "0xb9C0aBA138B98656FfEa4309bfE2881b0b7c1d96": 15488.16,
        "0x1DCb82280f423f475F7DC3A76Ed53f3C38578fA7": 15476.98,
        "0x9a30dc19752e2f2144CB8AB7CC2e97E23F7Eb32A": 15342.03,
        "0x0b580F3c49a78f9425cFF53c0d55068Ad0C4373e": 15305.75,
        "0x5e7Edd21320689f4dEC9D9abf60546Ca9754E62F": 15273.65,
        "0xf369D414C57C433EEd829f71463e1Bb178B3eb24": 15262.63,
        "0x8e85ef8b55528C1735630A6A43E665F5Dce160FD": 65929.80982201632,
        "0xf0b0A5bb90f94b4F5570b41106d6C325f7b53079": 15125.39,
        "0xf5e21B28eaBF1f0ee8a5B3f7d9F8b9768d71f8Cb": 15105.15,
        "0x108F6FCD3f6c636A1A3e3EE546FdC5eDB89dC200": 15080.45,
        "0xD9AB60257584a9cd2037C89F2fFAad1b0825cbe9": 14982.16,
        "0xE2070D28960CDBc5EFD0E00e55346e3fca2D0d61": 14971.41,
        "0x8BaA45B36381FF1BD33E4d037672e02a287b7f0D": 14935.06,
        "0x68258012DA3B933a81617FD08c9382a60B87cA98": 14915.01,
        "0xda1d9534BeF3344Fa5be3B644b767b349e7415C7": 14899.43,
        "0x7eCf3629e27b410d6a277CDca9c99240706EeBec": 14872.47,
        "0x28111Bf0a9851D581274874eB2B000Ce711fe94e": 14860.35,
        "0x3EB5d4E874f5A9228f291486329E3E935Cac468C": 14820.58,
        "0x6ff9593468C947e15C79F031E0B2b10304607d3d": 14804.88,
        "0x5A6efa4A3E361d2C97b53D55ca94B37d59606A10": 14794.76,
        "0x14B8FffD0Fd5cB37862D85Af7B2Ff0BB26F3f948": 14771.76,
        "0x0bee06fbA2660DD41fdb7B950F0592bbCd7F0fcc": 14762.7,
        "0xcBf08b80f7767B6A44F313aCAF44551CBeFCd226": 14740.74,
        "0x78FF53C8Ec318952A6cf09C3122eE057645Adc28": 14713.55,
        "0x53A51303653F2Eb56419Cf762B5D3799084C5B91": 14699.98,
        "0xAbFd07CC78910F8875169ae6373D95316F4cA117": 14693.62,
        "0x342dF3E6349c76b63CDdcc30291AEAf06EBA099F": 14649.35,
        "0x523892711c660Bc0Be2B3e39Cc7B8DdDd3AAd62E": 14643.24,
        "0xDb7546293BF2213932500Ba8fDF3f5926FBc8759": 14629.34,
        "0x58f1101f3632f1D0544197351FbdEd673f4b43F1": 14628.1,
        "0xF0ffe0A27B1973891061B9c792aE5204aAfb8ea5": 14624.86,
        "0x05391A4b0749c29335024f41552a56CFa6bD3883": 14602.43,
        "0xbC559b4806eEc27b76b9aEFFae83c8c873AB04B0": 14579.92,
        "0x96d4Fa4f39BFBD52dEa1Fb90500e79eb71522aC7": 14552.46,
        "0xBf891E7eFCC98A8239385D3172bA10AD593c7886": 14544.01,
        "0x38777df3752369B6EA6c48f04218bA97ac5CFD43": 14528.16,
        "0x016DE4568d4c9Cf85F03B0E19C7cE90289Fc2f32": 14526.24,
        "0xB9351ce53776aBF7255D91178F0eB2a615CFa55F": 14514.18,
        "0x5a67E7956cbF099Ae7f66D7d89A92D9eEb7e9Eee": 14557.297279483199,
        "0xc4cFDf12925E2d99709a33Ee0359732e9fbB0eD5": 14472.1,
        "0xd9842b5ad55ad0cDa47eC445F655E3575b855f38": 14397.97,
        "0x28737450c5725E0C36bec34eFE0315f7049Dd028": 32653.875444491456,
        "0xc6C8AeCb1d9cA59A09d691cDa8539992655dbfB3": 14385.29,
        "0x82E8936b187d83FD6eb2B7Dab5B19556e9DEFF1C": 14383.37,
        "0x8E9556f07B527f0bD220C8cd32bE818977b7DBD4": 14361.03,
        "0x92E5FF59832DBdfa7D18b426Da732CaF06A740D3": 14328.29,
        "0x94Cb984930abb5A29158D21FfE98e48D8e895F6A": 14322.61,
        "0xF300c84CfaF24Ce0aa10ccB7A27bc368Bd372b82": 14321.31,
        "0x1d23d35B510945b3Dfca94b96A00bf1d3429cFa0": 14291.21,
        "0x4D26f0e78C154f8FDA7AcF6646246Fa135507017": 14285.07,
        "0xf016dd21BB62fca44Fa29EA9d1f956F02B6c133D": 14284.45,
        "0xb31C2c1d5d1917eFe283aC20f37966C2A527C9eD": 14267.54,
        "0x156C4A0494Cc14dcaEA0745cb8980f389f7E25E0": 14252.99,
        "0xE339DCcB403d115b4CB27E68cbd0e3Fe8c8f2654": 14224.06,
        "0x0a0970382ce3D4ddAbbCD5e4CcB4A4C8dbe50641": 14214.98,
        "0x40bC680b605c6A9824860ABB101e482A8131e108": 14195.76,
        "0x045Db8C69A085a969224c11FF2Ff880ad4381c32": 14187.9,
        "0xf5a93410e7e32BBf28a8EAAfBd7f241cF0b290fb": 14185.78,
        "0xD8de1241E440b18f152aDf070997e1D3B7D80735": 14167.38,
        "0xB8B5678FB2Ed1df5f8E04Dd418D255796B97e6C1": 14164.88,
        "0x60Ab4608ba4cE9cAb603205b5Dc44B4b792E0037": 14257.165571927353,
        "0xC43b0f71B1692f66BD17a00b211daEc5C8409793": 27650.4893032501,
        "0xBF8a49F2E6a1652F36B93481c03a92f1dd14F379": 14091.09,
        "0xAC13d98bACbE371706095cb5Ca4456c2Bdc6Ee30": 14072.42,
        "0xc945D0F96E4b91333F0EDc870007d419806Bd970": 14057.23,
        "0xfb5cc2c0d9EDa0aa43981554328F9C302f9EcE7a": 14049.12,
        "0x85dbAb45F8904b773F6B7f0a2E3c5fB84f642FA9": 14006.38,
        "0x773a48228A236cc42e097aB82f3bEe3ed42e553D": 13965.22,
        "0x28bce2eE5775B652D92bB7c2891A89F036619703": 13905.66,
        "0xecAD91D97aB9FF4bdb79897eB514728B828b1103": 13899.34,
        "0xab9A9c8a76edAc1F58737ffa4aEbd5852356de7f": 470105.9062978466,
        "0x11c4820c6869d43f3b49b7EB49dc6C09EeD12CaB": 13800.73,
        "0x888fA186b31C4b17D26e1Ac6c95EdF193c2E6B9e": 13768.41,
        "0x6639FC94a92435d36838CCC6e70A943A19e0f97f": 13718.89,
        "0xaB13e657EB072C53915730AcFaB14446ee2293c5": 13629.57,
        "0x4E51a06e4643197e1be2F050b6aF60F9AD3Cef06": 13622.52,
        "0x072c43cCac7dFe74759AfCae907dcCc95c375507": 13578.48,
        "0xe7D12F406208FC2BFd84445ec7231C06d8E4d262": 13554.91,
        "0x7eC06aa501F3680e4B3775ff0C388B9fe46F3f64": 13483.01,
        "0xE799961B76d65A32365D34289D5AeA6C2242FC98": 13367.09,
        "0x43231335cD8279C9398c987CC74226D0e286E37b": 13334.75,
        "0x29C764d43758a6Fda11e8ede4E90A5E4Be74480F": 13283.14,
        "0x83510a5d0C5478fc4c505eaB2c5BE5B093787A18": 13251.23,
        "0xFfa9E3C940a406F6a16435a5ADDd28A84e57a233": 13244.39,
        "0x1f92b5affD12981Ef0FA7Ba22a802379Fd36929E": 13211.56,
        "0x6516DEDe38F2E0791FeFD07c2E550dF3C87E10eE": 13193.07,
        "0xd1b33d10965685b4bAbd93E07364837DDB480480": 13167.49,
        "0xde3079fb367986D2Ab07831f12C5317f321Aa7fE": 13113.39,
        "0xe10aA6b38D155D3F3DB473204c9E4A207bbA12c6": 13113.39,
        "0x97Db0E57b1C315a08cc889Ed405ADB100D7F137d": 13113.39,
        "0x9d8D285dd363e46D0A8965b57d83934b64978F36": 13113.39,
        "0x55A4aF7c6a070406221afefd66e0d93320B50ddb": 13106.39,
        "0xEB9f494f9336159BC9f3640FBb2cc521003a8477": 13104.61,
        "0xF2829fC923b6fD040Ead55d3F973F2953e86D13e": 13075.38,
        "0x3fb2f9b8addC3eFb0bfcCAB8AeD6e5930C56cF57": 16115.167165901874,
        "0xA0fAA58e05F32D11637005f342b58f2f3E30Ffb8": 13009.94,
        "0x569Bab69FFa71AfE435F64640210d1F0D49a2733": 13007.78,
        "0x1d448EAE1797a5b64E1Ae1c0a3E250E9A5281ef1": 13005.35,
        "0xb1aC25c795ADCDecbaA3fD4Cd5d0E90f278A1464": 12968.37,
        "0x8bbfF92717C6A299B34aB6b1624BaE1252d528a9": 250993.12,
        "0x9578380ECb0bb6E546C89fb595090645f8AbFfa2": 12839.18,
        "0xd653971FA19ef68BC80BECb7720675307Bfb3EE6": 12719.38,
        "0x3E6dC1BFcE0594Fe8061988B688C4226C9BD3F8f": 12665.2,
        "0x15e94dbf0E9D4C40896F126624CFa8393e2A9855": 12663.95,
        "0xD92CD959eDC3Da396A08F3008742324060244eA2": 12640.75,
        "0xE6Cc82149C037dC41dE39add5C2aDC014416f7De": 12634.55,
        "0xf6be6CF8900f4FE12848d2B2DC3bE241cE17138b": 12633.07,
        "0x815956Eb77B37401450Aa332eDeB51DB8C4F31eB": 12598.2,
        "0xB4E01F026c1FE5A4a9902169c3ea0A37Fc1Df082": 12584.74,
        "0x8516ab1Be93cd8973703391b500799BE7a6bA01b": 12576.81,
        "0x95F424cB7F8883c126265b0fED5AC68349596b2C": 12550.65,
        "0x444e6d946CB88Ea856f393AeB874c6c952aa4d56": 12550.02,
        "0x15568a29d52Dae40139FC61C075F27aE7ad58C20": 12547.61,
        "0x78C12f471dd8227E96fe0989cAA4cB7e17b29fE0": 12537.3,
        "0xD376d05C67365bB2cAbFbe686462e82af979B301": 12516.33,
        "0x984c5d268B220784E87fbe8EDbb5C6b9F7ba9Fc4": 12493.86,
        "0x879804b99396d979424Daf9AA7d2e01CF660Ceb2": 12485.76,
        "0x783264049081a1f7C1d0312c40B6C5db51DD57eD": 12472.89,
        "0x3d6cd06ef4ef34318524E69601a150349e8086a3": 12435.43,
        "0xb3d5D50A49C50734c710F55a8111ee15c61Edb02": 12424.86,
        "0xd7102A3744c302f167c53621453516345bC460d7": 12420.83,
        "0xaB57a9E1a500eC0165CCDBc9577f40fD683b47Aa": 12418.67,
        "0xe034E79fE266900Cbb771abEa829eD57F29eDCd6": 12395.81,
        "0x8061199A31983A077E691C08B2263a4CF5c24093": 12385.16,
        "0x6f531B21829DBFf76445910959052b0f4c08b5B5": 12374.22,
        "0x53e0B897EAE600B2F6855FCe4a42482E9229D2c2": 12363,
        "0x596b5A4d8Ad7faf91694d8Eef40e89c5a2E3de58": 12341.28,
        "0xbFfdc0E6C93bAe0a5Ad4488d5366fc5b89064626": 12330.64,
        "0xFe44Aa13A9d54e5E1Ca944959e9d94D9fbAab93c": 12309.08,
        "0xCC1E5EC620f03ca90D7dba7904cac90936439428": 39979.55426327161,
        "0x7f64219e48e349295A580bCa164434eA5D1E8433": 12290.17,
        "0xc8B6aD82adCB2911f607965d8FBdD036Dc215C99": 12269.64,
        "0x1927c3956108cE4887f03aac770DF22f3838795B": 12242.95,
        "0x0B047D8A08012daE90124c05d9Be68605db34b68": 12217.47,
        "0xa631fbF4b06fe773c2e67f62b1dD42797C48358a": 12192.38,
        "0x4b702e993b85bA0C176d18D30F6320b40559Cda6": 12185.36,
        "0x24db8a0A16Da2812B55AF4d0F3a8ADa8A68A330f": 12148.7,
        "0x8331b954fB84768D7601ae06f47a766c8ff97cbf": 12056.32,
        "0x6662304e3198C8D54530fBdf02A869fA84537639": 12047.61,
        "0x99776B918df4f78F41D30ba619929486f8f0A104": 12005.56,
        "0x80D47Ef41e415BDB23e87a383E97ad133C2d0fCe": 11987.49,
        "0x1e1f1758c8d6687C9AD13beD8A9F058C5341a359": 11966.51,
        "0x4b7292679D439CCd83B972A5fF848b47391AFfCA": 11947.15,
        "0x89808C49F858b86E80B892506CF11606Fb25fCDC": 11928.71,
        "0xBe2E24eE6171c466f4Ce0A2eC0d6a02D242b9392": 11927.03,
        "0xbF7e028AC196E925100F222BF85e8F61D6a3B61D": 11911.43,
        "0x5A5BBbACB4Cd325D2F44771aBDfB3d7c3697AB16": 11910.77,
        "0xD870E0af031778d00D53943BD55E00EEd0D3013e": 11910.01,
        "0xc5D7BE4A4e5957BAa078201F41d9Fd5F21b91B1b": 11903.02,
        "0x86a99D3CC0A6071121F015837C8bd832AEED90a0": 11864.65,
        "0xdC30074568965E23e7fbd37b1DedF2dAE09551ef": 11852.93,
        "0xdB58a1F478Cc408266226EBd811EA407B5820d1B": 11840.23,
        "0xedAD9aaFf8932605729C0331EB3B84aDCC9435b8": 11835.42,
        "0x606E2F7f46171fcFc38E3aA44D0FB2aF597DFDA5": 11815.86,
        "0x97c8025C61Cf3E2c59773dd083b748a27647e843": 11788.57,
        "0x045C678dBb1135D731b9000b908eD14e9F272Dbd": 11766.08,
        "0xa962affa8730993fDEAf096e5EC6C633f30CE634": 11746.86,
        "0x76e3e524df9e29863B06cd858bb1D8ed7F3dd8Ab": 11727.78,
        "0xA7c67dEEbAe334d52Df65ceC413dF9B0985cdcec": 11726.38,
        "0xDA0253dE9B557E5655cD7800F954D9948bA231b9": 11707.23,
        "0x60E9417fA3f7a2c565d3243d257f656FC2AFc15a": 11705.51,
        "0x58fAc82e724efB4EeBE43bBC6D824c7FB3D64FF5": 11670.1,
        "0xB577517FB7A0A174551d6933c7Ff2F0EEA3004b6": 11659.43,
        "0xfCC70cabF2d78E59294EeFB72f4F4A4C1B83322f": 11642.25,
        "0xcD763667cd74543Bd05c19386347441D3D3f6392": 11629.43,
        "0x8d655b1AF80200A6b81E11482fdeA66328b16E05": 11624.45,
        "0xA8F02C6B221d01F8a6d8adBC88A5F85b8569CD8E": 11604.98,
        "0x9D223c40342454B73b998eDa82cBF45E1D53462C": 11580.78,
        "0x5CF7db17B8444504B0b2C2Cfe71e3E8351505464": 11539.48,
        "0x2fb5Cde64ddD47d6AeE0dAac091E16a6AD0bB7fb": 11535.99,
        "0x6B5AC6552f2bd30F7EE7a9c4BB96d3C638a70F6e": 11533.53,
        "0xfe7364a43f1fbe03f7Bef8980a55e2ad3Bfb147A": 11520.32,
        "0x75066c400313276b9cAb1DE56F3134BAF8B974E5": 11501.54,
        "0x1e08fe4EaF8311FE0CdBf27a555Ad79D8022e351": 11495.27,
        "0x799bdb9CB1FC4Ed7B74c989a287fE9864d5BbAB8": 11470.72,
        "0x189570003b7D8C2D4c65406AB9ac2848A5107afc": 11461.78,
        "0x15088A7b5386B87d2cD8674f41AebCD1d5217631": 11461.38,
        "0x10F4F9036B285bbe93826F0b7D829eD0D6b6cA76": 11393.94,
        "0xE7DC5Ce9eEe1DA1Ea3C1613D83E31BcEE3c59082": 11392.12,
        "0x8399953AB01861D98EE2DCdee2147dB3fdebfADB": 11380.66,
        "0x54d38EE375b1736348e85e2E243C2f6f0A0f115A": 11366.96,
        "0xf6708f67b55372F7a46Df39413cB568a52e8EA09": 11338.25,
        "0x7B5aB58239EabCd559dD7A65f9e43Eb6db42a413": 11325.9,
        "0x983a5924BC8776DDc09BcA2D561F6c2BCAf97398": 11309.59,
        "0x97529B6B0f6Aa5820C622F135511A6A6E5CE021C": 11270.47,
        "0x48d18A882b0Be145606A11fCe6F8A301256B93fa": 11251.31,
        "0x3F0A53f64670E84d0796486136C217E6aB7B17a8": 11230.16,
        "0x6fb5421989807f828926b03E44A5Ce61D6906EE3": 11215.83,
        "0xC5d77333CC3627f99720aF702d4aF3A0e62ea596": 11206.48,
        "0x6A1DeAd7857Cdd63132152A17dd9201699AA8352": 11201.92,
        "0xC3c2A85272201F941F38E9c15fcD68CBf26cB09d": 11198.29,
        "0x593851CA21Bfd716a9FC71c744e8b1CdF101535b": 11169.62,
        "0xA0035d1B65f408D605C2754b9aCD0E3bA4013202": 11146.33,
        "0xB8C5a8E925Ab9fDa669EaeD03bB1C12929f7c642": 11141.21,
        "0x9aA9BaAf1e4Cfea1560cC5dD19f4351b49E299F4": 11088.22,
        "0x3cBF784380e2eA825e6aC8F93A5b75eA77e49bCd": 11025.31,
        "0xaaaB861931583f1AaDbaA91b6658DEd0BB6044b8": 11010.32,
        "0x123b154F14f879f23c5AfA950d64F884EA33A4fF": 11005.24,
        "0x21B4C834ff6E846dcA66BA63795C521cc7D4BC6B": 11005.18,
        "0xDCeCF114cdA49c2bf264181065c46aa786A4d084": 10989.07,
        "0x27b97cFB0eA261Bc0DA1A0309140A16202C7DC00": 10980.26,
        "0x283C1BEcDf448B192DDb86Bb4d1aa516bacDF985": 10957.37,
        "0xdF560574997EFA07B04cB6f55DE8956Ea2Fe1704": 10955.53,
        "0x42cDD5a2C855EBcf777316daF86D5c05dF1dc8b1": 10955.16,
        "0x32483662B8F73f0D0aa3c2931163b24966d5F391": 10949.3,
        "0xd3f179Ba57411Ad5D2DDB5f334215cdfbA134D20": 10941.24,
        "0x7Ed7888f3bF70ED07f94Fd7381D39476928331F7": 10939.23,
        "0xA824477AEBF0C1c839DC339b9030A507d4379912": 10931.17,
        "0xA2861C175e5aEc9cC58A3804821EBF6d858Ba36F": 10885.94,
        "0xAbEaA41fd6a7464b1203b24486526b0461a5ceA4": 10884.31,
        "0x9365187185bBd0732a66E1084E8AB8701B56F09b": 10850.56,
        "0x75C528eB94Caf172073Ae01667B9d740a1BFb3c3": 10836.45,
        "0xC1AaA96465c91804BC825Eec881f142bB1d6B7Ad": 10835.61,
        "0x1cfD56c2d5502B5205d91100F1f928b157E951bc": 10808.96,
        "0x2c60ea1039403C0B3c88D442A3Eee4850e4e799B": 10802.84,
        "0xeae5dd0fb83D6F65927cceb2561ea730461a4Db7": 10786.57,
        "0x5D4d3FaE4d0282FD8A558b5f42Ba700974cBfd1A": 10772.47,
        "0x1234530f2F57769e47D6F6E92e6F52E85929625E": 10767.01,
        "0xc06e477C74ab62f8DA9973832d1ef6CeD918F36d": 10756.16,
        "0x08cdC985242a6F4a3c1177b2d53F3FD474AfF883": 10740.42,
        "0xB5647958Cf71D7509A00c09f225005C090bb878F": 10735.24,
        "0x3b9A37aD9a5D101037a8bef3048B5404Ffc0016b": 10723.16,
        "0xbB8FB9928D7a3d9F3CcdCB2De47Db1534BcCFFdD": 10713.52,
        "0xbE684DD545f83A07d152Bf3b0EDB645903A3F66B": 10707.97,
        "0x28573e030E72e7BF4e1CAbeE75562Ef7f8abF6D4": 10707.38,
        "0x412eb8c11C4c41103e2763c408f0162c74675109": 10694.38,
        "0x4840514E51D4C4b5Ba16DDC74E40082cd2eC52A5": 10672.37,
        "0x8eC366961c2b7deE9abAe6EA897e91D52685686E": 10666.42,
        "0xF00A99781109bF625Cea8a4138D615691C10F199": 10661.3,
        "0x82EDbf821D369F50F1dE46d954bB26Bf8858b68f": 10647.98,
        "0x69eDdFb01aF3142438bF785B215FB4B54E2A600a": 10589.53,
        "0x8f2CA1C48e99D4a23e9595fC734eF9f1AC41aB8f": 274346.1907526826,
        "0x9057Cb12392539C553ebE2148627F3D79f310553": 10568.1,
        "0x29F9B8c796f01B9A01d5fA62bbD0e6eBb251a188": 10563.39,
        "0x989A638C82B8be7822739101c25913f10285f2A1": 10574.476674578946,
        "0x88B8073739F867126C96F392512dDB34EF3A350E": 248637.57,
        "0x12DAd3425D0ec383EBd9E86139A103Ce119aa0B2": 10539.39,
        "0x9BE00e41dF256E6D243Ef861F20Fe3d10E432273": 10527.24,
        "0xCB78A21421D4559B9F3728EFd9D44c9c62349e19": 10495.45,
        "0x170030EeD9678B8ce8dae357D18c8cdA4D97a68A": 10490.31,
        "0xda4Bb0c3c1061D468b4D57B08e5dE3c781Ce1d80": 10480.34,
        "0x9959c0522733D0543E2b22394cf5b7D396D092A6": 10415.64,
        "0x7e9c79d7666F8925345AA4B836C91719B2D0BCb6": 10378.94,
        "0x505f69dbcC43A51d7ef1C2201f54eE116C45b20B": 10363.88,
        "0x64dF75e142Ff37e81d58E479Ced2Cf830e160Ab1": 10347.2,
        "0x3336C6962bf81940976ed6bc0dD5Df3224C88d58": 10344.1,
        "0x8aa63a11835Bf0139E41859540f0C7161a92C7B1": 10331.13,
        "0x6C6cF767f07A742FF114879e0AF8a68fBFF10810": 10254.48,
        "0xEd09B11BD34B3094f479B08c9dB9d47b32dE994c": 10229.09,
        "0xfDE74F505Ff1F14aA1D7dcC25be82ba9A9ce5473": 10219.77,
        "0xb11903Ec9E1036F1a3FaFe5815E84D8c1f62e254": 10218.02,
        "0xD6980B8f28d0b6Fa89b7476841E341c57508a3F6": 10170.95,
        "0xA72d56D25879dB6CDe152659CEeaFa1A3036a194": 10163.34,
        "0x8EcCac8e1f37fB88c74a1174757132a1B9A3d029": 10162.98,
        "0x3D293f8fEEd6cA2344319881fDDD1CB75093385C": 10160.74,
        "0x413478D6739B8F69a697eFc02bEf1561Bd9f37dD": 10138.08,
        "0xCF7C4E1AdDBcfc5ECC1D5Cc23FfB37Ca3c4D6085": 10111.81,
        "0x1Eb18844ab577B5ad6FF35D1B6412839a4dCdf31": 248206.11,
        "0x6c111cbCb78BA90e3cC039515241f30D54E65665": 10077.95,
        "0x0f03F1Df2B5380AF381A10333F5B2C584B33F386": 10072.1,
        "0xCD811FA372EFc3e765F3D4A62fe25f0D81b71Ba5": 10069.14,
        "0x7BfA1E486037271090465A2E755f7676e8Ff7062": 10055.13,
        "0xbb095b350EF47d17138AA3e85cD2503054cc6c51": 10054.91,
        "0xc2359d9Bd9C65A34Ca2BeA9A9E5EEfF4DcD78d59": 10053.73,
        "0x9245438524aa65b148bEe7dc3625E1082b497A48": 10027.89,
        "0x0F89DeF402B8Ffa30eC805BeA36216876cC3E318": 10025.66,
        "0x29563A4408812680728B4b8C44b19288Cc9083CE": 10024.31,
        "0x5181Cdf1bB20dA04bA788F82989F29E65B67314A": 10021.78,
        "0x9dd875f4233db8b7f660367541D0697c7DCBD266": 10012.47,
        "0x5dCa7bad26550B04A2D6911BA64Bb7E7bDd67787": 10009.49,
        "0x97D95aead49d36F45574C0EdCb7a90A42dBdF8c5": 9994.49,
        "0xF925cC2cbea0b2B30aef6C29ec0c77d7cb6FcB6f": 9957.73,
        "0xA4b93d80cEeaF2960927BB719092A1529979Ac93": 9938.82,
        "0xA70291AF2821C817EF6B4248635cb9FbBE666645": 9932.48,
        "0xd639eeE81B30d8B34D5d8CBce83F193E2Ba298E4": 9927.58,
        "0x77fDdf0c4027ca4049cd3d7CC0b170ecaE20c891": 9903.59,
        "0x6eC8d33f755dbAd37dd138fD1505797fC4db46b0": 9889.26,
        "0x8Fd67BEe4B1263fadbdAe09Dc57A679C42cDA78C": 9888.7,
        "0x83eaFA47e4AB967f09186587AeDfb52aF0baFe9b": 9882.84,
        "0x88E6436f37cB5479b3AF0D92ca1351841CDb0C48": 9880.84,
        "0xF3052bcB48E75E0ae9a6b450D7FdBa68A09d9A7f": 9880.34,
        "0x00Be37f5FF77E402994B8838671639200e5c1a11": 9878.16,
        "0x8B223eE418fae4a7A3638b8d07Bb584AD3b68aEd": 9861.08,
        "0x2362e874D34d9D8DC21dd2D8d7DfE8ceAbfC8dd3": 9849.72,
        "0x92f8a15C264D8954FffC711Ab7150F81105bDF13": 9824.39,
        "0x757173C4AAB5C9425CE1917728ad4fd9b14981B1": 9824.17,
        "0x7afc53FBb65017617Cd4BABE4a6Ad19b65ac4850": 9819.19,
        "0x65BEEfA05108f8b728442e21f8A3ad6bcC59992A": 9806.11,
        "0xCdC663260A596cc5F8c936d4dE1290ABB67e29fC": 9745.15,
        "0xe5D3284584942b3d2d65057F109ebccED35C9799": 9744.82,
        "0x984F47Fec079d3349bb3AbDf05e40720E1C2d968": 9734.61,
        "0xcA96E5BF18770257c78EB297b26A67c412871Ca7": 9723.71,
        "0x9400F9d69D65cf391A87BA289120d2d3907FdC88": 9716.48,
        "0xa79Fb471D8667f80a5f8a128729566519b49a2A9": 9683.8,
        "0xC54595E2CD49d353139c1668380ca2E9A4Fb62Fb": 9659.05,
        "0x3017c6C75B2Ec21F89EbE23A6a7A50C7D889f08c": 9658.98,
        "0x5A6AC1B906Ec9b28Bd235B2F0381933458f71Bc8": 9650.81,
        "0xD04306F9a9E951822565f598BDeBAc98Cc87072A": 9641.2,
        "0x672c3D2Cf6E85Fd757abE557132CDca985a3F2cd": 9613.28,
        "0xf40Aca18A3488Df44B56C92a64EF00B38865178C": 9596.57,
        "0xf8b4De98e3487502c0b713CA90628C1826426841": 9595.74,
        "0x34aEEBD1F93Dd050f7bF188E581a7a44414FF47c": 9578.94,
        "0x79EF4490E245A610B590Fa4a221563d546483cD0": 9575.46,
        "0xCEaB5B24009A2fdE783440169f0b1b91e0fDdC17": 9552.43,
        "0x2D12A08Fd8f324e4B1A8d96502D4e11b45d1FF76": 9551.75,
        "0xB061271663099A8C97CD3f182fc7cFC0CD1a77B5": 9538.87,
        "0x1101B2038664D9BdE3E8C1BD1Cbbca1cAebD2A3E": 9499.52,
        "0x2EA2ce595Bd68a0CD1FD34b06dF98970952Fe4D2": 9498.94,
        "0x20e114F9E53b6f19A1873f0530eafEb809707129": 9492.78,
        "0x04e0e61845B0fdd58FC49591534bffAf26b5bd2E": 9468.73,
        "0xC7151Ef684989593266b7A255c85803dE5F939CD": 9460.55,
        "0x4fcEc3aCF7a10e7e610004192fF521ec3E8f27c4": 9455.78,
        "0x85Da627a9033ABB6f34EE284A3598e183FedA9c0": 9441.05,
        "0x7e2cAAef6101c1D87149295c72cd646586Dd6F3e": 9422.63,
        "0xB413A48088Cfb0074F75349C790062920434e321": 9411.68,
        "0x03568142491743f2EC350b24C9779e51723Be3f1": 9408.09,
        "0x0201FEFD221E00c89B717a8c2dd18097C5C3102d": 9405.45,
        "0xc7D2888bba55a5Ad472A7E1B4486631D1a0Ab472": 9401.18,
        "0xE53F4d44c45dBc16a20aB64f8a8B4404dDbBefEC": 9397.66,
        "0x2a81260D7638b014f84010b5E40baE884dd4e288": 9372.32,
        "0x162e91B08B437Eb52CDACae58a0D9C4BE3B66d0B": 9366.64,
        "0x90b95C7c59dd329C84F5715da1934027c77e3637": 9366.63,
        "0x0BdA0F33311E65379461D0A555BbD7669c0eaA22": 9356.24,
        "0xc02FAdedC679cEc2889BbAF8997caA1A7e06231E": 9348.44,
        "0x998666B774bdf9B4447364FD4c5eE884d6F505A1": 9336.17,
        "0x4333e5316CEcCA5dd40842A88a0702e916dE04cB": 9330.28,
        "0xb9096d6DB733d5971ebD4B901398e6e33bd7cc70": 9313.94,
        "0x013b77C14Ec5b2510452cdA5F7db0F9875Df229C": 9279.14,
        "0x799Da8Ea03D89490Ff3cF6B9ef1A0b806A7864C1": 9273.41,
        "0x83bAD39F067EF72e354F2EA9d318EaAD381a7F15": 9269.6,
        "0x6434cf801692D73B8dB136bC273a421a546a22b1": 9267.27,
        "0x5d1109E2Ef15647772dB320573AA8b35B7732633": 9250.46,
        "0x59a6Bdcae1657aF5dDBceFf96747510392d7675D": 9220.05,
        "0x81A45e133cc36be6e6fF010c83AfF01A18797821": 9152.36,
        "0xAb0199941ae6F1995DFf1447b59771F3AbDF117B": 9128.69,
        "0x26F9de308dcb617416b2e2B504771ee36aa838dD": 9126.34,
        "0xDe6fAA89285Ea7a406185ca257eABc2460C056d0": 9091.25,
        "0xe0A3FA43b4ad36a4340C898d9557Bc1A213CFF05": 9038.86,
        "0x65bbBDc1CED845cC2FE62e23ffB784118202c70C": 9036.15,
        "0x73cefBF6E7766721D99192449E481567010082E2": 9024.75,
        "0x4c2f21fF3F71F693185d7e28868fe7610559FA4f": 9022.73,
        "0xf4c6208CA2b9B37d1968B57793422670bc15124c": 9015.85,
        "0xF33Da811eD333BDFc8803bfD11A63BCef2498C02": 8977.5,
        "0xC32BFCD64cD0f4eb112E3C89E5bb50d628A58F77": 8957.48,
        "0x68a17A2f0Cd56D5181C4D70A310854601Eb8Fb8B": 8949.26,
        "0xE6E9f4979897A6116282CE86EA137899D5f00D33": 8945.72,
        "0x27063FEff63a019681251c907da9E2DFf6edF878": 8944.14,
        "0xaa5DA3e1f4455424E20bb7336443D6f8CA47726d": 8940.01,
        "0x85eD5D7d62cC5d33aC57c1814faABc648AEc81e8": 8939.1,
        "0x4096D69deE9EBDbE23C939a241660F7861e0A223": 8894.5,
        "0xc32053db3De17C5e6845D35dBD4EBB860fe265d9": 8879.65,
        "0xea4bDc60f5D0d6B154CdfDE2060c3820aA5b9527": 8840.36,
        "0xbba2379F5cc9A2f248C5Cf18aD72379AE2478F42": 8831.94,
        "0x7A81AC54ab686e8539D774E266832650774CA144": 8830.66,
        "0xaA3455a35AFe3a0311957981E505Ed99b0cE5014": 8823.19,
        "0xEB4576fE753DAB07635c0Bb6c8f0A355e1Db5d31": 8814.27,
        "0x6BAc80315aef7291c8aE23ff0a52c554a3f0b598": 8813.53,
        "0x40B322cEDd7AB3C379d65A55C51FE13A0B5A9016": 8804.08,
        "0x6c933c0909998907EF33cFdfE51f428512098722": 8796.35,
        "0xfDe034f5672d3E8037F8c69f82e0605AD5CeE7d3": 8791.41,
        "0xf772Ee9B9b90a1ED7dDd4abbd2082fED73E9AEB4": 8784.79,
        "0x969Ed5e13E0306d779CB8805A27c5Aa8617Cfc71": 8756.3,
        "0x57Dcbe7B0C745c3207AdDF237957aaa12C7Fa006": 8748.51,
        "0x70c9FafeA22ACC41Bda969F8ba2801af42456f51": 8720.45,
        "0xFfea13345dE4A4B0064ede70a7F38FD8B026091d": 9579.540943915039,
        "0x461329395d4465C19989945AaDA890dAF2cB4cB3": 8696.77,
        "0xE11A5323aef5c6Ac57182007A7fC6b30440994E7": 8660.82,
        "0x541A53d783a90fb0224d86f90b366E8b33f63874": 8649.16,
        "0x775153972BFa611FC70ef191513324351E985d46": 8643.67,
        "0x1d8FA86b705946bDF9DDF7f51662499b6a18829e": 8642.86,
        "0x1E63737Ed8CA235c2dA32FFE6267eaDa739CC1f0": 8641.28,
        "0xc9882b80509c93286D3307504cf9002FFE855385": 8635.7,
        "0x3dD9D9787A998C3D4814ff1044A55A8D5DE0c675": 8630.16,
        "0x04d522D17dA4225F7FE998F403B1AE00De3b6D90": 8606.41,
        "0x304856144A8CC390cd59c76F7Df2dcD8174bA549": 8598.28,
        "0xb08f1c09a71Acf744F22f15E7FBEB58047846012": 8590.64,
        "0x8048718C8ae5d4B7f5E07d310558Cce09639C1BC": 8568,
        "0xECa5e3CE0774372e71cE9b3675CB07c6677C2d52": 8553.77,
        "0x3B63BbF52aa94016B61eE8d6809253F915d61411": 8526.97,
        "0x1Ed2511753f6b844A18EBe196311e872721cfD06": 8525.98,
        "0xE18A72a310Bb39E61012EFD2b2F4062Eb36d9b55": 8506.72,
        "0xbF49B454818783D12Bf4f3375ff17C59015e66Cb": 8505.86,
        "0x8ec971994ec6033d034FEd168e6d54d16f3B8d91": 8487.49,
        "0xac844ADA82F3d0241533d827ebF84deb89617792": 8476.74,
        "0x1E67420d784D1dc8a09259CceA021Ba945d10518": 8462.12,
        "0xb26b2A6Dd5efb0645252357BA40C308553993582": 9807.099694912496,
        "0xB83F754Eb815E2100F4Ba99Aa61c299152b07145": 8432.77,
        "0x0A63e86eAb72f5712eeE7Eb86A4080416E79A559": 8400.77,
        "0x91009c5De1Ce031e405601739a084451CAE98E4C": 8388.25,
        "0x118fb5B8dd5D797d2957506b7d31d6812EaEF99B": 8373.61,
        "0x0e7dc0a10E797caeb77B51689F4D861d526C5D75": 8369.33,
        "0x0ABB0bdeC62f3c2811BE39773C73D14556A1Ac85": 8366.4,
        "0x5E07eD10Cbe07A34b7305F1bfDE72452B5F49c59": 8362.92,
        "0x11c17e0D634eE2eca8A2cb7F2D2B4d029f34380F": 8362.18,
        "0x5216834e6ECc7D07c99fBdf62c8E9F2999812785": 8360.25,
        "0x6e22FBe7b697F7c7A6424Ff0e0b0fd9F695c569e": 8357.91,
        "0xE0cbE80A4dc4324e6c01840e2371198E0A6B8a1b": 8347.24,
        "0x2AF6480232820f58092C33bA3Bb8627504F78A2D": 8344.48,
        "0x611B0C1ed942b833C786c53883A4Aa37a25602A6": 8329.24,
        "0x27dC3661794B60913808Ef169F25C591B490e2aa": 8329.24,
        "0xD4d00a14D2d3181DBEBEAF062933D150e9bAFB27": 8329.24,
        "0x8Bd5b1BaC83EEa9f64fB31C9b7b24F4DF1ceB84D": 8324.14,
        "0xe90C942791Aa02DB52Ec70b3F643dFf366a769e7": 8290.19,
        "0x0C9412416A1F73137502Fc290C068246D68baf7D": 8271.05,
        "0xe0647674B89BF40247cc6D7109F3C256949EbC64": 8262.85,
        "0x458fDDA54c4FC66fED71C8B9bc5E9bF7f3b948Fb": 8255.67,
        "0x1A48f060f1ACdDf096D63b7A262F9fB10179d29f": 8243.46,
        "0xFc5a5442b62D0711E1EC2196FaE61E94002cE042": 8227.9,
        "0x2F9677016cB1e92e8F8a999c4541650C80C8637A": 8217.65,
        "0xe5Fae1A033AD8cb1355E8F19811380AfD15B8bBa": 8214,
        "0x6FB2775c1424B5B10bD810bE11f68274264a7E48": 8200.05,
        "0x30949871f917150ad8fdd412cE79C44a017d41a9": 8196.24,
        "0xB680f628C56C8Fa368Dacbb0C27beEf8C98355b9": 8192.18,
        "0xEA059c24c010964bE2E2fE36C1202ad5607550F2": 8182.66,
        "0x9d0fb57f1c308694374c87Bb5d61992b83A0bc7c": 8170.01,
        "0x09EB61b29EbcB8A1d1aFD53a93a84Fe9dE5D45f8": 8160.82,
        "0xd5447Ed156f47fe0fcE2F7cFc15057db68eA90f5": 8159.74,
        "0x03452486f10344Aeb8bc1AB7457E5a9bE613BD56": 8152.53,
        "0x2d7B51D247DAA80067219c67294e00883248D609": 8138.05,
        "0xd5b2DaF2285d0FBf2F1c2A20E2866ccf9617E83B": 8134.52,
        "0xE819D07D9716c2b5351efa1000959edB5ab087F4": 8111.97,
        "0xada8fd60eE9dF769D00A389271BE8AC0570356b4": 8095.95,
        "0xc99783596103c9BEE59CC2c260548Fb848916C4B": 8094.21,
        "0x29DFA3B040A65ee3fC0DA515343c18cdD49c635f": 8070.5,
        "0x302757fe1990e6558e03d05036bb88C3129a22c8": 8066.5,
        "0x606d2C436A07be40C276a6176bb1376C34e49Ee9": 8061.47,
        "0x9043A9757aE62dE77C0065f0C039760c1AB92B8E": 8043.14,
        "0x0dE742E021461DDEF4DCd3969F335d3c79cd310C": 8040.11,
        "0xd89a04b5352E7449391043E12D42E3446fa21Bb8": 8012.5,
        "0x57696a563B66dFA0c180747217d0EdCF17A9cD51": 8001.89,
        "0x5B1c8CD6e98d8BCa397fD09b0DcC9933d712AD13": 7992.44,
        "0x270BdaD72001Fdb72BB8FA6C47412caFC3a1e119": 7991.04,
        "0xBb18ed77983c6ca915f6F0fe39963e185BF1064f": 7971.55,
        "0xFcBB477ec276476B6029Ed0467F28F5ac1712884": 7964.23,
        "0x3c698d1E054A921dcf46Bc213CA407E39AE4Db8d": 8212.003925988709,
        "0x9e5A57470A2a136a3d4De39e1996E05944C4b1fb": 7937.73,
        "0x8D49476968d02afcDd31E5F26d3862a3FC6b8c7f": 7915.73,
        "0xD3104Bb880d7A5b99E57EfB298CeC85df850351F": 7887.63,
        "0x6D9D9E0D23F6320901ec153B14eB8EdC30510E64": 7881.64,
        "0x4aeC0A40226f257d8a4Bd831A27ed684E819CFAF": 7880.68,
        "0x5160106262dB59c7274bfe1A550C9EC63744d6ea": 7875.49,
        "0xd0A16c9339d364eCb7a58eeC990144A66ef657ef": 7871.87,
        "0x56F3E748ACF7F2c219D7b8f65be8d5C233fC114A": 7868.23,
        "0x4797A94741B2512c3236D61ca0195638C44dEB4c": 7861.44,
        "0xEaE6d87F7040069645ccA8cd311EC1673aF46d9F": 7854.84,
        "0x06414ce57c48572b1a0A488eDb6b89F9dbe9bf2b": 7853.29,
        "0xa87ba34353f8B683B9ecE80c03b2EbB8F5648ce0": 7851.97,
        "0xC6376540cF443d22CC3c697526BeE1F81401e61C": 7846.3,
        "0x6360137007804Ea35046D7f41822d93AF0713540": 7842.04,
        "0xC55dd09E2703F02805AB190116c0BD0B431e4ee5": 7840.71,
        "0xa44813F75Edbd296f6070C05a5e1435f4dce32Aa": 7928.886362578402,
        "0xAB12253171A0d73df64B115cD43Fe0A32Feb9dAA": 7832.93,
        "0x61e8096130F668D7cC85a27D4bd933275c7c163A": 7829.4,
        "0xAD667fD6d41F1CD0C0731eb0768EBB5f7DE52628": 34773.68468733756,
        "0x14FEc220041977029187CfE531BD037b7cbEceA7": 7824.35,
        "0x41bD6Ec1888e041B071Bff8F64b03e00497dFC0a": 7809.3,
        "0x1d5742EA25c753549fE42aDf8870f080D793B223": 7805.79,
        "0x5acEb63d52D0d7081A72F254401893FFcf81381A": 7797.47,
        "0xDFFD8BBf8dcAF236C4e009Ff6013Bfc98407B6C0": 7785.88,
        "0x7A1AA1700f095aC4f789B7770739F7C2A29d16Ab": 7780.34,
        "0x74fd09Eb3D5342D9aBFccbD5C144E3B0FACA5A50": 7779.9,
        "0x1Adf992D79b9e86f9EBEd219DD1cCAC6121C8bF6": 7772.68,
        "0xAaea49feF8b3E4a8Be867534Fc34D8D47faB6D45": 7771.36,
        "0x4f40163eF6DEa71a15943d1fC0558AA13Af665d8": 7769.44,
        "0xc84f4cBC3bf13f9C14dd5B62F22F5fF281C1dF2c": 7767.02,
        "0x5ee24959419Db306FCf7f2979A3391dC81781c07": 7763.68,
        "0x303F2d38AB911296DEcA9dC19968a854d9cBCAdC": 7761.96,
        "0xB5D26158102181dc4ceee75f260A60Debd752E45": 7759.68,
        "0x55584f857B2Fb4f64c0934D75760d2B3616864F6": 7759.68,
        "0xD3193e0A93D21281b90dCE8Ab7b78BB898222e03": 7752.96,
        "0x2D8EA9BCf57A8456085947AB4752f3f9104FC7DB": 7749.61,
        "0x20aEDcC952Ccdb6d5F786B1977b964Ab3898c721": 7731.8,
        "0x6A42c1F4dd8d9FCF3bD7Bbcda396d12dDA35ee9b": 7715.85,
        "0xbf7A341560FC77e6eF57C8f7A44219516f2369C2": 7711.87,
        "0xAf43411971CA3640227A7b4eD06F61D0bb60a928": 7708.29,
        "0xD18C96b6Cd70987189b95e02B27d98e681BBA100": 7690.99,
        "0xbd49fDc83452c1f3b3841Efa1b9Fe2E3F3d1C71d": 7688.65,
        "0x3cbe22266f6e567926AFd60F50813CCE8FC38136": 7675.85,
        "0x037B49e51dEc0ff9F07d259fFBD2f63c3B6Aa430": 7671.38,
        "0xD2fcbD1553BDD6F0af9E980d35b1A249B2b0188f": 62657.095136496464,
        "0x1fEC6F448Eb3ff479Ea9682F7eFf21A69762318f": 7657.91,
        "0x576F1E53afe5e99b2257258C7E3248d3a1822548": 7641.29,
        "0x7f7a8754ff6a5debb5eD7AEF4aA8046EA401adCF": 7640.22,
        "0x282C04Fb2f2A9a75dD40001Be0DB6AfE4BE464c7": 7629.27,
        "0x7929dAcCf4f087fE78E8f7A6907981F296D44aAA": 7621.14,
        "0x718e5b4F5B007bcEB7AD6Ce8C2629ceA767FC4EC": 7617.44,
        "0x054E3D68a4fE9B1E370c5679467f3C3294Aadf60": 7608.75,
        "0x78Ef2755664d67d8c9cA3492C78e9441BbBa29f6": 7585.59,
        "0x0848ECD64D7BAF6DB9052cee9ae47E887bA45fdF": 7578.89,
        "0xe5160978934506e1C2D6c4B853100a07059b0d8A": 7575.94,
        "0x6E98386f1951e6f997691c4A3bFa27126a7F9041": 7573.27,
        "0xED5847639328EDd38E7CE934442FF4eE8e714f7C": 7571.26,
        "0x41d363533ce5Ba3697311465Ef6D763723E23bEc": 7551.2,
        "0xA2e4694FA18429E593c1CDF7187571dd239d1959": 7548.19,
        "0x70c4555d1bb9ACCA1EAfc80F90C9152fc4D7F2b2": 7543.72,
        "0xf2Bc825FB466136d00571B496E6EB1a601679919": 7530.07,
        "0x8FBbd23f05F8c49cB9231bFae3e62c029CfDa13A": 7527.13,
        "0x5F2Bdf26F6528cE05AAC77D7fa52bac7A836eF66": 7525.63,
        "0xA41b4a0e34ABcB598CF4Ac3388910fb5fe1Fa2dC": 7523.78,
        "0xC8Bf09987727D53DEffaf02B2BB1b223Ca014bf6": 245606.37,
        "0x4C014Cdc43CfF32f58224D7177A7E63b779DEa97": 7498.85,
        "0xBc49056F8BBb49d0B16E33520D65185d561BBcb1": 7489.64,
        "0x1743Ef7031152642d090497d127a786bd14f3A1b": 7484.56,
        "0x9fe3E03881b06c519c2D9f486c80FBf4b4A71ebb": 7471.66,
        "0x89D4906a2e0614368B83D5f1c3168A45ef049C2f": 7469.99,
        "0x77DdfE8AD051942BCa941E97bfAB5B2F1052bc3b": 7469.08,
        "0x0c393ac25E01cF32d48f175d0F9FA3F4092Fba7B": 7467.95,
        "0xf94dD2a308Bc696C9535310a6A1A3bd9DAA5b6D5": 7460.68,
        "0xA2A9bE465b48367eA68ca5e657C21d7d35Fbb9dF": 7456.59,
        "0x0711de882846C873b7125FacD54631358AD1699F": 7454.68,
        "0xBB41EE0011081BbE503B08487caAF58a0F5FA728": 7445.58,
        "0xcBcde374270c129895471121aa3A02DDDe09908e": 7444.59,
        "0x4d80D71B41b31F5FDD30dFa8A3c9d52Eb8485a41": 7432.47,
        "0x623607Bdf98e37163f93171C0b0D359880d1E1D0": 7428.18,
        "0x7A98f76BD8d89BA6760F8181F1D49C29e6862160": 7407.39,
        "0xB4c8127fc201e24e02c33cdd0b96cAcB8274F15F": 7403.1,
        "0x9A7AA84f86e9fFB1f587bfC9D0Cf14eFE906Ed1a": 7392.18,
        "0x645C22593c232Ae78a7eCbaC93b38cbaC535ef12": 7377.34,
        "0xf5a4eCEBc24397Ba4a30124Af8E84226f09088Ba": 7370.58,
        "0x3223B8eb71110dD73F83549699df6d1ec16f311F": 7367.73,
        "0xcd4e3408468aB7222134599Fd1aA8f44ac84080c": 7366.71,
        "0x874f1BcFf7BECb45C95f5582a7c5EC936f81684B": 7365.83,
        "0x66440625aDCb093Bd8234d4AdF56443875fA9CC5": 7356.63,
        "0x44Ce52A3F1c1027C87a8E98a672bD21Bb1dd5Df6": 7356.13,
        "0x4B8Cbb81B309385F40910F52140646aB864bD641": 7354.41,
        "0x7745E73dd09B2B3F2aC7be363f1d234F247d65a8": 7350.49,
        "0x348E3dA94845eb1653dDBCE9B2A742451f2f76bA": 7340.82,
        "0xb1a2f91Ad6ef4769327407B2d8Cbeb875cA174ED": 7338.64,
        "0xd116522133F8119297e27030825b7F861a5988D6": 7337.85,
        "0x5cEB3790095A0c8FE9e81ABc90c4A4D02B11381C": 7332.81,
        "0x39823b466a9031984baE5b1fCf1394145be38b40": 7321.43,
        "0x24ED7409Cb9F1ADbE5B83C86a237049DA6ECA675": 7320.42,
        "0x87d43C6619cc9B9bf61727479607CC8187ab49eA": 7319.41,
        "0xC6CE31DaFf9175a30FCEf932180b0A783cEAdD06": 7317.57,
        "0xD53bd0C14C9476C56CaDdaF3c09a0C9Df006C1B2": 7315.49,
        "0xdACFb507A99eFCa5D685f72c14e8579c5B44e44c": 7297.88,
        "0xA60AAdf62907bF06Dd714781d44Bbd4C2d783259": 7272.5,
        "0x2434D2b66a1917063994aebf4d4162B66960aaBB": 8204.394493023472,
        "0x3b1b211B3FCe0D1EE9f5e1aFeecadeB98378d0b0": 7263.1,
        "0x26e305E63354ECaFDCaDea1209246ff10820436E": 7260.64,
        "0x9168cC867D5B034302fddddbdddB75e29b2035f2": 7227.75,
        "0x647EAf826c6b7171c4cA1efb59C624AAf2553CE1": 7209.02,
        "0xc93C53Bb35d8Af26fA27c6eFF819969E25E9daC9": 7205.05,
        "0x282A0365909bb6708C440fefC5025e28e002e979": 7201.05,
        "0x9DE24f8639e57169d50eCD4DC948Fa24e0b3eEE5": 7199.05,
        "0x0176770c5B81ed33b97A039495e4e80338a951D0": 7185.52,
        "0x20285e3a9a1a3743f9FF5379fc9CEcD80390b317": 7162.23,
        "0x10278969BC205750015aAAC91801e27485301AF8": 7160.61,
        "0x6F09E3fD9CAF2A8B3c7e9fccD2423b17b9d8E383": 7151.13,
        "0xf3BF27fFE8DD7bBC05c57601975b510144B889e3": 27007.962133443893,
        "0x4F0De440a4039Be1F2aCC1414b35a2dD7Dda0845": 7135.04,
        "0xD3B026B45C4b5f808Bed270ca4F349e75F274c75": 7132.03,
        "0x00C3EEDbF73e455165D8DC65F3E0C3091CCa42f9": 7127.15,
        "0x1B45335b25c4155760602Eb083F5cE4083477B0b": 7123.53,
        "0xbF93F91825cEb291ccD9340e705fC525Cba1F746": 7112.5,
        "0xa519f9568e45BCbb2a19a325cB222ccDF4b0a739": 7111.1,
        "0xBE26152Faf2739f92FD013404A9dA921247D2A67": 10816.975321809654,
        "0xe0353Ea4F1d2F6D261569972E2719F1D64bDe53B": 7086.67,
        "0x1c29801b688e3A4625e3C215ac6bA3085Ec05843": 7085.32,
        "0x72207D37d346EAc4257114d35732c551D6A9C1eB": 7081.38,
        "0xF1578f87c0343051C07156533eA263320212bc9d": 7071.98,
        "0xdea40F4f022Ab2f5b66a3Db08701d6123dBEA20D": 7069.46,
        "0xaFAf97451779a609ECe1fdADE21E0F30238e5cf4": 7067.99,
        "0x0967399dA161d4f9F5d44b740Ebf1C74a6C5Ee39": 7064.93,
        "0x186b12Ceaf08FDE22E32647fcc800e45876F5Bd0": 7060.39,
        "0x5E340b4907365814B789eDD30E150601879C1104": 7055.97,
        "0x4F2d98E454D345f18ca7a57D0eEaaD33653766aa": 7053.85,
        "0x970B71Ba75dE9CD8944Eb77fB81BBd3476387F3e": 7053.03,
        "0xdCcecA99288EE57F9711F3BFF87017dB5E1F40f8": 7042.84,
        "0xA57C357E5Db460683204401ea8Af1Fe1c79b6BE7": 7037.73,
        "0x0f64d1Da9281d00BaCfb45Ea106C5E9373376A48": 7012.41,
        "0xe66498c07A5247a2BEbEbC93880dffe89C19cB20": 7011.58,
        "0x9E7638bF4eF1FFc05C653399AB418c8ce6bfE153": 7010.12,
        "0xded9BfAbF62839d96a5F8ceA18B43EDE833258C1": 6999.86,
        "0xBaD644f7FECA96d642aaFc17290e592cECa50c29": 6987.85,
        "0x1DcCb7E86CB6BB92b326DaB5384655B8190AED7b": 6985.53,
        "0x3C5C8535eBE4B544A3a22a2Ff9b7b2b2403e8d83": 6962.66,
        "0x7c7B3E9453610563Ae65c0859988b4aeBD9FB14F": 6929.71,
        "0xDB65884AA021704b3f3093dA2f69A81C1C3cB902": 6977.414193002957,
        "0x0f81b4382D9ED718e2860361730977a7e23CEf4a": 6915.8,
        "0x6E11cbeE1f6F417043818495c4cec5B03BcF19cB": 7271.011623192847,
        "0xC9d026537a257CA48319b5F86d036FaedE2B4d73": 6903.66,
        "0x8f5e97E1E3d47A2f223a67e06de21F067B7779Db": 6896.45,
        "0x3bE09D1462F86c9a9cC7301cd622F87ac867BAf1": 6893.07,
        "0x80B9943Ed33531ddA35431bbE46c13D497870A9C": 6879.06,
        "0x784206fe36e82A772Fde865d0bFabBf0ED205D34": 6876.46,
        "0xd210ae3Ea4bB169163F4e9876109A2C204Ad3a87": 6868.31,
        "0x07145F1a877827214Cc871b1C4bd71A5F8F98d07": 6853.02,
        "0xE3ae678e2747b1dc11A6C60b5d8e7fd94417EB8b": 6851.74,
        "0xbd48146e6786326ab3f8aBFC46d892db69EB11E9": 6851.05,
        "0xEc3878066F14315E5D1771a9CA07D887d6EA8Fd9": 6850.31,
        "0x548966F3129fa459C03Da021bB9768B54a2E4b60": 6845.1,
        "0xa42Cc5940471F14701EC1752ad69fac662626332": 6842.83,
        "0x5d725c14Cf9ee6d24A312350B201e63d10F90D57": 6839.22,
        "0x4ea0c6de1b4504952f40AB6268dce5696D3c3652": 6837.19,
        "0xBCE5d3f105754F6D4b822Df63c5DC6ec06D2CCB6": 6836.2,
        "0x718184095C74e154f7416F79c0D031E18f18D319": 6830.02,
        "0xC56e0614043698B61AA99c92Ec4f540C93073861": 6819.03,
        "0x7Bba80E55FeD1812974Ea0dB50E58D3f82348c1b": 6818.89,
        "0x657016D48b9954060c9673C6B9267Bed9a1efc61": 6801.11,
        "0xE1B09030aEfE8eAD4D430e6d74F3B1fF925FED84": 35181.16029794071,
        "0x76B44b064996C624B85d191897b9Fb292cd53683": 6785.17,
        "0x6CD1B82490Eb7aA18beC4305C6c2E691194C6898": 6783.8,
        "0x7572f7C345708da47686F24de05fd2b4d7868Ac3": 6760.48,
        "0x5E30BC0733F13321d5C7d74A315160fe6f027ADc": 6735.1,
        "0x33ccC38ef74660796d0428DeAC14438eB2ca6c69": 6732,
        "0xF2527Db33E668851Ea037ED029837f610D69605A": 6718.03,
        "0xa0Eb44b173AF64f2FdB47C7d76FF3A33e04103b6": 6713.27,
        "0xeAD3f1E420D6C29bF5A0e0E240441A4fE4B85193": 6707.73,
        "0x7a108830F410AA0750599D7E6c0ae34ef154A4B4": 6707.2,
        "0xe3674D0D1A5E2e593fDD8278D05305D02EBFD339": 6694.18,
        "0x9aDb1EAA6Ab01156189849c7Aa056f1a058A51C5": 6688.67,
        "0x99DeE42Daa80dB4BFBa4C66B9303804B1643e932": 6680.59,
        "0x4Fe0BC2A614F3dF511B7A11827AeD71D53e84a1B": 6680.41,
        "0x877DbFffAD2885c23AeBb8A070d3a88A543e0956": 6676.89,
        "0x1EB367744472046E321014e7A0Aca6D565014164": 6674.44,
        "0xefDd1eD7E2d1E3515270Ea386f4a2a63C8754Ee9": 6671.76,
        "0xC083201Cb5052b3f6eF427B1A6a77994B0e83D10": 6669.38,
        "0xC40ebdC95E9fAe4AdA1a2c5093d0599AfE0256bD": 6662.66,
        "0xBF881aa7491A093448D3E60F6B88DCB8678B90DB": 6660.62,
        "0x779C7A7E7AF5C14c3513Db5DF8C713Fab36119FA": 6660.53,
        "0x421B41F043d64d15Ce4E214a6f09cc909a8fB862": 6653.09,
        "0x63307f582C87f9f0B860560dc45E457725BE4Fc6": 6651.99,
        "0x9726d0e8Bd180A2136110EeD2Eb56fFDE8C98C7D": 6649.87,
        "0x90D0c1B7F6d7B174F1caF73Eea093EB0382bF0F4": 6645.82,
        "0x5f6940410a82197112Cf5F5863243Ff9c2f9FEca": 6633.16,
        "0x23Beb8439221f6Bf88E215620540cd78dCCe49D5": 6625.95,
        "0xFD70D7C0Be7c85c37Dc2eD7957c599457789C000": 6686.826117721956,
        "0x5ca642d0138f8fa36f4ec6311190825392246AdA": 6613.25,
        "0x84740d1658462441250885423588b6Fd12314747": 6608.98,
        "0x93BF27a3512F28a4ce66ebd0bc0fC8DFD0602448": 6593.21,
        "0xdBBD9B1e048BC1d1cabbd32D0423A204Cc59Ae49": 6592.56,
        "0x41b3Ed5001AB2CF688a05f50a562Cc8c8DEaE408": 6590.51,
        "0x9682304D5c68F805dc93A1d41FCDA0b9FbEA5012": 6589.12,
        "0x3D78aCE36ab76EAe6dBFDa33e2835873BcCC095D": 6588.7,
        "0x5c9147D5B6e472Adbf5C1B9099C95676D7fc9007": 6588.21,
        "0xbB0DE2E71C615Ce9e0754bfc4159840b4257De76": 6586.63,
        "0x215A7Ae6C22e5eD1c7A28620ab91934C7bbcA928": 6585.19,
        "0x86e9ec11ef3c43FF5110C75176883BC6FB094F32": 6584.8,
        "0xeBbB5FB70b2D1f9122ec8e5ed2f8172090a2FdF9": 6584.35,
        "0x9318Fb3928A37a3f5c05215a3c68Cde1045DF4D0": 6570.92,
        "0x43Ea4aF93DB9014141D1B4019d9b17D3941aF875": 6559.61,
        "0x62eee9f7E352528830091f98E3Dd084c7Cd8833B": 6556.19,
        "0x5bFaad4A04Ab0Fab6d206c9ea1144da886d31f9a": 6556.19,
        "0x39c4274cED5681802b2AD9fC83ec6b9d53f8A637": 6556.19,
        "0x33F123553F15463b1D90d1936Dea24cf167cd556": 6556.19,
        "0xC0aacF585C11507F7DB33632051bDA9081909aaA": 6556.19,
        "0xE716Bc88a611A481750663D7E4fcFE60C2F6Fe6F": 6556.19,
        "0x27D83F1308665E2Be54FaeBc11A53457f85fa016": 6556.19,
        "0x37511741558dcDAFAd302a726A2a0C7cC154e86B": 6556.19,
        "0x8F88804Ab678bA3bEF76840Cef8AD4Bc5C68b5aB": 6556.19,
        "0x14f02A817C69bed67d6eBf05f0440107FB3F0568": 6556.19,
        "0xA82618668A71Bb492d1aaf8948dE95D73eb8a243": 6542.98,
        "0x9eC8c8d2Ab84AD32320929EA69a32B79D5A761fB": 6534.83,
        "0x94969c81e797CE7813A63336e1989FBc9eDa799f": 6534.59,
        "0xc01a1cd505E6aFCD3ceD2eE1bac67890497f6654": 6526.86,
        "0x2Dc2285E1Cc1cC72c3487F5bE7A6CBcA048DCd84": 6520.31,
        "0xB224e28534e07c04Eb43C7fe20a1f881A6061755": 6516.78,
        "0xa12C10273B6272fA908fbEF440C1C478D75DB3A8": 6507.71,
        "0x99389A064D89778Ee2FA71a2D570791F61CF8555": 6504.3,
        "0x0a7AEe10D18cb298f818E8869e6B1bD5C840Bd66": 6501.02,
        "0x908D4F3440e8c7E389e137Aaf43b777D24edebed": 6499.45,
        "0xe1Faa0Ae17d85DDA0415bdD05D9F8caa32cC55A5": 6498.43,
        "0x1Be051C58B2319994886c92B4F71Fa07bB222c65": 6493.43,
        "0xc82335BBdc978cE2e1f1c6c4F9e5BB2270BB2Af1": 6493.1,
        "0x1E592bDA6914E083d56D50348913E180fa4972a3": 6473.78,
        "0xa5070993D4e1cc342bb570D3CE43937b045109b9": 6464.1,
        "0x6868E1606575e499D4C3c8181c1D2939B4363CBE": 6460.83,
        "0x5d4A8a9AcFcff707AF1d3e7F29be2E4d2d7d2f8b": 6458.12,
        "0x2e6CF30FD7e6f671c34cF351D2AB93322468b30A": 6446.14,
        "0x06820866A2411512c0D6B95d1d1B062b71614a46": 6445.89,
        "0x4E1c09940D8160CAb688A7d0a0B975499d40169C": 6442.41,
        "0x27182e18bDA900300E0c9d634856e0a2ce62adE3": 6433.5,
        "0x79ac315a1E948D12889117790005Fc79DAb22B9f": 6429.06,
        "0xe0A86AFB73c0922A50D4A985A25507EcDA8a9B51": 6427.21,
        "0xf5AfC179A45e902e4D24b2347434660baE08db01": 6425.19,
        "0x12BeDff5350f138d9F2975018729301857CdF2E6": 6425.19,
        "0xcB8E7519a1436Ec9bD93D80b5403f9F606F956DB": 6422.07,
        "0x7a4998b15CcB8018f96FAD80526d929D0F83d7dE": 6415.8,
        "0x8c8365e978e8870f9c29697F9BecB1D64F3cB61B": 6414.18,
        "0x9BE43Ec7472E708858D4b8711F54B238bf0ac789": 6412.96,
        "0x7c3a60112c4f5c461716F1167d8d03fc9183c61a": 6403.72,
        "0x940947116d8DDce1E35cf945c8B19c87A0528DD2": 6403,
        "0xBD2881Dd8F7B60b5b2f488694cA4f24E689f54bd": 6400.34,
        "0x75AC7aD3d98D14A6054F0818D0792641f8aFF853": 6388.21,
        "0xA970fa131985bf95397a4aD320f7a0aA91676aac": 6387.01,
        "0x619981bE255D4c4E80074C6F937a4C8daa2514aa": 6372.33,
        "0xeE29E45d71f44B74E000FF32bD0b749ccDE6A33e": 6370.68,
        "0xF2AFd564E04cbf803850682CD21150e54fD8ed61": 6369.79,
        "0xdB615A470A52BE50A2A61a3c34C39D002B8B182C": 6351.41,
        "0xCCEA52eE36e33B50F9DE467Df0DCd768897F3Da3": 6339.73,
        "0xEc4D8b4774648C2645e64BD35B24C1d2864C7D86": 6334.95,
        "0xA4A62f7127C644AAEf733029E0D052E411fdafb4": 6334.17,
        "0x32084EFeC481D37339Ce2A122233e372d2286E70": 6331.12,
        "0x2EBa0a5d03b07af80e4E4ACe3bBFFE3A7d956bcB": 244415.25,
        "0x89c53F6368EfbEa8Ab3e1A91E8453a19Ba6e82f1": 6319.78,
        "0xc45D05CDc809d20c7B14959E8cd4a1199E3e966F": 6303.04,
        "0xc40F6f6ade14DE9AA40e5a868aA8db4ae2aB5Be4": 6301.92,
        "0x3A835135391E51D3605863AC5dAc4e274FA7bb98": 358272.9374060893,
        "0xBB95650584A45530Ee1979f0cAe45DF81262cd32": 6299.13,
        "0x4dCEa47Ec4b26079cB4F9A0e0f400E1Aa6F199a9": 6296.11,
        "0x0f2496fd9C23246d146b70442C3FB589dc4dBB33": 6291.79,
        "0x7aAC540B0b09B4C7876300fb61978747980A23a1": 6287.05,
        "0x176a18C56824D92f6ff3A30A7756ADc6ac4028F1": 6284.11,
        "0x57dB3D697A249Acc4F7F95d391cFE82F7a2C33ad": 6281.59,
        "0xBc80fb9E4d0001a59d16DC9B88438a8b1AED8fb6": 6278.44,
        "0xED8E924735F590572361b52657ABd9A3260F35a0": 6273.26,
        "0xF990ce93C674E610939789f4Ec24A9c08aD8c042": 6263.11,
        "0xc600d5ec6B823ce2D8A8e1EaF8eAbc3789a00514": 6254.09,
        "0x29aFdF8B7d3A14AE2FdB1d89Ec2b2fd4242B5FA0": 6248.53,
        "0x765fD440bAcBd1A34bA08F0ffb823fce62F06c2B": 6241.96,
        "0x171096136F67C4d95e941394a757E60e4df88Ad5": 6237.67,
        "0x08b1b6C0AB216C3738a38F4e0ecA797a54Db7F48": 6236.67,
        "0xDB72b0C29745cBDf09fad51C4A644f6175506F50": 6230.92,
        "0x4248a05B5A6B4F13fB3D9e81B6A8510fe0850fD9": 6228.69,
        "0xc5115D9D85256cC93836189D21d23729014B9Afe": 6226.37,
        "0xA50fD1DeDF930C729E48E142E9DdDbD52fac54ED": 6218.79,
        "0x89e1cfCC3bf93De8dA0fb43A1311898067B3A11C": 6216.15,
        "0xEFAF15c50f66D7ceb9a0f387c5B503B6b8cAA58b": 6214.35,
        "0xA3Be17657a9d9098c88BcC291e243314F0C2207A": 6211.47,
        "0xB4F09B40268419f72677990E0c6481B6C8394Fc6": 6210.25,
        "0xF6B3dA7E39eDBc0a25e484D7B4Fd119Ef50EF393": 6207.54,
        "0x5a32fF1e3EC61aBB96D302896c87a3D50EAd37E7": 6204.39,
        "0x7cE45cF915F4e2DF5eb07BC92126A42bb8f48385": 6199.9,
        "0x266a289A65BeD42E84af04C97B9897DacF83F373": 6192.33,
        "0x2a23D0650DB1C536e71AEB63eCd3DAA0b52E66E1": 6186.28,
        "0x3aC29E895BB2cAfbCC26ea4aE1Ba8f5C7F180e18": 6179.28,
        "0xD2B84BEe0499cfe8048Ac20ef7587f766A4c6688": 6178.03,
        "0x0234737d7795F4A458077D1785Fe2012735ebc5E": 6169.66,
        "0xC27D217116748D94c516415C8Db4d10bBbe98aC4": 6165.12,
        "0x8Dc554315146E3b8e994CDad9c9496F9c6578079": 6143.82,
        "0x048B377FBEBcaaD76bEA3Bc0bBfe91AfF81078E1": 6138.71,
        "0xDd6E5983d42767Fdc2F057fB6E927Bc00eeCd072": 6126.33,
        "0x866F458e7FD4A113FD1AE31bAae786aEc42b2c79": 6121.39,
        "0xb144604e3E8Db8dca155dBdE0EDB067B4234DfC7": 6115.61,
        "0x02eF8147E2D0997cCA48d99f01bAD846D16558fa": 6106.68,
        "0xf1Bf0849e7F5eDdc668611E3338b135543121624": 6095.22,
        "0xa61f23023c9937236080840e1e58E0314CC95b58": 6088.67,
        "0x7cB42eD2f260B0f66413402764A9eF2BDDF8b687": 6088.19,
        "0x8cFeE9540FDA895e2323781391B49620E7909D77": 6085.26,
        "0xFDc6660c90C6FB0C7552F8DE237a054c650aa565": 6084.65,
        "0x1Ff91381bc154FAB07007f8fcd7b067E009ABa97": 6071,
        "0xd7454138a46185481F414748f1c37d21B8e328F5": 6056.41,
        "0x582b547593018902eb5335e790557dA2A13228af": 6050.18,
        "0xd5bA11457200153B1CeBb05f94d4E1BEa87c78dA": 6039.9,
        "0x215B67D707cEd250c3803a19348E9C565E42d7A3": 6039.17,
        "0x0C0D2Bb2E3c53e2a60b305fE76d181eef93189D4": 6037.96,
        "0x8a83B1106D69Eb6caE21bC7705B26737fFa744FC": 6031.88,
        "0xC217aE815e2C3a45129A5D4aae5Ee1ebFf7D9b94": 6024.56,
        "0x2c8feE29361313Ca09DD53F9384E3Ce18674B7C4": 6022.59,
        "0x41265765B64C4f6fC18af04eaDF6947EcF2224Ba": 6019.94,
        "0xa55A733608882667db525CEd48B5c869BF6Aa36f": 6013.41,
        "0x2EEc020C28E31CfA66f4DE68801b04784EE0CA76": 5985.97,
        "0x1A21ed0666D791565413b66bBbc25507F618e1D4": 5979.14,
        "0x386Ac7BB2531213B8741e7Da6Df7f5443E722D83": 5978.73,
        "0x63AB3b399588D96D7cDE54AfBAb8d40E326D862B": 5976.02,
        "0xFC33181FBaB11D8C33Cd904F7ee1D4C62685470F": 5975.52,
        "0xb1D47D39c3BB868E5E4Be068b7057D4CAaD0b31C": 5972.67,
        "0x2Df6b37F92bb4fD9dcC573B72F4879d68E72678A": 5968.72,
        "0xa999a35e8C3E9a0b7d81804d47885b96587c1497": 5966.41,
        "0xCD97232540EF8655A9a67010609E12315c2c3eaD": 5959.94,
        "0x035C184c04f8b2481C1949aD508F35152AE60B40": 5943.95,
        "0xaF40e5cDA459930474356070FE9BeEBDE0aaE92D": 5942.99,
        "0xC88359b5DE3f75626db520B8D74d08EDD90Ea4e3": 5934.7,
        "0x05Dbd88978B56FeC8d86C8daA9761A975778166f": 5931.59,
        "0xAc0b1209Bdbaa2AD5F725b74f71061dBCe37AE36": 5920.07,
        "0xD0C02300F2AddC62567C9F7b3d852834b6D2e3d4": 5915.85,
        "0x4aAd47CF429dc976079648F739e094Aa21350B56": 5898.1,
        "0xE03AD85536e64Bdc66F692495DD52BD754E59166": 5884.5,
        "0x5A9e792143bf2708b4765C144451dCa54f559a19": 5874.93,
        "0x40Ac62d5AA80cEddAB0de954C29bD62C75D514D2": 5861.02,
        "0x9548DA67337fbF6A2a8b030d7F15f2A92347f3E7": 5859.44,
        "0x05076E413D57003EC9E5D98d2710E6f0B5073d43": 5855.19,
        "0xCE2fe699a823Cd435519494DF39A9bDbcAA2fC8c": 5854.08,
        "0x3A8F106E02D9F352Ae9c307Bb445B03b2D18fDdC": 5847.82,
        "0x2C99d50Eb4DAA1D26b5bA0b1dAaB58cBFc0AC3E6": 5840.67,
        "0xc0FB21785eed5263c8ce1Bf0304212EAE23d5d81": 5829.08,
        "0x056F6bBE01F206Ed36Bcc5ADB2e6c62fB2c51Fe8": 5823.82,
        "0x39df7fc25c8bD67c80D6DF4DADe41c7fb174b7F3": 5821.64,
        "0xa146b54dc5AE5B1f1dE16472769bE94cEa3150Bf": 5815.98,
        "0xdD3FD2cdb67F18e9bD85E63c06F63DAA29ef795a": 5815.7,
        "0x171025Ca187D600b34Fe42b882CC46Bfcc1B274C": 5815.37,
        "0xcBadA322aebaD69E7D78a5fC73ADf29021414CFF": 5813.98,
        "0x868b45A159137af4e28dD42ad4bdABB32Eda75cC": 5810.55,
        "0x16Ce1B15ed1278921d7Cae34Bf60a81227CFC295": 5809.17,
        "0x7f5D10722c0217d2071b9fa4264f2C7dB4A2Ba10": 5808.93,
        "0x3b06D40f1a7AD2D936B5F11A161e84DD637945B6": 5807.42,
        "0x03778F799f066BdfA68f59cdFfd45f775358dBD1": 6639.670036028062,
        "0xe0C23eFFDDE4f8115600c177879175E9341eD439": 5795.61,
        "0x718eA792633fFD1A40eB7d40A2dBf0A1f0321183": 5793.63,
        "0x9E2502a8aEDA9143d5EA68cA64644e0b25a1Cbcb": 5789.15,
        "0xF02d4f809Fd6524Ac333ada62344602269320d71": 5787.12,
        "0xd95204Bc63Cb83C90bC457E333fb00A67BEC2A08": 5785.8,
        "0xbD733cED034ff9B3A2CC598a6fcd250c1f348E95": 5784.74,
        "0xcd81917ff5313d02d7Da3d47a9Afcd3f635c36e3": 5783.74,
        "0x12f8BF963ebeF11148842100156843292C83fa1e": 5770.64,
        "0xcf9174787097Ac76a1FC1D4E2fA53340cAfF0207": 5765.24,
        "0x65877BE34c0c3C3A317d97028FD91bd261410026": 5755.53,
        "0x1B72Bac3772050FDCaF468CcE7e20deb3cB02d89": 5754.52,
        "0xC2Fa91EFdE9fd71b3AC5912f7c7A48D4680847ec": 5752.33,
        "0xD99Ef9342f5D7e2E9c4064Fd22bF7246d16CA39C": 5751.81,
        "0xc71E2B0F787D6Be1B4d85c53aBD2CCCE85683500": 5749.48,
        "0x606789E8809A853856F730D27277EE0a9be02aA7": 5740.95,
        "0x3554451983AB0D97d44ce2f83131DD7470f18E62": 5740.45,
        "0x9F02988adB650E55cc5EB5619C383fd223848bb5": 5732.35,
        "0x3c9439e74e3baA7c81C67B01bb9F0210f05e685f": 5729.16,
        "0xFae1Db38f0E45f6f7AD9d42A53835b88a8a2Dd37": 5727.95,
        "0x56FC4Ea490003513aAe7F05FCEd01f811802aB56": 5723.78,
        "0x4F6FFF5CD87EAf8cf09467366fe783E7Ecb1317B": 5722.27,
        "0xBD331cDfCcA1435090536B3978cea93b08B76542": 5717.46,
        "0x87977f65E5295Ddf79A8404e9E51fDaB5c982722": 5712.75,
        "0xd7474d613CAf3C64d50eDD4D3C43ef1468bC3330": 5710.69,
        "0xf486d56ccE70c481b3455aF901fCC4F03FeE8107": 5708.23,
        "0x9e979fa66EE39095A875a87736b30f5f2b23eDD7": 5701.37,
        "0xcA40a8c87967ce1c610919dF68D416F7D38cE302": 5678.2,
        "0x5a61dd9A663a868144660F5fB7Dc8dB68F0500Fb": 5673.93,
        "0x4Ea1FCd4f3F52ea2f6942aA7D1e3695aa63EE63D": 5669.15,
        "0xE70fFFbD4fac17d7d839e9455653893E04D8Cc17": 5663.42,
        "0x3CE66d042B933c6542680A317B97c0655daf146a": 5659.94,
        "0xb5af6B22932a560590B693FfeA7Bf47b2305BC29": 5658.5,
        "0x4bBe0Fd0bDEC55E074C5E6ea9f4f627AFf31E93a": 5657.71,
        "0x731071598a30FBA72B4F7085721c9Cd5D2b3cd51": 5656.78,
        "0xfB089b36fD46FC0e84137674745A2F723e40fE35": 5651.11,
        "0xb5BceCA34861f60e75C4B837cc3F87d8343105E2": 5647.02,
        "0xB6eB19ecD9c0D73aCd5CCEb9E0B0841B5eA11250": 5642.18,
        "0x02608D35121Db289427f6fD4Fa53E93b5caE0BDF": 5639.17,
        "0xD13e3Db8e5799319758b3bDf13D6ab21B83BC324": 5638.19,
        "0x4920a95670B6282951813a94D9066A730D315df3": 5638.14,
        "0xb688dbEb1040583a2B8594d30725a7C776637e8b": 5637.6,
        "0xc30e3369773097428EAfdFB7fE4bBe30b97a8364": 5636.05,
        "0x52eE1B0efD6a1095A23bd220DDEa0217bf3876D0": 5633.24,
        "0x463F0fB489d0FC2Fda2eF9E4A5E0B8f39F92281c": 5633.1,
        "0x6DE6E901Bbefd26a9888798a25E4A49309D04CA9": 5629.07,
        "0xdC79C76c69AAB7cA7052301b3C8c7889A45FbaF9": 5627.78,
        "0x51c444Af0ABEa20714d0137Ee777090bcFa8065f": 5627.7,
        "0x736A6F35dA753e8a1d20a5751A6dFbF0c8c9754f": 5617.5,
        "0x5FEb55ffa2cE4bEA7B093FfD36dc19243bBcd46C": 5614.92,
        "0x518aE9dC06AF3A4d2DD1B75E2367C0D23257B320": 5613.96,
        "0xf94c0F25307581De1Ef1236F345CFf9D7Bdf4CAa": 5611.8,
        "0x0dDe0BBe12af3E2508DB05dc9220AA81fce3C5A9": 5606.07,
        "0x2B1bb22DeefC17c18289221B63466aeE964b07F4": 5604.99,
        "0xEF84E297213A07b155cBA5A147F51aA4fc5fb351": 5601.57,
        "0xf0da2e133a848d3E574e225e004d46Fb4fcDC9ec": 5598.2,
        "0x46c539C72466de9d6E67D757bac5C5De024A698E": 5587.49,
        "0xdb71f093397fEaaD82Ba7d40083A7D935A6D43C8": 5584.73,
        "0x0c9C3Ba64072eb566b0E9A4B6Bb0D7B204d68469": 5573.16,
        "0x58dD03d5c03A9227B622c866b13F1ABE83Eb696D": 12829.777468588483,
        "0x5Cbf4E9F4e121b88907eE44C8f6f1d156b5B63a2": 5565.34,
        "0xe47b3BAB295dA38c39B97b6e0c09395b95aBb81e": 5565.05,
        "0x346aaB59F9078E5467619a32E1450c86eCe02D41": 5558.64,
        "0x8D4D9F71D88eb6cdE2cdc00EBfB09AC8be960566": 5553.47,
        "0x96BC50B9373d8A45Efbb3eE6af3B90E4D31186AD": 5545.68,
        "0xc3526d54f9dE73959Bac1B67668668a3E940f659": 5538.44,
        "0x5E90402eEAa1f3D3CCE7d9CB92474eB65bf6cfcE": 5537.93,
        "0x2477BF2157BDF40ae2fa02fe6A487C3F28b5498D": 5532.59,
        "0xC6FfF74760331477edc05A5c2Ab9212b77ebEA36": 5526.87,
        "0xEAa089Dde4169de25ABcB4d1731801700496A8F6": 5520.07,
        "0x67C3803304a0Cc4827e33F5f7cE5773ab198ea04": 5511.21,
        "0x36829Dc8B53fDA4B7Cd8824117Ec4DE24DB01159": 5510.67,
        "0xA4E56D89Ccf3aA9317Aa2E7559f0FC6Ab3400396": 5510.22,
        "0x9f503E46a679dc1Cb2F27FD95B808408A897D7B8": 5506.66,
        "0x9C5A5Bf1C40b50EAE0c0bdfA044427661AaC2CD0": 5504.45,
        "0x40fB663d409C755160048370098cF8581bAa28d9": 5502.01,
        "0x4A6c76a01D6A626aA614c4bbFA31400eD62348FD": 5485.18,
        "0x788109dF1Edd20ac685505E091e1CB673516F6E6": 5485.1,
        "0xa1Df11E75051A414D42d6315d785Ed787077506c": 5477.96,
        "0x248B007f76E7616791B8Fe278C93096DdcF67F25": 5477.61,
        "0x95196B1A89B57f99feee35dE8771136D63945304": 5476.18,
        "0x65c89f1FB1c5a73bb4e8524db5b93cfAD001BADa": 5475.46,
        "0x9e5efAAecAd1D017964aaA682E5386e1C3b18D88": 150451.628618984,
        "0x23f76EA57931043aA94B6645d6fe0bc852acB8fB": 5474.59,
        "0xA810FFea2709C116EF180d090C142fc5e08586A7": 5473.9,
        "0x80C6312e4189d90747518DB3dA5D1F4981c38969": 5473.44,
        "0xcDc650dBda358b8a16F0c1F6AF87e00B5eBd172B": 5468.25,
        "0x161D9B5d6e3eD8D9c1D36a7Caf971901C60B9222": 5455.25,
        "0x577BE3eD9A71E1c355f519BBDF5f09Ba2018b1Cc": 5454.2,
        "0xadC22218bEb70Dc88E41e6689cab63ccaA8E65C0": 5446.42,
        "0xf8d232B78050314A089740bCDDc3D32E46dcaAfA": 5431.36,
        "0x8DF17996Bed8764d9B9aeaeA4D4087d7cDA6C48b": 5425.66,
        "0xb3a5C0f9a76E952e26032463071c27e921fE0e35": 5419.36,
        "0xcAAA0038F0dF9fA60E4b0AfEaF6CA6d2201293fD": 5409.41,
        "0x1826Cd21D59bC83f1B0d90A0d66BC404A4D296F3": 5404.74,
        "0x78F6f566Eb522e95e94695a9b76A25567cD1849B": 5400.46,
        "0xb61c7F6A4130eEe4AAF044B1b03E1bff105cFE0E": 5400.33,
        "0xF85C821Cd18bEedf9C21355E80c970539014E5eD": 5395.71,
        "0xe97F073Cc89534886dCE9ff8003B28ff8b006D60": 5390.87,
        "0x095aA77c26f47D0Bd2E445C531252c66d7DC3eb7": 5390.67,
        "0x0FC7e42C64858053Dc845D371ce82Bb415EDfB2D": 5389.49,
        "0x00bdef65125C4a30d7916a05c5C8616e65810Adc": 5389.26,
        "0x33D3C029FD119ebb90df20c3427a97074637Bf7c": 5382.94,
        "0xC686Bb52e9B959cC1a41ea30bd7991F35A70702b": 5382.14,
        "0xF569Df3E0CB3Ab6170AF79A1E404fae395F34983": 5378.41,
        "0x9F06D9EA8296B3D6562707ea68D18D53a94415D4": 5374.21,
        "0xc360c9E9fc65d967555FFfc88458902d66156E61": 5372.68,
        "0x40e21f845333d75706E0376f30F425fcE4090068": 5372.24,
        "0xFf74754841446CBF84A46ceC6e2838aD3F45E4C8": 5369.38,
        "0xc0F68e4fF853322eC90efCBBE476831577a2003c": 5367.74,
        "0x3F38E7B80BEc9879EC4636952FE48B6095A5bCeA": 5362.25,
        "0x953D669Da3b31711A8F3bD023fa449D9856b4d5b": 5361.65,
        "0xf914A9a1b13E1D1079FD20C159d0aB8d936d554d": 5359.28,
        "0x71d6d7fc5417F21c83Ba6eE352a858f4B5e70EEd": 5357.96,
        "0x61588e3AB92FD6672407937ddF25C7D1B329F6c6": 5351.49,
        "0x78c51CE7C7A475778aAd918d5CBE6D3Af2c77Ffc": 5350.25,
        "0x6D782d7FcF3D4FB93Bb902E9Eeb0B466b540BCD9": 5347.1,
        "0xdab9600873c2069Ef39D0DC0d5a721187Cf24224": 5343.07,
        "0x5BB53eEBF444976947F505c3e52a7B59952E1D27": 5341.73,
        "0xcD1FaCE1Bc874e936538913A44140b69991b0aC4": 5335.42,
        "0x78dCC0dDF754f95FCdED60721B91F57256263850": 5335.23,
        "0xdf35203Ce6F7f82F578c5C2608415A008039bec8": 5329.09,
        "0xAFc8898c5C447b340Dd696A51Fa6f67b7021908E": 5315.37,
        "0x57a8AaF3be0103a137237b9043841833465411b8": 5314.65,
        "0xF1d4fAe32b8B75A857b58BC28ae37f9aFB648AC6": 5305.36,
        "0xb246C66672d3De12E13FadA123FEe8Bc8807C8ce": 5302.19,
        "0xA647a2304ed93bC27600d5B1aec3a8575B1519e4": 5291.93,
        "0xa663F2acf62A6453b05Fb682dd8F27CF2bFE05b1": 5290.05,
        "0xBD3Efaeea98Cb2aeaD0f7e8908577df47bc12e87": 5274.29,
        "0x6b8F7E62Ed2072883C85d17f52f647a34AB3E197": 5270.34,
        "0x9cB016669C235CCebcD2fbbffA2D8d3a2247b02c": 5268.99,
        "0x55B2511E9A3F1aC8E5946EBb28BECd0f3aDBa4e8": 5266.17,
        "0x6620912AC168458ED84D5D3d6c83E728abf9941F": 5265.95,
        "0xf55a396d5FB3e2033d2E9464E51F9e7B9C30E744": 5265.7,
        "0xE17b347Be07A423e3EB0DEd3C3Db82e138a48F51": 5264.1,
        "0x665D06e9Ad53206D26CC7Df59CF91c00eC42f56a": 5263.04,
        "0x6F8CEb284daf956d03dfC8696CeB41CDd234F175": 5255.67,
        "0xf0e1C2575b1FA8b9AE3693DED2dE89059f4BbBc8": 5254.04,
        "0x5fE25915f9Df4f739663211330D17d5de746836D": 5251.23,
        "0x9Af6269692F391d9DB6d35aE5d7A02Bc8307e7FE": 5245.63,
        "0x642fcF3E9bB82EC3D31a32DbD0C9d92D82264bb4": 5245.16,
        "0x6A814bd8c711a08F3783Be77A5619DDDD790F758": 5242.84,
        "0x7655207a17EB47BdBdbc531B694c49eEF4F03E70": 5235.02,
        "0x4db09171350Be4f317a67223825abeCC65482E32": 5233.58,
        "0x22398Ff702e25E9CeB15E2C88728965e97f597CA": 5228.43,
        "0x29974e146D465638343d74c1e4937f5cb9965b09": 5226.34,
        "0x30df2a1462aa9f03390c0A4Fe26026b23bEb8202": 5226.02,
        "0x0f27b6897A24839171bFc32cB022eBd11E5EC82a": 5218.63,
        "0x50A852203b68861968786fA057b0716860775b3a": 5208.39,
        "0x1b6F921D37953E321472Dd7530C4171a59A10142": 5206.96,
        "0xac9558ce54f84e343AB5DA0FFAa5D0EA7C4E59A3": 5199.53,
        "0xD24AbaF0a01Fbf38C827C80539299da18bAd2818": 5198.81,
        "0xF66589b333903C9d4880FB36c7431d5e4481891B": 5194.3,
        "0xF1d2C14790dA025134d4D78F86ff93123E30836a": 5191.07,
        "0x35077cc901C41Ff7FBf15B5707dD6b9254A2734b": 5186.87,
        "0x77B861dedBB99c8918F274BDC251372619354e8f": 5184.77,
        "0x1a907D3bf2E58C5ff3cB48773c929B8f06FC3fAC": 5180.15,
        "0x8B051a8c0F0069b82395df038B7a4Bf1450e1416": 5178.85,
        "0xfbaA1A6D9E5cB4d4Dc2A3098D715CCDa8e76B679": 5166.52,
        "0x9C338ed170Ed5cBB1696176FfF31b96A1a7846DF": 5166,
        "0x9728BAf9Aa1595fA27d71050EC1dCBA515250aA5": 5162.66,
        "0x00006F6FC962FC8366c945f8FF7a7d3eBb890000": 5162.52,
        "0x545bc42Eb29a478af2dab1B694f972110ffF2715": 5158.27,
        "0xc204D01BD43E7d084dCD60cf1a4BF8a75401FdD1": 5158.01,
        "0x2Ae3935ec312E9c9FdcA433593e2049EA6df4B8A": 5156.78,
        "0xB4Aa97e7F842dE10EbA11014E63f493c191F44e9": 5155.69,
        "0xF4Bb7B8Cf001338E24F305B033A76c5C3629CBe7": 5152.22,
        "0x3c8D7Aa21df3bDA49ce7Bb4d8f4fc5745A74d1a2": 5146,
        "0xC81d73994f14340a95f28dc05c78f02e8854e793": 5144.26,
        "0x76E2d64A8151b0F696FAd094CAd39cAf20769cc4": 5143.53,
        "0xbcacE1cd8A551308ff80142f0588A5bFd167a72d": 5138.15,
        "0x6D8012dff0beFD8EedCFaA675dF687e37386b40a": 5133.06,
        "0x3E7b7f62a2BC66af57b9dAA394aa5ed51BBacd8c": 5128.78,
        "0x90F4c658C3cBF910Cd2Aa480247abAB5777c90d9": 5114.15,
        "0xA428B592888811eBDDeD34161eca2450c6650803": 5110.63,
        "0xD9b78302D8076bB91a39A5Cee50d00A03b1Fb004": 5110.48,
        "0xEFb4C56a6c36cA49d352EA0D4f39785dae7D3f28": 5108.62,
        "0x1A5a7AA7696AF51FE5d1A65c2Ac7bd800f1A4777": 5104.73,
        "0xa8e1C6747D42882c0c26ba9725712965D77488FA": 5104.59,
        "0xB149f353383aB92e74c4cbA3fEB848b04bfB3617": 5103.09,
        "0x96b0E317cA8B2233c41290A97E151969d0007DD0": 5100.65,
        "0x1732951b80C737dBb8F367e83E530623bB612E54": 5100.07,
        "0x61538125cce3cBcbc9b3f45369b24cbCf1C698B2": 5100.05,
        "0x2C9E500ab61700AA14F635fD1db806e1108D2a9E": 5086.75,
        "0x1180c27845c85d995fEE355a7F822bEBf1664642": 5085.64,
        "0xE98346E48C805597FD5BD05B0d9e79B9cC8dfc50": 5075.21,
        "0xB2fdf2152c355782B6734A36450eAf3823De02Eb": 5067.75,
        "0x31D9f33FA7cB15b99d90EC35F7d2Ce97f6769167": 5054.51,
        "0x22B052CbBf01cfE2EC5A8424a7d361f376aEaEb0": 5048.58,
        "0x94db1633DD6eaAB898DdC5Ed205DA8319160b685": 5046.49,
        "0xDB394AF0cE70F43c37436C81b644b8d2366942f2": 5042.55,
        "0x905fdFC6d0D46E0Bb50c2c6b99737240E3e38a2a": 5038.83,
        "0xbDe51cf454F5960315c28Fdb967F8C8d5FE0A9EA": 5021.35,
        "0x27Dd5C265B386DB19935dfb228b70Ab21Db4Dd80": 5019.39,
        "0x9437f0C907Ab11e42A569E2f0A91F33577FC9E20": 5017.82,
        "0x401282043cb416B08c0295F9154F33Cebe5D3C5B": 5015.99,
        "0x79CC4f8704Ee10b3F1089680dd34676A3CE4e53c": 5012.77,
        "0x0b61434b4A918d5213e952d28AF9E0Da9D2C8bA4": 5011.77,
        "0x811929C3C17DD598172F8078A48540Fa23f44b05": 5011.42,
        "0x796bF6165f997c8b2C9E37E018B26eD689827559": 5008.75,
        "0x7907a235d258BFeDdc9518BCd9342e28828a3F1F": 5007.69,
        "0x3864409690052c7BF7A2b5FD26B08FEA1eE8CED5": 4997.48,
        "0xAB4EDBd86ab484019dA2136E884d284398a2f442": 4991.25,
        "0x72e39E368Fa453c992f34ee435D67f6195e4a1A7": 26607.875448116505,
        "0x71CFD9Eb9801f36B46358B79F151E5F8369190B1": 4976.79,
        "0xFAA4ed12dc0aA5427B9A31755bb4F488196015d1": 4975.74,
        "0x1E6E52E0b5dc01f57047D7D880e42ec2Aed128a3": 4974.74,
        "0x9f16dB77a6b9e45378a72d02a7ebE29943aaA77b": 4974.62,
        "0xd4f7661d034e06C3F8E0b0c95193520c1e391C6e": 4973.34,
        "0xe59Ba48dC0D6EBF662c3Ff3c5b2Eb757D76Cfd9C": 4966.52,
        "0xf57b2c5720A4A3c6d8948fDfF62eC77Cd00BB7DF": 4958,
        "0xe9cc16B79E7EA3Cbc8124aFB7b547826Bc3dca28": 4954.52,
        "0xB554B58C1C362dD54de5Ac96775Da316F976fd0D": 4938.32,
        "0xeA14E1D58b20d575F00306f5138Ef3a7742f050a": 4925.65,
        "0x83337Aba444F49977787f4A314bd087e5a0A3ab2": 4920.44,
        "0x3E7b8D12D4De6CB284A7d60Bf92B462D2a6d6A2F": 4913.73,
        "0xE8788a8926dac3d25C591CAa64d5296044c1446D": 4908.29,
        "0x789498eE77215b80d201A814228fA7f248c3be18": 4897.39,
        "0x7e50eC24B9Bb33eB383Dcd5A1FAe3762a99Ba57B": 4896.53,
        "0xE6cC5e3EBB07B5156ba3aF510B8c6cA19804d88E": 4887.94,
        "0x72a452A62B537fb235f533370678f391d4C71Cc4": 4886.96,
        "0x16451D283B5113b69006D8E5EDd48898dd3f3f7b": 4884.44,
        "0xC1102e79a5e4CAEfB740eb7bA4e862a762D34218": 4877.88,
        "0x421191f895e53d45FcD7Ad2Ab15898e83cDA14F6": 4875.94,
        "0x40bBF87Cbc601B0870E391Ce2A1d871Cc62FD66E": 4854.38,
        "0xC8A7403AC82432c8eE1f5eF998874ff3d185573B": 4852.14,
        "0xC935B59c7f810cEC91e46B45F03A4ac4Cc0e915e": 4838.26,
        "0x19043De39EC459a3A89B2485B84DA448BF601a99": 4836.85,
        "0xD86b11C0725042C977ef837430442ce2D607FA7f": 4828.01,
        "0x196Ff5bdeF0adB23cec2ac6429F01C67774Bd4F3": 4826.5,
        "0xa89705Bb48eA5b78b6F2B12cd4667EDd7CAafc13": 4826.41,
        "0x77777020820B2D68144A1C37447E5BF6B1902deE": 4826.01,
        "0xc68Dd4c6078120b68fd19E77ead0D4C08E709C87": 4825.01,
        "0xf8c97F752c82d5303276a8A792A3DC9B5Ae12F0A": 4821.15,
        "0x9bD11E9313f61b2AeD601eb9d8271c3230752e7E": 4820.91,
        "0xa715c8b17268f140D76494c12ec07B48218549C4": 4813.4,
        "0x3d4b2941Ca2acbC6E7586E4C6160E4a0d891088A": 4812.12,
        "0x377333efa383051B8252a8E5b4DEB19cD3875A89": 4810.65,
        "0xA97dff2a87504800B629fDb07D8F3d7B326790eF": 4802.1,
        "0x62C0f61B85e568B9a8Cf61B00D3b75ceFD7C6790": 4799.82,
        "0x892382845FAf38BbF7B618f198BbEdf231900d5C": 4797.57,
        "0xb34298965c07Db84D3B94D0664Af15D9b353FB85": 4795.77,
        "0x97658D0a6a6180a99697a375f736BAD40Cc307b0": 4786.2,
        "0x75dCa5175e5D989Ac5736Dc8940833F964ffAcBD": 4778.35,
        "0x9BD1646123896FeabB069Aa83A7520e45e9467Df": 4777.75,
        "0xc1C0Fa0DFEA0C990bE8AF1455456f89aBC69FbF5": 4777.61,
        "0x310a3CEA42F93d55584c4361565aA0994912fF0D": 4775.62,
        "0x1F3c29BE1C07A8546A44b6824F4930B41F1FB6d0": 4774.88,
        "0xfB07D2bdef2Deb1eBeC001644b4732AB77281C7A": 13256.95684309537,
        "0xc04905916641421756bF60060731b58988e9Db7B": 4767.62,
        "0x839435084253CfbcF01B2aa99870586f9aA82449": 4762.7,
        "0x7BFEe91193d9Df2Ac0bFe90191D40F23c773C060": 4756.47,
        "0xAa5eDC8E911883Ed305f29aCe3a160699f5987DA": 4747.37,
        "0x064cB0bB4c8ABE11935134aEE670C032D6833556": 4742.59,
        "0x966B7B9019FAe5F8369d9213971d9Db2C8873008": 4734.3,
        "0xB2CB61CC0a8012df815ec40B54f5b9e83b76Cfe0": 4734.28,
        "0x31E748Bd893DE7F4A21E7Ce609783e1C7301b7ff": 4732.22,
        "0x8dE71Aae74bEe0847A1Ee5F620F645910f8e5973": 4731.28,
        "0xc8172f6530EBb435d7878A5276f6F816E7C8c8af": 4731.09,
        "0x42aa31117A3fd147B35e2c646818346B9Aadc924": 4726.41,
        "0x1900D224d697cf4CCd401486118B8a59FF07336C": 4721.71,
        "0x32Af25467b00aAe516505B3331cfEc52092ea5BA": 4721.2,
        "0x46D47FB19339745D106A07d9652b7636c3e02bB5": 4719.63,
        "0x76Da9F88e63a85Ba8BFA19F3821D5A271753D3dc": 4712.84,
        "0xc8A38387233Dbdf005372999625A8625C1d14eC2": 4712.8,
        "0x0B03a3eA3f1596E1070AbA9FAfae676F675a791d": 4706.94,
        "0x153e03a6641C2F417aED4ddaD00BE5c896dc8283": 4698.03,
        "0x2d3d2BA600Fc52c9B2616ea95590A18eA2D661e4": 4694.04,
        "0x6a018Ad51DE844243ce7FB743c3E5F4481DF6858": 4691.35,
        "0x194A5e0b29210527486680a99EA4af96eEa3f4B9": 4690.15,
        "0x2CFFb7F387E054C531414fBC3377149c7f4Fdf15": 4689.89,
        "0xd180dD68759a1570a66439548319b94240f309c0": 4689.46,
        "0xdDA875aB21eEFFEaE8DAfC5Ae3bFd21d9acE6d21": 4683.43,
        "0x3023c4310eAf16cAAeC7F7dB1463E6d235157FE3": 4677.67,
        "0xFac755B405533075A131707a2cA1F4A505F1dCc5": 4673.13,
        "0xB05Cf01231cF2fF99499682E64D3780d57c80FdD": 4670.92,
        "0xDd07Ee20c5bD92B9534885912dbf61B82aE4888D": 4668.3,
        "0x361e4660611565f11f1ACd73990bA2080e8135d4": 4667.38,
        "0x3EAf01b5ba0e8D4e77F9A7555eFa6D77C4947b94": 4658.88,
        "0xb48C2698dC9a6B0CB80E2829bd27C105bd7F1c80": 4658.73,
        "0x34De953d7772cb3F166354f88a11D08519D93224": 4653.71,
        "0xBa971F58A00e8ffC7E91C0e8E7efcCBfbfE8F09e": 4648.15,
        "0x5c17FbD90fdAFC0A7C1fB47D05C1Ce596Eb8834b": 4647.22,
        "0x15c92B910F1DCA458E7CD49Aab584B0A36162e99": 4643.16,
        "0x5eaC616771ad51668A90A31c3Afcdae20ab119D9": 4643.11,
        "0x8955576061D89990c7CDBD6c5C387169AbB19A68": 4641.53,
        "0x456fd876493aC6065549c8CfF0882aCE5f935CBC": 4641.33,
        "0x594ad38646bBC48f87D7d70572213b6Ce9acC7f8": 4638.46,
        "0xb0dF23b57A507A8fDC36A0180B2b1F1D1b82395f": 4628.18,
        "0x39627Df67daC1e62235B4e53De4cf16222885c06": 4627.87,
        "0x7982eb931808561596a121B9E379cd81af05FD8B": 6670574.22033446,
        "0x73D7a5E56C3B7669F74EFde2eA2F277AeE2ab19b": 4619.79,
        "0x65Ac8167850Fc7df7FF076740Cb4611EA41DE346": 4607.98,
        "0x73c23A08a52873D0648246f7B1d5E0B7C0D82550": 4606.61,
        "0x0951a8A27FEa2e52E9cEA89a89e68A66a87f2f3B": 4606.58,
        "0x4837CeCAA04255d014C6C9c08fF060114c760F19": 4605.58,
        "0x6e4B70099BC27649cc5DDB2ca58CDf11F12e92bE": 4604.2,
        "0x5BCd78F20803240950340Cc3ce04697615d335Ff": 4597.8,
        "0xBa9bAc554670A11e8C38539F275F248F618DCC3E": 4594.17,
        "0x5EFd95cED49055f9f2d945a459DEBFcCEE33aa54": 4589.14,
        "0x541c3EdCBB145CF83E298942Baa96dD76D55060c": 4584.95,
        "0xE6681dD818BF11508422aB39561d96521eafF751": 4584.27,
        "0xFFBe45D2882EC0D7b1205AfCB887FddC8226CB4e": 4581.82,
        "0xC13Aa1d5Fa211D04B7dd87ae2f780151d47022cd": 4578.69,
        "0xd66D0A60da7b3bfbada2CE43D60732E2B1fea0Fb": 4575.91,
        "0xDd9682956A211f117055bd92CdF70Ee93AE04092": 4573.96,
        "0xFeca27FE6b6b04531Fe992c1e73778b144fC58B6": 4573.64,
        "0x1c0d733d0Fd0ca902Ff8D9aC02B2924d41237A1B": 4570.92,
        "0x177031fb42cE5E3d3447f0E10c5d9c63e708c01d": 4569.36,
        "0x6420fb04f3C954b27984091d7A051C71f80793F5": 4567.11,
        "0xBc478dac32a0578000Cb5a96F6B3f90520E2E441": 4565.58,
        "0xa12EeC92d8C155C8ea9159Cb87da4e062BF9992d": 4563.44,
        "0xB486dc468a9017A09bBb26e35463d4aB5E929698": 4554.39,
        "0xF4c3d808711B7317c11c94c72B3420D55C7c6608": 4549.91,
        "0x76109B9D8566AF2a806e06F7D0C40f4A53a53050": 4548.88,
        "0xa2Dc47aCab970477b08Fd0e586A9F1FcE4347003": 4547.02,
        "0x96956d45E242679b30EcFb8afB2CCAc81b856aB6": 4541.19,
        "0xb6aFfb6A1dC30a669240895203349A4f0c619aaB": 4540.43,
        "0x636b1e5370e398123D1b3430172F34E00D275198": 4532.86,
        "0xDcBe7024dA2843D87d74d6f8A9c6179b94a80CAd": 4526.11,
        "0x66fd829e0F047a96f27D3DCc44E0e01D4dd39794": 4521.51,
        "0xf33dD8eAfb31B0d4532eA5239f5b7D2bff60faaE": 4519.06,
        "0x4BEa333C61F3a1381B2C854Af53A13f1a36A7BC3": 5656.888931342755,
        "0xF01adF04216C35448456fdaA6BBFff4055527Dd1": 4517.84,
        "0x0A0Ae54781C461439e8B08d84d79E894f7F054b0": 4514.02,
        "0xa1b19a67f20eb022dF3f8915205cd8e7105933Af": 4512.67,
        "0xcE34fFDD4cd25c672373C09eC0c53b54B0b20abF": 4491.51,
        "0xf9097D6a7CF5B29be2D40712C01Fa09558ab98Ae": 4491.41,
        "0x342E4538518C62328C95DDE170768bFa9367f4cD": 4486.13,
        "0xC7838851f593e12b462948c3DAe5214F8E4a253b": 4483.42,
        "0x98853EB1ba2FbB86B4FD55Ab0aF1a7782f5C4142": 4481.59,
        "0xd1401d2f57C36f57B5C7151D647f457d14F6d534": 4475.74,
        "0xEe63956639ce0784d3025831080d39F366385577": 4475.11,
        "0x02736c4D67e0b69D3265f040885E3e40758F0230": 4471.52,
        "0x45cF12026E83989903035c6B2d4E976c51aD687A": 4471.36,
        "0x88409E3D4eF006e7B5E3C5D79459927867488F5b": 4467.46,
        "0x699D833fFD292DbA6883e70D3990e415AAd7eBeb": 4464.33,
        "0xfdBc6FB91ACec80768B55b882F7A64d99Bf16D4D": 4462.64,
        "0x87aD2B5091534fad74b0AdD5D4bDeEd554d511aa": 4458.81,
        "0x7e8c1A232ED5BB1c2F17651F5c0DBC871F232279": 4457.37,
        "0xE33B746A030c3B3C512D274B05Ea6e40772CF212": 4454.79,
        "0x83204E484F7136285D36acD72012a870a0a785B3": 4454.51,
        "0x1889Fb39545c34780597e83960312a351D525383": 4447.65,
        "0x52dCc21458B8e79D6Fd3a7De51D322a602397bbE": 4433.02,
        "0xf1Ad8Bb8725CA39A67EFAf7C1d85FAF372dc1620": 4426.12,
        "0x0D8d78700E23E82b280f57Db10c26b2fF51Cd8cD": 4426.08,
        "0x321Ed9D1E70fA359d14ac9cFc08Fee3C05cFC506": 4421.74,
        "0xDc05e3eb114ad086E0be68874C96196C930405d5": 4419.1,
        "0x5E014aa0649102E07c074f498845F01BCD520317": 4418.15,
        "0x3747620Be079f042cBcea3c724e726ca2fdD9cc1": 4417.69,
        "0x8617d145Ad0be7c04C5E7efceFf9759Bd4c43c42": 4411.46,
        "0xc740F0A5cFDA1C7c2c1aA3029FB6B612fa2f2FbF": 4402.61,
        "0xF331ffF8c630df8C5D03D3f57FCC734260A44E95": 4401.18,
        "0xdC19cdEd2b4f3472b37B43c001d048754fE74b03": 4400.87,
        "0xf4B6318A160b336F705a4DA574BDB4bbE0Fc25eB": 4396.63,
        "0x8ba5559Cd47118e54F6Fa3Dd7117A0Ecf75c7DB1": 4391.35,
        "0x021CEEC2d5D6D610231e9a6e1Ac00730217367D9": 4389.8,
        "0xFD71f325B900d842370F072eECAaD94b0a38dc1D": 4389.59,
        "0x59085D19773ff01f168aD595CE17Aca4C883870f": 4386.99,
        "0x57Fa41a4f8Dd0D16cF11dA7eeDc85e51f5DEACF8": 4385.01,
        "0x3dB275acD97FC0F4b14dc150F6E0ab0aAcb8Df23": 4378.86,
        "0x449F07A108FC296C188A3e42e9547722C129775f": 4374.1,
        "0x320aC2c6Fc3eB2ccb8861eCbd0C06d7c7DAd0295": 4367.13,
        "0xBCdEe73e0fD52Fd9b95F641DbF2F81ADe8b4B3e6": 4363.41,
        "0xbac24C0ac57054b75b41cDc5D67DDe2e3fBC9742": 4362.99,
        "0x68ACb2051b73C2342be78Cd1a7E5Ca44483D10c5": 4361.49,
        "0x6c1FB03612E943d2b7cB0bbde0FB3470a0e633f2": 4359.65,
        "0x8d30D1bf3A06535013d8EA1733eC1677020307CD": 4359.01,
        "0x0ddA3228B0729BfE7698988A669B81d4A306A8Ea": 4357.96,
        "0x9538E09239a1fb7a9906341899EDfc91593E4055": 4354.4,
        "0x6e50923df8a2F98a39f3750653F4584b434BB927": 4353.59,
        "0x5e6456C7e3cb985eA85b83fEf1b62949733748A5": 4381.373587594856,
        "0x0D4E17E6E832515d50fCDFc9eD8E490090Be6045": 4344.53,
        "0x2F04ed87b5Ac8b703565469311341b0b44e315d7": 4344.13,
        "0x0d24479f1cBE69F50B1d3964D2609e45fE3E6F75": 4343.35,
        "0xCE5B6d4F24b06F9c93c42653695A26AB88f1B951": 4335.46,
        "0xb6fB12999a09eFfdbcC6F60776331eacCc42E539": 4335.29,
        "0xAd789Eb3042dDE224CbBcacf0b57399de0807502": 4330.46,
        "0xfea1890688fC7F9Cdd1Fc17Ae5D41a4772932B80": 4325.36,
        "0x67726BC6fa49e9c8C2a675b794ec33dE0E9c8454": 4322.21,
        "0x524e434b467F520239150f0cD8b0eC84cCDdD928": 4321.48,
        "0x7717e46DA3E83ACcfB052508a8390a49E780809C": 4320.17,
        "0x8c8504F476c184e298A223D4f841A7B4eD514d25": 4312.97,
        "0xe26E978B06b0e6Af44Ce8E2a0a47A174be229d5e": 4307.27,
        "0xC641fA4f454E724cdd8D64A96BB59d95590a9Ae9": 4306.85,
        "0xB2F610Cd62Bd592cD465519A998e2947e1dCb9EB": 4305.34,
        "0xf256F5fE200Bb84A8e2d6b0eBceC499da29273aD": 4300.02,
        "0xd0b92B8F61e2C64A9aDcfC246cC907890e30D965": 4297.85,
        "0xd365BfC9a5991727790685074624C23C8FAd455c": 4297.56,
        "0xd112513EA8155E2e565a933FCf791AFB9791c261": 4295.86,
        "0x0933cC77514334Ca565B92feF213A9d7F1598713": 4295.51,
        "0xd8d1bCDb29FB7F87DB3E14C488588171A27Db2BE": 4293.23,
        "0x5CBf97F607c23741cEAd8fDB776a2F477C6408C5": 4292.97,
        "0x28431a1446C86434DED04F7f8ba6808649329F4D": 4289.44,
        "0x9AcD4F65448208f691417511193686f4b6058952": 4288.22,
        "0x6C377C7F8238d8e3911547a22135a4223DD5F76f": 4284.9,
        "0x5316701e1ddb229B8dC13Dd3bF58abEdD51ABd22": 4283.74,
        "0x2F28C776C12ae1aC796A1C1EE068692d07035FD5": 4282.66,
        "0x9381400DE24c97D4f747d85e655227855439F11e": 4282.19,
        "0x79D13479261bc36E40970382d1FC75E49E1e0d01": 4279.68,
        "0xb88d3ADE7E4231c97038F6D82475A233772fFC25": 4277.35,
        "0x5d57d3ADc4713980CbdFCbe6f36CC58cCeDB68cd": 4276.64,
        "0x2Fa1B4212b2137da9a8F28A449B5041b2124DD13": 4274,
        "0x3451F23A794fC06889DCf36644518E4244233e60": 4269.21,
        "0xB16c82E30374a35FBe5dcbCD571F028092921bC8": 16549.496074138417,
        "0xc46a94d9D2c82573604Cf6ec30256dee3405eCE4": 4264.22,
        "0xDaADd85a60EF6386710620Cd160eF8b034C9CB10": 4261.74,
        "0xeedb470E8d9a2bDEb8Ef4897de5Ff01b822fd9c0": 4260.75,
        "0x23d7C2fb9F163441874d72399B28d677f47020b0": 4260.72,
        "0x8844c78C5482A187a7DF482ffD14D62208Ee6354": 4258.7,
        "0x2B8a3b7DB8cc1301938AF2A15A025A03DD536745": 4257.23,
        "0xD177aE3aBc23cf64a8dC7f4cF82f45862179b41B": 4256.53,
        "0x93DDA1F610d9043274aA072bEDF9EE7231E2a757": 4255.29,
        "0x4F2Fb27E4aaedBcF421e4c7976a21311484bF0Bc": 4254.34,
        "0xaAaC34d30d6938787c653AAfB922bc20bFa9C512": 4253.63,
        "0x53E2F719a0f7947175Eb1327BE1A27533A1b15da": 4251.33,
        "0x43E3267Ce69862FFbEEa59690cDb3e798f71cE7E": 4251.15,
        "0xCB32C33C01482795487e914e5Ffb35A355fcbb39": 4244.69,
        "0xe64146ef18DBA217f7Fc7ef1e6f86D59aa7545d9": 4232.78,
        "0xA8Ca949F6F1c7225fdEe740D239B4Dad8332a785": 4231.08,
        "0x84784D9c34bED34639c3345C7e700CDEc3F77480": 4229.72,
        "0xC80d8693Ffc5E483BfB89b2c3333f188dac2Ae57": 4227.79,
        "0x791437Cc4fA77c534B8B55D0Cc6f06C9cAB5EbB5": 4225.96,
        "0x0B7447F9106ff815Cd1B8Aec3e6c96D8B255Ed13": 4225.15,
        "0x7925c97533CffF9b96A65679A482bebCCF3CE27e": 4215.56,
        "0x5527320E2754a75a3D1d67E366d4D092AFF50583": 4214.94,
        "0xF699C7Ca398D205d558fad536DB7476101C9b102": 4214.1,
        "0xe2bCA5576d2A73283677b93e8D5c75A1d30b478B": 4211.35,
        "0x375e1e69b4b55750e36DDFE75017a2D2e16d1646": 4210.09,
        "0x5929cC4D10b6a1acc5bF5D221889f10251C628A1": 4208.33,
        "0x5D09A71D429e7F3e9CCB8823E163FA7311f2aE31": 4204.97,
        "0x42c22196aC2DBfd4D9AA90F79c1517DcCbDAa383": 4200.05,
        "0x05EeA05E01F67CdeC6A579534d559e1265Ab43a2": 4200.04,
        "0x9Dd952Af92598381b520036bEb60A38514736f9b": 4199.58,
        "0xDE3621B8Ecd32273eB12F8b5bd1d5D7Ea04B91b6": 4199.17,
        "0xed57aed7c31C0a1CEfa3f96D67383299f6d75859": 4198.2,
        "0x0A4B50F51f729F9ddf78322A9Adf79796Ec629F1": 4197.24,
        "0xD4F05ad3950D8b0F41ee4CEaFe0A242969B53684": 4193.25,
        "0x0892c23f83B8b15c30A22C5f5f1630c57BC2bA01": 4192.98,
        "0x57Ed6C887b16dD65021a8F11A67A5ecE6EdE74b4": 4191.53,
        "0x5D5950F50fbb081Bab24ab5fda90A592D30327AC": 4188.62,
        "0xb385222C461DD7DF0526ED22568B81984F6E5F02": 4188.17,
        "0x528E420B084B004878aF107f1c0090cD9CEEd195": 4186.7,
        "0x48c49024E2885679D0c9Eb3d4d6e73f2542B5839": 4186.66,
        "0x2f04D0331d4aF95b4b3251b82c4FB4912d4FA0fB": 4186.2,
        "0xCc36D759B6F919Ea2563E837E7F29b5C978cAA10": 4185.92,
        "0x02f55F2DF5352b20E33Ed6d2E027472CF919De91": 4183.99,
        "0xEf5B75ec7DFF3DEF472d3f58D1D03AC888257b4b": 4183.45,
        "0xd7Bb63356E09109Fe93486a71102Ce405742094E": 4181.76,
        "0x4374Cc09ce6d366dBa61b48dF18F2d4dfb0d124f": 4181.47,
        "0x6d06bDD65Fddd9FaDa9b8dd26af6EdDb2C903385": 4180.64,
        "0x5806594D03437742EFDC1b33EeA609A04c220B5F": 4178.69,
        "0x15e5b2aB5102da02C4916E815a6685bd81957966": 4178.21,
        "0x4F3b1951719df518603e29B9f4d55aF8B5383DFa": 4177.11,
        "0xda42B5c1F1ba421bC41654D2F3f600CBf978D09B": 4174.95,
        "0xa1F860981Ba585580Bf0248C86289C13bd7EC81E": 4173.4,
        "0xc917C133cDdC3106042117FF2bE8Cdc2ea429513": 4173.3,
        "0x0a3043F9d2b1c6cCfc492EB59Af5156F378c57BD": 172317.22691398274,
        "0x22510fe99F63aE03BA792c21A29Ec10Fd87cae08": 4169.03,
        "0x8e3108b540f48758580146107D18004C0c1e84Ec": 4167.96,
        "0xEAF1EaF9A95c7f1c37bCEeAF49423dccDEBFc6E1": 4165.66,
        "0x4E7F11cc8e7F3ffe064d191E89a5D8BEd1a20511": 4164.62,
        "0x2682506766962e4885efe1c2454db34253915E4B": 4164.18,
        "0x1e28b238D41D15137A1E9D68871E840606a213B9": 4162.83,
        "0xD4F59dF9be6b445FB0989d463E95239B6C412c5e": 4162.26,
        "0x199efbFCCE43Fa755362E2c44c7e01e87cc35831": 4157.44,
        "0xbe2291E01BED4744F85D6bC91f02F4874BaC7096": 4152.45,
        "0xf3c0B7372a201CB8C24CfBD8e27c71E2741d045B": 4147.21,
        "0xB1B2278C17d59bdC0EE5a26b8de1548B43A8bea7": 4147.04,
        "0x1eaB115506442B47137DE339180110C9001fA322": 4146.61,
        "0xbcd52B5537e4BD850B691b8c87D53D5a7eF5d505": 4142.34,
        "0x05A01deb76A08d8556e79523CBb54C89eDB9E7E1": 4136.69,
        "0x54BD7be15f883ee7583bc811C6537C753eAce76A": 4135.12,
        "0x37f3a48bdC4175cc3A492Af2fB992e5E60e1b3B0": 4133.85,
        "0xBD65134Eb2a976902952514D5FAfa05825dE1A38": 4127.45,
        "0x43410aE727161A8A4C0798A2D20c23bda7D66125": 4127.21,
        "0xa41868b9989Ace59E238A8cD5471D7F0E1dd83b2": 4125.07,
        "0x8bb820c251Ac194Ca770f9f0cDc12B76354E3dE6": 4124.34,
        "0x90c3a47c30A63977f19634bc08E597c0D068a737": 4124.3,
        "0x7F5AA3656B9291b9F3eEA4916282f08DdA68A348": 4120.95,
        "0xD5154d588D91Ce10DBEF7A3f7488f4fFb8281992": 4119.43,
        "0xaF376324875B95e81EC5d24243921f0662B629d2": 4119.11,
        "0x6F233706aEef859d4930d890c03d0437B5a815E0": 4118.02,
        "0xB9694C5D300366d9b93Dc13D8a9B81Eb0281EEBF": 4116.43,
        "0x495Fb330EFCb2AeA4eeCef61534d4404850909d2": 4114.03,
        "0x2f4b4114575Cc98B523cd1F664FCf50a9eE07CDf": 4112.66,
        "0xF1eAeB33A94870F7f4b746F2e140D183b8e5b9ad": 4108.1,
        "0xD60B115F755CE5fdc21049b43b62c3e2F9Ac34b8": 4103.6,
        "0x53f7cb117d77E68fCF2B14358FBF857bD7E7cc5c": 4102.8,
        "0x47F48812B7a7A1a405f2065bc5e98EA76881CeBa": 4101.24,
        "0x3c20a73DceB7ECCB6Ce6496C85fFd35bBc526603": 4099,
        "0x05Da533bcA66b6DF7A5Fa7F9AfbB62c36703C2E6": 4095.98,
        "0x81F70f684222137187b20F54E5F8095D7955Db47": 4091.54,
        "0x097adbE246858a0FA8F9492889ae00Fd87638044": 4086.5,
        "0x51dC3dD3Ff9a10B2842b51f1d655F26A86301b54": 4085.59,
        "0x5D4aC03df1443450bcB4dfC513A1a35F92912EEa": 4084.98,
        "0xc59faE87c3fA97c4910b38Aed14F8E1532750aD4": 4084.69,
        "0x0318cCFBFAE5e2c06b2F533A35ACECEA13b9909F": 4084.58,
        "0x3e10679F92F46a983889c154638592E6444e3F05": 4080.58,
        "0xC849bad896aaBC715150CC0B1d466d6B09434A0e": 4078.1,
        "0xf6b8ADfa981e04Cff6E08c955240b832dC8A39DB": 4077.44,
        "0x73690068a30661c528D6898e1cFff746cA5968E8": 4075.79,
        "0xFa3FF979001A00f52C923C2b6522C635C861E15d": 4075.68,
        "0xDC2410ab222248159Df1e26059186F3768582b96": 4075.39,
        "0x11D140c52CFE89f4d082977A7146b2d434d7D219": 4072.82,
        "0xF7d48932f456e98d2FF824E38830E8F59De13f4A": 4072.7,
        "0xa87e88D9168d3d080D41b6F5800D5d20EbcD02C9": 4070.81,
        "0x82C01CE7d848c6cD1cb26f9678eD1a5d5fA1B6F5": 4070.02,
        "0x4232ffFe4afBBe88a36a5d15aeA9Cf2Cf5FE0714": 4068.64,
        "0x60618E351688643eb9bFEDa8Caf85a1130a027AB": 4063.24,
        "0x3ACa8297b7EFEC12eE4A08A55c5d48121a9Da443": 4063.05,
        "0x343CB208222a3b3df1E767934587745A2e992A08": 4062.72,
        "0xB5197607773c8C17E7a91005E7D1B20428A3589b": 4062.46,
        "0xe036b693Df7BD682240F815F50233C05A87828A9": 4057.66,
        "0x7Cebc6fA6E923fbc6676cb5dE9528772c8b8AdE6": 4055.93,
        "0x435C64A54F4d6523e2B7aA707f05b1eD531e162A": 4055.63,
        "0x3441AE018e8aAe445f39C214A8D50FC17c431Fe3": 4054.9,
        "0x20bB4c01C67dD78324F111e15aB4d89f3f22632B": 4050.82,
        "0xc83851b54412b0e0d86966E9317Ab34Af0231513": 4050.16,
        "0x455268Fa60852Df9930726b03B89207469FE4b1b": 4046.41,
        "0x74F5E6F96273aA503842b2eCcaF78295927b1b62": 4046.4,
        "0xcAb512F7d04DF66F4a644D4d3315E88348B2cBd9": 4045.19,
        "0x9659513f09F833aAA527935908942ecC7A312fa7": 4042.02,
        "0x70Ec93EF92bdE5AA7AFFf6546207bD378A28933C": 4041.06,
        "0x4253c381501b38E2Fc1cC342fFebBC5583117A63": 4038.51,
        "0xd20862426c8ef78AdD01Fd448360Cf63B01b314B": 4037.48,
        "0xf2A2915476E42456d155a6b2a99E1bA3f7B38f81": 4034.78,
        "0xf18e403f5CA94f715021AaDe3a6138227517d165": 4034.07,
        "0x7FA217960D5A5274eE7F416ec07f30dBAD66c8a5": 4032.8,
        "0x629501F7bFA35E652f597233f48867DaA029E1E2": 4032.32,
        "0xA00Deb25bD18F8Fe90427D78c9FdD6B89080401a": 4031.56,
        "0x8b5CF17f9A975DdADaE4Ae09345b4Bc35329522D": 4030.29,
        "0x384b9b8E0A284c29AF4739a14ce8FC600a9019a8": 4027,
        "0x8A12A44fC87adC3a847fDC0238e9d1bDD8baB90F": 4026.42,
        "0xB9E0A05CeA0392a4775A18b6F1cc6585959E33C7": 4020.58,
        "0x769740B00919555aA71922DAFFc84eD59B7D71a6": 4019.35,
        "0x413513C9bF4E14D0457678989537D151840Fd8E9": 4008.82,
        "0x3445A938F98EaAeb6AF3ce90e71FC5994a23F897": 4008.48,
        "0x68940DeCaD7DDF1Bd4BD5763a345787E4413A9D0": 4005.79,
        "0x35B62D2e738235ad668F15b51AaA37d947523910": 4004.33,
        "0x1Ec1C4C4Db0718D0ED13c9F339cfC08db3F894C7": 4003.44,
        "0x0eB2F36C1ac5984B3769574F9Ff0c71B5922f26A": 3999.6,
        "0x9320ED7B32db6156e68B8B5d118cc0475c488A57": 3997.6,
        "0xA545a77ba8ab4592912362c51F292E1Ee2494D05": 3996.18,
        "0x8e7E8d4bD91dd075Db32855C82F628e0453Cd4DE": 3990.86,
        "0x17BDF0AeE159F76b901a587dd58ea4e179a8b6A2": 3990.42,
        "0xB49a34A82D84507F757309A10C5eb22f1Dc69A5b": 3989.73,
        "0x824B6b985f2C2763a34c527803153FB6FCAE49c6": 3989.14,
        "0x54A8E4dF617Debd4A809a685a3517EBd293EFbBc": 3987.99,
        "0x07E903786EbDac4971B514EfA2D34417DBc679a6": 3987.41,
        "0x3846FF2BFb84A922E567fFB4fe93E4Cc8ead6b5c": 3986.51,
        "0x4c169C11C0E3EF2cf07126def8921955dF3C4794": 3986.26,
        "0xB20C1864dacf2a4D93806F52651be7EbDE96AE6a": 3984.79,
        "0xA53518bf7E5B63041A235e2674C5A4FC13153Fbc": 3984.35,
        "0x76b0b66915aAb91ec6073bf40A75223fc9db1192": 3984.04,
        "0x41db9144861E51b6B47FDece0e3bB5B9f9eFC91d": 3979.98,
        "0x6f844644C66681748943E1226C6475Ff958BFd09": 3977.02,
        "0xd71cAf43A8EdF3A611FA466205cCF76E236770CC": 3974.05,
        "0x511EFf8Ee34F37e2442eBe43d4b07F2348627496": 3971.52,
        "0xd427812CA791f0145C757755c3862982Bd50C8B6": 3966.25,
        "0xCA4385A976078166eE48C8771Fdb7ee2bCAf281D": 3964.32,
        "0xE8e172812Ca8aFe7871b1E8A60E1858C6915D8bf": 3964.04,
        "0x5dd9746a6b2Ad0abaa08F1885a9CD4b4b61659e1": 3957.93,
        "0x97bB3BF0d036B35B751f95dcfcD2462b33E4b104": 3957.36,
        "0xE9b4639CE2A6Df8E0caAe039A990FB83fA9706eF": 3956.58,
        "0x3E1D1db4Ca480EBB65c73D55B03E3712b4FfC994": 3955.03,
        "0x88a73ddfddf424CE1A503782b1b35F5E9E5e980D": 3953.87,
        "0x1E538bc470e5bBbA9cd56650Ff905a04580D72CA": 3951.34,
        "0xdE4Bb35af19b27927f758559000cecBA74C8d2B9": 3949.99,
        "0x7C8F39f35Ba890Be972D2CcABab0e3Dc99A82001": 3944.36,
        "0x63baDa4E5f1E8973edDe8531748009799FA3047b": 3939.04,
        "0xdF894aAcC6E0609b4A223489de2Acb71C93dA2fF": 3938.09,
        "0x712CBBAA1f4aF905398CF75f528321e3A92DEA9C": 3934.6,
        "0x23f66992f63C1b42bd7842cC9fEcA1Dae789D963": 3934.12,
        "0x703F2f6BAA68b6F33C33dC7253675f7B6f22D8e1": 3932.39,
        "0xA8535cc13c808D873B7a57d929f5A9fDE81421F4": 3932.15,
        "0x8A57871475E1d7Ecb9bB5e523A53fc2958Fe2b4E": 3930.25,
        "0x0dA25A39aEb7857099d47FF647B2D24280f788B6": 3929.15,
        "0x5eD6d57F84E44D0cc63E393D5b233C7759d97482": 3921.46,
        "0xFF3FFe39AC9cd85B9D9AB97D34CD251972c1D78b": 3918.15,
        "0xeC0738462291f7A5c2Be0e4587fEA47e5b277578": 3914.8,
        "0x133B56E7dfb73667AF9AA72aeb228F9D966968F6": 3914.02,
        "0x3D6a18349E745442705AFA3377f8f725C80a6E1b": 3912.58,
        "0xA4eF650F3BB011B43bD58400eFb752462b9908fF": 3912.13,
        "0xFCF00495CBF07A0c834A176c1F98bf4d46046E18": 3910.34,
        "0xDbFe798827CF9E3135f0b3813b7192675D7E1434": 3908.5,
        "0xD77572e62dcA14b7a4A043e52A2029E0A27B06bC": 3907.05,
        "0x5773B645c153f8B09f83877bF08f3513d6E98388": 3903.52,
        "0x54742cEc8dFBf56eae4b77f06F318138E0819B25": 3903.51,
        "0x7d871538E508bA4AA645cCCA8A6542cf95F09d79": 3903.2,
        "0x476729Af2861E3E1B3B1f1CB7FB620F46b0f6EB5": 3902.11,
        "0x08434Fe640fC2D2236d2800DD0abaDA7c9BCC638": 3897.93,
        "0x95b05F935655c37ADa2088c5767E5006f230B068": 3894.96,
        "0x330C2ee8797768af627d596840b17890a71209C9": 3894.19,
        "0xe3e42Dfc7b7ef273c74e262c335FF93968Ec7846": 3894.03,
        "0xe2066B0c5CE951F53582eA283072641086570DE8": 3891.61,
        "0x6235049232A979F6eE4A68Cff865E858f5C47016": 3890.09,
        "0x60921bC9A50B79766b682717fe53D561c224937F": 3887.82,
        "0xB5643125aBEfAc721C2F60081A0F257f0A8f55b7": 3887.75,
        "0xD8c2e378c699b7E3E5F97cF4F0F46741296D8Cbf": 3885.38,
        "0x6a6baD23831056A1d99B3Cf760D6a4B5D85A696a": 3885.05,
        "0xBB0524c3AdaA090b23E2ea525971deea1E062669": 3884.68,
        "0x9eE390D942072F492BAF9f8e25b95F4B28227345": 3881.73,
        "0x65EaD7Ff90987aC285488881385BB4B065EC93b5": 3878.14,
        "0x46DD290A71146f23c4891e644B85B1bD78370f4B": 3875.4,
        "0x8110125dEAdFe47F135C6180BCCd5cAFc7D181FE": 3872.75,
        "0x0A8047Cc215158544f08597ecc1ac51b3ac0c778": 3870.41,
        "0xdf4Be75f9C675ef83357b18d2DD8d0D69cB1e91C": 3867.25,
        "0x188C30E9A6527F5F0c3f7fe59B72ac7253C62F28": 3866.74,
        "0x19d658C40F00F157A0c589867C494B57498cE053": 3862.86,
        "0x1D83D82672eAb0B28788432D712dE62C13faE3b8": 3858.02,
        "0x6B82c9f29Bd21fc8A894E582E759Bf70A8E2f6d7": 3854.71,
        "0xA8bA725E1bb38D5ebCd6950394a82919E839D1bB": 3853.16,
        "0xDAf36939335033E692eDDF335f0FBe676Ac833c5": 3852.73,
        "0xf21b790858B8675DD9b8A382a4F070FB171e9acE": 3850.62,
        "0xFeEfAe7574492D1ED4f4113b564f36bAA5d6E16c": 3850.12,
        "0x9ba2E946163aefbF9aD7d7E71C8a707ebF77520F": 3846.18,
        "0x4F15F0772840C9E9093EC26Dbd107B77d371526D": 3845.35,
        "0x77a4851342D1B3064E5a641A0129E6fd73a9e70d": 3843.57,
        "0xE3107687eD55303B52aA6AF546d7a5ADF005DC9f": 3836.61,
        "0x8E7686Ba34b8C4F7298421Cf981Dd73132deD831": 3835.5,
        "0xDeB7b114E34548A6c47521517a57c9e0207C891B": 3834.6,
        "0x95982451db9F89ae4d1098098E7Be39D75fB421F": 3833.49,
        "0x7e3926e7AfC698DB4855a8c699f925Ef1290eEA4": 3830.49,
        "0xe1426BFBA96a282620ff24Fa0f1D6D76C7BbaD5C": 3827.41,
        "0x7de6269048b29Ce846E4ae58afA130Dc01022208": 3826.6,
        "0xBd672073669419775A29C98B2bB0891D94a19860": 3823.8,
        "0xf168e751cBF19f822d45BfB4FE50cC9aC302c8a9": 3822.21,
        "0xdaC2c5D760ff866BC796DDb88dFfEc3D9A90b7e5": 3819.94,
        "0x0987E39E7373c858f8f170A92aCC4b133408F0d8": 3811.51,
        "0x564B3A3CF630D7B3b35ae78E47Feb074bcE2B06e": 3808.92,
        "0x99eC106FF326Cc591e820baD5822276E0a46F8ba": 3807.32,
        "0x0cF225ED2Da65CdF194ee8507aC7ce8119FC1506": 3806.92,
        "0x869D53F9C871c35B0840c66723d4F6276cefFCF8": 3805.27,
        "0xb049DDDC7aC36648fa745549c4bd0389a9b93050": 3803.54,
        "0xF0bFE71eBfa377041771df38FDFEE79AC8Cf4e9C": 3801.41,
        "0xCdBC2Ef4414D6a5dBe260b9C41aC84Eb58623368": 3801.01,
        "0x0Bed98ED5Cb979D33e7aFC52dd07c5c96347C298": 3799.89,
        "0x19397846901ACD5c052828ec4e1515d80DdC5311": 3798.63,
        "0xB1ef414B4c1648288343D723895A00F60AcD1270": 3794.48,
        "0x5a72C8E982f9422C92645adea661fc3E5DFF8E21": 3790.87,
        "0xCc988c7B448D70386140067FBE385764D32e2536": 3788.2,
        "0x5A8dA901aFeFA780462b32Ce2431Ba6353EaC624": 3784.87,
        "0x422bD7a861A0ae944e70FfEa0e5ef738B8620F19": 3783.93,
        "0x2e9BD20c9859C18453b7f72A49bc3E9e1a508E48": 3782.94,
        "0xE8B2c24038079bB624010ca7185D5CdFb716320E": 3781.6,
        "0xc59d8de7f984AbC4913f0177bfb7BBdaFaC41fA6": 3781.42,
        "0xBA626027DcdAE0343a9a727E00bc2d0f566Fe34C": 3779.65,
        "0x43992eC5C6B1F0ca4C369d65A00b102E819d420D": 3778.68,
        "0x11Ed38014D4c74B747baB388dab651E0Bb854799": 3777.33,
        "0x1B98CF8F5BB5C3D89A6dfDf574bD9f31BB04E00f": 3774.04,
        "0xa227B6286D8Dc365D14bb17140cCd3E5Ac798De3": 3773.82,
        "0x021938aB80aF7d43363AebeFE912dF9F48A1C7ce": 3772.53,
        "0xFb30C9201bbf33dEB5c23f07a88d144150CE5B01": 3770.11,
        "0x9201C32CA9c224dcB8991E8afd6e7e08272130bD": 4670.450550958016,
        "0x683028Fc63477B8A702CFE7475865952d3E8ac09": 3767.49,
        "0xd7D119DFac20f4F671fF9f940812956360a3e2Aa": 3765.19,
        "0xC7520794AdA72c6553426379dE0cb0D6C5041550": 3762.61,
        "0xc2a8245d214Fcb8bA87660F9cB5b6d700C1437eC": 3761.86,
        "0xaB7681825890C03998C25b7C6ba0a6AE1bf721Ad": 3759.14,
        "0xD41D919e34A76ECb3857c51ffa405592543Cc246": 3757.78,
        "0x7Cd3FC0C1940a31223102dD9B6cf617391f73b2b": 3757.67,
        "0x529497b2D1DfD5c23b3680ae5e12B12cb0AA2c7A": 3751.06,
        "0x0215C1B63e6B02a421677e72afdAB05d7C051bE6": 3749.93,
        "0xFC0283aAf71cE8967a1A6fD3f546B96E52E90a65": 3749.86,
        "0x66fbd5996735d2F7c98F47297E88Fd8F36e134e7": 3748.79,
        "0x777596dC7f99dF82D272c756364003Fe235260De": 3747.82,
        "0x54Bff376eb7ba52522888B7E92C2D75Bd689FD80": 3747.46,
        "0x5F6a2cfFeb9f5e20AfaeC7Ae8c09BAfaE52B8aaE": 3746.01,
        "0xB192042E81c8adFE62D236d4D011CF32DebFD348": 3745.29,
        "0x63471b5a938F85369D118a3EF0138c61a8BF6c36": 3744.82,
        "0xEcD114833A5a07a2bD98D4C7547e438a287bb8DA": 3744.1,
        "0x251BEE031A185e04972Fe66597E48c95BEeB2d21": 3737.66,
        "0xE5350E927B904FdB4d2AF55C566E269BB3df1941": 3737.26,
        "0x38332d808BA345953f41c71D38CA1EF79CffA5c5": 3733.74,
        "0x4801d049444a392D1dCc2dDFf30325C94060fe2f": 3731.95,
        "0x93f289A25C2b18FA72b4e38fEB902b224be01720": 3731.45,
        "0x537e789eC3ACb8905233c465D3B111E1ae2E6c5d": 3729.68,
        "0x81a650e045A5D7Cad4E9cb1EA7a572dF336ddCe7": 3727.01,
        "0xf9fb7bFC2938320A1e3aB84864C549D5ae8ED3a7": 3724.04,
        "0x54e0aC7641423845ECcc9A8A9b6163c005221d04": 3723.43,
        "0x31f587F85658f46958F3f3c3fFFf7Af2669BF1c6": 3722.55,
        "0xa13a8b8039B6e8E26b1763B0E7e9eC992a73b996": 3721.65,
        "0x3fffde17b4d87F4D480104fC7c7Bd986dab8a0C0": 3718.77,
        "0x26553884Cee0bB96F4ecEA4de3eD52d88d3f2efc": 3717.61,
        "0xFE16cb64782486e33551426EDd881Eaf7CAd8145": 3717.15,
        "0x3d18480A9d89AAFe6aA8eB8187c35b24362D8FdB": 3713.25,
        "0x2e2e88D40952D182391c0D80359CCd486cd147B8": 3712.72,
        "0xBD893600E8402698692c2FD34B6d3253484F6280": 3698.29,
        "0x6F593b321076453e26ba98FB30ce1b41652C53b0": 3697.61,
        "0x85280a07B5C78682B9e72754E7385A0f1D62b538": 3696.17,
        "0xFa2b33713eDb48c66Da8d751e474079A07340c50": 3695.46,
        "0x00912C5c2a6f3423915bd62d963bfA6a17334cB3": 3692.06,
        "0x9de76B30ba7B40d19365A1A91f3a4Be041759023": 3690.29,
        "0xd77d800e235f2BF44E57E3f5cAea9770ED76886d": 3687.89,
        "0xE4eA58Da1B88d1827A19753ce532C18817EbF803": 3687.23,
        "0xECCb9B9C6fb7590a4d0588953B3170A1a84E3341": 3687.1,
        "0xcD413A1b8234e0fDe22728A940AA9236F10a521c": 3685.84,
        "0xC6CD000fB94f6a1Cb2EdE895783601434a3CA000": 3685.7,
        "0x6aA015ac897a18c3EBEBd46712F83eF09788FB9E": 3684.48,
        "0x3B0BdfE3ECf90bCF7461Aa9b542D19A9a34963aA": 3683.2,
        "0x9c6016B2543cFD29a587992393c3C59Df1dC48Af": 3682.35,
        "0x948a09694EE83FFb2EC0575dd6E0521022a3a956": 3674.39,
        "0x61f3B33FFB5a6504C0709cE4Ce4811C973A1325C": 3673.78,
        "0x2d0481370328Ce0306D27dcd5C872cF435Eb7437": 3672.83,
        "0x8243486619d0209F37de880810DB3B3a1700542A": 3670.65,
        "0xa6891A2BA106A90A176782F5E642e963d3077cc6": 3669.61,
        "0x69D6401B424CB2fb0B804212727F1836198db7ff": 3666.37,
        "0xCB6586874cc04B01Cc4fDB777dE502cEa7b3D6c1": 3664.43,
        "0x5ddD3218570773BC7B40970669c414725c96E3aF": 3659.49,
        "0x47CCB52f9432127297750046EB1B9658E597F45F": 3657.6,
        "0xA5Cb9B5f2A5D6A9eac298Fe89a5A66Fd9711Cd69": 3651.76,
        "0xa8C1f52930Deb3134fC7C8335375444AcEd1ECda": 3650.7,
        "0xf7E55b99c47a68cD269AB9541281c968b7305D2E": 3649.16,
        "0x28AAb43B9878a9225FA891a7933aE7623bFE6d57": 3648.32,
        "0xEa04a9Fe2CEf51B504e7da8cf1b859454AE27030": 3647.08,
        "0x34A274459EAE5700ACC0C873C629BeF94b130E69": 3643.35,
        "0xd96E32AfE56c055239804C526A9132c04da9abb4": 3641.06,
        "0x320E02eaD8e0f132C916eD046Ba33ceC14D76319": 3640.46,
        "0x0A4AAEd77Cd8C4f15FE58F921B14ad1C7850c2ec": 3639.53,
        "0x2af9F9156C1a40C7701af46772b402dBeadF8CE9": 3638.54,
        "0xBDbd4566F62A849C1362b6dCcB553974F28E3451": 3637.81,
        "0x4E646c515cDe41151E7e28206Db3E149F681f9Ff": 3636.67,
        "0xe989EA790938011e9d421eB2734A4Bf9e89c54CD": 3634.99,
        "0x371b36D6E5aB8a31012B263c835B0661210E3922": 3633.03,
        "0x45a3D1b3c8ed0C2E90F788AEe322EE316d7D7ce3": 3632.78,
        "0xD4e9313252a529DaC2c74c87F41AbC7641e023AF": 3630.46,
        "0x18f92F0673e46cF247A13703f5E403493b7C17ce": 3625.41,
        "0x4787A26F78D08953cdfc5A821DBDA67b568C2FaC": 3624.15,
        "0xA3fF2D14b8289D00c22C7917cC85812a7Fb4CA77": 3622.39,
        "0x48c7e0db3DAd3FE4Eb0513b86fe5C38ebB4E0F91": 3617.83,
        "0x1069010E5340F43e5c9208760F8a5A545846c597": 3614.56,
        "0x2122908c29a99774BE170CFdA4773ed0DA9369D3": 3607.28,
        "0x66829cC57540959A3A698C0694Cde4B96C19E99E": 3604.51,
        "0xf93C25E1F3F6795A645C875b37aD83F3D01E408E": 3602.88,
        "0xe6F9Ad33d2DFaDceCb535D6bF8D09EeA00bf11e9": 3601.06,
        "0xf807D36DDB03DB996d276e00ded7cBB9Fe8AbA7c": 3597.19,
        "0x0B7a590c791F4A13C4Acadeaf1Bd2a670c5cCd7a": 3595.64,
        "0x3212529cd75F4655Ccd0361acaF62352baF64445": 3595.12,
        "0x778Fa2a3691dE867661b60a74fD7B5dB003AD224": 3592.77,
        "0x808C136858C6Ef2d6819FaA2e0c09548bB03c1F0": 3591.75,
        "0x1cC83F2C12957bE69d3E79dD535B78Df1FCa4Da2": 3591.55,
        "0xdda59A62F4c4c6A9fA655D14C6726ec1688527fe": 3590.12,
        "0x15d56d4B9B56bcdfC6a207605A8965b7764928c7": 3581.69,
        "0x2fCcA9685b8B64637d1Cb36E20C35b207E189F64": 3578.44,
        "0xFBb7A22C25Ef7d9f8394cCB188D22F2ce8CCff54": 3577.4,
        "0x4AFb54d112cbD15F0369d0753Cab3E9579a89520": 3576.44,
        "0xB36Bb8d0F98a2162b412A776ad32bDdD567E8977": 3571.73,
        "0x5d7dc75Db428D93d7092e243Fa967DB28350bA9a": 3569.87,
        "0x47b9857fd53E0Bda751AbaF0568313e1D946a5cf": 3567.31,
        "0xEAC408601394c1C3cF74bd9ff2D9502699bFE783": 3564.51,
        "0x932da1c99F8a48399943d76072F689547e9c98Ec": 3561.14,
        "0x78149363C7638aDCee54e137B0e640AccBd2136b": 3560.97,
        "0xE9AC0B6E55cc824C10FC58aB3E8b9452B8150c8B": 3557.47,
        "0x9f3548946850e17655F76A031C7d602202D8F51a": 3555,
        "0xE296d5DA95B58365cf06cEB36fc8b482f35C851d": 3553.38,
        "0x80E4b476Fc634F741A8A895c7ad17f0a7762937b": 3550.18,
        "0xF68D2BfCecd7895BBa05a7451Dd09A1749026454": 3546.32,
        "0xeE9a23404333361302790e905bd0f27603D39818": 3543.8,
        "0x128Dc4A2E692d7B7c59559d07047f4886cFF8BF4": 3542.38,
        "0x2fB3dBA8c91C8665cE71FE00Cd749E92f39a8C54": 3541.96,
        "0xd7858291Db85AfFe2d001A9198AF339F5f38DCc6": 3539.7,
        "0x32d8527342655d822B2fd12C4396420234cd9383": 3538.83,
        "0x3F3904354c22755d036877363cE06eaA58825952": 3533.6,
        "0xacE95d7c33414F72c0A91Cd76e8Da5E56F266Ee5": 3530.02,
        "0x9b2f6FCcDb303Be94324A0777B9013d867109846": 3528.41,
        "0x7aFCeFcF0Ad675B155983FdCF2A253fc92f3Ba1e": 3527.21,
        "0x592349BbaF162F0ac2A5E76A13b019881B6F3f71": 3525.03,
        "0xBfD9174E7ad9690b1a43A25d9215f6d10Cf42162": 3524.37,
        "0x82656B9633Ed7beF89E9c513B72372E291Ce5068": 3524.11,
        "0xE3D69bCab5dAAea39787eEaf4c0369de366d71BD": 3522,
        "0xA5094c06C65c61084D5b31512381558685a2D63C": 3519.11,
        "0xF942457b49E10D4BBde841D93903cd707AdD1637": 3517.96,
        "0x763e8c86740d565aEd402D10b73537BF91EB2812": 3516.96,
        "0x9a7a1B1E776Df37A91D2100027bdE58d9A8b58C9": 3516.59,
        "0x5D4F22F6D43828eDa31f8b4c73D9567C173a3fff": 3508.53,
        "0xAE5B15D620e50bD71cc787965B437E69eb3C1506": 3508.46,
        "0x180C208564402d103314e509E770a3aD0fd6c8ac": 3508.15,
        "0xF18D57153C66e9c42eFEd78264ec65Ce695Eedda": 3505.37,
        "0x0c3fFCab6850594061779246529cf9D2c3aADA2D": 3504.66,
        "0xa86b102df2e1ef777D79b2d8F7f0A013AEb74Fb2": 3503.38,
        "0x8Da940B88EECbd18D3c3632315B2328e65A19310": 3502.15,
        "0x091172106fb8E171Fb99bF961e38440fF609AD55": 3500.98,
        "0x812CB6a4dfaAb6D3b28126bB1137A97dC4564d36": 3498.52,
        "0x5882aa5d97391Af0889dd4d16C3194e96A7Abe00": 3498.52,
        "0xb5F9B11d7738D64F737964061f9827d701853629": 3493.62,
        "0x34a09c6b42d7D11cF23008ad63AC2983E18EFbdD": 3491.97,
        "0x22932588A880bc1d6a968A29b627a2fEDf9d1Df9": 3491.68,
        "0xC2D63FDEeE135D97b178F35f458B7F0D73366592": 3490.3,
        "0x0575f2b10067EFD206371F6939039Ae630AeF1B7": 3489.26,
        "0xf67278D2c7e91914F6471978e7D6281acF496aa6": 3488.88,
        "0x3193bd3973cFd3A073E6ef93E9194c221f5e58AC": 3484.36,
        "0x60dcBE9d4Ff46cc4123fe7aC602975419Cceefaa": 3483.39,
        "0x84FBEb26f4931f94CeCd487Bea6f7c88F9109E53": 3480.99,
        "0xC352e763bCE4E705441B9134bD1d410581fdD43f": 3480.61,
        "0x7822159ee394D14745Cde63a706F965fB73c7Ac8": 3476.35,
        "0xeE6f2d4D7Bf30eD5261667D5E7510B36dF29D186": 3474.27,
        "0xbEF5ad0e13e4b7C9b8f0d3E6d31d04551d466042": 3471.84,
        "0x417253525EB20DA87eaDB6f052D4681149B98B94": 3470.8,
        "0xA9b13685A5C4824E5169c45432E835F485C2C368": 3466.66,
        "0x79ff7D32A90Dae8B5c6C37778d833dF6AD1b13c4": 3465.92,
        "0xc663f5823561fB3C5d81282a05B338f8434BCea2": 3461.91,
        "0x5b7d73368FC2C60fe609f744CDeD1cDD5f407973": 3459.74,
        "0x0DC74caBcfB00ab5Fdeef60088685A71fef97003": 3458.24,
        "0x0D8b407EBdFBB810EdBBD39AFabE9A89711FFa14": 3457.52,
        "0xe11652e2fdabA8FaA651c14c874F2e754b141170": 3454.81,
        "0x9487891106fEaE0F6A2bad9a15dfca5c615BabA7": 3454.2,
        "0xc26A6c794e1413AdBccDaaf2e12D8dF79DC84675": 3453.18,
        "0x2C94117c29dd376C28d369D8FAEF20FA7565B3F8": 3452.34,
        "0x63dC2179A6e0E45f58bFc5E55B50116fc6669FC4": 3451.46,
        "0x6A7Fb29EA30081fFEeeBa14B3f3988E0C53Df671": 3451.01,
        "0xA49E0fE69612d0eF300D1642F7cb8b3aEE446C1f": 3450.59,
        "0x70E15212906c03be2f77D35E973b039DeDA49D6A": 3449.07,
        "0x4Aaa0c884e99A9dFB564d4ade07ED9eb32bD488D": 3447.05,
        "0x23B2A8dd3c929b75b4007Ca7e1B1b1c4378724CB": 3445.75,
        "0x7f3cd5Da54b7Aaf26Fe2EeCDbc394BD4d05B5226": 3438.96,
        "0x8Cb9Fb7C045b5FEd2b7ACe1dcC6E627eCEad42b8": 3438.69,
        "0xa988799FEBB0EcAB3bCD611bE71621bD2689d464": 3437.2,
        "0xF8cE22d53c732D79eE1a64f69d967774f0995127": 3436.83,
        "0xd4ea9F385Fff38717B588d527c492b285e276110": 3435.14,
        "0xc78534160D213066a3714526070393a2655a73E2": 3434.47,
        "0xCcebD3F969e7511C98Bb2d48711FAE99B4f3bCF2": 3432.41,
        "0xa85836206B14138959a8bc851300e80F3DD8C529": 3431.9,
        "0x6419d0ccE43e5abb6Fe18810D5F094767E0D931A": 3424.66,
        "0x3676700F7286089369D7d31Ad3b368b09Bf39136": 3421.29,
        "0x1B08Bc49Accb4FB813BC9CB7f3a1f7f93510010E": 3417.34,
        "0x1E6eDFFb9B11251D8165641d282EEe2F9a30B173": 3415.91,
        "0xe32703A0b50BdA1217ef273304333af3fF1a26d5": 3414.81,
        "0xc96902ab7D6d4cD17A87f6c5000FB59BA0Ef1c30": 3411.95,
        "0x728d66A885376d1DDf0809f4254085F171B157BD": 3411.88,
        "0xd0Fd0D3164666e69aF4f9462d2Af53aad503C371": 3404.73,
        "0x711799fcb318010c3eBebD094B3eefB7d1e2Cf08": 3404.24,
        "0x62A6fa2361FDd4062ba3C571F05E7deA35cc4471": 3404.12,
        "0xfC1EecFc3d9b37C1879d748CEE4c353d004a640b": 3402.9,
        "0xB2922D07711e9c7Ecd735d7b61ad6ee650157D69": 3401.86,
        "0x04b9934EAf668cA393290F91Ce5D824f6Ac68fA4": 3388.48,
        "0xb12158eA93f3cE919343d43Af32115084ac3c814": 3387.32,
        "0x18cD282e3c747B5D5486af7bDaE67C971132d43c": 3385.86,
        "0x64281c0e50e3e34322E01eEB80ACc5F05cb218F1": 3383.75,
        "0x4455add1A2871CC6DB66BEeFE25941cfb864c37f": 3383.59,
        "0x46235093A332B46f5dA458bcAb40E57B9836e686": 35978.47237279478,
        "0xce01d3B994B13151c71eDDd4584c3f4FE886C33d": 3381.57,
        "0x01052235f8b2Df3Db18538302E38a3C57437dD94": 3379.27,
        "0x07E089220ADE83652641eC71D078c3E2B9091255": 3373.81,
        "0xaA4Bd95FbA335215FccAB8B74a887C5C30d98703": 3373.1,
        "0x0c6F05Cfbe08F64464975791a0F0B860AFe179E0": 3372.62,
        "0x3A845F698d5B4D0311489f41A54ec2611cEc72Dc": 3369.66,
        "0x8A1b8929fAcd578994C7D158c9c5e67BBcCd056E": 3367.61,
        "0xD2F132930EA3C58A389C6AD3A91eF104f95fE697": 3367.47,
        "0xBbb33d2e7bD7ddC722E53Da9cA8ee97Df41CfaBF": 3366.96,
        "0x1f3cA0F7dcDf67a4da841c2B797174c67219C60e": 3365.39,
        "0x306bF96102eBE58579dff7b3C3c54DC360BdDB30": 3364.5,
        "0x429A144250D6Ccf964FF0d01BB30e19B5B2F11D3": 3364.22,
        "0x73728be04D37F6df6D5d9b4de1A428678028a661": 3358.72,
        "0xA821c7F2deed46d6edEe7c5580407dB47849382C": 3348.96,
        "0xC88C255798A1196bE9509247C575eCbEF1F654bF": 3336.92,
        "0xd178D4c323516ea8C860f0441a106345d3302426": 3334.2,
        "0x14fd7D24eBF81196dfd6d3AF740D5024071859f8": 3331.5,
        "0x89Cff61026f6743b8d25ae9B253582083136B1C4": 3331.5,
        "0xf7115e6A0F0eA077eCa66Aaa7282352c069e3571": 3331.44,
        "0x143D2767Dc3238b6f82E856B117C09273F487BA7": 3326.92,
        "0x7546bFA22D780a2171490cD6Ca1d5022013F4153": 3325.59,
        "0xe472243EA1d51735F92f0b5ec0c003b1aeF31689": 3325.47,
        "0x38B86C4D8905Df7339709bD6d23cCf9d1Fd387Ca": 3325.41,
        "0x009d13E9bEC94Bf16791098CE4E5C168D27A9f07": 3324.43,
        "0xb111433d504D25e19791FB6651cFce850b85479a": 3322.91,
        "0x94759c0cdD84054a71c4B9746DCdeE90783ACA4f": 3322.42,
        "0xC1988636348170ddE4240d66AAe8ccd0773791Ab": 3321.57,
        "0xA9c32f9ea880e30D0f4032a4FaE463c8e0a5b014": 3320.68,
        "0x012fda5d3199eDCFdB74a6f7f149f9831CcD7127": 3315.9,
        "0xfF2e1b2259B6189B41E24766e9b432CF2023505d": 3315.81,
        "0x4a09e148D8f59fb044f8f84567f70B27887Eb830": 3313.67,
        "0x1A52981e6655a94ecED698498A7986b5cF846c00": 3311.07,
        "0xAe5D71653Bef8d6a8379dE07aac6f13799B71114": 3310.82,
        "0x9c93914AAF32f851bd76303981702b82aAA29acB": 3305.18,
        "0x29197c3b222FcFF8571E5Af8029e2e7fCABDdF19": 3301.47,
        "0x77149050451d666B86268409F2C64015Ce8110Fe": 3298.12,
        "0x94D8c2041dBcaCb8CEFC645Fc69Cf99E54C40754": 3295.46,
        "0x9fE1C4612F464C6a74Ae5e2714300536a76Fb239": 3294.55,
        "0x42f92EAb97cEBb0073Fa0AbCBC7d1180c50e2eeD": 3291.46,
        "0x749979beC4474Fa4fceb1F8762AA7d1c3CBC6F3E": 3289.84,
        "0xa1d19A19Cdb3d0587816869693360F55C7Ac4C82": 3289.58,
        "0x5Aa498511DcDaf36a85833A6E2384dc93720e5f1": 3286.83,
        "0x66aC46f4510d3911519cB70475E6b4986E57eFFd": 3286.42,
        "0x11bcb66A295AEbA152666E511Ae052609bDA0a84": 3282.83,
        "0xa056C95d109E69667f23B0bd4c5b94A58CBB412a": 3282.77,
        "0x95304eFa4873684FB117A756C861d90Ff813e577": 5342.768494669974,
        "0xA10FAa01B53FdD3729448fe7AfCB2148D2619162": 3282.1,
        "0xA7Eef766B1f3F3d31A0c7C6Ebd0B3f31e9a87634": 3280.23,
        "0x93148918047D0953d34AE1376031492D0dD472ec": 3279.8,
        "0x332F93fb7708B950CcE542eC9b3d8baB567AA8C2": 3278.82,
        "0xdc7BDa7aaC7cc9731EC5D6C2a9cF2A768e062b35": 3278.1,
        "0xF09397DF1537D5A5a7Be2092005761010642F02A": 3278.1,
        "0xBF3C357528E16Ec081DE4A362eAC4A3A2E015427": 3278.1,
        "0x24C9a6464517D6Ab5880a6B5E365F375b894E0fF": 3278.1,
        "0x7389D73869941222CFd31503A996859E3df52Fa9": 3278.1,
        "0x423fC35e4515C40ABa28f978Aa768F9Ff0626A44": 3278.1,
        "0x64305a364Da1939d33DEF5bC725a868a24206a11": 3278.1,
        "0xb8b5CC4e199266b91ACe045DC20Ce54a49Dd51B0": 3278.1,
        "0xD57497aed2324517f801b5cF8269edf996907A82": 3278.1,
        "0x64bc4Ab80DC60d1256a8D74Bc02f0504961D5201": 3275.81,
        "0xEE05f233245C33150fd061F732BD213AEE0eC3c7": 3268.49,
        "0xD2eeFF73117C86c14F11A6052620848F8dD6E0c8": 3267.71,
        "0xF46D3a64d546d9Cec0883E5FbBA04583363df24c": 3266.2,
        "0x4B26c337B8441b0a537b97958A5733E438EF20d5": 3265.97,
        "0xE9E3af00D12ECfcD79C4dcc1CF7D780A6C9fE87D": 3263.32,
        "0xdE421266cfB282Aa5DB6F07Bf360998dc2dE1BAa": 3260.23,
        "0x18Ffe0eF3ab518d59E29d672FDdEF0d0131578A0": 3387.552822998584,
        "0x940627C7e1390d83EFa679dB64AF914B924ca9e2": 3254.38,
        "0xA923a9B3aA17edcA95F96a3Cb0b9F0762276a683": 3251.24,
        "0x099C327b0E090014125462aEE727351F0464a605": 3249.62,
        "0x7C50Bdd67EaA66F19c85D70aCcE4EF23a784651A": 3245.61,
        "0x41D3EEAeCE1671F26be512e53A2EC387f8Ef9764": 3245.33,
        "0x644f33e837AA372568fF11aFfFeFF72acef7189b": 3244.75,
        "0xD1Abd3DC04E60D9d2f02Fde86357dd6D7b5F7Dee": 3241.61,
        "0xe39846acdDE8c1D9D0d6c004038d6dDB18dd409F": 3238.59,
        "0x790b4512d023F85F381d29AA46C2dB30cF6a595D": 3237.73,
        "0x6ea2042CBd5398b9C2C60C6Ed06110E2505D8D64": 3233.89,
        "0x5ade40e345817B739b91c6B4615eFCE87F9D7c57": 3232.45,
        "0x64F13201FBA90630F2Ec67243f9AD7dEFbD726dc": 3232.25,
        "0x04E1163225A09172f25530f8C552F8A76808A308": 3231.78,
        "0xa95095deC7c9703ca850dCe2D9D80FFBAA270d3B": 3231.24,
        "0xB725e133780AA831d50DFD906499f9041c93C543": 3230.79,
        "0xeD18d1E55c4BBa34abdf950119964AE3A9A10e04": 3229.93,
        "0x6a2664aba79A4F026c2fe34Be983B1Da96795565": 3228.71,
        "0x4Ffc5F22770ab6046c8D66DABAe3A9CD1E7A03e7": 3227.64,
        "0xfbE0734d9707E27D2778b1F272430a4C76530227": 3223.4,
        "0xF542f223A80A9E36d4C7841041D5C37F056345E4": 3223.35,
        "0x4A58fFe3C90f150Ba64f0efB4dDeA5e9A427DaDA": 3221.99,
        "0x40750A65c95a9E9c19fe63d427B4F5338C0A6A58": 3221.48,
        "0x9DE9A9aB23e6896F637e1Ec761998Fc8e2898De3": 3221.36,
        "0x1b8Bb6988DFe267C5159c5C7E3D96fb919ab3939": 3219.9,
        "0xD9AfAc6b4D8937c1e90a35D9595c716Fd53B7a31": 3219.19,
        "0x1D656FBFF9E11e74C160D69573b936F7186c161b": 3218.8,
        "0x68383C9d4FAd7Ec6A350f5B6faF0157e987ebAD2": 3214.78,
        "0xeE2C63E67B954F86992aC8cB7096D5962218C576": 3213.23,
        "0x04e1C348Fad525d0feeaB18744480A31237ae58c": 3213.04,
        "0x7978670b3EFCe9F23b97c59cF9E8555B68a2C362": 3213.01,
        "0x6dBB667f77BE0E7Bb410305eE2C98D46d7F8D655": 3211.9,
        "0x6D7fEA7c2A257048032290A8D4A4B3f966F67c1c": 3211.76,
        "0x4aFb5daf1f6016EdE27EbB838c45a759E0A4e4c4": 3207.67,
        "0xa952501CC44063fB67CfEeC807b7baB7f785055b": 3206.67,
        "0x655DC2f8c3370358bF93DFB7666EB4fDA6fd8293": 3206.05,
        "0xE6dE92aA15277F1724fcF7Be133996EB94CF5aA7": 3204.08,
        "0xB8B28e37AfEa6988613C23C66f27B9938756300B": 3203.61,
        "0xF787A21c19a8BC4d4a72485f57759AA215Cf9C61": 3203.11,
        "0x40C26cf8CC2FF9277a274Edb01c2f00Faa092CA8": 3200.71,
        "0x2386E730fbA7D51c804579fFda151512D4b8bB5D": 3195.89,
        "0xB3FF1E9D70D0a7b4A0836Bcbb3895913CCF193c6": 3195.4,
        "0x25431341A5800759268a6aC1d3CD91C029D7d9CA": 3190.63,
        "0x1B87ABFf525cA2c907d57A679466c2318288557C": 3182.62,
        "0x5B3067C5e26fEC823d6fBf8F315e43632658D2F6": 3181.81,
        "0xF7bb96FdD8072Ec85B08E347Ef21Bf39b435FBC0": 3181.06,
        "0xe0ad5F6422687bf667D09590383FdC3C0f8aF392": 3180.61,
        "0x7cFEeC009015902A7a35B02C1dCe545470FA74A7": 3179.37,
        "0x0D2a85859a385e4E84b20b20441EA0E13eaDdaB9": 3178.54,
        "0x061E5b787a80d1dB219B56A3660480F869A58a67": 3177.99,
        "0xFDbF20fB5A9e4Db9d54788AF62f64833c449fDA7": 3177.81,
        "0xAC46dAc5c58bf33a216A0b756bfb9b3d86407f97": 3177.53,
        "0x4a7611b664c4648cCbfB42D2046922964Cd1ac13": 3175.63,
        "0xd2e36AdCf4E0A4EB8125Eb1a451B05a0360D46ae": 3175.25,
        "0x6F38CcAB98c6bC7a0Be86d6CBbfb64885474938A": 3174.33,
        "0xFA68D46E5eDbc070bD65B8Ba420cb0e6434Eba44": 3173.97,
        "0x013051b194640E617a1B72c9A01bb8477dF82b39": 3172.93,
        "0x40DE1E27377d65a2a027e11d987bfe189720B8AA": 3171.05,
        "0xD22e369bc4ebE1a0093Ba9a4325B559Ee80baF3C": 3170.43,
        "0xF4b6c8F05c6990600c06667a5A5a713D870B26Fa": 3159.8,
        "0xAA6A0e8c50Cc54c5C25bC013b0D345c1aA2F988C": 3155.05,
        "0xA8DF0d3d1abf9fD16F992Bbf4595C621935cfE0A": 3154.23,
        "0x640391A057AC728e434b413a58516f44A00F6ff5": 3152.42,
        "0xBC12D4D7e03eFb058782488Ee4411ea67aA2cAaE": 3149.64,
        "0x9C529Af39499Eec506aC31fDfA13bb299C2C2A55": 3148.94,
        "0xB61A9F7485294bE924db293369fc54c0E3b3A77b": 122979.30668878365,
        "0xB0f872407e4A5f3abF5F71D44F716018838A946b": 3144.28,
        "0x669a8b09B41f9447a4584D1b01419003E496191F": 3144.16,
        "0x55711A22d00241F0769d4d53f94F1DD29965C986": 3134.33,
        "0xB5BaEfdb365266bC864522C47321A6FD61189ff4": 3133.7,
        "0x233d45936362cdA56cC3772de90ce58372A56e8d": 3132.14,
        "0x73CA369f238Fe1902660870F4A0222538BB1A29d": 3126.75,
        "0x432a123603402E743F116e465aCA31645F2aE663": 3124.5,
        "0xD221725c9dA92BACeF260c2283c5D1BA347AF6A6": 3123.23,
        "0xc497a4A1655dA235E69f6c32b7B8A2e59172f86D": 3121.33,
        "0xEbfceD2B9ca169D2Ca566E1F72A75A9B6cc9291d": 3119.09,
        "0xe955De8deB67849BCF2468B05CA65733A29d59b2": 3118.31,
        "0x2B9E3e3bCAa160fBE43c2666FC0015D77D7eD656": 3117.38,
        "0x5A27206A4c53B6F339c7E795eacE9Efc5840b852": 3116.64,
        "0xBecCca982afE71f6fFF1041a26875E1228172f53": 3116.05,
        "0x0738f2a25e59bB9178aCea620935Ef8895b71c3d": 3114.34,
        "0x39198C2D81E3a4eD4C68b122b4591aadA955c1E8": 3108.63,
        "0xeE3a71b63ff19154829f39921677375F76E0Bf19": 3107.56,
        "0x79B1329B1fA00FAdd60238f71D43b4dbC8BfAAA6": 3107.3,
        "0x45232d48033B129571062fB05222ef456353253e": 3102.87,
        "0x4526EaE4C76cdFb03dee54916EA55F0dDF0C587B": 3100.92,
        "0xd424190d519E527ac3c76e55E7A8108ea9047A4E": 3099.94,
        "0x2eCa2bEfAAB783e5100e324bFC4DEe30c41fb7f9": 3096.82,
        "0x2a549e5f473212829d4000305f27529C1Ccbab9A": 3096.2,
        "0x78e959F6297471085D5b269DD13D8AD7A7A65e2f": 3095.09,
        "0xCEc03755ef910b3d253EC83C4b1B48cf3D03F936": 3094.63,
        "0x10ba44DF917fbbc67F3B5E7fD6320707b66000A6": 3091.43,
        "0xA7ff0bC6F74fc6C49ccbA87F3df51b1adf98543D": 3089.42,
        "0xbc83501a04709f5D69d7c69Fd154144bDdC968F4": 3087.85,
        "0x7a3a4450Af3f2322d513fAAF687b4dC8F43C5392": 3087.77,
        "0x6b6E87c037Aa8C3A50A5010d8704bc5Ea5C3d3AD": 3086.76,
        "0xaC11471c67ABd328f52F544819d5Db2ac8F03AAc": 3086.55,
        "0x5bd3bC9a46BAF9fd5d3aa1c0B96Aa830BbC23D92": 3086.39,
        "0xaD357CA4946F1DE05da78D553Dc21CB3B7a18DEE": 3081.41,
        "0x75D91110a6BA07FBd0866D3575C8490eBE192533": 3081.3,
        "0x4Be80A823e619Ef57A61cc19B6bfB72974dF0604": 99168.0266196142,
        "0xC96A45A0EB1eC12baF4E147C29b7B3162256aC2d": 3079.88,
        "0x2b26dA567C2A8c220daF91be8E37A429D33AEF0B": 3077.78,
        "0x89AFf30aCd8450Ca6b277ffa3AF677dcE38e6595": 3071.73,
        "0x0cfbc081feEb774Da9268c63E3376ca6879a4aB6": 3068.75,
        "0xD57b8277A9A75471C7f49a6B935FD1187C07ddee": 3068.58,
        "0x25e1AC8a979dd59FA3fCA8cBEd54e95754d48e94": 3067.62,
        "0x096F92F264FAF13643d887f9d556F13813A5a97a": 3064.94,
        "0x702D6DeF95d59E31ebA8420372821c2E49F2D607": 3061.65,
        "0x8E272A668a5733Fe64Ec156Cc07382A7c0Ccd229": 3060.95,
        "0x40419b043125675d85beF9Bc5AD1D310CcF489A6": 3057.04,
        "0x5f0c4CfaD44376754E7E3d1cC40455b2CE6E5B42": 3053.18,
        "0x7B8870DB91a1cF8e5618010ed2cE0ED0383e22fe": 3052.35,
        "0xC21A2D43C8DFE50741FC4C31439c64ec649a3c1c": 3050.13,
        "0x0908eB2b786f08506bFeE3A23f188fF710F8B8cB": 3046.44,
        "0x25f290C3C43A34c56FeDBe16a29FAFE3b21A1d0B": 3045.53,
        "0x582c34536D7f4A2A5d96118D5D80Ba3000c6B5aF": 3042.51,
        "0xc1a20f982fA5f8a3d28B2CB35f1D87E9DfC4799d": 3042.33,
        "0xc4dA9D0fb9dCC52680b7Ede6348376fE3505ECF8": 3036.85,
        "0xbe12e889a5Af67b12369C5610187a18C0A43dcE0": 3036.46,
        "0x69C1a51711B061E5935c648beb16e349898B17dF": 3033.94,
        "0x728839A19F65a4FDf096373D1490A7f249FfE9e7": 3028.45,
        "0xc8db72EA17Eeec2223c05F04efd63a86F52f0271": 3024.22,
        "0xd2d6b893E67100c72cFc0323A5EdaC056Bf1771B": 3019.55,
        "0x4Ccfdec256DBdc605E713E695f9126da823250b5": 3015.43,
        "0xDfCeCf71eb54931b8475A6B8da714A23c002fB3B": 3012.8,
        "0x2efba4Ccd1AEe02c9f37467Ac281465d688e6469": 3012.78,
        "0x4Ff254719c0f257102F79D6332C3BA4a4A76B1F3": 3011.18,
        "0xD058E7bCa54603e46b1128078Fb92c31953cf029": 3008.75,
        "0xf060c763d00642A877c7E2812D27327619881B14": 3006.66,
        "0x01A658Bf766c9F8CA9CE7160C2ABa369D0F42038": 3004.01,
        "0x471f6991Aee06Fd49D074D19F30Cb62Bd1C77325": 3003.71,
        "0x35b371D0F47F397176866FA94BFd4Fca5b89Ae10": 3001.7,
        "0xC53539fd4D109840dBFe8c759Ba7fc2E7200709B": 3000.45,
        "0xCe1f84c0B61db808A1F307Df8bc9853Ed89d679D": 3000.24,
        "0x4EbcDf46a45f551Cf40f69e2C43Db2779cD1f29F": 25104.866954287325,
        "0x1F20f433a1D29dF807b9A32eC5eE0e65DDf68875": 2998.45,
        "0x61BE4048c631954a8adB3A7088b17ED8D9C2A33A": 2998.45,
        "0x537D6a90650164750492509eEE0d646CbB7e99f4": 2998.45,
        "0x6aF66572c3AB134275076C35eB461c4BC6Be3c14": 2995.67,
        "0xE1364fF1100B2136c92502701AbD35A2D421BF66": 2994.6,
        "0x53F6ff4E35B48d0163CE67BEA5aF5A04cce55669": 2994.02,
        "0xfa4feB38bB8004C97dfF2711BFe26433b58EAeCB": 2992.33,
        "0x32292362aA495B790ce2876097AC78bA8994A4D7": 2983.74,
        "0x7E54Ea0bE74f756D70554C39E2AaFbaB4d883a84": 2980.71,
        "0x979E20fB470eA8919589FdAE041CdbE86F745302": 2977.99,
        "0xd9623C49bAaa0eaF24B59B650A7573cC5bA3620F": 2976.4,
        "0x8001f2eceB2FA4808C9e715cFa803Cfb07d2Cff9": 2975.19,
        "0x095E4f9aA7a13Ba91362FCE68B13098418e63C39": 2966.38,
        "0x27D5235930eaAe1f0882A9E6b2832bD5dE1eCd90": 2964.97,
        "0xBAFeEF7ad78BC2Ec4EE5B2938a4396c0D6bEC231": 2964.16,
        "0xd47a0Ada4D17a6e36D9779Ffb27FE4C211565b2e": 2962.04,
        "0xeFe2f31b936e587ab134f409564DD8647DD1871d": 2960.87,
        "0x1aB2128Cf93aE92E30B2aA5C135D552DA68c9E18": 2956.35,
        "0x617c6B678529726541EcB4d406373c7bF7889e37": 2951.36,
        "0xBE327e59537b0A2152545E9f01807370b916F0d9": 2950.9,
        "0xF0b9Aa2a5B8e6Ce7B18b3C832CeC1d742848F115": 2950.09,
        "0x28e614Cc484e01E1D890C631D49aa74eEA0760e5": 2949.99,
        "0xf113770174205B006e1A04929eCCCdD9c3221B61": 2949.81,
        "0x704CA6D0E408a2ecF838B0c98629626F88318CC9": 2946.19,
        "0x24336E1C08350C2CA581A617904fD9F8444A103D": 2943.38,
        "0x32ADc8cafe2D3245B16538be757088D901c50b32": 3020.5274577415944,
        "0xa904a0F8b4F0292785AD610dae1084a916142a77": 2938.72,
        "0x8AA9c34C1045C3f024066577FfB8349b1d44323F": 2938.72,
        "0x627E70D368E4a4193116f78f0aF94030Ca14c9cb": 2931.41,
        "0xaDE454CECF7dd8A94F5C49b434A0179d3FC28db2": 2929.48,
        "0x8a97b22a9036BFaBC85c90890bAa41ab9C76d406": 2926.3,
        "0x0eC9eFC8C5305978Cb957c74b228D4949F5e9DD0": 2924.4,
        "0x03A376468888cee39Fa23C234201Ba704992e030": 2917.06,
        "0xDFE7ad3E0cc6fb0798e66C67C72927C49fc42478": 2914.54,
        "0x3bD9fDDc2a4559Af3c10396683735052fF0B34fD": 2912.84,
        "0xD96BC065C8adc908562Fc85882da2f21111bF21c": 2911.58,
        "0x431338A91fa78659E8AAbc41A83Be37ED41cf9be": 2911.16,
        "0x8fa8e69D0651745d0F85e9Dd7bC73aEb43e799fE": 2910.05,
        "0x9BbECf2f81482A4F5245f2B8166e50493556B3dF": 2909.19,
        "0x60BC5E0440C867eEb4CbcE84bB1123fad2b262B1": 2907.04,
        "0x830Fa196884EC0f3D90e3b475eaC35a0A8a7af46": 2906.53,
        "0x9F141A20aFB661B51CFfEFfd82409746A1113a7C": 2898.37,
        "0x84572C31ACdd30c03982e27b809D30b1eFbCD8f2": 2896.4,
        "0x26f2C5e809EDD9Fa2Bf04f8d72990f70E0484727": 2894.95,
        "0x09C16E1480C4fcFEd2B86357859C90D5A5E47C85": 2891.56,
        "0xdACFbAD33bF51FBCca4688b6D6dFdB77c509a889": 2889.11,
        "0xB1295a038A00b48c72Ce73fCD1CC8b50F139B069": 2888.01,
        "0xb6Af05cc20DC1Cd95c697533Ff96f00671104E53": 2887.35,
        "0x885a8Bd0AED00e5a042E7BB788fa56c9e0fee5a4": 2883.95,
        "0xfc2D2CcA7b97658cb35b202715B3b02295BFa4Ab": 2883.32,
        "0xCc1657B217640c7cD8FD7168987BAf4dbE82d72A": 2883.32,
        "0x836A017Cd77253b856FcFeA110327fBAb5b5DA34": 2882.15,
        "0x760eF2400C8e36Fe1CEb6b9377eDf1aadE482a2d": 2881.57,
        "0x6BD0e32a7631688d78a3dAC24A3721601D3be287": 2879.72,
        "0x0C41894f31E892889ca2Dd7EfB57B0D8aA90b481": 2878.41,
        "0x9E8048B40DfaDa81b1902d21db3B45159B567b9f": 2876.06,
        "0x3a5E41C24d8d5A512690b553521084564059aB06": 2868.18,
        "0x9247E4f5F0340fdc13ffB64f68C71b796ae7BAb3": 2868.08,
        "0x8590c041F873486D5A2728AFB24BFF89Fa99E7ca": 2867.03,
        "0x34cb6faFEC2a99BC1D5CBff435dbb5A9358C82fA": 2864.22,
        "0x78A035920b855985d1874b3b6d213568d8dF958B": 2856.51,
        "0xba181DeB98AfC2202202C9AeBf26B18f46D70497": 2856.16,
        "0x088400891D3D66D91cF6E6FD0F2e1FC392aB29a7": 2855.79,
        "0xdF982320791aEE9ef491505d9e66b9CcAcE57d4b": 2853.16,
        "0x2dcF502e3Fa230Ce082891f0915F7b2c587d6b54": 2852.14,
        "0x4EFcF4f4925b4A7b3a6153Ee7bb6a3777cFeb58e": 2851.59,
        "0x510B0068C0756bBEFCBaffB6567e467d661291FE": 2848.04,
        "0xBCbeAc56eeF250E8a4859be46c6cBFd93aAe5d2F": 2845.02,
        "0x99A12829E47453BE9104eF2f1C765D7D40A0cFe4": 2844.96,
        "0x7547500Ddd87694E2af902069B699Ca331A1B096": 2843.64,
        "0x83090029C7F7C50B2c365648161C2F9C36bc58BD": 2837.9,
        "0x90F15E09B8Fb5BC080B968170C638920Db3A3446": 2835.95,
        "0xE87c09608c6306cB72977ddf65BcBC8200Cc9A96": 2835.95,
        "0x3BeBDc48E75DE9188e8eC1ca787096B091298Be0": 2835.85,
        "0x20949283032574D4cE987E42F1d1A3D79a5C6D99": 2834.98,
        "0xC764f60FaF30bE89C3D41ef0f44e8E8bF1204A12": 2833.75,
        "0x7CB158D3afE100D7bb4933CB5B4C5b16F5eF937B": 2831.2,
        "0x7F610b6B1306Fda1C53db908568Ff3414fD14e3c": 2827.73,
        "0x085c762A4c3a76E552AFe25421CC388B31dF3Dcb": 2827.15,
        "0xC5bD19f89263Ad5D3A08bdf0Ac4474B0F46142Ad": 2826.62,
        "0x7234ee53a74Ec3571CE3DaC4f35017dF19537a80": 2819.39,
        "0x47d743ae7eD55B0aACBDB8Adc9B9dab326674482": 2813.83,
        "0xf2CF9B1F65Ae3Df9647faFd9651c33d02FfA9f41": 2813.17,
        "0x385269696F8aD66Fa463b25eCB59b236763B53C1": 2805.04,
        "0x1DB06b00AA8F9d1fA27eD26AEc0F64b422a96a26": 2803.43,
        "0x9De736b671f842B2f84BD12F10dE1066C765eea5": 2803.29,
        "0xbEB637262a1A0C3C89510bFCc72dDea181f29fb3": 29726.829377697824,
        "0x3c112E20141B65041C252a68a611EF145f58B7bc": 2801.18,
        "0x7dA08FBa7A69c67c0D06fD433aF0C53F9c75CeE8": 2798.67,
        "0x0fF008490B88d25BD7631C8401346525689DD4F9": 2784.06,
        "0xf9Aa0DA6e2fa01a17e2F69e878E45BB26C1b34b7": 2782.79,
        "0xD48a206697ba7DD8641F97060b2ac74a252Be092": 2781.54,
        "0x50fa50Fa2032d85EB2Dda303929bF56886aA9AFB": 2779.42,
        "0x011d88c76d5CB8fb6A1F2aa9fF2bAd220894C7A7": 2777.54,
        "0xCCd6A4396dC5F911e3a2BaE27B2f0Fc21F3C9A92": 2777.04,
        "0x5C95675EFf8332a5E94Ec52261c320316Fb46409": 2773.22,
        "0xB2817Ed45f3a24962634A31d18a72022787a6c99": 2771.76,
        "0xa46C8bcaA1a5d3a7c0822a09FFE593399a1De80F": 2770.45,
        "0x3fE72d3829fece36f2DAd30e839f98594b161Af3": 2768.76,
        "0x6762F92BB957baFE636D179bd88bd9aCE61ABDf0": 2767.51,
        "0x5d4B821e5919AA9923e8c09DFA6CED9220488108": 2765.29,
        "0x098dDb5F48AD1DAA5f691c4b2AD6360e45a22747": 2764.75,
        "0xb0FabE3bCAC50F065DBF68C0B271118DDC005402": 2764.25,
        "0x9ceAd55d1b4f331C9A651015F9a5Ef19879d93AC": 2760.01,
        "0xf6eD81D5E9F61dd1eA21E96Ae1D660ECc388AE4F": 2757.35,
        "0xda9aD6284300b15bC802C3fBF6dbBDf7CeB27Fe8": 2750.14,
        "0x87e8B44E570F828b884169Fb6Fd2EAf6d8d693b6": 2749.84,
        "0x8B9742136AEBF377c956887aeeBa20471Ae4FC56": 2744.83,
        "0xf33F050231c4d4Bd77Cbbfe127b71a021C04bB19": 2744.76,
        "0x3DC7634072998c6dF8AB0A38b1Ca0807b57c4EFd": 2741.83,
        "0x586E6B7fC3a95C82Dd7D92FE93AD60E91C57E8F9": 2737.41,
        "0x0C0edF4eD612537e350777ED97255572627b6f76": 31955.77761360474,
        "0xbEa0e9e5AD10cb71e325F6E6bEdb0b6Da2d79473": 2733.86,
        "0x8ED761E6Bb29820a9A70896aecEFA4cb99898FE2": 2733.7,
        "0x48651EB2808F5C370A914899c576848bC43264a6": 2733.68,
        "0x697fBdcD1b3526B2391ff4291F6E8d280e259A53": 2733.58,
        "0x745cE001AE89310cc76Fb5e959A0daEF4Adf62f3": 2732.26,
        "0x88827aB31fA4A0833c2479d6cE882b95E3808A2D": 2731.18,
        "0x978079796e68a3a2F2a02599543f8471590d55FF": 2730.95,
        "0x125DaDB11BB7d0C6e947bDC67292dE4d032A30a5": 2727.03,
        "0xD263550633C52970E4E50aD76A091cC4bcfA2115": 2726.87,
        "0x724d55DA096372F9FF0fbb65EE0d701Ea6a8A1aA": 2720.77,
        "0x189ecEbfa5D3c5EA82d5172b1069c3305a0a149A": 2718.06,
        "0x20c9C43cD709ed4Df0c621C1130Edf7AC002C51c": 2717.73,
        "0xdD853ced1d922e3146Be5f4Cc8857895537a9aDd": 2714.53,
        "0x1Fa8825907226557A1A0FE1f0A2cD6738Ec37038": 2712.03,
        "0x4d28D9893821Cd060639Ee99642978cbC1F8D52F": 2709.49,
        "0x28A0A8fa1973Bf3c662617859b06f2331db5D216": 2699.28,
        "0x159c89560a17fF20A7d27A703cFd120c91557970": 2698.84,
        "0x6f0D2F06aE622B2047d7Af6F82460e332913257c": 2698.4,
        "0x6fE797a05359C9d91B1F85D418e2ED4Ea6C65a8f": 2696.88,
        "0x0429ea48A773eA506Edd69a6dBc9Ce5a37Ae9dfA": 2693.82,
        "0x8ba9cdFe844B6cD61c2E805ee3a25E9e9580611E": 2693.33,
        "0xe02E2e88f9a26df4527e9dBDA3972854392249A7": 2690.96,
        "0x204210c108A2117bC43D5D46737a7Eb9a40C5E9E": 2689.84,
        "0x5F29DFd0E96b9BDD898f26f0B2176975f9057F29": 2689.27,
        "0x80f7576F5f58192F59810c6A0104100D90B8eb4e": 2688.53,
        "0x263397A2559b0BD4E0eF2c7D4195a53F0ca58b9E": 2685.58,
        "0xb919caB8962c5e6d8CC0483661819a44a8FF98e6": 2683.83,
        "0x305B9cC345Ce267d4D854509425ECc54a5919c58": 2677.85,
        "0xD50ee5689cF0d5CB494cECfef44C047e9C379A9b": 2676.84,
        "0x3AF82Cbb895B42D8e9fBEb6bf9D23956397CB4eA": 2672.73,
        "0xF9b7850ee758Ca9878A052AEeD04f24A50531ea1": 2671.97,
        "0x12c07d0862761660685385327d8487b887113691": 2669.44,
        "0x2b43d40423B2b728Ed90F6C1E188377429e1950A": 2668.63,
        "0x7eA63fD4cA570412275d6386Ae0d40A66629B1F5": 2667.67,
        "0xDfbb4C78A02DC253597189D3F8189b8F873CbEc5": 2666.47,
        "0x402D47C7Ac0f735af1b29007350533543238aE1a": 2663.54,
        "0xc0810D9310C7a21D31bb9043cF7be01dD2A7A5cB": 2663.26,
        "0x8Fc27ad7FcA175ee10e425f45E05bBc8B1f9309F": 2661.63,
        "0x9665224A631B275D5ceFC08E5705767237f5887c": 2661.63,
        "0x1f4B60762987ee983AF168BeA5326965dAAa2642": 2658.1,
        "0xF2E5c357502c97CE82c6929A741bbADC85962521": 2657.5,
        "0xA78d7C58d8654618874e48942C5b1a62d1477CaC": 2652.56,
        "0x4F55E6B3eB76b90226d9670293b161cF8f54E138": 2652.28,
        "0x6DDe4765973a30fc327090FD15B9734C61FD5a63": 2651.21,
        "0x71Ede44fb370CDEF1fc0CB2EB32b16f08E6A1330": 2651.17,
        "0x88A003Bc7fD53B5Be7f71806aEA1fa967989DBc9": 2647.74,
        "0x2599721962F876b70Ce229085a190aBFaf0627fA": 2647.59,
        "0x47750B27B22c2733996b9b5e41762170D9c0a81D": 2646.56,
        "0xE7b27BD74F522afa05732ba82B2F46A38D4Be098": 2646.51,
        "0xC7F17706608f16222396a9bC36b6068A17D5F4b8": 2645.63,
        "0xBF0Df2fAC471CA9e993D628fd4E345925DfbEa6A": 2644.52,
        "0xBcC67420D7d76bf0FE11122643b54af139A097a6": 2642.62,
        "0xfFC606240cF45cFa02C19C46477B09C5303Da09E": 2641.25,
        "0xbdF81b19af7848F7384c38E68208885ff0C9F390": 2638.49,
        "0xD1c5F5A670612EBd01B6cae01E1F755Ad948Bf70": 2638.32,
        "0xbD93D26303aE0a6dE3b9F483384712bA7f14B349": 2637.38,
        "0xbB23a64414984109D40B4d2155764b778af113Ea": 2634.99,
        "0x58eB2e2c5a3ccc592dcAaa6D12bf09524FEc06C8": 2633.75,
        "0x5b2F19989eCb5c585C888a49a1c2a139771Ee403": 2631.44,
        "0x9DE70975E846E3D79Bda29D1c6Ca2c7F9c7B1646": 2627.35,
        "0xf06cc31757760CC9B8235C868ED90789f9c1E883": 2626.87,
        "0x067DFD94ADa3101945c31abA659cE09245a3C61B": 2625.38,
        "0x9883D081bAC57a0C3dd238910b43817c0aBABc55": 2623.08,
        "0x91f568F18fe3EA8eDC3cdF59706e2CABBF11c0B6": 2623.08,
        "0xD418555Fd342e6444814Ad7C5b8415A2193b4239": 2623.03,
        "0x5eb8DFDD34838F298BE8f251988E4942d950d2FD": 2621.83,
        "0x053387E8A893525aC9BAd308d782229FCC2305BE": 2620.09,
        "0xa8fd664477f82Ea55758E3e5C4f21e72560c1701": 2615.47,
        "0x9E14F3b50eE1518d32259484d7B3AB1bf5Ec30C9": 2615.33,
        "0xDFaB977372A039e78839687b8c359465f0f17532": 2613.26,
        "0x07996022C506D97Af64EC4eE0E40CF0B019464e7": 2613.16,
        "0x6C8DEad29A3ED840dAC654e1a505045386bc528F": 2609.66,
        "0x03b40D7Aaf7817Af010f6Cc884F0236517c05926": 2608.53,
        "0xe552A7D2E34Cab76BAa43D485C6B89D8DC10d04b": 2605.81,
        "0x1dE8cE7eed223195ba65472BB65E68392A644eb1": 2605.55,
        "0x892176D784bed3Dc877A62f3Ff9FC091377B2a49": 2604.19,
        "0x29A62bD2a778F5867bA175aB1fCA2694c0BF0A86": 2601.86,
        "0xfBD2a35029d4fb42F02E223ED2f25b73875A314f": 2601.02,
        "0xf97421335A3928D03Ab77Ed680B507843D9Bf334": 2599.32,
        "0x14Ce464E69aF9592Ea119CD9E574d079a78638FA": 2598.65,
        "0x9faA9D3FdBF962d8Ce187575e68a44CD858dcba8": 2596.13,
        "0x85D4Fb97F51b7382aE507D76D4C8a48F23fe80e6": 2593.28,
        "0x4De25b03475056B342CEFb2BeeB85c639160DD6E": 2592.56,
        "0x2369682E0A3e5bd81cC3f4EaaBa247bdCa266260": 2591.1,
        "0x61c8478478e612a8578D891051e08fBd590122A0": 2588.16,
        "0x7aE65265E0378D6728dC71b650b83B3a67cf1772": 2586.65,
        "0x5003d5535766Da0d082e9927F96555D7A355Ac0C": 2583.21,
        "0x69fc882A9eC5C391B87167A0E7A000a8720B206E": 2582.75,
        "0x39085F49C36f3C44E3821606b9d9e542faFaaA20": 2578.81,
        "0xB29177F64a586A074660257dD1ffb9500de9ba80": 2576.41,
        "0x42932a3cb32a8E731Bc03C0148321A1fc59Ea88e": 2576.34,
        "0x7Ec84099E261efEc1F35aa0579CFbae42345ea67": 2573.89,
        "0x42d48B1abd560A21B33Ea6a2051900A915428Bcf": 2572,
        "0xce245A48C85F7cbf9dd6cBBC91EfeC33D315E05a": 2568.7,
        "0xfB67a6a59609662330171f63142c7259f241f346": 2561.99,
        "0xE91b124f2C4487aE89fCC16023c39247B053598C": 2560.42,
        "0xbfc7E3604c3bb518a4A15f8CeEAF06eD48Ac0De2": 2556.84,
        "0x87C34D79Eb748577A58F86193E312E463a10f592": 2551.22,
        "0x9dca1574a3F3f617374E7872D8Fb6e8013d7aA34": 2549.28,
        "0x68D2aed8B955D4DC6EA7c24789C84418B1DDb65a": 2547.65,
        "0x5DadB2e88cF9cC2B6f53b5e7413ebFa1a7D740a1": 2546.75,
        "0x6fa048075029873264CeE7d1362d7538622A1D9d": 2544.59,
        "0x7392397198eA9503CEb938f7C44C7992a7FA5235": 2541.48,
        "0xf341c76D256D4fA386A685090Ec86F534B769678": 2534.67,
        "0x8baEe34bfb06652ef6668AdEC015eEb96e2A6c9D": 2534.32,
        "0x599B29809Bc7c401a19c09a3F90daA2eDe14BbA0": 2526.2,
        "0x8a48dcAFFDf71C547cD0Fd0434ae40fA57bCBF0f": 2525.1,
        "0x739993895502E48dBB3399e5522d9Aa2FC191fA7": 2523.9,
        "0x74B29bED05623CbE43FEaF22F3B862c800640c77": 2523.37,
        "0x65c46Dd24A5B27cC645D6E6c11105bcBc0bd6Dfe": 2522.33,
        "0x66bcbc4b7529F737F8814c5F37f3537C1d8B5C07": 2522.07,
        "0x3C93a2Ff9000aa7920635D5421FC67f67f8974a3": 2518.35,
        "0x7D374fe73fD8358a93c53e978477F7Ba4129BE0C": 2518.04,
        "0x114A180971cB59AB6B19B3ac2e82160D2777eaD8": 2516.91,
        "0x7E4e4D066C6D9b23D7813623A93dc5f3EA227C02": 2515.43,
        "0x97BeE47A9Fec3ECA5892171EC2B7C6584b8D57F6": 2513.86,
        "0x7a84A0361F4D2a5DC3d042Cc8769547ac97A5f11": 2512.29,
        "0xAE2586E76C8A4D8DC1FF3d9AB70bEc760ae143c2": 2510.99,
        "0x2AD7F82d4266d47E875aE2B06322F2e008cbF5c6": 2510.49,
        "0x838024CC3a0f2D63B5badAa4D4cE9846E67F03B2": 2509.35,
        "0x8cEF80A3E763E61Ec28B48B315797D921567F139": 2508.74,
        "0x684c350D9A0569A07454D778134f04406315a5b8": 2503.21,
        "0x413ca384e93e8938d865d29D2d346f9618364661": 2502.73,
        "0x2bBF56F0C36366AC39063e7Dc4636238a6b009F4": 2502.44,
        "0x817076e023d37e3728cb3800336C36E8E035C23D": 2498.37,
        "0x7Eab3376BF360194052411D89577fC80101A4fC0": 2495.88,
        "0xF82ce7B9692a32C27FE5477b6C85F163f2920eEA": 2494.19,
        "0xFd8ee539D211e47C1D9aA94e61D817be0e17a4cc": 31572.88611382558,
        "0x9F587Eb49349aaa78811f125DdA92944f524EB47": 2491.84,
        "0x61249460FA75F5ddFC9565c892cF1b956ad1D955": 2490.67,
        "0xF9e2531330b55153F86D3c465B582c3Fdf4c9D33": 2490.38,
        "0x95147C462f6d2511Af71FB19245790Cfb489243e": 2483.09,
        "0xA84fE466486223FA9BbA2dD3ecFb5C1100311711": 2480.06,
        "0x043cBB270577b9Bb2469751aDA88Fefc73d40fC9": 2478.33,
        "0xA0B6253d7787Ae282749B71fd4EF5D5c9D8A9e87": 2477.74,
        "0xaA970e6bD6E187492f8327e514c9E8c36c81f11E": 2477.45,
        "0xc14488c1d672bDfDb93F5f1ecA3697Bf2f904d93": 2474.56,
        "0xEa53ec04b8c2f5E34e890DdB5aCA821A9f92ee79": 2471.23,
        "0x4D32190b321cB49312bA1F80466E3628ed45B545": 2470.53,
        "0xaeC854073412C2a81581e4fa536205d1843D4455": 2470.4,
        "0xB7e48ef3d10825520d5C8AeE20e8517E3B9C22FC": 2469.6,
        "0xa252E920a7A4e11Ff24Aa41abE83B86dD7FD4b1D": 2469.25,
        "0x315Fd50A2eb3793b2444B598Ec8443C9746C6559": 2467.16,
        "0x8f2261C1E8D1740DdCB9CE63E31864F48b6F1551": 2459.78,
        "0x22B3a7F8beb2Ac510fc168DDb2E4efBf8dd1587D": 2459,
        "0xb61eb94aAB1191170aA2654864D5b29151b58efd": 2453.76,
        "0x544BED8c7378a0da0602B786926E708f8d001356": 2452.79,
        "0xdE79B2ED97516e5659F1ecd548dd08Ded68e37a2": 2448.78,
        "0x0a653bd08E2B0A80d1D212d33032953Db8298efd": 2443.48,
        "0x929b67DaFF3787CEf9061eCd474FbBEEBBFa8311": 2442.89,
        "0xBF404B6728094A9F0980f2311aD942b57FD5afF8": 2441.2,
        "0x80933f85bD8a1edaA8E555CE4a19d76FeE566DD9": 2440.87,
        "0x20510633Df5216a6047A63F3c726ad116621eeeF": 2436.79,
        "0x80D0a5afbE2ea62aa32f9a30f1ed22231D3d004B": 2434.25,
        "0x7fAb7299CCCa55C585DD9C3A535B371aC5FfCF99": 2431.95,
        "0x3011C65a87AfeEC0CEAfcA52E08fDa25c6EEAAC9": 2430.88,
        "0xeb126694dEa1f85e4025b8308af6E5e4f9B5eF47": 2430.74,
        "0x32515FE513DcAB8ea9287Bf38b1373C0A9A858E7": 2430.26,
        "0x7584e6794E8610F03F0d7FCBc827a5A9Af4E5005": 2427.7,
        "0x7cDdC259A5ad558D4538E90b0FF71E9c0bc4544b": 2425.25,
        "0xE63f6D6D26C053c05303E1437A46D0bc6af004e6": 2425.18,
        "0xC97A9221221Aae7Fc815AeaE1480079F59c833AD": 2416.27,
        "0xFF53E3A27b7252148E0F1DAF4A00261eEe59177F": 2416.24,
        "0x467E3EC16e259da01BB915CeAaEdA6ed9Dd35fC5": 2412.56,
        "0xbaE3b46e29E7CfD2BBA8164765D592CE9802ec70": 2410.23,
        "0xf902b504e231f5FFa57D9a321cF89249404e42A7": 2409.53,
        "0x1125917201ed36700F86c3CecEC8C5DAfAe280D1": 2406.2,
        "0x1d9f7973c467A046C7BfD5Eb62d7eF6ce5014601": 2406.14,
        "0x41C04996C6EcCa266e24d4C82BA4D9AD42483aF4": 3009.4192639760176,
        "0xbf804c154535DF9B75F6C8532B0A8B488C1F0cFc": 2404.18,
        "0xF7a1971Dd91f2aA93d28fA2C33232B97B195CB98": 2402.27,
        "0x03926DFaB7c0F6773f061b3d361BBD01A6Ffc7d6": 2401.57,
        "0x7a09E2a465bC7a63CcB39Bd151e73B2c1D05550A": 2398.85,
        "0xBA53f52503E5eCBCBFd316ac0543351E222c92Eb": 2395.59,
        "0xc330628E6f79B1575CF0640A089D9B9f0B0c2524": 2394.47,
        "0x5863d77A0CeeAc7F72aDd8b54f8c71EABb78dA4C": 2393.09,
        "0x6dceFd396A949a75B3a646B608EDDC7c325b818D": 2387.93,
        "0xEce1A6E8FdB5490924ed3952d3e8Da73fC455051": 2384.68,
        "0x328d75A47E07F26e1Ad22fF3DE08E8ba3ca190d4": 2381.51,
        "0x3220A38173ddA4d0a1A43DC2307e0fA107e9b8da": 2381.07,
        "0x8623A9c6ED3CA5e8b50BCaa74334501fDbE63BC7": 2379.62,
        "0x98Be2f963343fa37b324070984Ffd72b0460eDbE": 2378.93,
        "0xe23AEC0E68f1D0c039f5587e215F649EA8c3DB33": 2378.25,
        "0xC2FEC534c461c45533e142f724d0e3930650929c": 2376.47,
        "0x89B974c8108eb81F5974ca2FA9468b7ef74978c1": 2374.94,
        "0x3D163F1789d0Fe2ab2083e0E774280fE5B0C94B7": 2374.26,
        "0xe1229d82c0A19BC52986C9b75cb9B2084D13d903": 2373.17,
        "0xa270d2222d62500d2821f0c5dD2BC4fE4d497F08": 2370.91,
        "0xf78eDB581843f40060B80af21659E8732B9b55dE": 2367.97,
        "0x8C131a44f14f8c87223DAe308077BabB77C049b1": 2367.91,
        "0x98F2Ee436C11A8cC75E3f63E7c02989fA4af1976": 2364.7,
        "0x98dbaaECC33738A78CD2155A8B5D63cFD17FF34D": 2364.02,
        "0x726FFcFA3afBeCB2390FbA479CfCe1ddd410a30F": 2362.75,
        "0xF99228d6CC780d4B375835E80850Fe5D8bD642C7": 2361.27,
        "0x2758F6929c3A480B4405799297C9825C663C92B5": 2360.5,
        "0x7bFa6949194EF2E96928E2720eD77039951b2c8f": 2360.07,
        "0xbC2C3bd6E01a5677AE03798b68Fb979d0Da645C3": 2357.99,
        "0x1160D22299E7e0E75B4f267099c00C679a20FFC6": 2351.98,
        "0xf5670eA8317e037d6FE14A4cD3c6c383Ed2ff3E9": 2350.27,
        "0x524f1961347f1bA25B4DEce4770a87ABaed8662A": 2349.88,
        "0xfe91BE8Cab36B1F41E9810Ae777563B203f1734a": 2349.18,
        "0xc02434690fb0C6c9d300737B88FF547011AfC5A0": 2348.35,
        "0x670239328138620f1b539f390d5E30a6b85620aD": 2347.46,
        "0x9e4748FEF62d2cD4f16bDa3893E477616609DB37": 2346.24,
        "0x4F1D8351CA1e07d71111156166ce39220eE2d15e": 2345.24,
        "0x7bD614d21f7533AB4795fD134bF2B7c2640B91Ec": 2344.82,
        "0x869A6A81aAccc55016157b6a4ce53B301dE88F60": 2342.63,
        "0x2c8dBCEbDc218F0F4E39C868a01c6C9A857AA5bB": 2335.66,
        "0x3aEE292f34F1c096E8d8E7899C56BF3C2817A2f3": 2333.94,
        "0x0c8BCeE012161Fa3356F4D612CBa9CF55888bE9A": 2333.11,
        "0x10d1f44470d966735F72C223c58E4D9b8Fbdb006": 2330.02,
        "0xa518A4F0063732795E74F405a8d9624DfFA149d1": 2328.8,
        "0xe59355353F7e2eDF82fB58f3EfCF096e1aB0F72F": 2328.61,
        "0x24fF1aD28b33dBa8Ea2CE84B47C093a184dCB96a": 2326.68,
        "0xCE76E10B764de934d09883598B329498Fe72D9e5": 2326.59,
        "0x7771DC35197cD4D795aF226b42648D771212DDe4": 2324.14,
        "0xb0B2507065b621fb92647950C2bEeC69Ec032cC4": 2324.13,
        "0x94d50de6dC4041fdaF5b0F1586885b491d93EF16": 2322.36,
        "0x7938521a3F065A27FE62E0D40b0eDa7C09d8B4c0": 2320.63,
        "0xB6286600725C98A1A6B2eAb10280af125a241AB4": 2318.27,
        "0xC441fCd2E080A01F451b63e9b6BA4b524C5E1d58": 2316.29,
        "0xA723d3150DDeEBa7859B25c93aC0dc4B040403fF": 2314.64,
        "0x2a6c9b295147f7f61927428065aBb21ec9aEAC3b": 2313.41,
        "0xbE93d14C5dEFb8F41aF8FB092F58e3C71C712b85": 2312.71,
        "0x2F66b8499b673F8882d61B9128Bd0B571407bd9c": 2310.79,
        "0x7A53E106d5519aFDbEa37b03bA794b0e7B8f7Cbf": 2308.96,
        "0x17929246A8b048ADF6338C91802A04696cC44dCE": 2301.22,
        "0x6b060ca8C430f2561d676E30B13B95F66f0BF1Cb": 2299.93,
        "0x03b0E4A19F357a112BE59d658eC4E2834d510F39": 2299.78,
        "0xf014B746D7F8169F0D14886277e5Dd0DD49718D8": 2298.89,
        "0x7798Ba9512B5A684C12e31518923Ea4221A41Fb9": 2297.37,
        "0x2DB3decD0332f7646260d9A009705cAAe98165bb": 2296.6,
        "0xFB99A486d8529223b2F1f6B5De3333eE679959CD": 2292.95,
        "0xf2e4a05cBae83fb3173BECEe7a31686e8A6ae3Ce": 2292.4,
        "0xEc2961fE387120cD6A1b68314E64E14E1691E886": 2290.82,
        "0x00000000763E7cD1dBFD125Da811281Bcf61b013": 2290.52,
        "0xDB611d682cb1ad72fcBACd944a8a6e2606a6d158": 2290.32,
        "0xe88857D67CF8E0031cA1674fFE17f72578e566eE": 2290.32,
        "0x17a609bA82723a04880F6dbeF59D4412175073A2": 2289.74,
        "0x8FdD0CF22012a5FEcDbF77eF30d9e9834DC1bf0A": 2288.86,
        "0x757a2eedfb492bf152de1ee7e799F396808e280A": 2285.28,
        "0xA997f11605425b9684748E256E3E9fB8453A3f99": 2283.34,
        "0x71FBFe41A9ddEDd13Ef25a337faE01438064a08d": 2275.71,
        "0x1b648ade1eF219C87987CD60eBa069A7FAf1621f": 2275.21,
        "0x4a245Ff2934F7a32c75c95B6a7397C9DC4158CeE": 2275.01,
        "0x08082F916FF4f4f3837839D20Cf8cf255E8dA57a": 2274.92,
        "0x0380a3e4F99a4A22B6380149c7f5622C95a7e401": 2273.95,
        "0x52dA762f74eBE135baB43d30cbCc5aB9A5bD6Fb2": 2270.96,
        "0x3ACA3f13bFdFCaEbBf9222c43B7CE4f23bB1531a": 2269.58,
        "0x354086d5ecFa27749732c7E931152B2517E3059A": 2269.16,
        "0x55348aadD46fCDd0ef3D0FCdA9a3f20C5B13967b": 2264.69,
        "0xAf0d0077b43a918Fe8c26385a9cCD1B96EaFed54": 2263.95,
        "0x043d128F7836C4f3053d956F30dd35659b425c42": 2262.43,
        "0x6fE9D2b4dABB50da1233207Ee2772Ac18030fD11": 2261.1,
        "0xe44D701EfACB70Ba69F9C98cf5Bd701cBaf2d0D3": 2257.91,
        "0x04F32d95AA0755D6C0325E6D18E23AF177e0b9a9": 2255.69,
        "0x79015522D207F0ee807000D4BF6F0B496cd5e657": 2254.55,
        "0x393b5505807dCe9f57ED9e285317e15fF0C622A9": 2252.28,
        "0xe5F4fD14cff837BEa475A058bDd565Eeb95674aD": 2251.94,
        "0xfdb9334b1c30151438dd6Ae8A28370fDbe24c3b4": 2250.85,
        "0x115d0d8822efc9607c52B04628098b48970B993b": 2250.05,
        "0xB686fB874b85D9e84026244a9AcD28896BFbB84c": 2246.99,
        "0x8898cAa8eed44e3695338699e0Cc9eBa504bF94E": 2245.42,
        "0xe5E63a7FD8E329Ee60Ed8Be8676F7bf103522fE7": 2239.44,
        "0x2Fa8111171BC2886E6c73301E91f8CeF908cD4B3": 2238.93,
        "0x189E0D38bBE45035C1e60bFA01A925840d8277Cd": 2238.47,
        "0x1A45fc3B1C21a259a9e8b230e9D076a93D4E9485": 2237.08,
        "0xd4d815Ce793281785b9f17ddfA472046A65DA669": 2234.59,
        "0x336Ed4f0137F3957DcBF3EB0A91DCD9adb92Ba93": 2229.77,
        "0xa8834c214791Db3342Ef97B6213baCa6012E67b0": 2228.71,
        "0x5AD3ad9a85ba7692c0513E67e2C2433Dd66046C3": 2226.34,
        "0x30EdE08bD06904242a422A63f29925aa0658372C": 2226,
        "0x5580bA66f8d6Dc71adB0CA1d1c6B3D142Ff7aACa": 2225.69,
        "0xc7d36f9145dBE07fafFE092a7e9543306c77ce71": 2221.3,
        "0x35f7a9311eAB6961B0b278C7e176b8Dc9C43C185": 2219.86,
        "0xE3a210B03d71C436680e99269F826eb65621D5aF": 2218.88,
        "0x723D4D63bb05c169f4Be5EfA15D991434e653CC5": 2218.78,
        "0x5a1E0fB4D5cE61df6298f6428B329599E4AD3f3D": 2218.62,
        "0x79c164dCE0154c8B103904C894fed109D55dDEbD": 2214.29,
        "0x665dDA54E3D9c96527Ac06A1269F15F3B69046D7": 2213.45,
        "0x7fe97d097EE4FCe42550314d4186D7bfc3C1c599": 2212.93,
        "0x9C74D538D2e92516CdAF5A90003448508c13F643": 2212.73,
        "0xC3193E39F77c2Ed59045CfFfCDCACdDa72f29987": 2208.7,
        "0x2a5Fd504143B8FF93F2192F70f9e557eF10518db": 2207.79,
        "0x01e58c75a8C9A4f188AAB32e2b0d01b4a9d2A8F0": 2204.86,
        "0x6D7FC9df45F6da0E0223a9999D2EE7E6f5FB84F9": 2203.95,
        "0x814745053E2C0CcEaBF8ca7d066e9901f4CbdBaf": 2203.63,
        "0x1a40B1f0D0BbEC72E27F014DeB2dc78930582006": 2202.15,
        "0x264827B8DD1cA3EF6afB080241B3D3D8dE8178B3": 2201.12,
        "0x97020c9eC66E0F59231918B1d2F167A66026AFF2": 2200.64,
        "0xfba381fB57D1f1efDc12661e5bE59425E545e649": 2199.13,
        "0x4Ffe6B3E9170D1e149F3d3Bdd7e4bF5434D29132": 2198.31,
        "0x95ed89b6eC7d5B40bb6dE49B88fce50B32A69901": 2198.19,
        "0x79Bd77FcCFcE56270c48C6BdDb8Ba7DAC01bf875": 2198.12,
        "0xF51f757755573f1759fe09b824dCe3fac6919Fe2": 2193.17,
        "0xfbFbc2ED58848f0870e0b522ddc01FF3695c8D3b": 2187.85,
        "0xfc3267Cc1eAD34059f43A70Eda456b29D1D64214": 2187.55,
        "0x2fd47AAc2237b32bf31DC86A902aFD894faCceA4": 2187.45,
        "0x2a9524d0dBF9968A9664dD8f51c4F1776c843754": 2185.41,
        "0x0b4F09c8b09b9A5D4F8269bCB9eefA52d7F0681C": 2182.94,
        "0xe65ca10925A8b3A087B070718e71EA214467D547": 2181.76,
        "0xD631B35A4ACad244826106116410100Bf3269e60": 2180.99,
        "0xf79B6766C1A06aAcef0D86251d805fd67b9e691f": 2180.85,
        "0x0EEaCD4c475040463389d15EAd034d1291b008b1": 2175.96,
        "0x02d5bDAC817b8f9ddE4B0658675cc34F3d383993": 2175.93,
        "0xC182aA0ecb24A674C00C76cE8F1761cC5a10611c": 2172.74,
        "0x7E03b41a3bd79dE20e2B38075aF02F2dCF174754": 2171.48,
        "0x91df252F01893e0407e5C1a63612c1AaEbd8a34A": 2169.16,
        "0xE1EF6c4D19EbE12b668Ff1E24CDd2cbA59699B73": 2168.95,
        "0x06A0571B904d915EBb9F31D7Ecd7567Fe7518274": 2166.83,
        "0xB4772cf913DD7586177ED47ED9aa31e880244fEA": 2165.84,
        "0xbd1C10d1451a084C00Adb7B6052C81D0bdaa67aA": 2165.38,
        "0x976251D2d376f021CD88a64D13C8e8f444FF5fe3": 2163.35,
        "0x6b2fD31c3b6d00a3E767164f953dB2130D0e614c": 2163.31,
        "0xf7702FEd1b88b63F5eEbfEF1Bfd0e90A89582FD9": 2162.33,
        "0x06cCDa5DCD7533E548cde11AF604781F1A7AA18a": 2159.22,
        "0xf47841F562689AD85363B41C235D61136C0Ccf26": 2157.31,
        "0xa74b8BC8dcc65F3F559FA4179C890A72B66F3F37": 2153.77,
        "0xC3465B3200FfE73E5AE9261cBB6455b842e5Bf79": 2152.32,
        "0x51b5A0a314a762908C2eAC77481B9c409df67628": 2150.55,
        "0xC7AC75bB666E0De0e5A4ec43687a9d0bdA1B183c": 2148.82,
        "0x93072e593a233Cef979F37F898fBECfb2a09218e": 2147.56,
        "0xDfA361B293655f41e8df1b4b46e98cEbFb8DE292": 2146.73,
        "0x5f4051f963a483403359fdAD8C35a006F49C7c32": 2145.69,
        "0x586F4460d418aD89684bDa2F94fdc97fC6af9769": 2143.94,
        "0x32B1Eabc8BD6c7337EdA5BD6Eda20c9aD495ba86": 2141.24,
        "0x22550eB35186221Bb1734745d403eAEbd629C36B": 2140.48,
        "0xeFA9B01d57Dd8D09Be153c37aEc0231Bd06f438F": 2139.38,
        "0x3FB2C066499dE2c29FF360D124A023b0bD33d330": 2135.65,
        "0x36A6fA132607Db8b65d73d758ff6E3Fb8E03C1DD": 2134.37,
        "0x7E5Bb89Be2ed21C6066E8a5bf1e474d4E2D66648": 2133.98,
        "0x0DcB4DCb98443A7B10323E556B92628e8cAaeECc": 2131.58,
        "0xb8829168d3D3269bbd32acd313AC916e2C79695D": 2130.32,
        "0x1d27EAe22eb16f98f2Ce65b6Bf78B058eC9B60F5": 2129.49,
        "0xF70b01c098074Ad81567ce3F161bf977928757e3": 2129.27,
        "0xB1101C790731f62BD06cc5e91551Fa523a20330D": 2129.1,
        "0x0C355c4BA543005F6E95927c055D9D53e3741e86": 2125.57,
        "0x9B6208970AE24E2cd3188A403830ACe3B78Cd7bF": 2125.42,
        "0xcde5041D01A48DAEA54caD390Ff310B7cb79391A": 2123.93,
        "0x0934AA1e8B210309053184d529364C881Ec87bc7": 2122.57,
        "0x5353D57398A1d5cC3f715Df0a365d4b5F2A4044B": 2122.26,
        "0x134a90C6F0421ef193737e55E79D3C72DF72D500": 2120.45,
        "0x2371abB87A08F90F77c4Ca9c52Ad06895D0d9c64": 2119.94,
        "0x649a50f9cDd808466ab616cDa9a8A689DEfa1dd0": 2119.32,
        "0x495E5f46c45cdB7Cb8efD0037e3270DC0c1582AC": 2119.24,
        "0x3823a62339C5E9A75990EFd1F91CDeFf73bDA609": 2117.32,
        "0x272cd4c6c9ed824D236F0FC718649547e14b9003": 2116.14,
        "0x2C2c0c044CA3d2d1e31AB37c8a94b525B2cB3bb6": 2114.49,
        "0x51804dEcF490ce574cC06c50Bc9a17052a22bB0f": 2112.59,
        "0x77c98bd25557E3Da6AE5DdF7fe076bc09506fF8c": 3273.5219195768177,
        "0xb216DF07caA48Bfb950a4AC4D86C8FA4feB6537e": 2109.4,
        "0xc799DD327b5D6c6E4Ed5bbEC510b49A1ce4bB6d7": 2107.36,
        "0xcB5767F6FfDD568E3cEe9f47D89858D2C484e254": 2105.45,
        "0xF0BbDF1b8c709F8F6177fA1B0A1fB77bA0e743E9": 2105.18,
        "0x151e5062D509bF6fC1b5345aFa0e7397c9c82226": 2104.92,
        "0x757E7fED48BDcf152926F5bbCAc448f494e6f8d3": 2103.26,
        "0xAB2DCF4a68Fc91D099FEE8818141fc748dA5381D": 2102.4,
        "0xafD937818C704863AeA7c0E871A05F3B9B16c569": 2101.53,
        "0x16B00dB74167b7469dDa63b674Ca9A3B1b70C439": 2100.38,
        "0xc44D7FD052634a4FeD213938D1C0Fa3c0F46ccE5": 2099.31,
        "0x23807719299c9bA3C6d60d4097146259c7A16da3": 2095.31,
        "0x2ae7BA6E60E86397575EAdF27fC90614275b4d89": 2094.81,
        "0xCdD49f7B85B111b35761A725AAF9D5DBc02b4CeF": 2094.14,
        "0x681F956778d8C208C330E233c87BB57b2C0D4708": 2091.89,
        "0xb1B40953A476825877c0cA22A76db930E77d5519": 2090.73,
        "0xb29feE00F5cc17f6Bd10dfD822A3C91549EF9F01": 2090.31,
        "0x0CA78eD9F48dFC2dBBFF9E1D55227e52359776f0": 2090.31,
        "0xaD0cA78bdcCE91b8A076aEE9bF6CbCD0733a28D7": 2089.5,
        "0xcbf32b29F37dE105C546704E73633189330625C3": 2088.51,
        "0xDCF4b536f15c832Aa59aa4B3EEfeEef98e6e6399": 2087.38,
        "0x51De71DBb757b249DaDE462FB21530803b6996a7": 2086.75,
        "0x234237739f507aFe5d363eAcAd93fffF1b8DDC3F": 2086.66,
        "0x22E14C9B58Af311Eef370a4Fe70F07B9Dfa40244": 2085.81,
        "0xF076823122F106C2b7F21CBaacD1c9DB1Ce4cf27": 2082.84,
        "0x582965927a709C097a85E4FF85008aC2E84B999c": 2077.24,
        "0x01e9eB5B2Cd5b1AE2147d1A68a9f713b4D0b4e16": 2075.57,
        "0xE7Fe347531348F135e5EC4EAF5fA741e662573bF": 2071.31,
        "0x6b5ACedaB13570190B8ac695ff6122f125cfc180": 2068.37,
        "0xF754BFB09978C3E47512209A7c90fC517b51a8cB": 2067.1,
        "0xC0b1759EE372BA5542abC317DcB2AE778e7db7D3": 2065.91,
        "0x8CC2da3F7e79C0F56362CfEB9be5b9bd9184F1E0": 2064.07,
        "0x4a5FB08C50B18D891E6eCec109CE3d1Fc335966F": 2063.4,
        "0xa564eBF525fc61AE01F1E0689DBbB4616f215f24": 2062.8,
        "0x8cc1547f2aeBBBAA9466310355110427449A937F": 2060.58,
        "0xF253f56F5b8118E9D28CC8dDA7316761f4a85fc4": 2060.58,
        "0x7694c57016F7f1E8Aea7EEcf7dF886f138Bc4aC7": 2059.28,
        "0xE76292D34d597DfC999834E372205d558Ea5d537": 2058.68,
        "0xCCb80763b932d03A6c5F0C4877f54B9992cB9Ed4": 2057.61,
        "0x940700Fde6046bB711127F43aF66FdF1a57ffa53": 2056.93,
        "0xcDd62A699e895eC5cc142c312156Cc076C9af580": 2055.31,
        "0x9fAb819d48550b5220EB90386Ef7278523D1dbF9": 2049.68,
        "0xBd2820EDBCd7C5848c3D8E984F47Cb5E50608005": 2049.48,
        "0x9Bc05d6ABed3857457CCEaF51B2d87E4E06128f7": 2048.49,
        "0x14D7DCFA4678964d4816BEC2b3E891D28eC022CC": 2044.81,
        "0x2B5Ed7578f4b3C774b31dB7A4e471e975Fd785E0": 2044.35,
        "0x33F85b4E9Ee3f245df7510614d0aFbb8267ceA6A": 2043.45,
        "0xEeF9462B7e4db80Ed34A9f22DB06A9cDa8854569": 2043.45,
        "0xfc0B4fc10A2c25455a20c2c248dEDE4826D48350": 2042.25,
        "0x37F1a3d8A72767AD189CE946b2eA7d4601765E91": 2041.89,
        "0x3e1679E731bA8231776b0fdf6D499f354B3E6B83": 2041.41,
        "0xcc5B087283D69dB4237Da489d487140f2745fD28": 2041.39,
        "0x6FE8874dd0e751594Bb2aDF00eBde5Ec2bbD46FB": 2037.24,
        "0x50A4181d0B43b3A25C4be80Ca728cA0D4ad712dd": 2036.92,
        "0x06b605b1a4321F2842187c661741b74E782Be44C": 2032.59,
        "0x5149d0D95244D3adD96b0E326de55a713EAD59a5": 2032.55,
        "0x656c54F9871850780E2E08f64f49fDED995AdDef": 2032.3,
        "0x8A03F11bc8D1571E89453587Feebc5FE227aFe28": 2032.23,
        "0xDE929463608030b1719cebC925b7326957da53eF": 2031.67,
        "0xdAecff8faaA8b81D6a9B01cEa241B25b27E20536": 2031.63,
        "0x92A790438Ab4Bfe582cb34A5032723718E5B1C45": 2031.27,
        "0x54E23654E6c0f4587b6083b0aE1Ae4D4B57802E6": 2031.24,
        "0x0b31EbE7C7127B74aeD1053064EA8816fCa3b9F7": 2028.34,
        "0x21f59001e8543fbd84fCACAdE38B1A06274F0cA3": 2027.84,
        "0x1c48bC112e8f03Ac691cD4439181253b19e584Da": 2027.3,
        "0xE51e79FEe438000417C4FB609B933887dc758e3a": 2025.21,
        "0xC3732034aE7A252F7507493083d5416DD89cfB70": 2020.08,
        "0xc4DbF062a97B9F5841fCEFE74CDC1cb8C852DE42": 2020.05,
        "0x6444396685b9f69c01C983945f1E6473Fb83431F": 2017.78,
        "0x5c796cc998a4b585Cf049FEac527dAd650aFAb65": 2017.57,
        "0x419e0AC43F70d44c8E0Ae3D2AE35E803e523D09c": 2016.76,
        "0x5fAf276f6E3e0b10213f8A04BD6C872f8752949B": 2015.2,
        "0x3AAf5575935Cb449f618CF3B9FD9F67b6Bc8140C": 2014.88,
        "0x1CabC3e62e0527cBe09917F5Ca8e6D9999502d82": 2013.19,
        "0xF6ee08C4e3d158afcC35F9A8D247d70EA29bF618": 2012.75,
        "0x91bda93E07143cBce8993B0361F01e485a260017": 2011.86,
        "0x6C84F8e53B70e765dc88E4a7ad4CA6832beE8730": 2011.71,
        "0x418340B636A908E69E98bb0C36eC4610980dCe87": 2008.01,
        "0x7F29667850c1b15d868d69d55612C29d0305158d": 2006.68,
        "0x22Bf8977b1F33073c52FB4C4ed9A4B9946F5a092": 2003.79,
        "0x0E39B12Dc1F8A69202838F540684FB5aC307C9c1": 2003.65,
        "0xBA85850C0Ce2b1ed164a1d9Ed3Da9AC3ab1dcCC0": 2002.65,
        "0xA0254539d867FD97ea482A390F6C0A95D4c5106C": 11881.19172354207,
        "0x97641A5f3EE3B0561c6BcC522F7E1BEdf2c2985a": 2000.16,
        "0xa229b80a5a9EB0Cb4E5a5D9F7fDAA15dD02F280F": 1999.83,
        "0x94bb64f974b5Cc1aEEaFaf66aC43c6195d6e7BB2": 1999.3,
        "0x2d6fBEA7ee716EaD4206ad091a02616627c36794": 1999.3,
        "0xf748879EdBe8CcA140940788163d7bE4d2A2E46A": 1999.12,
        "0x627bc37EEfB35357f70D1f5DC033740Fb462A837": 1997.15,
        "0xA377855c38B1A5bC6FA513C6BfFA29ad2450789e": 1996.83,
        "0x474737676ca5993EEcA3c2a072572440E0524bbE": 1993.58,
        "0xf8d59231bD1c74b8878cCF244C4dFFf412C872F5": 1989.01,
        "0x316079E767e2669BFd2cb6e9479b1CA09e121F65": 1988.03,
        "0x2E59578E7f29BC02B4616c0b3449b528F4D89910": 1986.87,
        "0x5880CFAC02eC49e56358f03002c4B7f00EbeCE44": 1985.6,
        "0xCDEdCee9C46284667997eB4D29f8427b696dA3df": 1985.13,
        "0xDDf8dA887a1D5C07d05A948856b79DaB091efc78": 1985.04,
        "0xfe84b62fD28882c0b4A0A9557d9847EA313931ac": 1983.68,
        "0xe271cB23eE78e201bc342EC78480210C26D9B38D": 1983.15,
        "0xDBe1a101b489F64694f42A18C1CeeB3E39866c96": 1982.3,
        "0xB43D6A23d72f124677F305ACaFF5a6ADb828137f": 1982.01,
        "0xAcCf339e9985Ee2984AeF6ba0b4605BEA3d3fd88": 1980.77,
        "0x43853d2586BB55a3DADfD2060c12A13124dCC16E": 1980.44,
        "0xbA3F603FE5eaEfE9690cF91f333d5D35e4dC5a3a": 1979.88,
        "0x82cD1b0fAA449D0562bB32072dc1E5BE9C509c1D": 1976.95,
        "0x4c63bEe8c99e3F77b07D1a09F9FAe093a64787Bf": 1976.18,
        "0x8eb5D539C301665189f8743696b60Ec97639020D": 1974.94,
        "0x041F421B463e1BC840f18f48f02bACb31c967F2E": 1974.43,
        "0xcE0733AFFb4738328621602dB5B6B6196Cdfc1d5": 1973.11,
        "0x3C711A6eb7EFb5F810680380c85AACE62aE71316": 1972.92,
        "0xef70B51BC064B76C874e0675282Ea927446cb07f": 1972.56,
        "0xC78AebAaf175aE1c896a6031AB485BFE72b27bCF": 1970.89,
        "0xA6861734e12E45e3B3A1DFc3D06d1bc5D3C34589": 1967.06,
        "0x4a186A59938d5C8Cea23b47e096a2e1493E8dc76": 1967.06,
        "0xd9C13d1BAdC0fe49B9eECB41299832Ac42D08972": 1967.06,
        "0x1db1a22Bf61Dd8907d9DE28245f1e5F0De36C14d": 1966.85,
        "0x65534e80783363Ab1a12ddFb71e62D7028C1f594": 1964.26,
        "0x788D2c0813Cac59770CDF36f7BEb9bFC819B6475": 1963.85,
        "0x66C78FFf3c2c63c447e8664AB8311A7521762ea8": 1962.29,
        "0x9949Fb0275E2f950C26dc79249e5Ff3D8c5d965f": 1961.85,
        "0x0684518BFe8014a5A72E1695DF4cB6b3f7274bB1": 1960.06,
        "0x33E7398605736718648D724aADefE4efF838c623": 1957.76,
        "0x33F25F33F6B4f133e92085220217D10d3A9d9542": 1956.78,
        "0x81FaE337D4932E2A817CA2cb6eF6574583Aa9b4e": 1956.54,
        "0xCd216D1B6d4cA2B25ab4D7a9941D8852047d56A5": 1956.35,
        "0xf3bcd2e7cc95Ac1C5824Da5e372b9d6259DcF75C": 1955.78,
        "0x7a50046BB7D5Fc23e48E73270d5E627F3CA83A79": 1954.28,
        "0xb760c246dB7eee48169C729D0394a7773Be6A376": 1954.28,
        "0x6834cd00F761c38E2E968196f8627B61A8468D6F": 1953.94,
        "0xD500cBBdaB85C5854EA91B0eC04215caf48866F5": 1951.12,
        "0x80D8a2A197bB4925Ba237c3Ee8b3614d6f2Cd181": 1950.75,
        "0x9B16ca2EaEd51550a97aEc3A6f3A0fEF6E9bB44A": 1949.74,
        "0xD273485Bdedeb856083DDe9A8b293aa556cf8178": 1949.29,
        "0x2b03C480f4F7fF5a8275ddb77227889e58eda16f": 1948.74,
        "0x374A7111a36Ac451B37077bcaFa80aA6c9811b40": 1948.74,
        "0xB392ae2298291393902c1Cd09781708C4F812F34": 1946.25,
        "0x8b5d3e6FD56488c7Bc4F31b93Fa2f2E219fDfb38": 1942.69,
        "0x0D1Ce32357BB10ab80E5651417A16B2Ce470Ebd8": 1939.34,
        "0x8DB743eCf3813F7bC8F142d654aE8012efAa3481": 1937.65,
        "0x420fCC9ABcDCbb83c1A629520f0bc24D7422Dd42": 1936.65,
        "0x5A0Ea6E237f97b0c3Ad2aAa744f257258cC797bA": 1936.26,
        "0x7D0e947F0EF553Cbfa1dAb0384fD01A7a983aA8e": 1934.48,
        "0x1af88f5f269c642b3609c7e20f7b69A5c0FEee07": 1930.85,
        "0x69f424Ce7215F20d206922539A0a291d41907Abd": 1928.63,
        "0x5E40eFf9FF5F86384fC53598d7b3C4DB26C2a62C": 1927.58,
        "0x684F1c1015C45fe5beA67FdE790dbdE604CBf2D7": 1926.9,
        "0x8Cb4959d5B346C5c8C307f73964eD851401a4fa6": 1926.32,
        "0x2C2Bef414c54e79e853f10556B05ad1B034e74D0": 1925.32,
        "0xa2C13a6913D1DF18ff4f5de2bc342023Cd683C38": 1925.25,
        "0x3961A78f201Bed1dC91FdeC25eC6fC1E1a2D9A24": 1924.91,
        "0x933A497C359cDF437D370E37158f2553C167aF0f": 1924.29,
        "0xdceb0Bb3311342e3ce9e49f57aFfCE9dEac40bA1": 1923.04,
        "0xF6708fe044334953478FfAA0E9d177635538cCce": 1922.69,
        "0x4c84eDBe99E0D94178aAD3310e4C563b8aE0aaa1": 1919.24,
        "0x7B9207a3609838b39E45982a91d6422f5851186c": 1917.52,
        "0xe3abFa7745b463BDe635FfD59456f4792b556e0e": 1917.5,
        "0x21EfC2BDA4102FeA51EBc0D1E081662a1D8392f9": 1915.29,
        "0x65cC2A026766B49aA2fC69607befE09d05933Ee6": 1915.13,
        "0xFC6A0e6647C10d9812Ff2b3E58364E53f3309E89": 1914.96,
        "0xD4fe6bc042e989644cFC8F1b0972E74dCbbffBC4": 1913.75,
        "0x970268A2aEd971a38a70Dfd46d14d8252EdE8825": 1912.56,
        "0xE171e110cfe6f658c4421C2Da4c86E4933919de4": 1911.96,
        "0x28040De02dbE9591772920a7305512534bfbe459": 1911.66,
        "0xeb2e226eA149360BF2ad14fbbeBa0452168cBbc0": 1909.99,
        "0x2fDA99BC76BE76cc6Da99ee7E5c6A853fb25fDB4": 1908.94,
        "0x1f3fb69F4087c0EF10FCfAf2B6dEC21508379960": 1906.55,
        "0x5d8d7F6D12Cc3d23dc300D57335b943fcEd83154": 1904.68,
        "0x5Be66f4095f89BD18aBE4aE9d2acD5021EC433Bc": 1904.64,
        "0xFeC1083c50C374A0F691192b137f0db6077DAbBb": 1903.9,
        "0xe9Eb5B18f6A6098EaE9d38D03dbfDc924bD757E9": 1903.39,
        "0xb8a9f51A019c8A3aDab61f6cC94EDfe099CB4c1d": 1902.92,
        "0xc83518a319007e629BF5e1AAe8a290d7Ee0315ae": 1900.55,
        "0x3dAb4823510336453d64Ad40a910D4A41cEF7646": 1899.6,
        "0xf60784c87beC69e36aB66C923e18Acc571427b21": 1899.36,
        "0x7E8ce0bC69b8f32517b1581A518086C84D7F1215": 1899.28,
        "0x7e1FF06fc9adACa7383560F3d674C6b686AEf67e": 1893.91,
        "0xb78e118D1F7B9F61FD723901d4bC546E7C1Db172": 1893.71,
        "0x4F2AB6F8D5C9F434130c04Ec189FC93fBe75db09": 1893.32,
        "0xA2f6E5E644250AFD7d4c6aA41a90e3e50AA2ef47": 1892.56,
        "0x7861476639cd649a365d983eDeA82113715e7793": 1887.73,
        "0x769256fb273A9b856B6789f3a7cE6dd572854242": 1886.26,
        "0x0ce16bd26356Eb53Fa5236170CCaF95B12A5dFb0": 1885.76,
        "0x42fC814764b28038E41b4e5737e1D2F9fc4827d0": 1884.97,
        "0xcC8cf53648899b5daC6E0074B4da0057c7D887E1": 1883.24,
        "0xD461417568661E1c0C7f0AEBaA4D01dd8aC8dD7A": 1882.82,
        "0x89557EDF57c4Ac779973e2C4e7Ac8530eFf69A1b": 1882.28,
        "0xc2a51BDc6C7D3e620686BF57eAf9808442B57B7D": 1880.97,
        "0xDAf399BaAF8ABFA2f307c73Bf498437c4DA1109e": 1879.69,
        "0xeeb6828E84278b3615C8E7085D0BA60dc7c7eF22": 1878.7,
        "0xE3c0fa64DB6fa1EB9ec3bEf37A4587a349fc1382": 1876.47,
        "0xeE4DfDC5e32bDedCb147eb7EfcE088322Ac37EA6": 1876.45,
        "0x5c76fF5DB4f5D40f3e6984e603F6aA9c61e46C24": 1876.36,
        "0x811e8f6d80F38A2f0f8b606cB743A950638f0aD4": 1873.73,
        "0x199c619177005091B8A5E4C3e96ea692DfAe4FA8": 1872.2,
        "0xFaD576EBC93A47031bA895064405f8A04b6e96FC": 1872.16,
        "0xFd36832706EDD3B4eaadCD0E4849e5E4C82D3442": 1868.54,
        "0x9cB3Af7BbaD837189Cf3B0Dd2606c7C48D4727e5": 1868.31,
        "0x4bEb7e81fbc20476B23a324ed035e538618407Da": 1867.12,
        "0x794d1ae064A5d2803cBA821b7429d95cCeCcf1Ea": 1865.61,
        "0x244964A517dFa272F0d05B52E8f065aaAaad4Ee5": 1865.59,
        "0x2834123c30d7c16d1A7337455505216bb37366d4": 1862.99,
        "0xF891ac2FA436f92DBF6bb80D663DCD20b5DB88A5": 1862.05,
        "0x114EA5E587733472bf6c80E02e0CB7dC5475fC59": 1861.42,
        "0x32d5be1091491D9d1eB6E8Dd125598cF18ab45a3": 1857.99,
        "0x1CcC9e825888Edf942780D1Dfe7Ce1A2a16B199b": 1856.42,
        "0xdaa070D909E010211606144eDe5B2ca6864C2c1c": 1852.51,
        "0xc1Beae9873e3eda41c875f1e348Ff356B205B933": 1852.19,
        "0x88ca682c8DD3F6EE798d1dFaC3ac90799a54381C": 1851,
        "0xCaa518C1601782843eE32c14e0D1ac4CbD1E7144": 1850.28,
        "0xA11E32756bb1B4A0fFdF11920fd77a57a91701d0": 1849.83,
        "0x0Ac80b8abeE2D5Cb8428a2317FdE5831C58147bd": 1848.48,
        "0x6b004053032440D867788C64207e4A6b042d073d": 1844.34,
        "0x963e238Fd42463AF3C49d6F445ACfe1EC175ae4E": 1842.8,
        "0x76dAc15813D4267248dc28a0724D859a7326f328": 1841.93,
        "0x0D31420A4EC3E4f54c0589b66A6050B785Fed401": 1840.64,
        "0x59d869c75aa99F69FbFc1C75F4EdC862e9a7E7E5": 1839.96,
        "0x81512D9EF03faD3e4BEece781D9A308D46cB9582": 1838.83,
        "0xC4AABD689E5A14a7CC385d10e46c5177d7b98933": 1838.46,
        "0xbEC85812e620b56525681312B12eFCe711A58135": 1837.9,
        "0xcD67bF44eB8FB5c728cb7ebDC8105b4c74F30e62": 1835.76,
        "0x000Af300c69d35012415B70C3009b765529C1C4D": 1835.71,
        "0xF83128AE01Dc7d66d4D8807903Fa0431eFB4e123": 1835.71,
        "0x029CE1566Be5865125aFeDb57E219D864647Dee9": 1834.02,
        "0xE2952771C80D9B9c77A32e47D985bB3Ff4e5A93D": 1833.87,
        "0xef7F71aD0607D00DE9c9897BAa30489768F4601D": 1829.84,
        "0x16a4EeBbEFbf4dB1ee6275a3A67578fCf9398217": 1829.84,
        "0xdF2E0A3C668379e1B25901B3F719EBfD00F0BFBD": 1829.84,
        "0x0516578E2BB01A1Debde0278af79ebc3eC860036": 1829.68,
        "0x8BaB9124B4b47D6ebE57c503F8BaAFFe7FbB5a03": 1826.31,
        "0x01F12FB1d38156fc6D1c9a7d813BDe4b52D38E47": 1824.93,
        "0x436ab6B28220E1c97d34728D760DB4561cAC5d4f": 1824.8,
        "0x095C86cBc3123f8109191aA5A2c693aFA8DDDb97": 1823.86,
        "0x8c1DaF1325BE003D4654c586E6DB91FE8DB3Db1c": 4155.905004014083,
        "0xf0A6f3F9a452E3f8BAEB026dE0014D46888B74DC": 1822.56,
        "0x610D49F8a264DB3B41A793173ba5b8acA70444C2": 1820.27,
        "0xD9c504aE4d18Fe814e18dE41426c30b34e26c868": 1816.22,
        "0xF2b4DAF4672ac99ec064Dad6f69AFf7cB4Ee6D9b": 1815.67,
        "0x6aC03D9F77086B2Fc49CAF4C7a27E3A4E558C294": 1815.61,
        "0x712a81B587AbcaA64EA8FF2F0201F2379BF120E7": 1814.42,
        "0x42e4AcA1199D3f7d0A15A973F788c4AaaCdcfaAC": 1813.93,
        "0x99d248Bca4a41Dd75893ab626B5cf08d97ac51A7": 1813.85,
        "0x24B1bF98402c33a78c96178b833F89dbde7E76a7": 1812.71,
        "0x0D27228f024a20012D044B8870a11F4f3D017804": 1812.3,
        "0xe5c40F7Fefba04A99f2404269C0C5689eA52cb26": 1810.03,
        "0xF8e5408823976628caE9940fC768Aea8575CFfae": 1809.7,
        "0x2233416F6F7d93D7d8B77F091a373A71e75d3a34": 1807.38,
        "0x2D7000C0Aac7792E8512bA98722dd483DC703689": 1805.36,
        "0xf97eF06387DC8Db38d33AAd5def02eb0B1884140": 1802.85,
        "0xEaE36EcEa04000EBDda3B3a981D6F0dD8f7FEC8B": 1802.07,
        "0x153a6d27ea4Ca03627398E42D762d6DcA64D1Dc5": 1801.78,
        "0x1eF565c23C26FFb3c77F7a03e33aC625f3552524": 1800.99,
        "0xf7d15787A033215080C5b5921f696022cEd0089C": 1800.23,
        "0x00f04E0f2984e0Ee9B4c033582E5e3E7bAaca07d": 3741.755188919401,
        "0xA2b582E014C431A375643884Cf3f4348D629E6c7": 1797.21,
        "0x88ee8692aDfC54798C2190c1e68612f75aB15618": 1797.09,
        "0x299925D097554472EABa82680F8FF2Ba39B8D449": 1796.36,
        "0x29c1031b5E547D8e1c2ea8aE159AE3b91Ef538f6": 1796.05,
        "0x308D8bC1f6321252894E1fBFcBD72A794A5Ce669": 1796.04,
        "0x4870929AFd7B982D31868628DF0050628c76A04F": 1794.73,
        "0x15e6Cd5B10aCa2Ae2Cc25c1121915c751310AF84": 1794.48,
        "0x93E730B28b3a1264153BAE1Dd7B84880F64844e2": 1794.34,
        "0xa23BDe7B73b4acC73918e2362E6A646761955C7c": 1794.07,
        "0x34b111Ee7738604d034687E71dF51Bf2e5Bcec1A": 1791.58,
        "0x761Fd2ea5085f753619a5f70aC804cfE0ef7Dc82": 1791.04,
        "0x5732fD69EdEda743aC78D2F3A1d1eA30fF67D82d": 1789.57,
        "0xe5CC37B25e4A223797D9Bf07884B858b5dBe5152": 1785.5,
        "0x93A5911a759bE475044041d038C0eb1EBdb9c1F9": 1783.99,
        "0xaD2c383dC37D3910Afb1F8e2CF291C68bbDEe529": 1780.51,
        "0xF319f8FC9Cbf8b8051463b26Dc55eCE4B1020fFb": 1779.96,
        "0xC415deed95E38A83172d4f8Cb754F2077B634410": 1778.78,
        "0xEe9479E834B4700b588C0168f425c83e6378E3B7": 1776.43,
        "0x7509eDcb562D473244f22376424fb49473fd8055": 1775.28,
        "0xcEff98A045a3732f3e26247A29Ba5e7d52FE84b2": 1774.42,
        "0xd7253Ef7a3e0B488145c64C5fC333019f0B01727": 1773.5,
        "0x94D7bEe57bc3DAe85A267a5d91874025aD15dCe7": 1772.56,
        "0xB82e12d1da436611C5C94d535C3a40F5fB3f35Ab": 1769.88,
        "0x10525E2942c00EcbE50Cd91679EA31ef6c11e1b5": 1769.38,
        "0x21484A41b00c014c4ad5c92BbB7661fd7c1C9a2B": 1768.88,
        "0x3489339891dCC4Abd9ee0665a5feb1EC66237869": 1768.78,
        "0xB01aBAe52CDBDEd30A1495c383e5D319fC22F998": 1768.27,
        "0xE4a705a07feCAB22528503A24F5E9b197151A988": 1766.42,
        "0xd60F6bF502C5593Ac3A25912Ec98a05532aff12a": 1765.82,
        "0x3A6E6eC9F678Fe0fD0E6371AD823b162373291Bb": 1763.81,
        "0x21c74841D8857F88e244ae6E352cB41Ab399A7b3": 1763.67,
        "0xFB67fe292D6d7E192c5DC0cFbF26fC324d0F060D": 1763.67,
        "0x7ee615E93d2d58fEB14E58EA93F3fb5940D227e4": 1763.34,
        "0x57FB802a00e9581905ae75C7e13ba09fa139E0a8": 1762.67,
        "0xadcce8276Ae86226C4f484EBA1a0CB2b35776Acb": 1760.8,
        "0xcFD1F5292d929E9A0d9abd1508450ed26e61506B": 1760.67,
        "0xa08F8FfBA6c837604D9986D380Fc1352958F27d3": 1757.97,
        "0x2aB1E2Ef15386f12171AEC6c50c9c508F97859E3": 1755.65,
        "0xD682A5F2eB63d79a472FCEe45aD94ed9A03D479c": 1751.91,
        "0xCb35D3096cC85FE2C155C9117959DC0A8Dbdd21d": 1749.26,
        "0x6989D6013b08B3cf3D4D2e00bb92Fa2c15Ead16D": 1748.36,
        "0x646985bBB677653e5768139D354ca706F1858fCF": 1747.72,
        "0x4fF82f1afc569467E206a8E0CfE5a1777104C7dE": 1747.13,
        "0xB19B254C6597c3E05F80175c5F5E9f78a680ac5e": 1747.12,
        "0x8Af58B5B7aeca9F3dD9E9356E296615D3CCE33AA": 1746.41,
        "0x49770037Ba75dC1856a84fe600E43c9980CfF4bc": 1743.18,
        "0xe6b58bAEB95515668c9539476AA48DDc745EE23B": 1742.18,
        "0xAB7EBeEe0db6d6dDad9393C97117fe5003bb5f8A": 239837.13,
        "0xDb10d21f28a34FD04E4425eac777483798f7e217": 1740.62,
        "0xe1A3b21F851F4ad146879C07F8d6Bb44959daB69": 1740.27,
        "0x941082709b211Bc3Be33BD0F0387e92EC2Ae7481": 1740.2,
        "0x218B84A3321f40C4536e341d69054dc81Df61437": 1738.11,
        "0x07f9Dc78DD0c8A87b06FC841fB86b30c6377fdDE": 1737.86,
        "0xE5C60cff7C5D5A4e05B0e904Eeb47933cEf8d25C": 1735.73,
        "0x7A921b0365B4571beE00ba5A1DbB422B11f13F9e": 1735.63,
        "0x503056Ba4f0A7eB7B3797FC6E3163c4884470EfE": 5423.423403741886,
        "0xCf6BbeB3f92BbA809678B2393ef54b102BEB3681": 1735.13,
        "0x641A91267C7A5a4fc0AD11C0e2dbc6B54A0618b6": 1734.63,
        "0x2745CACCf88E156D15fC2f3E44f73Ac1Cf278a2a": 1733.85,
        "0x927f5E93aabA25e4488e03C7DaBaE567735279C6": 1733.11,
        "0x3437858750273494FF292E7EdD868D442cFCE92e": 1733.05,
        "0x4267DAbFF26fc85d9c8A2c3f22Ed9e4C42055595": 1732.83,
        "0x19ef0a4f863cCfcd292c2321FAE31Ec898ef9092": 1732.06,
        "0x1a59aE274A47577DAd60d0D16E8489ad10473281": 1731.06,
        "0x94003c45A74Dbe132D45d15a0993CaeBf55aeb61": 1730.7,
        "0xb88779eE8594249FEe347202607A72F6a8DA165b": 1730.08,
        "0x33bAdAEb38AfA2337c3544132107eac2Eff0C731": 1726.49,
        "0xb069295B2AA04bd2CFb0e2A7afF18637fC2F85A4": 1725.35,
        "0x6c607fDEB11f83B3D5169014A45F45e035f9Ab4A": 1725.05,
        "0x6833338b84EaDb845e4Db8DE6d9e4e378Df3794B": 1723.14,
        "0x3a20BA3678C5c40F7CD48EB373fF8a501d170534": 1721.66,
        "0x03c5dd6845DfaB89cBC66C03e76c458e44223051": 1721.46,
        "0x973DF918f676f36Eb777C87a4FFb6F1b7740CFEF": 1720.98,
        "0x9Ac285fFE1840E718acD6264509E56A5A60756D6": 1719.5,
        "0xac65CcB9658db0C9B5d02A33fE14825053dE1a25": 1718.17,
        "0x7D794A7C61C50b0c1445Af8f60fB8408092ff0b2": 1717.57,
        "0x4e197aDDbb6D9bB6848E8d87b1490667D6E12577": 1714.87,
        "0x9D763293a50233bcD1b5021339EB9AE4f1dF632c": 1714.09,
        "0xE1DdCaf61fBA4fd9fb39d3abF0E648aB09Db8b85": 1714.08,
        "0xDb9d7a37Fbd3a9a24eB2FE441a977C10d3610458": 1713.82,
        "0xbADA88073DD58b151afd19A5B5Bb6450fFcaA8f8": 1712.45,
        "0x000000423dd4bcd055a8C227676ECF9f3A19A75B": 1711.48,
        "0x5e4f2FDF682e1BeFBBE021038Df9CC8073A41980": 1709.26,
        "0x7045371eeeAbf369e875C46C3E1914cB02cF417E": 1707.02,
        "0xeD96Bc0fd61b87f3B7f6478E55dB024e75972FAc": 1705.9,
        "0x771426817D8A829D3798Ee07afEF8889C4117C3c": 1705.9,
        "0x7083C30331556f4bbF85785E348dc3Cf964F2252": 1704.02,
        "0xb8Be375f7aC305DD9F09a623Ca16aA7d3b0d9F26": 1703.38,
        "0x2F24750B85B9eeCb8f387B90d2310397fee4a472": 5452.663932330617,
        "0x81e14E07493BD2A3ad29bB7dAB1f26de9C98151b": 1703,
        "0xcF2cD38bdd7CF2CdaE5D69CbC3f229500B97A789": 1702.82,
        "0x442bee95D7FeA5217431a02A0df4D10Bb1e85e68": 1699.25,
        "0x2bbff3aBFD17eA861A36A8B1335c29D887d8d308": 1697.7,
        "0x0C1d47312BB5212CB8b946EC30660D1fa98aB6cF": 1695.28,
        "0xE6631C12C27ad42bEBb6679f70d74A10131aB1A2": 1694.76,
        "0x3D1eF0651CFDC8Da7150A4d2C3fE58C83322e501": 1693.6,
        "0x0952615CD36904d97C736A0b0A5EEA75C75e26D8": 1692.8,
        "0x5Bd3530393b126327e4e80b32be8D5913A8bA875": 1692.25,
        "0x1B3Ff06C884EcbfC1040E08475a5b3c4a2ebFB5A": 1692.22,
        "0x2C3dd65e94f97B2A25239EDDFfD2e192c08769B8": 1688.27,
        "0x731aF4C58485cC278b8eFc82962bc1497c00C0b7": 1688.27,
        "0xA440dDF82786C883c7B2a4d475435470ACb4202F": 1687.84,
        "0xa418eb71a4D01fac76254c9A11F8a8206a563296": 1685.95,
        "0x00b9228eb19a13C6A943b350916Dd2AA7F182c21": 2765.9254260518755,
        "0x407Ff01Aa6664bDbc448ae2003cA1B711015E954": 1684.11,
        "0x7aF15BB6225Ece3411DB33ED395471C817965C3e": 1680.03,
        "0x33F2582Cc8A334C2d4002C57FA813BDC4108Ab9b": 1677.85,
        "0xb99FCfA7fe32966442E9131a5568D48CA69863A1": 1676.54,
        "0x7A70EcA937f10234c42b4dAED0970FAe6f88DF15": 1676.18,
        "0x2b11807Dbfc49BD0E21c5aCe44d7A2191D992421": 1674.16,
        "0x1ED6DC9ae37b0E6C0FE8130fadc4E3bd56912df5": 1673.7,
        "0x5d3C877423d3E71d718987dc0C505974bB7b3f09": 1673.66,
        "0xB73Ac8AfBace98FddD63b978280Ed077BEe7c421": 1672.21,
        "0x9C9A1e581eD8a16A607438858614C1E47863bb68": 1669.81,
        "0xbB2926eD6EA5E29E1371Cd74079eBD232f300021": 1669.25,
        "0xFC9C7FDDA3974230a3221a009F99B12478acf753": 1668.59,
        "0x1BdC0a8628B06c471730Ab99e8B5AE1d10c0E32e": 1668.4,
        "0x7c3D3c9EA0F11B162a4261a849033030B4Cd3064": 1668.12,
        "0x661bb695BeD9e5384C8784e1091225436160eE15": 1668.06,
        "0xe05503795Af1419de0f585e1028E4357e8005062": 1666.25,
        "0x6C2e73d510D9dF0b154bB8a0ABCA71d2CeB27883": 1666.25,
        "0xD7d7C959529b8967D356B5e01d488C2cD75dba42": 1666.25,
        "0x7191BCceed9860A719e4B8ef622d420C10486B85": 1666.25,
        "0x7Fd67Cee1794EADAb74adAEE774FcaD33A1Ddc05": 1666.25,
        "0x3E30bb05e183D388b573ECc6377E9F584D7cfC42": 1666.25,
        "0xd41Db7074acaf3a92f20553A88130f9532eb9595": 1666.25,
        "0x1c3354d276b49fE8941a09b822a9100d50E88727": 1666.25,
        "0x74c79BA676A3538D96735FC2246df393E17D9d5f": 1666.25,
        "0x42c80751df6Cdbaea1C42Db9f172755141478354": 1665.94,
        "0x378EB2585AF152E6C4F3b8f4aFBa8c6968a3Ebe8": 1664.78,
        "0xff2cE9D334df35Ed9FCB155F33856b638Ec5D3a5": 1664.23,
        "0x436fF82AdED2edCb2955499448004Dc3542B312d": 1663.58,
        "0x8EC08994b3ff3c50F8c88Bb647c3E14c23d9f861": 1663.04,
        "0x6D73D2bb5F3B613c3C99202866119177902fab32": 1661.39,
        "0x3d7A1FA54D9AE415e6Fec2de6B7cC1E8cdAdC685": 1658.65,
        "0xf8DFFc0CBdCb2E89d2C872DBe88F4BC8Cc7C02aa": 1656.49,
        "0x966faDC6C547c919923ac99A9BEF3505F4D60D6D": 1656.46,
        "0x4C55ADF88fe327BefbA5dd15000b039B818f365F": 1654.01,
        "0x49231B99f2eEE7D2CE026bE6D7086dB634744c76": 1652.22,
        "0x1d10FEdC5C8A449c680D32f2d45Bd1A9ab3a858D": 1649.32,
        "0x6e74053a3798e0fC9a9775F7995316b27f21c4D2": 1648.6,
        "0x2D9C839ccDA6E58f81B1B12899b9Dd256524e7ba": 1647.52,
        "0x4C603bB0785B43336b9AB9b4a00D0F0B8dD301bD": 1645.48,
        "0x690276d1e5d7BAc0bd144fc9Ab9Bd3b3e3aDA8CA": 1644.44,
        "0x9596B6554d653927800Ad13c9Df4193d12C07F61": 1643.1,
        "0x54A92Af08638A716Cb23410e94C54481922b5b23": 12460.744211854058,
        "0x4053136D1CC59dbb0a6355642C64Afb953f58Fe6": 1641.9,
        "0x8F18c4E799C250e3d7946409ae17838Faac0b0f9": 1640.41,
        "0x9f2c39Bbf9062603e4C785d123F50916735ef14D": 1639.44,
        "0x3085c13518B6EbfF0C4B2b1CFac35E9a65df26A9": 1639.05,
        "0xd5Cc9763394741845A4848cb897CB684686D0000": 1639.05,
        "0x6426385a917174e13cFa8d8FfCb3866adfE146B9": 1638.89,
        "0x819f85F2C07A0173b31532E7f26E005065cF888f": 1636.91,
        "0x3F59Fdb338FA0157e2328470A113eC8f38e13797": 1635.42,
        "0xbEfE9B5971660cD67c6897280B96e8BB07C6F91A": 1634.78,
        "0x367cF9ca6e152E057562Ac33059b535B40d7CBf2": 1633.88,
        "0x8658755b0A3066820A49Aa6cFe5d67B8c0eF64C1": 1633.64,
        "0x17006b713834a32A7D897d7930036703B21c8570": 1630.39,
        "0xA5e17edc9e57Fe6de0DeAfb1dDbFeD47651Cae2e": 1629.75,
        "0x3Eceb400Eb44E77dd125B69542774cd52964042d": 1628.83,
        "0x41509ac39df0386Db13E6070BdE94849163c5AcE": 1627.31,
        "0x79CbaE6CcDcdA93112F81f0de834A129a8628F62": 1626.43,
        "0x985dBFFd8daAf59CC68883d17cFAb313B2343184": 1626.3,
        "0x7eBDFe413376Bc9c399E2c566f51c814ef90b228": 1625.48,
        "0x4e5D89A736Ee6Ac5D31f833AcBcbEf61319a9CD4": 1624.05,
        "0x5C235931376b21341fA00d8A606e498e1059eCc0": 1622.27,
        "0x01F7CEA695248151bAcaebAb0d2E08Ae0a525b6E": 1621.85,
        "0x5E9ab5EB3C63c02aE2622E1548bb0C947671E79d": 1621.63,
        "0xcAdc11f5a2576F46F3A9D87a8e39F9c72f5F8F37": 1621.3,
        "0x3863A9b194f9665E4a3564bE141975278992B7b0": 1620.37,
        "0xaCDD548EfDc9558C36dCbCF7EAB27B4a3667293a": 1619.75,
        "0x4B8006998DDC98Fbcf62f2eECE6BD092B03FdE58": 1617.63,
        "0x4EFE29c86CEE4818295F58fc85fef78e09C0FcCA": 1615.36,
        "0x9769D34723d1a2eC511679CAec46b09a3003BDDa": 1614.4,
        "0xaB047058412A2d09B344f0FFCcb7526180c280f5": 1614.3,
        "0xAB85C08c07F6e3a4E3d10Fac404CA23b21457CEE": 1613.63,
        "0x08Da130258ED1C1d1B1dF819802A721E51B202Ef": 1613.47,
        "0x03A1a0EE0e2a14bd069c8691a4adEAbFa6a4d709": 1613.2,
        "0x8C9277158DD4647cf6cc9b9fE21F78Ae25fe42C9": 1612.7,
        "0x9Ca93bc60c93E01a61b3B15262e353D83782c18C": 1610.94,
        "0x2365887bBdb7fF611F54b380573a5055170fAE7D": 1610.18,
        "0x2dE38BbF00f67f2C3362cA4552F654c164886743": 1609.99,
        "0x952B18E50EaDAdeCc1778920Fbb37779F0957b89": 1609.57,
        "0xcd8a671717Fd1038884A0C095aa3875E6371A902": 1609.42,
        "0xACd97A24977aFA76D74c6ed7F363F6E4366F74bb": 1609.17,
        "0xD8A080dB0557C6882f3e718A0d492FE2A80Dc493": 1608.4,
        "0xFebA40c875b7989910F8feA4f96e0FEB0cEa59f6": 1606.66,
        "0xd07Fb7ED317736da67453246342b517F578668A7": 1605.53,
        "0xDDE346eAeceC99Ff62B8454fbd721593d40e2Fbc": 1604.64,
        "0x93196D19a5C5166be27CaA5Ae0D2dFA23cE3515c": 1604.48,
        "0x27e6b6541B6cc20C527e2c24205A30912EE7bAd7": 1603.96,
        "0xf202901a2a9A4B5BE59291b349853876cAfCe99c": 1602.31,
        "0x3216A8A03b07b6B19cBC21d62C8942e625fc3e07": 1602.12,
        "0x11110A1E22c2b9D147909436D1f58303EEE34971": 1601.61,
        "0xcC71f41424F83f9296b43fDa92D05c968A791c3F": 1601.21,
        "0x0bA33e76fB8262aF42De6FC3c382Eaa38E37DE27": 1599.84,
        "0x2133A199ca68Fe44cCdD8DC2EcF826de8E5c3A5D": 1595.38,
        "0x22937d6bd21880665FB0B8FA7d1cd40311b3401c": 1594.76,
        "0xE3B4C628a7fb3931881eFAf39C160fD4292f92f6": 1594.32,
        "0x919Eef36956776968b5c8F84973AE8895426f88A": 1594.24,
        "0x2A2b31Ed1fC4b330Bc8Ef71c68E1B7013D4a23EE": 1594.06,
        "0x86bB37F67b782aBc96d3ADdd4baE13cB84840217": 1592.93,
        "0x9CFB7b3e546E47751Fb592D72A6948B19A01dAEd": 1592.25,
        "0xdB841c93c274Be0cD1242db1d5dE8cdA844E44A2": 1591.54,
        "0x6A51BeeBb9bAE23c6b4f3b2813A2cE02eccE97Bf": 1587.3,
        "0xcFBa6D63EC822425775d3C509E60ff689C1Ae1e7": 1586.5,
        "0x927Bc4c215315C6a82370954E68d1EebF610b347": 1584.99,
        "0xF3BC245AcdC0C40C08e5921f9130701F5978B3aa": 1584.78,
        "0xDFF28Ec657651B447E426ff5385461af1cc4F76b": 1584.27,
        "0xb00b60CD0efD8E173989890ECe61F7f6B1FAE77b": 1584.14,
        "0xcee54C906E8eea8dc61a881aEfc35D698a39BE52": 1583.17,
        "0xD37Dbcd4EfA0220507BCC2A438ed73e79323B433": 1583.09,
        "0x865752c650ff401211A4C7528F596A87Ac7aF4cd": 1582.47,
        "0x8F9340E9342cd594Cf7867A5264c5F7f95E3716f": 1582.24,
        "0x6252D23762c78157b34194EFFf7C87d3bee4b1A9": 1580.45,
        "0xFF1cB94EA4C73Bc0B12e4139fF9De11082cF0215": 1579.92,
        "0x9914d914294630b9F51be76B2F9a34C2a6282d1b": 1578.44,
        "0x8d3ba797D8C39f3e26D8fd7eB2c4458fDf3af1e3": 1578.42,
        "0x7204eD7A6efbbc4361CfBab3a7E4462281Ea86fc": 1577.43,
        "0x2C1738BDD9091ddFA92B711D397dD4f3DD3A92fF": 1576.53,
        "0x26764Ce22e2afa2B6C9f2481A8984bfc63e0F382": 1576.25,
        "0xd07957550111934a0087A2bFc61e959D30b39BCE": 1576.17,
        "0x001B71FAD769B3cd47fD4C9849c704FdFaBF6096": 1575.19,
        "0xf7a3018f7656baE461Ce84f12278b7274AE5f8A8": 1575.12,
        "0xED0a8574387dc0f2cd0CC73a95Afe78d7A188E82": 1574.05,
        "0x19df15341AEf2EE713Bc18d87A0Fb4344212C62E": 1573.9,
        "0xf907685BE94582793c5c2ed24eC7C4F28aEDC5D2": 1573.2,
        "0x5cDF049AEDE480D07FEe61533eB32463CE6A58B5": 1572.9,
        "0xfAfAb6f54Bb9eDdf54570D0B4Aa92C278921554C": 1570.61,
        "0x5e334FC2eEc978478E84d17446d842bBd8C5Af7D": 239664.28,
        "0x2925afB329Ce2dee93A0AdfFDe65fBd12B1523a3": 1568.6,
        "0x85605b4305FCbe9f1867a4Fbcd26582657989e52": 1567.98,
        "0x9E31E0ea84AAD5073056BBe43AE9440d78bBe1EC": 1567.07,
        "0xE44bD2d031Ad3e7b851fAAD90E2659b9853CE166": 1565.39,
        "0xC89639890BA4b98E0893d2286B6B87b80394bB2b": 1564.35,
        "0x2cAd6593Bc15D9c3a0e3Df1ac343AF54eCd5dee3": 1563.76,
        "0xc47A4f42325515773D16a31EE44aE77EA98DE2ee": 1561.09,
        "0x727A7E33b45a6aB8CC9b1CdE8cD1941394462660": 1559.1,
        "0x369bce4890a7c60CF4B9998B0c1eF0C080De7A1A": 1558.18,
        "0xFEc11B5757f1694866155bd0989709ce58e8dccC": 1557.78,
        "0x372Eca68346A92C03a0D7EDc5f7E6A5A6384106F": 1557.2,
        "0x1E3Cf5bcDfAcFdFC193245fd8c0064d8C955D99B": 1556.65,
        "0x202c8b326cA75bf737fD709b524A1333681f0480": 1555.66,
        "0x153B4F4f2c6c284f844A53eB2e097D23B7bfa4Dd": 1555.26,
        "0x3f4000A6daF4eEc407b07dD496cd24d23182b1Bc": 1554.08,
        "0x7F163D66C5d395FC0Ea2cacC49cb1893b64d8E4d": 1553.88,
        "0xCB8139d3607ff3B6Df85f6325b4F807eB6e5AD68": 1552.17,
        "0x630394B1A474768eA1CA872F80342126D38B9e69": 1552.12,
        "0xAECf89718604b2EdB5B7Fbe6203448755B7d9525": 1551.21,
        "0xa38cDB63c943E9481c9b87DB5C80f5AC333d16ED": 1550.93,
        "0xdA071E732205F2b9976A097E6e0f2A7DcA00C91e": 1549.26,
        "0x803dccb2eE5b07427335B011e196991672EEf6B1": 1549.22,
        "0xA981e3409744382C4Af983Ca58a68E0fbF7D7EB2": 1546.9,
        "0x1f0807C760485A1b4EC451726C13CDCfB4ec3f23": 1546.85,
        "0xb8344d6D1f6a155119b2868dB5ae34D0E51f6380": 1546.46,
        "0x74608412bAD9EEe9b0914CB2c8B8d6594B3ee7d8": 1544.83,
        "0xB71bA81a183b2F956c9820729642063D64780b93": 1543.53,
        "0xfc38C8569d4CCE7E991c57d8C7C3341e47Bcb41F": 1543.07,
        "0x9c0f95A2fA96Ad2c03483e080c58359612972777": 1542.28,
        "0x60F274a61EAbD749995dceb3bc080F256Ae6CD4e": 1541.41,
        "0x8e46c60a1Fb0904B404b691069730E7Fe5dE58BC": 1539.84,
        "0xD6d78F262C978668d21c1798BAfF1B7c2041053a": 1539.19,
        "0xCa934F77e2B762C244fc3a37EaAC9604440AB4eb": 1538.21,
        "0xDF6C5cf32b103e68ff904911c86Ec7A19cfEBb1b": 1537.53,
        "0x8e1dB74Fc28e8d866a35b49cE3ad4dA9c7c18485": 1534.61,
        "0x4007486416Ea09aBc44cf6D8E3061630E36483Ab": 1534.43,
        "0x44A088e784F2A7936C67D772f9e06dF5093663bF": 1534.1,
        "0xCCa6457c8E77C34848B182aA6544Cfd5022A2eD4": 1533.53,
        "0x66f1941053E13730c7A9E78c39c8D5F965B5c9FB": 1532.96,
        "0x0fCde807C578F398fb2Cfd493A908d7b9f5Bc1d5": 1531.85,
        "0x00494eb9E11677D46AB3f676f8b6400F845Fac2E": 1530.44,
        "0x7A8C46B6abE17e6bB80A7D1e98a45b3aEB4708B0": 1530.43,
        "0xc5BE928C3D096969842a3524A3bFcFf051d7D68E": 1528.56,
        "0xB73CbAaA89F2d8FC2108538dA561D9C182948c16": 1528.17,
        "0xDE3ba1B41e6c612a3Ca3213B84bdaf598dfFdb9b": 1527.55,
        "0xD4d2a32Ae4FEC3F86d599577138a26fA72516541": 1524.63,
        "0xc3541A1Cb6d44B48cF71B693dAD8932227271def": 1523.72,
        "0x3a2ACC5f5CFc976EB517008fec19A506501b3130": 1520.88,
        "0x5aE3d91433231e5Ee2c3CaB48f1f6E1c3b1A9bd9": 1520.56,
        "0xeFcfFD23BA7f0b71848ddaaeCdAD4BB8F6948BA7": 1517.84,
        "0x914D64D8416247A90a961A60A5328399291b210b": 1517.48,
        "0xa1De98B0aC96990395Ab317cbeDafF6Ab4DCA8Fa": 1516.69,
        "0x3F0210656Eea50f414ed429fb7D931AA86f4a625": 1516.06,
        "0x69e02D001146A86d4E2995F9eCf906265aA77d85": 1515.46,
        "0x764f4909251F81976A0A2DCeBcE95333e4C27517": 1512.44,
        "0xc19cEf52C7d485e9092bc30695e09212Ad3ED778": 1511.46,
        "0xBA3d570535360bc9383B28691C872959d4A34061": 1511.14,
        "0xB202D6e271645a63C6e2f0FD8098725e0D523015": 1510.93,
        "0xDD0CDF8D98d9Ad3ADfaa49AaECD444Bfa01d9C9a": 19520.085986942053,
        "0xdf19049d52B307BcE8EEB325a2c9cCedc1939BEC": 1509.92,
        "0x11661EcA8f739A51b59c954a2b310FB8144Dd5E0": 1508.83,
        "0x88db161ea72aC28102D5B5A48754E0b3C7188f90": 1508.63,
        "0x3213886983eEc823A78fb194dbd4FAc92B4E5741": 1507.9,
        "0xF597c6452aD43651E8e6B1D35abF9e383D985e0B": 1507.58,
        "0x33B522FA0b8511eb864AccC05f175f8b6Bf03705": 1506.52,
        "0x7c8e10570F396c427f7612855369E13077576779": 1505.15,
        "0xFa11a5dFbDfbBBd548a5A4d946c4F957c744F20F": 1503.5,
        "0x3b7742eb38aAef2177dECBe7Ff673c44E2257A39": 1503.14,
        "0x99b5Fb37B04C966dCaF1EDB5eA27B08644Cc4d08": 1503.13,
        "0xCD22a3962A067472b335CF2564365C3034Bc975B": 1502.36,
        "0x1C790c86171a878f243c67ae5e785F3A5Fc62Eaa": 1502.31,
        "0xf2a1d9FEB1f2988C7aa2dd4705289b4A1F9d8C7F": 29503.621823123896,
        "0xa5B9d747f1D7e4e24f59443C1dCd221731455EA4": 1499.67,
        "0x03c89a40b3Cb98f6E9e1873c3BbeFC7939B46682": 1499.22,
        "0x6722ac3fEbD5082b5b1B39a3F1E069dB7aDe186E": 1499.05,
        "0xFea1Ae6da352b08F61958800De6FbBdf8DEEF002": 1497.83,
        "0xA5C73C922b704ABfDDA648775B78ea4dbfB1dCB0": 1497.63,
        "0xd35dc936722176A8f1F4bE6e6908a7Fc102b9655": 1496.47,
        "0x0810f4D416350687c2C30505f2Df374baA8010c5": 1496.21,
        "0x06232028c253dA3404cce43A4789dc802a62C846": 1495.81,
        "0x5557D32FC4B2f3bCCbb3429B7cf092e56cE0EBEd": 1493.29,
        "0xd9033F1F21d5e86AD7f5FfE43E36604f77e2eC64": 1492.54,
        "0x4F68Ca72550A0b59439678Bdc9190f1F5278D7dD": 1492.29,
        "0x5BF2B6B176B98d20eACe5d996568f4F1E69CfF24": 1490.27,
        "0x1B98d6BD397b15Eb44802215e7219cc3DB850274": 1489.46,
        "0x7700912B69F128A0B3f062b05f19EA6A8b5E9aAd": 1489.4,
        "0x1739502e53900aF280f0E36fdede114464326369": 1487.48,
        "0xFcEA91E004426c4D6f17c0C0E9015AF935516EE2": 1487.25,
        "0x90fba317634F4cBd99Dba804D8d4be583126606B": 1486.74,
        "0x1b0a09Bc99292f102a3C4Ccec85432128C05E704": 1485.74,
        "0xFa347793D0f0EA3A436CD311ebe0c95B1f089974": 1484.73,
        "0x9c92C1ef6606396B8dE0D0620A4Dd37f7c0A7527": 1483.15,
        "0xEC44d02fc25BBA6a5dae504fB3F7d787DF3993D9": 1481.71,
        "0xE1E5aff61827cBC00989FF0f36016a46FcD16633": 1481.45,
        "0xa932aEC0DacB1d1f04A60E2a9eC972D7d2C4b263": 1480.7,
        "0x4e505ba5bbc29483CBcaE0f32F8d675516E8904F": 1480.13,
        "0x40aDfc9e2c6FBd77A62a6958B190F1ad535c2e8A": 1479.94,
        "0x00aB97c782c661fb3D08C96dce06176938101211": 1479.43,
        "0x3D9F87F345c7d343DCC1170cF555E58Fc19B7C44": 1476.28,
        "0x50c55d3448f528b699F7CdE2F30b5851Ed7Cdb69": 1475.71,
        "0xa32ed73EAE62F165E3B3ddbEB19100e3cfe17fc3": 1475.4,
        "0x87dd9282247D03e8415C37025137752522DefCe1": 1474.65,
        "0xE84ACb5265948780228E2D76d0AB5f88c7950422": 1473.58,
        "0x228Fd5f40447657e6eCD747988ddDB251A0a3cE3": 1472.49,
        "0x75dc611683639Dc7dd4E41bdE53C5fC763804af4": 1470.74,
        "0xcD104FA841D0fFF847e71B9F6FcFA234Dc1F4AE9": 1470.62,
        "0xe7363f2dF32A634FC29F269383245b099A7a04EF": 1470.29,
        "0x4e34d11741899356bCbAa802Bb0e739A51E8f660": 1470.16,
        "0x8C9a169f0A4E3daA2E8d885F1F170dda11DB771B": 1469.33,
        "0xE1aA441644ebB251EC57F63365BE55D2668F5967": 1468.39,
        "0x9bF68A0f0be9A9B6dCeb4D5675745c2f7cFb9483": 1467.82,
        "0x0D3015631c1E642e8Eb35b5A0efcea24A7685603": 1466.59,
        "0x8fa83D89b6cdf866f27e175D2A4b40d0ffF69E53": 1464.26,
        "0x42a528b769cfB8E4720919446919b5848d6bB458": 1463.22,
        "0x692df2b461F8791c7227D01A81da0c5638f93394": 1462.14,
        "0xbC871D302a202dA7D79ac1dd9563E0f2A27c71B6": 1461.76,
        "0x9BA6df247EfcA09D9546a1a1eD467B25F3793e1c": 1461.05,
        "0x0960Da039bb8151cacfeF620476e8bAf34Bd9565": 1459.54,
        "0x53e213da8C28d85dc6663c3b5e35Bb0ffBb05752": 1457.27,
        "0x18ACc7e09e5b4adAF4d51DcE21Bc2ac616EA9440": 1457.02,
        "0x9Be0B48608fBaCa515B760a19c262132E07454Ce": 1455.13,
        "0x62E1af3e818aFc059D111C4F53CF0a2D9Fd29110": 1455,
        "0x0349Dc3629e09bB939E69B6b781E5C8B8b9ab432": 1455,
        "0x6b6cA48DA27304eeEb1D15d355D948f68b852733": 1454,
        "0x241f402a3ea6ECCb73B9c5B3B6426c28F99D33E5": 1453.68,
        "0x29c53930CA9757dA7C488b257Be3d1F6548DB7a0": 1453.24,
        "0xf1b0e78A2bc422dF50ec9EE4C324895C9b79F80A": 1452.99,
        "0x6c28F443C491F941dEF2fd983F4ce044e1C52a29": 1452.78,
        "0xC79876CC32558e7CAf38d53745ddA2591a4849ea": 1451.49,
        "0xA90973E64d74C3a71A645497ab1be77E786213e8": 1451.37,
        "0x3c5AB1fa39beA9065ec08Cc30283d84b349B69fC": 1451.3,
        "0xE39d00d4d15C45B8338C5635E7fb18FdEfde640a": 1450.97,
        "0x61313Fd5843223365dC7c46Fcc2877ac3645122A": 1449.97,
        "0x564239Ed5f2aE88FEce563B2ce43838B34A0BA86": 1449.62,
        "0x57F6F77da955C8FA89f3CF7973a1fB8054B56204": 1449.56,
        "0x44c630a1fCC2817E048cC1101050a18F919Cd099": 1449.46,
        "0xbd0b71b95EAc0ea4447790f9Ee50658E3206925C": 1449.38,
        "0x8151b1055198D46BDdAb703052e6Be6b13e743E5": 1449.22,
        "0x66604Be473e0Fc931F3294EA493B29f11a754eA2": 1447.62,
        "0x78ce9fe8D59E2e39fC100A02D30109B16d2D7fD9": 1447.45,
        "0xBaa9B493bCCBe1A900b39870980f41356f85822a": 1447.45,
        "0x3542b2d6172bF3F39aB7f4CBC37aD0Bb40DFe403": 1447.34,
        "0x56dD1EF83C8f90Be5fDf16982630e613E8d1C1d8": 1446.94,
        "0x4564d6d107a19d3AB3D734A7BaE61Eb63dC3d30f": 1446.44,
        "0xdAa4733bf26b80438Bc5f7DBD3296817Db13D18e": 1444.31,
        "0x666dC10583FED3362B914e1a6eaA462455e2e8CF": 1444.16,
        "0xa33ca84383baC2Efb11B8CE21bC10403Ff9CC77A": 1443.42,
        "0x2C629076Af75C971A4F608F965A21BBAf6D079C8": 1442.1,
        "0x49Fd1607a0b93334F090eBaF42C72BaBb38a0f76": 1441.9,
        "0x26C76dF2abDC0255b82D3Dd48D2a748Aee81bb9e": 1441.16,
        "0x09bfDCB05Ac0e0f9C7843fb3CD8Ec4750700D01d": 1441.16,
        "0x68b53Aa18D1b8437B7CD9524040C776E2261e06d": 1441.16,
        "0xd7aE1205dE384D70CCdAf057e1870eC7cEdc5928": 239535.09,
        "0x1b7F4A74D261500BcbEe38a11208c47ceBC51167": 1439.64,
        "0x99F1396495cCeaFfE82C9e22b8A6ceB9c6b9336d": 1439.14,
        "0xB686D2b7F6e6f71CA9b6787aCa103660A68F48Ad": 1439.14,
        "0x9bA150561c80B8Dd5BbA76491E1aafaeca4f8fc7": 1439.09,
        "0x1b90B46F9Bd6BDcF0adDc4D0601dFAD832FDB1bD": 1438.88,
        "0x8ED07226eFac3F6e3543626aCCf302095008b613": 1438.59,
        "0x8Ffbe6d99402950b359d71f5f0a7ba949B0e8a5a": 1437.91,
        "0x3F01FA6e75f9d0477108F994400280b71915Bf56": 1437.56,
        "0x1dC2D6ADf253665748F12aBF0a901aC3bD774C31": 1434.35,
        "0xCb926F497763eA5CF993912A442431E6a91d5A64": 1433.84,
        "0x510bd1A857df836c2ad57aA3a6fAE396E011d958": 1432.33,
        "0x929017cf2fDeaFdeD8bB1261DB87E91104A72aB7": 1431.47,
        "0x1B45B83A237b868d3eCB822988C88017665701d6": 1431.09,
        "0xa87a7EC43ACF48E3fc49D04C0165538f2fd78Ac2": 1430.5,
        "0x44Ef1f545563e813e3090b7aE9a7fB777d42421e": 1430.34,
        "0x1E07333d9DEA8EA695b905cA757ffA1A6fEca439": 1429.56,
        "0x6C9ccB01d58222B1c05A1cD1b7aC1443E7583e54": 1429.4,
        "0x9bFA71a326A255e1984C97F72FE361dAE34872Ce": 1429,
        "0x35063502261a6aE919B91efBB569252A3628f5c9": 1428.07,
        "0x51f4128EB16B3C8F36bdE10b00F163953B11Cb50": 1427.46,
        "0xD6eB4C0A3e09aC8fAaf1430DD9c7f21970203aF5": 1426.6,
        "0x44ca547Bf0116ce6c433aC6CD03D78FFcC55Af4A": 1426.56,
        "0xaEb35dDfB253179803f6c7dEaF1Acd64d11ce2B3": 1426.12,
        "0x0A3C1312cE76918D9E472030dE4aD494AD250d7c": 1425.78,
        "0x328fE286b2bE1895959E2601364AfE9DAA22aba3": 1423.96,
        "0x885258EF26Fa87D0087c7e1898F16e8AF997EfDC": 2832.6978736406086,
        "0x53Be5579FaBe5Ff2c0bAa001da458e6f0Ef1318f": 1422.82,
        "0x29EF03315A726e9cb54764063652c1dfE2b2d592": 1421.48,
        "0x923BF0C181e4447e1fc2deaC663fa89191F64f1F": 1421.43,
        "0xcA95f155aCc701Ab86506B0BF1b4B16FF407843c": 1420.55,
        "0xC355b969A72b391B288ba0222FAa2dEe957b378D": 1419.55,
        "0x80a6780Aed72A59F8409aA212838576B1540b4fE": 1419.23,
        "0x811a576Ec4C99a632190C1E6b836Bf7d79169B11": 1417.13,
        "0x2f29459E998e229e3a6B56150e37C50CB3BafcAc": 1415.61,
        "0xC6D9C5c2c98564Dc18Fc7Ce5E5C16aD04E7D3b10": 1414.46,
        "0x829A2Eab39aBB84C1E0Aa621736a14443b5c5075": 1412.18,
        "0xe48d4Be8FDAFbFBa520491d99E3b5fc2cf2c194F": 1409.96,
        "0x6C78Ed7d2808729d7F8bEE862318A20e8348e3cA": 1409.94,
        "0xa59c4eBCCfcB3283759B8044bFCb68aCf4603e05": 1409.4,
        "0xE800693DeB220Bb0A46560B32EA9B22515a8Af91": 1409.23,
        "0x8C1b98a311567308b7304E7938799C5C1FDa6E8e": 1408.65,
        "0x3780714829bF3186aa90681b59bcEC8F39C551e5": 1407.92,
        "0x92BF7657DBd6DA03D548128A1dB1bC01F4dBCEda": 1407.61,
        "0xF4D6B6c09c7ee884481B68cF0E26c91742E3AfE8": 1404.87,
        "0x9e23436CFab31Bb8f3274b3459a7eb7fcF5A3C53": 1404.16,
        "0xB1D5A18649EDC3328ea858f5357391f5bF84F1Ad": 1403.85,
        "0xd2c6650610283d10AE5B84DA6bC30011c914bFEA": 1402.76,
        "0xA4f0B6899cA568DF1595A3D12054499E5E1c9FAf": 1402.58,
        "0xEEad1396fe5f0daec6DbC04d8a43E85dDE4d97DA": 1402.1,
        "0x12e18Ff5E3CA5B262ceF7F4F72b75882c142898a": 1401.65,
        "0x0C17e90B95a16BA2b41FbC4E7950E6eba13F85c6": 1401.1,
        "0x2d1d874E4d3369b500bf2aAD0083Cd85E83FB8f9": 1400.25,
        "0x4915047a2FB94F0968793ca3fF38603737FfeDC6": 1399.92,
        "0x37855736CAf82F8978f858fF4F8DD65c51B7D0E9": 1398.05,
        "0x6bcfEd1a19BDB2702a4233DdEdD4F5047de6d674": 1394.9,
        "0x1A57F964184Dbb0Aaf7796072759B345DF9E9F6B": 1394.04,
        "0x22d5E260ff59B96e342D67788ba777eCD1ff9AC3": 1393.16,
        "0x8d893429b077455f0dB9bc005536f441785eEeb2": 1392.53,
        "0x4Aa60BB66fF24230dD0b8fA5F419D60F45a067a1": 1391.02,
        "0x94b2BD4a7fdd0bA53C4550EEAc2f35c1a454674A": 1390.08,
        "0xa41f244B14e8149DC4663460DC7B764F9067e864": 1389,
        "0x1138f2c7E2198d6B1d7dE80377454d280F6877d1": 1388.5,
        "0x5269E9c5F70118937858AD4Ab9F9CB5847853aE5": 1387.72,
        "0xaC2C5c5E2D819a2A9fED1949d0aceb5705FCdA48": 1385.58,
        "0x020Bc7f28CB1f8B8046DBC7880Ea384CABbd9e02": 1385.46,
        "0xAE4aBcE9aDc6F4adA638CE10C5643f9429520E76": 1384.47,
        "0x17C455081D9130E3D021e60ab976a3b5299803aB": 1383.67,
        "0x31a4c393456C7ee342720eEE14082A3461520Eb2": 1382.89,
        "0x0668e9Db4162207908a2b728807E23a9bbbc3882": 1382.64,
        "0x92D9A8BFd4B034917b77f8A7B867aE9ADd122746": 1382.4,
        "0x25e2A352478B83dC0DE5d74beC53A8f13d4062B6": 1380.94,
        "0xf7732326d9465001c12D4605DDd0FA9491a385EE": 1379.22,
        "0xbB73D7E950F659A78f96B22f214727E865514fC9": 1379.01,
        "0x60C6AD35127EF050720bdadDaE7e698e6EFDE2D0": 1378.86,
        "0x136C65a3f31682fcF683906DDbF3C76db2633F99": 1378.42,
        "0xCB09730A0746021EB1cAcF4E5DAb8E262845c76C": 1377.81,
        "0x8fA5ebb986fA6Db89291a383142BB756aB88428E": 1377.42,
        "0x4670a5563a3B534A4482D0d5B36F010a9AaA5788": 1374.27,
        "0xD70bD78A9132214bc8a8343Dd7Ad68Cc4b7e994D": 1373.89,
        "0x96Be47E8532b3FF06b456868c9f426ABCE85b9b1": 1373.8920582339695,
        "0xc411cf44254c4b80359B8741b00dafD37d3999Cc": 1371.52,
        "0x37F8c5c4ce1718DD3860a0Cb78E309bdC6B3D7B4": 1370.77,
        "0x101Eb8257d669C3009a7Be8f6Ca3a469dB5E07Ea": 1369.4,
        "0x8e72C2c0Fea3a798F34e2F480F6445748d61Dd1F": 1369.07,
        "0x3A0E181989B21AeDEF6Ed10E3ddF8f0e469a2151": 1368.85,
        "0xc0e88CDD85E832e1f946FDd7A75228f198eDef0c": 1368.54,
        "0x331A1D942e7850b4a1803abceA8Eb2E6482D7122": 1367.52,
        "0xa6914e7be6278C926A077fbacE6e2A75ab5343EE": 1366.38,
        "0x0123974E5418EdF3f35282dd414c2Ff9f8866124": 1364.85,
        "0xc7eC059a34CA42ED067ebAB7dc22c1Adf6B4294A": 1364.7,
        "0x3b0c34EB18cF7a10cC37Fd44Ab3a58376EB19056": 1363.97,
        "0x9029c27fAC3023229d777D7187B6EE658b31D416": 1363.5,
        "0xE6fD3A08fbDA2397f81823233daF61c410fe294e": 1362.99,
        "0x3b16F6f8Ec1bE0DE87d870E235fdC58D279727ff": 1362.43,
        "0x16760803046fFa4D05878333B0953bBDDc0C20Cb": 1359.78,
        "0x997E4c5708904A8a0A6747607D0Ae9588888CDc9": 1359.29,
        "0x9770E942e19aeB9FC935980cEB5eC81C10b1D030": 1359.28,
        "0x9Cb71449CC7D9A810b376243029e0eFce2428a5A": 1359.06,
        "0xe06924Ff9A06f13CC1Ee25AeAb8ad90695bdBcB1": 1357.8,
        "0x17A1B47d2027c1e3304bB1903e4733b0a8D4BcCF": 1357.79,
        "0x42F28644e75C9c2150dD21ae09CeCbfc6457D471": 1357.78,
        "0xBAE6379ACaEe0FD0d5922CABa1895292533B6FB9": 1354.75,
        "0x254dD57D751622f76803466EC9FaCAaB8A7D3AB8": 1354.75,
        "0x9B86a62452B795EE0D7C7F5a1115A31433d2801F": 1351.02,
        "0x7abDEF5Eb43d74227f4B5CA253e1b202332ad044": 1350.52,
        "0x7d3B064DB69f5ae790C56881aB45b7E1Eb2DC63c": 1349.1,
        "0x7DDcA6c31F56727c8aaBe4E641Fcf43633EC9784": 1348.45,
        "0x2407BE874FD09A03426Ec4E89902FDAcE3a43dD1": 1345.58,
        "0xdB7bd73Eb596836eDb6975bB015B7F2F5Dff7d86": 1345.06,
        "0xbb9D3fCd8Cc230adEb8d3d86f6abC357Eb228552": 1344.96,
        "0xabEfA7f913eAECe302231A7a6f74b1865289b5f4": 1344.12,
        "0xe06EebB5f05C271a04A8Ff8aa8C1a635CDc2c788": 1343.89,
        "0x28197a31B0154433c62ed408D4C03a0a65076b8f": 1341.14,
        "0x8bDe011B050a3FDee1EeCAa65ae8E938e61AE23E": 1339.67,
        "0x7c1F83a43571E1C24DA38b2CB78Cd8E32A2C90F0": 1339.43,
        "0x6921B20F28dbD987f2634d76fEab357263defaFe": 1338.52,
        "0x8B3f14F0582FbF275BE87d265C931B4dfD5F13B7": 1338.12,
        "0xA0Ad97d8808D12cE69622626E1A50276715F98dd": 1337.51,
        "0x5AD09118518F79bF872147ceC849d35584d61d74": 1336.44,
        "0x2Cabd36AA48c40Ec4EEd1b752b5902EcFC7fd0A9": 1335.6,
        "0x19832Bd5104D1327222048fC78e91Efb099554f8": 1335.04,
        "0xF7E0e0a06658647e7e8F824492884eE1BEfd9525": 1334.62,
        "0x2A8411EeD6359983876c1314386542f8FF32FB0B": 1334.09,
        "0xb48CfEC1A9bEF55AedBBDa9efC2885F0B2C437e1": 1332.86,
        "0x424b8dFf1AB6edF393A9D75d8E8C3f4C96BF2CAb": 1332.59,
        "0x389b8e27e2f0b46F49476D62B822899a9a709099": 1332.2,
        "0xDe16A3401Cbf39e166735108c13C6Fea9EA48A66": 1331.83,
        "0x40F313cD10b7Eac1651a66B90010bd4fA6CF4ddC": 1331.57,
        "0xEaCEB7f4cddb1177b752Ef682ad7A0c5cD31FC05": 1330.56,
        "0xb629c8516f4Af73E61154e44283DD32aB2ae03ab": 1329.4,
        "0x0Fa547c97a90373Fb9660d159540f90c06D27773": 1328.9,
        "0xE66D9BB77c3859855FefD091beC8D6d0c56CBb8d": 1328.71,
        "0x9a145DEaC42faB3B878Fa606f48E519604a04563": 1328.52,
        "0x206ad867B8d42BeE5D95E67A81D67435faD4eB2C": 1327.78,
        "0x7ec6FB8645e248Ed8b26228B19Fb80dA652d3dEE": 1327.58,
        "0xD272286e84B50748370d9920c317fF2924d10769": 1325.69,
        "0xd32eF71A0Dd571dE695d84Af6052C7f058FEaF98": 1325.48,
        "0xE961066D859D4922b51269801CD26A2351c4f1E3": 1324.96,
        "0xC73a0Ba657374dE66FeB4268F3D2ea5F4FbD5350": 1320.75,
        "0xEE57D8989170370a6f88B2f99395b81204117bf2": 1319.78,
        "0x2D5B4c25a99E11F57FCddb8F3B60f8E99b509453": 1317.74,
        "0xA2FCc0196a6506B4b5A5eCc407B6811320ce1313": 1316.77,
        "0xBcBbfF6041E563dF78cBaa6043Be2c8F6cAed0eA": 1316.73,
        "0xC92EBDaf0B936fAE4F21d8c8A4e769a9A1C42339": 1315.66,
        "0xb7DB1273E05BB89c9c4858D3b0A280cF9dD38d69": 1315.45,
        "0xcD8a0D2C7D41078B410D145aa4b25100d1638222": 1312.5,
        "0xC66B22a2bf5f2FdB289537Bf65D2539d2548109d": 1312.08,
        "0x0737d1A3af4767620BAaaF7bA45226a2430981aa": 1311.09,
        "0xEF9b3b7FBfF9587F7bB9cdA3171400bced0906D0": 1311.04,
        "0x23C13DFe376bFF288e7BA6C602725f21E426b95E": 1311.04,
        "0x3a54157aC9f5e678Dd410C668D2A7502ddc08645": 1311.04,
        "0x453FA5e706E842D35C5C36b44d136D3919f9567F": 1310.92,
        "0x7476D1e9659a49B92C3f65F0A6De00a18fc3D6fA": 1310.41,
        "0x940Da2C5bfF7513b9dde61B3dFa7f23fA3a4ebb1": 1308.39,
        "0x0916b2b1897D24Daf86840B5E83F2a05264F00fa": 1308.16,
        "0x594c908F9dc95B66BC5E1108773cfD8e3b3C00AF": 1307.28,
        "0x6A0B55b607D3B2104E4a1ac1dc53bE77d2A9E145": 1307.21,
        "0xC255a5f24Cb7d39377E5C414B0b73b2F186Eb7E7": 1303.14,
        "0x00a9b1721db9fb21C51EA49989a475899FF49312": 1302.96,
        "0xD4Db2Bb94f31A2e7df698b69134FfaA78a11A343": 1302.85,
        "0xdeDCaFA8bb59aDB3A72730f7573E271422939e5B": 1301.19,
        "0x5C6A64046801D2D1775BA57867c90c6d0436FcFa": 1300.81,
        "0x19213f85107ba87F06aD10894163160Bd8642955": 1300.16,
        "0x973DB9dF46606b3542872E47733F50139767e50a": 1299.5,
        "0x199B8F1f8E4a71a8b1595AA50dabA17970407497": 1298.82,
        "0x133D20c739F76236eEbacE7Bf5BfA751BfF15a9f": 1298.32,
        "0xEa0AdE20fB1288975b43190215e17BEd3BC1d371": 1298,
        "0xFD9ce79FD7F62ca88acE958cD2716f4CCe25e2DF": 1296.3,
        "0x11EA7888C0020D34CB37e89aC8bd544120bb16EC": 1295.8,
        "0x7c55C37Ae3da8272c41eeFFf9B6B3C43f6Ef713d": 1295.8,
        "0xe6be573E78AB4Adf3e61E9e49141857922CBC556": 1295.45,
        "0x06dc1a837269D1c8496023FDe01312536161D242": 1294.97,
        "0x01264DCb78240FE10408c04792711A4583ce7089": 1292.19,
        "0x95f310d284f387738B533dEf70973DbB4Aebf6f2": 1291.58,
        "0x82738b0EBc1d667765cB9CDEB4A2a96dA6e6A77A": 1291.27,
        "0xbFC4fBBeC37c291aeD1d14f02B5221d0bE0Fe8f1": 1290.12,
        "0x51A8D07788571F545658E34dde71e1E7c21aF19c": 1288.75,
        "0xC56276E7D8Afb73C915B3FECdf9b594AB2f11353": 1285.19,
        "0xd83410EdF02eE6c9F801fC81FDC89f712F84a81e": 1281.69,
        "0x37dF0e34DC942D2ab60206748FB101Fa51fD7992": 1278.67,
        "0xea41F0B66548cD2A7F60fe9e3f7e50189913Ff21": 1277.47,
        "0x26DA817F78Fe2DD5cf730382E5BEc4CeA3150305": 1276.87,
        "0x96a2699644A7bE70A4f6Bf4d42548f765399D649": 1275.14,
        "0xEf1A697E052Ad7AAf2AD02c4B652C8a280FA8EdE": 1272.62,
        "0xbEE2D469AACB46251aE33Cca91F482e26c971dFF": 1270.12,
        "0xcfa02c50369eC81FCE92330843c87D8b03F2Ce27": 1269.7,
        "0x947ebecd725e07baC225363F328De957AA5819b3": 1268.85,
        "0x1902EcfC34A4D2289759AFF23f6F104BC9B8eD53": 1267.08,
        "0xb02D787e006E91057062f3A56B8dE71665ED473a": 1264.92,
        "0xD1eBFDAa76D8873dec4C68C91148D4BEfBd853A6": 1264.56,
        "0x622F88102Bf8D68e65FAf109f66E0781b46Bbed3": 1264.06,
        "0x71535AAe1B6C0c51Db317B54d5eEe72d1ab843c1": 1263.05,
        "0x02BF3258D6024B2B34fD7D21F225Db6CDA939E76": 1262.55,
        "0xC2C5cAE84ebDE7e29c9f8C6331d2E9b8137A84E1": 1261.04,
        "0x4c7eabe657187D2c8C5f7e2bb453478f72fd00c9": 1256.84,
        "0x38e481367E0c50f4166AD2A1C9fde0E3c662CFBa": 1256,
        "0x0Be4EB0e89abEd9f52D94F1550c22A16008cc463": 1253.8,
        "0x81F10d99464d604EA1E9242DC71733a506E95b4e": 1251.97,
        "0x38085d984C33d4Ae2E970A0629c0B5FB0403924c": 1251.46,
        "0xbFe24B4d8B1E421ca8794f6416946dB505d6dBD7": 1250.6,
        "0x38AFF755CaC6124b85169483eF7cBD59CAc21fB0": 1249.34,
        "0xAbBB7F82cC7112bcde45188a1E0e8303e574CedE": 1248.89,
        "0xF35153BC3129438eD3dAB917082429582aF711dd": 1248.44,
        "0x69bbBfDE43c49fc50f5647223dA5ef4756D78659": 1247.94,
        "0xDC2a4bF46Ef158f86274C02Bd7f027f31Da9EbC1": 1246.93,
        "0xb54bdfFf8A4f7703Cd5405E8a0E550D0dc68b9F3": 1246.93,
        "0x4bdA02d39091399aaC5C318d44A7bDd22598dF28": 1246.4,
        "0xAAa5367B0f777e88f3291b572eb27e798526F5C5": 1243.91,
        "0xcf1e9fb3AA42bc4F888cfe1161F3778E71141453": 1242.4,
        "0x79556392Ba14bA7C62461B0809A1127FD74834Da": 1241.39,
        "0x4E713838a9669230fA4C7C8446FbBDBb18656A9f": 1239.67,
        "0x1325A694F22f9Fd4fb67e838F46bAc28D744AA7a": 1239.48,
        "0x3c054956b4d80cDe530377797d2657479555903D": 1234.05,
        "0xfb001153e9D553f91e9899053324a83ac138365a": 1233.7,
        "0x160Cf6551ee3d910f673AF762D5a2f1bd4855be1": 1232.48,
        "0xEFd74B918eE8FE82f006dd8d1Aa4245407d5EEFa": 1231.48,
        "0x3eAa110442F994c821d18fCA9640Ffbbb1Ab79CD": 1231.02,
        "0x1Ce0C2B445C8E87EA4C40B6e721D9A39B09f6459": 1227.28,
        "0x793a4Cd73fEf2561c7762dc53eB89c68c30210a9": 1225.27,
        "0x0E669e05F7f71944B25a2c20B2AEE14e1C296dD1": 1223.86,
        "0x8b478359B5593747473e67f78B1f0048C1C523eD": 1223.25,
        "0xaaD02dEA3422cE7b1B7E9797B80039C2252b5463": 1221.31,
        "0xCE617EC677c95eb5506522EDB44592eD6a18Be67": 1217.21,
        "0x4E2b2E1E01559a77a30eaCBE78ef02fC77988872": 1216.44,
        "0x93C20947353996eb928aF059c07546814a7f88c6": 1214.53,
        "0xfC6C84bD2C5b909227F9F691a03f90922c983376": 1214.53,
        "0xf0897d5a5D4B959d189a791A574AAE5A09e1AF0D": 1214.53,
        "0xbE681d305f9AC149eAA565bebb4A125eeB06D7A0": 1213.64,
        "0x6CE1b44D5DA46612bEcDa2E8Ca5Fca475Fe8506e": 1212.17,
        "0x85FF24a082a902B3D6195c784cB9CD370645a5C1": 1212.12,
        "0xf903672BA62039591812141eecB4CFd9416CfC83": 1207.51,
        "0x91Eb12839003631e3a1550f0b4B59148bE822dcA": 1207.47,
        "0x0A4fC1B3308e763A6A322f38138748a781D5B576": 1207.13,
        "0xcACABFafF911d7fE25247E9aB6b8C8D19E37F21a": 1205.51,
        "0xb1850c6f7a36E147800DD5C5d0e76C7e3967cA62": 1204.11,
        "0xF61488D8C97CBd5Ac47EB19034fFcA1C543a6F47": 1203.6,
        "0x89eDC11116CA95170FDFe2669F66dBB287dccF7a": 1201.59,
        "0xBce3Bd1E1Cc867d6BE17924E4D53ae1cc147Dc7b": 1196.55,
        "0x7abAE7a6d10C8a91a2c37B43fD5D019d920a8d05": 1196.55,
        "0x6954f7ADd88b0c0a2761A5DD0a56913df88894C8": 1194.46,
        "0x64766F7Fb8Ccc99c5FDba54e2e968d1d244B83Be": 1189.47,
        "0x1F452Ea54d4d934AfAdc300C61ca0A3B1bbDE958": 1187.48,
        "0xC814d2ef6D893568c74cD969Eb6F72a62fc261f7": 1185.47,
        "0x3dC606cE9cCA12196917A3267A8AE7008E018958": 1184.96,
        "0x13E7652B9eC7a97a4A98906FC20338AC70940f98": 1184.46,
        "0x4B17b32De85Aa3636929AC2CC029b95173B2Aee5": 1183.45,
        "0x3830f1290Da3fDB91A337a1458aa34f60C49FfCC": 1183.28,
        "0x9a212305c951911D92fc7a457c48D900e33dfecd": 1183.18,
        "0xc8f7b747eefc216964E567C14Ec823d17D25C932": 1181.94,
        "0x6613a1521394C2F17c7d705e48279E44c2A01936": 1179.42,
        "0x3b1c9D24C46df6AB9775D6Bbb478987cAA6018A3": 1177.91,
        "0xA4a8840b76aE2fc50C4eA9aF37515BeeB92957A3": 1176.45,
        "0x9c0a721Ff76ef77d4c7CE7dA315c26D865a380AA": 1174.25,
        "0xe5D8D0Db0043b23e9f6400b0BB163CED73b8D28B": 1171.36,
        "0x19300B956D3a147F526D935df5159799522BBaB0": 1170.37,
        "0x8C85F4b81e6E43a81D4fF42E7BDfC8E4D34cB369": 1166.17,
        "0xE92f0e0f6EbF4cBD3D112bfffbA9a41d9C65618a": 1165.42,
        "0x2c9C3050B242Df683c5Db26A0c5874c938E06B8F": 1164.3,
        "0x3e51e45628ECE90Ca2d7DF2d0F6605F3c200EcCE": 1163.42,
        "0x193dad0127F564D973ABA50B373DB51Fd2F2588a": 1162.19,
        "0x2CCBC2D212BA6d33e9e85Acd6d2f795412d9e51e": 1160.27,
        "0x3eFEc9925973AFe87CBFE219DFE31fbBA4266369": 1157.76,
        "0x97555Ad70080B4c2679Be3aF720660c23F613850": 1153.22,
        "0xE0E216283eef00895b6ABAa73848448596B85724": 1151.12,
        "0xBBc25274b5B8bb6507B3078E38b56d8901fc4102": 1150.2,
        "0xebb8eE4722501358bf70559d26Ef6e7B1326b3c6": 1149.45,
        "0xEe14ECa1B366cE3f6E287d3a3D7D0f3f76c926f7": 1149.19,
        "0x9c037CB27BFb666474e264cb9ca554720bb1F102": 1149.19,
        "0xc3dF626D62429E31cdea23602ADD0E47C1a85a5D": 1147.18,
        "0x4d3869e2451D28bB4f03AedA60322EAf01E912db": 1146.17,
        "0xc8A1668bA4b94BbA1D8cD4e99cc61570068cc323": 1144.54,
        "0x5Cf49F49e691B3C4258E8c31D556aed2F157E4ef": 1144.48,
        "0xAAE06B0C7556f2D0c05dD264423C5b3Cc006dF7B": 1144.43,
        "0x0F18781605624D80c516e3BE8B9F89Efd2a27df0": 1144.41,
        "0x9cda5fCAf3B7308CC4D900c550422CeA9E0d44F3": 1143.86,
        "0x794783dcFCac8c1944727057A3208d8F8bB91506": 1143.65,
        "0x09E4FcdF86a22850cf47E39aFd2398d7E0eaaa19": 1143.47,
        "0x02dCFB1d14bB6D36b9126eDe6A8CCb3c5940326E": 1143.06,
        "0x1e7e5BdcEF55Ec658f2A29A9bcbc69CaBaF1606a": 1142.38,
        "0x86AABcD459587bC1A347aE1E2d15223856354EC9": 1136.36,
        "0xB1b4d2c37C3D76EAe8c47747De1D7dc782684849": 1136.21,
        "0x6E40BC433aa6f205703f0245f1B16aE2799E9587": 1135.53,
        "0x4Ff99787619274Cca67CEB06aA332Fd033221090": 1135.24,
        "0xB6c3e778FbfC698f5B3fc941fA4727525141E0Ca": 1134.36,
        "0xFe8176C87cb6B08890353A47623d20b634C1844c": 1133.36,
        "0xD52a7f599009f68310Fbc0658eC4d48811e15E56": 1132.07,
        "0x24a3bDe2bd95Fe4C36894049E34501D340d9fd56": 1131.56,
        "0x599321B91D0E4e541f7d172Ab1CacCCc0d5a8e82": 1131.05,
        "0x973A783D79Fd380309f3CCFC1f4eF9F21fcF6C0C": 1130.05,
        "0xF239452db1E11C5e41E4Dd15fB6a3831d7561BED": 1129.15,
        "0xf927A47ab617A7ffDAae7042fED54d56807cC97C": 1128.39,
        "0x22e022fE53E20D0779bE66Fd0009E215f77530Df": 1127.64,
        "0x5e73c50043acC5cA7332b6e9229ED242AA737387": 1127.33,
        "0xd488169e818Dc8c7630f698C7B354e87A1888E96": 1126.22,
        "0x24C2151504fb5F84A3aBE34899d31aF13deA163a": 1125.77,
        "0x083b23284440C53c2639BF805B49Dc6d4a423bbA": 1125.34,
        "0x45bb69072e1a119435bf6D9c59736BE450dA5163": 1123.91,
        "0x4F57F4256c12be23d1196eE5aA78D688151Dc14e": 1121.99,
        "0x698ebaF100f616A1D9ef471aF5862F60FD502146": 1121.91,
        "0x839527730e470eB9d4A15f627DB991fd210C86f2": 1119.43,
        "0xfB176697Fe881AF351Fa450D85e730018bC36f68": 1118.46,
        "0x0e78476d091D6c51FC34d274833e180305715892": 1116.05,
        "0x923A7a13040D86D32A42D87af87Dbf9157763FB3": 1114.93,
        "0x65268d4Fb73544b6056fa4f4BF20FC90E0b12a80": 1113.92,
        "0x78A274041b7228cfAF7A9C4a6F201A3015aEFAa4": 1113.92,
        "0xf137179cC5Bfc599bCc4bE2A8E3FFbc8827DeDAD": 1111.41,
        "0x88b1E97e6cFA9023280c9c1828F4Ee14dF555E21": 1109.43,
        "0x5163e34e218789F98EB8f84E2E24025baEA90c7f": 1109.39,
        "0x853054857d755c6d1605e003C8495Be0407476AB": 1107.88,
        "0x4d68526E45e5429E6a231b9085c03EeA1A675ABf": 1103.78,
        "0xA2F07232275cDF8463A5115723c9D73085a2fc17": 1102.84,
        "0xA9307Be67256eE4b17BF5468babF56eF32673bd1": 1100.52,
        "0x2f9fb6e23EEDb1e4148b97bf7fd71A8837843bD6": 1098.43,
        "0x00CE227C3DaCbd1770Fe3718807394bfFf0C842A": 1098.43,
        "0xD84a1094bdcfddab392666535FFaa3ba1E306a4a": 1097.28,
        "0x94F748eC36A03F44BbaF888B21CA0963d4EEa0aa": 1094.28,
        "0x569F6Bc6204a4e07d3a16317D1884BB0FcC74841": 1089.25,
        "0xDFFda37C4BA2facCaC137Df790872529a2D3Ea44": 1089.24,
        "0x3838433F63f4d4A24260F2485AACf5894ba7Bc93": 1087.22,
        "0x8694405ea183a604a9ED5eB94020614C40BEb947": 1085.12,
        "0x95c43Aa651bc361e4B67F06ae460B11038208389": 1084.2,
        "0x1B7eA7D42c476A1E2808f23e18D850C5A4692DF7": 1083.19,
        "0x3e8ED075563FF3ef9221FC042e17A817F7D101a5": 1083.16,
        "0x84ECB387395a1be65E133c75Ff9e5FCC6F756DB3": 1082.69,
        "0xAa4D15bbb94b36c9f6c62b336833bD3aa030ce56": 1080.16,
        "0x11CA19199763cf379a072F96cF18Ad13982B3E45": 1079.42,
        "0xA593205079A86C4E319254c4eE76572627a05Ee2": 1078.82,
        "0x556C9c6bdE32c7a019A273Fa2750Ad13B46aC374": 1077.65,
        "0x7a164f6DAde07Bcac283391D75E12c0Aeb20B65D": 1076.24,
        "0x73C91af57C657DfD05a31DAcA7Bff1aEb5754629": 1075.63,
        "0x615f0289305E2995D51F83dA5E21314FB4780f79": 1075.13,
        "0x9c4d592042F959254485d443bBc337d29572264F": 1072.61,
        "0x422a555F7e0333FB6e22BD0134a1DeA8D77bED14": 1072.23,
        "0xF0208e93d6481ba343bc22199fA35ca91B6DbC0A": 1071.1,
        "0x73Ea5b1AB2F4a36556B0A57381ed0101643615f3": 1070.38,
        "0xEd0b462edebf3D5017AF641cc21448Be24c0b552": 1069.22,
        "0xAe242fB3C49ec01e34642e7A503Bb27B1F1d6EFf": 1068.58,
        "0x2CcF109701bB766ea47Cc673B1366af4e82976B1": 1068.58,
        "0x1151CE76cCA782A19f751925ef383Ed744533663": 1067.57,
        "0x0238b9bB23af9221488aC4d8c0bDa0E08E9d130d": 1067.41,
        "0x2067BEd542762D26E2755Ce7d8776728F3429f48": 1066.57,
        "0xd3898De83da44796B67e37Cd5795779082E07aA2": 1065.3,
        "0x6eD26F219AFd2e64218917e8868de932024AdEc5": 1065.14,
        "0x4b30Dee65A2b29aa8bb4C3Cd18Ce8007a57EA1B1": 1063.43,
        "0x8011B26D05f9f768159299AC19C61D2971dD5a8c": 1063.4,
        "0x1945f9469D5824dB64059a0e05c82528fD12a78f": 1063.21,
        "0x4FfDA342DB6366E564b28E98DCbc48890ae204Ac": 1062.41,
        "0xC15ab90872fC8320a4DF433b36bfDBe13c12d78E": 1062.03,
        "0x5591f90747e1112a2F33A45AAFA51f753AEFB9bd": 1061.17,
        "0x75dE5388A9C514cDAe790323d63AB0DCFfC95468": 1059.99,
        "0xF4918F4F68189EdF57d49B61Ee301de2Fb87bA40": 1059.23,
        "0xE7523A8821dfC9495de0E327F9E572693352D708": 1059.19,
        "0xd0c1117b4DaBa299914e91EdB1BC280c06DDa580": 1059.16,
        "0x2B4768a6fed62c843b0be2d96ee5b7cbFC593878": 1059.06,
        "0xA7fF395b41D29bad9aa8f99C1688aE7Be2724800": 1058.52,
        "0xB43FAaAA5Ae147ad09Fc946a0eEBe2b4d31bbFC7": 1058.12,
        "0xAf9EB4f8F69C41cc260Dcaec145be88FB6b05C49": 1058,
        "0xb6B03f7D37F6A72419a3CCb78E18385cC45743Bc": 1057.63,
        "0xC2c7D536Cff3318EBB1484B95A52AEE850c158C9": 1057.46,
        "0x89DF81D0919dB82aDD1F78Ae977FBE3cF9b534e8": 1057.2,
        "0x1C202B33148c33C6Bca283Ce7b4b4BA510bF7b8F": 1056.93,
        "0x8fB51594A9Ad60D52c69ec3F01e6514714782E14": 1056.49,
        "0x9B42eb19B0D46Feb3ABcea64352c5972438fA494": 1056.44,
        "0xA4ebaAC5E8d7728bC20f911f4599Fc5F9f9e33F6": 1056.32,
        "0xBa1fA72bE53A1693dE4867DeA60fA9f041073BEF": 1056.16,
        "0x3A51936BDf8b01025Da5406b3E90C8E6434C19C3": 1056.05,
        "0xfA4Ce8500eBA98255F2Dda2CD6D3c8B16be7056F": 1055.46,
        "0x1aEC38688E9e504Fe1E5137e7C92Bb1B092faA15": 1054.98,
        "0xd0122c4eB34AB6B13895fDa13BCa46Da2b3188F1": 1054.49,
        "0x539C82d5CB886c94dD3E2d76Dd5c73936c1cF391": 1054.47,
        "0x49e6f2D934077995cF4b24701Fa5aE7F7B5E82e5": 1053.97,
        "0xf2C690B5587AEE6f69f0fD85Fb3115DAd78D5A92": 1053.18,
        "0x2D6AB3deD8A86Bbe1D3D8A497CdeeF6296869339": 1052.19,
        "0xAacdC3EBD619c4920103F6c34D3621319d42A415": 1051.22,
        "0xA1AFAc7F937BFC32601b8562259eC33E671de7eB": 1051.21,
        "0x7D303bbF47b1C2c15A3Bc3e4B57b41049579503f": 1050.1,
        "0xc1f942CBA924F15e9c05299aC6cB2e9b9A4363A1": 1049.5,
        "0x46a83dC1a264Bff133dB887023d2884167094837": 1049.44,
        "0x1bC3e2c44E0b2dabB1b06A1890273571825d3e03": 1049.44,
        "0xF8Da2575b55e5b7E5ebd69C2A5ABAf6427f7A414": 1049.19,
        "0x27a3bEF7b3C26EaC288410Cb84e4C93175B0C3D7": 1048.93,
        "0xF7f4FfeA88AA541720A39Bc909EeF38b2F3a4d55": 1048.43,
        "0xcDd3830020Df2466324c73AEAD9Bc1fBEb06Ae47": 1048.13,
        "0xcf4E7c9210Bd2AedEa2414B2d66e9cB969b83f5f": 1048.09,
        "0x7eFAd92a89AA0471B1515b0237c6610178E19818": 1046.92,
        "0xBd8b192d2081b77e148095c08dCc719e61C2D826": 1046.92,
        "0x76A3ED30740D178398f600f3b2a544288232DB35": 1046.58,
        "0x0B2d3DD982DBC6c2EE2DD34d0057AE5f08A726c1": 1045.13,
        "0x7aE73297a93715b888AB873a683626db9c2fd614": 1044.45,
        "0x437FDB3Dbd6773c6C8Eb3583Ca1581CD3F275A51": 1044.37,
        "0x5Bc4FF33f86E0272be53Fa25861294489AB2FE2a": 1043.39,
        "0x348A633BD5Eb306019Ba411b204fFF8e527F824b": 1041.16,
        "0xC7e76Be112e98620E5335B6bd4c0cCc006AAACA5": 1040.19,
        "0xF490f6761651C11335f8332b7880f6F855cac228": 1039.16,
        "0xE684dC05C16851c65Edb5D9fc3b11Bce4F427Eb2": 1038.32,
        "0x0f962096Cd202bec1F6383BD8aA9d703e797ca70": 1036.84,
        "0x6A3E98F964e93f183a9e5bb607dd9dF75110D2ac": 1036.34,
        "0xbC8Ba8E6745d6cC53f4C4c20AECE8811d879165D": 1035.46,
        "0x33173A3B9b4a86654fefA252F75dAB701df092cB": 1034.4,
        "0x4523b791292da89A9194B61bA4CD9d98f2af68E0": 1033.73,
        "0xF19DcF7B249B4197952ca1c3787cB1A1783396E7": 1032.28,
        "0xc2bC1c2Ac8098e29605ef2A0A902409ae136F4F8": 1032.21,
        "0xc315F794b2b2F988d15feAA380f0B36F1842A806": 1031.3,
        "0x0fA8e6518E2f5c2FCF5c2d09f8b2ca443BD5b853": 1031.3,
        "0xA952D7ca6A0c67201514716eFe77Fc9093131dae": 1030.29,
        "0x01b3ACDc9a4a7b3b943bfd52052eFf52707b1158": 1029.4,
        "0x18E06E49Fb3110c8A32031ada5b0D376CE4A8249": 1029.03,
        "0x516786fC518513FCf6E849102ebD51d568171882": 1027.14,
        "0xac18C73423d43Ad14630C32491Ec0DB14E2E6148": 1026.37,
        "0x3a74c5DbcE54f28f445dfA5673036559bC4290B8": 1025.4,
        "0xC4915c55DE94B242d811d7FEB92DBa17C96f3438": 1025.35,
        "0xF5f5C8924db9aa5E70Bdf7842473Ee8C7F1F4c9d": 1024.75,
        "0xD51Ab3249CB64Daa72EfA15Aeb0248bD3a823368": 1023.01,
        "0xA971182cEEcAAC649eb6E8d4800ed8Ddf0312106": 1022.23,
        "0xe66aF8B375Dc070Bd1607703dDE27d9B9BA70c2a": 1018.18,
        "0x7e3A1c726E864C7E61A8d58C70D3237c1fb13331": 1014.67,
        "0xc9e791996Fbc748DC6f5763488ddaDEd4FF925d5": 1014.15,
        "0x5dd6Cc88213b73F64525eB4DCdEEf2D2f7629276": 1013.39,
        "0xe12dbb4320CAa9035c5D104620aa7A0DEbCbD554": 1013.16,
        "0xc3b3D42D08D337371FB2872C26fB832ACcCDD266": 1013.16,
        "0x1bC72975bda5B2E9918cEE44d383dDaAfcaf1d5f": 1010.93,
        "0x283A2549b640E56901A8Ced2Ec5277A32CfE6425": 1010.02,
        "0x6F6B87d1C1FAd5a51F5EAb7E4Bc70e830DA7C11a": 1009.62,
        "0xf8f7d1F47D14386583586102e182540d05Ca8C40": 1009.11,
        "0x1D32Ff958431783D8c50a1FfFc622f034CA80F64": 1008.12,
        "0xdb379b5645BCB3190454C8faDC3EFec30f2d0007": 1006.27,
        "0x6D1E0084a6910a8803ab7c22483A1a2Db3F1001a": 1005.27,
        "0x103948c5E054AC42fc340E3622EbfAA4CF9423b1": 1002.08,
        "0xD35f7f2ACD4Df8D1221D6Dfb334810Eba9F728B1": 1001.15,
        "0xE9b8f3225983EEf3653C3618f4D9dd7A8745A744": 1000.15,
        "0xCE59f5c26Ab95039e4C79371B8b89F8B69030e2e": 999.06,
        "0x8557b1A9c2bb5D51172187Bf6945c0f6fcE3Bfe6": 996.54,
        "0x29d42d47AFB7Be8C3ba6f5E850Ed04003Cbe1d4d": 995.53,
        "0x0953eb1d555E6282208c7855fB99460d459ae100": 995.01,
        "0x6059895f7f20CC25C251D4D283F525F7400cE034": 994.02,
        "0xDC91c2CF4313fc80F36d540FB4f797d68F9BDe1a": 993.06,
        "0xb8c511dC5d5aB1Fc51Fa7a4b521f0F3DA0746c28": 992,
        "0x8aDaCE41Ec579423F149d7402f282301fCFaFF36": 990.99,
        "0xe527DBb875fBf9B37D28B939e58b677db0E772a9": 988.97,
        "0x97069428Fd9c68FE487a861e0CBe4aC5B3e76Ef2": 987.47,
        "0xfaEAAd01421B3Acfd3BdCbFACE76d5038F4Ce665": 986.96,
        "0x420d40297fee474b13f402aA86d76D6783b68420": 983.03,
        "0x745cD76273f5e1C78d0A2f1634d57A4bdf8cd00b": 983.03,
        "0x753AD1Ee38e43C383bD5d741F753E5C8fa6cdf49": 983.03,
        "0x095ce1a6A1A916C0F13271BC40E6B0a6BB9186f7": 983.03,
        "0x30858A8051eaa08FBC3dc37FB290792FD30664b7": 982.43,
        "0x7B0DA0B8F90894ab5cFb0cA27a7c0935b8d3aE22": 980.41,
        "0x000000e28fAA823d5B53ff6C2922c28335840375": 980.28,
        "0xDf9a709C649634AE724D5A26634c1425a28930C3": 980.04,
        "0x78082d8DB5a648E92950C3Ebd9867eDC7Cccd19F": 979.91,
        "0xBe449C3f7CCc2bb5A17D39954D7ce710d3C0Bf05": 979.04,
        "0xA248F4a3D9c1b9D08e7E2e45cF5E11296B2bf4ea": 974.87,
        "0xE6e1E001268b48DF39D97C318eb21c4FA820d7Bb": 973.64,
        "0xe259db8D84c2CDfa6e6D264d2D2F84C7104Fe112": 972.73,
        "0x5146d64498f6735801c541C3Af2C96769fc5294f": 971.11,
        "0x3c04eC0d34F8C074644A792Ce04366AB789D3EB3": 970.34,
        "0x2159E8d5566369DdB67bbfC6b288Ed5591D34235": 969.83,
        "0x3ec783B1C10d39F1653C20C821E0ed810eAf6A2e": 966.03,
        "0xe564D9AFc3e8D7dDc99912Dbc5dB58925b414024": 965.8,
        "0x6F34ce7d13281a881215c64D8d6e874927Cd8561": 960,
        "0x073F2f6E202088307E480001bbd52aedbBEe1CA0": 959.28,
        "0x6586185c2b16E620db0Ab02e7Fca0c66DeE7C9Ea": 958.38,
        "0xEB3648865b1471996e5F65Ae845F9Eb9226B9a02": 956.23,
        "0x0D709b89E44f868a1707aE6a392453968AbeE2ed": 951.98,
        "0x4282890fF9661a51EA367AeddF341C6f6395d4E1": 947.16,
        "0x74E8bEb278dc75d26D5918AE83BF85b58C82D3fB": 947.16,
        "0x4C37700d949db46Aa11A9F1627070F9Af31F8011": 946.66,
        "0xF69B6e6AFFc35Fb10a38A96735D00673c97B2558": 945.01,
        "0x20cC5957538463a193c6b0D6245211003854477a": 943.64,
        "0x3e35B6DfdCB948907B4Edf6Bf6545D5330135463": 942.63,
        "0xd55Fb14e54f7Ef4D1825Adb21603A4f8fDfDE3dA": 942.12,
        "0xccC4e8Ad313dF8150211B1b934725345924ab81D": 942.12,
        "0xFB0B7E0EDd26d8B7e9e74B78D4B30F89Da0Bb93F": 941.12,
        "0x12C55D1A8441226412002cc82C81F0933326e8cf": 940.61,
        "0x2B9F541d42d37A3941c4Bb774B95BB98Df05D380": 939.61,
        "0x161adFD406CC079eDf4438Caae8A1c57dc98bB0a": 939.43,
        "0x0899A0B74eBAb3F637B59dbF90883E6df481Fe00": 939,
        "0x74Cc4771a283001b3F8539C6AA90d0459c60Ea77": 936.36,
        "0xc003A01F539eEF414adab96366844C8D03Bf1dB7": 935.58,
        "0x73f432dA307525B6590c858bf458116322D50d16": 933.58,
        "0xC145d2264Be094c583133918EA3c2Af0D86c901E": 933.56,
        "0x7026D2dc1a6314DCAe5B8834C506987a30c702a6": 931.54,
        "0xeb17a5C378DF482F581f2fBdDD2681055F59f1da": 930.03,
        "0x8b740fa853297E09e17099D44DF8cD81d2bfA269": 929.03,
        "0x50E3449024632221562C6BD11e1d5D4a6cC06a3f": 928.36,
        "0x842B1275c0709bC1cC0C6a91436fD41D7539Adb5": 928.02,
        "0x39d94eD8102740E8Fad63E55473a466Aa20e0983": 928.02,
        "0xB307D426A34A72A94B32BCa5c5f0c8B36440Fa80": 927.51,
        "0x1d1013c8472122E2FA21bcF87A54d658224923ba": 927.01,
        "0x314d53E5968BbC3406d9Cf8FDCADbbd68bebB0Ea": 924.05,
        "0x4d6E078E9c953F0eB1C3dB41A0Ae019fFa9bd857": 923.92,
        "0xDBc88E5858FD2Cd02b2670383100B04804Fe2f27": 921.47,
        "0x877d7095BC4c8C484946C73E385D3cE5B2F58886": 919.42,
        "0xe8F6f03505c9F50F94cC8971D3496e1fE96A6660": 918.95,
        "0xC4b339C82814865748d270700aE5FB79c482651D": 918.89,
        "0xEC93ea832B107B84f61a3d01E4F85Ef9067fA5F3": 918.13,
        "0xb6e8db67c3EFfbF3E7fB74Ae9aFaED8c553C569e": 918.1,
        "0x59653fd9713a30C54237A6FD21fD97BA141aBbe0": 917.94,
        "0xCaee6c7aAe8805913E24a8CE5D5d22BE2d4fF7Ad": 916.93,
        "0xb33941984A22eda37fE45a8b63b97a6c0499F29D": 916.25,
        "0x41D69eF6860f4a89A7ae84de6709c165925232dA": 916.14,
        "0x3c66773A87BAB490753130783B6c63f448417bD8": 916.14,
        "0x6b73A81d3724267BEaB9393eb89868ADE5CA6A29": 915.9,
        "0xa83C0698E70cADc20A6dAc93B8fdAfF90b36e04F": 915.9,
        "0x37EC6c34e88806e7c920518530690Fc346fA8797": 915.9,
        "0xe50726122850b2d1A56EB2962bC432883D54bCCB": 915.07,
        "0xe8B55Fd62045d51274812E5c3aB803055C0E3EaA": 913.91,
        "0x0559daD683289338D6ABD59271C0Af2677268d04": 913.85,
        "0xd51B3b8DB263150366d1dc5A0D71A997a448afA2": 912.55,
        "0xd565b4Ce530A9720DB5D030044acaDA55318C749": 912.4,
        "0x1e3798D939dD7bAFEF9C2424d9ac1bedC715b4A1": 911.9,
        "0xacd65b8E9d50128780a114a16D8e9870E19c82c3": 910.42,
        "0xd2988719B6894A7D643b8854D2cb8e4645724471": 907.89,
        "0x9A4De9267ce98F875B11407D02b829b64661Be31": 905.35,
        "0x82E96B961022CD61ff4Df9162b3fAAE6A4068aD8": 905.35,
        "0x03b7F7cb25be1bCFa4BA8a0e5fb7c1f404CBEDE2": 902.83,
        "0x1aAB3F4EDE38e381f9684EB9C0A0b475639dD3A0": 901.82,
        "0x5d47E871F81F84D3154AEC772bCce14973112C69": 900.81,
        "0x5Ba56647A245fb25CF71A5e30AC166CB3e7D87C6": 900.06,
        "0xBeC69dfcE4c1fA8b7843FEE1Ca85788d84A86B06": 899.8,
        "0xAa5A98aBE7Dcc579Efc3458bb1a37B74d7887298": 898.87,
        "0x1D84dF4a792E4415258629BeA17C81a655EAE202": 897.57,
        "0x8FC339425b2c5BE02035C00Ef311FDa7d1Fa9aB7": 896.78,
        "0x3083ab8A6C7E310699D44E339C099393f2bF626c": 893.86,
        "0x3631e591A117cd71Ea786DC39Dd8011d189e0b9d": 893.76,
        "0x2957C2968ebcB91f5683768a9bdC468d08C2a2C2": 893.26,
        "0x237B45906A501102dFdd0cDccb1Fd3D7b869CF36": 891.68,
        "0x785B9D314526588b3C1Bd6F08233AA4Fe934954B": 888.75,
        "0x905eF06810B5D168d0c8D351593ed5D1880dbc28": 887.64,
        "0x12924049E2D21664E35387C69429c98E9891a820": 885.84,
        "0x50b3E08D5c3a2386e0c9585031B1152a5f0E2370": 885.84,
        "0x2C70B126d62AEeA656ae5367e4F09b0ef6dBe0d9": 884.63,
        "0x90F19c93dcB498093B19a6A9818cE8ad1297d4b8": 881.83,
        "0x34E63550284a4918B9A2e4999B5532d4458B78cD": 881.13,
        "0xDe2214B3c6c3Cc5CF8035C5830428aB9873a32bb": 880.83,
        "0xf315eafb91bD04F283D4C0Bd47E64E9Bb5384e11": 880.16,
        "0xc38e3e9eD9b33512aaD18905744ac6f287AeA714": 880,
        "0xf6E2B10d4A01A7A4e818e7FaE8D0CE242e1b7CF6": 879.75,
        "0x1ddA43A970073c1dc4943802AB9f4a5433411A4f": 879.65,
        "0xDe7f17D3A02953e77461Ab38C88b8Aec293BCed7": 878.49,
        "0x8C553DbD9c7e52f0f698D0A11615FAFe999Ec271": 875.12,
        "0xb12B502492073edeb2adddDb1Eb8c67de54Ead46": 874.34,
        "0x9173BdB320E7Aef0d14d23Fb123b8885E6FdEffB": 873.15,
        "0x089c9022228A263Fd2799899A7aBe6a57e07612B": 873,
        "0x5DBd454952e6AAC62688251b7483504161f06825": 872.81,
        "0x2B8cA9728FcC756A1B222bA70B55f3c07eEDc267": 871.41,
        "0xe7C5f46954702b7057D438b6448c9E052d2360bf": 870.81,
        "0x0EA1e9AC50eC4D8dB153580C2aEC1c5ee13C0961": 870.08,
        "0x484dE6813Ed85da863C5735BA710C2b971FcBc88": 869.13,
        "0x40EC537fF3226eCfdF82509e3292Fb885c8A15bf": 869.07,
        "0x4618f907F1C76Ba49c0c91731e0fd5EEc76C7e23": 868.85,
        "0x53542C2638051231F736d6e9385ea28C5DD490b4": 867.56,
        "0x2130FD01026867A6c8DdE24ad5E64F2e2DFce196": 866.05,
        "0x5EfeA13B03810a571B32494B726F084079e4b0e8": 865.1,
        "0x09CF50574504d9dcf127E848A6058e8e0Bb814Aa": 862.52,
        "0x7D9a78f607706b8F5cE26Fba6c9EaCabF8937df0": 861.79,
        "0x722d94da967B9c2Aba38118a78A9E6fA07701843": 861.01,
        "0xBfCaC232944660Aa999A5672cAcfACA515cf6128": 858.13,
        "0x5FADECCc5a393e681E8552580aE412Be114198Ed": 857.04,
        "0x8fbF14143EBc65f47b1097De9E0B00d2e595679b": 856.98,
        "0x4024602F17550363Aeca791D939cf9FC5b3E4a78": 856.33,
        "0x855aF9247e1Df45640b6013625947AB4C420edAD": 855.78,
        "0xb44B476a7F6A83B5E0559433B0D3ad374a0c1682": 854.97,
        "0xD5dE81E7e5E4F740a26Ebb254d6052e1D03B4787": 854.92,
        "0xBC8B65Af80c9E3031033067799055a697520bEF8": 854.33,
        "0x9964B37010Fe1092242750ec46b1B2C2c0284E2f": 851.94,
        "0xAf74A28E7611650cCc6aC1341386C09B6Ed804C0": 851.44,
        "0x55F007605d7f78bA48bEae6034EC46A2BBe98d3d": 850.94,
        "0xa66DaAF3e6736CcE993b56EceD596512a7911dF8": 850.94,
        "0xa22636C936B91b41B24c6C86e1EF9E594fE51687": 850.43,
        "0x4fc4B49101011C66C93f832BfFb1Bb032e7ff038": 850.43,
        "0xd4cf8ADcfF3f5E7A2e57583050660c0c2d7D8805": 848.98,
        "0x83cf51a12258848540E862D1ab8b2FE05518F716": 848.92,
        "0xa13c2DEF62c36697407fBe7d574e946bf60d7350": 848.02,
        "0xcE10C23561Dce134ae20B32f8166A131c741F463": 846.97,
        "0x5805641E589CF538004a0ccFC31a57Ac1ba2cb02": 845.39,
        "0xC923dD451dFb1fC6A4608982C6c077414Da06a4d": 844.39,
        "0x469dd74d52dB54089824a31b0900C1EcE5e3A08e": 844.39,
        "0x66F4dD243D824Fb5aC0694177a2371037EeEd6cB": 843.88,
        "0x798b81c5EcEc1825788D2CC538de6E56D31f69A2": 841.75,
        "0x276eB94CE86A8E69EfD79b5226b9c377b1365d6D": 838.34,
        "0xc9e60767BE3C0e812301ab2F38237EC52B56a009": 837.84,
        "0x0A6C743c6EED67ecb1614F90956B9593b90BB10D": 836.74,
        "0x1E593f9FAbd9A166fC6Dd0Ad8255A266fDfb490e": 835.82,
        "0xdBab0B75921E3008Fd0bB621A8248D969d2d2F0d": 835.82,
        "0xC88291A6491E951b14568a97aFcEdd576DCB87BA": 835.32,
        "0x5584Ab96B25bfa81d1a518109238bB39108fB20c": 833.73,
        "0xEDeEd75328937a17749C1a59772E2EC79eB51314": 833.12,
        "0x509d877b68b32F871A6494D34a015855279a0d46": 833.12,
        "0xa87259f8e14364953d91F8541A7bA0B32E5E7008": 833.12,
        "0xF3f0BBA02B30eDbBC240cB36C24E6d1a351580fB": 833.12,
        "0xDF02216E5e47a9d5a4b13e39520940e522447918": 833.12,
        "0x60E13c78348E31a2eA48f50aA287081F85e27832": 832.29,
        "0xb3eB1346178C3137a72761B3d11e57137781e083": 832.2,
        "0x6a9696899e5b114342882C358ffC7C4e620e88Df": 830.73,
        "0x752b6547734c389311FDb9b03a83C2bB4Df9CAdC": 828.77,
        "0xb7d49ADB031d6DBDF3E8e28F21C6Dd3b6f231cD5": 828.12,
        "0x6931C0FAC4aba5AEee32578e3439F0bA469995dc": 827.9,
        "0x6cCA923e29cE657D39724bf78451796a83cBe32a": 827.72,
        "0x6a1cB4177785bD46fc1b1374cff777770127817C": 824.74,
        "0xCfa88902165c5c6BEc47Eb78e791F0A75e0f8238": 824.28,
        "0xdf9134f23f39519CB8E5af048873faCfb0154080": 822.32,
        "0x52910fdf50e7F597E7Ffb037c3CFC0B37d430F64": 820.02,
        "0x2E1bfb63Fb937b0d8B5d48983C640677c5cD7eAc": 817.76,
        "0x9D5Aebcc11C81c2a5941f8C7E9d31fcfCE1338Bd": 817.19,
        "0x214fB5Cdba82A7A01d7e60A0019c4f5F051f4F54": 814.32,
        "0x50CD86868D9326d9ce433bD9aA16AEf91f6f461E": 812.14,
        "0xf3b059c887172f2cc52b5e77EE3b2C8B3A32E6eF": 812.14,
        "0x3fE2e08a1F7766606574a91a5CfAf3342d023947": 811.85,
        "0x5E347E884dfa340c8e9feF03b16F86bbAf7A0632": 809.67,
        "0x1254Df8581B92609F087A505F77B4a9Dc89502C3": 807.1,
        "0xe211Cc9c8BCc94a92700AF45Cb7e07443Df678EC": 806.88,
        "0x74D973A770e8E58867F7Cd5b44798b0eCbbEFa3d": 803.58,
        "0xD7c71303d5C45840ba56B271797B6434f694A9b8": 802.67,
        "0x94Df62C754cEc7c0f90262Bd4b292423282888EE": 802.07,
        "0x0549c41564FA450E7749D678eE5cB1101f81E79a": 801.06,
        "0xD9D4F25Acb0466b49F3Be1Bf68770C5aA12e898A": 800.64,
        "0x79016f576376cc3Bdfbc02642211828471760185": 799.55,
        "0xf96A10dcB261Aa932a589146E87D80E4Cc8446F2": 799.04,
        "0xB5025A346Ae2bF6511a33602DAe4bdac7B5B7528": 798.54,
        "0xd188C6ab379cEbbD5c4635d3A13f6a0883DfD9f1": 796.61,
        "0x1c35AFbe3d4c73946cCEB6f0A7b765a2cE65e4d7": 796.02,
        "0xc3122FEB8855a05C9020FC8092d9266D13C2AA89": 795.52,
        "0xb9878D041806f426ac56E2dcee1239802d1cA696": 794,
        "0xf3aFc2383a0B45ae73D77B49dF7F2184B1Ad4B90": 791.49,
        "0xd84feFF192f18D4e0F7EB3Aa3a5B14FA73fB8E74": 791.49,
        "0xb4A778347cbb63E02818f417E659Ec60566A8AbF": 790.48,
        "0x9E8C646220613d68eaf2B947f46c2B4F52Bf3f45": 789.64,
        "0xB25e55e36CC998a546639365272F88FE2ce50753": 789.47,
        "0x15a6e721B8FdCE87c05b6711B0C7EfBD6809960c": 788.97,
        "0xa2D36f11E2225d1b89146F443350e825F15B8B68": 788.64,
        "0x5AE47A0A52c1e5E67e65bEDD56D7Fa399258Fdd2": 788.64,
        "0xCa11B963d3f35CF68CBdD4548538752A4278Ff14": 787.5,
        "0x554069726423affB00AFa5FBe60Ad3668EaE0544": 785.44,
        "0x9D837774EfB22C42d975fd86A8642cE97462f848": 783.52,
        "0xe5e990e4dD4B8209Da38CbcDCC7B2D0b64Da4329": 783.02,
        "0xC4B4691D8C9194E9F98e2609e6f8481BA713dd2a": 782.42,
        "0x991B76Cc6BF004Ba17c1E181D2bbe81A5d81be52": 781.63,
        "0xCEe1ad5F9EF7263c6F89fe9333CA9F12F235Fa50": 781.51,
        "0xE2796EEf9601daa61124E63914D3Af62C16A33eE": 780.4,
        "0x890e0A43E72c67501Fc5A3399c99756898D41996": 779.9,
        "0x673eB761D1258CF3B2381a15df70038242f05d82": 779.82,
        "0xeDDB00d08022f282A0179cb4c35697F50EF3b138": 779.62,
        "0x94d41Bf9E8Dcc9Ad35C134267f3D3a5f50E83Ab8": 779.39,
        "0x8997a688fdB45b83F5C391EB94158Ac0a2b7B5D9": 776.61,
        "0x8DE3c3891268502F77DB7E876d727257DEc0F852": 776.18,
        "0x3A0Ea67e8284b77EA368E26eD71025D49f8B1049": 773.45,
        "0x594Ef2480db681c1Abdd1BdB049dAd2c3Dda2199": 773.3,
        "0xe96F4E42719542b3f9556EEf6aDA7B819F0AC793": 772.34,
        "0x615e1A992775613ce113F26298D7c7265315c0b9": 771.33,
        "0x34Ff77A853A14579d2120Ac08C5e342CEe08AD71": 771.07,
        "0x06F246eAEE54009f8135dff71638BD701d604117": 770.83,
        "0xC210A5Ef47b75851D5BFdf20d9a66a28dF17A7A2": 770.83,
        "0xDE1D6C870ABb972D0DB1A4B5293D6A008205Ed10": 769.08,
        "0x5f338DD3c5ba4e5368A6139B81e1c120ccb2567d": 767.81,
        "0x16a3C4AB0db726beE89aD1b563b3eEf21C4C0406": 766.8,
        "0x80337d2FBf7697A148bb46484197aF0915E3805E": 766.11,
        "0x2765354F429855828852d9516186825af1AE1aF9": 765.59,
        "0xA5C710505b9fCf1Eca8c2501dE3c906A40dB41B4": 765.29,
        "0x383f554CAdc3Cf7a7a2C1f649DC947e86d995ef1": 761.58,
        "0x5d7e1dA11Df6f5DB1891Ce6bA01783148F2C9729": 761.13,
        "0x53a50D58Ee38c1134945B4c7C906b3566A87c8D2": 760.75,
        "0x55cd175919042B57Ce6e2056322Ad05e8EFc1020": 760.25,
        "0x61AbAe3E44784b0C3D1B3BB1F4d23FC7f300723C": 759.49,
        "0xf7463e7335033586683Ac1f3DF3080a0B38BaBe9": 757.73,
        "0x1A4A28B33aba69C4D8B19ee730528D326332E8f9": 757.27,
        "0xcb02f8bff3BE1CFA9411c0896c5fFCb660Ce8418": 755.72,
        "0x8Ab4d73558415C4844c19161e39C0a3FD6B7c230": 755.29,
        "0xa13A85de0aF0d2A0640D7Ec03B05cfa00c846Ad6": 752.69,
        "0xb136d7643a612447Eb603c051C193fdEAD1e0e37": 752.6,
        "0x626932B2E36C6e4cfE57011D1a90477583aCE93B": 752.6,
        "0x00c644E774D7B1A3a95154113f86b9e25350a111": 752.19,
        "0xa1bF240a6B4B54b77497Cd3D741F385E0F5B5199": 752.19,
        "0x7b6599A9177A897E3C7e02Ba5008df1787adCc7B": 751.68,
        "0x8779df19B430669733704Fa383310e96c4F53367": 750.68,
        "0x2a5cCabA06fE805b51c0f612c3436D79C9302184": 750.56,
        "0x120AbEA2412709fAdcEBe43f81D8a488584A4728": 749.67,
        "0xe710Acd21DA5907a1E6038b75324a266ac96E23b": 749.11,
        "0x6DA02f6523fE3854a932b31cdce8B977B6724a1E": 748.66,
        "0x5E5f476B0C42ea1f79Ef6218102Ac14D1D0C1ae8": 746.67,
        "0xB21EfA3C5f1968F51F36D9c8Ef5bB0FE29BB3724": 745.55,
        "0xd9e393321f61A2F476431ABa1407f1f12E273F21": 744.13,
        "0xACFa475E8769e933663EdeBC0078B11E412D14CE": 742.68,
        "0x118B85d62A78BcDebD619F75A3bB1FAfcF411315": 742.62,
        "0x75e99D4780da5a84185498A75eb872099dD8bADc": 742.62,
        "0xde888A2401EBedC03D04f94EB9d33Cc2Ca22C8e0": 742.04,
        "0xE0595c10ad2CA7Dbd156d5790d6507e35d05d697": 741.61,
        "0xC0C900871ffFB8a3e8373D040A16d2b179398B40": 740.6,
        "0xdfA32D43731CD2D15370134bF4220CDEC8337dF5": 740.1,
        "0x0CC1a1958fc33475C03267fc7481E13ab6B5fDB1": 739.09,
        "0xd35fC346e15BA5b446917C9fD23A9471d6144701": 739.09,
        "0xf3CBf86B5Fd4f7555B6C4783d7989206DC3Fad96": 738.79,
        "0xf432Ce1Eae375d68D139c367881d3C67aF331AEF": 738.54,
        "0x8D64a563f653B56ea11d55F08cDE04a6ccD77320": 737.58,
        "0xC2272EA05948236Bc097371B03affBd375039a57": 737.02,
        "0x0F66fF957429f3f7b37335267bFE5174cc5158c2": 736.07,
        "0x3EbC1273126afC31Ed101204B7542683cd95cd5c": 735.56,
        "0x5d8d5184B35F0569B79d7E169be0aeee21A3C078": 735.53,
        "0x68f5DA4A7027705590220143AE1073877076ffF5": 735.53,
        "0x4E190B3D31d96e0cD11a1520185a77b57A0182f2": 734.41,
        "0xEDBf8dE67F84fB7f166652F9338A9a06FBE33893": 734.05,
        "0xDD32BEE975BDD7b3b41840B77f7b42e4a021d208": 733.95,
        "0xa92AeCf166253eE71B7F805eE6783ba5417E4AA4": 733.04,
        "0x69040918a15d5f624951A1fB028D0a9c4855564c": 732.2,
        "0xb65966d1D7A2Be2dB33379bE84d7F012dc9A0753": 732.04,
        "0x609470c2f08FF626078bA64Ceb905d73b155089d": 731.53,
        "0x50BBf827267C4E920B512F8aA6c1c9d1a465a128": 730.02,
        "0x421264F51D04A75fC71118f909Aa91C487a6cb0C": 729.59,
        "0xB2A61E63DeF95405fb8A38639C28E710b75E0db4": 729.52,
        "0x58463dAA71691089B14363b1Fd2D865E7f236B46": 728.01,
        "0x8d1982b9a10f5890d8A669A0f982bB402175bf60": 725.47,
        "0x1B89a08D82079337740e1cef68c571069725306e": 724.98,
        "0xDCAc0ee047DA0aB449f6bEb08c8f79c00eaBC67D": 724.98,
        "0x3055F3Cd374Cf5B49C5DEB05C1Cb7389635E41a4": 724.48,
        "0xF786b0717f045595c5A3904262B8EF649Bd666F2": 723.47,
        "0xfa53f48b0Bfdc115F8EDa45868D8E6a7A1C1F267": 723.47,
        "0x7A166f2Fe92551d6058777367634aC0D471c9C80": 721.08,
        "0xd847FDA8158B1DCADA13d386B1372136724D4f3f": 720.45,
        "0x35135671c2E46D4a16DBfFaf2348e06c7041e664": 720.45,
        "0xA4983222F6c9fc2371c4E09390BdD81AE6EF324F": 718.15,
        "0x4a7fD8f063A6EbA78F731f562a5a1E9fBB3313Bb": 716.42,
        "0x742b6DE8Cb16327B68c83e1d6433174dB89FD2E0": 715.28,
        "0x30D41a62B6e36E72B4FED35236c3168F4369b2f5": 714.91,
        "0x53e3F51c1a038738B653109725741A083f4D71cF": 714.7,
        "0x87f1bf916CF34Fa266E3ABD4224A00004AEe4AA7": 713.9,
        "0x5D781A5E0D360006B28C96F383d54f6B622044aB": 711.88,
        "0x4f54Cab19B61138e3c622a0bD671C687481eC030": 711.48,
        "0x0Db56C99B8ad68F35F4b1772a4ffEd3Fb16204F6": 709.87,
        "0x1cab2CE19FF9B27680D4a8FDd3745197004Ada57": 709.87,
        "0x0e80b8eA35Ed0D15689a6372940619A5a99588bb": 709.36,
        "0x6aAEFBE8564aA2719139BB7A4335f94A380c6476": 708.72,
        "0x38312022F5C24Dd257777f981075FffD20233e19": 706.85,
        "0xFC19EdDC148e92a59C67d1DED4bd7f27aFeA0194": 706.47,
        "0xe886D65fE13C828c466465e5975228f9E910BE81": 705.33,
        "0xb5e00B32bBeA4a4ecC7a28FD7f7A1248Bd2822C9": 704.33,
        "0x2a724bE1b63caEC1c3Ef95834fdD443c3347Ee1D": 703.97,
        "0xD7853400B83A044D0e393b779cf4e4585E4295D1": 703.82,
        "0xba64294B01d43F0B942879Efd5184352bB33A5a4": 699.79,
        "0x23E01e05AA1376FA3AC83C954816B967A7302891": 698.93,
        "0xBcA143600d9718f30022B2463D597996Bc410E5e": 698.28,
        "0xbC4D31e37b0Ca1108F64EaA378A3A80679D6b866": 694.75,
        "0xf9cE0B68f4BaA50BD30128A01c5297e2b46A6428": 694.75,
        "0x38E76E6D3024475e2D39deB94B2797cE801381c0": 694.75,
        "0xcB938bBED7789EE8AAbd259a8cb789aa3500bbf3": 694.75,
        "0x1BCCC3DC32d6977CA14bEFf7a2130F578620CDB3": 693.75,
        "0x45F692A6959ee71C5962Dd89B8cA909fd48Ee6A4": 691.73,
        "0x69E24369BfEda80348BD5104dF01C4d8b33ECFF9": 691.23,
        "0x6cfbAFc7AB21448b4D53620d6aC0095585478dC2": 690.72,
        "0xF244aEa8d5b242059f578b9d0D5F0be66d8406A4": 690.72,
        "0x025CD0e27Ae98da9Aa9A09CE4435fBc9467A949f": 690.59,
        "0xd39eD4D79Ba8b649b5a6843b7BCEeF5747187cee": 687.7,
        "0x0849f5477813c0Acb47AAcEB5FB64dA0eA5256a5": 686.19,
        "0x28d0F9b8af8752ab927d2D319e2C5827F5B13DAb": 685.69,
        "0xe5845761e7773976055F2559ca54be41F09d9E88": 685.21,
        "0xb7B22565A4880B13A287B172d093434b8eCf367D": 684.83,
        "0xEaAB37BeA43500Ac6D8BD61b222a27eF4Ee23381": 684.68,
        "0xC41DA17d2E0EF86d1cCA4cFA7895a1b4e46BCAaa": 684.42,
        "0x8a51551658d667A29aB42182abA4a31F6a1697E4": 684.3,
        "0xB7A7B148A90b277B4C21fc4f33C4734E095b5dab": 683.67,
        "0x6FFFF888E1B4C10AE4F798F9F0C6211285B2e819": 683.27,
        "0xE101754C39d66cd7E49676Af11dd93FC68189DAb": 683.17,
        "0xdc0D491BD92861746C745b257edfd8Cfa631470a": 683.13,
        "0x5D98609F4a43ED4d36DAe38A58365B352109C7a6": 682.42,
        "0xf14e38eda5298Fe51958045d901f0fcedc7048d5": 681.93,
        "0x6d9723ffDb9a8fAE16fb72328377FD53abee5537": 681.81,
        "0xf0F3532d70559828A1bf5F9B8E197dF9E1c2236A": 681.66,
        "0x7f28AfE146f7A81FE97C6C2FAb9ACf2EA9f8eB7E": 680.14,
        "0x9c4b88fBE06b6B1E461d9D294ecB7FB0c841dB4f": 679.68,
        "0x5CAbc434185Fd34D4De0bAf430658f7E356A5699": 679.14,
        "0x3C045d92B7c3bb83E2018e2e296F6A0BC0E2eB07": 678.78,
        "0x241e25c9d15b5E7FB007B5E028C4ce8694893870": 678.78,
        "0x13884E58213CDff3b012CF15F8eC3bCC9E1cC75A": 678.63,
        "0x5d65A068426A802f77dDaf2b6038533F3C135Aa6": 678.13,
        "0x988eF20F01DD17ca87eBCc155cCc82B10A196474": 677.62,
        "0xDe4EB5c828432d1D674a6143029604bC811011E7": 676.11,
        "0xCa41A5FccF73D0793BdF8657ED4010ec40F10F2C": 676.11,
        "0x19Fc43306F065862D3f6a652034Faa999efb65a8": 675.11,
        "0x1F42bdaEBF64510e0c31E0D885d8aa498588A2a1": 674.76,
        "0x6c2693F5a936f37eD03CfA8465bF2D8BEFf19A0f": 672.59,
        "0x3f21dEf91eAAe16c7cA5B04E846CDEaa23AE971A": 672.08,
        "0x300B4A16304f453D226745Eca7500d5F12FF9A07": 670.39,
        "0xE4c3104beAa1871885b15595C7E125897E7D7a45": 668.39,
        "0x3Ed3f55e8a82a74a34487814AA5C15Bd685bc956": 668.1,
        "0xaFb7896E3083FA1D93F344a7DBeC40B61e4Ca49b": 668.05,
        "0x917b4B0E86fC7766695095dD1A5292B3BE8b2D14": 668.05,
        "0x71A458678bDa9D71CbB2b711DDd3f62118B457Ce": 667.55,
        "0x4594de64d7FFcAbf324D6420f186b6325Bce5c64": 666.39,
        "0x5505F7442fcBAD24F65265c422f8A055993815c4": 666.3,
        "0xE346cB66Ee5Aa2ae3FB315b7E0c226ffd611D2B2": 666.1,
        "0xA6BEaE4B5903763E3339536BE3115E3F1C2F9844": 666.04,
        "0x16ef04260Ca959C75bd8d4247874517c9cF74d12": 665.38,
        "0xbEF56c68c645346DFD47b5F0B68D6256ea96667d": 665.03,
        "0x7c02D95F6c79f2ef013779DA64cBbeEddAA182Ec": 663.01,
        "0x6FA275074A5EF5ED7e6DC343dF998Cd0EB1426dD": 661.26,
        "0x00Ec472D818f2d344CbDAb271ba1Ce96ca62BF05": 661,
        "0xa742017d7B299793d6CDB363e62B8002E42f9FfD": 660.19,
        "0x07BA62EDfd41CDA248242e826Bf2b6462AA5cdD3": 659.99,
        "0x222A9fe65e32BEbF3b9488Dceb50Ea7117D2B889": 659.99,
        "0xC0A1162C3FF721DAa7E0141Eb639CFb5765EA589": 659.1,
        "0xB98bD08341Ea110088d2bCE3cA09Ac9AD18290Cf": 658.98,
        "0x0A862EfCbFCb4F63EE339950BD2414062107E079": 658.49,
        "0x6598dF1870CdFD6B4B0552cd26366552882eA68E": 658.37,
        "0xDadB07d444eF44d56fdc04014e6DbD02A2f910d1": 657.47,
        "0xEFa401b07D91637AFC3327B6AefcA18E981ab3FD": 656.8,
        "0x5fAb7fa9EA16aFF5d369CC17a6577D48cC842C33": 656.02,
        "0x1858657204E2604344E17FA14e7F88cFF3c14637": 656.02,
        "0xCe52c2E8e54CC717D1B35ac730406141DDCCb47d": 655.96,
        "0x15f04b7D199C91F4981d0395ADD0070750Bb9669": 655.46,
        "0xE4326E187e40140Cc4336130D0b7962243F1bf80": 655.36,
        "0xD814E1b7cC203ff6ca4358BF4aa3ce9771FedC68": 655.33,
        "0x1CF8423299241F155716eb19D0ca65BEA4353F03": 654.54,
        "0x90632858Ac76aC03713e74d1C56d67437D647Cee": 654.45,
        "0x41bb08c5F310dD5eb32289A621eFA54d8Ac89f0B": 654.45,
        "0x66C092b6909E0FF3A63De2F9C33ACb1FdCE178aF": 652.43,
        "0xDe1a20Ad593386D0Ac260A8450b2349d8Ab4eb57": 651.93,
        "0xca96946d4B754d9172D401EF3d1e97A1f4aA0207": 651.93,
        "0xf2BE94DB73f895ad5a1D32964E0711404A807A94": 651.59,
        "0x68E0384D0A5DAAF5DC4247aB0D49cF6Dce4Aa748": 651.43,
        "0x7F63921D9faC69a6824dd3Ef5fB8E1A89fcc984D": 650.92,
        "0xCb0D7149e65b51891eACbEaEE59775AC207D7fB3": 648.57,
        "0x318962D28813fe14B9b6265fE2dAFB241C7F7777": 646.39,
        "0x42948cCD9F20264c773B29701499fC74930c0b53": 646.34,
        "0x43F2a3ea177175a555a7Ca1182De3611AfeA166d": 646.18,
        "0x95d52C084F4c8BD9e85986Ab218E5f3281021Ba7": 646.1,
        "0x94f34e6564b4926b41f45572F51300077089D5fd": 646.1,
        "0xe0d91A3E9266a25FAFA978d29fdF692D5AA79BaE": 645.88,
        "0x0F1945529ff7B884AB0276532Bc0F714926f1Ea3": 645.55,
        "0xA8A54039c283cbcFE6F6f892D46bB79Da25780BB": 644.88,
        "0xdc7434D709bdbf483eD74989EAe91c17b7CE1a33": 643.37,
        "0x3fd5b7d37757097bdCB45AcC65969dcd18BCc593": 643.15,
        "0x2b5e9D126FA4Be6128Bc017Da3Daca09cDB0198e": 643.1,
        "0xEb7308482e806dCc7Fe7939a21f20b3d2a36a730": 641.46,
        "0xffeaB7f32182D889e138F0AafFeCC2F5f476228F": 639.84,
        "0x6A4D00bc2a921e9Bf5397cEcBa78c6802BE3702F": 639.84,
        "0x9342174252e8aE1De46AbEfc1b930E21a3CbCF55": 638.83,
        "0xE37761B727bC9202499c63bFCa73C3dab0cea329": 638.5,
        "0xba86Eb14e0fE25caBef156604eBA6D09b226BE6E": 637.82,
        "0xC1c1fdadD3f76Ff4E34F6f3f0b00F4dB9B539A8F": 636.82,
        "0x530A6B90fd8B9B56E959d788db2a61B28047F3EB": 635.88,
        "0xec4Acd46A9Adec6223E47dd02520921B64a29938": 635.09,
        "0x0e42d7887e4Dfd681Fe295BeC85729C0420E0ae0": 634.8,
        "0x9cEf269a62e911A37ca9039d31746B196f25Ac88": 634.32,
        "0x069E413fA79578Fbfb8eA90EaeB17c8032d0787E": 633.29,
        "0x5f449CA0C6Ae1CAc4C4830220229233f0B60C103": 632.79,
        "0x3D88E984b1deC0187DEEad28180Ab53969858081": 632.46,
        "0xf1a24ebA326c03E74782Cf0ED47c6b7E8AD27f2c": 632.25,
        "0xdF703709e46b4e3992E8245BC8CCc205F0FF67d8": 630.24,
        "0xEC5b22756D0191fBbB4AFffDd5ae2A660538D196": 629.43,
        "0x9eb2d5311EDBAFd2137B9292d5683C35BF301Cc8": 629.26,
        "0x5Fb5ae540f763d70162cf7deC4E8e49b77781c9F": 628.75,
        "0x23146A7907987aB0bDCebb3A3824072bE077EA48": 628.75,
        "0xe3Fa81aC757e4A5eAED0ea9930Ac28557a664a65": 628.31,
        "0xf53Da038Da4471d11EC35874AdbaF09E517A3227": 628.31,
        "0x8a998C997D248F4263Bb61dF63E0dEFe3fB7bD6f": 628.25,
        "0xEfF1b58f76ABdF8c89277b4e79584d495250C0F1": 628.25,
        "0x274F44a0dEBD22d9827571447012b15Beb287113": 627.3,
        "0x7cAEa457224C345d1518a23FBd07ebDBdD21170C": 626.17,
        "0x34352365AFe60881f11042D3FaA2498dFa18560e": 626.08,
        "0x1eC9C8B70B7473Dd04a82AFc5930Dd0a34AB3Eb9": 625.73,
        "0x06917EFCE692CAD37A77a50B9BEEF6f4Cdd36422": 625.3,
        "0xC1C32aF296621daD0D9617a10f9fAEd18A1a4233": 624.3,
        "0x0792113E8b43dE564b09831b1d93d0EEe2aEA36D": 624.22,
        "0xe91F0085F5c3e67C8Ebd5c8f6E7f4d884452DBAa": 623.21,
        "0x74A5B346F2cccf06e2127EB6680389E7D8953c80": 623.21,
        "0xD2D7d69329b85e04e5dfC95b01E7Ede4FfCfC956": 622.21,
        "0x4E8f911B2da10563dA1357ED0eDa1670902c6390": 622.21,
        "0x76C5A034469E684e057d865553940995134Ce223": 622.21,
        "0x6f744b8BB88e9ec5E8A2678F9C57fe09CEcb9329": 621.89,
        "0x6b5F6F32C3A2BE3eB0670f80907Ab648c7EE95df": 621.7,
        "0x5Ab8E8a5Ac6Ee75BDf3ae1E9Bb5E354232768053": 620.29,
        "0xE87a10d5B212D169CCBC9a50Cf5E23DD3da27cb6": 618.51,
        "0xc408f4f72a3e802E0F10A0D8F109711571F17ACc": 616.84,
        "0x98D5ba40a5407C73B63842A027b4C17e6C7553cD": 616.09,
        "0x6fb737D1Ebb73cda6CFA36Fd16D9273065D1b084": 615.66,
        "0x62365E0af7b6A188D063825AFa3399Ba0b5AA7Cd": 615.66,
        "0x1c55aF9F52842a1b7DD8aC070047F79A1aeA1DeD": 611.53,
        "0x4Fa428EdaD94372cCf106A786f6b0D56363138b6": 611.12,
        "0x3a781cB383b65A1fff97cE061c3D35a1C09e6960": 608.6,
        "0xaA7c039B07Cec20C6F4092e58e4c0bf3CBCd5c78": 607.96,
        "0x21F64aB89929e9eD0A4b33D2D8e46719bd3dEB42": 607.26,
        "0xE4495842d915738D659609727a51E39d15b66778": 607.09,
        "0xf83C8f5aFd3d55AA74CEA7eDD9fB43Dc2e8D2EFe": 607.05,
        "0x8644d841138C35eC6724caFbcF6Ac8440d8a256f": 604.57,
        "0x9BD215C2530dF574657510B2F991d5C326df7C50": 603.79,
        "0x2a7f97640728f67033ed6E549B678feb23CF123D": 603.61,
        "0x4c9f175F83A3fFda627A0C5bcA999d1128eCF8c3": 603.56,
        "0x44CbDb1979FbC26Fc72156959191f322005E8F37": 603.25,
        "0x4fca7eA8770eA56d3E5eb1Ce0f35fFE44F198C7D": 602.56,
        "0x4f3482212740e24C374d1F88F61d0A29b827af7D": 602.05,
        "0xdd7432FF02455348F09459E9E6754549A9FA5217": 602.05,
        "0x4a21040B18Ba0e18B48Fb69233982756A67A0dcC": 600.54,
        "0x4ed7A3c71E9Bf0009317ff24Fbd8BFe96D8D808d": 600.09,
        "0x7854163b1b0d24e77dCA702B97B5Cc33e0F83DcB": 599.53,
        "0xd62a38Bd99376013D485214CC968322C20A6cC40": 599.25,
        "0x84a3254b42E95A236DC534BB503b21fFE8FF163F": 599.03,
        "0xbC627254fa9e73117cb70E1D4Eed610Ba0a9DE0D": 598.24,
        "0x71BCCe60D491390B55dBE41180D1755959b65C07": 597.24,
        "0x8cafd0397e1b09199A1B1239030Cc6b011AE696d": 597.01,
        "0x1CF274a674A29fFe2425c1111b64B4d181744CE2": 595.91,
        "0x62DE034b1A69eF853c9d0D8a33D26DF5cF26682E": 595.5,
        "0xa344C1401D8fdEC5F842E07a488006c6ec6A26b9": 595.23,
        "0x9118F45d7cE829e2389a2E79C39ed1866053bB38": 595.05,
        "0xaC9161439fa30E646dEAD6A11E23371F97eab067": 595,
        "0x2cFEd10c9e18D3D92Fad0b7dca74932af9185703": 594.5,
        "0x6A704a0e46dcC67A6316644372E261e8FB6F658c": 594.24,
        "0xAc6307742C8F093e9A59DE0F0487dC91D700F163": 594.04,
        "0x8950D9117C136B29A9b1aE8cd38DB72226404243": 593.99,
        "0x544845005e42fE00a3C0E9735EEEC25Aa068b428": 593.49,
        "0x3F86a3993c330dae0193b6081D49B32Fb21090b8": 593.18,
        "0x6415A12867Ff9C118Dd8c4A7FDf41FF0aC879C20": 590.88,
        "0x13FeFdD563A930F07B1aC8A2227Acc27c3C12946": 590.23,
        "0x0E6C677D8A38BF7133Fa79d961d800171c26bb45": 590.23,
        "0x4dDEBa3cb70e38DeE2F22071dA5F71770D1eCeF2": 590.23,
        "0xD4620bfBeFb6D40B7486Fae57Ad3F67e4Dbf9937": 590.16,
        "0xddF0cebC3b259420280371337b11F6fAbDDdf2f0": 588.22,
        "0x8f3Ca2bA9f6851DA523222f5D3b6Ba65Ea14Ed30": 587.95,
        "0x25a6029c33Fee6e0632017ee3424626CA47aEeCB": 585.93,
        "0xB1Ecc06C51D2523145465C7C2C29930DD47f5947": 585.8,
        "0x4D92c7272384C055EE2ef7aB0B7112c35B8CeF79": 584.92,
        "0x05155a722227f55Fa09D27Da44648BE4d5722005": 584.92,
        "0x9ae07f4f2A9498EA935f6871725cF596820e7E7F": 584.42,
        "0xc65c762FC8A7E1618529C1E49Ea3fE572DBdc40b": 583.41,
        "0x85593464c9dd38eC4625EF44e60CD6e8045Aa067": 583.21,
        "0x9b8D45DFF1A7ce03ffD0F9F282b4E3B190A2D915": 582.4,
        "0xDDc23d34ea2f6920d15995607D00dEF9478dEd6d": 582.4,
        "0x462aDB61b06922e9dBd92702be81CdDc65ba6cd3": 582.17,
        "0xe3E6Ce11e22F2Fe44D8B97f6C3CC8E29b6dA9c21": 581.9,
        "0x75d566aea8E7b1C9509399094d20267FFFFF08BB": 580.89,
        "0xE6901A12ECBA1f95a69b2a46D0B2DF786D20aD5d": 580.21,
        "0x264F77C7B6491469E6a8bC68a2aD4AAeD2A5A61c": 580.09,
        "0xaebb8FDBD5E52F99630cEBB80D0a1c19892EB4C2": 579.89,
        "0xCc38bB5F7b7Ca683D102963705a17315259a9148": 579.2,
        "0x2a030fe052D5269a45e63421E7122226A2894168": 579.04,
        "0x7731C6Fbe420b7698540C22CFcCBA9bE3F4ddfC7": 578.88,
        "0x632606E7017383A702BCBc8D1EbEDb349d144798": 578.61,
        "0xff1cd797c87c16e394e156C4D36a45dB01503B41": 578.22,
        "0x862865b52D17F7628a9F38763B0aE3832eb304D2": 578.01,
        "0x7Cc2cBB3C1E602208f73113a421bF99b7919Ba5f": 577.07,
        "0x81119A835eA963c8F82EF923b7F6d3234c8D5A31": 576.74,
        "0xB4173fEe41920a8e7D3451863f9779468EbAb98E": 576.63,
        "0xb0430a7E47ce0309C7BA242e5Bf548Ad0ba989Bb": 576.36,
        "0x85f813e2B8D084Bf6936143c1e813781809CB0F1": 574.85,
        "0x9950Dd62617F6123551aa61DE4a31a0DEe02A4e9": 574.38,
        "0xbaB4bB5e935EFC6CF94F0D19173eDFa4921d8439": 573.84,
        "0x006059c30d9BF772f60396D6D33d94d0f4CaC9B1": 571.82,
        "0x50e71E23D51cd79Cf484845327AC372970D47144": 571.73,
        "0x2067d095f4cACB434E921a2CF5b89A09DBF518a4": 570.82,
        "0xDAc11260EA26aA7Ace35F846ab7E389bd50C75aD": 570.31,
        "0x13a32F37AB615D3f2c4296d43E9f48a7546C1b77": 570.22,
        "0x5b77C93470d34e0742aDf80ddbaFaDeBe1483F79": 568.8,
        "0x2a70eB20E75b4Df3BaA6e1A31fC6232609Ab767F": 567.79,
        "0xA0eDfC6adb23f6abBa4F1813dB3f3bE22e94BF5E": 566.47,
        "0xE4664Cb4DCCEB441D816cf80c0F9758036222aaD": 566.28,
        "0xA0583D7F326120Fb8e083044a3B7D84df9B2049A": 566.22,
        "0xE3cFbf8fb378f5c4cF780077ee5C2ffe7aAea6Dc": 566.06,
        "0x0C0586a35FA30FF528b2d7Ce5969B845eB8c3A8c": 565.12,
        "0x6c76EDcD9B067F6867aea819b0B4103fF93779Fd": 563.76,
        "0x69bFA6aE5058361A07DCFa4288687Ee4Dbe91505": 563.22,
        "0x59118623e0C693d1BBD8D90D99F4f2F410491b0A": 563.17,
        "0x58EfE9AeE1b12053f4C58233B75c319412CB0614": 562.76,
        "0x92CEB7bF60718B5AC2582773dFcE3383e1fcC1D0": 562.22,
        "0x22138A0CFf84952C018cbcBF5650149017d6b292": 561.96,
        "0x8E29a644a71B1c9Cac1C46A5d9099d17301c08f4": 561.75,
        "0x2D5a17539943a8c1A753578AF3b4F91c9eB85eb9": 560.74,
        "0x0064b28742EE529579dBA1074f0A1633ac1194b8": 560.24,
        "0x17114903eB90909D3058dAE24D583E5970030FFb": 560.16,
        "0x84D8BbDE4B192139E85D4f4638a1f5E1A86B3371": 560.15,
        "0xa5828AA399F166E7723081dE17853c9700f63812": 559.73,
        "0x2c3B2e491268E76d0d2981Da42383A9A9bc1b115": 559.22,
        "0xD9955789F7094b6C0BD5f7E7aCFB046520A6a85c": 559.16,
        "0xa46B1d8fA98356a55395646Ca6094f152144F134": 559.16,
        "0xe84c5cB290E4A10f9Cd80F9B22D472C19421113D": 558.69,
        "0xE5061BcCDFB380Ae12E8f0a1279D006bFf32193b": 557.72,
        "0x95ea02e82F67FDAc79b2466C9d443fd72f37Ab36": 556.71,
        "0x8cAaf4cB80Ba7cbBbB324066BD03eAE3Fc98f813": 556.21,
        "0x0E866Be48D48520De28b4e6ac01a3dc1F68Ea461": 555.77,
        "0x06Ee98C8B78F5A43bc9da554F8dE869C42004A6A": 555.2,
        "0x22d97822FE17632361692090E5b2c6E79058A754": 554.69,
        "0xcfB10af967E3FdFe8F23fF15487F0E2496a93915": 554.19,
        "0x3E88681De2E12d1AC4116a7A6fb964A2C4C102AE": 552.68,
        "0x9f3eF866E769624D9A7A687a669d226C1e327b4D": 552.68,
        "0x60034A6D90F54d3bbc3188033fD08b1A146802ba": 552.18,
        "0x57877Fed03cbE9b2Fd002B0F2EFF67AA9b531282": 552.15,
        "0xf1196bF726ed9227507f5a8b7C87Ae177124dB2B": 552.06,
        "0xc688a50acd33CdCBa91760f58290FaB20bC11095": 551.67,
        "0x2Fe5A31A678A114a297B18dEC7771601fdCDec9f": 551.67,
        "0xEAf9A74BA2928A903366bD42339f1bbf1cbdaa59": 550.21,
        "0x439832E01A9C97F20374972027Aad4B73845ff32": 550.08,
        "0x4543e5710338BF6E514258ae7f4033eA29C700BD": 548.15,
        "0xfeFB82c43EC0f8eE61fea0922a5B122AbEfc3867": 547.86,
        "0x261e1f4667E750b2F3895B2c0c9A4DdaDFed5835": 547.14,
        "0x0E156BF3A5326322f7FEe3d336fcF63d00641C6e": 546.63,
        "0x18528dE7A2b94e13a6E2F2C4FE5Da6a86E331F10": 546.14,
        "0xA016A6dFaD2992162155aadc813dcfe7DC4AC4e7": 545.32,
        "0xe3232DB3aDee21123B18cFd2dB89B4F373E4Af45": 545.13,
        "0x4Aab9e6eB125cDd378671188255f19325E3A804F": 545.12,
        "0x65d8703eF7207CF701BC5E7f26a0aD1af8F63B56": 545.12,
        "0x641389016792d5e4300621A4fe1F059dEE7d6B8F": 544.65,
        "0x3465D93b84Ed7557d42d84CB7c8999Fc3DB2113d": 544.62,
        "0x4c8bb8279951fb8b1DE6e801f2ad8981F91df301": 543.13,
        "0xf8e5d7C889ce49E886D81ADbd7a00de2Fb22517d": 542.72,
        "0x0452b130342e83334cE04f56906B1B095B9eB19E": 542.13,
        "0x91A44879334114abaAC8DB9a2FC6c0AC544bBEa5": 541.69,
        "0xF6ceaEb105a7B01Bc0c726c78cb30636a03ea89e": 541.66,
        "0xE0d6AAeccD42464e04E86bC1D31764D8A1648914": 540.59,
        "0x80dffa637A669E1B26b83524921932e51E9a720B": 540.12,
        "0xb2Ae7773e14d857D1202cfc2A6A5a2A3de1525F5": 539.91,
        "0x73051a64044FEa61A6100eB0b55C9087BE32ccA3": 539.12,
        "0x5a06E90b84F7E14197eA1a02f548E6f5c5D872AA": 538.95,
        "0xBDC338f3CA019E6db3818d04d21660F685bb80e8": 538.07,
        "0x4d65E1871750c967aAE2e88599064c58A0bE57Aa": 537.62,
        "0x4cfe3339e865a38f4f5Cd379e837436A6556cEC4": 537.57,
        "0xc3386b8744C92635e43B07c6eE8aC26066119FB2": 537.57,
        "0x8bc0b371f03264B6a2c47AB4b253230808694A18": 536.77,
        "0x4a843aA4d6dc057A5e2C76150c6CBF747Fb13C36": 535.73,
        "0x0388edC27BCAeed2371EFA64e5384F6E0989277e": 535.05,
        "0x54012F79D18F584aa7ED7C7245C8a795Fd743d5c": 535.05,
        "0x3F3721173aFf420cCbEc4790E049b66E26cd9886": 535.05,
        "0xF13FB1113138b94deEcb91E1ca27CEc90b062835": 534.11,
        "0x11Ef8F3f57b7c2a317a420854Cecdd8A88f6Cb64": 534.04,
        "0xD8E7A250DAE3e8e3d77A69B8F6eA7729ee87ab23": 533.53,
        "0x83EC47Cdee957671962D7478d6225583c61e1D8F": 533.53,
        "0x8b9fBf6eA59830cCA64a725bcA0d5a0EB9619e1e": 533.49,
        "0xc7e8d3925cA08b91A493FD52480e2514AA6C0C5b": 532.53,
        "0xEE16BD78011347eE3437484D20288fc76Ed5992F": 532.02,
        "0x77d4D1D555533652815C2F12171AE7f45b6332b2": 532.02,
        "0x842De632cbfd3716205A73Daf024a3c318a93e77": 530.51,
        "0x55996aB2705fFbF8f1F08EB208a8e309F529f554": 529.1,
        "0xcEEeB61e596f0Bae44B791f3f1655501df7fa045": 529,
        "0x720971eDbF5b88D2Cf021e081c25FAd91EcCD359": 528.5,
        "0xa906B773bf4E1F5C668EeDEed06aa8917057eA7D": 527.49,
        "0x99375e063d30a2E3F52e4a43Cb040fb5d93FE75f": 527.2,
        "0x2187119E30603d27B59C8FdA7aC1a695A669203C": 526.96,
        "0x7BF3fDE4FE3D031CAF369BFd15855B31b4512a9d": 526.87,
        "0x5aE60432076d1885AA082546CAe5d0E4cF0E9b1B": 526.48,
        "0x52d126f15c651cc00C2270ec58000D6Df9E7EDb9": 525.62,
        "0x4eE67d558e065C6655f6a871A881e4717d97d1bD": 525.47,
        "0x7FB15cE26aB114302F0FC003350534FbC8b65eC9": 525.09,
        "0x89f42ccb1B90103A4b886Cc8ee01979492808079": 524.97,
        "0xB213043DeFE5A668fF6DCAdFe900eCc0ebc0eA52": 524.97,
        "0x6e3584085c4551596e0e2EbBba2092862Ae2E6dB": 524.47,
        "0xe635885EA198C78D0F86c64b95DF2aF2edC6DAf2": 524.09,
        "0x8cb20f59E717D2dEbaC27c7271370dc365F77be7": 523.96,
        "0xB25932CFF5a6AF21b15b6aaB5A153F30582dF33B": 522.95,
        "0x3A250DFbdDf46f798Ebd2Ef67dDFF10014946E9B": 521.95,
        "0xC18dAC166eDa9538933258d21A272C1775C19c73": 521.95,
        "0x13b2d56DE62F65Cfd389cB6a2F275c272D7C850E": 521.44,
        "0x0E647809755c1aC0A38CDE9C5e9234Ca477d846A": 521.2,
        "0x880db7D610152156De5CA3B5759bB00E561A2854": 520.78,
        "0x986fCC6B0D290308aD6F6A0e8471F74f53dec06a": 520.44,
        "0x0EcA5Bd7b78603C3A4B3292914C98b94500f843A": 519.33,
        "0xd211e839f02A450a05BEDc52aAFE520EB45eFe59": 518.92,
        "0x52497D4Cf8eC2d93CAD443F1A05028abc277CB25": 518.66,
        "0x752d5a59d9cD3ed8af87E0C8939D5d19Db168331": 517.92,
        "0x7A6A59588B8106045303E1923227a2cefbEC2B66": 517.76,
        "0x5113E792816311741f9a8a803953405f2DfFEADE": 517.2,
        "0xAb7Ab9b6495072c1136F96E301bD8f8DE900f119": 516.91,
        "0x88896886F994dEf40213EA82af840c32B8b1942c": 516.2,
        "0x629cBcaAAE418dA37F4eD34f13637F809F75278b": 515.63,
        "0xf240Afaf9a72bA475b9799581D985A40dB1A900b": 515.4,
        "0x80a295Fd597981186834E5D2EA882b74cb4B6CC1": 513.89,
        "0x97deb30C5C5a607EC7CE1Ed004015050d272dA58": 513.07,
        "0x344ca9bDD5F96EC279c3fF759cce08d6Db417150": 512.37,
        "0x3d7C2B938F3d293C44532C7bfFbFCBc6f7F8A2E8": 512.37,
        "0xa5C232FCf44DbE5ef32802aE3d73763EE8DdBd3B": 511.06,
        "0x8023d8ec9C538A46Feb69aF55529c2f5288107A7": 510.86,
        "0x6bDD96390110208bDC7f5bbD9f94FBaA9546aA57": 509.86,
        "0xB157EE8325aE8e0f5A5907e71C0871fDA62748D8": 509.06,
        "0x63cfeF91EC13813962920E71afc42f2473a9Ad56": 508.85,
        "0x1533F040e4f4d3bD23D806f064D00D31a955c3Ab": 508.34,
        "0x277ce049f66e6E8fa3DA47d7c83D1C6aE0139483": 507.72,
        "0x4a82e533eC2131A187c96dCA136e25B1F8087069": 507.58,
        "0x6C5CF6bc43cb1a58D61ec4e5b7758b202dE98a80": 506.83,
        "0x455813b0CF1ee9Ee4FAeE2F1B9aA909C432bcBba": 505.83,
        "0x9368749CF63a2FA77B8936eA2f55560Be7052009": 505.83,
        "0x4CE268F49EF0726d602a8b0f22FcC543aa23bb51": 505.83,
        "0x7BED1A9Fa10BC030456C7B3154590e4C02C9cb4f": 505.32,
        "0xb13CEa39A360D03198d8031ae00bC3150bCF598b": 503.31,
        "0x80223b82Cc86c20D1011576F731b226999e00531": 502.8,
        "0x5d980f615Be75aB7007CEC2D0177f15e549DAB0E": 502.8,
        "0x806388E04b7583a0148451A8ECd29A748b8fd584": 502.8,
        "0xe392EDd00a716141e4569161aa0BDE64D97A6f0e": 501.53,
        "0x13Bb00942C70B0dB5b073b6dd60fcc212ab6cAB8": 500.79,
        "0x50b04Bb49055F00E80fDa852940F48edF55A6Ad4": 500.07,
        "0x32cF8e7884b904e93961E046564bfd90Dd7Bc7e8": 500.07,
        "0xBd87D73D1261353de16A3B07207213E936561953": 500.07,
        "0x91b7377A3Dd7931Ad4757B60d7E859954B939E85": 499.28,
        "0x2A22e1d8423fC61b52bE9E3787Fa54a38D0128d6": 499.04,
        "0x9B81FCdb243fF7137aFCB77209d1D4BE9dC3a6b2": 498.07,
        "0xa8160e32D14E6B693D3c6f6C4bA090b87eEDd25a": 496.76,
        "0xA0be9216fFF20eD6F7eEAd48E4Bd2C256f9DbcA0": 496.25,
        "0x401c0F82117B3262b79a7697Bf98bBD7C0d4e36C": 496.03,
        "0x4C5ab437DCb44ceA186d441f160E17Aa3F734065": 494.65,
        "0x1980316479F2B01203B2CBF7E5EAc1aDC8f82bBe": 493.73,
        "0x54F2d57856e44Dcf81880DF34Df300D145Cc7D57": 493.23,
        "0x3a2cBFd3b7cf757C4b1653bcA04eC96D2F7Dac5e": 493.23,
        "0x171fF70367D5B9Cb702655E460f73e42cE931DCf": 493.23,
        "0x9Cf64fA5E8eaaD5250D94a97879A3eaC598ee262": 492.73,
        "0xEc99bBB6137A80c959db44fDCDA5D0ACE324e7ce": 492.73,
        "0xbD90Fa61ee83123A5c42EB2024Cd00FEDBb932AE": 491.72,
        "0x639FaD44e324329a726cc1845A4B7f3AB2ac1DAb": 491.72,
        "0xFc29862c02057685f01e134ffe44B7887812381b": 491.72,
        "0x7dA67Db95bB0F49602B1925d1aED9573e5B6321b": 491.34,
        "0x9d480D2E3A1a3E5Fe678CA8b932B4cA7d1503e2C": 491.21,
        "0x23CB5f48fa3F4502232F3442637f90E8e3355701": 491.21,
        "0x2DBf845F9f865352a694830aBf338BD5E8593431": 490.22,
        "0x1F367E135c820B3ED88c16eDb30eF2D508aD1191": 490.21,
        "0x2F7949779e18c18298C2F253E34F9355403a5c4E": 489.7,
        "0xdcF711cB8A1e0856fF1cB1CfD52C5084f5B28030": 489.7,
        "0xe5edFe0e968bf5dad6D023814989b536C0875676": 489.7,
        "0x9E40E0ba219e9e656420b3ad760c5779eCB601E1": 489.45,
        "0x28261858E665F9617E17C637a951bc205DA16150": 488.8,
        "0xB215627eF2fF410d67Eb9D8DEc14D533B234051E": 488.7,
        "0x75AfAEce8CF2a7974B1e541648923aFD9339B3f8": 488.19,
        "0xF2ff2bc69fB16674D0cc58BCdD7f674DB576bc77": 487.18,
        "0xCb5884f0aa33557Ffec512b404f3462A3416c8Ae": 486.68,
        "0xB6CE18fAEb71ac9dCA1984A3b2F66860Ea90E0ad": 486.68,
        "0x58524C6206382d8ee1A85B7B611bD9A10Ab9e743": 486.68,
        "0x30F2316cb15Cef2F05B86B8e7b2703B55021D5FD": 486.19,
        "0x6E552FeB6737458F771dA429735CBD1d66aa0E44": 485.98,
        "0x7E2d3E0F534B71C2C664B66F1EE32aE57AC8FDe9": 484.67,
        "0x8F29777b60643264518B7B8dE28cae85Fe24848A": 483.66,
        "0xaF0b68A684e2B7961A0B6078e36f43D6E990e54b": 483.66,
        "0xc8336B9DABBac9bFB9Aa483E76fc351B13121784": 483.15,
        "0xD4C00FE7657791C2A43025dE483F05E49A5f76A6": 483.15,
        "0x28aC01eBF289292783cFAAD9Bbf2c7fE2666dfBd": 483.15,
        "0x62eFaF62387873cE4f72a00622f89c5335115cb1": 482.4,
        "0xF9F898a62454c2Be282F5750fa72C73E58f98678": 482.15,
        "0xcC02D6fAE48Fe1652395d2D874332EF710a0375c": 482,
        "0xa5C4cF52ECB13F6dbC43240F1095d071a9a44930": 482,
        "0x7BCE17a7a874e07b672F703474460A4f4D8AE570": 481.76,
        "0x4A2ace39df5Dd670bFA0860faCB28178B62FF388": 481,
        "0x0c33A369f82eA6487ECd3023FB87272E6e329a16": 480.63,
        "0xFB4A7f3B61E66f2FFCE84415eb39AAF3ab2a024c": 479.37,
        "0x2dF1d109652fe1913B405E2b662f04DF7EEf75D5": 479.12,
        "0xA556A5239BEC88Ee0aCa8BBd59e9317f402FEf2e": 479,
        "0xe877A2f90F463b9f9746971387448899fb340282": 478.62,
        "0x08f518870Ec33bc96Cc251692b79A745C1af78B5": 478.62,
        "0x8C4b2471c7bd10261b9D2c3c5B9109db62604cea": 478.37,
        "0x294ca11a4faEeB79Ff01E515d130772559f886EB": 478.12,
        "0x582B07D825557D79bE4F5eA051167b6c534FeA1E": 477.61,
        "0x78EeaFf0E960649Ff2E727d10131157D142c04aD": 477.36,
        "0x75a84e5064FE0269740651B17E5b3B01Bf5A3B97": 475.7,
        "0x245C4d230b99E5D1B7c5300E969bbc2c08929dD0": 475.6,
        "0xb5083B50B4128CeE58EfB1a06543Fb50A8dC478A": 475.48,
        "0x5aAb6A96C74f2cDd8ac758800B02A06307276B4e": 475.29,
        "0x29aa47d52A42EFf2A7972dE74EB6FdfF8640ac9D": 474.99,
        "0xE6D7D904Bd6f500f8e3646823c4Adc2Fab0CE261": 474.92,
        "0x518781E2F40CF7871A8e8F5CA0d47714A6754d56": 474.59,
        "0x4c180462A051ab67D8237EdE2c987590DF2FbbE6": 474.59,
        "0x951356818C7D8363C430f4A530116F3E12fDb227": 474.43,
        "0x8424102DBAbaB1b95f4789BD9DD9f735089aedd4": 474.09,
        "0x1C708F7cFBB3DDA55CA45186a98C51d9b35202AA": 474.09,
        "0xf81e61fB582190295cECD2678224d1f877350F21": 473.58,
        "0x4A5EfA846e7375a40DcD596c7C6DAdB28df28AE4": 473.58,
        "0x612d5C920AAb4d75349a0F299883be71b1bC060D": 473.3,
        "0xbbafC0bC7E6C9Bc0Ec2C3924c0DB2B96a260C8ED": 472.57,
        "0x501EC729879b9c38C1bBf5E7fC33D0FEF649e053": 472.07,
        "0x3a8B8B717054410F38508DdEE7a43E4f73d1Ce8e": 471.98,
        "0xf45A4c6e742683c3Db5a487dbDF91A056553C78e": 471.57,
        "0x0EAdb62d5Caf12794866c33Ea934e5cc59C2E9cD": 471.57,
        "0x8A0454b05A952C572619935ed46B6D8D0aa97a76": 471.57,
        "0x95fe80aCB3e6c701e37162F0516F4ad62B3055F8": 471.06,
        "0x47b2EFa18736C6C211505aEFd321bEC3AC3E8779": 471.06,
        "0x4533E03d983Fae04741131C5f7cB35F1b32A1ACD": 470.18,
        "0xB44262A4B5c791Ca2a425612694C5f2aE1eFAD26": 469.43,
        "0xF4f07596c38ff3325cEEe518817883721616bfb8": 469.05,
        "0xF64242972e116B4Ca713EfA590730E3741589016": 468.54,
        "0xE33de23Db957431BD78e1969b72606c96bdf28Fe": 468.3,
        "0x41ea85A57725e77169C9f4d2edF17Aaef50bb14D": 467.98,
        "0x850B0Fe06389bdfa7F768353973dEf830f9De159": 467.74,
        "0x91f3ACF393dE794E7291FBF36DFc408Da617cfF0": 467.54,
        "0xB7BaBe35CE543e2Cf2F615CB1c792a2025feb572": 467.54,
        "0x7e2dfb80eB68f9946f45D7F0ea7c89Cd26660DBA": 467.03,
        "0xf1a77a3365555C3859B2c4F81eE4dAAb2F335B94": 466.96,
        "0x0E9B063789909565CEdA1Fba162474405A151E66": 466.63,
        "0x3888fdB006ad0294316c86FEaF26Fe91937b9bFd": 466.03,
        "0xBae401D98c797C7955c751eFCb5ceA0DDD548e2D": 465.52,
        "0x91B5d6c51D13a541cA25dC103b3C407FeF45EfEd": 464.51,
        "0x72241b7cd963Cf56ba409E80ED59E1AeE76a1adA": 464.01,
        "0xbdBf2706d4C4631A2fA3De0FF670a7343c5b7C9D": 464.01,
        "0x3aC6f28a7055A7fE3e3092184080Cc915C2Ea10c": 463.67,
        "0xc210086f4cAea1DcBCa5941E2535D34952f2813F": 463.51,
        "0x8f804dEc80028Cb5BBC5537762b27629A4Ab6C94": 463.51,
        "0xAA8A149C94054F440C543eF3831f7e7AE110f134": 463.51,
        "0x89137Ad23E3e4F3662534BC15f0B1174145CfB75": 463.21,
        "0xaBe780bDc3872B4DEC16bD44B2bB999f9151aE28": 463,
        "0xc4506f1AC7c1dE2Ae9864afb4dFB307aD5d576dd": 461.25,
        "0xaB72Db4aC66452e7b03063f6cEf85b26e8C1f800": 461.18,
        "0x9eDa173B60B105d2E255A1f535f70dB2587eEFe0": 460.99,
        "0x1914717974224765B85636159d48F46DbbdBdE27": 460.99,
        "0x88f08753D440AbE800f46f7114FbA8045B0022A2": 460.99,
        "0x644588099b4beB96cD782849A739F06D0cC22E4f": 460.04,
        "0x90eB355a85ea5324529224945bB55F1960dA1b47": 458.97,
        "0x897A51a2cD8b895d2AbC66B4f7e47715bC5aD93c": 458.47,
        "0xdC7D0D897e1B7998c780D16b3C08482A74e71F33": 458.47,
        "0x2962b7d54a2e770A3313801fC40C6EC92A045aAa": 458.47,
        "0xD23f7594185A26D4860FDEdD2b759FB0Eba6058d": 457.46,
        "0x470224E4ADA16de2C4276a74f46f7D1209314758": 455.95,
        "0x67de083c4dabEdba4619D39995423dF8E630771C": 455.95,
        "0x5d134Ce34C7366Dd76843c1C35C26b302ca463C7": 455.27,
        "0x9741DD89FA0969aD0E2e26806C8Aaf334F9c7FA6": 454.95,
        "0xe6b7775e47507a45184Ae31122E91De586652ed4": 454.94,
        "0x29719517a3B755E4b9b52BCa5Af631a623515C28": 453.66,
        "0x0e2436046DdB286D203Cd5e072F4B29Dcfbd3db2": 453.43,
        "0x9B09399e07EAB9Ec8A53aE595De3029909572AFF": 453.43,
        "0x4d554Dcc76221783afb40176C7Afa958e4d0D8cF": 453.19,
        "0xE227836Af161c8194D982a658BEF21F2fD594BDA": 452.93,
        "0xBc943fd601F3b86994d47F164bAAa8FAFe4cf915": 452.42,
        "0x4FfD0A59a26cB2Aa76D403215e4cC2845C053994": 451.99,
        "0x1Ec3C1f70E1D6bBDC84092ae86eAaDE495fdDB9b": 451.94,
        "0xF5f8dD7eC9075c3f1368Fc0bD2A2D7712b8884b0": 451.92,
        "0xd801e8d85D963B249C4408E67e3FDf472F0b377d": 451.41,
        "0x108C665471bc72c3Beb4F09fb1960081E8092dEa": 451.24,
        "0x0fffa71f769868104d6178b29a0a2cAA75eCe632": 450.94,
        "0x476DbA6a05C4f1C0A7dA2Aa28bfAe5F83425FCb0": 450.07,
        "0x4CDcF25036dCAE8A5eB58e96722705D009b80f06": 449.94,
        "0x2452E136265E4B2cE559534e9eb18e9907F45973": 448.89,
        "0x275818ba9a1870eF5E9FD6C6C91F348a766BE597": 448.39,
        "0xD138FbAa1236c8568014CCB2De9faA8E7945C6D9": 448.39,
        "0x607e34A7ADf09b323e6f29b784EC11941c77C25c": 448.16,
        "0xAc4a0358C5E860dCCc8B7e384f13BfE7CaE84774": 446.93,
        "0xd57faDD02679e0e31DC1838c4287FaF670a0B03e": 446.54,
        "0x4A1C2e8b2A59Bb044872000804a746dEE235D1E0": 445.87,
        "0x51Cd245699780aD2be18fDF254d6c519adF971a6": 445.41,
        "0x0192ba2F3ff12e0dB99142829d12b806903068d9": 444.86,
        "0x14da174FaB1356466aF2dD0ecdF94204E828A732": 443.86,
        "0x1982bD37E91Fd7a8c88805E9a7aa009fA804b1f9": 442.92,
        "0x2FD99B41Cf2aD7b5b7d69CeFf4194c5d6D519781": 442.35,
        "0x5F399AaF88796f51207aaAe3F4c4eC9546C95517": 441.07,
        "0xFfeE4a454b874bA1c16883428532FB44c9B36854": 440.92,
        "0xfe6F04161eE19801EfD6dB1f9E692984E234d99e": 440.83,
        "0x5A1Db6317ee8862Cb51c427929A0528fDbcA1127": 440.83,
        "0xD1Abe5DB14d073883f2084c2aF105652102BDefc": 440.83,
        "0x5eDA2dc136986Fc88D4DF5696bC464f96A20268A": 439.83,
        "0x140e1A864FD1835BA4A51b5Ba7c39DFe2218d4f8": 437.81,
        "0x0feeB7936a806bF2006EB3D73D3552eAf4300fEc": 437.31,
        "0xf20FDc9a62dE0B4724580EeBb867E34fe0C6E5cf": 437.31,
        "0x113e29e69e25a902d579a1FCB78Bcd661FC5F705": 437.31,
        "0x56E57ED6fafD049d182fF9e4B8B0fd4083053389": 437.17,
        "0x081223c2cEa1d7288f42276CC519346019b3C479": 436.8,
        "0x020989126F19AA0662e0C69Fa269fE5D6215D786": 435.8,
        "0xBc622C6bcc9200c68d525AdF5c8b1B9C3d1C6DE3": 435.54,
        "0xAE4E7B55ad7eb4636964fE0B87B4F082E8BF155e": 435.41,
        "0xbA977B238297365dcEAE952E1b42ea64e9b7075d": 435.29,
        "0xb312665792d45A3884e605e8B7626aD5b09D66a1": 435.07,
        "0x508fE8256a6Dc870fCB8cEdcd461D03E5D8af448": 434.3,
        "0x8100c6D03Bf91C4c524f1356CA27b51d3CDd9Be0": 433.9,
        "0xc7Bd0345621Be74C0ce406FB16076CF47d467320": 433.78,
        "0x7e7454277c9BC9Df97C7fa288F215CfD5ad2D253": 433.28,
        "0xFcF80133cD4E8d79dDF8125A32980398a0B074D0": 433.28,
        "0x9B97682902dDb7D1ab195E723977B56621bF3711": 432.87,
        "0x5752E385fedB45Dd21987F23e7a6987c21011306": 431.96,
        "0x3A39899DC78b7307aCd83f51463C853Fa79E1B09": 430.76,
        "0xfb15339d187A76AF62698F73D700E1F8536f03BD": 430.47,
        "0x25397B8E6C19AC2c6F6217f89747a9Eb02ca1946": 430.17,
        "0x00ba280c55643f707e23376c948BE41b5468eF58": 430.04,
        "0xe4c1AcfC81dA2E03e0d166c7e95031802c3819c1": 429.79,
        "0xdd1c5aEBd67F3c662Fb6487dF60cB5FdB1823A1a": 429.28,
        "0x11eBeE2bF244325B5559f0F583722d35659DDcE8": 429.25,
        "0xD48BE80e72f2B81a36BD3d5FF0c67cDD954258C9": 427.89,
        "0x983C108de3986932Da4dE1d8954eed98c545b614": 427.73,
        "0x9e59Edf20D62acBc689d5e72b8F72fEDd7a3d282": 427.73,
        "0xA66375Ade8C5Ec7bC41c8F0C19CF927D7f3192E6": 427.23,
        "0x31e01a9B0796E131b5661eeAeB93981315B7d8D5": 426.73,
        "0xc925275688CEFbA9Cf9f01e1f7E6696ecd0741CD": 425.89,
        "0x4FEecB0E202D8a52be1706f5fA210c82e53a62Ae": 425.89,
        "0x37e6072596a35B623e949690dE49430706ADD855": 425.22,
        "0xe7CD9a570B8408761eECdE5791732A9B6E024963": 425.22,
        "0x5d87F0d97117A455F6a3CF35503Da5f357e5eD7B": 425.08,
        "0x94Ab7004390d951DA2Aa2A2e646758Ac498b521a": 425.06,
        "0x0e3E8dcB7DCF41A87f9224b05400ba46bfaE4b4C": 424.98,
        "0x1Fc5fbacA1e9c3e187d79D728FaC51C1a2119922": 424.71,
        "0xf6365e34f8Abdfca311DA07921616ACF0397b1d7": 424.71,
        "0x4a4d72082D31f2F7051558b5C41EaD5AA7beeb03": 424.21,
        "0x7b1426d5C26FDE907718F8EBB9D7aac2f3528ddc": 424.21,
        "0xb37A69C4f4EB82Af5CcBa06aE2BD9fAFB8940077": 424.16,
        "0xbd58D2Dea3A24b1d2F0cc5C11D38B8419B9B54Bd": 423.71,
        "0x3D71Fe614d1A372EAa90bac2F6146b3b7415578b": 423.7,
        "0xf7C755b0F3181c1F0362BAE38590dF697535CA58": 423.7,
        "0x975aC81122f6EA7a3DB50c49b168fd455801daCa": 423.16,
        "0x2CcDe611A35Aa395c8aEb2bAbB4E25C835CA1760": 422.19,
        "0x58C4f03a954e4CbB1b8E204a881a8e9A99d015Dd": 422.19,
        "0xD9D8ac720d840A81d538556967af2AF287f5E80b": 421.71,
        "0x616B073b6C67c729134E9De6FF7EfE74F9eB7566": 421.19,
        "0x116f282aDCA7a37E59668d80400D2e4277DaC80A": 421.19,
        "0x012ed994df76022637F79fF9E209D7D44a4D1c8e": 421.19,
        "0xDDb4BFacf01bCc012B130717f9a7B0A8E9Fc24C5": 420.97,
        "0xC28B51b270d7F126fC6659A9C0f748AdB787A155": 420.49,
        "0x5a60d345FB510A6Cc230Febc83C7Ff7016eCa0bf": 420.18,
        "0xB4C93d0A04D4B7966776cC2A0Ba31b2C9Bd40d18": 420.06,
        "0x8A65C9a1E50F26dE0E12ebf4185a473905f23ca6": 419.17,
        "0x16F570e93fDbC3A4865b7740DEB052eE94d87E15": 419.17,
        "0x7BE8DBb062FfceeEa525e963F033fe4fDF35E41e": 418.95,
        "0xe74B3696c6d93716ce01472125Be3b9C74aA378B": 417.86,
        "0xb2C0422E617dAA9c70f81Aab28C033370e1d29ab": 417.66,
        "0xf09e41562B8c306E72415d8EDb66aF1a85fB3909": 417.66,
        "0x0C9e20B9046f31DA1E84B1B968b5FFF23e815FD6": 417.15,
        "0x14C1D06Ce5feAC55414151D91DB9ff8cf79d1b4D": 417.06,
        "0x80c41B621f432A2f5a8De1da44BE5E072316bFB2": 416.87,
        "0x96D41D8F4709d21448FE8d9aF43Ee00B8363eC5e": 416.55,
        "0x256E2248ABB150e5Cf0860235E153d0b21b02b25": 416.15,
        "0x2A8e0ebDA46A075D77d197D21292e38D37a20AB3": 416.06,
        "0x002344F3C01b32771936403d2E531c1B4018ECc6": 415.14,
        "0xaf2e03293f2176C75f251f3b179fcC17E58a6621": 414.95,
        "0xe0654ABC5FB4917AC59237F8B9f75316982cF0bf": 414.64,
        "0x64A966901F9D02E1B6f3D4f8E6f82d9d27b594CA": 414.64,
        "0x8Fe316B09c8F570Fd00F1172665d1327a2c74c7E": 414.64,
        "0x4F20af317DDC1065F46468B759d3ed2B82e4f602": 413.92,
        "0x188be73B0A68D20830eEC346Ee3eaa900F848bfa": 413.63,
        "0x766ebE879d83FD88F260e25698c459B129ee1352": 413.63,
        "0x278FbF0cdF19Dfec7F2a7C7D319c957B2B62fa6D": 413.63,
        "0x25E2d930F6B34a85f967ae73bb85104023d0F8Da": 413.25,
        "0xDd4cD105656446F7419C31925D3be18D542b7b19": 413.14,
        "0x4ddA9E1A1Cf3a97974c31c9a7FB2Be6486332D25": 413.01,
        "0xE8a17d5276F9c665e7713a2F7A4a0a388915aF8d": 412.62,
        "0xCC41F0B58b277553Bf416f7015B3301c965AccAF": 411.84,
        "0x02852c8D47685caa718DFFd1dB1D31448779d8C8": 411.61,
        "0xA65A864ca19535E4C06000768c6CFa9F6EbaEb12": 411.61,
        "0x15376620Ae9261AbcEf4dA896B1e413B907d25FF": 411.11,
        "0x46e886F3FCb527679AbAca2E49272fe92A62348e": 411.11,
        "0x30F89f5f4cF25f457B4D9cBFb64a64A97F00bED0": 410.55,
        "0xA3617Dfb6C364E183E3c141fd8DEA6cf8FAd830d": 409.89,
        "0x1D12e488cB90E6684caF9a07DdD6bF930DdAb2eF": 409.6,
        "0x84021E99AfaEDf0E36f89f569218651A4a81Efc7": 409.16,
        "0x74E66ecE5724e0217B8955F851eE6E1Df0790fc9": 409.13,
        "0x5a2514A65ecc8613F6CDA213E155909990508453": 409.09,
        "0x61Baf9247340b788AE9392344e059CD760EE8C2e": 408.85,
        "0x5A825C64df9DEe1E35Fe9041CA8D69509414C4a7": 408.59,
        "0xe8B8385F31723c538595D133Ac0293228B2A98aC": 407.08,
        "0x616b8248a78Ba31c04f769242060d0D16913c04D": 406.57,
        "0x9526f4FD80a3c0456C1d180517C15Ea8134f9fd9": 406.35,
        "0x03354437f81AE7aE5569F63BA3B4A1325dD12e69": 406.07,
        "0x848887741B3e38233Cd858c5dD7B48Ca9197FC08": 406.07,
        "0xAC8b275b9ce0Fee06aBFB98ef20471A9E9dA56c4": 406.07,
        "0x9BB3A2876C09B7a51dd9FcADEd501ffc393b08Ea": 405.84,
        "0xbb2d01F1cb61A1c784eF7170906463C282F757Fa": 403.05,
        "0xF10fd43f5f58128269ed4E312FE56084a18E50B9": 403.05,
        "0x88AfC9ea8dD40c6B4478532846d87EF614e0057d": 402.54,
        "0xBf7620D0377B0660A6cBAeF5CDfe2E00eddC1495": 402.54,
        "0x56d12039bEAd6789B5431DB78143ab3085E56441": 401.03,
        "0xC667d6baf85ccB9DF181e2280CeC577c014D1c3D": 400.53,
        "0x540BD7eA85D7229E353a85d75FD73bcB8C74e0ce": 400.06,
        "0x4a7f94a50fc5E38350Be07521Defeca1A925B453": 399.83,
        "0x1f5FA0fCf048e453ef2A1F1485A8bE1388162915": 398.83,
        "0xFa01C614B923a3A6574719574CA4311e8A1Ae08c": 398.81,
        "0x8170f9304373DC5eB1cb91CD1EDF878769c69B3C": 398.8,
        "0xD051A78bFD41ABaE46055e36A3239894941f27d8": 398.51,
        "0xc96088187468cCdfAd6154442Cb0204DD323314c": 398.01,
        "0x9859A4583763a5ca30cB3dc676b41eae3b628e4a": 398.01,
        "0x03A01b531Ed557460922583aFB4a4c3C84d7F9B1": 398.01,
        "0x1f67DfD96A85180051Ede7D5c74A5e17878A3E7f": 397.51,
        "0xa00FB4af5b0560F941aC9819eAd1C12855b4cF49": 397.51,
        "0xf9e1D1e9F22c96752356AdFd377231528c7E851E": 397.51,
        "0xc28495826b2fB0dCFAF821652F186792B47B4B57": 397.37,
        "0x50DAF20699e6D747760E94172b54564B63f47d79": 397,
        "0x647B41B745cf5E32E244e432902468C4Bd89643C": 396.5,
        "0x7d261BbA02a6064b1136C9bca8842928e65b6FC8": 395.49,
        "0xEc1f12c955E98b4C2F55A26e37E75d43c84e6844": 395.08,
        "0xDD9bF0A45452a4F22cfd2C963c15B191D97Ce106": 394.56,
        "0xa3A3deba8a8300A6A98682380501f8D6f3e333fa": 393.66,
        "0x0318F8Aa777548D0DA0D35B349E46DA9EDd0cd5c": 393.15,
        "0x8838Ae7754a21CD7FE376f18eC3f9Bb83E8F390D": 392.97,
        "0xDeEA7465ba904B61b27Ef1FabC6B2Ba691F173B7": 392.82,
        "0x0b818Dc9d41732617DFC5BC8DfF03daC632780E1": 392.82,
        "0xEB2D541a7599eeCc86049e366AA82A914A7cbc74": 392.47,
        "0xeee3BfF9F48D5A05E0b352EAf826c4F12c06dD02": 392.47,
        "0x7Cd01cAC1D6c9518B525a33DcDb005a6Ca3C37a8": 391.99,
        "0xF22862b5c8D5a17A68536521e0c82C5387BD65AF": 391.96,
        "0x7e6C6b2DA2f5973272e2AdA5405b35431937f3b2": 391.81,
        "0x8844126cA5dEFEE105Ae50e5089933768cCf9999": 390.96,
        "0x8d71E9F18883fF3dB6aed212BD288AF2a3Cf7A97": 390.81,
        "0xbFA524D804C919E0BDf66503c06e53E47AeB720E": 390.45,
        "0xfD00B2be80b8b8fad1Bf411270dc3ba545Ac6952": 390.45,
        "0x913e484704E97043c32ec89097FD453B8b679016": 390.45,
        "0xb3AEBa7fc075dEbCd37Bd6743f1dBc4FfD6baBfa": 390.15,
        "0xB3b4c2126cDCe49ab6d778e9479F368e503c352a": 389.95,
        "0x74E121599DB43F2b11b75179aaF06F5ED6187977": 389.81,
        "0x7EC7B375834Ef33A1A677503D5065651Ee530975": 389.45,
        "0x08ebe5FC18744fFAA3d2AF319A022a94a889b98A": 388.44,
        "0xaC516CFc8a5170B4D003312AdBade589F4E93ece": 387.93,
        "0x843CA717461a5D27ec57d26e07618599C7eE4252": 387.43,
        "0x07590b780927586D5B2e870721e71b8D5A4FA871": 387.02,
        "0x6355a9Ca54D121796750d6b2591E4d751a1539F5": 386.8,
        "0xC56E12Fd9435bbEDD79E03429CfE798271aa4b5E": 386.72,
        "0x0c36246B58b288BC231b2F070113A91449B9d49D": 386.6,
        "0xd099CD21055BE0De9EfefADe7BFB5Acb3d74C7a4": 386.15,
        "0xFd1f937df2e64019D4e1e7eEC745A61176ab2cbE": 385.92,
        "0xC954892D9cAF463e967884E379a6Ee4c78D61BE7": 385.92,
        "0x5700fc8a6079A6a9f92642078B92924f8a0c64E6": 385.92,
        "0x36794c0762d5A78B4A01CC64FB6bA83D5f53B75B": 385.41,
        "0xDaaFfba0aB113acBee5C65eCdCCcdc60AAf7D110": 385.41,
        "0xA740522eCaff98D1F2eBB29d5CAA19Fd4cF5D92F": 383.9,
        "0xdCFE58b449e5BD43e1bD0294077dD0186cd0a585": 383.4,
        "0x100FeA55DA1316BA7C624A7E5E86eE9861e3ffB7": 383.06,
        "0x3322F6b154fBD6d8C9E873586fFf45642b92d5a4": 383.06,
        "0x42a1ef5FfDaf134EB958814E443Db9c244375C8f": 6894410.811316385,
        "0x3Df6fEDbF3Ed9E580cbF573D712B5CbB725BB2a7": 382.9,
        "0xC0984E230fD669D000294D35A8128B742B8367DE": 382.8,
        "0x0ce5E99719a20Bc75a24D610A12b692A2740d4da": 382.39,
        "0x657018f03dD33EAb03A31CcF5E87dadd1aAFb97B": 382.39,
        "0xdd504361b7C1Eb4aA43B9751Fb07e9485fEbd3dC": 381.89,
        "0x563a21ee82ffaEFa8C45BDA5f1e5D4BEcA335050": 381.89,
        "0x3C9c3dE51bc19645fBaB52097Fb48a104472a70C": 381.89,
        "0xddC60D163015CF5Ca1369D557A2ca1cC2de1F1e3": 381.47,
        "0x1343cb35d15C3E8ab1a592495101e74646665a0E": 381.38,
        "0xc60861680f748fb8164e392Dff70ece0577B4389": 380.79,
        "0x0e26b2Af0cAd6eda72Fd0D2b39CFb4d71bAB4A36": 380.38,
        "0x582d6FeAE1926C19304e49206C710fe06C5F5593": 379.87,
        "0xC396e325afEF0E49d7712A223208c8440c1b9AfE": 379.37,
        "0x8B95aB83D350b6BA7e352cDD77FBF8b8f30f8d57": 379.37,
        "0x00b3eCC795d7f3C3a0416be0784c43B652D5f4Ca": 379.37,
        "0xe433538E2a41CD7fc7FbD8d4A6ee07E5a71ed916": 378.87,
        "0x0Ef7a404d0B0fbA21319eddc7c58F918A64A7f5f": 378.87,
        "0x301B0679876B92e44238b52d99917740E572418b": 378.87,
        "0xed9Bf438be20869199fDbAae24cab3C5AE518767": 378.87,
        "0xb1CF7880351E6D16313C03a6686B4c8a5bA6372a": 378.36,
        "0x7097f0ca46c53880FBffe74b142fd86b4241fA13": 378.06,
        "0xFB901B5D918329Ef8Fbe1E4091Ce5d572fe55FEF": 377.86,
        "0x341c18D764d0843698122aE5b5D2DEe20067645D": 377.35,
        "0xCB04F9F5E1Ac544dfFb0d479b696e7AAdb76dBFB": 377.35,
        "0x307d85ee43edC3ffEC7401164aD85728d7fc070A": 377.34,
        "0x9FBA91753Ebc75A4465A608eAfA3326FEEFf4A5C": 377.02,
        "0x90e2c16783B4a3EECFFcd03eBA587dd33075D9d4": 377,
        "0x8F23B1606eB4781dD99C6d7b6c3cEfbfD376b58c": 376.85,
        "0xD08c3C698C25B3cC25B6d9BB7a9224070679B04b": 376.35,
        "0xD1EDf51Ec3431E9eA16317021fF627BD750ec706": 375.34,
        "0x9c9c48adC52d9ce7f7147B50835b0EE61AFC25EC": 374.78,
        "0x7dd508a1e4Da1243789B799a480f8B45e58b1B5b": 373.83,
        "0xd287B9581D7d502e681a1c4C3882E765594dEfC7": 373.32,
        "0xd53C79fF8c473bbFE4E40e5525D4d24fD4b8534c": 373.32,
        "0x2A7051d7CBbEF7B6889f8e14774020b1653b94C1": 373.32,
        "0x27CFc88640089f340AeAEc182BAfF0ddF15B1B37": 372.32,
        "0x8eE7a7AAD2AA6Ef5393Ee6F3a58992C906E6e734": 372.32,
        "0xDCa84F5039ad4bC51E974386E65264F11F7743fB": 371.81,
        "0xf2ee11039377dD00a9C611af560d27c7517E9481": 371.81,
        "0x6aF642C12b77e70caa6B4053b825a1D0c8c32922": 371.81,
        "0xdC9F27318a3990c3Ad9532C6d769550eC111d770": 371.31,
        "0x6487d336bDec94d4714a4d217B15aa5c7b9dfA99": 370.77,
        "0x164F0fcf621037476b7F4Dbbf71d122ee2295295": 370.3,
        "0xF5CcD855B7d196c3f3D54aE65e90531F1849bBe2": 369.8,
        "0xeA6D4B6962d9c19C62DD391BbF4c5E7a3Ac0632A": 369.8,
        "0x5957658FF8bf237565c12be948AA1787cA60b91C": 369.6,
        "0xbb7809A2bF7B788CbEf16CA8F1e9D8Ab44756C90": 368.79,
        "0x62707F17000355C1115DcB52309686ACB4bfa52D": 368.77,
        "0x696378e49Bc7B77D046d733A466256C2B6ed0Ae7": 368.29,
        "0x98625957C6b96eeECD040e5BD26bd42100D124B2": 368.14,
        "0xFbe12d942b8c152248Fd118F598C08124FF3D7DE": 367.78,
        "0xAefE98bC5B06EaFAe82a0267A525CF4D2425e452": 367.78,
        "0xbAF3450838069a9BAA0c0540878188007eD2BA77": 367.59,
        "0x35E55a4227160D4d4f1b1732318d5062f348b354": 367.28,
        "0x34274eD5C887cb1e9f4cF408c4b2705C98394AFF": 366.76,
        "0x5bb96c35a68Cba037D0F261C67477416db137F03": 366.27,
        "0x4D172eBF657c0e7D9af8408abe00002d7E20a243": 365.77,
        "0x765ecC4089c216385d6B1d4DC1994FF012e73d39": 365.26,
        "0x039665790696181f2E76021E4E1797AB2eC4fE8C": 364.76,
        "0xfE02CAb6602A8f1E35EEFaD2792d304998451C76": 364.25,
        "0x5666aD07470068609b34F51C2a13c2896732CA64": 364.25,
        "0x870aa098D943382d13B491B50C6b93876Eba1eEa": 363.25,
        "0xCBf65cec512A996396be23cE78dFED2A857184a3": 363.25,
        "0x73C62d8D98215C7C97A320d1C65407eCeaa1107E": 363.19,
        "0x4cc3DA2190BeCe1Aa7ae6f24081B0D9604b43143": 363.14,
        "0x820A2943762236e27A3a2C6ea1024117518895a5": 362.75,
        "0x54b00AAE51E8C8f022e420681Da940ad08B780D4": 362.74,
        "0xbDF509A684aa8C690d1207D267D631c41356ba23": 362.74,
        "0xBB8FB8fE5198f25D117C0e7B1b9C8260CB19C3C0": 362.24,
        "0x45821aAA1d5923Eb66363F82B9F37e2Fef758433": 362.24,
        "0x47cAf3275Fd9fE21Ae842DBCeB5c8aaC41c873a9": 362.24,
        "0xfE22484158C747CCC0652D6F408B8a0547A59938": 361.23,
        "0x13a3D67b0b6AD8D7380f9B32A295D509D3987159": 360.73,
        "0xF30D3f233a747Deb41D35d4C63Af2C3C112c33AD": 360.73,
        "0xd61015823B60A7C6E156C887A72467a8170259d2": 360.73,
        "0xabE21a7537cfF588e6209492aFCa65d635A3b313": 360.73,
        "0xd65370c5565F2bEa121F3C22823233F98A4Be793": 360.54,
        "0x1E76E800745D5e6CC76E11eA9fFdE2D65b4f60db": 360.18,
        "0x64878672B3Fc544DB57b043eB651e13F1Cb8c4eD": 359.72,
        "0x95910EfbF5faC0B7715121656c5b62a819540C3a": 359.53,
        "0x8A0A19083B9B7bCba081A3CeB241DB2fA52EBAb5": 359.53,
        "0x42bA181d74c10CF172373e0b2529367D28bD611f": 359.26,
        "0xFDe34A676aa8D44b66d5ced822831A5b1454f8b0": 359.22,
        "0x4F54edB55391dF3156607971c71DA03fBFd31D67": 358.71,
        "0xDD63Fe25E25B76686Df754D5283e8c5e703aE39F": 358.21,
        "0xB651978a51BDC8643982580296cAf99aA448BBfD": 357.71,
        "0x80ca39A504f37081bA2805420d234dDC9DaB9d45": 357.71,
        "0xeF382f4888bB69E077D5F59177167Ca536a5A199": 357.71,
        "0xadc1d13ACf57EA12cdF14679177Fd669221ADF2c": 16720.9783539603,
        "0x27e7EF864A1143d95D4f0d3391232475B545F9AE": 357.52,
        "0xE64290f31019acDBd1162Ed379AA168B8cbAb991": 357.2,
        "0xBE96635eaf3C394B583AbCD303d043F0A8311Baa": 357.2,
        "0xC2787EC3F1bbd5A0BD1423850E94c9446b48E2D0": 357.14,
        "0xDe639C2f28378AB59702354608d51B11a5019c3f": 357.14,
        "0x5345462544ed763639519376C298E939228dD1f4": 356.7,
        "0x7692AC24Bd274EaF2B9DE02F05Aa596495A2f29c": 356.19,
        "0x605572243c30Af7493707C9c8E8aA2Ee25537e9A": 355.65,
        "0xfcB1C752FBC206035799cA84046Ef86902990C45": 355.49,
        "0xe1E7106A790017185ECa0731301bfB7c571aF7c1": 355.19,
        "0x809eEf5fA685EA349A1CC6990FBaCf3A355d1E24": 355.19,
        "0x404a8094656CBfe38353F637E815fCc05820E949": 355.19,
        "0xAE78d5362f6687de8fbB9B5De6dD129883d61ea8": 355.19,
        "0xF3fC9208014aB619FB4b4A9fd00efE5994a6c153": 354.74,
        "0x8a2e722c2f167283E38FFee0Ee5F1a035596915f": 354.18,
        "0x731e8d889597781Bf1f1c94F45b15254C753123C": 354.14,
        "0x3DCab1486D4B494145E3fD598E421B6C75498103": 354.06,
        "0x7532A096bE1a39A87aF68e3b27e06dde7065E87F": 353.74,
        "0x15b4bC68335B5Ef21835cc0414ad22E18e9758C5": 353.34,
        "0x6c7C462148823c4f12445E1687EB5Cb2576C915B": 353.17,
        "0x6e868846b2182235C16FD122FCD44739E55A58e4": 353.17,
        "0x69794735cA88dE2eC2426fB20F416FA00F64Ad37": 352.97,
        "0xDA5d647aa9cFA75167D0A9F299fDf01beb9Bdd1f": 352.73,
        "0x0f42739c803584524FE28230B3253BA15b326c7C": 352.16,
        "0x52F8B09FAc8E1B7D7dC45643CA27d0f573814AB8": 352.16,
        "0x5987fc9b72105b433F8373594B8Bf8e94C33cEEA": 351.48,
        "0xA82E10f6120Aa01B95474bbba71CF9649492c05a": 351.16,
        "0xb7e9Aee176eC340965bde1015Ff9522c0B971d3b": 351.16,
        "0x24198aF68Eb5f276fc0406d2e07aE09210bDcbB6": 350.73,
        "0x75eD1b4e3285A3B89FC7452ca1D63eC7a46bA4E6": 350.05,
        "0xD283cf89c832AadA01db076289E90fe67E1309f6": 349.46,
        "0x72D4bd7c618b6BBD35eEAfd70b93f97F6AAe8baf": 349.37,
        "0x17850aE51422F3FF20244931198213e8f56491c5": 348.14,
        "0x4853081029c557e645Fa42896efD46029DCc32f2": 348.13,
        "0xc0fa207d207288d727BAF8b4f2b3CA93F45da246": 348.13,
        "0x2afeb9ac4196037c575b45aDa553b70Ec80d40Df": 348.13,
        "0x5637e39DAcA999E221007dE982AAe3D4D5085e5A": 347.63,
        "0x83FaD94eAa0FA69df6A9F13f7c3577Be6180b3BB": 347.63,
        "0x169945cf64ebd10139BF7B85C86Bf710947ac9fa": 347.13,
        "0x34BbC9a46B09283698ba7Aa1c273E8B4E9F7bcC3": 346.62,
        "0x65F619D0eB17FE49062eE6c8F8C82f2189c56756": 346.05,
        "0x6BB0E66b437e4e1a61a86A729cE359eEE686D811": 346.05,
        "0x1EbB73f5F47Bcc3D7dC1dabf7284875E3AE40E07": 345.72,
        "0x06d45164A9065931692fe8b454e332ed8CC2Ee17": 345.61,
        "0x58a80268A284c0EeAC28c4821fa20cc0228A558B": 344.61,
        "0xC44cd227B1c4f077392C29726cfE77B89d961483": 344.61,
        "0xE82a43687829D003b91250f041bA22163ba6eaC1": 344.51,
        "0x0c4E7870fF6F11e722B9C0e1EA8e930528AfA6B5": 344.43,
        "0x0E80A01f8E69D535975Fa34e64498651BC74247f": 344.1,
        "0x13b39775583E0888F9836782aCf9F1E50F767ca4": 343.71,
        "0xDe1FA11188571b887901f62EFA0291Ce47e509BA": 343.6,
        "0x4087855d9905F37e0712cd6705105B7d6053F1a2": 343.6,
        "0x5163D2109Ac93B447828789b8dF537bc9Fa3BF19": 343.6,
        "0x6d57d70947fA51fF14325Bdba75A884d14030b88": 343.6,
        "0x633bCb12fe73C7eAcAeC3157a9A52b916aDd5968": 343.42,
        "0xd6D7Ea4833f22edBED3DbD3d71Adf3cdD8E36a01": 343.09,
        "0x35b7E813A6B99d8FC15050aF4FA618e832A6e63C": 342.59,
        "0x4fBE5303bCa958b8f1ee35b5443Aad9aD442e3D7": 342.59,
        "0xd5cd4169d75fA1567c773Af21964bC85Ed701c6e": 342.09,
        "0x226F97b743E6BF400733E86dC304348E29386B64": 342.09,
        "0xc1E8A62e3C7cBc093FE83298989dFa41F7A915bC": 341.08,
        "0x1DEd04611E3B48F620D42bC97f798cb085403f73": 340.86,
        "0xFB0857E91Ca6aC98FEB8748BFD4532E785d8FA64": 340.58,
        "0xc908EBe17f637d5B0c805eaa872Eca509Cd47e57": 340.13,
        "0xd105dEd0A518bac298550146FD3eDaF299337976": 35341.26429047748,
        "0xd1EC5E2Bc945AB3c0E5BA8a4F30e6c586E6010F3": 339.71,
        "0x686a0AF16D26DD698c623e01F752a78e0A612479": 339.3,
        "0x14678eAaE5571cAb919A68519574A0edF2024fFd": 339.06,
        "0x1804038eB19837E4C8126da9ad527003C727da2E": 338.7,
        "0x64A206eA3E642Ed143e647d941Ea4Eb04f3dFbcA": 338.56,
        "0x5983A50A686141fF6856B653727d9595EAaDe1d6": 338.06,
        "0x581278aD4C00f4f2aF057105817A8e78b424A65C": 338.06,
        "0x7aa61e5fDEF15599D2E8cba9B8900d2152E3d3E9": 338.06,
        "0x78b36415EA94c83FAE0cD2606F5Aa89a1CFD2980": 337.7,
        "0x90C0Bf8D71369d21F8ADDF0Da33D21DcB0B1C384": 337.55,
        "0x5f27a88E0dA9033AC3EeAeaB505B8c5aE5a55f3F": 337.05,
        "0x1dc619C4f2D36965EE1F8cd94732DAc48003A917": 336.55,
        "0xDEb6D60114C24d825384Ee1Cd24b22c8066556E5": 336.37,
        "0xCb45b6be12647943fB5A49AB68AeD7283bCf0743": 335.03,
        "0x377C6A8f82Db0a5e97dC5bA644a22F8185f58Ed8": 334.7,
        "0xE0Dd8C40ACC74005C71CE5d02Cd5116A2eEDB1b0": 334.03,
        "0xEF0c7668af2e04bC8cB8dFa321e5f9159F4BaFe4": 334.03,
        "0x6206d0ba5278a78ED1AA078c4dB946e126848E0D": 334.03,
        "0x5EF533fa865954324E488f3c46606D03B7d097d7": 333.69,
        "0xD1cBF265fCdCAfBA2e406A17dDd3D178BC7B6803": 333.52,
        "0xe3a5957a0503F5b9026F39Cb8714e0Df6C137D3d": 333.52,
        "0x79BB250E121746a9f5097340275D1A1B9A7AA41C": 333.52,
        "0x8c93f5F1A8Ac534542d837EBdCEcC55A4a2E836D": 333.35,
        "0x6c1D054C38a9C84eD07412e77Ef4197De58F1753": 333.05,
        "0x46F7A9B8FFCbe97763A2aaEBBF54A9eaB8d9481B": 333.05,
        "0xa79512CEBdC9b66fD7927C77D6156938B5705b38": 332.69,
        "0x5aA162a88DB019C7c65e11aB2898B9cE927A05D4": 332.19,
        "0x8F2c46cE880C288Bbf0926123814496a9842a591": 332.01,
        "0x5A515a20DAA8b2Fd90e1F8d3Ca22E26f887EAC84": 331.66,
        "0xBb00900B914C71D7CC0d6c8865359499B9d0b3B6": 331,
        "0x035EFfA901E21Cb460357B08faFcC2B6d69e323f": 330,
        "0x4CAe5BED586f6E73Ae54EbD40A4AC4eD2c477C34": 330,
        "0x4a35D869d28dA18EaE3f10d6059c343d9E944748": 329.69,
        "0x6DA3DCf29BB3dE02e74256B4ebfcF5E0d130a5F8": 329.49,
        "0x0C5AcB430409912b9a286AEbFf69C245B7CF9079": 328.99,
        "0xBEbE54dC168C0ccB6e4b3236DFbc140F96556219": 328.68,
        "0x4eD7437e6c72be22aA41B6738913B352ddBc0B02": 328.68,
        "0xa219712cC2Aaa5AA98CcF2A7ba055231F1752323": 328.47,
        "0x6Ad2a85393Abdb183349f1987953492FE6033375": 328.01,
        "0x05E254cD48778b37001fa982441a557682E113f2": 328.01,
        "0xFB60d2d0C6BDa4b3661E252AB3263809D0720Df4": 328.01,
        "0xbf91cA5D69f10424f0f52372ec09b6d933c12516": 328.01,
        "0xceDFDf7444B9508E2be6671eC0D015037D6A7F62": 327.05,
        "0x179C799C649C23c249f580d08C9FE40ade8F6E92": 326.97,
        "0x08138243c8b2c5BB825763A7B065280A57Af79E5": 326.68,
        "0xD820F0fc608A3bACEF3E3EF41dEE5426b5A799A9": 326.62,
        "0xCab4C999a7083F1EA054A48b78E93cc529499565": 326.47,
        "0x450Cf20323733EA1ba31357Cc129BD7dA188Cc68": 325.97,
        "0x29Aa2eD8712072e918632259780E587698Ef58df": 325.46,
        "0x05b5240dAA1894a299a41D1F63f1CaACF94bDeb3": 324.96,
        "0x08bA46e1fB7279da2233c8C75f3E4784056b4bFB": 324.96,
        "0x1e9832102212CbEB4Cf61e741Ea2fC70dA9d9487": 324.92,
        "0x226Fa898550EF48313d359d90F69914018a89F73": 324.45,
        "0x8a20A9CD1Ce3c40c997345a3fe15f76A500e2D36": 324.45,
        "0x74ad47b91469d6b2356337AFdb05608CfabbbdE8": 323.95,
        "0x952815eA349a0c10db5d854a16A27d768e85053e": 323.95,
        "0x44423597E18f4f63405eD13739594A2CF0830769": 323.8,
        "0xc0433E26E3D2Ae7D1D80E39a6D58062D1eAA54f5": 322.94,
        "0x41a6ac7f4e4DBfFEB934f95F1Db58B68C76Dc4dF": 322.67,
        "0xad48CCa48B5B9e0bFfbaD0bDfFDbCaB08f286aA9": 322.44,
        "0x78f214cf1287b5c97df55a285E885b09C0d43e3D": 321.93,
        "0x9176E536F21474502B00e30A5dd24461f7EE6DE1": 321.93,
        "0x27ADFbDb9A913fFDf886b4f76eca80AB8f189beF": 321.93,
        "0x2f8a3A55cB32e7208df17c5E707582ac2f5f9a4e": 320.93,
        "0x04A505B7Ff3cA4Ad5f759987de5a6A746542FB97": 320.93,
        "0x4fE8C620c7BDc4839f17045522011F2fF5146FA6": 320.67,
        "0x4334703B0B74E2045926f82F4158A103fCE1Df4f": 320.42,
        "0xb090f2E51535046983b6c541F2E6F60f4BD5aD33": 320.42,
        "0x5cAc4a6ff0C0c90053F0204e8CAF1b707BC307E6": 320.42,
        "0x5A6E9ba01afDCEC6Bbf20D02493047Fa8ccb5b98": 320.42,
        "0xA455C79Ad2E6b2c64372886661De7A2ed0254d75": 320.42,
        "0x34311fC19594fD3Aa36fc2191708Fb43E23c577C": 319.92,
        "0x111a8934a5d0D3913e5D055dae46DC2c965709a0": 319.92,
        "0x10d6152D166020C93BF5bbEae4210ffbFfC6F50B": 319.34,
        "0x9DC3E0fC228c2455773E70ee9E987aE2a6FBc07D": 319.25,
        "0x5b5d5bb563B041E2C68dc98C78C3fD33C2630817": 319.25,
        "0x85EC99bF30C9963fd0Ce9DD4bCD58f62bf1F8088": 317.9,
        "0x8651460Da34c8e75F89dF06463592E386dC9dDb7": 317.66,
        "0xfa84cc161B9bd9243Ca6E009bb922DBD6DE0c88F": 317.4,
        "0xEa173f401253436102DA7a77548fc99322bd76B8": 317.4,
        "0x672b678Bf3B2e6B7A6a1Ed66AD3A2BbF767c8b8C": 317.24,
        "0x3A8A15E11bd83EFb9a9aE2c752c89FF5b3E26F8b": 316.66,
        "0x3d805a35e9F634684762E973f56d58cC6C2CDccB": 316.39,
        "0x4B867E361DBbc3c053c5B0836246e0318E096b39": 316.39,
        "0xC59dF331531Fbaea476cA77b183c2745d9e98bae": 316.12,
        "0x0805C4BB2EfAC3Dde1887d73927241c5d1DF1efb": 316.05,
        "0x9E1D38565c4C8d0A2debA5A4de6cE0D3B8132343": 316.05,
        "0xcfA985eAFeacD824135173dEb3Fde50c05aC2cE1": 315.39,
        "0xe0979ee9BB502FbB95042748Fe42494677Bf3a5b": 315.12,
        "0x647bBd41441d537acCb5B75D538e6440796BF950": 314.88,
        "0xA8518a2cCDfe353844F2fB553B90D8E8A740b347": 314.21,
        "0xB9E80fF4f9b97F160BDDF80a1e0513F7f1D14570": 313.87,
        "0x1b2B36FAaa1cF712d28dc2DA8311051F24348749": 313.65,
        "0x851B1A980947f37563F0C4b50Ee0f1513A6Eb141": 313.37,
        "0xCA37d80aBD9799E9060E2Fa64B9A9476E5Bb097f": 313.37,
        "0xeCb48ec6a12f37840d38d09b01540f622e122130": 313.37,
        "0xB9Fb11B215424838146A0066cc3cc3f78300313c": 312.89,
        "0xFfD3Da76203642d4EE112893F33749A0dF7Ea7fd": 312.87,
        "0x3Cf60592b6Ad570791E8B872E56d7165968ee96c": 312.87,
        "0x28EbF504b2D49fC5Ddb751f99d494D7607832a8d": 312.87,
        "0x66D04143395256769D19DeB6ef0BBB1aC63D5219": 312.2,
        "0x1B30b75499f2248C14A6B172062ce2149A23179F": 311.86,
        "0x819E98CDeCC1aC4a3927bB6a6F16aeDEFdf098f7": 311.65,
        "0x22cd7b4C5d78fb7baBCf84c390166B20dA363614": 310.93,
        "0x5399a6b7792175e664ccA7fAaE17BF48813A267A": 310.85,
        "0xEf044f956283F12854D3b7eC000F3485b824619a": 310.85,
        "0x8074Ed7AeA09a7F371aF44daBD4De6C42839929B": 310.65,
        "0x44C832526EaBde3af5051E7dD36EF5410597a902": 310.35,
        "0xEE96d0738b2A87876537E96Fba205A6B1C879eDc": 309.64,
        "0xb9afa613ECeea449FCDE2F81F94c4C16d9B159b2": 309.64,
        "0xCAeEAC120121a33C5c232619A2616e306e329cd7": 309.34,
        "0xa5803aCCE163Edc79Be0FB463b3d268bbD806970": 309.34,
        "0xc86Eab5a2975B1989245a32d77Bd66d0B084Beb3": 309.08,
        "0x42fcdF3B9597E46121B194c7911faF0ab2f6ea43": 308.84,
        "0xB4264E181207E2e701f72331E0998c38e04c8512": 308.52,
        "0x8896B42460EcEbB749b11CefB02532ED4d75F296": 308.17,
        "0x227F2F1b242962f9EF06dcC6ded975F8508D53CD": 307.83,
        "0x487c6480C33f32435F99cFa4b1E09C0D4e4165f7": 307.83,
        "0x823b8C5FA9d5B19649434Dda4ee042BA94e7159E": 307.32,
        "0x533834AB612E74Bc78451FC7198262b209213f01": 306.64,
        "0xB4F85b484b50FC0F00e9BE04c4382a6Ee91B22e5": 306.32,
        "0x44a1670350c1e23b0347F614E7b4Ad8f8d2E582A": 306.32,
        "0xab15e05fcb1C61e36F98349dA8923Ff2a5Cc3a77": 306.02,
        "0x433120a9C679173c6d6525b7c90E3E43F94515Cb": 305.81,
        "0x2bcDCA8c689b4aA460B66FFde1d6B1761d41d5dF": 305.81,
        "0xdBfB0785366262f4736BcB5757Cb20f0065c4dD1": 304.81,
        "0xcCe9eFdD67dbb46186C84Ab94F58b7990b18893E": 303.8,
        "0xA97Be4812b99f4Cf014d3bd1F2Bae18aFff771B8": 303.68,
        "0x7B2fC0feacDf2F59bc26F19839AeB6eeE43f4224": 303.29,
        "0xf3284a18B5BaaFcFFe6E0635F5452F7f5a2A7dA4": 303.29,
        "0xEF1244aF7099dCE45eE7F937534f0968501efb29": 302.79,
        "0x4d3730E9a2080902446c0Af9f9C7f6da9e58c264": 302.71,
        "0x6CcD7c23e6Ccd9c5258EDdA9fcA61D1214DE5622": 301.78,
        "0x3c63Cd40fD284A9944669c8e69862BbFb9aD16Dd": 301.78,
        "0xA6a1f461289395E42F1d10CEC5B6C5eFAbe3c792": 301.63,
        "0xFCAB3337172623862D1E8bD742432410b125Ab93": 301.28,
        "0xC6BF059aABEf5668c32eBeef3DAe82E59d4EbC4A": 301.28,
        "0x647Bd6d2997fd588838960B419222d1Cef903eDE": 301.28,
        "0x88Dc672624B511DBF08881624629a13AF10aCFCE": 300.77,
        "0xF5f61157f3c13e4bbC5C42E75Ae80946b72de83F": 300.77,
        "0x4b718319459972e70766c72ad698734f53EC3d97": 300.27,
        "0x1c462907552572f07B2e8897C93d263686d831E3": 300.27,
        "0x12cFA0fcBf3B2B12D90025D03EBC3241EbD63BFa": 300.19,
        "0xaFf7d4de2E66F032BE4C65eb13841412338f4fB4": 300.12,
        "0x227C11007bC83B8D0AD14166D5169EFb881A5E7C": 300.09,
        "0x5786Ec177Be57110cec0cD1b742BDacD6e1fb42e": 300.04,
        "0x103a1F94Bc38313Af8724777Da71201e40ADeF5a": 299.77,
        "0x2755Da7BB6B7A70eae26CcCF447682298EAC1eB8": 299.2,
        "0x5D20723D6eCa69738EaC8b4767c46682ecC76F3c": 298.26,
        "0xd4b0eb03F9dd4Fe80f5dCEaD8d2D880B4E1Df934": 297.62,
        "0xA2FCCaA52223aC5B78Fa81B1D54211642FDA9Ec4": 297.62,
        "0x040528e6eBdcBC6e37e3C78350dE0a59AedCe622": 297.25,
        "0xa1257A2E63CA8f0EB6662e5252ae2A32bfb48648": 297.04,
        "0x90C9F4dcAfE2bbC9536306765c70a49e493A51Bb": 296.59,
        "0x3b8f79458b6d303B47D56734B00CC6941443bd95": 296.24,
        "0x99b553E06F1a59Ed7231983D7D61eb0f707A3c85": 296.04,
        "0xa6a8bA4BEB5AeAaa9Ec19FbFD59A09DA8efC3fEb": 295.74,
        "0x4ac4FF89b9D4b3dAF54942E3dF63751a4a54c735": 295.74,
        "0x3544773551EB240C2d8B499A62CAb994E7BB2662": 295.23,
        "0xd613A4cc742267Dd51259d9679cc0D1ad83f7776": 294.73,
        "0x078B8Ff955e3cf77550Bf2f2eDFc0AAcbc29ADc6": 294.73,
        "0xACc2C59c954048fE4FC8D9f1C5dCc8B93AFe53bf": 294.73,
        "0x2A36b16a31e28098572Ef981eC551384487c944e": 294.23,
        "0x3D3fFE5Aed29a841A606f8359315264D74624650": 293.85,
        "0xEA2F79BCE55908A11E0BF7dFfb855C962041674f": 293.72,
        "0x5d1C6e65f0c2Ea0c0d81d35392d497DEFDA3CAcE": 293.61,
        "0xCf7841FD47bF33004B07eDE874e7aFC714616231": 293.22,
        "0x7302bC5b47F5588174A148C90747a88CB528A8c1": 293.22,
        "0x18cCC241CcE98a67564E367eBc1F1f0e692E3188": 293.22,
        "0x43F09Ad2Da895e6AccB96adDA8c0d9f71C327222": 292.71,
        "0x43D16CCd581E1D6A8d51768f75DdF09b79F4f856": 292.71,
        "0x12E83070AF0B8Ad53c76826e0ADE6b3d4e2dFb42": 292.61,
        "0x8A6D9d34Ebc9C39Bd30e72c5466C37694D7809da": 292.39,
        "0x661B2Ff33A5f3C682820E17c8dF830B9cF6Ed6D5": 292.21,
        "0x6c5726Cb312f931fce2FC8080B6A6bB876Fe7bF7": 291.61,
        "0x2fE7dF4DAd91Ef6531Cd14fC1C109D2bA1755203": 291.2,
        "0x737d8e671B806851522A925858157e273B015f74": 290.82,
        "0x1bAFc574581eA4b938dCFE0d0D93778303Cb3fb7": 290.6,
        "0xA7272D4C9114E6a7322bf3b45dC36016CBB13DF1": 290.6,
        "0x55DF88abD27bcbD379af67ADeddE15fC55cB24Ec": 290.6,
        "0x9B15F13e0C3180aeE2963b5FbA6C0a1C71DdD1Eb": 290.11,
        "0x3Ecb35b0012B71f04dfA994D6dea750a17CfF0b3": 290.11,
        "0xD43a6388eAD01B950598EA589abC05103650d1a4": 290.11,
        "0x7F44628BD0F7921820107392EdAd71AbDdcB17f9": 289.69,
        "0xca3459c85009D657393717D7E0072A42f0C69733": 289.69,
        "0x08035EEEf09a566088B4F33c4D057EB533FB5550": 289.6,
        "0xc38E6640816B2731ed595780582A87c9b990D0C0": 289.19,
        "0xae1c418071A34186991F7ed2F83aDd0713eFd102": 289.19,
        "0x5A00e8683f37e8B08C744054a0EF606a18b1aEF7": 288.68,
        "0x80cfCd0157030d8808e03d283e742C8008614654": 288.68,
        "0x577638d983a464C9d99796096B7D91a86d02f7a8": 288.6,
        "0x0c8B244e44d7157F717B6B0AFB58a4Ec4eF9B0C1": 288.6,
        "0xB00C639fb8996f2aC3713C41a3194FAb6C87AcbF": 288.6,
        "0xC6537969b03CBc712A2d9ec4d89917c4a310591f": 288.18,
        "0x0bd7CbfEa2E0E5baCf8e91f20213367E69b6ddd8": 288.18,
        "0x309153728E3e4B91980003BBB21520eE7042ae72": 288.18,
        "0x835e7e74dDc84befa0A4663d3D6AB1493A2C71b8": 288.18,
        "0x62143b4497d1D2F8405671dC2B5BC5b30a8a57F1": 288.18,
        "0x0F9230A18FC4337D426Fc0e65790a99dA7b02B60": 288.03,
        "0xBF07387D5C0997A1d6FbAF220BF7901eC8576788": 288.03,
        "0xaf8C3f1Bd96e44fb68B94bCAc9bdF275db91E70c": 287.68,
        "0x808af82545A721C06D1FcCEbea915a6F5128BeF9": 287.17,
        "0x5243968110439573D2395F1AfE38f0f471c3510D": 286.67,
        "0x8320E7e7F433cde77B80edE49e5be2Ca0BeeeD60": 286.67,
        "0x6a0d078799F60C9a4A8C325e07800Db05CC4E0ef": 286.16,
        "0x6305A0074738757d445F7211544fc825736cCdbb": 285.35,
        "0xba3E2dc0119D8B84EF61C0c48A923054beC9665B": 285.16,
        "0xBE60B326ff517C4d5B6e62370702014e4d59E6A1": 285.11,
        "0x85dC8ceE3600C10917474Ee35458188149a107db": 284.65,
        "0xF7Ce05cB95d321C7F22aefD1defB99e54E087B15": 284.65,
        "0xbFdd62139F97163D83Cf5CB7F940564b56c6fA5D": 284.59,
        "0xA5ecC068db75fFb36d157625b08E747895A03d18": 284.15,
        "0x8c580556Fdb1f57853e49F409Ae9b89f7658e7A2": 284.15,
        "0x3a0b4DdE32d3FEDBe5E2fE9E884bC04923c7f3A9": 284.15,
        "0x67bcD41adBf12D1eCFFD86e17AF2b14179B556a3": 283.59,
        "0xcF96db5AEe05b4875cb7d19BAB1B32d584F4B732": 283.47,
        "0xEf6E620fdE6E0201F90C1D593cd308933b907BCE": 283.14,
        "0x4310370CcAa2AFCd664ea4d9FD3124cFF85E050f": 283.01,
        "0xBFb810B67A07528F8c5a2c81d65347a5C99f58FF": 282.99,
        "0xadfBf9eccEE2C330D7a045fB5533b978FF5fF2b2": 282.64,
        "0xCce0a627557f2b9Af402607e5342bA15AD5F0053": 282.64,
        "0xC397a2C2963e3181883B7135a7Ef1bA85E8cEb82": 282.64,
        "0x8A95d808481e9b12506670b7A9cd4Fe1703bbfd8": 282.59,
        "0xc1a032008324BC4471ef7e535B9ad28119d26918": 282.44,
        "0x4A3592A24A88249F14adaac604EB2e79FFe948CA": 282.13,
        "0x745C5A40B1dCA74BEa74358B49b0731DbE61e106": 282.13,
        "0xd5cEac5B4Ca2b965f4d18e01cB04572F86680043": 281.7,
        "0x59FBa5557890c89c4b7232d52a9218A11E3CD922": 281.13,
        "0x9f05A7a5d012321D06A501A671cE3AE85bCD551f": 280.62,
        "0xDFe66B7dD823531f32e002209D6Ccd5552C6C356": 280.58,
        "0xe1347e9E5e36688b6Cd3e8853195a2FfFFEd0f76": 280.12,
        "0x05e5ab383f3C2D423cFd118B83420261ab0990Bc": 280.12,
        "0x029bC418a5Ed23D7D9e7fE4058e61a816EE6ae3f": 280.11,
        "0x063a6171F2cB53AC193f2377A26d435834fdb27C": 279.65,
        "0xf73485b87539224A400d8fFEBC7fd9944795521d": 279.11,
        "0x9e9336C6aa5e08Ce6d7CF3AC019162240a6f7897": 279.11,
        "0x15061b3aA8C2e9738fcC3ea2243AE53d9eB402F4": 279.11,
        "0x2B1855f3E0d453faF76c91EA8504239D3bbEDb61": 279.11,
        "0x6649449f075A8F6Aa56Efe43ab5c45B8ca0dFe2C": 278.97,
        "0x2aC757eed6f96f0B0a4F248F3148E615D56E8BE3": 278.58,
        "0xf85262B9191ec62E96e1e1Fb3eB81A59b65C3bfE": 278.1,
        "0xED5c60e0F4d17fAb9A84b76Be3085406790D9Fe5": 277.96,
        "0x0152667429aDfd3eCd2dd6C3d3cfc1e669E67309": 277.58,
        "0x671ed4672BFe6e6D2e2850684FEF27109c3a945a": 277.11,
        "0x060f729A9d7471956D2516DC8CfED6589d4C6B32": 277.11,
        "0x55dC5d3Dab013af752832a5B03De7Ae902aCF049": 277.1,
        "0x5929b019F5396BDbEA040B1f2FD7C461aA1F5531": 277.1,
        "0xb8b0CC3793BBbfdb997FeC45828F172e5423D3E2": 276.59,
        "0xae16928a9BD3c1dFC41Abd797646fd1230490f42": 276.59,
        "0x5e78bbF73546F4C7748B3eF9087E622a446D651B": 276.58,
        "0x6C8398F6BB69153B1fd8cB3317F4C7B2c11e8AEA": 276.22,
        "0x698129eCee187BC180ea93803b9fAEa9FCE33a46": 275.08,
        "0xeCc0FaB1cC1dE4541B47488bE2752685b29526eE": 275.08,
        "0x84F70b3dcC6f10552CCE01861393C1B81261ceCA": 275.08,
        "0xeCc5a33938425bcd26C445AA57186F2e67323437": 274.81,
        "0x81dCBFB02B11522648B0F30a2E441Ff6e0d3E035": 274.64,
        "0x6dCc125fd1dDB4B78a11878830bD9483912d8Cf3": 274.07,
        "0xfcF2D8DBe2A5eD88739b4658eD8eb10Fb3512C7F": 273.93,
        "0xFaf6DB163Aed020A0F8a99B67A91c96ab55b3b7c": 273.93,
        "0x72A2da3Dd2F9e29C6d11AcA62834306e6122B41f": 273.57,
        "0xA97AAF494D52Cb85C9A0cf5a4787FAC77cf1D59A": 272.56,
        "0x00DfB0d32722D7820DF685E1B93f33774E83892E": 272.11,
        "0x1142184C427c843172c14025DF52501536caFE26": 272.11,
        "0x60104a2cDbb0207f4337036bcAB90716b2925C69": 272.11,
        "0x856096a04005ee2426e951686f9E11762b93B679": 272.11,
        "0xDed5c1b36DF43E64385277667AD6C6a7A3ffe295": 272.11,
        "0x61EE78DB97A6D68BEA605b07c4B1d23d7f413c8d": 271.56,
        "0x0Ba892e34EA9F88ee54928f4f5f4d41f79c705b1": 271.55,
        "0xcb3b366cEd5aB2170D2Ac72a5A97c4747e9186D8": 271.05,
        "0x8FC4FAa9DD274dc801Ca629234E83183031634ec": 2975.5470603332456,
        "0x702d1AD579D45B2591E501949994f1f202854ac6": 271.05,
        "0xe9b9Ce5a1eD1885781Db5221F75d4734A5eBCa40": 271.05,
        "0x4007af5c02ea3640BC008ed93D0dF67dE6E29eD7": 270.56,
        "0xCaD5FB74819922432FD4bFF68E3BfFa159ef8671": 270.55,
        "0x13f0D371407DBB16008495b51E2fb750FF211Cb3": 270.55,
        "0x9de9828C50F7b3b7dCEa34DbA148A07bBDF601aa": 270.19,
        "0x3066A3C478A621F903E3398EeB2F8310a1FCB2D0": 270.04,
        "0xCCF4395f9810DAE6954239CFe85211a2142EEf76": 270.04,
        "0x6cb4890d712C91020df2E62FB7BB869CE6Ca3e8A": 269.9,
        "0xB0082B9AB70dd4B218BA6DfcF5aD325412e3F670": 269.54,
        "0xadd4a5E93C26B61C63D6e01cF855634737Ddc485": 269.54,
        "0xbB3c466F9Ea1e878CA61B61D0201E68C5E426Df4": 269.03,
        "0xdB3bEA6B62CD2bB89aaD81CeF42645Ad8792Fa2E": 268.56,
        "0xe3Ef439C6B377Ad1731127Fc501075e9d065b152": 268.56,
        "0x87049c7C047A84F58a3549da0D2d48e7347A4e06": 268.56,
        "0xBc8819C1821Bc52b5d30D2Dd52F0Cb6110510005": 268.38,
        "0xC24CeB49aE784fc95302C1152ecC8353e37E9eC9": 268.03,
        "0x2a52b0050459cC4e9c1B50D8e0826755a9Fa3326": 268.02,
        "0x7F55b20cb25b9e4351664289D3c718dA83371663": 267.52,
        "0x77d0efF0F363E30C5d3aa5B0211Af64EA2234413": 267.52,
        "0x3e6EdBa22D9cE22a7168406d26598AE20FE08e41": 267.52,
        "0xB06476EBcE74E1674802Af92bB4d6975D13bAA74": 266.2,
        "0xBBacB44b12F4f21f57fF7b31340b885b781441f3": 265.7,
        "0x76e5db63BF8F1F22886EBe88fB4ed6859b36B6cD": 265.51,
        "0xA2451E7404B3e1811Dd06649DFd8f34D1C579Be0": 265,
        "0xfaaa79eD017A66f19Bd08161a2ebD215150758c4": 265,
        "0x25D1858b0173f31b1f77Be04E643A25B62B437c4": 264.5,
        "0x1c6CCb6F9a1E12E4B50e129805635929710A9F63": 264.41,
        "0x310F3030E7cC99d9093C5fcd7E8A7fE4CC92B9D9": 264,
        "0x01FC9b47D4C1ece4Af9EA9991C5A051aa57884cf": 264,
        "0xf9c9672EC2Dd4959d1aE2Ba6a46Aa757fb3AE0Cf": 264,
        "0x3A63717548f60EeC71BFe86eEC55CB1Ba1F554ab": 263.49,
        "0x519fC0eB4111323Cac44b70e1aE31c30e405802D": 263.39,
        "0xE24BE97C5c70B6C6eFb1cD717c238313bFEec4f7": 263.04,
        "0x26B5e14DBF21bfB62BFf869f5F4Bce8dbDDbcfcA": 262.99,
        "0xD71fFDDABc9aBb9602c7Ae3922057e2BEeDb9bCe": 262.99,
        "0x0b53e10C124eee5ED1D908DE0cAd3ad3Aff6a18d": 262.85,
        "0x78d579D652F02AA7037eaB3FF1798e54F785Db44": 262.55,
        "0x8D6849ec89DCd00AE44cdF65f1a1AB829168F121": 262.49,
        "0x0965fCb1ffe4b7D71A83d6F572aC81484d75d527": 262.1,
        "0x1849c37717374ED89101c67Fb8DBb24750650103": 262.01,
        "0x40Db8365d1252bcb06598927698238a99D39228E": 261.98,
        "0x596DF4AF8fF502F344C934be82fFf5Ba287b6A6e": 261.85,
        "0x37DB80C2fa7615a1f31515A84a428A32813Ce48A": 261.48,
        "0xbbE2383Fa531c2fCe0c3884F5A3ef32bf72369FB": 261.1,
        "0x8bA6Fb982CB4B6a240065376b944100bCE31b9D6": 260.97,
        "0x6d9E3CA64792bCDef8F2227631dc369408fa3838": 260.76,
        "0x06CD1d95Ce27481d6FCF5052b3b69f804b97eEcC": 260.54,
        "0xa288b6b80C02F3a7916609fDE831b30E9FA6BA07": 260.47,
        "0xaa0C64a7729Cadf94cde9D1A1244d96792D2E9de": 260.47,
        "0xAA817AE12E718077ab42Bf0b00804DFDb3ff0A7D": 260.1,
        "0xCBb54Eda2048b57d1b0Afb19a73948E9D58B6973": 259.97,
        "0x871501072c388dEB207584A4F15FcF14304F0c81": 259.97,
        "0x95494598be091C63f90543abAB37Fb2594AD7670": 259.54,
        "0xDF2aB14EF75313981c505e3478b7d732cb3236D1": 259.46,
        "0xF6A145BDD21916491229e9C8617CAe222c90C30f": 258.54,
        "0xa4a2FfE1538f429e8D5a21AdAb35085f680B1a4A": 258.45,
        "0x42EbbfcC11F9faC6de28241cB9209EEc078174D8": 258.23,
        "0x54BAe794b6dDa32A5379F091AfdF5bab0E37B664": 257.95,
        "0xd46c81245A0582891c2249daf2d68925977cF2a7": 257.45,
        "0x51e432dF264c3315Bb0D1aA70D265cDF0792c679": 257.45,
        "0xeEBb10d8f1636C41f33A128C63f5175401668e87": 256.92,
        "0x17748cB3aa5528C4eaC514f8b6E8FAdef13B29b4": 256.81,
        "0x055a4C66484C7909CA3d23d030ad0af7259222aA": 256.81,
        "0x5202b3863fC11ABc6CfBCc1cDa473a5fdf00198E": 256.14,
        "0x7b65E9a5C8f5B788D487A227039c8Dc51bFf6e33": 256.1,
        "0x08e5F4670B8E70fE77D952BA0fBBF9f4762aAF73": 255.94,
        "0x56e08bABb8bf928bD8571D2a2a78235ae57AE5Bd": 255.53,
        "0xed1b3b062514171f358641952A865Df9CEE7fF3a": 255.43,
        "0xF67E9DeAFDc40edcDea0214B7779059d515f0fa0": 255.43,
        "0x221CF0e68a2102aFaaF87c1fa999bF93310156cD": 255.43,
        "0x3E6aE4C225DD547F9C9B171603BBb94C0a842D8F": 254.1,
        "0x07D9a5994A8d0B88513421b017Cd93B20527A557": 253.92,
        "0x9d2e29bE44fb2c3D7AFdbEb79F59F51224373aFF": 253.92,
        "0xace3C69a43233D2B99bb4113Fd1aEfD7cD833aBB": 253.79,
        "0x199a10fF327fe76737F0c5abccE24E7a2d3D205B": 253.69,
        "0xE00571FDBf7452E02CEED9808C46C6C6c13e87e2": 253.53,
        "0xC3493323a9251Ca4c773D715Dd5E96A05D6b03Bd": 253.42,
        "0x40De0cd40f38fFB9bc07ab0bF73Bf167e7E50FA2": 253.42,
        "0x6BDd846122Eb546Fccb3C362D9C8324affADdD5C": 253.42,
        "0xA0eBA15eDA152fcdc38Fb32e3C50F73e3a2Ea965": 252.41,
        "0x388b2d29E7919D45b1B8F6e88b8A13a392f97b40": 251.52,
        "0x13D1df7cBCa9B818F7ccf1E5c73A6cc5DAa04142": 251.52,
        "0x048c5753E83027bF30EF103aDee49Cf9612cAB84": 251.4,
        "0x24C93a9c54564Bf70992F49A774E39385210688B": 250.9,
        "0x4b9D8dde4c5cEb5BA567334d9fB86Cfc94282A03": 250.9,
        "0x2D22029Df730321a5D2b48e6926C4E3923F808cf": 250.75,
        "0x99349957ea9c3c4120751018AB074E79C34e0611": 250.52,
        "0xBd5f593C86319523e6E8AfE60dEdBEfaeDBdB8C9": 250.39,
        "0x864DE5bbaf4b8c808E94a8385B95B0855d170137": 250.39,
        "0xAf2fe4Ce68387450d81eEBD330eb2bf6f73Ebf5a": 249.97,
        "0x823b6b8DA270906f0a231223e46Edb5BDeA3ff13": 249.52,
        "0x28a48d16D5E8D79F6de73f2c1b3B9e423f95B9F5": 249.39,
        "0x2EA2C6d33324b6F3e0BF3ADa8934Ed495e6efa8B": 248.93,
        "0xcC82240CDCE955766c741bF60161f61E166d0487": 248.88,
        "0x9e6B695FA818730A8dAC1A5deD41aF335AAd9047": 248.88,
        "0xe116d5F4CcD817e93a4827B4B1166fB3fA61BEC5": 248.81,
        "0x706E8a1de4f372df952e26f01b6B7611b917BD2d": 248.52,
        "0x20B66765E8B16804090a2856023b43c3802Aca72": 248.38,
        "0x5C535D00fD648410204b952871C6ddE6757D7029": 248.04,
        "0x1467E4ED5136DC02340723e113a321F8F9E0291D": 247.87,
        "0x017154d1f2C228765c494DA30C018fa48a09e1aD": 247.87,
        "0xAc858f98Be6124EE42D776fa626328Db1C562e23": 247.87,
        "0x9848A28343DD74edB05eA1fCB838aD71DF0Fe641": 247.37,
        "0x39837F4711b028ba82D43bF9d7b017Cbf8E5c8a3": 246.87,
        "0x8BB037ef7344242eF29BF3599F94C280F1099AF1": 246.87,
        "0xBcF07fe3659D38adA501CC7a6A3Ea62338a52c07": 246.51,
        "0xcb0B99284784d9e400b1020b01Fc40FF193D3540": 246.51,
        "0x6b26046B89A3e89BE3fe61AF939694131d9f0af9": 246.51,
        "0xe538eB2F128634a95a0cE48f9efB3b6B58D1b3Eb": 246.36,
        "0xb5C443bc3C15003D85EC77f526D1AFF5343eD4b7": 246.36,
        "0x5329B814Ff3A1123E47357E0Be98978617b69dBE": 245.86,
        "0x2eC2336dBf354E95A49CBfB3e05C42415AdCb9d6": 245.1,
        "0x458fa5c80F899C6ddE9a2e196a8325cA0bbFFF77": 244.85,
        "0x204a79fF4ECaC8164c717Bd46C02cD493a159789": 244.85,
        "0x8Ca5a030A4E118b3C084bB474Fd5d1125Fffb541": 244.51,
        "0x317EA3F40890987E177F82a7A9962247e2584AC5": 244.35,
        "0x3eA23c21408aD362418692CEE2F8E8482D9607e2": 244.35,
        "0x4F321aD6dDC21EBcf9eE7213D2B41895196b6a9B": 244.35,
        "0x31E1c86c87791C903ccB82726E11A761187Ef694": 243.84,
        "0x18f580129709D1D84ad25de2436467246CA9875C": 243.34,
        "0x32a2c2c61A5473b2C47Ee1dC758f6EB40Cb1a99D": 243.34,
        "0x8CD509e416D0e6f5fde5b22C660746c36a69AcE3": 243.34,
        "0x41fc6db7d930dB6D1869163f664Fe4BdC3fe8b61": 243.34,
        "0x51BE4CF8C926B275030B21D489f026342D1d5C1E": 243.34,
        "0xdda0f603c2bbff8b66aCD1185b0D7A6e03fe157A": 243.09,
        "0x4A93C3C014DA94070dF96352d3E6795E0b682022": 243.04,
        "0xdD84Ce1aDcb3A4908Db61A1dFA3353C3974c5a2B": 242.84,
        "0x352F09110eAdfCD5fD46bFA7B56770c04D3cFbBb": 242.5,
        "0x02a0c0D47939d757FBd5D10cA848F6D4a041947D": 242.33,
        "0x738671901aFfbc417FA370CF936e461BB5315bd0": 242.33,
        "0x07C7d97B79881D8245Ee3Aa4dCE27fDfB2CC3130": 242.33,
        "0x84cfF3C47eC2DA624834436C589E0fBdC73B219d": 242.33,
        "0xc2979f313dD6731efD591e983d4CC5231E49a387": 242.33,
        "0x8De214908AAd3A8448c0AF9Eb2205FdD6BcAa99A": 241.83,
        "0x3940Bc411339515A3Da4Ba88639201de8421566a": 241.5,
        "0xd16004cEA4C812B680Cb3BCB2c80952Cdd9F97aC": 241.33,
        "0x153C63a70B3dbb166e0e11f110f75a2c159b8cA4": 241.09,
        "0x10b755b736c5B0D3AF0801eA79e644C18F517B16": 240.82,
        "0x3f6E4667Fec54733Fb3B15993B9Ce96B69B65cb3": 240.82,
        "0xEdd4aED4829775415B927c38DB0BB4Ec18088527": 240.82,
        "0xcb25aE086383EF2BB05228fdc9Eaa2a168144afe": 240.5,
        "0x955ED6543D2d1cAC235d4A4EFf4cabACE2a7aC9a": 240.42,
        "0x4B9CCE0e6c7ABE8a3c26f513c06517F667b3d36a": 240.32,
        "0x3e516B6d229Bf935F1B6Bf4A0C2531ddAB48cF1B": 239.31,
        "0x03769Ef2598ff2e72d5e937F804e8E43A3E022e5": 239.31,
        "0x45a8fd21a879B368DfAEA609E09651d51AfF8EAC": 239.31,
        "0x0630717c9c6baEAbd2b0852e09dF08FEbAcCd227": 239.31,
        "0xc5Dfbcf2461c0eDC8d0f98D8b0eD9B9fC8B86Af9": 238.81,
        "0x3fdDeE6383e30571E9CE36112b6C70aacB70AaF5": 238.81,
        "0xC9e901a4564cdf88972a12eA6c3E6117222892De": 238.68,
        "0x2E0F3A5e2e1c4cb387D416E4fCBf55aDf75c420F": 238.5,
        "0x0bf7Fb51211b4842bAd8E831ba2F42fcB836C7e1": 238.3,
        "0x370a5275F69CB3C2E76CFe575cF7f846f906b34D": 238.3,
        "0x291971D8FF4D2C51Ef6be0F465b5699dd61BCFcc": 238.3,
        "0xABaa7B3e2769cA07a68Bd4b15f50d75A47ba3451": 238.01,
        "0x49Ab5fc10011685912a9b36B0eE4deF3BA74700E": 237.8,
        "0x68E07cb684C1A5445463F361f945230D3e4Cc100": 237.8,
        "0x7b523A0C714988e5C4ACaA71198ef0b52E0FB6b0": 237.8,
        "0xb4405aCe30A3134334c0f4a1fCD00104b969455e": 237.8,
        "0x03fc69777C02316170956b084eF7811E20A0f2fD": 237.8,
        "0xD54C3c611448EcB1110FDd3c7e913845756acE62": 237.8,
        "0x27d2791842476060e16B99a9f6cE97A0797c6477": 237.29,
        "0x51E02F63fb09D00DBFb6867660E014D8d21efdAE": 237.29,
        "0x629f4566E3E8Ed73c4151e49a248D243e7c24299": 236.79,
        "0x1877b072E25Bd2E4F1491ab00ac1735736289Ec0": 236.29,
        "0x9d00f0C4dbC82a516892f233849Bc25509044C6a": 236.29,
        "0x358381d47590F15dd51E2De0d53EF5Ee51957eD9": 236.04,
        "0x7239C9c7Ca2ed6F684182FcA881618fE4b557f9E": 235.78,
        "0xDdA0bbA4035E29ef29E4f7592027e2b861293408": 235.78,
        "0xD935A63d629cac4cfC8F632A2f4AaB3ca8D99E38": 235.78,
        "0xf937800e295c1f9fb07A573a7c4146Ccc4e8F64D": 235.69,
        "0x80C2B66A0798Bf521151b92FC74B485ADf030092": 235.49,
        "0xdDadc56B6BdB95B488dE8AcB5127c5cE4be1b2C3": 235.28,
        "0xb5Cc6b2d2f6ffeAda7be0EBCbc1CC55a6041386c": 234.49,
        "0x7Fc11951fB401Be13E6ed08390c2AF15016ECD65": 234.28,
        "0x3A1d967Fb10DabF61eD0f3a4077457bD025Db065": 234.27,
        "0xF14B4e244C29452d76E2eE75e871069E260E809E": 233.88,
        "0x4f476ACB375cA6BB3AD6B7DA3e18Fc20F3b591f1": 233.77,
        "0x89fE2f3c37D184304Eb978e5cE3EDef8A229B97b": 233.65,
        "0xacEf9927bB8668dAc67F3606FE3579Dc032c277d": 233.26,
        "0xDfa333BC8BCFab377b8b1018FBB016C4Bb91A321": 233.26,
        "0xF9699c81e1F99f736E6874Ed79e9813Cc5056149": 233.26,
        "0xcB0Fd804a913ee4cB4e8CCe26dD5CC8012359B79": 233.03,
        "0xcfF66cA2996fF7041241D2DC69e4D56CbD81CE03": 232.64,
        "0x779c1305d19A61ce5C460Eb8e854e27491013a56": 231.79,
        "0x5BF1EF039Cb823DeD81CeC067e7F8C7a5EBb6Ef3": 231.75,
        "0x7c333ddbbf80b6439fD489023de9c792548F45b3": 231.75,
        "0x19D0a209a678b08951f31C0feCd5bd2c30f3F347": 231.63,
        "0xE8f00Fc3FBe2CF8125AE3e8Dec582c316c9Af31e": 231.48,
        "0xD5148b94c8cC35749BacB9F3E2Cb313B22F91810": 231.25,
        "0x9a679F16A53a7b353c4879E40Cf50082d6ebc5ab": 230.79,
        "0x4AcBf283ACBB2d03A994089776c05A1909A1411b": 230.75,
        "0x995658108dC413e8De55cA6C913085691d0CFA70": 230.75,
        "0x71697752deA4322ca87b44bD129B6747a700A0C4": 230.75,
        "0x1de23363bcAeD13fDA52378c47d332F1cE0E9f3d": 230.63,
        "0xC8aFB3E389C2693E588bb716d37Cf1B53179506F": 230.24,
        "0xDcA65df4A8F80Fa3A8A10ec11C9ebCcbCe3E5bBa": 229.74,
        "0x18D84AFfBC6C1192ae9C5AF670807CecDea0bec5": 229.74,
        "0x4A7186F05B68d1a2Fa0F7F327715D0003e5f6689": 229.48,
        "0x301E464B50398A856bf26c09702AEe77C99105e8": 228.73,
        "0x22386C16722418f2c73cb7010959f8D927491882": 228.23,
        "0x00000000051CBcE3fD04148CcE2c0adc7c651829": 228.23,
        "0x1853dc4fbFe3B29012Ac6dF6ca44B4fCa0aA1959": 227.72,
        "0x318AFdbEe3D0300E5073f52FcA22F734aa1E1784": 227.72,
        "0xb04c9f7306aF476Dc2E7aBAD153987D8080793b7": 227.72,
        "0x9e18f8aE23B8039ecf6f4D3e6706f5730039d43E": 227.72,
        "0x0884A36c40ADFD036EAE8B1DAE96A1d4F94306Bc": 227.6,
        "0x91CBC5f7F79c6D0280dD2bB350a6AA5df3384DdE": 227.47,
        "0xCE06012ccF4B9648710B6d624C09e11CB780e93C": 227.22,
        "0xa992332EB15eCc84E53D05830fd3aC5B49e400E9": 227.22,
        "0xf7b5b5cE43E2a4e2b9be860D8b3122661303Fcad": 227.22,
        "0x352bF5e59A4C1a0E4403278fe5C9189F63AFDe3C": 227.03,
        "0x0A057F1d94fb53039026990Fe2a92dA090f1D847": 226.74,
        "0x6F7e3D13F1Dc8077892749322Eeb8b39fF7B0917": 226.71,
        "0xBc948cE88f583f133f86fe8beecb172DCcB1765C": 226.71,
        "0x446925B8Fa3Ce7072a6f389df46150978da748fB": 226.71,
        "0x15691e4Db66Dd8fEEBa5F32d0dCE39E341359578": 226.66,
        "0x648D11ee45749530E7837BA6B089517E4BB8c902": 226.47,
        "0x44646C1823433071cb4d60E90738161F7a056cc1": 226.21,
        "0x904A9238bd8ea6eF2D02a349C284891318d76685": 226.21,
        "0xdCCd89bC40cD81A2a2c8631907174CA8aac6Bb6F": 225.96,
        "0x5912e6c2A1d9FB496a80e77a7c6926f8Aa919cb4": 225.71,
        "0x814b453A15806ca1B7Eab9De64658F062463aE4b": 225.71,
        "0x3b7994F623A02617CF1053161D14DC881E1aA02C": 225.71,
        "0x141cBD79074e965f3c501D8B63b8e55157ED0722": 225.71,
        "0x715C1ec865A06fB0E0E5388C6b9F32DdD85BCC0C": 225.71,
        "0x69CD4AbD687ab23E2F95f0a065cD9Ad211A58713": 225.71,
        "0xC016a1C202B531cCf81d96630247C9B91a7bf5CE": 225.47,
        "0x6F103b5217029C3F4D47fC2eb2FB909C68a51E2D": 225.2,
        "0xB5d2fE65F88C8b64822AA273eF71aF70dE67a0CB": 225.2,
        "0x54e6FeEF614946C0359D4937BE5ee22EcdefA43E": 225.2,
        "0x4D7b6D3e2eB38C6505ac58FbA0cF42F434a5658e": 225.2,
        "0x0E9d6Ae20c982b43c219E9bEFd94ce2302264068": 224.7,
        "0x47D6F96Ba098816389DB7c87CBF077dE7181b853": 224.7,
        "0x2ab9Fb108Dd6297c4a45D616f23BA17Bb66471f5": 224.47,
        "0x99ab0afB022aA3CC3c986CC66dee014a4918Df0b": 224.47,
        "0xD3a64F0615E521684D439B061A50860C6689f1cb": 224.2,
        "0x8dd498089723d25BD02936543A0e85695DdC64EF": 224.2,
        "0xDd6B0e7125C1F37ebFcbCB3ce8F712B8B922D09e": 224.2,
        "0x8cd18e314E3e2e2c0984419dc3EBb188fFa32B5C": 223.69,
        "0xaB6a463C016724d76b4ebaD6E4Fd16711104BB86": 223.46,
        "0x51A3D4620e61989B152b942d16201A1913e23784": 222.86,
        "0x8643C722031A05fCBb12212804693B81CcF5A4d5": 222.68,
        "0x7D6b111c3c453A671816D475E12a6A344c0EFDeC": 222.68,
        "0x32E202cec456abc0b393Fb98e91F25cE40792d2c": 222.68,
        "0x8cdDB8c21c0d6A1aeD622a61695B8a6B85D717e4": 222.68,
        "0x3DeC3c07d209914f3CC13c7492Ac12E559C9DD7F": 222.68,
        "0xCb37F1fe07988E6ff6C21b28B986fED13eBfa549": 222.46,
        "0xF8d9dE13A0efeCbEe653a0A35c06b751cc03904C": 222.46,
        "0xF489741242F62A0D1a13507Ab2c9c4473Cc59B83": 222.46,
        "0x30a2311227F13FFF419877A551960535d113f94d": 222.46,
        "0xdFEa4755c067DfABAF0a18C88D226337874469aC": 222.18,
        "0xE2E61752Ef7Ed9aB04B61BCc88B918d5264DC259": 221.68,
        "0x64169DF8F5B881e6DDDf5c9004E7D8E322d4f5DE": 221.68,
        "0x7F76610a9fCB77B0903804fAf87E8e7EcB768D6C": 221.56,
        "0x6680E5C6a64046419Cc4853A0B07598dEB7B24Ce": 221.17,
        "0xD834eC8697f4Ab0EBd626C0DB8e2f7414e1F082d": 221.17,
        "0xC02095766b950b0609A792656196D720C00FBd0E": 221.09,
        "0x355292840Fc58C695d6D548aa1E30DD8d791a26a": 220.84,
        "0x6d45bB12DC53F784eEc7f5b4efcb70Ce8Bb60914": 220.79,
        "0xfFF6EB6fAE78e604c93B35c97F6892E36acB1dBd": 220.67,
        "0x6d67aE59Aa6fE06f93aB5029453b2D1a3a5c1DE9": 220.39,
        "0xccFa0530B9d52f970d1A2dAEa670ce58E4176389": 220.17,
        "0x51F0c4d693820eAD25F573e243f4895C57A2276f": 220.17,
        "0x4D6c97dFa78C5adB7c607bD6DE9A8930A73eBC2A": 220.17,
        "0xdbB60A0170C546840dE2896f3667ef384Ba2fF8A": 220.09,
        "0x51Aeb544C49EA8cc11e7421ac870019D628F8Ba2": 219.66,
        "0xb29678d4956Ef3DdB3Bd017002127854c3c9266a": 219.16,
        "0xC4156a6bc9b96B63f159F42FD5dB95fB4c82cAc7": 219.16,
        "0xB50d6beC9E5b0ebbb1F72C9c34100BE83Ba62180": 219.1,
        "0x415BE58b62Ed85Ea515137ac6AAF03702E7e4040": 218.45,
        "0x83d261E656152F8c576b7BBcF5a4045Ad3f5C566": 218.15,
        "0x3D9f631dc609E749FEBE9a7d0904FcA3040B4cdD": 218.15,
        "0x7AfCA8A4e70995E0B05363328b8a242525D30f84": 217.89,
        "0x6532a7C47B033e83EaC702B2bAEcdb8B834558DE": 217.65,
        "0x1530F2940Bd7E9d9E8a8c5EaA37409Bd22dbFB3F": 217.45,
        "0x835D4F2a073b401ae934fcE12C0635170Ad52407": 217.45,
        "0x6cA71425648809868fCcCA9454bC1Ab2ced62E27": 217.03,
        "0xC68b8bfF2b23Cb070b33832EB28314bfa6696c25": 217.03,
        "0x9B6C7e85cD7809e51609c5931Ec9Ae097942ff6D": 216.64,
        "0x3e3672B23eB22946A31263d2D178bF0fB1f4BBFD": 216.64,
        "0x628A3240137Ef7C5f729C6c106378edB3Fa51250": 216.64,
        "0xfB5b4b6bDb5787A07b227Bc99E36D314Bccd18Ca": 216.64,
        "0x019130eFA873D5E1E82070356deBa5A4b7f79c65": 216.53,
        "0xDa6aAbCf79948d7e85AD05C3B980F86046A308B1": 216.45,
        "0xA80798cFc94F1010267dA78C6B4E57Abd7bD33CA": 216.13,
        "0x67D27a7531c08319D72e505C3D5596Db4719c170": 216.13,
        "0xF4605fa919825e4A85813752006697Bc14cFc0Ed": 216.08,
        "0xa2621c9994d25162946833d48589B8233A04ab46": 216.06,
        "0x690b3Adc7FFB64760cAEFe54cd0cEf6382E52C51": 215.63,
        "0x0C830A9806AF3EF3762b21E98Ca6818e373Cf985": 215.63,
        "0xaF02f27AbF8337Fe8C78E9Dd22AB85B4661ff50D": 215.63,
        "0xF2bAA167a51FF1088D578c971C813A5CE35832f8": 215.63,
        "0xD923dE646D3f0BB9Eb7f9169f259C79C3edE2188": 215.52,
        "0x7D48D92727C1ba6A88cEaaEC522481790483bbfd": 215.52,
        "0x984a2093D0fb2Ff94Cdc6bF926a3027D23dcf03b": 215.45,
        "0x5343F404F7293BCb1EC7eDDB1077b152039b739E": 215.13,
        "0x2071cD4a6E21Cf2743AF3dCBb63F755A375913e5": 215.13,
        "0x9BA500a46C672aea761142a4a97A2e689F01e199": 215.13,
        "0xf8FE983023AF57ce12d6D1865b515e8f524BdD5c": 215.13,
        "0x703DfcD90b7003549Dd89E97D541137eCB03C4D2": 215.1,
        "0xdF35239348B70490ab8930d96aE43d42f920Ed92": 214.62,
        "0x0F341837A7581b9CF32F3cf527c5E7d0a203Dc03": 214.62,
        "0xC8CaEc7aE8B36676c5C60D11423C6dAC8343EB19": 214.51,
        "0x601b7D7798B5E5c104016b3120a30D474cFEE0F5": 214.45,
        "0xE76Be9C1e10910d6Bc6b63D8031729747910c2f6": 214.12,
        "0xE0E20f13838e5e296f9f6E2eCF6333A3324b6B8F": 214.12,
        "0xad61C083591c292899a2B20D0E1327C9B1e067D3": 214.08,
        "0xe586d805673ADad674AF313308dc21E86ffffCDe": 213.65,
        "0x192820CE84FA9eb457Fb228c386fE0ed22F7E33C": 213.11,
        "0x2Ec19e982172EaD28B312a07FAf25105fB3747d8": 213.11,
        "0x3159BFBB1f89b363C24Ead3AA5AAAfe400269E69": 213.11,
        "0x613cA7d1573dBdd7711ec1d84258A3D0fdB76d53": 213.11,
        "0x5C4adaC003213C3BD26fbcD3419064f0CB9df76e": 212.61,
        "0xb5f4af1a4B5021Ae10207E1C2E119ce8249B3007": 212.61,
        "0x90AA5c7a67081409d0b826faCD34600463778a48": 212.61,
        "0xFBbe90DD04250B5E789Ed9d1bFBA2476E524a852": 212.44,
        "0xe941EB810651E784a2DA10b37d4D94b33D245De2": 212.1,
        "0x77819D746a876B523B0B41D942c1477F248f9137": 212.1,
        "0xa943681cf687774c2D44Aab6aEb7D8C701Fb7CBB": 212.1,
        "0x2e97BaB47DFB1fd1395Be6D86fCd48c19374b79b": 212.1,
        "0x544D7D8eaB614ba0786F1660f3371A89e2cD40c4": 211.6,
        "0xEfa4c696Ea2505ec038c9dDC849b1bf817d7f69d": 211.6,
        "0x96cD8aeA2DA8955C38f951262d4d5c06e4315fEd": 211.6,
        "0x7982398688C1a0dF28f1649d8D21d74cD5A37Bd2": 211.6,
        "0x6B8006f6D43CAd01bf919eC50E70c7F67D88111A": 211.6,
        "0xbfF734478F1D1E7a313f174F2444d0E366b034b7": 211.6,
        "0x0e69286eA0E263fbe00CB03d0FaEdb7899cE6aEc": 211.6,
        "0x247984f64320eF38a3f9316A8AC248Eba0b5BB0F": 211.6,
        "0xA1958a37C21372482DEfF4618BAEbbeC23C9a449": 211.44,
        "0xdBDf70689CB64b096C5291843936C56731E8240b": 211.1,
        "0x4a2490c461D8bDcc0d7b6C2F7851D845D4FE4aB8": 211.1,
        "0xc810C87e195a9a180068637CA66C13884E040170": 210.59,
        "0x0fff37da7403A3C997D7eb5B745e3850cB5358A7": 210.44,
        "0x2c0f09106f7bc386b1f9b2988389beC9Fa459679": 210.09,
        "0xE318B883Dba68ba977dC3de178691b2341dF0288": 210.09,
        "0xf8D64874EAE3Da370c9e7B4cd3522e581737985A": 210.09,
        "0x12eea04A8c4c6065e239A746D705C038B757c43e": 210.08,
        "0x2970f4ad9af5b7B77dDc49A30c35CCef395A01AB": 210.08,
        "0x4da5Bda21C66eDeC94BA1A7d215fa2A62Ad8e4fC": 209.08,
        "0xAf5B16f740bed90af42Df6C28e5cd79458C102f1": 209.08,
        "0x56E30aF541D4d54b96770Ecc1a9113F02FEe3bf1": 209.08,
        "0xE606cd799C28651bA74E48354Ea24A66008FE2f1": 209.03,
        "0xe589fc04ccBedb95950f25258D2a81119e6367c4": 208.58,
        "0x7870DcD3c0773dF4C21Cb741B06C6F7C76d41263": 208.58,
        "0xc3A5D34Fe6Fd81C8e78618048AF4b787756bFc04": 208.58,
        "0x7EDef5A971c6E5EDfCC243113C8Ac5a23D16c7A4": 208.58,
        "0xF13F6E3536071b7b863D0498DA4e0D1E3ed0F3b9": 208.56,
        "0xc85DB94cC12e1b51f9A77611e43412d2b68e046d": 208.51,
        "0xF4753b05f81a52ef21576e1aa9BcB3b6A89D66CA": 208.47,
        "0x0218602cB8434C34F45dF464A57b1f4C59901883": 208.43,
        "0x00b439a201110Adac18614945349d2b565A4cC24": 208.07,
        "0xD3265468Fa677aA87bC28ccF54c3a8d2f5537057": 208.07,
        "0xc039fcbb84fa8bCC8368cdf3d86C30950D930723": 208.03,
        "0x07be93beB9F58a3f0b02C871e07dba85CEadA0A2": 208.03,
        "0x579F79B02Cfe0Ff61e7173c03C309c69e8449fF8": 207.71,
        "0x6dBf2926Bf047F1cE0a0073DBD53C2654775Ab79": 207.57,
        "0x4215a881dfA38fA2FAced28778c9366eF3E5FBb6": 207.57,
        "0x018439894b681cC2aAdDB613A425a1cfA6e59c29": 207.57,
        "0x0818F6E98A6b62E02A6A258458Dfb579FD2387C6": 207.57,
        "0xeBE6cC6820a76705B6654FdD1254256DcD54F1dF": 207.57,
        "0x82FA32993fFF3BC87777136d28935B9E89A6195D": 207.43,
        "0x24120627F9d31859757D9B94c025041A5868f196": 206.56,
        "0x7Fce7B91298ca703E90DfcBfA809361D5D3251d8": 206.56,
        "0xAa9a898d73795Fdd935036544f86f92d5dc1A4E2": 206.56,
        "0x39b0ab31511F0817D24ce44D8D3A69113D2aFf61": 206.43,
        "0xb8010A57fcf2c1a512A73b0Cfb3176833B20E2c2": 206.08,
        "0x5259E022CD88761eabF328f29aab25a123112C8a": 206.06,
        "0x6547835644105F1313FFd5194f467720837b0c8C": 206.06,
        "0x4F1B4a2D5cF60240dF3035688db8CCeB97170301": 206.06,
        "0x9340C56A44cab9E876E638960Ad4c8D938Ab814e": 205.93,
        "0x1C75a8bE04Ccf2c4a3a7B0a3EA88f9c1620b598A": 205.55,
        "0x579595F3064AFc04A4b0a1660f3dBa789ddE0448": 205.55,
        "0xf99983c1b128b87beD9aE10eC19df12feFDEb822": 205.55,
        "0x801d25183a0B3300B8f3e3C1363C3b6FA8e6D798": 205.55,
        "0x7153E0F82Ca869CA81aFe95D64F992D03eA985C9": 205.55,
        "0x9c6c581b079Fe0b1B6dA569c463A445B9948C0A7": 205.29,
        "0x0825d6c1d8e93b29C8F057E90457bB938061f6ad": 205.05,
        "0xdC44FD0Fcc2b25Cc6a7dadD3054042368FDc6DC4": 205.05,
        "0xBC87669b00BeE9136F6C9474BE88fC0962Cb6f05": 205.03,
        "0xEAc51aED409a3C90C5ABF0f0104De144E415AC00": 204.75,
        "0x410f2959ee9C8115cA6CF0f817B14373b63B5d4c": 204.55,
        "0xbc043f69F0897b6E9442D88e011E9cD7645149d0": 204.43,
        "0x7690453F91dbadef8a592a32c679D8f0f5E0116b": 204.43,
        "0x5518f50c14626251DcD3442F7622480975C14457": 204.4,
        "0xfc82b05426D0E675c9F951Be4B3889cbf7DF8105": 203.54,
        "0xC5C91bB73154F4dB6F6e2B4D154635dE1748F435": 203.54,
        "0x4C0b9B5D8943CE9758ee5D951c5907F2651519B5": 203.54,
        "0x14ea6d2a6765EB177ef66Db2c14C8214b4046257": 203.49,
        "0x6E30F5B11a0d27bABcbd4fF0ea62104436e285d8": 203.43,
        "0xb47cb15CD0873dD7039FFB2ADA5e94906e26913E": 203.42,
        "0x17434dcaDC65191FEE6A0C7e57a9eCe8a23Cb7Bb": 203.04,
        "0x5C0796ed4F0B1dE9F9edA9fD6fE29562b2a60296": 203.04,
        "0xc609b5595e38acBDDe1672F9b482db823f51668A": 203.04,
        "0xdFe6E5C759Ed08de05664065a2Cb7788FEFf4711": 203.04,
        "0x715FD2c3e4e65Cf0644C9004F895F6B8d95C1a90": 202.8,
        "0xd475db268DCcD4d58E825d2784947234A8Da055c": 202.6,
        "0xdf8538B3cb654fAbAA60C9B2AF5cF08988cC4Fcb": 202.53,
        "0xd158637f7a7bAC0E16e83e532b8d01edc77c4797": 202.53,
        "0xFB405a4BF5F83e5DAc996e60e1eB4094Df81ff7c": 202.53,
        "0x1D918d9ca7509C070Fc6c51b4140a8A682cee461": 201.64,
        "0xF418B89D62fB0F0732E527Fb7113F142C6C20075": 201.52,
        "0x6b44cd66f105EE5368197568a85bB5b66211c667": 201.52,
        "0x731591207791A93fB0Ec481186fb086E16A7d6D0": 201.42,
        "0xCB872098a68af91E730f61e0058E28Dd309E2AA6": 201.42,
        "0x1D2E44dede73dcF080104eC0839A70DA14641762": 201.03,
        "0x5183d153A2431d9d582f54A8b2225a3A78F60e05": 201.02,
        "0xC4F39BA15f5376732c594523408EA2e5149aA43D": 200.52,
        "0x39d5DFC3E547b2fF27a5A08A803f1ebC0fb92b6E": 200.42,
        "0x602cE5A4DabcA14950Bbd5cd1bC5f93eC1D84926": 200.41,
        "0x1F452f2beeA8C1105cd5363b18A0995367a87D97": 200.32,
        "0xfFE3385962b6Bf54860F06dd35d5db3504bD1286": 200.03,
        "0x8431d385E16924F4a897BFaBe5550F9510AD2604": 200.03,
        "0xdeBea614D0951768497D3B4AF64D8cB2A73316F2": 200.03,
        "0x70f6Af154C5ba90775D6FDFCCaB4C0E73595329E": 200.01,
        "0x43C3Ecaf74d44700A7821F3EA58cEAe569d7158c": 200.01,
        "0x8d2D627c589c2dAa8670fd5B46d11A4c3e8e7aE8": 200.01,
        "0x48A881c6c2fF0C962D017B2c4FB9701aFBE3c5f4": 200.01,
        "0x6A6583BF96F9Fe5865F75606dD6F8A333a28d881": 199.51,
        "0xc1AF2a378d98b43C574eB2d021e273935707A3ef": 199.51,
        "0xed9A912182745fE101ecb4291D00b802d982Ba0F": 199.41,
        "0xFb177Bd11b0821F997e7B426ED924F27E07cCb5c": 199.41,
        "0x1F7aCA13f47402B32B48f5bDA10272b5BA362176": 199.03,
        "0x32C8e4D2Cb2642A29bC06115336AC96Bf0160485": 199,
        "0xA641752824d512FA8683758c6b2D8A04ea46dcD0": 199,
        "0xA178c15dd95553da5b79c1BA0bDE1659Fa2e76c8": 198.5,
        "0xCff15178629375cD52f579127A03d78B981BbeE7": 198.5,
        "0xAf4C6c334aA5af433fE8Da5AD2DE32b77f554A91": 198.5,
        "0x05F84E3A22054cEF37C486e0FA06FcBa80B26095": 198.41,
        "0xAD7F321730941bC096F91066EeE4295b4cED8fc9": 198.4,
        "0xFb60594E45CFB9A5E823fD991cbd2cacA82a1E77": 198,
        "0x09e98d213061501dF623aE8fC31a0646752E09cD": 198,
        "0x6C93bf900fb2eE79959feA354ec24Ee382C36F91": 198,
        "0x525D0207543B09a2B8Be370072f259856AD14FA1": 198,
        "0xDa0902Cb35b422bb83456c2c3F9c3B3ea906042D": 198,
        "0x23bBD657863FBc80c32925CC6f83e09EcFBe1573": 198,
        "0xF447B405fC7b41DDfeF3CF66EC790EaBd6b26A47": 198,
        "0xddF0C0DaDfD7b17C9E22f332590fEf9aAb3FCAba": 198,
        "0xfC9f6BB19C91D6490D8D73F2353d395Fa0892736": 197.49,
        "0x44f4DA18D1e9609E13B3d10cD091e3836C69Bff2": 197.41,
        "0x4513a07a0B09B6E734E0c383232058338d74BfD2": 197.01,
        "0xF01603E1ce9916Ba7446b57b8fA975aE9f1C1143": 196.99,
        "0x5E14C52C105c036C61Ac707468F462003dc17c94": 196.99,
        "0x77e1892Fd956c6df5a283804d57BA4c6e2803766": 196.49,
        "0xe6882e6093a69c47FC21426c2DFdB4A08eB2dEC8": 196.49,
        "0xD3f1BC0815a989c293b9c9388225f72F6a1339D1": 196.45,
        "0x44aF8BFd575Ba95B91211242B74222DD5802E6Fd": 196.41,
        "0x0FF33EA1B4acA9eC2878d73590B99d2fd8334818": 196.41,
        "0x001C2113cFC6037E0Ea1015A7dc7289DE072e7fe": 195.98,
        "0x7B8Cc1C88d1f754f51Ae97a512C5212E27F9948B": 195.98,
        "0xd35E24699cb637207c7486A570039d30FAFa824C": 195.98,
        "0xf7C04A39e47C7ea9D6888F9389eA85846e22aE1a": 195.98,
        "0x501F4860aAD23FfA53992DCA8316952e374EAEAB": 195.98,
        "0xC2a3Ed78eCECB53196F3ef97d1d9A7F04Ee7a157": 195.98,
        "0x8346524f40E6289F71671241AbdaF9C84b011a48": 195.48,
        "0x4Cc56A1Fa96fC2cffc869AfFbB33b2D1A3196B93": 195.48,
        "0x6a1a3eCd04DF0fF2d7cb25584052CDD173fC609B": 194.97,
        "0xC00a6614B8030cE216302016e11C6B4140B5e499": 194.97,
        "0x221a68818A6A77FAE0d920306B45a3b1E32E6743": 194.97,
        "0xbf7a212642dd4ac4c46AF83410E18337379c85EC": 194.47,
        "0xcdb7361E0793350BE029F2B1139621597e4CB053": 194.47,
        "0x13e9430d0FE3b18944872bf13Fa4829915374520": 194.47,
        "0xEEA35F1EB652C2F4E09Ae3D2581D243c83DDb1bf": 194.09,
        "0x90554D3C00B5B34fa2849b76c17Bc874c90F9563": 193.97,
        "0x3E52151b9F13c1F73c095BE69f6CF4fa3Eac14A2": 193.97,
        "0x169798885202680c19f4131CC7c427088073bc0C": 193.97,
        "0x499e194d7a106AC1305ed4f96c6CEaAff650462D": 193.97,
        "0x17b1d9a1a8F0363E04bcCDF2839cB107B2297774": 193.4,
        "0xfE3E0c1FB333BD0eC11b3213725102C618c823BA": 193.4,
        "0x0FE1AA632A2837239f218e3Efad21E8018A9F4eF": 193.4,
        "0x16ef0642923099483ad4F9461b29365e53F99130": 192.96,
        "0xdFae5d166fbC1b17b1E5980fB0DdFE0755954610": 192.96,
        "0xb157FF7802e405F346E174960C82a221Be9b5D74": 192.96,
        "0x08e5E4Df2F56Be734ead5C80A3B2377616210a62": 192.96,
        "0x7dAD39E5bD6021f6A2FC8a3F2C36402f7101FAB2": 192.36,
        "0x5Ee8C2080Ba639469c19e10705023b089DF6db28": 192.07,
        "0x26a5cE5620527599c143157954104e5bdFE5812f": 192.04,
        "0x4B1f9C77c70c011aAd465C9A1965F8f6058402d8": 191.95,
        "0xc12FfE2735301127089465E5b0639E6B51725eC5": 191.95,
        "0xe2AC92aE3FDb5D7630AF4A3d01058d7c651698f7": 191.95,
        "0x233Dd9C513012418fA6Aa38F464eBed1c5bD0D7c": 191.95,
        "0xddC3244A5857a15D19dfc5ab66CF9565AC362f44": 191.45,
        "0x17e06f16ce70607f2fACa2DfC7EED07Ab5f0Ad26": 191.45,
        "0xc91703F7b55Bb1459840B2f7Ac099d47eb002422": 191.45,
        "0x10f145C5caB380C4D937146b508b45d13A271600": 191.45,
        "0x773E415A9f9DE303a236de68BAbA0C2e690c6666": 191.45,
        "0x8603213d82723613021C6454832b64a24dE3B8bC": 191.4,
        "0x346e1df87997C58489922E4d0Fca9d78e2275E4A": 191.35,
        "0x19baFA77aaB2e1Fe6cbe4B2c60597b9060B105EE": 190.94,
        "0x6c83ccDAfc6b935e88cf6002c0026F2aac34AA1b": 190.94,
        "0x24Bf21C742791848cb37d228AfAd72A5a273B181": 190.94,
        "0x76e1aB166D6d3964E7AE456D2f846cC59D24F97c": 190.63,
        "0xD212137a99863949D69913716Ca73eF001c4DF22": 190.44,
        "0x40D68C490bF7262eC40048099aEC23535F734Be2": 190.44,
        "0x49768906E50E990cca24E374b43925B6771d0B49": 190.44,
        "0xDBaE4A204A9eE579E402c7Cf9F72005eCBf8f8e4": 189.43,
        "0xbAc17EAdC8C1CB94e59fA54f7E988b09f5ec58fE": 189.43,
        "0x6752C9A5bA6594e43F42322D8eB8B04CfFec3D97": 189.43,
        "0x95Ce459B20586cf44ee6d295C4f28e1a134CF529": 189.43,
        "0x941dCDe25e34367A4274AFAac3E630973B5d1d55": 189.07,
        "0xA57b812b708Ff9FEDDf56f0012Fa4ED48718F0b1": 188.93,
        "0x8585c184975E44e16adA632e27934dD780a2c203": 188.93,
        "0xBa1461e8d222e1b3c05126774C1f4714ABE33CD8": 188.77,
        "0x77E395cCB0f042083F389404f3459DAD40B6D552": 188.42,
        "0x4FCD50BDE39d5802Ae5e40d5B3612B24f1A4Bbc8": 188.33,
        "0xcD07799e9E01C02c3b569Cd42f3729713639081C": 188.33,
        "0x39Ca661D8A4e20B58f82e98d22aACa40e39BC59f": 188.07,
        "0xcDA609Ab3153517A80785505cFD470f879810460": 188.07,
        "0x49F4D0222C880D4780b636662F5F18f572f2f88a": 187.92,
        "0x141888fA737a084044E6C9e97cb48fAdcbe25D73": 187.92,
        "0xF059B59bdbeC91d83C558B4a3CD3c1c6E275F2F1": 187.42,
        "0x97855b46C5558412Ba4b2Eb063875912d16b5CC4": 187.42,
        "0x24b9a7427445F101516916467bcF7Dd443BBcD9E": 187.42,
        "0xa6473CcE13F11614745e6Bf9caD704646616A9b8": 187.36,
        "0x3bb08D6fa8fa12AfBB3e0181BF7bB2eC127cc446": 187.02,
        "0x29c7B44E0584624C1e877d3eE0856520e2851Ba6": 186.91,
        "0x62EFEe7E52B4E87ad053B42963aebb85bb2085F2": 186.91,
        "0xaC749eF37797F963acC59146E1D2F4015E97dC79": 186.91,
        "0x7F017993FC515d4709a7a1A4009a1000f2ad123F": 186.41,
        "0x30232ad3dc049D8cfEEb1bb8471E416b8CC5fcFB": 186.41,
        "0xBd48855db52b9d0B5ea728E75Fb20B74297ac70E": 186.24,
        "0x5Abf7CF60F7b9B33E8a5b298CC4eE2C6f5B403FB": 186.07,
        "0x1811F7732F8C641cE45856973fF4F8AcDB8279f2": 185.95,
        "0xC9080926CeaB0c032cd0b1E1FF843cD253bF442A": 185.77,
        "0x320A3e7D9A16b036735e7a016368bc2d7d33A0fD": 185.42,
        "0x9Fef61db58aaa33d6Fca47510330B2b9797A0dcD": 185.41,
        "0x735A2Ea69997e668dD0f4b2a30fFa9f01e045072": 185.4,
        "0xA5F9f3e9Ec7cE29cf9c0692085ED9D5F5a03e149": 185.4,
        "0xFf0db36BdF740ce4190892E0D930bc411420ef44": 185.4,
        "0x9A236aB113d6051ef58b0C1d07d7847EE26b9e1c": 185.39,
        "0x587cc46C0CF772Be7668Cde6679B577800d98883": 184.9,
        "0xCBfd4Ef00a8cf91Fd1e1Fe97dC05910772c15E53": 184.9,
        "0x81F967ad9533232946D5f9e492862BdD93B5d641": 184.39,
        "0xF3132ac272f3B71D302856Ada06E1f97D6B6c892": 184.38,
        "0x02D039fc3503e887692C0d5532678DA962163E47": 184.35,
        "0xa78EeA2874982946d922Ac2eaF3CFB50eB95E404": 184.3,
        "0x8a81DAFbFA575C9992eb649bA3F370197F7De9b9": 184.3,
        "0xEbdCEE17C461441a083B2B77d80167Cb25D9C750": 183.99,
        "0x2a34A8F3b7a7e2F8A0aC6e013b3664776EE8e0D1": 183.89,
        "0x6Bb84ACDA075cf8aDb3628d57CD8811aFCBD189e": 183.89,
        "0x9A0a94c984bEC0281AB13eb9b8Fe44901980f966": 183.89,
        "0xdE7667870f823E899b1d21CCe01eD690e4C80f51": 183.89,
        "0xa238D83D43E331905BdCdC5E6bDe5A50E3682471": 183.46,
        "0x540AA110391B400C5Ea0a8cCb6878266CfB115ba": 183.29,
        "0xc80a5430D22e8f96B9fBf0d4d0925Bc9E60daa1c": 182.88,
        "0x6708CFc9AaD523f63BE6cE23eF082a79Af705992": 182.38,
        "0x63735e3edE348A157dcFbcd1a5BB33d64b850990": 182.38,
        "0x47f6eb5e32EDaD098F66E25D120CF8E54ab6c32f": 182.38,
        "0x07F198a684199bE831a08F79afc1c9e969C7abB2": 182.38,
        "0x1698f8D2F58C76B3bA591eCa2Ea934AdFd17Ff78": 182.38,
        "0x0C470f23B09847FC99E20B63Aa9b0c3dB13baCF7": 181.88,
        "0x625bD976765acEd25960E8998845326034Aa373D": 181.38,
        "0xe16DbB62Bf2C69C885078db0eC071da5307CC87C": 181.38,
        "0x00A133C53Edb71773C7cd2d6b3285A442F4590C1": 181.37,
        "0xd9105BfE2f1448AcaD670d102263389f7e2A8e0b": 181.37,
        "0xC3B40Eb864a318C6E97682CaE85878f3b470E1fD": 180.87,
        "0xEfE34e5922cD8eAB835F45E49D2EB270e8472998": 180.38,
        "0x6b37a8f5874b4782D462650047AadC5962A7943E": 180.38,
        "0x44B5f2Be03C8aEad6a33a183EA603E4442CCFF24": 180.36,
        "0x72EEc2691B856a7F0B5529266e83f3C7a0552b35": 180.07,
        "0x01bd2841b1EB6a1d7edC364600482dEeEd5EEFfb": 179.86,
        "0x0e649d15B366eE8f559Dd272f7cE6Fca4573b21D": 179.86,
        "0xaC134879Bf31275C05F4372acaB9dAE8772e11D0": 179.86,
        "0x7291d890C726d68F43b32CF1D922D066533558aF": 179.86,
        "0x5f05A92FaFe95a92E302Bd0Dd1479dB425b4dC17": 179.86,
        "0x0e5b115228fb1930acC96555FF6D14554D816970": 179.86,
        "0x169a490C385c5EEac12AcC3999f4BC9605CD3AC5": 179.65,
        "0xAb37b0B63e6b94f8906BCba89c522e62E4c2E0d7": 179.36,
        "0x968c9FD77857295327d6A516d2bE3b03CeEF3CC0": 179.3,
        "0x2Ec81a189F7C9Bf97DBB6105Ee4195eF01510766": 179.26,
        "0xd1286E0280ca712DfFDd7Dc8eBEEEcE42d09E250": 178.85,
        "0x833007D2a858978651b373474CAaA381f20B6EcB": 178.85,
        "0x064BBaF1a427B12ca52e94bb3F564f2014BcaCc6": 178.85,
        "0xb6bbE5a785F6cfEd3F65F2BA91AD20586B00f7E6": 178.85,
        "0x2643796cB6B4e715140f09C352Ea26AFff1a7d93": 178.85,
        "0x6dc8E5Ab8904bDe308C23b649829aD38f36FB71b": 178.85,
        "0x5Bd24C33e56aADfDB0aA7E0BE49e1e2512aF96be": 178.85,
        "0xE1A29Af25dd37d1Ad2dB9Cb47A6536B08Fa6a20F": 178.85,
        "0xc57C05FFbBdD7Ff0A6Dfa02cF2A6D34A420d375A": 178.35,
        "0x9b8EeF973a3b81b563D034411Fc5dE79cEFF4E46": 178.35,
        "0xfa67a932A6380Cd548B7c1cC8D9109ad4f950587": 178.23,
        "0x4fabF510a1FDD7Fb0A0C391833fffC9616E8bd93": 178.08,
        "0x2C596321dAe94EAc3E7354066275ca9042E316B8": 178.07,
        "0x43B2f09aF118e01dA1Ac5c9Af1176792b0f41759": 177.84,
        "0x8F824380bdf496f539D8306500f87A2cBA38f828": 177.84,
        "0x068279f9b20D37D013b9401F165EC03c1d69d33F": 177.84,
        "0x948005DefE7e1AC618A7CD53531852Aa3Fe3C877": 177.84,
        "0xc03876Ddf9fBDc47AE66Bc4c7A639f0D78d90904": 177.37,
        "0xd107690086e94B60CCEb503aE2983ad5D7Ce9D8e": 177.34,
        "0x75ACFE484B40425cC9aac1871458D498b4074ADc": 177.34,
        "0x60A8A2B8AEeA672BD12459F75Be3d89A5cdf11B9": 177.34,
        "0x49Ae63864988Ee94791a8aeb0AA05A465699A5dB": 177.34,
        "0x9dee381c35Bf8964047c88f89f4A49760b3f5D82": 177.25,
        "0xF9e4206fdF1e0EB75E1db336f62590Bc3e320F0a": 176.84,
        "0xBCE49959eDB00eBc509e6a9E11dCE059582E7756": 176.84,
        "0xcECDE28D37714D11E44086fA1EC92C24A2975FCA": 176.84,
        "0x920bCba669734D63db9899e968959e99ADcFE850": 176.84,
        "0x9C20b6Eb1452e6AD77d67A8B5D86FDdc384E93F3": 176.84,
        "0x4443327B5FEe07fc80e227561477e9Ac733d653a": 176.84,
        "0xEF917875279f4363B849F1F7876F1d7e6d68c49a": 176.75,
        "0xDc8c1959C74ab2cb3819ADD153E62739d12be550": 176.33,
        "0x924dcDCa42E7FCd0258C5a4a2333Aa9d86E79Ea4": 176.33,
        "0xa1C9B67b267c631555EB83164287D969B778183f": 176.33,
        "0x8B1fEd5a582A299758753c0A58732b792617E720": 176.24,
        "0x0F535e6e28832209E80958cE6C2c824355a655A5": 176.07,
        "0x2B8F25475b62D8bEC75D1e0B13E09f8D17170Fbd": 175.83,
        "0xDeAF42D4a2CC1Dc14505Ce4E4f59629aeC253d75": 175.5,
        "0x67688A3F8133116a4dB39A8E8e837BAEdec9be3a": 175.36,
        "0xd6eE2CE949Ad28Bd18CDEAd03eD23846A2CE11E3": 175.36,
        "0xC7D36Bc7c7bB8AD3DeF0ffF398F8Ee0D997a9BA6": 175.36,
        "0xbf4101e500419cD28c662adadad14EDA897729aC": 175.33,
        "0xE1926a7Cbe64557ce1a6e9D8B1592130aCdFB088": 175.33,
        "0x38C48873B4Ff40a7C1eb075f87C31D6B458905F6": 175.24,
        "0x6E56E7ff87b9D28BFA3EB58Aff1C4ECC0955b25e": 174.82,
        "0x53A385d47D3a011539Ec377f53aCB410F53ff97d": 174.82,
        "0x78B7254B5FCC7B60376FD9e16bc9f23860B190f4": 174.82,
        "0x509aaF71f59b61F6e2184F8c2dB7dA0BaCF6d53a": 174.82,
        "0x1C52562C969dbd9A67E8f1cD429DC8e86Ca19AF7": 174.36,
        "0x560fDA57F2F1C17f264673489279c2AFF5BF4957": 174.36,
        "0x5F05Ed08E67CBd71E5F4819146c5409F405baEe7": 174.32,
        "0xaB4bAAc46b47DBe219900eb43ad819aB3143b6bf": 174.32,
        "0xB609099b6BBaB96b126d2542A8d521D6ECf448F0": 174.23,
        "0x2a523cc9793997273CFC7cEAb5132552e1b39209": 174.03,
        "0x4B6141532cA5f3484773AA1Ad0969ee1504672a7": 173.81,
        "0xC8B02Bd12705F1CF4eE78dAE82557919c8733dc4": 173.81,
        "0x89440518193dc9dae0B57652C726133D88A16a37": 173.81,
        "0x31800471b0124018BB6DEDbAC093CC79507a4870": 173.81,
        "0x24FAAF0848b0dee170E606E1c01266e321606475": 173.81,
        "0x98c8C2b7151f420040817949435C7Ca6E988aFCA": 173.31,
        "0xe9789D9EF92df852eDF80795a6eBa21DCa0AE2C5": 173.31,
        "0xfF1ab12063eF69258C0afb7f5E314d982d2323b4": 173.31,
        "0x57a7604baAe02BFb83f102eEb96f2c263d2f2Ae1": 173.31,
        "0x19b8614d148a083C2A35598470BE07e05A805d9e": 173.31,
        "0xF68d4b506ED84e4c9F30652dA9c511A32Bd1A192": 173.06,
        "0x00Ae7Fe77AB7C4e77F894C76c167DC310766c57a": 172.81,
        "0x5035568d03B6C60182ccD9929383a1362008a436": 172.81,
        "0xcc4dC4c0775016262812Cba808AecC0875Cc8BF3": 172.81,
        "0x335819cb314f320B4ecEf713F90edF8451F2BdC7": 172.81,
        "0xa02a1aB39Ef37b7d860D7A791661703023389149": 172.36,
        "0xbD5A339bAa86fcACf6cd2B8193a81Ef29da5A1ee": 172.3,
        "0x90B50EE9Aeb83001fBEAF61541fc666341f36400": 172.3,
        "0xD5f7D015c6b02Ddd913329c056a404054b29cb9a": 172.3,
        "0x1360b179e399DDaa05D42D642f669598a32CcE89": 172.21,
        "0x65605a2E4e557b8d6DD6b8C7C72390F7dE09B01a": 171.98,
        "0xF05454C3D16090b652cf5389C9eE520ceC477E5e": 171.8,
        "0xB8B21d29e8e0fceBCF6F3231aAD47953A9c92d1c": 171.8,
        "0x848ac158D4aF8A753227AD4e955a6eA3b0CbF480": 171.8,
        "0x06355362cd8AB65f6349535D0aAC83Dd911C3d54": 171.36,
        "0x5C50184BE105D3Dfa44A22D91A14Ff5Ce7e23087": 171.31,
        "0x8FED8509Fd1D649dB8f58E1e24A401fF8757b7BC": 170.79,
        "0x1dBD54599A449220bdD5E3540861Ce670eA9EC36": 170.79,
        "0xA34d58Eda3d33E1FbadBBae34E34f7b224623FCE": 170.62,
        "0xf10046Cdb3e75395eE9F5e7c4f239Bc4D59C4A7b": 170.35,
        "0xfA7E3C1Ea5F7F5c4e713aa2D7494ABd0E2D55854": 170.35,
        "0x6b32BeEb5004778047b53B7b47Dc0B345016efba": 170.29,
        "0xA0D09dd6130596c3fadb66Ac6d94eD982510CDEF": 170.29,
        "0xee0E8AC27BB4252cbB432596806DF60e6AD29657": 170.29,
        "0x79FbeF59037c4720968DA292156c20dcC0079458": 170.29,
        "0x366F42B551B4d836BAd729DAb9f4D295f5269898": 169.78,
        "0x259Ac73E164A94efc5411f9814Ea7b4b6d12430a": 169.78,
        "0x61181b6afF6eFA8578F0cCFa48A3eBF24B7Beb6C": 169.77,
        "0x88233D0fd7A6A9c5337852413FfEfAd7F2c16e53": 169.68,
        "0x7dc3f84E7AFB258A29b67204A279f6635e305CbA": 169.28,
        "0xfa8343c666C7b4E617e502c7070A31c52D5A46EC": 169.28,
        "0xBfdcf5eaEC3145704ecAD91e2b868477E762c80b": 169.19,
        "0xc8F7738dF10E9c8f8F0C330d6C89Fb820Ad5Bfe4": 168.78,
        "0x50F27CdB650879A41fb07038bF2B818845c20e17": 168.78,
        "0x26E4f8de303991fC9Ee096b7Ee7b03E04da9f3F0": 168.58,
        "0x157D330DCf9A57Bc45C0f6d9fED575b6ea60333C": 168.35,
        "0x7A4508B4C3DdBB4cBCA59EdFa77cAe11983ef74A": 168.27,
        "0x66C97dC031bB2f6aD421CeF7b01De0CA2AE4fe64": 168.27,
        "0xcbBFa40F36F0Fda22f28BC25E43D52573D6826dB": 168.27,
        "0x40B9136318d9DD0ec7CFb94688CEb5A2691040ED": 168.27,
        "0x24fC7A0751BBF53C239cC1D21d2951A5b21f733d": 167.77,
        "0x31796f518c2BA6f2Ea1F01aEaF5a42a4e374dC7a": 167.77,
        "0x5E2eDa615fe7360f415282AbBcfcAeF720207FB1": 167.77,
        "0x121291756CAE7B732E13346D32e35CE97001aBc1": 167.77,
        "0x8c344539d45715983091F4563B286Bb40D90e0C6": 167.45,
        "0x14b1b3fF91525Dd00E8fb8Ce000097ce7d1Cb251": 167.35,
        "0x98D925821767eDcf7E773810E74244026B6e8A35": 167.35,
        "0x547B36b9710B5fDbcd89aBf983c2B944bfc6C073": 167.26,
        "0x99b8c31DeD78266F66833a8c1997cf30c44d60eF": 167.26,
        "0xB0faE6175f7e8719885fe0D02c473977C30446Fa": 167.26,
        "0x46Ff01A9C154371437a43C59Ac40aa9Bd3Ee3430": 167.18,
        "0xD7983b8a42A352Db8B9dAadc3b5FEbdBB4e7f780": 167.02,
        "0xE45F0CBeAeF93DEd18f23D676BF178C15884c2e8": 167.02,
        "0xde39d7a8e552246A6e05A745b92B4AA6cC173e08": 167.02,
        "0x123902d39D2b5006De993F8D2D829148c40BD2F3": 167.02,
        "0xec8e3A07d6c5c172e821588EF1749b739A06b20E": 167.02,
        "0x729a3b0d022E2dDB8af23C5cba6E21156C1c854b": 167.02,
        "0x0CAEe49BDd3440735cea29F855aFcC19c0214875": 167.02,
        "0xa6339C469DCc9BBEE939C0E2a8ee1aD51996226a": 167.02,
        "0x1C4534da7fEE4994e4cA57c39693cB2b6440d23E": 166.88,
        "0x34833AB677F5CC40A44A36330Fb18fEf2aC4F03B": 166.76,
        "0xBF861d09615543c419c749Ea8cBEB720E3B3E3ad": 166.76,
        "0x1E25F91381Ff6B1bd0eEc330607860E4Fcbc3905": 166.76,
        "0xBfb12c30a347d06778Fe9DD582C33c6deDB373ef": 166.35,
        "0x9bbab60B6C3828ab2cCd2101142371420796ab32": 166.26,
        "0xc8295d5FA5FC96C6b3F7d83a0e08f2344ce8eDe7": 166.26,
        "0x0bd54e59FF6b564cDD2c8a816D1d6EA0d99A132C": 166.26,
        "0xCC2a6c936F3765B7adFc695960ffEa5A9828D309": 166.2,
        "0xC1263a10b5BF7670ad4410BCA84A865CF7b05054": 166.17,
        "0x20A75D13CC7E7bde1534252F06a4578de8D70953": 165.75,
        "0xa48CcDa96C340AeB4262C4faaDB08c25804a5260": 165.75,
        "0xD2e2Cdc8f987d25490138Ab7751c1C9712d947C5": 165.34,
        "0x3e1659B2334bA21f070305A92bFebEd3Eec78242": 165.25,
        "0x22b908c2FeA7a1e6043FfcDBc77D660D4D326961": 164.75,
        "0x2d9F73c98F256870887EcfC2Dd9114c9d0F97aE2": 164.75,
        "0x5bDFEa09171A1c8ECF64f521e8451d8B7Da21C09": 164.75,
        "0xf8e23DBD5817d577188CFE8D55227D2072b8a3ED": 164.75,
        "0xCA1b14e2352dCD1d70d6BE4154BB423d02ffa15e": 164.75,
        "0x1006255BE450bc35265f69A8F6928850B427B772": 164.34,
        "0xDAe5F1a2bbf141d099101Dc054F41b48D8c5C207": 164.24,
        "0xF7C8a4a99bA34B4744D08999Dd017B5FAa4d3378": 164.24,
        "0xA0C0E158F25689569386E5C136239d6F2E0D1430": 164.24,
        "0x7bcD790D1282622dA859625F3786bE9F33042d50": 164.16,
        "0xE4E6B25491Be67550b4352d4D6c866f4ef420c59": 164.16,
        "0xBa61F8df05ea7462d200EB7Ac741E99b9Fef16Ff": 164,
        "0x37C37d2d94bB3D01e0935d43184d8608A167C3b2": 164,
        "0x5F285De1FE16f53146BAa750ed138B452Baa8Ba0": 163.35,
        "0xddF18E68c7f993800F612e1F4E633F44d866658B": 163.34,
        "0x368955eFB1bF001683cb5F7AB223380CAf0b86e5": 163.34,
        "0xD66D834997c5edD18cb2b36142596dD951c795ea": 163.23,
        "0x91D6d3Bec03eF9a0CdD61fD22705f825665A0d71": 163.23,
        "0x1A03c9A30D59cfb354df536bF9F20de7EBA84077": 163.23,
        "0x5450a98BD84B8E0708a2A3D55E6c048f15977CD1": 163.23,
        "0xb3313b023e68CdA95d7B625200e1B0fE6335A0c2": 163.23,
        "0xB123d62c2193E309f806Cb770E3D51b04C29c1B4": 163.23,
        "0xc92D60af8001b1070CE40337205Af18a0bbED142": 163.23,
        "0x5648aca0cbe7B4810B02eabf949a493063DAa3E7": 163.15,
        "0x0d17Bb80c0e8ae506a3F267A494297a8a0084aEe": 163.05,
        "0xb7fD4302eb683185115741A15EfE7Fdda2E2C886": 162.73,
        "0xB2EeF2dd33A58c0DD3F2Ad9390a13533bFD23Cd4": 162.73,
        "0x57b78f52C6781b81684e25c2FDA2d1cF5fd3E484": 162.73,
        "0xFe10891eB590e9C73f8C8394915e36CF05095574": 162.73,
        "0x5A4485986d3dB91A6E33a32dDb8CFe53F81d9878": 162.6,
        "0xB444776908Ff797E69D516caa5CC22856781B0A9": 162.34,
        "0x78d23147E319398fbEbe75232710c88f12540E33": 162.34,
        "0x021B995445C5dc40F29B8320F6dD0b8f90e5ee5F": 162.26,
        "0x8Fd6640adB92d6361dE34d776103024408c29afe": 162.05,
        "0x0cbdFac5e093C49BD1f8633fdeD37216ACBDcf4F": 161.85,
        "0x45dC664635627C0FE5c7119fe5BE2C3D39Ea3e74": 161.72,
        "0xd7145B1B5643Daf9385727A2346e54E55610f224": 161.72,
        "0xB4087398Bb4E562636EA4Be46C0Ac307bB5fE189": 161.72,
        "0x2AF5De5887edACC7bd86c1784e321cb34D89F59D": 161.49,
        "0xCA0772bCd51Cf72b179699CdbFa8b951Ca3fcFA2": 161.29,
        "0xBCF8c5F6ED6c679e6a5A858F807F0c15535fb16D": 161.22,
        "0xC16DfE34d78246Ae49f4098630cfbc90c78DF161": 161.22,
        "0xedEC48f7B562C0683BF466EDba129eC370FD6900": 161.14,
        "0x7C56B0353430E1ed39ac3A1Dc966594A2AC84F5E": 161.14,
        "0x86Bb239d7F94cADf707f9aC52e932aA42371111B": 161.06,
        "0x4d85e4F760fb58E380f02657AE5Aafb8bd010601": 160.72,
        "0xF3E4511e84159Ef4973ab3aF78F279A12AC13c17": 160.72,
        "0x17a89E040d34837B8c87fe82B7665DaA5EAf2345": 160.72,
        "0x064B902D2d6e02247508F13f05142b8cd326A5B3": 160.72,
        "0x3d030547DC33855FCd25f1167a3D2AB6473b530A": 160.72,
        "0xeb07A913F97c840D44e8e62DfAF4624F54DEB073": 160.33,
        "0x685BB42e39286E204F72428D5613bd83694bDc13": 160.33,
        "0x78514353D7681562E4df65C44b1beE15A6ecE901": 160.33,
        "0x18FF8Dc9DFCb1604C7961508F1979aE503AD95D0": 160.25,
        "0x9f5e6aF744a137C9feFeeDfb6b706B0640a57673": 160.13,
        "0x982b1D44Ac3ff17e4e0b6E2091fE0cA62C9442a0": 160.06,
        "0x4262C25B81D6e9CaE2962d93f86e45B59d2c437F": 159.71,
        "0x2B83aC024B0a4Ba3f93776Cacb61D98310614aFE": 159.71,
        "0x6831033167f58803e4B92c9CF6B77D9bE2E225a7": 159.71,
        "0x4b8B235c511f0c830264c7761520b1F9AD441716": 159.71,
        "0x37eedb7AC276bD6c894e81B8937b0b0BAB154E22": 159.71,
        "0xB196a8D6836fD62E607F065da9E487B331562457": 159.71,
        "0x49aBB27e23f9F70beA99370889C0529f1FA68C94": 159.33,
        "0x4d2A353Dcd9B25A241382241C9b9a27B7cD08f20": 159.33,
        "0x8dFA9eb8661076F475494dc54F19053944333dA6": 159.2,
        "0x5D8b2A6cC711A2381ef4ea3807961dbA99AD0Ef1": 159.2,
        "0x6DD93f62E209533888Afd02421a69312D4b9B275": 159.2,
        "0xbaBA55Af21E34F5209A83086c5C0156532A8D168": 159.12,
        "0x464fd6B8E4DDe4352117940a07d7cc93269a77Bb": 158.7,
        "0x4ed55058b11e35dfB0dF8844db2734cEd20B3678": 158.7,
        "0xC23e524325D26E429F749316d6B3115F199a4B78": 158.2,
        "0x143D7B35c91166643dDF29A4f3da1B8f125857D8": 158.2,
        "0x00C67d9D6D3D13b42a87424E145826c467CcCd84": 158.2,
        "0x40411Dc3B99F29338AB97365081C2979f1b85599": 158.06,
        "0x328C41d916877Ed4e9283C6AdE39706d41061D2e": 158.06,
        "0x816225f2F3f1C3734bc9536d0f5C62f0a2cf893C": 157.69,
        "0x57424e704d9912129445cadAE8c321A3BEDe349d": 157.33,
        "0x994cf964ef84C920977de052295A4f986274b01c": 157.33,
        "0x085cCfB94eB52EA0A10D7C180d7ADF03B33fDbF6": 157.19,
        "0xA9Ec08edd196B91Bc9177420137804bE1D6EfDa0": 157.19,
        "0xFf36b9cb75C9178841D8b75Baf9776bfA59FBE9d": 157.19,
        "0x08B2F2bF6DaddcD68C7C842e4C3a376C1FC69527": 157.19,
        "0x125531D524226A5035f29Fe57c7e5986AB175Dfd": 157.19,
        "0x78a5db0645C8E8dcbf27E678075DaFAc71e2386d": 157.19,
        "0xeA09CFC7239476AB030B649D5CEFdB786f0e7412": 157.11,
        "0x0ef004C406374Cda5115422a218c45f4b22Cf290": 156.68,
        "0x83f350d16C9581CA9af97dd53A77c72C8be2cBE7": 156.68,
        "0x70b1C13C592Ee6Fdb7ED2F06c70a409776a11cE6": 156.18,
        "0x431b5DDB0AcE97eBC3d936403ea25831BaD832B6": 156.18,
        "0xDa1a32ADecb9b826B52570334Be4759AD481b0FC": 156.18,
        "0xA6BFf481FcAb444469F58743F11c8d6B73825B38": 156.18,
        "0x77337dfe579a03a07a475870DB443d65127F0769": 156.18,
        "0xCd809E8AaCE6343dFa2F54B3dE8782dab904e9f6": 156.06,
        "0x87Cd0a0FB182d366AA629D085811A3929389f817": 156.06,
        "0xE6bC908f0b866480A2e5644f856B2e97aC9BD721": 156.06,
        "0x5568938Bf4188Bb868Dbf31614091062C4a44B1E": 156.06,
        "0x016F17DC99e1fCbE08e6bF62A42f632340611b36": 155.74,
        "0x3364663811DbD2293E11A13D51B65Cdb8CAd3BeA": 155.68,
        "0xbfad818EdB25DC4eebac8Cc44a7533bE4652AD6C": 155.68,
        "0x6476D5C547D2Bd26F827ACB38fAA1a0529bf9E36": 155.64,
        "0xE5ED7a66Ed839c94Ee63CC78E892f897C49E9948": 155.32,
        "0xC77C559ac58508410Ba97A9688d66d881D03a9EB": 155.32,
        "0x863A75356A04d4Fa3d30f4a518a136FE27097Eb3": 155.32,
        "0x1A0d5De5fe02d4D2734fDF538Cb3091DEC4f6De9": 155.17,
        "0x9dC2aEa18955DD9F898d7ef130e4e166B9800354": 155.17,
        "0xdb3AD616fA7967f3a267459C98931DDC56927677": 155.17,
        "0xB75d6fE6723290677a4f7141307e3ff6d7509711": 155.17,
        "0xe1428D7724997771896e19e1c87E3783408D9225": 155.09,
        "0xdd6bc886F14e607254D6F1a24321Ed38Bf8E3F5e": 155.09,
        "0x0C6476B446116ebc62427239a6d978bE60c28395": 155.09,
        "0x924F60124543cbEcf77d06Cd0C33151D6b43e1a4": 154.67,
        "0x8C3F1cfe98eCB28Ca170438722EF3c3Db88043dC": 154.67,
        "0x580cf96008598D6203be06CE926aef038E19E473": 154.67,
        "0xcdEC9217FDdF2D560eB0A6f127574F61c8979250": 154.46,
        "0xc4F58aAcCab3a59b7d2f152777B797F8Da609dac": 154.3,
        "0xAc3F8A924aDB52d6616ca194917dA4E5fFFfB698": 154.17,
        "0xCE7b1d2d6702531237311461B984d9f1d1baE27c": 154.17,
        "0xf1f5D35c46Fd62fDD9150C39acc4A1b6A8327Ae4": 154.17,
        "0x6C7116d0b65dC3de4aD07137D10C7B02aDf91389": 154.09,
        "0xAa32a69dCC7f0FB97312Ab9fC3a96326dDA124C4": 153.66,
        "0xBD1f63E533325605a962Df4C90250aD317A500B1": 153.66,
        "0x343454958b83b1B31ae98177463b34a8fA3310C5": 153.66,
        "0x9bC1e1DC98c30b24bbF0F2b8e9319f2756aFb7Fa": 153.66,
        "0xC4F694F8dA796b7b36d9F5CEeAcAe5722c2D1d6E": 153.66,
        "0x869921f41Af38Fe397c8309d3D1885809508B723": 153.32,
        "0xC38899D01dC59A92e38cbe5FeeC9FADD0eb063B9": 153.16,
        "0x4312eeaf2CFd81f3df76E9D154969a1d19104F47": 153.16,
        "0xCBB008D4d2d6c32Ab1B6F889a7f25F0326131170": 153.16,
        "0x5538793f0eD24fD4EA2Fcd5225A40995A8f5Ac3a": 153.16,
        "0x7E7fE107E85f626903497FAF0f4240b9E18a2672": 152.98,
        "0x420c49ff3B77AcBC5E139aA342E443e54214d51E": 152.65,
        "0x817079ED67a0Cb30a2c60640568e31f49955B4D0": 152.65,
        "0xb9367bF71487eb10A68c3179753b9E1BA8871c8f": 152.32,
        "0xE2bc04fB76AF6b51780A0579A526930E783862d7": 152.15,
        "0xBd5678481143b4F757d240deeF122A954f480A05": 152.15,
        "0x45ADFF324Eb1ac03a6A115dc539052232D4bA980": 152.15,
        "0x163282F109b86167A7017A9DB2c995a9240Dff38": 152.07,
        "0x0FedEc78f117DaA66A6b02bd04939Ad333558E99": 152.07,
        "0x6801bD0AC207fB59bba730aB8aCFBa35eb8ed96D": 152.07,
        "0xbb8F6532f791b11199213E0Bc4c7b362EB6C6cf0": 151.83,
        "0x3F7C10cBbb1EA1046a80B738b9Eaf3217410c7F6": 151.65,
        "0x9fAb59236A8608E5f1240FdeDDf0D22277c7Ce88": 151.65,
        "0x454A58b02438019DbA1A014B00A854C37396985c": 151.65,
        "0x797BC498EdEE4357a16a1054dB0323CbD04C84c3": 151.65,
        "0x23BF98A57AeD6501cE6055548481d5f1967eB9A5": 151.65,
        "0x4F46c9D3257D95e35A2441dF2FdF293Af13F47D9": 151.14,
        "0x4116Dc511fbdC34C2e5719Bb2D8E023fD8b8Bc42": 151.14,
        "0x225509847509f66c9bd49cdA9714F481a3a6200E": 150.64,
        "0x642078fCC20130Ea8999d7fe55368922FD38971a": 150.64,
        "0xC4D78EEBA8afefD69A28A8C44C740DDFA078B622": 150.64,
        "0xf4130730731f1310461ab73C26C00014aa0e8e74": 150.64,
        "0x86E46EC967f62BDc1f11a6A8Dc9DA3abf1AC99EA": 150.64,
        "0x962A48960336608457b9AbC30B1E9D4b9752D608": 150.31,
        "0x141ec59b2E2bc703927EB77Bc843E5D1102Ba913": 150.31,
        "0x1E670BB5FEC8d4cEbddC3d2Ad99d68F15210D742": 150.31,
        "0x287D2974Af3a369e9bD42eF5636b5D1Fda13a35A": 150.14,
        "0x03d33248EFCa24b57564Fb2276B8f2D063936A8D": 150.14,
        "0x9948FfD4B0E40A096f8979CdAeeA7D852f6ea177": 150.14,
        "0x2f2C0DDff9080f7E3B18AF57dc353BfD11D9d1C9": 150.02,
        "0x0Da584E836542Fc58E7c09725cF6dbDfeA22f427": 149.63,
        "0xC03eDD677A9F4eD8128532A9b31E9a3FC2efFFb2": 149.63,
        "0xB6C4A3Ffd5877cCb32485Fb576a7E5Cb16FAc761": 149.63,
        "0xB5CA2Dddf8Cd15E11a58D4C02825CD9A82D56D5d": 149.63,
        "0x8fc4a12a6f356D51417339043421F6c434f3e3DF": 149.13,
        "0xe580BfFE2f427479483395fA6A563C07f7ad33Fc": 149.13,
        "0x01DD5c4dc2B4697f10F9e6e7C6f92bD4b8333653": 149.13,
        "0x8e81776DcC3Db49AD715631f3B9276ebd9De6a36": 149.13,
        "0x0607Faa20f91cf9e9415DDab1C392D9E27DAe517": 149.06,
        "0x0de4348c28c4e9eF19d5Faf4024Ef6653c326ec8": 148.62,
        "0x33eC34b1B4bfcdC9B5E37BA4ab02f6E993a457Ae": 148.62,
        "0x8a2dE3a00ce3f1c43005b8248f3aC65c53659757": 148.62,
        "0x97d2204D2427236E4D5611e6d7A5de5945Dd4715": 148.62,
        "0x9e0149f7CC28c93A3B5F76AB3e8A2a22d14435b5": 148.62,
        "0xb8951eC20af5899550dea6728eeF20dBB27EcDfE": 148.57,
        "0x1d9cd9b4fA512765FE344bFB8Af4BEf9df296888": 148.31,
        "0xcBD2c4c8f3CAe23DB66ED8E882A083f2dafD1296": 148.27,
        "0x514Fab6ca1213F22Db9f7E1bD461986AbAEe93B1": 148.12,
        "0xCbF7270cCd7B36A91d6dD5A5e56761799984D647": 148.12,
        "0x2E7f0F4DabdfE46f743E7dD3eEdb86B92cf78494": 148.12,
        "0x68e53742E7a7De9831b9752046072a942f18e4fd": 148.12,
        "0x0b776552c1Aef1Dc33005DD25AcDA22493b6615d": 148.04,
        "0xe28b3058a2f7F251741a7289B633a902126260ea": 147.62,
        "0xfd6696e745434D6Bc6Af360EbCf81876CdE48D90": 147.62,
        "0x7ef838B76249d2Db315Af69B539FDA301f9C7Fe0": 147.62,
        "0x0a27F53e3D044465D07607EF7A048E71809F295E": 147.62,
        "0x4Eb4FF4206B92b28383819275a91Be201899467A": 147.62,
        "0x6858A4D8d7D0297C138b403B6A34cb3b424B7f4a": 147.62,
        "0x55fe0C55359F02292E95b67763d41d0181399188": 147.62,
        "0x5449F6Df38D7d6f2fB8ccEA1F3f9F87418e8A174": 147.62,
        "0xd8b2B7F42873F111348c835563e26865474337db": 147.31,
        "0x854ce16536CC41A0593A754F88a3eAf14EEe9938": 147.11,
        "0x5cAf573a688F21Bb7A73a5F1cbEAC1DfD6b505CA": 147.11,
        "0x4284eE5f2826d024a6d3ac269ddbf7521393d102": 147.11,
        "0x222A227A5dc77C643e836556E573Cb266998A870": 147.11,
        "0xBbC863afCdd2F790FDbFD6a5190b75E9C2043554": 147.11,
        "0x3e97b8dA1E88C8A318069A8b35DFf8a7b20df636": 844318.1140694343,
        "0x17b7aFbe43503813E525bE9dEE970D6fafF75633": 147.11,
        "0xD8c84eaC995150662CC052E6ac76Ec184fcF1122": 146.61,
        "0xb9948e7f65942EAA4Fcbf7f7ec331D7a41cAF43c": 146.61,
        "0x0eE2B668Db74B052d48515AeEe7198119FcfeCF3": 146.61,
        "0xAf7FC773b91230d9F9e4d9ecbC32B67F011063cb": 146.61,
        "0xA529DbF959fc80F9Db66d990b47Eb33e26c416a0": 146.3,
        "0x48375F609f570a89d6814405b69fE019Ec90F333": 146.1,
        "0x2eD8034947261547603ee66d164aF539A14bF8F6": 146.1,
        "0x46E28C5F9D86DAad3E3BB85Bd3a7E4142032892d": 146.1,
        "0xd0224884CaF7Ad34D6fb9352e35b0f75aB6069Ec": 146.1,
        "0x5F14568bA9750B5FCdcB8d50163594Da0bDCfe2a": 146.1,
        "0xddCa6886b00120A066156DC9093544Ba09a05E34": 146.03,
        "0x6e977e9d8163d729a6b2050D1463D156E8888888": 146.03,
        "0xf1F6d3aDE2C6419730e60A7Bee8bAa8a6789B87A": 146.03,
        "0x740b5548E71532afa5211f65612ad0ea91422Ee8": 145.91,
        "0x10D8B874b74AB11cfFA04e11B0CdBC7F16C80069": 145.91,
        "0xcbDfB1F0988749f791e265F60A485Cc0f996A1cb": 145.6,
        "0x8fB66dBF6a4D1CdAEd5B72135324F345Fa6C9B83": 145.6,
        "0x1133073a32dF0f80ef34aD8A41015A664A1FBABA": 145.6,
        "0x5968A4f3D8e31a79a6886750bDce076E604C8ADE": 145.6,
        "0x99ED04C212dD3929E9063bd78B26Ef41858CB62C": 145.6,
        "0x4b12c81612B1ca7675C3abAF2b1b5f493e6413A5": 145.6,
        "0x9B590cAe0949B46aadE82bDFBF9fe427173A948e": 145.6,
        "0xb57bC9b9a0b021103052cCd8c7ca30acc4F41612": 145.6,
        "0x48Fb55eD1Fb62ED26274fb805f6444bEa97c1F28": 145.6,
        "0xda4488f2fE0Ff3E2Ded87ed63d3e1d3d074dF276": 145.6,
        "0xE0A738dCc3D41A6E34301Df80261567458D6bB48": 145.3,
        "0xA6054e37AFF66a8a9690e5857F82647d13AfCa67": 145.1,
        "0x8dA4b8ae83EA2Fcc7bdBAf9B6042B819CD2DaE3c": 145.1,
        "0x111fbf7b389e024d09F35fb091D7D4479b321B0A": 145.02,
        "0xc04032bcbcCE4d43ef978cC808F1D2dA5C0Db3c3": 145.02,
        "0x03947F2B7A615b02D52c172c75b2192Bd86Cd547": 144.59,
        "0x7e2400626811b1cAe987C41139c39830F4b2BA9A": 144.59,
        "0x488BB1b37Ba4a7399b21A27B320EcC652075e135": 144.59,
        "0x23Cb5467e23AA967F7864a018FF862D35d52eD5f": 144.59,
        "0x31889b97c0E272B97dC1c8D6c81BAE3C2a82bfBF": 144.47,
        "0x810Cf600db7f8FA48092cD954045c695f3c222ef": 144.3,
        "0x24fB26Df76E505a1C21a603eE91B11814B4D1037": 144.3,
        "0xb82f31849E12a5f0460EDBC6c78b56B7a33da4cF": 144.3,
        "0x85D628d0537839c32f2da674aaa3A6C48da2570D": 144.3,
        "0x44D0d42f3294adc5C861Bbc4E47196A05840c960": 144.3,
        "0xa6855663972D7da311a235a8F35Ed2812Af2dEc0": 144.09,
        "0x43Da88EF16B6cc56B5B8E7c891FC99B2f126eE03": 144.09,
        "0x7F85Cf44E446a4B1AaCe2A28774E88cd6d4e3441": 224.3276125326058,
        "0xFC3CdfD5631050FF4281Ce26A7131c04c47DdD51": 144.06,
        "0x78b54F078905F357D87D4f50c27c89B6d4Afbede": 143.59,
        "0xdbE214C863D6b2Ecf5D79012E5D03aab09C57e28": 143.59,
        "0x5631634c42416c34Cc4f0198e6A5d47994ad689f": 143.47,
        "0x6960d1fA290F0a60896D23Fc3b533a9b0de03644": 143.08,
        "0x376aC340CD8f91899a9d93737C191C644f2A42a9": 143.08,
        "0x8be60fe9F7C8d940D8DA9d5dDD0D8E0c15A4288B": 143.08,
        "0x51cfA61222807b1b9b00f92e21f0BDED7796E9A9": 143.08,
        "0x6aef48eA854Bc0e805232ceCbab2fab592037c19": 143.08,
        "0xd6B75eAa9Ea208FBfC774F2C6ccbD49e422EEB88": 143.06,
        "0xB7a63463F36AD47Ca7E964b983DfFe17F4A0eAe4": 143.01,
        "0x950a89611a5858a4d8501776001584C806ecCD14": 143.01,
        "0xCbe02a534B7dC01c4524E5f397bd33D03E90Bb9C": 143.01,
        "0x0a3a1EC7cf57Cb920C66B4b4e7956A0bd0234CBD": 142.58,
        "0x66911f0d4C73A9189Ed29ecAFC1514236F51dD45": 142.58,
        "0x3b19BBe2E348371360ab39238fdf1B86d7C21b9E": 142.58,
        "0x7a2223c939e9C09026fdE10C1C1baCf2D9155889": 142.58,
        "0x0b8da8683998718dc4818c14E556D4F6d27dce7e": 142.58,
        "0x89F580DA9852B1b5F34BF35cE9402dB8Af7e17b6": 142.3,
        "0xD1C9A97c5687eAA1E22c89D7F38a568C99F30604": 142.3,
        "0xF67ce3586c9046ff77a78176a0778a6E649FEF68": 142.07,
        "0x094109Ab78767713305D2E5Cd05d832Cd1FaEfb5": 142.07,
        "0x19B27f5cEc84969e83Cc63B78108b843a1A98cc7": 142.07,
        "0x1E510e363ca6672d9d822b2897F49E5aEF0A1D0B": 142.07,
        "0x6b8B01df86bfAaF79Dda038009fc5597425ad0cF": 142.07,
        "0xaAe833D972e4a8dBcDcD007a5Bda0b22E5Ddf583": 142.07,
        "0xdb527a9f967d22B9A2801f21DcDaf819fcD9509E": 142.06,
        "0xdfFEF5d853E5E1DaD3B909E37Ba2DAE94087c3cC": 142,
        "0xd52D391ebDFe9708346FA5017076d5D190493F78": 141.57,
        "0x29976c9c4CA5d92d70CCcD2611Eef58f1FFe158D": 141.57,
        "0x6D07A8ab8275FA0450182eCf77623bd4eBF201e1": 141.57,
        "0x40a01Cf27cF6C82944e2B59D7341f6EC75094EEb": 141.57,
        "0x3063e744B4d5BFba51FC7591833dA79514A6AAE6": 141.57,
        "0x3F9d386eeb91304aB65899b567EE8756D3298d40": 141.57,
        "0xA30FF4ed003c4403F3776a72e4b0c66292D43474": 141.29,
        "0xf989c2293aF1ED4a0Dfbce8E0EE4bB1E804dA604": 141.29,
        "0x5bF7B9b119d7828Fc363a59eCBA0fc6bc05C49D6": 141.29,
        "0x6a5334E6c9352C1b5735969DD439e41BCF9b4dA4": 141.29,
        "0x7bfd4D3A74AafEd8185Fb19FBeF69c65F1c9c736": 141.29,
        "0x569a9aDaaDd4ae9DBd4D5AFF7668f2257631804F": 141.24,
        "0xa5c3A513645A9a00cB561fED40438E9DFE0D6a69": 141.07,
        "0x3af30125B7A81C23bd3608645c354CD02223224D": 141.07,
        "0xf5627dC91f3E5FcB0310E78939ce12470F6Ad595": 141.07,
        "0xad5509273D21F6F3E7a8Bb9dE306e6e573a84c04": 141.07,
        "0x53c960C2979Ff6254A50fDA7e53236413dA1E931": 140.89,
        "0xcd070E0685301e3DB6566F7EC1f574B38bB49F74": 140.58,
        "0x354dde24182953C7794eE8f1e9c0675467072fC8": 140.56,
        "0xE7168D1DBCCAE469491922763C5FeAAd64244170": 140.56,
        "0xF71953B029dBa0517d6eb7Cbda9Dd390728DDb98": 140.56,
        "0xa4E057E58a11de90f6e63dC9B6c51025bD2c9646": 140.56,
        "0x14b1b989Fad1e0ece572EA5Ee69702804b26d831": 140.56,
        "0xD7429A8daDcCA340b31015603511E232315d5dc1": 140.06,
        "0xBeF716e7fBC844020925dc372879becd2f932bF9": 140.06,
        "0x70C178A8ebA8e872C9F01a40870c7c2889B762bb": 140.06,
        "0xad3C447C7cA1B323f0E0bAc8f9ec03F2080fD9DA": 140.06,
        "0x4271D22292aA37e13cD0C68b8210A7A6AF194407": 140.06,
        "0x220a6CB04d48CA2c33735E94DF78c17F8B0F7C9F": 139.99,
        "0x7aD9d3ff40b0cd31f1572730c55b592bDF8D59a7": 139.61,
        "0xDD40128465A66d3f51beAdB4948B4710E67a8bCa": 139.56,
        "0x437b5baBB1cBB0dFfA09aF1de95b11aCF6222C77": 139.56,
        "0x8BFa2E0789f3f4d1ef2bDc86c5C7EA3885c1f2B9": 139.56,
        "0xB6398fad2F8D238aFD3A522A8cEafd400e71Ef62": 139.29,
        "0x8a85C8c2A09Fbaa0Fa90941efa1c4104362BAFCa": 139.29,
        "0x87001bC1bC1BE74920Ba3a22a5f0b233341D9656": 139.05,
        "0xf05E4F44De569cF8C6aCf5fCe98271008A532969": 139.05,
        "0x6CFefb0E84B3648E945DbFC924f8a4D636D58B9C": 139.05,
        "0x828ef26D34c64a6210ED38b8807805312Fc8C9Fd": 139.05,
        "0x1B78284595eD8468608DA05aA02933b84C6A4183": 139.05,
        "0xb5EDFe53ED4Fe480359ac603Dad0649638A41e54": 139.05,
        "0x81dC17b949cD4591d6B8f1eE826Cd5294c9A0D7A": 139.05,
        "0x2576Ddda067Ed9d99A31fF64BF0E9fe7dC7420Af": 138.76,
        "0x20886778D8DeFAD8C137222be6A3F7E4100b235f": 138.55,
        "0xB020c70C4b995ecaf9E2bf784A3858275F44BD0E": 138.55,
        "0x69F6DeAF6282b2cFE6310AB421959fa24aF79555": 138.55,
        "0x31244b107B7F06c8866926303bcefd68EA59AA4c": 138.55,
        "0xC4aC1BF686AEdC4c37F8eb1CA8E7c1DD53F7377B": 138.55,
        "0xEf58fa9Fc1E3904807c9Ac73a5c7C59100b89498": 138.04,
        "0xfBE3952035FA70018D8003DE1E9956d22bf2eeBb": 138.04,
        "0xba90B576573D9B2563D752a30c4cEe502C15C371": 138.04,
        "0x13C6C005fA669A122088045bEc43B5bC5Cd0b47A": 138.04,
        "0x8d07D225a769b7Af3A923481E1FdF49180e6A265": 138.04,
        "0xdC6a5B3DA5C6c4cA0204Bac74654bE877eebeC04": 138.04,
        "0x868CBfd33ec93B451c510125E4D9f1AB1E42fcD2": 138.04,
        "0xa435530d50d7D17Fd9fc6E1c897Dbf7C08E12d35": 138.04,
        "0xC54A102345B1fe6b5371E5793344Eb8aCb86Ba64": 137.78,
        "0x47936e516d11D987412e67E5c20c8fB831053653": 137.54,
        "0x3395AdDf4b103Ae0B6c12084880D681fAa8393c3": 137.54,
        "0xc88533351059765F165A3B51f1a5d2B8dFeC3c08": 137.29,
        "0xdc453E01c0E2E0E5d36545E70ff38342ed65ab0d": 137.04,
        "0x7faCf85E84F443fEF7113bF85e7a582B251a25b5": 137.04,
        "0x31A6686Af02e5f51FD647a9daDfc9C711efcAA22": 137.04,
        "0x6808C7CF650C88C63273544695076f90339E1515": 137.04,
        "0xF6d4A41579BF6069A369eA56a72C29fB7D710664": 136.97,
        "0x9c57027B1eca93093a6F446422C59C85A5A3Fa52": 2866.8203996629222,
        "0xb7B6fa9A2905eB3355F723CEF38778C8e483e990": 136.82,
        "0x99999990D598B918799f38163204Bbc30611B6b6": 136.53,
        "0x64931189b070Fc7C8c80839C8a2d9a10b83082AB": 136.53,
        "0x644Be8a25BE30A21E2DFFeAE4FC43937fBCf3efd": 136.53,
        "0x2d7C5450434C544e994FA8c0DBB723B783E75736": 136.53,
        "0xC5B3D87fC8C96d2c4C8bA181F510052Fc9eE7F2b": 136.53,
        "0x48e2Ef76631170C68Af46Da23A5D05DF4F070992": 136.39,
        "0xDC1c5a3d2173D6bcC0d6a62b7e94c00f88DdBaE8": 136.28,
        "0xf47E696EeB0845e443B66793F0264C00806757b7": 136.05,
        "0x35119741D2D3c40fCD456a93860F68c1754a4f56": 136.03,
        "0x98289029B0d4bB73Ead9Eb1A3300eD724Fcf6779": 136.03,
        "0x22acB6b1E93869226dF1F0fBbeeda47c799EcdFe": 136.03,
        "0x8BBec86Ed6a27D8654aa601e364A3f1A359CF428": 136.03,
        "0xaBA92f62Ef9d45d0b61808D330461c3b2d8fece8": 136.03,
        "0xcf6862511797537EBF04ea5B16E08ce1826Ed413": 135.52,
        "0xf6cb6CEDB822Cc2CF93251A131Cf977BA2423639": 135.52,
        "0x4296780C7810cb27c9297B4F16664eBc4a7717c0": 135.52,
        "0xadA2bD6a38D5aA0008221FC8f28EaB5ef36cF7E5": 135.52,
        "0x7c715e14523ba1a7533f8DEfe77892cd93D793e1": 135.28,
        "0x4D7a99d36d2bd21aECE4c96FEE3ab8fF5c904Be4": 135.28,
        "0x13eD158678455526778249c3ef39aB75e27a3c60": 135.02,
        "0xc969126CaB6501aa0dA1AC472503A4dFfd262b36": 135.02,
        "0x43a5a7bf43E0B680b30Bc8Ba06b4Ab7aeA305559": 135.02,
        "0x3509b3B6fe4965b367021D5c4cB13C12c681095A": 135.02,
        "0xd3faB52A0C93346F23a9b9b24Fd45ea0b8dD3420": 134.52,
        "0xa06b4F71b94Ec6b59e0633c015772d3F1efdF7cA": 134.52,
        "0x653564818fb4217dC4aE892A30815b2585456302": 134.52,
        "0x7fC68ABE512c8c34439862e8b911Af8695D0d930": 134.52,
        "0xA3F07a20A0F70f5807E8c53C4E03438256Ff6a42": 134.43,
        "0x386D1AB0D50764e135b10247574264Bec20F3E03": 134.28,
        "0x1eF2925440aDc96B950B8D1119d8918Fe2bAf447": 134.05,
        "0x97A0E5872B47f31321fcaed57D293058bfA9C338": 134.01,
        "0x76942474c5C8d0405746ac55C3D7BD2EFC6d4631": 134.01,
        "0xF1253ae06A4E2c7051494631c67770F9010e8417": 134.01,
        "0x2623D8ADD57D69F3Bfd91916C261C8e746a5C7C9": 133.83,
        "0xd1dbb2B82915b6dDaC5B1Ca7a5421a678953b7cA": 133.51,
        "0x68BF599B7D79200D50dfCa985CC1f86FB329C586": 133.51,
        "0x9F679ef626b341afe058b40058e115Ce208A3d2B": 133.51,
        "0x0bd8C72F3f5e13DC6EFEe68B57b32ecca3Eb474F": 133.51,
        "0xf4e7E6B600286fFba8154F5125420A0F78DB835d": 133.28,
        "0xC0723DcFBF60002b3B5b55Fca06F0414263ff111": 133.28,
        "0x8FB22c37beE6e64A787942DA05cbA1fffeB72F91": 133.01,
        "0x8d2aE74898d7C068DD9E1A73929Dd77b75d819B7": 133.01,
        "0x3412C43A36E80263707dFBa6078Ac9b5871E2ec7": 133.01,
        "0xc6582B03Bb46ec2c367B9b1b712647c46471F96c": 133.01,
        "0x0a1a8a13fd2c3094B8F563B4944Db4e18bFcF90C": 132.94,
        "0x2ABE2aB81A7e76b93A45BFfC4066dF2603A8D36e": 132.83,
        "0x4cA7CEB2D96F660f46C8Bc9416d56A52Ca99BD36": 132.5,
        "0x2594Bcad3314cAc904a79D2A607276910f2b3893": 132.5,
        "0x3A286227fc0B59A4788Cf7713DF5994b5bfD95D4": 132.5,
        "0xbeD9C70eff039b2Dbd8bafdA08C53BFd986d0C1F": 132.5,
        "0xF807c99e3b8f9a5cafCC32Db1ffDe555aBcBD728": 132.5,
        "0x4BDFAE7d2A6FC206c5a80f4d41e683a5D5b30D5b": 132.5,
        "0x83B97790c7dA251FAFB24d6CbfC481cFa4AFc4F6": 132.5,
        "0x817cC22E709FE6b0f26d22726cef3e73089ca2D6": 132.5,
        "0x3dF83eC9d2b62bb9bb83EbA1218A202564bb67DA": 132.28,
        "0x3EDB7d5b494cCB9bb84D11CA25F320Af2bb15f40": 132,
        "0x11Add7af96d6f94bAD07E338E9a4CA5dC0f94D4F": 132,
        "0xD4fc1974bFB6721785cA25828711d76A0Fc2Fea3": 132,
        "0x1A271f76EFC137505dD32A8541ba6219909adc3D": 132,
        "0x3a81cCE57848C2B84D575805B75DBC7DC1F99Ab1": 131.93,
        "0x6626949B6402A54a7C5eC87CE8051dF0F73D555f": 131.93,
        "0xdd54b71E1C58Ec943df869760F3d676FB129d7b1": 131.49,
        "0x3ba1FF476A9A3Dd20be5f10311C1033dA584d19b": 131.49,
        "0x8F84643EA8Ef4D88fb2527087Eb811Efd6A5A7Fd": 131.49,
        "0x8D481eFD1813764E3cdd41600d16FEdCbD39047a": 131.27,
        "0x46ec3B933283a14A8f3c7e2d9A8086b4F592C3c6": 131,
        "0x8770Dbd97A61C39A7c4C5Ed256076135d64a242A": 130.99,
        "0x3888132606615fC0759853b6eC1107E717D0Ae52": 130.99,
        "0xF6082098a6f14B8e21351346a6F0BD46bfA77B40": 130.99,
        "0x7852d40F2a8Ea6C219A91aea2249f5a3F70D4dA0": 130.99,
        "0x926934C924042370f421027aBeb420b036cB71Be": 130.99,
        "0xBA275e06a85F1Fde5fC26B6Da5B23FEB7fE0daB9": 130.99,
        "0xE9e4993aA434d1E7CB64dB6A57507ae37257d4B6": 130.92,
        "0x6dfD648529f19A276c8FA7a54d4F38A2d51d8E56": 130.49,
        "0xe9ff279452597d80A93A18cCa19325d5e29489D8": 130.49,
        "0x74597A233e403aC2F48c40DD66Fde8D22d6634F2": 130.49,
        "0xE2bEcCACce9F372dEcea5E5B65F328b61870F748": 130.49,
        "0x0Ea7dD4f92DC0C486D89E19198B82081DBaC0632": 130.49,
        "0x1DA6B3273A40F01C0A5301A87c237F63b24Aec1e": 130.49,
        "0x3EA59cb8Ac06b6D5e691eE92069676b3ab8Ab5d6": 130.49,
        "0xa459D10B51B7e78FeD6ABFC9935fDA67265EEEEE": 130.49,
        "0x30d691551581f9fdEd589023A0561071719E43fC": 130.49,
        "0x46911a56BD8166Ee843A01c456Eaf9D6D241aA21": 130.27,
        "0x9e1A7c99c44c6B7B70402c43AC0f4552dBF729A1": 130.27,
        "0x7bfAd1dd12a8010B66DB7aF2606793A3A7938d6B": 130.27,
        "0xF41cFAAA86b66C8cBF3e8f70cEB7f13C87Fa9d62": 130.08,
        "0xE9db81A85fDc1f28239bdcA8D3054ad39F44A8D5": 130.02,
        "0x1dF428833f2C9FB1eF098754e5D710432450d706": 129.98,
        "0x72bdF017721111185f159bEf28b701491096c7ce": 129.98,
        "0x3852C563ccef8436468e5F5f07d1d9f282817391": 129.98,
        "0x164a8379198a8d7155a1F0eaB9BAA256078d378E": 129.98,
        "0xEC2cBcB2b994F8410073220D84D29EB66F9D9eC5": 129.98,
        "0x1a21Ad20211784B7336AD5a490C11b09b32EAcee": 129.98,
        "0x67f5E368D28835A8f6B8E5576b1e17Ae2CE24769": 129.98,
        "0xdcA29673D3C7665e0cBBcf69a0CaC75213Fad52C": 129.92,
        "0x5c57fec3e02E5B64F8c3b47B39942ef682e51459": 129.48,
        "0x561EAf290e0CA0421582cD65339ce6724AD97cE2": 129.48,
        "0xEB0f6B46Bc25BF573bd3ED4F46913495E8DE935b": 129.48,
        "0x3d5436130Dd499D4b7d8fFE324B41ddA70176A81": 129.48,
        "0x87ff5525F4e3983E82BFd841D84bfE4FdCa47B98": 129.48,
        "0xeEBE5A1E8ba2c925769a29002B550849c52fFAa6": 129.44,
        "0x382a8f56fe85CE837148285d6219DdEEC9ef11Ed": 129.32,
        "0x8157b9805E2c984774374740c569f58211e6f8ee": 129.29,
        "0x4e775cc023E66E3A36885d648fd5848326Ab04Cd": 129.27,
        "0x68282C7FB58A7Fb09537E44F2C9436c43a544a06": 129.27,
        "0xD6b2095e913695DD10C071cC2F20247e921EFb8E": 129.27,
        "0xE699e8334d901986d9Ff6Bc5AE4b44AE5122F1ee": 129.27,
        "0xC4b4b63011D10051EaaE77d6CBE7255aC93081d8": 129.27,
        "0x0aE86cA9596b5d1eD58522B755B1d87AFFA91D64": 129.27,
        "0x85e6A873B58E4A6E4a6Db7D0c69f93C871028549": 129.27,
        "0x51E7bcBEb2b963d81b3074B7F786E39c4173B265": 129.27,
        "0x755Fa1543e7fba12DD992E836D68fE043f141b0B": 128.98,
        "0x9B891F6D2Bb1a7358bd5D0d4d415F3Bf9Dd4CC1a": 128.98,
        "0xb3dABA4192523d1778beF4138D82caCEB06B1d2f": 128.98,
        "0x3296B13B1eE66D953d4449BD81581a4612ECc27F": 128.98,
        "0x4140100f2229122245E981c3874ba29CC183c8Dc": 128.47,
        "0x6CfDaf6646E210E246414B971FD63443a0aD1924": 128.47,
        "0x3aC292d3257b0f8Bd68e7DEfA1C364F917aa551B": 128.47,
        "0x3E149289fca31001aCd7b0B226FC050111b52cdc": 128.47,
        "0xc3A34F50f0f2b6393A79689B6a9b1b5704c1668d": 128.47,
        "0x5B64e5DF4051E7b8EE66855C62CefD8df3544408": 128.27,
        "0x3C12B77aE8B7DD1FEB63D1D6a2A819AcdA0a41d2": 127.97,
        "0xb76Af3b2D258c35CcBC2384f26259618B5a4eB73": 127.97,
        "0xbBcc2E027A065D7c4E1FdCA27885B1783348448c": 127.97,
        "0xc578958DD1880cF00BFfbb7Feb9c28cbbbcaD3bF": 127.97,
        "0x8210b30a77b0dCdF25B14C9d6a65399B27d5c10F": 127.46,
        "0x2b5a0bE5940B63dE1eDdCCCa7bd977357e2488eD": 127.46,
        "0x74e75cb6feAC40a45B6483a7689B41877a0F0FD1": 127.46,
        "0xc8Ad3FF2102CF2DdE691EA45FC472a5aB34f394f": 127.46,
        "0x4037199e26ba2B49E52Cd82d2914aF80E07435AB": 127.46,
        "0x375E3dc07d1C84024dBa2F5CbAf677f5D8538c93": 127.46,
        "0xd095E0f8C72E22319846b643c4bac0caC1f67006": 127.46,
        "0x23b4aC536A0C14b654b307935398Bb3198691685": 127.26,
        "0x4142e7B1E829Cf498BF3017B8F964e6eD293FfD4": 127.26,
        "0x2Bf5Bf6977971E9428f4BF084D734f34e3eD9659": 127.26,
        "0xCfb36f13F8B3B2B8ACD4A18263268F19f5e9C867": 126.96,
        "0x7B73B70c70B4c620029a4b2FECf95b151Ac43894": 126.96,
        "0x06DEB438E139308f81e80D43bd1dD72E4D931ED8": 126.96,
        "0x9b8bBc91218519Ea385d59A8D661B50121249CD5": 126.96,
        "0x02E0c302380aa679189D9caA349A0Da5A6A19108": 126.89,
        "0xA708662C3Ec26010f8ECA31c65b448ff8B946D20": 126.85,
        "0x187C3c87D6791bC277943404531E11F4c14248d5": 126.48,
        "0xB11Fe701874bF43197702B53EbDb304b0A1BE053": 126.46,
        "0xDCc3689b3de254FefddA883E3bE1F8Fd8CD67130": 126.46,
        "0xBf7B3fD6835f8b5220A07bC8B38d5A5324a93e8C": 126.26,
        "0x49D86f7c3604BAE177111C05f8fd19d478f11c5D": 126.26,
        "0x9D6c04A9CfF0E167c347d14196997ab485f6F17d": 125.95,
        "0xE3acB4a504423df6Efc87C15aE441BC9bCBBA153": 125.95,
        "0xdde9aEf30339d2C5D02101E0a483E3D1891E1d69": 125.89,
        "0xbB8fda6138B90C68f7280b0051bAbC2cE5d3D038": 125.89,
        "0x4869A476D9fc7F191d0249851600b93B44AC9a1E": 125.45,
        "0xa9D406Ab943C0c0e9Fef9C9f771bE1a2B681b685": 125.45,
        "0x4CE69fd760AD0c07490178f9a47863Dc0358cCCD": 125.26,
        "0x0084592D91d29b0472Fb9B6370041c281a8f6262": 125.02,
        "0xC694e1FeDFeF49eF594EABB33a157bCC042f4c24": 124.99,
        "0x88a10d7995b96f28a1ecD7dDf1F2e2CbBe1E3786": 124.94,
        "0x288a2395f027F65684D836754bA43Afa20CA09e6": 124.94,
        "0xD9652B834ab5918b404902f0CA1452477603a2Cb": 124.94,
        "0x9EFa4729e12773a9185129cf3395833Db1185f32": 124.94,
        "0x319134Ee7Edc17b66acCE122b3c9718f9FA20a97": 124.88,
        "0x0c1a5B9d3f746cd60dba2D4506201416BCBD05Fa": 124.88,
        "0x3b2C9A92A448be45DcfF2c08A0D3Af4178Fc14D7": 124.44,
        "0xEcC0999CaB4Adceb01C6F1Bdb43B22313cEF3F8F": 124.44,
        "0x62ACd5987Ef06EB09B9b1529c2cD8b6CDd542d3f": 124.44,
        "0x97097c24BFAf1D3f3798bE7482d684f6Fe36930f": 124.44,
        "0x0436BFa5fe3653bDcF9053459B6f2e9ffc093306": 124.44,
        "0x7905087612a26adC05447A98FE21531Baa749e3c": 124.39,
        "0x02E7b714fae84e4BA80f3CDa5508553e7CF5042A": 124.26,
        "0x10E3F33cdC227948E5D4203f174f81c4995cE551": 124.26,
        "0xDb743c5132eB9ae11bF829014C82ce503bc621cB": 123.94,
        "0x3839AcF1ee7699D1F46b1BE840D8aD8317FDf757": 123.94,
        "0x79d31bFcA5Fda7A4F15b36763d2e44C99D811a6C": 123.94,
        "0xcEFde4F4BE712FA47a84eE90FBbb388064eFDb17": 123.65,
        "0x4232cc095D14C6a804A8235F3B48D9d66B732B0D": 123.43,
        "0x7075f6a33bfa27d0D592623EEBE228673F1C12f8": 123.3,
        "0x1d7aDb15d97547487D5adaaeB68B638CC6984D9E": 123.26,
        "0x68DA9f01a7de69436f40af6a412ecBcc7Eb87EAD": 122.93,
        "0x81D98c8fdA0410ee3e9D7586cB949cD19FA4cf38": 122.93,
        "0x0FAc4EFa9Fb13445Fe1dF54213602Db311688516": 122.93,
        "0xbE00FA424243C56c7CF5792aFBd6b8Dc4d6CBE4E": 122.93,
        "0x3Ad2Cd5D3760D745fA55A86AEED3f34161adE78f": 122.93,
        "0xB8e1f0f1E0AaB629eC07aE9e4FA680B58732c643": 122.93,
        "0x33296a3CB2607b5a1436E2444fCBaE2001D6e0b6": 122.93,
        "0x2f5Ab230e5B0564C0eecc93674a8B85B781A499F": 122.93,
        "0x11b53D1dAC74F1038A63e12651E5C4341Fc19d5f": 122.87,
        "0x8dBCE5563c2d86857a7d559453282F315f90bFb8": 122.43,
        "0x0Db0A917476085D9CCB7cB8D043D1d0500312cE2": 122.43,
        "0x9d7689a665B992Aa618BcFe585aF8C4607288c9b": 122.43,
        "0x23E5399E0A63026379433cF4cf36B1Fe507C5452": 122.43,
        "0x83d74D9f332C10033c4f2D72f6C0Ab2830Ee7032": 122.43,
        "0xBFea9b1EDA54EaDd9E0d06022882f23647Ac00Be": 122.25,
        "0x41c0F529F559c6A3ddc324Cd86A6D0c75b50c949": 122.25,
        "0x4fe603c604c40e34Cf96b4ef24E80C2BFa2Fd5C9": 122.25,
        "0x235f202679AB25F6bD6a230858005D96EAC3Dd57": 121.92,
        "0xE366619833126918F7fd3Bdf516002BdaDF1ae5f": 121.92,
        "0x02d4f28AEd9449E57081980e3c8151469B9Dd7C1": 121.92,
        "0x9Ae111Dd9D50367A9C384aF1e1994067Ff102B64": 121.92,
        "0x704890FfBE1aAc039a7a9cd3972997c2c55cB8Ed": 121.92,
        "0xA21A800138B3c95f8992cf5F14C736FC23Bd6045": 121.92,
        "0x6E874B85468d33EEe94EBc9297D20e7111c54Bef": 121.92,
        "0x4a82F3536b40E24737a68Dee8eb2a106834aE525": 121.92,
        "0x70414Da31DB1E3720ac28b4146a0C17e7a9539fa": 121.86,
        "0x047B9400F00917E105d7F0946bF6c162153bCA29": 121.74,
        "0x7F583ee1469D76B2Ae348697629B480d10d70714": 121.62,
        "0x942dED827CC5A0a8820b94b4a64b658dE7dCd0E5": 121.61,
        "0x92D0996E3F19D4b4A56754043F79e174c30Be515": 121.42,
        "0xB0600aF91A48011EFd1E41DcE3972e9707b85a3B": 121.42,
        "0xDF632eA5Ba8283488aAe8538e17a2F802243A61A": 121.42,
        "0x132B8752dAfb2bEa8604625082012756A451e53F": 121.42,
        "0xA844d0e4802B0e3A20e8801f3117D685D892fc25": 121.42,
        "0x9E1B7fA62606901c46038a5629a82544B24b07F6": 121.42,
        "0x839e0c17F60Da855651eFe729a9B21Ef693A5fD6": 121.25,
        "0x55E7b812523509803A4ff71C451d54848944fa18": 121.25,
        "0x216b3B33976641421B15d0260CA0160C993bDcdC": 121.05,
        "0xeC273f27a589cBf0b7c13406cCA1A64C0B5e2dAD": 120.91,
        "0xe93C39ac12dC5Af5Bc4f961E48fa5C6C42Be70A5": 120.91,
        "0x712255023Ec2eF444A56844a1A73914b054aa0c7": 120.91,
        "0x151DCEf15100C6399cC570B7E58B86c3a8F1b75D": 120.91,
        "0x1a6a03B245af2c8e0351738A2b84121395D1Fc54": 120.85,
        "0x6c7b8F499A3a0C310e4A1c9EdB8406E764590950": 120.85,
        "0x2D656A133e3F075a1d1E2C9b759BCf651fB2414A": 120.85,
        "0xEdAc1779d89eD877c99637861E89945CA7226C4F": 120.41,
        "0xdCd2cdf5360f78a8a88D285972db84f96695037d": 120.41,
        "0x786504696489E2B4755791d7585DbD620b2459F8": 120.41,
        "0xC13cad139d0a54Bb496cb05BE126fcBFf785AEae": 120.41,
        "0x5D643f55b82E89F394C4A688eD6B91Eb1D88e931": 120.41,
        "0x32a59b87352e980dD6aB1bAF462696D28e63525D": 120.41,
        "0x22Ba6A56DF5CD632A44c51AA6F0a503A5dAB03fa": 120.25,
        "0x866F98E4d2B0742110cd674214767140477BB342": 119.91,
        "0xd1BB2B2871730BC8EF4D86764148C8975b22ce1E": 119.91,
        "0x58603461149Fc2A800a56d421e77DcbBA2D83CA8": 119.91,
        "0x0a9faAfb19e4df3A23EBEf4cFA01FBBe2a137C78": 119.91,
        "0xD0E53ef59818a74C4A82A8c7e927f3Eb61a63322": 119.91,
        "0x10Ec2a492fc64BD5E2c0b0f663bcF3D8d128Af7F": 119.91,
        "0x11E8434F0288Cf11aEd1424907377951f8913979": 119.84,
        "0x79dDE984E259a196dE3Ee4bF6E06254e02BC83bb": 119.84,
        "0xDd1e190A5Ba48C56eC98a051F27F5FdB5B99A7B0": 119.84,
        "0x6d6eE330E22C239fC699e61C55251110b15b943C": 119.4,
        "0x27d748FE544416459D7dF51Ed4616da6a09EB590": 119.4,
        "0x05204E317D25eb172115546297b056965bE2C74d": 119.25,
        "0x707FC761d76b4fa1eD1300b6aF98c734Fa5A9e0C": 119.25,
        "0x473bbC06D7fdB7713D1ED334F8D8096CaD6eC3f3": 119.25,
        "0x3ca4bc7F14bd114364Bf2089B4A6C136E7A31edD": 119.25,
        "0x8FA5cEE4788957F3bCFc24652094E8D569F5D6B1": 118.9,
        "0xbfE8838dE25Ad36D106fD600F24471BaF31e3FF3": 118.9,
        "0x926eB5E50cb34E9836e7d93C645768CFB1e2B1Ce": 118.9,
        "0x5f219a363F1cE98607e08659a1EF51ed9C7b2958": 118.9,
        "0x06946365eA2D99A34B84ed2286aec084FEA6f4cf": 118.9,
        "0xa2891fdB4e67f3410fC6BdF60e221E04A3252840": 118.9,
        "0x6462C30Cf4C66A2887E3F60C4CF4ac6A474AA50A": 118.9,
        "0x130A53022792a73068c50e485f58188596149621": 118.9,
        "0x648F0F5Aea620C9cA90d27e2948DC7BAA4DE0562": 118.9,
        "0x12D9bc5C41AeB094648B735891D6F9bdB17eCc25": 118.9,
        "0x49b0E955C9e373df77a7F42c6e58241D566A0bF9": 118.9,
        "0xCb972ac465a580391f8dcf455104FE3ace115f59": 118.9,
        "0x6a8F293d3292Daf0b46C6ed1F666f6bD04ABFab7": 118.9,
        "0x7Fc8d585D2c96C0aC15D3a8866e7682fD1AbbC68": 118.9,
        "0x48d11A3c2C139429a79DCd02bCD4C048877764E2": 118.9,
        "0x398a79F345Dcd25E900f63E7e998a95750ed9F42": 118.9,
        "0xC944aC8D25d7313490a15F405BcA53da469b28f4": 118.9,
        "0x7e244264c2606151cd1251Bf6DE48d657BcA68d1": 118.9,
        "0x4F234BB5bf0FABf58422b21F870afd65517d4e20": 118.9,
        "0x5c41e33244439d7E6012b0cFD2930dc1BCc12f49": 118.9,
        "0xAC6cbA6eeDdD9bc5aeB0aece0b75954f89cD76E3": 118.9,
        "0x61Bff993D2d8428B1AaBe9e6107dB87642680022": 118.84,
        "0x3Bc29Ca7ff3BB9a205A766D31C1CDd6917202734": 118.4,
        "0x6115C8547521B10460B804958eF6457588b17A86": 118.4,
        "0xA91531E2b92265d071D60BbDc369612999b4DC2A": 118.4,
        "0x98B642Cb6E40538474Be7f7846Ce840f14b7dE64": 118.4,
        "0x050F9023ede1172C2Aa2ff6ebE3226ED6bd12C61": 118.4,
        "0xb873BCF80afA89c2A9e5182f5792d64a03Eb4311": 118.28,
        "0x80fd0accC8Da81b0852d2Dca17b5DDab68f22253": 118.25,
        "0xcd631c6d4905779580646198175F9031df8CCd96": 118.25,
        "0xD471AeC6c713379f0b928FA8cb80b9761Cd9708d": 118.25,
        "0xE6156d93fbA1F2387fCe5f50f1BB45eF51ed5f2b": 117.89,
        "0xB8931D2dBF3c1339371dC4045284aa92AcF0e237": 117.89,
        "0x42773BE0C112fB311D08C8c0783BBfa6540d6A6c": 117.89,
        "0xBfBcAadE099Cf80FBae44d5D7b3a7af79e3038Fe": 117.89,
        "0x13C31d43bb05EC526FC41440b17A06872882e172": 117.89,
        "0x2f33F5dE63e8B0C6A539E5c51C334ce51a96f9F9": 117.89,
        "0xc51628D198210424248A5A32000083C2D9e84973": 117.89,
        "0x55F6986569C9BaE8263D98a33770fC196e72952d": 117.89,
        "0xcc749D05e9D6CC7D978c533F964ab785742a65D5": 117.89,
        "0xE749546455Cf694D0b3B96d52c473a107FE8c49B": 117.83,
        "0x0b7C75A9689A84854256c7d5dB7C87fEB1bbbb8b": 117.83,
        "0x226Db4bBa32eEE42B295912bE6bcACAD0Ff8387E": 117.39,
        "0xacecAc0129B7ffbC5879e7175C5D46227c4a8C37": 117.39,
        "0xfe7b25A93f38995A140d064f9cAA433F20103339": 117.39,
        "0xaE69116E4AA49645f78C1Fc9f28F677aeDE0d153": 117.39,
        "0x730223bc79E1159422906f17fd496a9dF2a37561": 117.39,
        "0xFE3A593fB8a90185A8E31eDC8eb02E7d889D52f0": 117.39,
        "0x9e136c1c6D31504F6b0aF8cba2CD3f1ea77B2E2B": 117.39,
        "0x0857217c55997F7D3eeC36140BDAe7ce6140f8C4": 117.39,
        "0x72f030d92ed78ED005E12f51D47F750ac72C3ce9": 117.24,
        "0x5A34F25040ba6E12daeA0512D4D2a0043ECc9292": 117.24,
        "0x2d12187F1a9aafCfa496f05998495c7Be29a1398": 117.24,
        "0xEe1fba33ACbDbbf52e7DD2B30e198a231DB0d155": 116.88,
        "0xAF8775e253753df6F9913054A6aA5348f4ac3DF9": 116.88,
        "0x4cC80aD41c7F9797BfB166F26AAdC694C217Bb9C": 116.88,
        "0x62D75ab0db98289eFF25bbB98c776AaCc92bd9d1": 116.88,
        "0x138A87c80d1659AEe5e729221cA4872F51B2937d": 116.88,
        "0x6cC76d20646aF5e6944BC6bfE60d21EA3Fee63a5": 116.88,
        "0x8a702Ec3948Fc97313D47F2A95dC516A30f93f81": 116.88,
        "0x04c872122Ec2553B2D8aDCc6C7eAC4bec7717Ccf": 116.88,
        "0x6f5C19c5093f5570f9C368ECF781f88A9E26Cfe1": 116.38,
        "0xC316eDF89dcC0fbEdf33e9D479d271eeb8b90852": 116.38,
        "0xF5879e290eF1B780A84Dd9E2A0CdEa5ed1c1c41e": 116.38,
        "0x76d4e3677a98D7EDCe96D496F1aEb421fE1904E2": 116.27,
        "0x0095De71519335E73cb4ADc18126313e4d339980": 116.24,
        "0x25c7160789D8D16212Bbd092B65133624ca826d9": 116.05,
        "0xec6E544D6605b78D24afD71Cf6604Cc8d2430170": 116.05,
        "0xAdffC760EDF4f6146dce89022B5AE7EbB7edD2B9": 115.88,
        "0x1D1F91CBd0F5988D3E87E7ab3d4E0B64c8af4D4a": 115.88,
        "0x44c271e4Ac3ebB14B446d157FeDBa315c45E4e1a": 115.88,
        "0x605959Ed62f5C80b9F9D964f835827dB6adb15DA": 115.88,
        "0xf56036f6a5D9b9991c209DcbC9C40b2C1cD46540": 115.88,
        "0xB393F2fa4C9df2dA3E54D169d0561D9E5979DfF1": 115.88,
        "0xaC9c065B1A84A486628fd20efc9426E435bA7Cc2": 115.88,
        "0xE2DcEAe30b9ea109a634fF6695688Fa389F39a1a": 115.82,
        "0x9172B82bFf8011c96711AA464E2a7D4659b0E4e3": 115.37,
        "0x9e13e43B1648B890D3D958fdA96ECBE8708207fd": 115.37,
        "0xAF5692dDdB62Bb679f94923407d61b124cc73025": 115.37,
        "0x67397BC3c350a038351dDf2a00D1c6d549930323": 115.37,
        "0xFec55b9007857fBdAecd8bFcDcEe524637A92288": 115.37,
        "0xE6eA861295af4e0d0D7F331c7B950f7DA3A9D265": 115.37,
        "0xE6d178cFe2B5B8Be0Bd6D124CBF04304C4d0DA45": 115.24,
        "0xA5b5B85f0C5209998Be7aa72e17f0Ae289bc71bA": 115.24,
        "0x9dD3045BA0dfd6136e0ce38fC322De3557279178": 115.24,
        "0x079d0f3cA5CEaB777292346d9110441EeaD3d182": 115.24,
        "0x6303E91ba946A0A1B854FC4acB2399ee8ac3326f": 114.93,
        "0x3Ee5a77E6d176f42eaF653D9f49FCb8aDabbb6fc": 114.87,
        "0x9Bc86996822381b9dC51D367A6bF088d397d9F68": 114.87,
        "0x2A9b6f644B4632F4055129Ae062ac6bF4A739795": 114.87,
        "0x934C44B813Dc4c9CA08D5FD0D5190447dCadeb51": 114.87,
        "0x2F9035F14D9134bEd45e2642Ae148f673f5eCB7e": 114.87,
        "0x3Ec6732676dB7996c1b34E64b0503F941025Cb63": 114.87,
        "0x28E58e752af7d3fEdeA40CdC025cFB2089c2A592": 114.87,
        "0xd4f537901080542BAF88a54FE899fc004A42Cb50": 114.87,
        "0x4A23BccF39A5Ca0E3cFDd67d74cBA3f380ecA38f": 114.87,
        "0xdD7F6064ae68A323fa3aa4Ec506700D0097Ced2d": 114.81,
        "0x106153B853DeDDF4A1C69d4595B31CB64D1f77Cf": 114.36,
        "0x4E2b5d23Efd816a4f057E28e9cBF75387bd3F828": 114.36,
        "0x67EE60a40088a61351Fe5c37a522aC59973961D1": 114.36,
        "0xA264D3CBa51525f5D4902F7b3794a3c26Fc13Cf8": 114.36,
        "0x27CeF68437CB19a87ecE341985691EC8e1EE0937": 114.36,
        "0x86688C0E166750Fc716a36c18cC3662d70c74873": 114.24,
        "0xfF01EBdE5532f399418C8c43fE76253946861a56": 114.24,
        "0x073e069FB2D6F17dFB9FAf08d222AB6A9e398ac7": 113.86,
        "0x6a7dC166975E25098fE30C26242517d9Dba1F771": 113.86,
        "0xdF5985d9f5bd8fff50465AB9FD1904f6747F1D84": 113.86,
        "0xe1afEe02124B44394f6b8c7950fC7f9A38DC9Ce4": 113.86,
        "0xEEd7e1c7c9c68611584e8f6230178Ce0A48Eef7F": 113.86,
        "0x7A58FF245480964B989a78af1FACFFFFFCeAFE82": 113.86,
        "0x61f12Ea36c822a30Eef51941368AD8F54CF372a0": 113.86,
        "0x62CFCd9B95c0Fa404bCD14d6163BC6d84003904c": 113.86,
        "0xB77720dA0d7b6Cd67aDa573F3aCEc25B89B889B4": 113.86,
        "0x7D9f4A3ab2568F61C9087A8b5506DFcD5E8fea49": 113.86,
        "0x9462A60E1608587c4ba9A81A3d58d25551773143": 113.86,
        "0x61F195709B1C1CD41525738d1872a68829ba6977": 113.8,
        "0xfc466aa39b5Afd9e65604d0d916B8e6b23C38b2c": 113.8,
        "0x2e603149143338b5B4DB33ca4F175ef7BC325048": 113.8,
        "0x41594e4fe555c8084a1117CdE8dd4554ed4E2dBb": 113.8,
        "0xE4c2D15df0c02c932d19d1D178E242aa23951e2e": 113.8,
        "0x23CA480459778bb1D10B93bCf706ACf046350b35": 113.36,
        "0x7AAEE144a14Ec3ba0E468C9Dcf4a89Fdb62C5AA6": 113.36,
        "0x2eac22179b82eBC63c94a47A321C7d1C5d4c785C": 113.36,
        "0xd692a8b22ADEE210234a7fb00510E300411a8B93": 113.36,
        "0x6C478CeB0C323eacbbaC0Bc3Aca176D1C7c7e9A4": 113.36,
        "0xE326FE653Ed62b38ACeA220CdE1820a98e23c213": 113.36,
        "0xCc3fd391414BF8F902726d465D2286ffDFF91794": 113.36,
        "0xb05A2cD71019721D67cFEE3CD85aE5A80E3c8ecB": 113.24,
        "0x4F60Dc21a22207BA1eb21572759851cb3729B5e1": 113.14,
        "0x069c24B8F91aBAD5aC634248B3C6739C31DF900c": 113.04,
        "0x47e92b5BAcc39Ad01d24BAc3C25309e4ee293c5E": 112.87,
        "0xBad58e133138549936D2576ebC33251bE841d3e9": 112.85,
        "0xDF90BC63d773E674E0cE2488dBF173cDC3622796": 112.85,
        "0x82c686a5809EB940BcF8c9BF623c3D3122c4216F": 112.85,
        "0x5Dd39A3fc1c33e4411438E79Bf86d4fAb4f6932f": 112.85,
        "0x44C1072F3225351698630B27bEF8141d206d12ec": 112.85,
        "0x3bf4Eb1397996Ed2067bD888D7db61C7c0185B7D": 112.85,
        "0x001Ab34712dc2C6b5e17400fB91182e98d6EbfA9": 112.85,
        "0xf55890702aD081A7F7066E2ea9A9D9385425BdF0": 112.85,
        "0x184A0aA66Bf35aBca7383A81Ff3D4EA5D0eF8990": 112.85,
        "0x03D30f8b423792DCfB47dE6140CBD3F475CC99Cb": 112.35,
        "0x9f88CE4eB5fbbDca7d911Fa75c6f8fBd95D2BBbc": 112.35,
        "0xfCC06F7F02f6ab02051F259Db4f82F20d8d02112": 112.35,
        "0x9ff04a696efb92915De317DF30114B4F55202dc0": 112.35,
        "0x26ab154C70AEC017d78E6241da76949c37b171e2": 112.35,
        "0x2446f1a75162F045d02F23D1D3b0F5A2C0f9A4cB": 112.35,
        "0xCE64fCB545cabd91b58C3ffC35042c855f2D33fb": 112.35,
        "0xfC4B2a62A06cb2E1C6A743E9aE327Bb16977E4c1": 112.35,
        "0x480610cB9762362B28de7fFb3A9Eb427e423eCB8": 112.02,
        "0x10B2c6489De6Bc0ce1034C24F52826E7489219B7": 111.85,
        "0xD8992543ef65Dc04bA8e71be895435BEe3aB796F": 111.85,
        "0x47C465E7Beac169081371969C0FcF62D10c84Ef7": 111.85,
        "0xb436141073EFE6C21aC6BE9A5Bb0D1D74F0ce87C": 111.85,
        "0x390cb9fe9Fd93a851A30937D248be701471d7FD1": 111.85,
        "0x8b5A81dE615B267De6aB5E2B1F3f93a6228eC9a2": 111.85,
        "0xB8563e99cc1B97f0DA2Db5c479eE27eEf3987630": 111.34,
        "0xb39AB1018043a64359c765c5a18a8E54E3888975": 111.34,
        "0xE02fD9Dd91786369B94274b3E7613562a5ae9B5f": 111.34,
        "0x49D62Db57076eD009Dbe4325F9ECDcb10381198f": 111.23,
        "0xC64811361df0c2bF0EcAf3D0B66e385Ca5E042F1": 111.23,
        "0x02FBc4c28b4C9f806D0aA3636708962755cb258c": 111.23,
        "0x795982e40bEb1eA8A186C94d4AC01dE7b19dA7d5": 111.04,
        "0x274949b0dB377742A46074f75749E953A8da45A7": 111.04,
        "0x512Aa7c329851e985924016D343ca6cb3D085A50": 110.84,
        "0x8E33F8940D988647EAb344aF105A0E23157624f0": 110.84,
        "0xebD65d1b26f715fc87CAF1c12f0CAd36cE44fdf5": 110.84,
        "0x35fFC49E7FEFC188dFf81dB3c717dB098294BC23": 110.84,
        "0x7c8787ec009E8A4f234C5feB055A8557cF0305b4": 110.84,
        "0x20c0c2c9B00Eeb2513225cE2Df83AF0DBA9b4A81": 110.84,
        "0xf211Bae65556CA6d8577419775781f39c9Dd884d": 110.84,
        "0x9b75157C8458245b210987a2229250bd05484651": 110.78,
        "0x2736459C5550777DA08027a5C298434B2Fd590Df": 110.56,
        "0x875A6dC230931eBD99542a89f76837d861d2C2F7": 110.33,
        "0xC44fd65765199B4bc0a6A03943423819B15293C3": 110.33,
        "0x4e3B1ddE3ee925372497C1cE725CCfCFA3d8d382": 110.33,
        "0x11B1785D9Ac81480c03210e89F1508c8c115888E": 110.33,
        "0x48Ec3c44A772aDFF8BCc81151d1A1e6172170B9C": 110.33,
        "0xC5924856AE09bDCfFeE456eF9FCD5f8e35046E43": 110.33,
        "0xa3b926f6d2bB5507fE711847640bA2086CB11A75": 110.33,
        "0x91544E0d0ee6361152f06891b52E778B3614d253": 110.33,
        "0x7F8374961620A370c47EEdB599076320D5C82C9b": 110.33,
        "0xC877D91a16a5fb483dD96a4a00Ede9B240374a25": 110.33,
        "0xf1944bDECa564C4C75511f520E261ABC64055Fe9": 110.33,
        "0x581Fa7596d81ecCC231d30735d239A801f13DadD": 110.23,
        "0x36C392836190FA5B21C1402E9983ABf760a3F2CD": 110.23,
        "0xB99BAbFBc8Ed0e58E0200F4708cc0CF41e31D6D6": 110.04,
        "0xaDeAE270a55629b6aC9Ad6240F4f3154b587dD13": 109.95,
        "0x0a11acDd1fFBDb8ADfc34a84f1836F360e6f3CCE": 109.83,
        "0xE012D8eCfF24057e3A47C93F44Ff6Eb9d1ba2f4f": 109.83,
        "0x0cB5F0af4e0D5103E1B2126Bcd787ce405D12EbB": 109.83,
        "0xF9Ab04B9e99673cF71bD2C41Cf79a4cb5e807B2d": 109.83,
        "0xe72A579EffB01fB35Fc995cB96F752e250F2B4DF": 109.83,
        "0x0A5d2190aFc397B91c2de36d128b03B275A3a255": 109.83,
        "0x81C12ffF4dF0aFe91d61ed3B768890D94b5C048F": 109.83,
        "0x6FF0887931fB338070E67B4245EeCe0De5819d66": 109.83,
        "0x11e1dCf0c0F0F7464F1A8Eb69D6376B9a5ed6873": 109.69,
        "0xfD8bD978f198503a0BA9C5D7f7586E23fC4A4b40": 109.33,
        "0x1dE8355dA82CFB8D2453A5EC3FC4C871281ab4Bc": 109.33,
        "0xBA77e0B03b41a980BB4e7BB32ec7A2dFe1B66f8f": 109.33,
        "0x7ea2D94c0bb347014db4c08E70fAC5F67793fFe0": 109.33,
        "0x43e403ab4d1F9d0D6E61c44E9c389C6c5E7a8e29": 109.33,
        "0x55E8eFD13bf9d4d55DF0f3Bd6Cf7Ec834A1C7028": 109.33,
        "0x115907de34Da3D03a7CA8410b7B16fafeCa9c966": 109.33,
        "0xe64E3f4824bD2e2bf563404a42209f5deA69Dd61": 109.33,
        "0x7b01f107dfc44E0ad760c0c6f0D4c7383b8044A4": 109.27,
        "0x0E360309966BC76f39be1023DA1DF86045C53E7c": 109.23,
        "0x78bCcd5d99C37c74E5b820a3a1627aaEE7871567": 109.23,
        "0x64030Cf7FFb93a5a9eF9AB863ce40603dEB2d671": 109.18,
        "0x474Aaf9C26E83B244708356f972Fe73FcB5A6382": 108.86,
        "0x3a08ca9E3A394c7b947b9CA56493E38176F3428c": 108.82,
        "0x4b3764ab10Efe2747c4F0e36BB442867aBd3f9e6": 108.82,
        "0xB21731D830b7e8460E5D6c66Dc1CcC0A5D0A6B87": 108.82,
        "0x980B32A10d21105a925deC09f42f92dDFe0fe6fa": 108.82,
        "0x8851d8834F0593602d20c53bADc267b599C80754": 108.82,
        "0xD6c23E2c0E19DFdF8638b076F1d076f7B29b74e1": 108.82,
        "0xd1D56e4ec7B6fBBA2AA00E62DF188b971bf0152b": 108.82,
        "0xf0B84d97327b4a27D7FF1eF03fe9Bb37E554628d": 108.82,
        "0x7AB95968f781edc714231eDcBC1542dC0bEe944f": 108.82,
        "0x249fF70dDc9FC626D1188E4Ad4E6387e7D97cbb2": 108.82,
        "0x348541EB9604d28ad14274A397e9396F7Ba955bC": 108.82,
        "0x7B5635e98844f6f47619A5582fa3531a0D263C38": 108.77,
        "0xc5672F89AD95570e466f5ED0681A229DDDfd2C4e": 108.77,
        "0x9b7F72dD8fb89b3dD5ac8eCF70193D75CEBA9bE0": 108.32,
        "0x1BBB1AB33f6f859A936dB5af961d6E6b5346DEC0": 108.32,
        "0x3996c69288e1464C8D23823Ddb7e72743021154c": 108.32,
        "0xE7d18AD3Cb0c5C3FAaC0bB8275D306E1A46564b3": 108.32,
        "0x2aA5D321F8629d0692eA51bb7F66E8A42EE6203A": 108.32,
        "0xF41aB7f2a16068C4a850c32b8B4687214B2c26f6": 108.32,
        "0x5cD842fd9bfad081D77601b3B55DC38b01B27b4a": 108.32,
        "0x9755e3d858a3310e9915e490104435ed4f0D7547": 108.32,
        "0xcCc773E8F7E32D8Bb9d65a4ccE0F11D0443dD5c6": 108.32,
        "0x5a6F4E306A2198ca88CB1f3fDe3E75f2F9805D1d": 108.32,
        "0xC693B4FFB338579467a541b2bF267B1955870920": 108.32,
        "0x99991db4949Efe77F1d87eD6Bd4BFCd4A97c8C4C": 108.23,
        "0xdc9d785adf9153eCFc20924d9954370E96949Df5": 108.23,
        "0x872D24a78F9343D95fFbD602D3bEe5EC9773E9Ff": 107.82,
        "0x00a01bC13a1DdF4a4Af6852baeE66b76A0316CBc": 107.82,
        "0x1D3f5C7aE35e4a60178dB468996DE6E5CeF37752": 107.82,
        "0x5ca32F4E8617Aa4eA66e404d100a9b9D9b6e10E6": 107.82,
        "0x3af395f085Ac04Dc4Fc26C247D6B8Bf11b282B8A": 107.82,
        "0x4f329abd38bebF831652b31a3FF35fc9A9Eaf97A": 107.82,
        "0xA6E0F9C75Aa9C6D4193E937d880cDEA9F6da3B39": 107.82,
        "0xad5A1aB3f6d2FDb99cAA6dA208E3BFC8cA2f3C0e": 107.76,
        "0xFdf45e7D16bdb5DF94AC2F1ef36C34984787b0F9": 107.31,
        "0x6F69F79cEA418024b9E0acfD18bD8DE26f9BBE39": 107.31,
        "0x4C4baa9907F23c1C51ffF261B518e704Ce1d491d": 107.31,
        "0x0D280E4b6511E626b4C3e557de9F35E8B0e61dd0": 107.31,
        "0xF0E1A6DF0Da6841ba53b5317d1ffc2c4da9815c7": 107.22,
        "0x1580c51BDcbe1801249eF1CA8D76AfcE8d04c61a": 107.22,
        "0xF00dfFCC8694a6f6aA3491d79c8fef90889A81a7": 107.22,
        "0x21D3E328e7209149A5352666bEc8000C385a9248": 106.81,
        "0xF0C4992cc952057524Bce4C05F36F9D562C85C85": 106.81,
        "0x4b26b230c8492F1ec73564CDd7F771C69d279827": 106.81,
        "0xD8121b41561Cb55132561927A30cB340baAD62D3": 106.81,
        "0x099500598f7b16cAdC124775bdd36Db354eDE1b7": 106.81,
        "0xBA91ae8eF39E2027E798F013aEbc2Ebd98a2Af7F": 106.81,
        "0x8844657af9b631cefd5686B514B00d8A6f332189": 106.81,
        "0x8B724CD0A211f23e83a66794062a000966ED2107": 106.81,
        "0x199E1c94041A8B1C4F6095E35C072211f2b4E98a": 106.81,
        "0x95aa6CF80aa61c3433215c7b8330C065eD29CE97": 106.81,
        "0x96afDd4A636f809b36EA446af7fBCc44fbc9D7a3": 106.81,
        "0x3E3A39695a3f45B146FB955c8ed276e543Fe5e04": 106.75,
        "0x4c96e5E5e0a1be4Ae544790a81D2C169846aaE38": 106.75,
        "0x9C3A5131D6a5052D24a516c671B86d9CF9a95C40": 106.75,
        "0x0d423E7877c579A4bDe7C70c4BBAa49FBC69720E": 106.75,
        "0x29E866A8471DA4f89b4AFF3FD41c801d8027058b": 106.75,
        "0x3177BDcb49b717864A2fD9b26dF27C82471519C9": 106.3,
        "0x63D8e0f850a956E3b358Dd1555FC05558eFB103F": 106.3,
        "0xa341c5B993e0dbF832994Bbe9306618fe1E53bB1": 106.3,
        "0xd48A31241e56Fa8B68e4b97A0a7e4879F76F86c8": 106.3,
        "0xe794ca09e80DfEd3CAC9ca02E52E7594D0A576A2": 106.3,
        "0xB010f98395e72819d391818dA9D54A26D985F402": 106.3,
        "0x0b1EED87260147822cd941CA1EC73DA55dEC49ac": 106.3,
        "0xAc815ca5Bc8eF95D08893600ae8ab979B48911b9": 106.3,
        "0x44AD3ab3770FE6Cf15c8DC64141Bc79fc1A94d72": 106.22,
        "0x4A4a9423BdBF211a0ddfD41A8CDe7d084a2Ff1eE": 106.04,
        "0x72fc2F0cCEeC498eE01AB302B62CB6f78ac36BEe": 105.8,
        "0x85c2A89987B4B469B3dACE0d905063b069701E07": 105.8,
        "0x69FA137938A050A105C99fcd5824C2591b837c5c": 105.8,
        "0xaef1889D58677805399C6F8326c11D159B09cAF2": 105.8,
        "0xd12D05ba5bf8983e8c41071A32422c3c2d309669": 105.8,
        "0xc4f2980B4826881F2cb9CFB05b60c0Ab1B62061C": 105.8,
        "0x98076110c0D195B468d5776Ad89004C5864Ffc6d": 105.8,
        "0x396a6D7a33655c45044143CB8A812227bf279578": 105.75,
        "0xE185889d284a987773FDc1db2566a68719398599": 105.75,
        "0x0E79192f49271C08eE5e041d8f132Bef95B4AB3e": 105.75,
        "0x793Cf10f2542Ad8A98b5951F632BF8526Bc2aC63": 105.3,
        "0xd2e44E40B5FB960A8A74dD7B9D6b7f14B805b50d": 9684.768276155008,
        "0xfDC46fBDd8AF50d9Bf7536Bf44ce8560E423352c": 105.3,
        "0xBF08026d7b20D1d7013fC1B094090e756cC2E468": 105.3,
        "0x1F0CD8d7366737aD6f23c9eF2d1DD6e2c74F1Eb0": 105.3,
        "0xAe587494e10B07Ff3AF2CeAEB6127bD043c2b901": 105.3,
        "0xCC0D97A3A651B585D09E434E39974Be07b43686c": 105.3,
        "0x6AdAbC8287a814b21A67E2b5811Ed19Ae708872f": 105.3,
        "0xA599b538C8D8cc9E2b4aB57d71F19644cc8A2023": 105.3,
        "0x815bE786d0D761D943D6956bfB3CBFc535523cBd": 105.3,
        "0x6AfffA3f4cf79a1938461F6eefd3fB99929AbEEe": 105.22,
        "0x2CffFaee925a4Bb7274C15EB484E803244a9c622": 105.04,
        "0xb073424F158295E39951cd9557c9bf45A3f03f94": 105.02,
        "0xed7646046603F5F661d789964ea86233Dce0E297": 104.79,
        "0xA8Eab2E9F100040a66FBF0f6c0CBEa490a8E551D": 104.79,
        "0x0783286Db649A3393Ef68Ed008BD65533c8e99c2": 104.79,
        "0xd8fAbC4E16a744697cA03CACf9aCaa16f7E5d93F": 104.79,
        "0xBD5E289f454e639CE2c3D56Cc252f400F8031Ff0": 104.79,
        "0xB5eCa0A315609bf3831056BFcd42dB2363cb4466": 104.79,
        "0x06040158f9DD01fB6CC71Ad99EC854C1a5A69ee9": 104.79,
        "0x71D87aabB42de94a7214976a05134935F73e64aa": 104.79,
        "0x82a2BE1C3Fb85D0A83171D01706FdB468178ce51": 104.29,
        "0xdE848f5949206a9e66e1800e2C5a69D2601FbC22": 104.29,
        "0x5B2ddDf2a4772D9C27c9B3099c371c3e7ba7b4A7": 104.29,
        "0xb3595935B3852d7eD8499c639d484c964FeF0826": 104.29,
        "0xbAec59D8eA6DdBE5C1eAfB2094Edc7FAD90C64eC": 104.04,
        "0x3b51A681aFBC71342bFc2bf98ed0BdF7D04CeF55": 104.04,
        "0xEAB900B78496eC846f9c5125a72Ee5393D57d146": 103.78,
        "0x714A8521db3Eee3F5f7D4d2Dc0a33d91F0AEd3dc": 103.78,
        "0x1dE32E155bc1a74E0Aee4F358724a086D3A3a738": 103.78,
        "0xA1CB4468F529f51296180d148f4764ADDE8563A3": 103.78,
        "0x5b5435e35f588552CCbB1F9212F6941c4C44dD71": 103.78,
        "0xf22B3e9FDfac016Fa197C2326c84657ba4f78f78": 103.78,
        "0xcbfc78d7e26C2FF131867ed74FA65572dAd6FC90": 103.78,
        "0x931b2eAC9df30DF850DD3048E52087C4e82CDFA5": 103.78,
        "0x70ACb6C9345edFb47b7563224722Cc762d217c51": 103.73,
        "0xe9D53A10ee7dAF5e60a628396F65C437dd4B2f09": 103.6,
        "0xfEc17f5Df51bAfBB9FdDF25942DbEa0daBfB711F": 103.28,
        "0x17d0bdD31C6B1Ff185B98509D3eCf21f045d9b3B": 103.28,
        "0x3F0d4C1FfBb554f4226944be3880697204C0E83d": 103.28,
        "0xC9eD7c5aE4B31dece1B8e5F224023E9583d63863": 103.28,
        "0x50258A2aE0b3065754936828Cd7814731C6fC008": 103.28,
        "0x8bcF9320497028119Da1c99525d19A9f0d86f92a": 103.28,
        "0x1426FBd146942e153653863cbe633780c17268DA": 103.28,
        "0x1d884c7d4132Bb1D75BfD228cE9447D82527a217": 103.28,
        "0x53e1ec8D078998bE6838ACd58DDA93F3c555f807": 103.28,
        "0x373dA292C38965458054a19969C95cbccd4bE642": 103.21,
        "0x9b2581a9EeCe06Aa1D1ed5DB211DC33776366Ec0": 103.21,
        "0xeB32dab5d38FF953Cc323ACe8Efbdf4F897f1b1F": 103.21,
        "0xDD004cea426f627a85eD1A6822650ef97a2E5AD4": 103.21,
        "0x57426DEFE97558B6C240D22c07438370Be103d67": 103.04,
        "0x07Ad58e91F409Db6351a3b0c779a7740E234b11E": 103.04,
        "0x071f1f094b862b43B9169eB7505415dc74D95ecC": 103.04,
        "0x1A5A04171dC7143aFe49870fCDa9c875E5F86F38": 103,
        "0x1091fB53079f123e823859919E9f7Be919b754e9": 102.78,
        "0xE53f8Cc868dC2e0fb1Da5BD1b5E6404600A6DE22": 102.78,
        "0xb0FEAc4F419F388F6441F2A8081DcA6C5635434a": 102.78,
        "0x952cF3902991E25cE0A1e1fc52181C1D739859dd": 102.78,
        "0x30818B058547C8c4ADe180Bf08bB01Aa2fed1Dfd": 102.78,
        "0x20a7D9C6fE927266723cc94eE69A17601bC9E6Da": 102.78,
        "0x40Ef3Ef4225E7c69188B8825F26c84983A468E7c": 102.72,
        "0x7D936BA6DF17e24CB90e595379Bc652477568da4": 102.72,
        "0x6860D457124613765a81a57a5853F467aBf2D8fd": 102.72,
        "0x6C383dd7D2418960211AE76ae7BeeE34AbD372Aa": 102.27,
        "0x39Cc43B3068A208AE87042F927Fb53b85586C654": 102.27,
        "0x1aa4a66Ef0cfA99cA9D39FdAD2B05489744C972a": 102.27,
        "0x952c23f8F067A5e7e165ff0E42491f51D87DBc95": 102.27,
        "0x5D2e73DD5A395384961d60982A64CEa4Aea2dcFE": 102.27,
        "0xe98f0B95292c2c7A3CEe33E091Cc953F0F1C3CBE": 102.27,
        "0x6Ac5755992F781674853E49c6846bEbB89AfCBC7": 102.27,
        "0x1dB30C74a4d16cDFEe29680CA4637EC12aC55EC7": 102.21,
        "0xEe74DCd8F7D13b2502998B35303010f379a594D1": 102.21,
        "0xBDC06FFC7e872fCA46a796f7B2c91f20bF820FF9": 102.21,
        "0x777df6E51A4D666135061d45cC68acbbBf1f1aC9": 102.04,
        "0x00A1d0d9c04f1F991D04AA2800E560D489d13cD2": 101.99,
        "0x20a05ae8efE1EB91BE0CD07356BC20EdA9C2E298": 101.77,
        "0xC7Cd234A7Da1aE9a0F4f9acb85e5cFFeF196189c": 101.77,
        "0x43d25e039eF5eB86887dF3dc60e260737dE62b53": 101.77,
        "0x96A1e88dc09887de698b9B4BC722AB505D2BE452": 101.77,
        "0xFaA31A7c7715985138D4fB196E6400b65697DF4C": 101.77,
        "0xdBF01A7705451170e1191D354EE9Eb84245F4861": 101.77,
        "0x2D6B114c77F3355F204c37F657c680157e85dFA5": 101.77,
        "0xbFFc3A1E97Ae5B1610BF4cBb87540E3Aa774db02": 101.77,
        "0xa3271E536593B26A4bED801145c7e6cD4b291419": 101.72,
        "0x874B5d34620E9C52EF58f51E2Baa572B037c7723": 101.72,
        "0xD0d2456ea63C65A4D7F1150DC30098C41e80ff93": 101.58,
        "0xD55Fd2610f7a3fD1a9a1e2B23909689Cb85D1561": 101.27,
        "0x2292B2b53fA976b2d68159fAA97987606AAf1F38": 101.27,
        "0xd455712e43582134F101a0C686d26548B5438A3b": 101.27,
        "0x28177B138fdeC353c1DA1858798c52AC0bE0A0a8": 101.27,
        "0xCFA9e1FB594872526ffD388E00A7eD226Ab026B8": 101.21,
        "0x08820eBaD58Ff10aFBA20A9cB86590A7d96F2B3c": 101.21,
        "0x9cEf6e59C214179Ef24E30EF50b3E6c15a37D4e4": 101.21,
        "0x4a4AbC2439620b311e6E044Aa22841126ceb9CF3": 100.76,
        "0xc95F41579E19099503f85db8c949fD45565cFAf0": 100.76,
        "0xD58bef55aef5b09494A5aF207e6f57427cD06c25": 100.76,
        "0x9daDed8D4355587201556a6224A9b4aA0217b220": 100.76,
        "0xEAD71ff7bCce7c3dD572B3CD6Fb7bC4C6359aF5f": 100.76,
        "0xaE74D4Af5310170f8B2c0227B0C8CA70c8E2C78F": 100.76,
        "0x1a144A9ec6F636bBA066E21fAfDb99967c096737": 100.72,
        "0xC8D46eb7881975F9aE15216FeEBa2ff58E55803c": 100.71,
        "0x27132b1C44Ed20BF54Ed53D13557485Dee422a66": 100.71,
        "0x04EcaeDE106078C2948534c5Fdf128941C7Fb638": 100.26,
        "0x8a7030A42d4E461684Ef62DF6f3f168CfB39E782": 100.26,
        "0x950247B63d8D2470780aa5cEE2E63BeFB3a1C2F4": 100.26,
        "0x8e944F7eBA816a50bD7873944FAbb72ba233e216": 100.26,
        "0x34Bcd3E82dF46d516aDD888bDb92AbaC8d1D8103": 100.26,
        "0x283ab5611F510D30A9EA62573f1B3158E8f74682": 100.26,
        "0xAfb5AE082dF42850D07A7058526fBE5e36328731": 100.26,
        "0x1aAa8d951C6c74F6548bd4E89a1c54FB5FCD0Ac2": 100.26,
        "0x0c688322a70dA7C228959f55beE9dDB2F04771C8": 100.26,
        "0xE76415206C9B3FCDF2d0920ab0B6B9DB6E479B0c": 100.21,
        "0x1D8D739912AAE17819618e6e33580284C16785A9": 100.21,
        "0xCCF756AB48abDb3a6e02308B076Dac4AF4789e0C": 100.21,
        "0xD0d38f8dC083aa8C229e6e20843cE56b85976993": 100.04,
        "0x9936063a574aD34eaDF80aD636A1eDa1e315e4DA": 100.04,
        "0x4D875Aab37398eA559e716bA14aA67911EeBF6EE": 100.01,
        "0x777781E43f3F739973389AA135d968E7fb2311EC": 99.75,
        "0x3Ac41c2cF72ca3975393C6c9571B6C048e5e616F": 99.75,
        "0xB157ba30e3467DdBC844f14F02b4ba741f1d549F": 99.75,
        "0x2F486cD2711fed55ecc481a5a0aC62001EbFB16c": 99.75,
        "0x1cf061f8F592bc7860321AEEB2480c662492b794": 99.75,
        "0x26d139e2dcaD7B85084C92C5bf443520489f81B8": 99.42,
        "0xc7DdF329f4cbc3B592990c382E5d6e2C28161c62": 99.25,
        "0xe864c76dc41797E606b67ecD23Cf0575841cb24E": 99.25,
        "0xb4a0C27D79D54fd2ecCB6DC9Ef9eB49eC706626E": 99.25,
        "0x33A431c03adA4Edf4a2FACF97c19a999ff33926C": 98.75,
        "0xC9C070d4b472FBf9E652c052beEfF16b79E3B7ab": 98.75,
        "0x1ecf60715191aF85dacA2E0749bEa05dA6101dcf": 98.75,
        "0x4837b90f60c024697a5341a13D5fa46c22e304d4": 98.75,
        "0x9F8091368bdb564b3F78313B096a22FC8fbcA0C2": 98.52,
        "0xc191dD544f9B41796182ef4Db4e001faF27203Dd": 98.43,
        "0x50555829b2C145c8F7fEB50473E42fD165c42807": 98.31,
        "0x995f006F5bA64b6Fc1a7039Bd346B5A8E19c1deE": 98.24,
        "0x539438A890A678dd1D9E7aB92c403C97e787132b": 98.24,
        "0x1395DE9DaeC52Ad405e945603eA0a9346d00d01C": 98.24,
        "0x2B7e44DC0aac0BE65045F7058a3b2AAc47A1aBD6": 98.24,
        "0x181ebf93092438f13eBEF682B275230c7169D0F2": 98.24,
        "0xd6846289dd3df8c563bcC837b273b06D5E7Dd25F": 98.24,
        "0xfddfBDb8899DEf4EcE2b9D1B4572bD833EA7b10D": 98.1,
        "0xa21957306BD617E489f2A4070975e5Abf4F6F1AF": 98.05,
        "0xef93d76523C6C224f72FE1ABcf3bA1f61e2c99CC": 97.75,
        "0xc4884736a39C8b0D1d88a23BB2Cc15Ee0886fec3": 97.74,
        "0xA044C595d085A8956569B3bD996BE420e89533dE": 97.74,
        "0x0Eb181D647FB2eDEA2D0DB525560AC3A6E225864": 97.74,
        "0x73D3Fe580F4E030aab88688584817a5dA1Fe7109": 97.74,
        "0x29964b7C46144D79457473661F99F725d4Fdf0e3": 97.74,
        "0x6C7Ef4f81325F272800C0f6c8647844B9154921b": 97.74,
        "0xc707C96Ad17143c0ff66663FD34361C301D47516": 97.74,
        "0xf790bB9a7221C9a3e9983F3a6c23f6048002a529": 97.74,
        "0x5D7ADC26bB08D5200380E7Ca10f36821a28B0339": 97.24,
        "0x5FB5E55431AD15F6F262a594D3bE218aCedB9268": 97.24,
        "0x464567a90011774B2244374D10B67B50702c1AB6": 97.24,
        "0xB53dad314523B33aB9E2576dA9208AFB57e512D1": 97.24,
        "0x66d4908E053F7150038b1bF3579cF384fde0BA72": 97.24,
        "0xb21cf61C3cB30D0f884eAdc3d81CD7d8722fD820": 97.24,
        "0x3B84feC5617d5078c641e595A30ACa4F02648881": 97,
        "0x5C04BE15D14677D3eabF6b52Cf5b39738AfAb3F2": 96.73,
        "0x8995AEb1083E4B1E1679Bf5C13A17Ef9eCFb4a44": 96.73,
        "0x4Cbc25223aE8076F6b509593a383d395E1aDf3a5": 96.73,
        "0xdFC30c075019Bb671d60D84242d814f3cdf8d76E": 96.73,
        "0x98AeC4EC5050945Ce67063b9b173FD27576E9c76": 96.37,
        "0x25005b3f6402Ab7F5e4F8cB293A50A9020aadc99": 96.23,
        "0x1302a937Bc0fe8a06F124e644236C876b639F54E": 96.23,
        "0xf7f1aE6e7634237C02a2d32b7dE3F653177578a2": 96.23,
        "0xf3772fad92D4fa1a656bb3Cdebb54Db5360Aa808": 96.23,
        "0xaa217Ad3aC637056C72fD5D08848F16Ac961d9E9": 96.23,
        "0x04795cDEE2B677b46878896DAe76BE5CB174dAc6": 96.23,
        "0x58bbB8D3c0c16b35c6d09A8306DD012b61911699": 96.23,
        "0x6Ab2d5789AF8fc628b306d04505de6E5a78ba660": 95.72,
        "0x7D673c30A16cBD0F5c3eF954100502a07efBc445": 95.72,
        "0xa7725DFd2a7C93D5cD41D0802384d2702792F84f": 95.72,
        "0xA2aa014D93eb0025c96EB57CA46bC1969309Ebb6": 95.72,
        "0x894b87dfB9e79082d2D0Ac7c16cE40658afd42D1": 95.72,
        "0xACc3F29902FE029e7D0Ebb66B28B282ddc4b9f26": 95.61,
        "0xB3e1b74963301D2ebd72ECeae539007c3Aff3424": 95.22,
        "0xd511A8D9448Dc95e774000dcc342207144aA9377": 95.22,
        "0x9020fF4A0ddb97eBbe4CeAA6f14c93C3fD8d7C80": 95.22,
        "0x5CE6CD8Bd9D007d2911E1b7a7ae207A8d1E03176": 95.22,
        "0xec7C75a3f03598fd7f9BaBCDD904eCF389f78c4f": 95.22,
        "0x033E0a61aC00288A6388D1c8BaD11a881cA9e212": 95.22,
        "0xD65BDC683E69C683972DAf5409aFBf8e144063da": 95.22,
        "0xB2174AE00E97509b7D21cab8822fb34EF5BC8B56": 95.22,
        "0x840d0D1e473465ec37AfE2998F39aC00b28989eE": 95.22,
        "0x2a57701cc3338dEd47fe44695DB146342caB2428": 95.22,
        "0x5F862659CACa6CcFd0df886df9cC951C0E1F2414": 95.22,
        "0x3A409EfF50A47aEeF294E3f0BB3874490dD99abc": 95.22,
        "0x21bFF47096014BD377a697fbd8137C73efe884F0": 95.22,
        "0xDdc22fBc4559feFf07fb35CDa96a636AEBBD2aa4": 95.22,
        "0x995Fc0Caf93b0B69EE7A7dcD27c2332F1deeB818": 94.72,
        "0xBb980f1545b7f71D28bc6baf6798D213fc95C39b": 94.72,
        "0x7CE487f43C2A11f85BD6f0bc9174C3B031D8A6E0": 94.72,
        "0x17ae0a6BE2e97b384165626dB2569729d5006640": 94.72,
        "0xb957DccaA1CCFB1eB78B495B499801D591d8a403": 94.72,
        "0x69B20338ed441DfcF434dd38B00a487bF09D1aeA": 94.56,
        "0x3126da8881F8A68961abF61C7ce151d074CF8681": 94.21,
        "0x64a541629EE3089b513aff1Cda971F417ED58E32": 94.21,
        "0xc4Ed448E7D7bdD954e943954459017BE63584F69": 94.21,
        "0x9A608d9F416518b5F11acf3dC5594C90D6998e2c": 94.21,
        "0xC466600F78c06b04B96F880a1A3418324c8A8167": 94.21,
        "0x209699a7D9c9a3f005a9c3179F58F8B942A27b0c": 94.21,
        "0x81A9b8684317e166bcc9B55dC88996D53B74619C": 94.21,
        "0xA3a6d4497ea5B46BC60876cfA49A092C4A5F558c": 94.21,
        "0x8Afd6322116be3BeF640ba9F302430777D4d73E9": 94.21,
        "0x7cE55E171005F730deA1524AE6b6a84B7554A8A7": 94.11,
        "0x20c22b1C1bC1f45478Dd0C2360C463D531D498Cd": 93.95,
        "0xaF6419b5C44D8F95966A63bdB5595DB57fA9CE88": 93.79,
        "0x9F36A6bB398118bdCD5B1bC3343D8FEB6d7d02B9": 93.71,
        "0x00b51820A9d027Fb2DE9eb58d898db0179eaD8B4": 93.71,
        "0x9AfD4F7aD03A03d306B41a4604Ea2928cFf78fd1": 93.71,
        "0x856b63349fB6c818ea7cD7305483Ae0EF6956f6c": 93.71,
        "0x8293Fdc6648dcd00b9194dfa0ab731b51E294F66": 93.2,
        "0x15B746e7C8ddeE0f857772A70275fFA326072B02": 93.2,
        "0xEE0922A6b0768e32FA66a8AA51E8C0f085A2Ed4c": 93.2,
        "0xD86C4483318B1E1e8fDc848027BBF3b4E56B1ef3": 93.2,
        "0xc2ee66e557d43c70E4dd2bC6DE4665d90E070AA5": 93.2,
        "0x53Ad76dacfAdE8789684aEBb5dC3f7E079bf8596": 93.2,
        "0x420c3d6A24f32438154Cf261C3012366C446919f": 93.2,
        "0xD27FaDcb642657e599394Da3356E137d92bC1914": 93.2,
        "0x13000d4fF30F310717182893d8bFbCBC2D455d18": 93.2,
        "0xfCa268A0f468B4A8fe0131045B86FB2225D66578": 93.2,
        "0x27F34C4F30f11a6a9698D9711573A1319c6A135d": 93.2,
        "0x6Fcd5b9e47BF816De6308CfAFbB8d8e30fEDb23d": 93.2,
        "0x66d8A06B38dc6fae22b1f0166AFCB85649543265": 93.2,
        "0xDFb34114AbDb32d105a4551117a151C4FDf89a33": 92.7,
        "0x0a2f675591577BFa8d5D8d2eC3FB8179aa821405": 92.7,
        "0xA3eaF6176f4A76F88bE2a5fEC7F102fe44FFc563": 92.7,
        "0xE3053cDe2124eAA6103DddE8E5c6BD36c66F716E": 92.7,
        "0xE03D7Cb5E146e7F67c5da6BD81D7252B2D6Eea09": 92.7,
        "0x2E25362700cf06EAAf4845c34789F67ea1B78D56": 92.7,
        "0xf51fA083336797D6E5f083e5a73208F3e185A8b9": 92.7,
        "0xfb702e95Fa231C5509487a9E99156003985FdB9e": 92.7,
        "0x0C8ed58764F35866407620A1E6c15576B1309d5C": 92.2,
        "0x8968837E2b3B3313C5D4b82106D76B9eBEBa59f0": 92.2,
        "0x002748dB885D4CCfe3C7C92143f0805F4eBEEC01": 92.2,
        "0xCbfbC46259b58C37aF7506D6099BC18Acd8aDb73": 91.69,
        "0x3367A005c2bEf54f2836a616ce3E4Fa2d35910da": 91.69,
        "0x03490f2b65608070C0bB15503C81A1d55b2C55C0": 91.69,
        "0xecdCa28b61D398ca1e2442E7958e2724A9cf0c98": 91.69,
        "0x49072cd3Bf4153DA87d5eB30719bb32bdA60884B": 91.69,
        "0x2334581B075aE94c34ff64FD5bF8d47f07628890": 91.19,
        "0x67d693dee156Cf89Ee524b961cF19E4c023936e3": 91.19,
        "0xf225159d7eEe3B9b31589206d1ae27BbC8268238": 91.19,
        "0x42D29E6fFfEf7D2df66bA652242Eeff2B01822B1": 91.19,
        "0xDf5fa32B726a5118281e74aD3B7C707423e28F8B": 91.19,
        "0xaC0BEEe809563edbc5960D42a798D12Bb5633045": 91.19,
        "0xD89BEd3d579FB532ec3E9cf593c44ca7B5D5f00b": 91.19,
        "0xBff4d4f82e2Aa032a1Ef35f7e648503789113609": 91.19,
        "0x4Cbd163b6FA861B2617fE1015cd5e2F20C71b32B": 91.19,
        "0x6d64dFc18523cb3F6B7F3514c6504eE92F93B183": 91.19,
        "0x1eC8Cdca5232cBd61E305F94261fFAD2F91F16b8": 91.19,
        "0x00aAe21e3b89CdE691D75b050a39B2B06949d6BE": 91.19,
        "0xEeC8D8162334d2E93311952d5a7A4269741c4d4d": 91.19,
        "0x58c1b64145fE880abF97b66F6a0907e07B4DA79d": 90.75,
        "0x9B9E8BC43C15559653868587A193bD014dff5c65": 90.69,
        "0x525320d8712AeAB3f3FC6195102ABd477AD998Ff": 90.69,
        "0xE492e921F11d8c42f78E80E9Bb9abc75D9C49243": 90.69,
        "0xE55a6c22Cf889b88d5E21bEE606AA1Bb6Ac5F76A": 90.69,
        "0xBdb4a74D788a14568E0eB7920aA116387Dd6099f": 90.69,
        "0x5115B261fb75084Af050349020F09164CB8Fe059": 90.69,
        "0x617e24fcdF3e283Cf374E950918ecB960253FFB2": 90.69,
        "0x4b0d93ecdADD048EC4cb10794fa48624E23a8c2d": 90.69,
        "0x1aDcF07389b1F6605C44a7683c50A5243829A92C": 90.18,
        "0x153CD5217D6dabE839dEd8FFEFF369A72aB392be": 90.18,
        "0xC3D4FEd7ad9976fb210a85Ffeb122E2141050133": 90.18,
        "0xaf1De295a3AE5b8F08a01172cCeFE137ad88b30d": 90.18,
        "0x5A73331e614186a08439526b6D0535c63A987d6e": 90.18,
        "0x2A2081C0B5a31897E0B8C40EdbC763C34345a38a": 89.75,
        "0xcd96E1536e7f599e0AE2aD7de780960fD0A3BA87": 89.73,
        "0x6BCb9EC9686aeB3B2Fd854f036d3F24Fd48eaBba": 89.68,
        "0x3bB4b90663c3DbFB0ad52B825Bf0F0cA8BB468F9": 89.68,
        "0x6a85C3BfC93D59B9746152A35832FD3255f7F930": 89.68,
        "0xCe066dF39b6F4E08f27b2d86c1a85BD25b5Bcd4D": 89.67,
        "0xAb890bBa96ffa70b5b1E72BaeD4fa9EB783C0F22": 89.17,
        "0x597A11c323818AA638A229a741570981C6f4d5d5": 89.17,
        "0x33b571Dd358cdeCABc9B6D5A225187dbE9C3054C": 88.97,
        "0x8D6a1465e7710977B2D2795336ddFf81C2CC2A52": 88.9,
        "0xc3b34e05E1425a012a2617F3808c093F4C6c25ff": 88.67,
        "0xF3E5b415e84047d68e412cCCd2d14B15e308b120": 88.67,
        "0x29F38498071b772a99bAb18C7ea4125387Ed2332": 88.67,
        "0x78e7b3339445E35CAa26D6d175f3e7D9bf99AEA7": 88.34,
        "0x03995e81Ebb9653175941772698c3D33e1031C21": 88.25,
        "0x08f8F9fDFcd849FBB2231b7897c3BB3577bbc306": 88.17,
        "0xaE5C50251017Ad218700F875DcE2f20fF783Ce1f": 88.17,
        "0xb42CD13d0B53088e1685Ed7f6C78066b243f42F9": 88.17,
        "0x597BEa912e8734E17DDc4f43A489a1472d9459cF": 88.17,
        "0xEe659F1F00a10B1aC28E81a66B06c8Bfae44CA07": 88.17,
        "0xA528A3E900fDD074aDC2a2D641BE7157488DA90E": 88.17,
        "0x32D29991A1d9cf4b3cFd72120a47492Cc994F1fC": 87.66,
        "0xA7c1f75209c5cF1e0668f2186814a1108f7EC9b2": 87.66,
        "0x61503d36Eb845023651d93650F4bAFa9b678fc38": 87.66,
        "0xb57F356eBA8B4666d5fFd1F36F6F52b823AE8E59": 87.66,
        "0x8e43CBE0d817e56D89a004d18361193626582E63": 87.66,
        "0xA36e7A8C5160ad3F85C8b6029bA662286ba7704a": 87.16,
        "0x2ee1E6483AB36C07a7F7593ceE9C8C7df7c729Ac": 87.16,
        "0x3f6364f662B0127a3430bb9a9Fc16B602Da9a188": 87.16,
        "0xF71D161FdC3895F21612D79f15Aa819b7A3d296a": 87.16,
        "0x3fc6121cb50b00A5Fb8BD2a3c755f804D0E694D2": 86.66,
        "0x59977FeE7680632fD779b55f428361b7ee4bfebE": 86.66,
        "0x9f834835927a0D9d589620669c0cd16B6AF87D57": 86.66,
        "0xc1d72D05D777b13b4184036D7EEBa16635f20e0D": 86.66,
        "0x28893320E3Ec737271510b92b3eFe948144A396E": 86.66,
        "0xf3aCdD34dd3CD92345b5998e319c2aD4666B0066": 86.18,
        "0xD9D836EBC67Abeec65b29E586F89816Dab991F69": 86.15,
        "0xcc1DaD651A5B1526102d8C1d9d12a4823D6B63cD": 86.15,
        "0xC996760cE1a50b2b69f076df1182214aFf5342e2": 86.15,
        "0x9150D0A199882057C5B36fe9d09e9E845f14bC25": 86.15,
        "0xecAF401a100ff4e390075a5D45f7dB021F90a0E4": 86.15,
        "0x3d409b7CaC949135657A9eE5f59FfC27E0Bf5d6E": 86.15,
        "0x997c90DECE38bb59e79c66dEf042a23B3e683099": 85.91,
        "0xB97EE67E5f3FD3e2c22deD8ed6ca19693181d72d": 85.72,
        "0x8fF43bFD449ad3F508f4a4B98d24C99B8Cb5Ff9D": 85.65,
        "0x5EFac20C07eBD844821A72FDC6cC2c2770f320d3": 85.65,
        "0xCD275d536C1fAfF7dFa271aB1CeA2bE091f137Ad": 85.65,
        "0x9599A45A873171924Fc5E9bc76206Fc32762fB00": 85.65,
        "0x2951B1F7058bd2C05F01954002C450BaC0873847": 85.65,
        "0x300F818133Cb321b1099cBD845044390F37e2E22": 85.65,
        "0x55D0CeCd3c360098eBFb10A9013d2059c492f930": 85.14,
        "0xd2801e7bf6A72CCE1ec225bb007A26815AFF9878": 85.14,
        "0xa669070D106E96CC2390523E9745B425a1b3a0E0": 85.14,
        "0xA60e8ea9d55dEF9339303c62A4c91B5cC3a4a738": 85.14,
        "0xB3A0aCd90daA82dC0A942A7b114A284711a32331": 85.14,
        "0x750EBC88a87e41C0b0775a298797c90Da03e7721": 84.95,
        "0xE29555e804e414E295E2A059Fc49d002EC18F268": 84.64,
        "0x043D083ea86cAd545cEaa73FF6469abdC48bE78C": 84.64,
        "0x882A42cc25a4c3542dEAEe7A7c4924C5209Cf2A8": 84.64,
        "0x5C0843066F64aA0D9858611401cD2DD6F2e1f7E4": 84.64,
        "0x6eC8B8Cec5645066FDA40C6c6D6C3B749A565755": 84.64,
        "0xC03d8DB64dfe98ebFD94a84bc1f825CAB90EE15B": 84.64,
        "0xD7bFd63d6d370dd06383C7AcF49B6961FaDeb5C6": 84.64,
        "0x05de7185D0A89c40Ef6a4b684296DEBfd2e7BD0d": 84.64,
        "0x71D0189A0BfD5ECe58713f0fC7336179a6aF84F9": 84.14,
        "0xC9C4209ebF1A00D347A658A5Cbc2436219c045a8": 84.14,
        "0xa696d246c9fee573B7582Bd9FAC80Ca795CF8DbD": 84.14,
        "0xD6977796aBDAcb208eC5416E774979439b245fE6": 84.11,
        "0xd2f7684A95248Ac18095510c460706D9483B3AeC": 83.63,
        "0xa1A733F1638a4104E07655Ca611634Ec20559E9c": 83.63,
        "0x0f2CE18919b4eb9838760cFDDa65E4C8766E9c19": 83.63,
        "0xA8621894cA5aB12391C3b387Cb2A238A93E238A3": 83.63,
        "0xF0e9b7c3065b3e6d5Bec761488ac3327Be17457a": 83.63,
        "0xEc941fE3291Cd1F10B3C2Ae9eB48bB8041266075": 83.63,
        "0x602fFC48BD6e6Aa4faB26b87a377380abC2f6A16": 83.63,
        "0x9F1d096a272E40c71534c823919864ea761cDD47": 83.32,
        "0xc7189ABb8A5061976aD37F4Dd5d5a36f79a3943F": 83.28,
        "0xE0a54F24Cfea9e19b40aB3d43eA53662ae3469F4": 83.27,
        "0xB721262e075AD4073EbE4560161a88fEF8c82dcd": 83.13,
        "0xB07AeE9Bb2d03b6F65346f666154150caCDD3E51": 83.13,
        "0xf494ee7D264AF843BFb9d8BF138E42bd8f64A0B4": 83.13,
        "0xa698566DDa5AE9e2A1Ac7efAD83C1b1fd0216a50": 83.13,
        "0x3d2EeCC8aEa5F1B5e462358C183125D9490bfFB4": 83.13,
        "0xa5fA56f3D9519271831875437fFF64156e25126D": 83.13,
        "0x96051588Ee65acDE2453e972e1120cf6b2f4651d": 83.13,
        "0x9c5203149b331ea5D9B7ca67BB6d5476Ac0C107a": 82.62,
        "0xf8600a12987C562377AE1747833cE16f7de3B2ec": 82.62,
        "0x5AfdD71EC312eDa36663f72032f269BD9C950cB4": 82.62,
        "0xB964ee3dD2189CEAFBCB9b721890B2986Ce92701": 82.62,
        "0x56eDF0Ef4e0060b3951D75dFC8856a18b3a9417a": 82.12,
        "0xE513d1821cC0904c6C6601A951fd1Ff63F07239d": 82.12,
        "0xBC1d315bA25501b20CFc475A86087145b7f48374": 82.12,
        "0xAAf4108Cb563BbBA173314aA5cF1FaE1C916F264": 82.12,
        "0x8298CA68DD147F42D2B355D320DA71561DEfcd21": 82.12,
        "0x3dA0Dc44D6669E9085d7c7AeE291d7Dbae1c1507": 82.12,
        "0x9d91bf02f95217f3d861aE51669F244f7A649912": 82.12,
        "0x4cC72219fc8aEF162FC0c255D9B9C3Ff93B10882": 82.12,
        "0x5e3391F90a523c61ED5844CB3Aa1c81f3238d9e1": 82.12,
        "0x89416B7fD83cddFAa6EeE814a8967f76d4511294": 82.12,
        "0x3627d69797bf071818155f61a408d80DFE6C722C": 81.74,
        "0xD9Cea717dcFbBaF0F75A2aE6bd059De468660C9c": 81.62,
        "0x7A736aeBFDFf3eC824F8ea3F83639E863D7963C3": 81.62,
        "0x72421BCBd0bc46FddA98f29505177Cf09B710Cd8": 81.62,
        "0x2843c34F6aE9d3EB79aD557Ac83A78e8fFa2dCD5": 81.62,
        "0xaE56f76F5dC8325242DcE61cC24488fe740f4832": 81.62,
        "0x8f21bD39FcAeA3A729D46339A383081ecB7E84E0": 81.62,
        "0xbED1128A2F01E12d95E8C431FCd34B8fA052b08E": 81.45,
        "0xBC527291113A81facAb0E2151A0552348F60fAf2": 81.11,
        "0xFcc92026ff27764D5E535c2975Ac559263D6a941": 81.11,
        "0x236926c63467E3B80af4C1fE6284e59AD77eaEAf": 81.11,
        "0x901a89cEC0608eB5435A915f006b45bD46405314": 81.11,
        "0xf5e3c687D2b13751ada65906849DF79b609D9746": 81.11,
        "0x0B4B5cD5F3CD7e6325c34564Fe6320318eaC2ae6": 81.11,
        "0xD69496100C5F2372076B8Fc6c238e53B8C9dc4a6": 81.11,
        "0xC1791da88cc94c9A39E606D8760183d21268dCBB": 81.11,
        "0x71159BDd5926442BeBBCC6738F15b27A6b181eF1": 80.76,
        "0x6864b1d1f7F67e21e88EC10Cc52C834278b241B5": 80.61,
        "0xe79c4a3807621F223De76404fB609B8a278e0262": 80.61,
        "0xD9bd3137B277Fb45F8Ba81EF7E70bf6B05109459": 80.61,
        "0x6C445380d8d58cAA3BBEc9749106093b7d3e44F2": 80.61,
        "0x1f2d8E46977818203fc53e4Fa7A55C8735ec4d23": 80.61,
        "0x1B52A70616Ee7ed4Ea070d19FD18a60e467a5276": 80.61,
        "0x23D3c0d5e8226F18bf58BB3C68b149b3d7385936": 80.61,
        "0x5dEF3a4094E05D5E73156864E905E55463a2F68f": 80.61,
        "0x21688De02c673F8eA5d283d3c7831E9459e123dF": 80.11,
        "0x9459EDa837626A5D7f929BAf7d3AC1DF60e26239": 80.11,
        "0xA34C3f815B737Cf0100E88ae0dE071BC29FDba4b": 80.11,
        "0x548831F70c94537dab9D48a2086FAF2e48eFB2bE": 80.11,
        "0xfE466e92da3EF38732F980E0a8032aD67349708C": 80.11,
        "0x5a0DDa19c6805Ec3689DA721F969864B04B67959": 80.11,
        "0x937793Ab079Ba9A6019E6239DB1593c0C4c2461d": 80.11,
        "0x7E9d8fD68C32aA950fD302faDDf04FFE39b6FE9e": 79.6,
        "0xF789c17bA9daa75c15Ccd3955A525842b251bfD0": 79.6,
        "0xd4245Cb7E14ad1309FD999c63Ac84901700A8899": 79.6,
        "0x155074DC8b86C48916569B7dc853579dec902D82": 79.6,
        "0x05140f7d3beCD8e3129113c35e4b62766d6Ec3E6": 79.6,
        "0x87Db6a19c3b8bAF8829e0Fdc2bBb09cdCa373e58": 79.6,
        "0x3B6eD35D0A9A6476fc5186034DD4F5C1Ab2e90a2": 79.6,
        "0x85782569326956F7144B650753Fe9aE02dFFC6D6": 79.6,
        "0x294550e014756241e478F94cdc12Bc41d4e483A8": 79.1,
        "0xF84368Dcc03dBd47A6567b7267f573c28B2F07Fa": 79.1,
        "0xFffd05AE9Db4d5F4e23e2F37395db2F87359bf5d": 79.1,
        "0x6Df75f971EfED00C3fd5877A739cD2721C926Fac": 79.1,
        "0xd39eA6043d1Fa03f5be2bEB2cFE65faa4eF0e595": 79.1,
        "0xA03bcd812bAFe3480d1C232221E30F276EEd5855": 79.1,
        "0x7B85f197f6944aa5cA32d46EE3b0173Ea33Fa052": 79.1,
        "0x252438f00FCe3aC218d98882dD15ADA56A844A92": 79.1,
        "0x4372a6bb30DF110d60bCcaE53ED6695468E9fccc": 79.1,
        "0x27211186a6ACa2c1371Ea8b3dEb528659A118081": 79.1,
        "0x8Fc78cC0276C0b4AEf40cc3085580ca19EbaA07A": 79.1,
        "0x0c4d231f2432FFdd99624d82Ce10eB8b797fFb42": 79.07,
        "0x1e9943025ce6a74E38FC20aA465D58Ba27066961": 78.59,
        "0x04B2f53B45096ba3995Ce99A3d72fBb0F84ECb0f": 78.59,
        "0x551F3a3b0c538496d5e71bbb528Acbf0673e1201": 78.59,
        "0x235987B53ED16a5F331c3648F78cBc148A877D27": 78.59,
        "0xdB5B154d5BfFdF6854c72f7dD06F446D3f8d8408": 78.59,
        "0xBf75404773a34e020bDbBd9F3ad6eac03EB75C1d": 78.59,
        "0x741Bc936B183F8bcF807C0204BeE62Fa68eA561f": 78.59,
        "0xD05128333c9500CE0b237f0e593Af59Aa180f4EC": 78.59,
        "0x71A4873f09b78900ef7431B7156542aa2Db159b8": 78.59,
        "0x7173A301c832e50119DdB12cfB6570A83b1eEc05": 78.59,
        "0x30224981a4b5A6e2938d0a62900F77f90A2A0c24": 78.09,
        "0x42570Afb327C374dd4d95CB1E4443B53f04Ac95e": 78.09,
        "0xAA61A58830996a2b54902bAC0913641ccD362828": 78.09,
        "0x12a6F711070408D36CBFba1371861B7b470e7531": 78.09,
        "0x4d4A92C87B543e27C35523F19efAA2a80F97c103": 78.09,
        "0x1d8c4d80464270AFB50576CAB66F08a29903747F": 78.09,
        "0xFdc3E8eDd74A90fe971EF7d56a0C66c870b10F5D": 78.09,
        "0x7C2a79124cF65fE7F671F421d767c8d2ab7cd7e1": 78.09,
        "0x5f203fF3A20c74bae3a723BfF8B34cDA33a52EB2": 78.09,
        "0x561301118d910ea0b2FF58779419870ada72f321": 77.89,
        "0x12ef58947285F01cE8d8EcD90b3Ea384B022cd1C": 77.59,
        "0x689A83a08aFc2279D6ac8AF6Bd6A4D3C49B35210": 77.59,
        "0x24823664542ebE246cef0db1b1bDacD4b989D972": 77.59,
        "0x9c026EF96FAad6932eC3552769427B84b1e82088": 77.59,
        "0x7F922e25A3fF62F9A253C83f3f1F2E1DdDaE60Bd": 77.59,
        "0xEA7799bb4139BC81Fb001bd009bbA7989Fa0dad3": 77.59,
        "0x6A8dB0Cbd37c515A7F4C0ED6A58AE2e72c2fed33": 77.59,
        "0x62aeb9a853AB9731819e96fA4628FBe1CBA6fB01": 77.59,
        "0xbeBfF394e920b170eE013f4bCdB9a06fb7481944": 77.59,
        "0x9B8FDa210BE6060626904eEcdd022b50e657F290": 77.59,
        "0x1d16c8c463637cEa12678065362d074109DFC18B": 77.59,
        "0xdc5eDFeB777BDFaA851EBDa34c102162738290DA": 77.59,
        "0x90A23Ca50c31161C5297BA9Dd55C70212AB056a7": 77.59,
        "0x7cbB5074Ccc2e466d0A3E54Af4C6547195898447": 77.18,
        "0x31d6460C53F9F793894059a89dE899fF38f092e8": 77.08,
        "0xCCC3ac360ffaf97fFd1fD274C60DA04DeBEbe099": 77.08,
        "0x21B681C98ebc32A9C6696003fc4050F63bc8b2C6": 77.08,
        "0xCA590551c68a1a67d54770Efe8d89c0276Df956f": 77.08,
        "0x5E98bD720249E2e126f21529d461B7c443f17Cb1": 77.08,
        "0x0DF06476eA7b96c96D928429e247Aa0ec85ba95d": 77.08,
        "0x47045D1eE924AD6Ff890Ce8B52D6c1F08Ad42235": 77.08,
        "0x16EA0AD83c08cf5edA40f0d21fCC16ee17D47d9C": 77.08,
        "0xF9344061881a5df17bC1BBA38423C10bf13760b6": 77.08,
        "0x0C38b0F1ed18cc36a51feE6fC4CE0873c13046C5": 77.08,
        "0x201b0eA27717c02b67E2802F80bb1A4B3cDC9A85": 77.08,
        "0xB3B7dd6f038e060BCcbF03fCa8Cb3b39bf9D5337": 76.58,
        "0x884c0A25646893b90E967e74fe22e24C950703b0": 76.58,
        "0x48f58DF7267077f9a45894a1e283863E0030B51C": 76.58,
        "0x9EF171A8C62Eea6455830Bde5de99Db5A7cA5119": 76.58,
        "0x66e4E30Cf1eB6155c1BF0422879A470e582f3A50": 76.58,
        "0x5Df78bEe001Bc44F2529d0e51724D75632a0D3Dc": 76.08,
        "0x8f7385282678FfCb690506f74A8F5Ff3Dc472A76": 76.08,
        "0xcAdC672a191aC9b184B468064fDFbB99fd9829D6": 76.08,
        "0xb7655B6060079fa92E543e3eD4d38D77c50D9597": 76.08,
        "0xFace7bf1BA8c712e78119087Cdd2135Fc96b3F2F": 76.08,
        "0x3717d4cC1D3226395A82A8680C3E0078Dc43146D": 76.08,
        "0x9a62DB4c17146172c0B88e7e439dF169a0F93E0E": 76.08,
        "0x387EC377E5B3ff17b61B61a3724A876369EB59BC": 76.08,
        "0xf5AC187Da273c2c645a2e8327c9c3D2bb51f7a88": 76.08,
        "0x05CEFB1b44D447627BD0F341F29401790963Ca9e": 76.08,
        "0xdfDf2D882D9ebce6c7EAc3DA9AB66cbfDa263781": 76.08,
        "0xEe6066b7655657e34f6190629a64F0a8014d3a96": 76.08,
        "0xb29f1AC5B4748e502979Ed6B3F2Df43E5F218665": 76.08,
        "0x01Ce13624025d7cba80024daCE991F2cF0F3cE76": 75.77,
        "0xe6A4c1aa9D9C78fED75077774a0f1934403CaD3E": 75.57,
        "0x5e9b1a78a998C5370946bc779C285c8396847CBD": 75.57,
        "0xF11b0926fBF9bA688B2B84fcdB1E588e06298a3F": 75.57,
        "0xF6F1DD531f279A70ebf595E8b7a25C7B6D91bd21": 75.57,
        "0xA5495A3dBD5c6c00EF69bFd1c133C7049724b4d0": 75.57,
        "0x07497437dB00a12db5ADDB99D3Cdd9F6937222D9": 75.57,
        "0xB6f07eeE42bc70e8BB32E8F7Ee7C681BD93EF903": 75.56,
        "0x54240C950fF793A4eB5895a56F859216cB1c3f0D": 75.54,
        "0xD670a99b9ad6b9FE256294f51cFE5F38E51D54Aa": 75.07,
        "0x0fC4a9d195Ffe18EB85786Ff5a81134276fB44f2": 75.07,
        "0x6F6cbAc3fC494E57Da3B53977fA9872C8fc74987": 75.07,
        "0x357a504228e1C671f064D9346c18Adc3A31bF9ED": 75.07,
        "0xd5123E618e8120B662567e30a0a16a8717e0bbA1": 75.07,
        "0xafF2595341a6c516Db4B60B5332bb8B70F2f1625": 75.07,
        "0xD0c218b477A000aA75f618c1793Bfa9198Bab7d0": 75.07,
        "0x32200044D81d795B63C7c61b95e502D798788398": 75.07,
        "0xAbD73aD3574b1Cc60C09B6B6ad72f0BA61c7DbBe": 75.07,
        "0xDE547847185A09eac21baeB2540146FeCF2Fe50f": 74.8,
        "0x175fB20b9B5bCf80a0167D403405E6F3a074cfa0": 74.56,
        "0x574398289fBaD26670d76e39BE3b6aFdd0731783": 74.56,
        "0x8dc4eAC2012e04F62EF6445cDf4b19DEA81A2D8b": 74.56,
        "0x7C0B689A3003e0DBd2d37Ce15e8a2273d91bd7F6": 74.56,
        "0x70a9c497536E98F2DbB7C66911700fe2b2550900": 74.56,
        "0xA152Cffe11B81a4659377d3263ceC217deD741CC": 74.41,
        "0x501C55D242422811440b6866C7d9a7E74a73BCd7": 74.06,
        "0x9872948E7faE8a7E57669966c3F7916b223f76CD": 74.06,
        "0xB13D1B60C8b3eECBc67048EFDABf07c6349Ba917": 74.06,
        "0x98e6D83F4088C581adc7759690db59Bed1C72E67": 74.06,
        "0xD9E884b2e1151140495b089fd6B07D0296616198": 74.06,
        "0x32D0516dEbE5b1Dbc85c2b3cFB0b4A970eBcdc5e": 74.06,
        "0x1017DF6724Dcbe640D1fC7187547800ac930865e": 73.86,
        "0xa3fB23D8186636c40b103aca2fb91EBA77e920bD": 73.69,
        "0xFc64410a03b205b995a9101f99a55026D8F1f1da": 73.56,
        "0x4e6FBdAF926545505F0F74aA34e74194D0a3dA17": 73.56,
        "0x1fB33F826aBB8B64E30Fe92232F830407d9f14fB": 73.56,
        "0x853641368a6CD41ACE5Ab6db303aE6Eb81A14edD": 73.56,
        "0xBe8eB72d33d76008BB4964189E86F56378aCc518": 73.56,
        "0x2699465609aaec51f814899C2a87583bD472C286": 73.56,
        "0xD5f2f28D57689519bbADe52eF6F47cB5558f9645": 73.56,
        "0x99494790fA74300AffeFE4C2E75c2231517eDc75": 73.41,
        "0xD67682Fe80D25C66B6F6Ed205641AfDfE43E9081": 73.1,
        "0x2092cb4e986716573a67533dCeA12F76CAC39184": 73.06,
        "0x073aBA73177668Ba1c6661A4CCddbF77dfC8809a": 73.05,
        "0xc3Dfde1E7dA064Dc673fF1ec9f2826Bcb416ae3a": 73.05,
        "0x8eBed0FF2B0232B0AedbFe6e9c0f72AC72577869": 73.05,
        "0x0123E230C261e026C476A21fAE07De3Aa55aC870": 73.05,
        "0x162073D3bD1D3bCe47e85Ee5b9904887D1bA6e77": 73.05,
        "0xC3836599dE06bC821Ce9b99Ab30CaE1b426760EA": 73.05,
        "0xCdC93f039805Bc5920c55cA31b5f785De40c52c5": 73.05,
        "0xB1c1404739D1917aFF22739ae24af27D832a1Dc3": 73.05,
        "0x506765dFdE54034CFfC105747Ed8829C2B719719": 73.05,
        "0x3bbe99772b596bB4CE0B2Aac5a0B597dC2F98dea": 73.05,
        "0xC118AaD878CD75907CF14945326dfdA1a70835Af": 73.05,
        "0xeFbE74A2d564B5Da62407d452038Db32C9fd6B27": 72.55,
        "0xb024eE1b2A23914c85eFCbD717dd54075588421F": 72.55,
        "0xb95536Cec4013bED921619e1aAf1360d8F02c3C6": 72.55,
        "0xf169aD2dF638384A4304807E636777e8B334239C": 72.55,
        "0x0059c5796e6c149B1D4b5A9C1836542cBd705A16": 72.55,
        "0xb9be40bdEc31ec3935830ACC8BCAAd1A431F8BB0": 72.55,
        "0x9Bb5cb33D993c37febA6BeC782855f1dd18Fb0Ae": 72.55,
        "0x0EC717BCBBb21B3657F0f9159f28F3E2F1474600": 72.04,
        "0x7EF0d352F7A77c0dF51dEF796e63a008234a7cdA": 72.04,
        "0x6Fd5a849cc4BB26fdE7737395E3b4A91F3B78A5a": 72.04,
        "0x87f68D3c871442e32247b0584c2efD7012FBe1F7": 72.04,
        "0x6552A83d69e49A418EEEaaE4E1E3E5D8ee0402BE": 72.04,
        "0xf3d0Cb1b3Db63A5f98a0EcB05d0D9F263058B7CB": 72.04,
        "0x4a9e280596C9f4b87a6650e32d29f865cBdd0aec": 72.04,
        "0xaa2819291d32D22A27638c4e16e26Ed19c6e43d7": 71.99,
        "0x67497a536302237B60F7076708c79A3aDFC290eb": 71.94,
        "0x1bFEcDFaB4787338F0998DdfEE85e78Dd25e06A4": 71.54,
        "0xDc728879e5ECf679Ae932EF4b54dacf34bdf0b1B": 71.54,
        "0xeA2ffaa47FBdD4C5E6A6D37Ee372f9c3CE539065": 71.54,
        "0xd5bd29aA9816F2140bFE283a5b3a8f42d2060A8c": 71.54,
        "0xb28037800F282E7A96a79fD0b0B5c1EED64bAaD2": 71.54,
        "0xeB608e9E81Ca95Cba74bD872C727dca25a707d53": 71.39,
        "0x0E06A299e3aF15a4E12Fc5Caee9DE36E7E5fCD22": 71.04,
        "0x0580cf836f4127B40054E90936ba4F36a1C35e5D": 71.04,
        "0xb4fbd802d9dc5C0208346c311BCB6B9ECFF468C6": 71.04,
        "0x998B284AF974DF8a7A9AA395DeA78E61A36646AA": 71.04,
        "0x62e8848bB104546EF0f317d28f22553CF71E60c3": 71.04,
        "0xc80144c8d8F82d632A9562b5E54D3E2d17Fb881C": 71.04,
        "0x9750ddC8b30eAeabAD1b20e71167de9BD776B080": 71.03,
        "0x6c15a9FB4d2a86e3d665Dbc941daECf026A8938A": 70.75,
        "0x4e5AA333353db1caa76EeA7450038D2C117B6E26": 70.74,
        "0xb68dB04F0E89607a904d92D3b4a768d699191590": 70.53,
        "0xBBa7f4fA59362E68CD4081F5a098e1d9c01FC552": 70.53,
        "0x98470a4959Ff07AE7D336BF905Cfc9C71b70E4af": 70.53,
        "0x834E48ed3B1a7787B481cFc97e156772f6981B3B": 70.53,
        "0x59C14801e17673dDc4a73B01676fb2FF27D1c545": 70.53,
        "0x5192309938Ef4A6804e89d20c839169F05d8a8Ac": 70.53,
        "0x5275Abac9282790637Ff18A951dFd2bF6a5f2480": 70.53,
        "0xDBC41ec90bd2De39db03648B8236d7e766c27EdC": 70.53,
        "0xc146Cdd5b2CcF9eE547B75C2fa7D1cA2407A0488": 70.53,
        "0x9a717799733552A3a49667Dee2b6341BC4d8a38d": 70.03,
        "0xD89ba09A3fDb49d10aA3E99636d35d5810308F99": 70.03,
        "0x936f959db9c2318fAB6a95c4cBe83Fd696Dd10F5": 70.03,
        "0x40B4785234Ba0766Ed323299b8f29bbe0DaD1922": 70.03,
        "0xB7Da8491dCF2E4C18be605351C2F7681a7f527c5": 70.03,
        "0xcF31DDC2c0B5571FF4E6db70092e1De98aa8D888": 69.53,
        "0x3C46fc2AC8101FabDE89fF88da0fdA895ddC1C15": 69.53,
        "0x0be0516D11CD36c06916F7D86a353481a59Cf6B6": 69.53,
        "0xf9551c66995eD3Ff9bb05C9Fd7ff148Bd75dc99a": 69.53,
        "0x0cf476991CE3B23123dC7854f27E7B0fcC1BD91a": 69.53,
        "0x7A8309F1BA9BC08E743A5d5d007E1844036A815e": 69.53,
        "0xcc7B6FC7267021930b79c84Cac9352c4127510dd": 69.53,
        "0x5FD2Bf679dC01E8f222660c712301B1899880099": 69.53,
        "0xc50222Eb72910322cDf4164cB8A220E2de0468d6": 69.53,
        "0x66E192109e228471C55D51b3D9E24c05554A385A": 69.53,
        "0x85f2421ECBb6E6c3d6Ba0A59E1783545B04E2ea9": 69.02,
        "0xD32Ee6605d50dd77f41C66b28742269854324759": 69.02,
        "0x41b289C60F14230944e3f88Dc11d7E127F7Fba40": 69.02,
        "0x714D7baF5067855EBa892296B6C6D94a09857010": 69.02,
        "0xD78D29bFcDb0Af513D3B740deF6C951D4aa554B5": 69.02,
        "0x89C8121115955831056958861c6800f0298B820A": 69.02,
        "0x927aCD5e72CC88fF836F713D52F5D7Cdf27750C5": 68.78,
        "0xC9e04d6f9Eb9Bd4008316E7aaCfdAf7f3F411359": 68.71,
        "0x9aCAdd3FC71F93Ba8f657E49305Bc442bEA89370": 68.66,
        "0xe0a46Db77FE3932a901214BFa0A1389d3E996332": 68.52,
        "0xc515B0Ff0f47FcB050EABd0eF1E176ABba889b8c": 68.52,
        "0x60e89FEB6dF8cd089D99ca9FB2cd3bB092549F00": 68.52,
        "0x2F9021771EDe6A07324aE62CB4864105691248Fb": 68.52,
        "0xAc6eA2D5953f827e1e0046AB276A3C1A01e82fE7": 68.52,
        "0xE0822d2501e9fa58b267D4A23df33d88ee876f2A": 68.52,
        "0xf829f3B414f75e5AB99295eA14bd2372044434F4": 68.52,
        "0xb9cA67B4eAB3ba7e58D4eD3403D5Bbf6e04Bc957": 68.52,
        "0x479A6ee7A08439303Cd194D5B234E1603Ac38c82": 68.24,
        "0x46F0AaCc078A848cBc33d0a3bDcAA614AbdCaD59": 68.01,
        "0x92cA794AbEE06a3571c8Eb92E42E5e6f5BD5CE54": 68.01,
        "0x12B21D1E73B3b48d73dA04Ed05417B392c7FE55f": 68.01,
        "0xbDC6F5C462C9B08c90dE285355D98aeb2Ff25976": 68.01,
        "0x1A2923D39F11f4b0A47BcdEC29B30eC273dA0932": 68.01,
        "0xEBcC98573c3cd9b5B61900D1304DA938B5036a0d": 68.01,
        "0x3Da48C5E033EDC7Dbb3bcC1e68293753c1Ce9cF6": 68.01,
        "0xa52b701828be7E8E1BaC3DC55872949E93fC01D0": 67.86,
        "0x00C7ecc4187F239e09D4cFeA5aBe6d3c18f923bC": 67.74,
        "0x044CD5f498ddbf0ea854aB4Bc96110756b26de97": 67.51,
        "0x80b9fD429F47dc6a7f02aCff90A1959956a19607": 67.51,
        "0xB0a50F6de417a1d8A225110d0d32333267Ad80f4": 67.51,
        "0x772f7D3D955CD1CE290b1Dc671267D7204Ab6098": 67.51,
        "0xb282F9A8ECbe13667420F0F3B3925f004a0380A8": 67.51,
        "0x566819A9ac46652d520E97bf5777d737481fb988": 67.51,
        "0x7Cb6329eF5A332e8687888D604b03Cf9aFEfC944": 67.51,
        "0x06DD52564B68DdE77B4e9D4e0e5D325f9a86746D": 67.51,
        "0xDAFC75A50DD4572C27dcb339fC977A8F4d323D53": 67.51,
        "0x1c0D0AB4Eb517556197DFF3bf4dBB9481702d516": 67.51,
        "0x688B5c7B549339922C0D2243debE2Fe921A1A488": 67.51,
        "0x3BD21b822f6622DC4439EEBD9F75362C5a8538c3": 67.47,
        "0x0cd86b4C5125Ea2713574AC763fB28F15E228c2e": 67.01,
        "0x6B36502a604bceDC6495fA1596c19fF1b7A1BF81": 67.01,
        "0x24dE90e08999FaEd07011A574104Fe57f3465f96": 67.01,
        "0x4F266f295BaD85436ECeA51E0Ae2afe82B11553B": 67.01,
        "0x444BAcCfBD402FAC6e55337e527806Dc8b6E12bd": 67.01,
        "0xeba06532a72bec44A1d33130aaa7C45c31e502F6": 67.01,
        "0x064E9ea8Eeb3EA9A0e68b397Db271fb7ac525E33": 67.01,
        "0xc9273A8Bb0bcbCd5F6a97f19977213ae9a9dEc5f": 67.01,
        "0x8849aF5621E16b3661D2d248756e65435999e60B": 67.01,
        "0x367F2405f1346b64247FA08C64bcBbfFc41232a0": 67.01,
        "0xF5aC0E0AF8D819c5C836A86B535B21B37153dEA7": 66.56,
        "0x28Bb9D8Dd55B47301F7068173a396E46966788e0": 66.5,
        "0x9CF82254826b5836addCaD3610B9b997999d7280": 66.5,
        "0x7A205a4a5f1cc04Cfa751B030322804A0EB42d33": 66.5,
        "0xed8b78656901517A8BBA181FCD6d697173FD3F0f": 66.5,
        "0x39BAb484F7AB6bE53Dd225ecE07504806fD965D6": 66.5,
        "0xc12C91a0a0e647a88702D3637D9B7eB035E2a120": 66.5,
        "0x3b22ac2739a20f2511F21f06EE6e013F690FBD0e": 66.42,
        "0x7C578f2ADeBf07973805d6062bd021D5a8081Fb1": 66.08,
        "0x13B4ef8C42b873fd1fF9ED57C5878375B64a1807": 66,
        "0x17E5a662B373673475C51b6DB9d79Bd291dcE573": 66,
        "0x317aE3371f777ADeDaAdE238B832311807f5Ca26": 66,
        "0x75AeC9656F60d412446B8e58A764024B27174a8B": 66,
        "0x274dDBCc68Ea479d8b9D0BdF3159De04E42Aee05": 66,
        "0xCA48D8a27BC1c08620d0b1d66b7790310be75e79": 65.5,
        "0xcDd393f27957744926a135528661C198ae867bba": 65.5,
        "0xc1b9F63F0226EfB1019425248E8af8094A7595A3": 65.5,
        "0x0d307D9C8B6D4aaD162A662E4bbFbA9Ea96A5F81": 65.5,
        "0x920f9Fb367C457819aB678aF65A854995D74a0AF": 65.5,
        "0xD0a2Fe011342c2E59A81866aE5Bbd6E13C6C572f": 65.5,
        "0x868bAC4cB7dD8B86A3D6683ce40fF134C06f928e": 65.5,
        "0x80E5A00D8B33B50C06121be5440e39720E683c26": 65.5,
        "0x3Bb8d70932685E75fb11c166b2c30F5B0a0c959e": 65.5,
        "0xB46C872FE2f96ad7a39645658F719B535DbA6Ef2": 65.5,
        "0xD51dc8660C014c1Beaff0f2085C574752800351C": 65.5,
        "0xD3B3abffaf8051E398aE48EBe001aed0Cdc70463": 65.5,
        "0x49DcfE2aDEC314C730652CDc3184c962eEf10a82": 65.5,
        "0x17F343182B42D6488FC54B6ae73ac5DA5Ad4E326": 65.5,
        "0xE06E25050752d1578088af88811D19063c2F7ed5": 65.49,
        "0xC957307AC8BF080247985A56E334541Ef35d7124": 65.42,
        "0xd1fEBA0bf3e3f3eb6b9A79c2E54Fa0Cd47672727": 65.4,
        "0x42162A1d3B4E823e431817789Ea2DF1D8a1041f8": 65.38,
        "0x0583C70b6Ec91bdd65aaaf5bD89091c8E4fA3cE0": 65.3,
        "0xF2a37434df782218Aa7C116F4b6B0f08Ff931Ea8": 65.25,
        "0xBb9f4BA12c768230cb536fAD5d57B7DEC8ff8632": 65.24,
        "0x3E8CAD695E4E47DF8D5abA7B7f412c07dE180711": 65.22,
        "0x8b0229F9bD45b096766232489C8231CF4FA86BDE": 65.16,
        "0xcf8d4955E5479E357Bf1b8bD0e4956604c2791f7": 65.13,
        "0xF195a2592EBe67C8d9058F3798aB18e8AB5F24Df": 64.99,
        "0xA6040115E1A7E42D6c60FAe6B1354c635D89c970": 64.99,
        "0x8B26149A06752417E9c4ecaAF110AB80D8a39A3e": 64.99,
        "0x3b528d4aB08EF019972E6bD7f40D55ab35c0846b": 64.49,
        "0xC0a5906059F1612cC0eC625d8FC4BE0834D73786": 64.49,
        "0xD6d29cE0996F3bE82f171Af75c64ecd61549112A": 64.49,
        "0x6Bb48ee6dC739Db470e29E3DCf0c3B34E94277dB": 64.49,
        "0x3E863E814b6f40856DD492a4ABf6e74b2DFaA815": 64.49,
        "0xE006E905De2C1762fe90D216eF604F3E628465b4": 64.49,
        "0x76aE30Af1B9747C43cf05Eb3bE33c827c182A5A6": 64.49,
        "0x700d4EABCe794e75637564211C0DF62701Db59ac": 64.49,
        "0x74e197e1dFB1a3094ACBCc0550Bab7fef9E43873": 64.39,
        "0x7F5CA5B57f13c4aF875053D65dfE2f5afECF41b4": 64.28,
        "0xbCC630A84aA4f8fb9420271E8a16cC06dab57158": 63.98,
        "0x72a8915eAa7CF2709dC89cBb3837a098c9D70e09": 63.98,
        "0x263E3976962649b128d63df6c284952E02F62729": 63.98,
        "0x4177a5c0E2369F6830A4c3825aFc8fB3Dd47790D": 63.98,
        "0xDDF78C235FFc36EC30381ae12314fE47A236E29e": 63.98,
        "0xaa27F2F498a525dAb10bF632178dF529C064744F": 63.82,
        "0x904b79E00059c0527B5d009b4515Ed530C0Dd2bb": 63.82,
        "0x4c7d159766b244C78b5248b176af8c7BB1868501": 63.48,
        "0x8a89Ee675d4ADeDDAB41197385A20c7a5b4CF1ac": 63.48,
        "0x945d5bcda8dCd9Cd8b221fd23CF4b6C0E7e50bD5": 63.48,
        "0xf286E07ED6889658A3285C05C4f736963cF41456": 63.48,
        "0x3967D78660bCBc95c625d58A40C42Ce10bd905D6": 63.48,
        "0x5a219e0846Af2F551ae29561366cE40AE1E13AbF": 63.48,
        "0x9433a650937374324c8905b22d9ab52B66544b24": 63.48,
        "0x34bF2E2339E0cDF3954820177125b1e60a79E36b": 63.48,
        "0x408132a5c6b09Aa8DfF7b877AD9a3d3fe6ABdCc3": 63.48,
        "0xEb0A7AA958fa2AfB37471e3A45d5DAbBE02E38f7": 63.24,
        "0x0435BBa479C458b08d049121D68e9bCa8B9Eb10A": 63.24,
        "0x3ca27E21d927aBb5b764C7f84c424897B8297e1f": 62.98,
        "0x2335f60e3e1c162b16C52943322007D30A3135Ab": 62.98,
        "0xb8cfdB541e0DbB5C2E6415Ea4dFFf60424145283": 62.98,
        "0x4B8c833e4E6d9Ad4154754412d549639B564338C": 62.98,
        "0x65b8ee88Cd729b00c574884f3404678bAc479dab": 62.98,
        "0x7EAB3561033C3200E294A65f1C2bFf5C098A39f0": 62.98,
        "0xed4b0Ea4BA23D0E619ffd058f63e941b495Feacb": 62.98,
        "0x6eAbE04636a21156A56BB3ce4096ce49DBc280ed": 62.98,
        "0xF92AaE42cb0d6635840aE3Ad825283089aC78c67": 62.98,
        "0x539460Bd8D7d6130ce6C4A65c0b59DA3b3d2da42": 62.64,
        "0x36790e52E53A14b7E23FE0aDaEe73EE291c1b3A3": 62.47,
        "0x1d35cb4B60f4e86e8BdEde3AC72E9D0492494828": 62.47,
        "0x45EC431Fae4fBd986cd7743ADC656Cf8AC96980D": 62.47,
        "0xA177D003fa7f0d865a42fC02b5fDFF4d44386585": 62.47,
        "0x87c24Cf077cDCA8BCAb7e3953fe079Df625F0a40": 62.47,
        "0xa5d7897e2779f7E5c5Be699D41a7B42f9cE0A5c2": 62.47,
        "0xF5b18c7BB5D760a7c899E0c48d855DC5A49f1949": 62.47,
        "0xe4F077BF767a57Ae9aAD77B0aB54CbdE0BEde65A": 62.47,
        "0xCd2Fb8A5A9A89Bf9166E7d2ba5D5e887E7e8F0E2": 62.47,
        "0x968B3Ffb95272ADa40E82ED2228d31C3fc3EBa00": 62.47,
        "0x5356df73b293BD9c6e8eFD22C99833391EF8821A": 62.47,
        "0x3Ad2280901900B19AA2EF23da1ED41712D8a6Ea4": 62.47,
        "0x087dC380D1da603a9ea42221AD925c00246433Db": 62.47,
        "0x9D32F1e7C5fF707e92b4B30937A1e5E2C2De2462": 62.47,
        "0xcB089a1407dC404DDcaA599E97df6E89898f7CE0": 62.42,
        "0x7715aA5b1C6e1621febb868FB0A1c851427f8555": 62.4,
        "0x5eC8BcC899bFDbcd4b0a8b1906904294E8ED99d9": 61.97,
        "0xb4828D78d468dFDa9b35fEbcC73b50bE51D28b11": 61.97,
        "0x64836f2ba7f1036d5126ad20A2DC0FFEf119A63C": 61.97,
        "0xcD6d90ba70b8c67B1997b4EcdE264B73cB7Ed760": 61.97,
        "0x7b0f99A3911FA3773C8fe173f69873d9984A2BfC": 61.97,
        "0x8Ee25bb8D6777c21cEffdeA20583856c620DCae1": 61.97,
        "0xe2ad9135cabC552Fdbc5F60c694fbfC5A9B8Ae56": 61.97,
        "0x3abDadc434e6408D676cEEFAd21E5Fce85020b26": 61.97,
        "0x0Ce4A7444f68acc7D718F1C0485742578B5c0dDB": 61.76,
        "0x33e503B5bF532b179391321c5c17e14fE2cC3122": 61.46,
        "0x7da384f6A1d7316A2fa1Ff217Bb074d68121348c": 61.46,
        "0xA2BEa4a6C798624DE209e1273FbAAC14E76213d4": 61.46,
        "0xa3a442c7bF7f5B444Cbb604b8D3425ca20EA1E08": 61.46,
        "0x8630821Cd31ff019e7ADDFe0d21c3f401A436D0F": 61.46,
        "0x97891Bb5a666800D2F07C27Feb00ddddb69AF221": 61.46,
        "0x510A4cBd16B65ddc32E3392B246Eb19005332a80": 61.46,
        "0xC51feFB9eF83f2D300448b22Db6fac032F96DF3F": 61.46,
        "0xA07D83334758Af046DbCEe6991E341C0E061d121": 61.46,
        "0x7A25761bBe5994A2139B2795cdd34eA2Df44fAd0": 61.46,
        "0x470129d550acb0D7C9b78f18806AA23688032e1E": 61.24,
        "0xEAD94B5e23445839d6e38EaDD9f81957D16c86E8": 61.21,
        "0x191e0285E4F25e44b97294e2CD6067189202e83A": 61.09,
        "0x600890bEdcd4f01a9E6fC193C0F3a82a95Dd7f07": 61.03,
        "0x5aa59f43E9E4dbE14E28BDC34A7F9E5E9cC5Cc1C": 60.96,
        "0xf5659d33af64B5B987F048a4Ba7cfCa1C96f7F7a": 60.96,
        "0x1cea4088E5800dc88EfEC4309aA87E656eD8dAA6": 60.96,
        "0xE729E82C62bA98Ee226DbF680803CFB4189DBE30": 60.96,
        "0xD2f223de67d69E0c576A3a5f8A300CB02E79941d": 60.96,
        "0xc104e475bdCB9F219265e9f371588f163aa9bD5D": 60.96,
        "0xB7770d333377B7cF3A6B3DD609f9C50E3A9e5B08": 60.96,
        "0x00682C5BFA15039FE6FC90dc9eFd129e758319d1": 60.96,
        "0x7fd8A3e656C90A0e3cd703e4bA46aa4C9d9e84fB": 60.96,
        "0xb22C756147b846E5A97FE4019EB6C6b243892128": 60.96,
        "0x3Db758C6cB69062AAF787110D98fd7545092D181": 60.96,
        "0x151ff7b4933441a0404F09b07D9465F6c278D1c3": 60.64,
        "0x7c22953Bf2245A8298baf26D586Bd4b08a87caaa": 60.46,
        "0x2e40afe82d94E53c48655E8D5233294c62f85831": 60.46,
        "0xDbdE6081017F0a9F88DB0b23ea731f75e5285242": 60.46,
        "0xc4ef6744a3a8b52545685549a87b438cd51780Dd": 60.46,
        "0x51711385F735C6B6B3Bc22866F845A2ccAaBd06e": 60.46,
        "0xC8440beD5E0f9F9c7a6c6e5e295eF00A49F8C321": 60.46,
        "0x820E3671D0B32A40f62962A936939f6E459D898c": 60.46,
        "0xc5fd654bA7c9C9d6b5710Fc347c1306e855Ec582": 60.46,
        "0x58b08Bd3b495994439A16cBD6EfFBEcCfe01f634": 60.46,
        "0xB872E90d96Cfa33eF31FF744F8beB9cFD92388B2": 60.46,
        "0xEA15d58Af42EB6cDC9D6840AA317257999eE3fd0": 60.46,
        "0xC8805b64c6dD27Bd030bCd2bE2c83e739f764a80": 60.46,
        "0xE543cD990f107442a3a694FD36DbAF4068DEad06": 60.3,
        "0x308Bb413C833678f9a168b7B21B9CB0270999963": 60.19,
        "0x9eFA485bF9965D3E0d5b40cbA6784190D728f162": 59.95,
        "0x90a14725b01A7e43186bCAFB6E9C49e57953464c": 59.95,
        "0xaf61956Bc12c7951a5A23D7b5dC088D4750a4813": 59.95,
        "0x05bf2958C314fa1E1D9A64fE0Cb16A12C6304F9F": 59.95,
        "0xD1DEee713b0404b799f67bfCB64e0647C14bf11f": 59.95,
        "0xE3501040BD21e78D954B90f60930eA349256fD66": 59.95,
        "0xec9D209252fE238037021e6e6B1aC99cF7f46dF6": 59.95,
        "0xfbc905917240A668Ac95367eb04666E6C1cc1B0f": 59.95,
        "0x37aDB6a8B29562a17E4F776E905796D674c3fD5e": 59.69,
        "0x05eA88DfcCE934594d367edB6DC9A5E4B3ec28F7": 59.45,
        "0x1c7a8e5Db7b506c8b2F306406F7946515a9E9617": 59.45,
        "0x6Ceb397b68059Ca73049874D0a30c62500aE9877": 59.45,
        "0xA74e65f8beE81a717de22cc49d798cAA11fb494a": 59.45,
        "0x0833A695f0E9dc8553Df85Dcc1451247a4aa125f": 59.45,
        "0x99329a9d73f7136EE28E344Bd85132eeAfae3FDC": 59.45,
        "0x63BFE79845300E314cb0f01D23b1f19E341056d9": 59.45,
        "0xbf6e93fB31A9b2F6818004995d89eeE73A4cbeac": 59.45,
        "0x662585f660F1c38b0150bffed74096Be688fd076": 59.45,
        "0xd93f9fab707B98581294e253e280b9387FaB384c": 59.45,
        "0xdc198967a5574E8af893931c91D5e0Ef6B2F91FB": 59.45,
        "0xA3aD5CFb4FF4B68e37A338Da200BA441C1850B5b": 59.45,
        "0xa38BF0afB2D29174b62a7Cbb7d1B25883A1ab480": 58.95,
        "0xeFF4b928039078B70F72b8EE592C0dD2B400309c": 58.95,
        "0x69856bD74e1B1a6cB8745C577B8688d5B6661AAb": 58.95,
        "0xc2F9eb13D16432C4FEF25048cD1B287fCd58944A": 58.95,
        "0xC0E47B66DEd1C7E2d2403d7567804e3eE6b8F2bC": 58.95,
        "0xAacCf2110F87aDc33E14Dd124B631F6400002A56": 58.95,
        "0xc60EFF91532443916B50A96cD0AD7CebA08288c1": 58.95,
        "0xeA785F32dffa4532fCAd90F0A067786280AEC2f5": 58.95,
        "0xB2Cc26FA2918D474fdC87c0Fe6dbe2b2F69efB57": 58.95,
        "0x8A830F105a42e705CFE3a0295dfCFD7259ED4570": 58.95,
        "0x94d00d5FFa4838CE422F3f1B534429D5A34bB0FA": 58.95,
        "0x9700c58e1C6a1e5fcA5Db5f62e477EB182fE3dA4": 58.95,
        "0x7110D94153cCBf0a6F9D11527648549516b4C809": 58.95,
        "0xC7394eF373C15BB9f487a92e526D81a29f6097B1": 58.83,
        "0x2978e77f1B027d7BaeFF2FE2B56CC4455e627C8C": 58.6,
        "0xA6c7a72034F4df2E42E8711bf47c66D6e1a3795B": 58.57,
        "0x8B90d55362b68183d168AD4D44C3301E1f685F47": 58.56,
        "0x4eE976b121de67Fcc77140cc36045E18Bd3b7AF5": 58.44,
        "0xDf17F05EB4cd1876f1C4E18517B255Bcbe94D88c": 58.44,
        "0xa4831321aCf9920a19941c45eA6472ddCcA34b3c": 58.44,
        "0xE08F6374dAa80E45c28e17c1ab806d60cbeB4686": 58.44,
        "0x1049c923fF19FA5088d2466F942A1dAa79D03d85": 58.44,
        "0x5208C58fB7e4561453EEA7622430928b6F7cc2FC": 58.44,
        "0xe12D731750E222eC53b001E00d978901B134CFC9": 58.44,
        "0xC579B72fe7986b64A84948f8A41c4BEe396835b5": 57.94,
        "0xE13E5Cb1feA0D1197eC5B9D50F3AD26C68763F5c": 57.94,
        "0x358310ef71DF3B048c8D6637A72Be7bfAfEa5c7C": 57.94,
        "0xD10c1617e7afF13759Ad45AA373E89d5251B37cC": 57.94,
        "0x0d2e0083dDE4D115f842C6cfC59Ed17ccA6Bb7c9": 57.94,
        "0xa57b927848e94110898C56C5aDD293378706D638": 57.94,
        "0xFf1a9BB39640BA98439A9E1771d125D082f45EeE": 57.94,
        "0xA81f5f238D8F0D8523D73f9e8Ba78F538b01f1a1": 57.94,
        "0xf7a4629b791691FeFa99925fB890EB89F316D284": 57.94,
        "0x27254961dF563174222e1a09E41279D0Ac1ee34d": 57.94,
        "0xC0D9397597AB85Dfa4f82F3a69e2eefd246a6D6C": 57.94,
        "0x9Db3B4Adc4D4e3e60C9d2761ecC913a68c8D0519": 57.94,
        "0xcD3BdEF98593fA91FAf0db167B13cAE4d8a3b886": 57.94,
        "0x9E82973a8b30e7FBA8256c3C48C10f63B4D64360": 57.86,
        "0x0e61b43EDc0CE0e4a0216FdF36e03e51Cfa95d73": 57.76,
        "0x94824d798C4d2fd2e093EE4e0084d2f1F75F7554": 57.43,
        "0xDC849Cb277D665A4d2D86220eeCFCF5f2B5FFf47": 57.43,
        "0x9dfD3E093CCFD86415B515125304742EFF2d17De": 57.43,
        "0x417e8accDF7707AF31C581D0325382580ad58DbD": 57.43,
        "0xf4e262A2165527727CB51E6ecc0B103f14ac4CFC": 57.43,
        "0xAC8557B877e3Fa9E5F21185929E17515fBA1C2FB": 57.43,
        "0x68f4d9D075F5d3de2B2fEC6A461002c0DA8F31dC": 57.43,
        "0x04DC2f801b92f4856919Fb4e9E006930BA86EEe7": 57.43,
        "0x3C44d74a3BB9CACD11bA62eF01A4bA95a58b6Be9": 57.43,
        "0xD7a93a650bA0C438B43c633d9FAa864a58409d27": 57.43,
        "0x0fD8cc330025F1Df694eC1B15f502e6DD60838Ac": 57.43,
        "0x9d00f77E254E62a6412EF8a7af10e2e3C3BA7408": 57.28,
        "0x07a1f6fc89223c5ebD4e4ddaE89Ac97629856A0f": 56.93,
        "0x3D0A9EDAcCb98402dd8a769b5A494EAE895c49fE": 56.93,
        "0x00035696666f096553adB8Ac49d2FF1339c07B8f": 56.93,
        "0x1b2601C417Dcdf034fC688B912C4aAA52F146742": 56.93,
        "0xebdA956c7edCf77154489aa1368fD46BEf68f603": 56.93,
        "0xD4ac2e147c8065DbCaDcC64B9d108e847Baf6382": 56.93,
        "0x25f0A60D95fb530435F733c8e480C8c4c1619D1e": 56.93,
        "0xd2675C768a1506305c7541FC66c50F320C7C1F35": 56.93,
        "0xF540acCc324cFa0Fc97017D7e664Fe95A800d997": 56.93,
        "0xb8Ff99c9aB9C920372343a87f6E0a2F0F2db71A8": 56.93,
        "0x475b3662009E29c243a35c3D814C03b4a9f467f0": 56.93,
        "0x67Ca1BE725C35B65c7429892de87a897ADD7f30d": 56.93,
        "0xC68310Ae77C9492c7675BE4B971444bA4e09B911": 56.93,
        "0xACe742Dbb04AF172eD4f19F6150f1a71986F7227": 56.93,
        "0x2A1CC2F5DD5DF2b81D010DF67bCF272652c84C53": 56.93,
        "0x34d0c3E912baB2ea82136847dc5Df4dbc95e3D1D": 56.93,
        "0xC872CD0638c73B882C09258D94284da15C46Fead": 56.93,
        "0xFcCBBe08538662d3f9F76a293575F9a6604129c5": 56.93,
        "0x943980b467fE194Beb923dAF7A544aBce90b5f93": 56.93,
        "0xf84Eb813483163a85a4109723D3947c60684adEb": 56.93,
        "0x10ae381a762a9cC313346D248f6AE8D179b8E5bd": 56.43,
        "0xEE6C29D19AC7F94A2D100a9a6bac8491d1C5BAD8": 56.43,
        "0x670fbD72155b2aE2e5336C82dC62C8b22eD4BA09": 56.43,
        "0xd4De386605f61641c3CB0c9c35487A3dD4E4bb83": 56.4,
        "0xE7609313d93Ed413f102B718f7eb9D43ce9Bfd6A": 56.23,
        "0xe8e1b4c0Acf7A9a4C10381457ee54eBD69F2dBD3": 55.98,
        "0x484b155236F5143B901B3a6e1DA24c7363619Efb": 55.94,
        "0x13d411C6BEddBa45FDaF25E8fCC6824BFb373185": 55.92,
        "0xaDc83821108C2382A4cf96B55B8c75134f061d9e": 55.92,
        "0xd2E817AB8f1702D857b7018526176F3f4858E19C": 55.92,
        "0xB46D5324a77351BD0357A7C9C8758C7d9F94d125": 55.92,
        "0xc64956114dE761Ac3Fa4123b0e2aB7cF4E24Acc8": 55.92,
        "0xc4b2286bE2635A4CE1C986EDAb361f7391837cB7": 55.92,
        "0x603Ec88ab7260C0eA063d1b63ad8D01d7C30e9A2": 55.92,
        "0x79912f3582C55D57A8ccf1c2fB59a55C0C74A089": 55.91,
        "0x8cDa69c53710C45E699169485b31eb409e511648": 55.86,
        "0x0aA85ef44e42425d2F3a68C82f9564f3b176385c": 55.49,
        "0x2d9037c11A3F238bb8844F281aD263042aef2ba8": 55.42,
        "0x51E171d2FDe9b37BBBb624A53Ef54959422388E4": 55.42,
        "0xb636BC1B0952951e1F3eff2Fd30bA4bD67F798C1": 55.42,
        "0xe51e38A5Ba9c686CE6d699A64Af885E1aE42262d": 55.42,
        "0x051113f273942Ce806965F471665B6215B198A88": 55.42,
        "0xc617D8f0ee1c7951B03831F56DeFCcC45C9A325a": 55.42,
        "0x7B329c7feffaDc2217D9745E6e4cd28AA5434363": 55.42,
        "0xc8785C18f948DBB4E27c64138E252f4e8c35EBbc": 55.42,
        "0x99d6d24012361620Bfa1a3f16d4e745066fC7c69": 55.42,
        "0xC5Ba2B86292a73830CfE7619f24f4FcaB66E398b": 55.42,
        "0xe6318Ac14Dc1235E01aF21d354088118e15783BA": 55.42,
        "0xDF23d6FD44249716a515bdddc81b82C18b915345": 55.42,
        "0x60A299bc654Ec399373Fa377B482321A90220051": 55.42,
        "0x7c12CD5b7Db841f7Ba9B3fd1B7a6D02C1304386d": 55.42,
        "0x2120b403B391F47F981dcDDE342Fd4541541419c": 55.42,
        "0x75FA74606B95877AABF6BEF66DB511C36492E66f": 55.42,
        "0xBB9cef1aec2A7dE1bed08eF759fe76bE6BC71A7c": 55.42,
        "0xB0d0058e6258Cc41819F50897606E0d6D5E6EDF7": 55.42,
        "0xeb6049F54e751d7B924c9620fBFF3e9d69325090": 55.35,
        "0xfff0ea0Ea835F5b29e61bDAFf90012Cfbf4F5986": 54.92,
        "0x86fF945E6DC2470317ca082A01dE7D24188671Ac": 54.92,
        "0x0d6C65719E7208D15E2D1E0025A6FD1993614a47": 54.92,
        "0x1525D8fcAD680088245055fFB43179367D3EFfC0": 54.92,
        "0x4ED1fDaC5009b9470dbF5378dab55B1b7b591cFF": 54.92,
        "0xEC125008897EB009f55cD2525D3EFc4fc9603Ae1": 54.92,
        "0x78EbA07D1A3F49a697940266B27928c6696e2b4a": 54.92,
        "0x9866aBbb3b136feAa4134c5619A5e6a9b78fB6B8": 54.92,
        "0x741A7fFD7916eD69a517d2CBFdC83874525de130": 54.92,
        "0x309c65c98c56C4Db478Ec67D3d0c91738CbAFC36": 54.92,
        "0x8dF9505262083402d0850F85Ffc7F6D34bd38169": 54.92,
        "0x83Ed5f2CAa4EAB7312CE765c8960FD4d8C436084": 54.55,
        "0xc3204b9538639CFa1AdB0C3C6be66FFE42f2844c": 54.54,
        "0x6435Bbe51F00A4A8c886Fd4C6c78DB1a8810b55F": 54.41,
        "0x729B82d268cECf3dc26E5b4e746e9BcD0b9e3EDB": 54.41,
        "0xfA53B8cca72C61794eBac3d54B54554AA0F4229d": 54.41,
        "0x04003e7b28D08bA3A3F9111702Ca8279d786c74C": 54.41,
        "0x0f3563D5A39f6Add7E60630BD14f9D8dED0CDC5e": 54.41,
        "0x73F7EaaA5726562B99B71f274b91cf0052f7e4dF": 54.41,
        "0xe6569AD1cf54b5f49Be0218e42e27100E63c5f81": 54.41,
        "0x1561b90927967f28df09bc81dd4626fE8bDEF7a2": 54.41,
        "0x7d6aff9f85EF8802a1492189e8021B085c6B37F7": 54.41,
        "0x3d93e77EACde0c32f71491E83D389B334C240216": 54.41,
        "0x81FAECCe358f6a03eA619f5847281aafcFFb8E22": 54.41,
        "0x142769F06e9ed0fA58BDee540BE49014fE0c9c7D": 54.41,
        "0xc8aa83D7a13910536363d7C55599308fe2718C10": 54.41,
        "0x0524f2B8765Ee3A1a033311dDc9e2DcaaD34b8C3": 54.41,
        "0xE4Cf7e6feb0AFC7f5cf201F3298b274600F8A8Ea": 54.41,
        "0xb0be01cF3a5CDe8A86E1A39367EA997f5dD08372": 54.41,
        "0xe20cb5B152bb1b0C51b466f3Ea46ecd13aBCcEa8": 54.41,
        "0xaDf18a2De81cCd3bBd64cFDb665316Fc34eA90c7": 54.35,
        "0xeeeB3Bf2e6B3dC5e36aA05c004a9ae54eF50dd50": 53.97,
        "0x9DEd50ae9d043e1473F7159C0279Fd1631153f41": 53.91,
        "0xe3D2a9cFB702eD8AA1A105eC8a0164D6F237DC57": 53.91,
        "0xFA6573fbDe82A52D57b12f98F396ED805a78276E": 53.91,
        "0x4DE41A3a55Eb23c714938309E0D3172d04903D20": 53.91,
        "0x6D6E472aeEC3F54509c6A805B8B216df2aD99c19": 53.91,
        "0x54e708434FD1543830556B8C952f63337cadb01C": 53.91,
        "0x54cFd92459049F2E21f46D9E5e2591dC9B136967": 53.91,
        "0x98d182B4e4Ce5e0cd008c439c32ff1cAc18E036B": 53.91,
        "0x5E7765D3585058C7ad2BD69008Cc551FbCD0EC20": 53.91,
        "0xF7C0D5e897666Ce6590a749fF1bD9Edaf7EaB2a5": 53.91,
        "0xD82FCeFc172F860cE2bC94c0F9dEC666ece12E52": 53.49,
        "0xC292573D51097347bA34Bec624fD088DD3D0314A": 53.4,
        "0xCD8E9278975E66e5E3e7861D9f44DD159Fc4dBB1": 53.4,
        "0x36fB3C8D2174285888A97C6F398a8bA91673eee4": 53.4,
        "0xd3e211AbE0b89DC01c97047D19E0AAB9f8b65d2b": 53.4,
        "0x9a9BFA5fF9f86235779814D43F77C7669F6766F2": 53.4,
        "0x8cbe0e70513178e65Aaf6721955F6202262145d6": 53.4,
        "0xF057F269731f1E10f4cbEc0D5AA22A39c9F9F12E": 53.4,
        "0x5775f4A21bbEacd01a08dE854096982aCD42860c": 53.4,
        "0x34187a8d18197f8C04a9De76AD56575273FC7451": 53.4,
        "0x5710671CA8cb234255e5f2a0E2531C40cC51c65f": 53.4,
        "0x54b9Abc57e4a69f6e20a6049Be930Ec444a9005b": 53.4,
        "0xC2A091bB852CE978D9D6c84151092060f34C4A43": 53.4,
        "0xa90ab1B586b6b750798539269bF4e9650e82D8B3": 53.4,
        "0xEA34cd01c83acb54De694EBd56A1dBdEde20e63d": 52.9,
        "0xCf0db1b6b91097d462Db5dd817336d703005315a": 52.9,
        "0x4Df0Df2d3780A192E4EE87cce6156c562904e940": 52.9,
        "0x58E03d622a88b4012ee0a97235C6b110077FB867": 52.9,
        "0xEa4D6795f3ec6819789543455a27159Fb5129F74": 52.9,
        "0xB5fC01D2C965cA6B6C75559fFA3e7Ed79311Cf04": 52.9,
        "0x284B8e24174202C2674b31C3BD0c054e81073480": 52.9,
        "0x14C88824ff6C37d6Ad8D77a30E9e18c14139A510": 52.9,
        "0x48b576c87e788a762D6f95A456f2A39113b46950": 52.9,
        "0xf00408DDcAf624129cC0D08AA122A7ABE1f2EF31": 52.9,
        "0x5d3C0C7ca02B1e9ad4Af17fEb6D71aC8509039Bb": 52.9,
        "0xfcA9895a7dd0545C3D648f7EF235E546053946Ca": 52.9,
        "0xa1e47a8921542deb1563349B2C7f45a74248f8f9": 52.9,
        "0xa172BE302b24DF2C0C095D03F6c8459e6b83D894": 52.9,
        "0xbF0E80E8544548bBB2dAFE3191f8a8f64Dc97Dd4": 52.9,
        "0x08928DCB5bD0b58F8DE51921EAaDE7Da8146d259": 52.9,
        "0x586634c272DFA3894Ee9B99836541DeE35660F34": 52.9,
        "0xb5Cf96784B99AB3fF842170a234C22d7579775fE": 52.54,
        "0x4eDBBeD7850998F302cAF0727dFa333DC8E0E914": 52.47,
        "0x00C7870E3a5004F7e77f8aBB302b7FD25Fe67D26": 52.4,
        "0x2224e025fF675D435C739C15689DF32d3108e824": 52.4,
        "0xdE3aD8F4A7482014b534541bc55ba40F4FD3695F": 52.4,
        "0x4a07571Aa5d50373eB2C4BDE72fFC10a3e580E7B": 52.4,
        "0xeF8c41B482B0B3114218434FcEC8E97d3A67d91A": 52.4,
        "0x227FD2fD881Cc6c99DFCcc0FB40f2B1dc2f3F36E": 52.4,
        "0x7e1E1c5ac70038a9718431C92A618F01f8DADa18": 52.4,
        "0x7b2dcaDceaC7b472409eceECa489feE8B5Db2DE4": 52.4,
        "0xc5683aF5722720cA11E28aC6e0d1Df8ed8cB56ed": 52.4,
        "0xbc529a6513AE84602Fc7366a46c7BC26acF27679": 52.4,
        "0x7DB9C1383279E7Ecc3470e2373a64fcDE0d0f715": 52.07,
        "0xdab6F20e51A770E776E62C3DBe695683d45Cf859": 51.89,
        "0x53Ad39EAB8612A9118E92Cf48e2c4e8A4Cca4DCA": 51.89,
        "0xAdf3194180fC874D03587fEA704a062EE4a2FE36": 51.89,
        "0x1d759f67e1FfC39Ccc75186A5CdEBc7d1520e162": 51.89,
        "0x5EF15c21e8E265badC386CFdEb6FE8785B41D614": 51.89,
        "0x0A4b2413fc8F172633D8b146D0f3423049D84528": 51.89,
        "0x5d91C94fd64a08f9b9812c22f4da940b8ceDa4ee": 51.89,
        "0x7A8DaFADDBde6B2e321EA87331fdCD3CB64ab790": 51.78,
        "0x491A52E8BA0EA781C02DceA134E9F2551d3F2689": 51.39,
        "0x818Bb80a26FF5A6DFd52BAB54B3a651C5Da9e514": 51.39,
        "0x23Fb6239bb674B995F5501593F96C036600a7d6a": 51.39,
        "0xc7aC422595Da7c1aef9e2f1119a015272C27faF7": 51.39,
        "0x1af3F9eddd38b7926edabf2dea56B771Fe97A17c": 51.39,
        "0x3BDda96e2e17f5bE3dC78cB82CDa7C464cE8e56E": 51.39,
        "0xA408144f4432574009984bef065c9db36cf8D5CB": 51.39,
        "0x185541A045ED6FE9fF1142419B647CccBd62a04a": 51.39,
        "0x13296EdCE934D26d3D00f9845cC50049Aa7F6939": 51.39,
        "0x63552BEf42452622c66ba5312d368Eb74ef93ECe": 51.39,
        "0xaDCe5DAB9231E31A07C2F6eb346E0cBB1C5ed4B5": 51.39,
        "0xaF22B15B2B9af20BfF733350248BdE23E5a3246c": 51.39,
        "0x43213Fe9369Be4a482d58605d029705a289eab56": 51.1,
        "0x73d52Bf205839bB5B090aD68D8691A2462492bf1": 51.1,
        "0x89aAB05665Ed24744b0B54ABb2c7EfB121e69815": 50.88,
        "0x9924ACD69B59cCD26398f3Ea56De561213e10E05": 50.88,
        "0xe587188aB02f02280b00D8a7aA990453a483f175": 50.88,
        "0x14fA6410f7c2D81F4617a4C7f0dEA91235DbAd1a": 50.88,
        "0xC6e87ADF4133Cc61CacDA134e79c243De9dB3E69": 50.88,
        "0xd23A8EEB620c465d43b35A1736c47539bd7C11C8": 50.88,
        "0x62661B101ca48734668669a9F1Cb83c4889049F3": 50.88,
        "0xf5a42683d4458ba74a0829e1e6e04612422F9bA1": 50.88,
        "0xf9618180E75EC26240cbfddcb80A915E8218C048": 50.88,
        "0xfBAceEaCA257D55E44B044f9f24b565a28916d00": 50.88,
        "0xC9F10493e3777E2Bd9601B4A8Ed819E8ec329Cd1": 50.5,
        "0xa60451fC17739d27CE7B12062A5AB6D28a7C0346": 50.38,
        "0xD36F809FF66a9923A19F501794BfC0e7Ded82F1C": 50.38,
        "0x91817a270Fb9F03E00918FAE83B3fE718c1426e8": 50.38,
        "0xa63A35237441eFaC01C0F5baC0031BFF7628853E": 50.38,
        "0xBcaf219BA7C5299892b074D69398564dfdfE79f3": 50.38,
        "0x80e44d803017D8EA5195081190fB20B8c8b1d9a2": 50.38,
        "0xA502107CE1393D37Ba9E74CfBC70235EB9E8d028": 50.38,
        "0x7D6D20EdD56088FFE139992C06819581291A15D3": 50.38,
        "0xD77900479EF30963F4B5aA7d752b15795192eE15": 50.38,
        "0xDA739dB2EA0B6aAb2986eDB2AA69ab3EeDDC0C07": 50.13,
        "0x1E0b99570028704e9043b38E33aCCCdC07f42Be0": 49.9,
        "0x0Aa87866C86d4D4344d55Eb048B7f3f4360DCF08": 49.59,
        "0xA899eD6Dc41a7f6DCaDb018aAaA3222076982eb1": 49.38,
        "0xcE13221dFB4C7df00d9436BbD6F8d4f0fDe49d4B": 49.19,
        "0xc98Bc5372148aD3fDC9c641F34EEc46Fa8A33622": 48.37,
        "0xDeB1D51D7F22867Ee83f557acE7e0Bc9Bda7Ec35": 47.37,
        "0x97a8CE01a1906B69c6E6CfCbb55EBcC1266c078E": 47.28,
        "0x1b91f09B4876fD158Ea23D894D58fab7d5098545": 46.7,
        "0xB4Aec198499ec997E989De427eF6Af7d264a22Be": 46.7,
        "0x8aC750BD5969565986cB4Cc0c44A14Dd91C1a837": 46.59,
        "0xb79D01d39653dc873273166240B9BCbCd49ab97b": 46.58,
        "0xdD80549AC8378a43DD010E8375F3Ad5b63a5C228": 46.52,
        "0xdE5FCD4d7f98A22054E48a02dcB699336a0f8244": 46.51,
        "0xF7989dc77D68036420Ed59Ce0E29840c07884Caa": 46.49,
        "0x9be3587710BA175eBcf4a366f8E16E2d4882f42e": 46.33,
        "0xb9C1cAbd855A5ec9DB34aD53F1463858fd9a46b9": 46.15,
        "0x8faCD5bC702DA642Da00156d7DA5b95EdEf180b2": 46.11,
        "0x2136A0391F5267F4c3548014D246d27821b0B6dA": 45.95,
        "0xcb308dde5fd9E42A019798f325c3BDa98a18a5ED": 45.55,
        "0xf0A11bf379954777344a9B4766d6756820BE0B60": 45.2,
        "0xd6459d2657b7B68f21b314f0E5c87370FCb612bD": 44.53,
        "0xa690010dB2f2AE13809e4718277E3c83c8E002a5": 44.39,
        "0x7719e42e28eDEBb10fBe30CEBc986c223575d9a7": 44.14,
        "0x67ccc9C6026fa98140A34a13cF0a700f434674cE": 43.95,
        "0x003E640E2d54C0142ee8B83fAf7E529Db98df592": 43.56,
        "0xbB27600BE1aF729c86A3526F1E182969E605BFfA": 43.18,
        "0x9213aeB356A27D1F305bA1a5d011BFA57D5Fa744": 43.07,
        "0x7C8c8eF20a48901372775618330B294ab937C934": 42.69,
        "0x093A24dbf4d7D26a9c910b8c310c19bCC0eC25D1": 42.68,
        "0x835F4e94C99500bfEfe535d148123CEAC353773D": 42.57,
        "0xc4BF06C9063530024782d8425C66f4Bd540fc655": 42.17,
        "0x53fbe9e195dfd8DE773cE00eC66b9Bc4d18bBB3F": 41.84,
        "0xa2F279a2e4ef5770C36c29D40A6146648eDfb842": 41.66,
        "0xd9f1eB19C096b0e826e892265616eb3Bd95f6037": 41.62,
        "0xf3a5Ca43b774b30A74bc3D0d1eb85ff1dBC4c512": 41.47,
        "0x2C0c869f686965613c13E9216e9e8cAc3Fdc2A92": 41.39,
        "0xF0eA58A245929232697bef1A7E93e0ED99E64100": 41.33,
        "0x9408C19FA455Cd73cC7f4344E77A2dF693d59Fa9": 41.24,
        "0x62564184B1c5EeeeD993f3fF8A091C9C89dfb824": 41.02,
        "0x3735A92519bA6Bc055133EF5aBD5670c59A9Ea77": 41.01,
        "0x63167F2905B6194330435312BE0945d9B46D6A62": 40.66,
        "0x3d71DcCAdF8d8440cA7Af91De76c4949D52BEc03": 40.55,
        "0xB21dFa958442EeB903BbF516d01D1551fDd0446c": 40.29,
        "0xB6C820979ebBc0e42230B93D4490277eF9EBe3Fc": 40.18,
        "0xC8560C85A60B2cf4e16920f5a3db945D67C11294": 40.02,
        "0xeC57E22E66885a4326211445c23cf000eCa7712d": 39.82,
        "0x5EF0D19fcf77fD71a0B1B0450d491f2E4cbEA13e": 39.2,
        "0x4b1718580eA31f34bEECFc41A67f9731066D35FA": 38.71,
        "0xaA37b8869484b58b7c917eBb0b2206B8f0E2F983": 38.56,
        "0x86C5AC2E977BC872a1D1CaD57526D0d6443f0F52": 38.11,
        "0x0b19706cEb745E3956FFDE084922Fc979EbD5bE4": 37.97,
        "0x723fC361D72cC551fa5b910530c736632dd9f4fC": 37.95,
        "0x235D63f71be1ddF52213cCa25783911C068A5028": 37.74,
        "0x896db64AFe4699a6De120893787aD69Cd17b5d50": 37.67,
        "0xEcc13c415cec64A31d831B34fc75a264f0d4FC27": 37.57,
        "0x796eD225aD053A32D0AA93E509e2D22F87EB6442": 37.03,
        "0x9e068AbEA9ba3E92E8Aec8e673d07de992100584": 36.92,
        "0x756aBc0178D22a67285e8078D48EDf9c9294A979": 36.78,
        "0x0E069FC43054706D28Afd83c28A06c43833655e5": 36.73,
        "0xc345986e61C7D76d0b2ae3E021E35f6fB63B0f89": 36.59,
        "0x843E81c9cF1b4B92C713d05eCb3678d17A2E97a0": 36.41,
        "0x1902076e3a96D57dDCB520C245b8A2058701B202": 36.4,
        "0xde4EC86A7b72f29a126Fe1B5e566BefD6c36E291": 36.21,
        "0x0186a9aA28b0a0D0466627F267BbFfd06ab20CbE": 36.08,
        "0xfD40fC951F899D3bD7A32A05D1e5f3e08CA4e067": 35.02,
        "0xBe816D3cdA4d25ae118aBC80854849560EdBadaA": 34.69,
        "0xc487f0272ED14d8D5a31395EC0B458f9e8f068D4": 34.05,
        "0x44a4A9df6e2b995005ba1925E92997856faebc94": 34.03,
        "0x07F12B24E14B87a50E31d93232C02dFeEc72C075": 33.9,
        "0x58D38D9d36758Af61dbb9521faEEd24834Ef4276": 33.38,
        "0xD43Ae231037A9E0592cEd1F475e0Ef4e64C59Ad5": 33.29,
        "0xf14cD4b96298F87F20F6d1A4014A630621Fca580": 33.22,
        "0xb989B6Eb9CD780bfc37c3E9bD6B50DB35027207a": 32.81,
        "0x8396F091d13a929BA13e48D570883c43f6Fd9Dc2": 32.67,
        "0xFF167DbaB36A0ea67340E6B5343445A6bFe3BC5B": 32.29,
        "0xC5a0e3E189799ee87A3Dd03D4DD34F9E3FdA8d59": 31.82,
        "0xEAd20CdB3044727d38005Cf31b3c91Df0083fb28": 31.67,
        "0x958270483b345Db08347514E8b93b938624d6371": 238126.52,
        "0x1d810CfDF819e5714D0c9d4FdBd13226009554BE": 31.01,
        "0x2b842a77AF279A22226c1F002eBf9e9aA1103051": 30.87,
        "0x66f74eBf7C0A00b1DfCC95Abc5a64733bAfFa480": 30.87,
        "0x096d7FE8aC23daF67E539Dd10958F41312792bc2": 30.61,
        "0xA885e5a6c998390CfD57B15b023a03319B07b9B3": 30.54,
        "0x4f3F63af83E4a876e006CAd7e8506c02EDB444E2": 30.54,
        "0x86e8dcE118176B0034d77FAd96DC41F466eabeBF": 30.5,
        "0xdF57E392ed93488F107840dF68C40890A5c83d3a": 30.48,
        "0xdE7eeA833f8c33B621AafBa3e9C1eF7bc103d4d2": 30.47,
        "0x29d5895304e67060cf3a6b6a7701B29171Fb6dbD": 30.35,
        "0xfD5844867387Cecc3A0393b3e0BE32479Ea9e61a": 30.25,
        "0x0D97A67FD7B7798Fa64926805d0Bf0e223d4Fa1D": 30.19,
        "0x9A66d7DE381D5a4d50f76e3B8Fb354583b8eB262": 29.95,
        "0xe522e310BC6c7944E868e7d33c764B8e3FC0F12c": 29.89,
        "0x5869f1029108aC7dFf75Fde8626a499253aeb1C3": 29.82,
        "0xA92aCEc75ccF83Ce4e6317D0377b152B22867DD6": 29.69,
        "0x20e19114d8CFd0B4d44E2Ab61B60F4dC11771219": 29.64,
        "0x6bBa81E3a202562CabFDc93F84d717d0F86130db": 29.6,
        "0xa42E4685069F9E9D5345fa2aa85Fd1Af4F3a4dA0": 29.36,
        "0x113809434Ffec2D21ACF2850d24cFC882d21DABB": 29.33,
        "0x74FD655BF9E9e47725b22934CefC52fF45fB362e": 29.28,
        "0x0C847a118421BC4225b590f61610d0438C03f594": 28.97,
        "0x2C4D94cA7969C11cCfD6E058241aD41D071D05cC": 28.95,
        "0xB5Fe78b6D216EBf79408613352bfd007DF9194ad": 28.93,
        "0x4aeCA0620112540B4468cbEf7975FEd3bD286DFc": 28.7,
        "0xB830F2E8c79bC95C4A510dCCaB8733f9a5518aD6": 28.61,
        "0x4dA2D718B3913A397adafB153E0a8cC9eBB91538": 28.47,
        "0x925b68151caFA2462072dDF4F5Ed8a904B72e3B7": 28.31,
        "0xE13e2E75d990FC711f4291A1F1f31ecf7c022c6a": 28.15,
        "0xf8cae0bEA24ffd0a3816CE6041E4d0BEc5FBfFcF": 27.98,
        "0xE560dafD581eb3eFCa1d881Bc5e163Bf8d5638a9": 27.74,
        "0x249636eD23B8E9fc7F29039A3Ba58d9E1e095a15": 27.67,
        "0x570b86aC7E3cB18A1bc9506F6Ecb7fF724D284fa": 27.08,
        "0x7B7502ce9936EFDDB1FAC9bFcBCDdC9CC5dc3F78": 27.04,
        "0xA50743fd3E6F09eEa7a599a47df121f4828009ca": 26.85,
        "0x4FeeD749b133178c3F332487097B0d863dd78a6c": 26.81,
        "0xFa0a6dcb914f37F0dD0A12a05d2202A74082e7Ca": 26.77,
        "0x96a622890cBbD877DF21Dd6E7C13b24Ae3c65899": 26.67,
        "0x9d76602DfE65a41b2e3dD169286B52194B1f07Ba": 26.23,
        "0x949ce1AB9C2e0f25ebd5Babd752602A69A869E4D": 26.22,
        "0x90B7925ABbBc6993984FF77F49E574f31d01C4B3": 26.22,
        "0x999D001Ad9a65484A9602819A2edE9312048E700": 26.2,
        "0x5871f6E44e8c55e491989E8b02b30D07fe644aCC": 25.98,
        "0xf8cb29192EAED7aE17D48ed5399Dc6ef099FfC87": 25.78,
        "0x98684423D68EaBc356EBdB9185151Ca85b22aa55": 25.77,
        "0x7b687e853f5a5d1dd4dB668EBC4cC2e2A55f1321": 25.76,
        "0x4608A54b4131169cb8be48F16Afdc6B59418BbD5": 25.35,
        "0x2a3CF9E53f72ED5a66C7f129FaC3573B9Cb45944": 25.32,
        "0xCe0c58bcfBdae90Ba167806d3F49364188147DDC": 25,
        "0x8C2F9E6686c6245c80CA948fd196226b900DB99E": 24.54,
        "0xd173EB4569C4f9Ae7Db0d831c9B42F5333F921AE": 24.39,
        "0x987095086e4B0828f7B5940c2144E8aCB0f6D7b1": 23.55,
        "0x51C4066c1a5768741Bb9f0B36e3140293938eB75": 23.11,
        "0x5920367dcfb5b5B21ff3Da9BaefbEdA6e492039e": 23.07,
        "0x66095394a9AE846332d8E5903812DfA5C2C767F5": 22.79,
        "0x051FF3a24202015B23F9f43E686289495EA957D5": 22.38,
        "0x9c95818D0a5849CE399C4cc507ba6b84FB232E14": 22.31,
        "0x222002F70b0c46E98D917C85f13d8A983cE17Eb9": 22.04,
        "0x1397B7Eb17167Fa3dd0e9Ce8E812d28D59Df8A24": 22.02,
        "0xa434cb7aA39F68c74273903F68De0Fcdf38F54fc": 21.91,
        "0xc23B5b3d84a6c69Ef2e4FE662A28177468779EC4": 21.9,
        "0xf75729DCA43E96dc38F519d1dbefB950Ae95A507": 21.86,
        "0x6B166050F772b4764fdC0fB48b54487dF789B79A": 21.81,
        "0x6472f525Ad132e5c6B95914EacBe00256f4AcAe6": 21.78,
        "0x578c38Dbf0Ac4c8c531C9f6990Cfcb395F3DD717": 21.23,
        "0x2D152f1d1C9f2996d320900322C3878783bbe65f": 20.03,
        "0xfe9f00bC42e4315292C2a9FC8fC6a709FfecE39E": 19.2,
        "0x8bE208ED153b39d3cAdd25850FBC79e82900Ea70": 19.1,
        "0xAe134FE39514669B53242D8143257e94258e5E15": 18.07,
        "0x08eEA99D856B199f3Bf5A098dbE214fC7d1d8C63": 17.99,
        "0x985aEDed5e93D4cF39B79A2d89C3E5cA6BCa63a1": 17.21,
        "0x3812e585425bA78a67555f956c67bBaF62Cfcd67": 16.6,
        "0xc0678901b7906847228A486e71e85c898D2d62f4": 16,
        "0xEEF2262E43d5D5705dbfA7100d253d9Bb8e725d0": 15.82,
        "0xBf0a2f317b26758f9D39498cE033c33d44668790": 15.57,
        "0x103Ac82DAf13Da683F6251DC0c5008198Fb2A402": 15.45,
        "0x4F9a907625F7A67F30021Bd518898285953b8379": 15.4,
        "0x6ca338F7fa82Ac712C0fe9A4f2e44589866A4312": 14.85,
        "0x0a143F2EBBF81977090F823FB32186e1F0c5700B": 14.76,
        "0x8DD9a9f0041Ac8Da5ac7301821092cE929C3671C": 14.71,
        "0xef983451269Cf2b9e9cf7450D45799164120c9F2": 14.7,
        "0x553fECebaB4ebE71aC9b4Ff364A787F7Cbd8E797": 14.44,
        "0xF9b8094dC2C96dE90A15e4f882A3F595E1eCc8e6": 14.3,
        "0xa7D4d3Ec1536dAbB5CBF36765E783ed2A39DF9a8": 14.07,
        "0x28C974C18C6553B445c4B77F35D83F3499ACF58f": 14,
        "0x10852dE7f9a406e3217f4F2724bCf936eb0E2ae2": 13.81,
        "0xE34A2Af4B14Cfb4Ff873CD661D0A4365ED1758D7": 13.35,
        "0xCcA219BB637C98C69604e8E748756ad969159b0A": 13.11,
        "0xfEC7DD486cb25BCfCc12a7d91FDb93763CcbB2b3": 13.02,
        "0xf6091C59B6b897949b00Ac51eA9Ae5855D8C5F7D": 12.81,
        "0x4489866B03b151D21f65Da49A8458737457E9336": 12.6,
        "0xc9f88D8012Be24DcF091777756490BA469562aD9": 12.41,
        "0x0c18a4b1909eFd6674A531381ff4C58e793Ef642": 12.25,
        "0x6b048681dAB87104f9346aA4043b71c7c4193100": 12.25,
        "0x7Bf571cC64A944b5B19049e86F3b6eb85c7f441F": 12.01,
        "0x480dFF6A733D56067a26780a7C4b776bab179cF5": 11.62,
        "0xd2Cf59180544e27Cdf04E128447Dd313dE267714": 11.59,
        "0x4a894cDaEe054403D61F0Acb3591D10e3adBB2B8": 11.52,
        "0x073524d9016d7880B41A81e2681728F9d37587B6": 11.47,
        "0x7B730244789f713DcDC063183C5ED2607DC2752b": 11.4,
        "0x8CfC187740b72F4E23254A6aCb50F12194285244": 11.1,
        "0xDb45eF81754d5e9A315380119D1717C008b4b966": 11.08,
        "0x2f5AAb38bf985ca3C022Ee60126C39af985384c5": 11.08,
        "0xe080Bb7FB300FA4Cd49De94Ca76C706fAC42Ff6d": 11.06,
        "0xf2b8C8C48089b5bd9731aDb85f71Ce503b853721": 11.06,
        "0x8D9Ec22af0947bE388B3bc32200fAD06cB9E9DFe": 11.06,
        "0x492d4012E4B6911A4234d2129D1e1851F7B2AB40": 11.05,
        "0xbF8DDDB85a055133bbF3b52C60efE5b65f4eA074": 11.01,
        "0x3fc725e13CBE95C04c3072A148B816323e2F312E": 10.99,
        "0x03c9B8F16A22c29d6d660b76749C9CF6367E318d": 10.99,
        "0x979ffFa5ae6824105258D616A2EAc5121b5D3DCd": 10.95,
        "0xbBed94cC68dE973a2aCb1d03d5bf9b8dDDe2f518": 10.58,
        "0xd759fEaad7A7863f46503A2EAB403e5127887e95": 10.57,
        "0x526a7b02b8c92A0c518b1879D6F560C7C7F6eD3e": 10.48,
        "0x6285f201641AE13d7aE9A272987f756C0a17C68d": 10.32,
        "0xddEBaf006161DcC12E0Ef9858562A1b535993265": 10.22,
        "0xb74F325337A52b64794A099cbEAB2CA2E586c4a5": 10.22,
        "0x0D7c47a0F4f7eE65e93eB7D4a8f0fa5233c8Be7d": 10.08,
        "0x7C817F5E30aa68DB39B6130E7cA247C5C4746084": 238095,
        "0xb6aeb1ACBcf87173A8228d1Cf893424EdF4bAbca": 238095,
        "0x83366286F18e2b012f5EE2cA08162d2420e66b8D": 238095,
        "0x30c31D48fCb0c99Fbc0c60c76c9f826DA992a442": 238095,
        "0xFAe30d758AfdAA9A92892b3C4e4AE4D6589F4122": 238095,
        "0x95bE88b05855b7573E480d29Bcd921da03CCAF41": 238095,
        "0xC4B6c1b27bE6269D61e9CFb396F0922D4cBd164a": 238095,
        "0xeA8604Ac433291F363304C5dd4352D9b9899d2bc": 238095,
        "0xf8DAd768B13c7e7a5E48a8679313922c6A690630": 238095,
        "0x87cb23a1566A609b0242e476bD4D37659eD88E10": 238095,
        "0x9C73C7534E33AcFa6533E49080C57f3EE7480D1D": 238095,
        "0x3363BEb08ef7Ba006B77D10b9A1feBC90f9b91c3": 238095,
        "0x7aBB334fd82456f77216dA59271e6c462Cb7c5E4": 6474.9939945213755,
        "0x54d646A7045eC3297a86f155AA63273f313472cD": 57136.355465249064,
        "0x8014A798cA117e4c44047f5C6cc617bc54296284": 559720.3941930532,
        "0x4c51CDFF2A977498BAd2DCc4c726F1bd49d510f5": 1375.3517870278226,
        "0x9031EDC59F87C3010ce2Fdb6Cc56249dA08E462A": 423492.9488918731,
        "0x9f7e246334Ba736298aA707BFBBf109437dd1C73": 13000.41333399022,
        "0x4d35586dD94dA4b85836A3aF8C5Dc8eF98F25423": 49329.05757043482,
        "0xCaF88361edD46a25d7CC09F3330321B8E4e8ad95": 148921.83810921732,
        "0x1747524Dc81dF4fA4b240f3f7121eB7C3a438311": 5629.79341104612,
        "0xD87d6036989453742111c179680dD654Fb597b09": 8967.03496440942,
        "0x5f81Ad8264B6fa7b02D5C0Ee1cc8EaEc5162b00A": 16277456.477890939,
        "0x2f9Ea193a21B446F62264A8F0c354C293447507F": 218989.89866855834,
        "0xD627675cFA739A63e818f1c70f99431D3088F6c6": 98.86073386723353,
        "0x8284e39e00A699B2D15482A70D2345F35787D7AB": 2752.743870866899,
        "0xC6b0f72362EFc59894c19c16cA6bbaC3480c1E36": 93.6164723473124,
        "0x83A10f39A5d70732Df6ac773325C531E2Fb8bDf7": 306.2552011745255,
        "0xf7f666d229B80a7418222FFb63082FD971D86a98": 115790.47846127457,
        "0xbE4CD16c4Ebd3A8ec66401cCA988D603EC7417c2": 1288.9421954498048,
        "0xe8cd33866A9C1FB4eF18294239dBe054f75B86c3": 5611.922088469647,
        "0x33727bDfd9d2c3Dc34f4460fE7073E7222790199": 4.781582566270575,
        "0x587923B84Ac90A30d6d3cf205c20EdE32c52B71D": 1264.234873691945,
        "0x988000ab27DC926Db6989455Bf4bF12207Bc1716": 579.4231071356314,
        "0x7DFE8348BBC87FCc78beCC3cD64B42CDE5Eac19b": 812.7896097018545,
        "0x2bdb4bC82584B4A38f863cB196d055F744e0be2B": 762.3779330132327,
        "0x9c7379CD61b830aAB5e6B3d97D099E212b8f78b7": 39104.13957515246,
        "0x51260A392E6416E2E07cAA816F17234F372D6E7b": 973.1763259801551,
        "0x9501238AD79F878253634b81907e4e38dfa1ba99": 1458.091397635208,
        "0x20D77A224476c1B4Ea6cb41aD805Cb7b185B2d93": 4223.651216580757,
        "0x602703827fD0B7B06666409380E6960dB79Dc8F4": 124811.12697149905,
        "0x33De82C19E3758c0c4E5d14d9Bcf9CD7dA6C8FfF": 17.011513696062647,
        "0xb1B4fdcff8fCC721A08BA2d538e46e1658Eeded6": 755.6997557915979,
        "0xeC5Bd81eebA9CaCa693caE608F9746f7cca19248": 139.72362260641216,
        "0x922E03871C8314f226d9fFA01E041CDF62FBfAA3": 25840.805761239637,
        "0x7A298E1E780cbbB23cC2eca3A9134769edf41769": 1221.04058441225,
        "0x492E3311a7254071FbB20f6afD6F6E5fAfe78C5E": 26.398719849808018,
        "0x4B4e6167559eca2917A0557dBb9Fbb7F5f1F79c7": 1339.1576716178554,
        "0x36185567fd629252B14186394BcA9427a548ac63": 12.152233866940492,
        "0xA794FEfFB7aAD1179D0094DAf9Fa8650F9125706": 3090.401035119582,
        "0x8281A28f6C6C8631d56C7337cf704dd2EBC71D51": 281.3155875211755,
        "0xaf524482ebd10D6017D5106D15a0B6DC986313a8": 102.87916332897977,
        "0xaA56828856Fd9D8e7171A04c464feB14604fc468": 55.01914631005602,
        "0x12f904cB257fb05dC24c1a2A1099D66DdE0cbA7f": 90.15224930196497,
        "0xc960517deE7a3FC8b1F28481fd82756023D3470D": 18.840086313472632,
        "0x417932ca3DA34bf3df20009512a85b2eEe9429c3": 35.5888830729162,
        "0x0950497149935D606e5eb0542Bc38E950C55EF31": 9.345422080802683,
        "0x1682dc9b3524d1Cccf5e786A398979EA49823C80": 3.5437677450815506,
        "0xB00e06Fcd33676962278dd701fc8EEBFc70Ee6BE": 5.316964936943793,
        "0x958e43563E71f8A1551721664CD4b1Ef38E5dCC2": 7.089694189079818,
        "0xE703d9C24c3AA138Ae1AC8f80D17035c2aB3fA05": 3.5165191960301394,
        "0xDE71d39943F9d9EFBE945ABeE5660f6f49370E43": 4.441889539208605,
        "0x9947d4eee33E4B9AEFcEA67B4Eba15D4cC13FF2b": 17.26208914871545,
        "0x9486800c38Ce242694e4575F85bd4CeD091f38D6": 10.360013653106831,
        "0xd1b2C07f92C5AD261F04ee2c16B6db8DcB849BfD": 5.539712376094366,
        "0x45a449bB4fc1AF4B6C7B284a862C0b9d13F8e3D7": 7.009706377809996,
        "0xFE8060C00FFf61DD9A8B51E67f5673809C421252": 5.867476771057574,
        "0xD15688D584bFcf5f3A18506C9ba2787f23951c67": 9.667832090298653,
        "0x78cD8fAe1faaC050e8B144F6d284c67ec6580D74": 6.653643143676329,
        "0x5e8CB425f2ef896cE8a5BD7A1696727E723A281b": 5.651413357859655,
        "0xd0Df19De162BC99D2Ceb91bdAB366381f35d40ad": 13.867724834999533,
        "0x7bFaF79751CC86aA1cFaECcB6C735fCc504e5FAB": 168.50779345048812,
        "0x9c4c81848310b8Bc368290476AEBaf726AC057C1": 3.568358242578482,
        "0x70007D1F0Bec4e7C19B3488847ddf27433b4362B": 11.649509021296437,
        "0x72Dd9FBC3AA9144484457eD0479d91d19d263Cfa": 4.804592533305394,
        "0x86502F711c69f502d4cDb4E5B5D6622B95A9AdC2": 3.5155857578571172,
        "0xDef985285B9Ae82190e4D6b5D7fe22E8E413aa49": 3.122310055754471,
        "0xDdD44AC778313955171cFB44E1C2A6bA95e88083": 6.22219243095965,
        "0x9B2017eA5E1B3333B627A51a5D507cC54C7b3879": 14.033901682087599,
        "0xA707fED65A5d587CdE00f4BE55D472486874641D": 18.192801818644288,
        "0x91Bce7FaFe5F2f6F32e44b14D5d42970115f1D93": 6.597055467438846,
        "0x1DbB31B4f9b7851Ae4Ad92B51a19589D86c711dD": 12.085421268125941,
        "0xDb0745Dfe7201bc2fE8d99349a15CBaf0e4957Ae": 11.41982878214455,
        "0xAf165497Ea57936b5d3BB25a67206efa49A3c137": 17.917009550002657,
        "0x00Bb75cF84E505ef4052d1Bb5bb9Ed0d5a139B8C": 12.158029967904149,
        "0x27021e64cbF292a8cfbcb7C05C33689c3aCfA093": 11.709653141760255,
        "0xc2bE9372ed3ed0bAE48D292d1aBcfE5F17022299": 23.38448414141736,
        "0x235Fddb667eDE4232D6A2dC4D1166126BB60Ba65": 61.33213112272912,
        "0xd266A14312A4e94A55Cad89e2e4C23D63E3eDBA5": 19.128036825004507,
        "0x8F9A5111058dc887422b9c5659a332a02B623bCA": 115.83690715770788,
        "0xcEbea527cC5F602A80F27dBF8C4600A56e2Fcef2": 17.34680585501083,
        "0xCe3f0eEC95346f091c8d41A756cc500F1B95d730": 34.787711895562744,
        "0x908Fd20D56F6b8f487A2bFeF337beA0c2c56116D": 363.2015736652446,
        "0xD3AdE00f17B4fC483b0E851B96dE2918A420356a": 23.656014257510268,
        "0x1e0CFAB35D47e17Dd0dd225a947ae734D9992711": 220.5692303157695,
        "0xC9eebecb1d0AfF4fb2B9978516E075A33639892C": 24314.657244716887,
        "0x5D2410bC46cdEbb2614D7184ed876A51571D25C4": 33.31001717266064,
        "0x23e7927c465EB26de853B8c9501EDFC0668EfdDf": 2.6772470435636597,
        "0x6Ee2134DC15D8126190Bbae8413F0dA37517a4da": 258.1194135125256,
        "0x421f6Fd6A2f6A5Fbe5b945F7eb475Bbba1F2e235": 28.197264869560122,
        "0x2F024F2D1dbbB27C23e74a74846A1D8c8A1b063c": 202.66360263261853,
        "0x95C0D59F297b35EDa58Ba9478DFAe997920382d4": 262.77445558266675,
        "0x815F84071a53108f3b66B229b1f08b741976026C": 9.481527705657857,
        "0x886Fabb99b6954060d903d3460107d3C46C694D9": 332.8190028090051,
        "0x1c2636f70fe58A15107d99187e9a740Bd9599Db9": 256.00471334754235,
        "0x433930d7aaA5EF8a64c88C03598144eF3F4E078b": 513.1171479003923,
        "0xf7d95638740f8f08037f51c1e9Fd84E07596FB70": 429.8648506493051,
        "0x6d61D4e6eA809636DEDaBd013c72b7dAA30C6aa3": 209.7616325555287,
        "0x90EA5ec076Ff3AE8824511B937F4b41A8eb7C6cB": 49.75833989952828,
        "0x3E3FED8f88803CAb8A252a4f4f0a2F4E39F408A3": 11498.885908541268,
        "0x1Da0Da91D9293659599D0F7c8283B2be197Efd6E": 26.869388406598105,
        "0xC3ae7c5d4CfDfBdF75d4b7d6AffFceC2010ca108": 36.503688780911,
        "0xB7Faecf3684B80a4432ebA09c49CFC0c3c8Bf9a1": 51.0300583886248,
        "0xc462e48680c98F0567447E4153cc052e32Fe5052": 47.59433956730954,
        "0x6189305574FBCeC639e9A6B3755fF30Fd15367D5": 21.81685607543642,
        "0xF2977F70D5cfa743a95b7A461CF82265FBc968bF": 26.54803444516165,
        "0xa2d4Ed08E7c93916aC888F056bCf01563551d3Dd": 1268.696315563271,
        "0xbCAe1C8f9D10397243414B3674511DB10eb8055B": 94.36324493305302,
        "0x2eD7EF6fa65CdaC11C9AbdAF14859590a5C6Dd8b": 104.95041853190203,
        "0x762230822f4aE3277EE95fCAE82B8541984E9F55": 4.667714829164952,
        "0xf77878a8a2E21Bd101e93D9f0224580412Db468E": 25.86518866678953,
        "0x8D511b7f21dc26b289E1dC17F0B6bb498Dd496aE": 50.94198345213883,
        "0x00af3342F8A3dC073aD1D06Faba93Bec3c72199C": 48.92221908734271,
        "0x2c7065d8171c61fBe1947A3228522dF5e17466C2": 25.40357166148559,
        "0x27dCF0486a9EB514a719AAe8f3E9E5bC609E4BeD": 6.646539627488751,
        "0x0772703c504eF3378145d204FEC6f75F2b95d35e": 44.452893591199796,
        "0x3464F2d6B55D4B234e772A1118420786374728cD": 5.81446048806023,
        "0x9Ba8A661B2B902F5D9Be61F7C86e9262A6F6753D": 11.863182074091755,
        "0xE747685EB979B349f62fAF36045846C1C706C37f": 218.2336687417277,
        "0x1AD7275Da49A8FFCd2385972505ef999d2992A01": 307.4008586666459,
        "0x647E1d3f6E71C6c77269951720C259a65d9986dA": 44.314764163812505,
        "0xda3E044Ea763B4Fd40990E825D4b87383bbE79E7": 300.80241997396166,
        "0xed362469d6448e918D06Bbcb1445aA6492299bf3": 177.67855490984252,
        "0x7aeEa1D0220bfa7A81d24404C542353b4Ae77e33": 302.70815904831073,
        "0x6A0fAD9b3fB072D37A5f38E7903eC7Dd2602C1a8": 333.4951010947708,
        "0xE42ccF9F9c316171F060aA5Bd8bA884809cF224E": 107.60857706219777,
        "0xE9a4fA3b639EE676b2dd542e378544f109FAD26b": 254.7077394325269,
        "0x80E371FF02C1498Ad353Ef51B6dd2F1d84817801": 5.566020846748329,
        "0x4f56E0d9962800a747894ffa9a6DAf310Fc80885": 275.88746715375646,
        "0x9c62e26e1d04aC2a52ED86133175fFBc4719AE4F": 550.9802185038774,
        "0xE132F0EbDf43b56b8A1Db9221eaf4bb6ac096479": 21.74905507338218,
        "0xc783285d693AEEaE429B2586Fc95d36BE2a21b70": 32.557655447708555,
        "0x7A114C6ED6059dB16777806607c7789056b8E9D4": 63.27483845616265,
        "0xF89DD52AD3cF073a715a792757a5fCc71144Aa93": 1514.8734213653481,
        "0x5C6b063F24d51Ad33a4F3E40A807A4B7Ee70bEA2": 20.371547702625957,
        "0x92c70E5e75f05f3EE1871eE5E032Da6a1bB0e2F6": 17.866581472969298,
        "0x3C75C4A38b15808b0c37c9B2E2cCee5982A73033": 28.79921076434454,
        "0x2eE216Bfb6A537903C30c678653216A5Ab7ACec4": 38.02913998881677,
        "0x745615edF158653787cce02f6337E9Ea2367d1dB": 38.01340066393324,
        "0x787D8913F20549DA279075965626b31F65a43Df8": 19.999634983444366,
        "0xe773D70db0c89327d38cDAba791B03a23F74B893": 50.898470217233374,
        "0xA703C99a18B72190809D132B6cf2E468a2047638": 498.7122988182558,
        "0x92fc7E46935d4A5627872cf7c25d5acC2B20C6Cf": 31.47663665133221,
        "0xdD731ba867d84662BBec3FA1B2A37B1128854851": 22.167119978205612,
        "0xB6cC2b09015333c26F192209a9B60170E48c68ff": 31.399099716868374,
        "0x9035D55928FaeB5e9EEb6057890386f9c6766456": 23.307019839484038,
        "0xa67c3FE7286DE855793F591894aDb2eC63B14210": 1.5153069549580045,
        "0x9Feb5d022d349E4DD0A66b103CA0F71FCDcB7B66": 150.75274465623224,
        "0x423cf485cd1E00A3C1371467fACd69937148ab77": 5849.655201384097,
        "0xe4F2dEB6D33CF9f7df0B837D709932711a091791": 11.826835949613102,
        "0x9969F990668f1a19f2Ee467Ec096a4eFb64A6712": 627.187222118396,
        "0x7C0bF246662A1d75879d6ca05E98A2DEeD3DD27A": 12.184965484158218,
        "0x84452B96551948c5e138DCfd0a68aECE811Fd9eB": 51.79862122713112,
        "0xDcDcc333C591361d28bC7597CcD60b7Cd3c1390a": 21.659631243264776,
        "0x9400Dae240Ce46076D51889fecdfCbF844a2b5E1": 101.4891129916981,
        "0x87377f6DAF8557911980e06CA4BEEdC8d8C4D7E0": 107.77767699775715,
        "0x7E47F99c25012e8d48f2E4d0CCaca9476C434026": 144.9560569236387,
        "0x394c42a99Dc150A251C6da19AFd4A99DC4015183": 28.45656876089183,
        "0xf3E4D4c934daB2AC2B7169a182a343D71c6F5C32": 58.51280572300394,
        "0x4E6c3181A13d8202afb4A05DD6Fd219779eEe510": 166.08503203094153,
        "0x0405Aa75C72BB3208DF2e7CCB2E1517e32E8E074": 121.88257099566852,
        "0xAad96ca7B36c0c6ba68068Ff00e2A64a8F39A370": 16.05620981711977,
        "0xCCcae96C6933ab882FefaC6C248A758a78F5aaB7": 297.22603280693284,
        "0xb7DD55DD0CEcf0b223f08c7a92838b259d05C5B2": 1778.6021974295275,
        "0x87c1dD79107f8f3Df27212115eF5cD55C6D29E6c": 2.225533165938707,
        "0x7b5e4402C7f9cD74E76FD61da0a990fe8d71033F": 203.22329428442694,
        "0x11f0cf9e8b9ED7ACCBb077660a5f4Ac136A9008B": 19.211115637018356,
        "0x43d46f559B4Ef5147788cFD258327601F7C0E832": 19.481100292720672,
        "0x6851Fab8f533Fce9b6B9C2C11180A8471855f7CD": 26.331235114217645,
        "0x93d0cfafA6e7c7992dc7cA37BcaB8e3CcC10B00A": 43.25613939672413,
        "0x2d8b27b3C546fdcb62e6e25754dDfA0ef175012E": 39.007507656227624,
        "0x84DeF126aCD5C683c7BC87b217E96725dd7015cB": 38.44548327939449,
        "0xcd07a1c6f1585f61d523a18285d31C7Fd300F9b8": 27.90145259588832,
        "0x89bED6d28467C5D7ced8253602600664388B8c6b": 52.883575512828735,
        "0xded9A9Ee6894B493937a7C97c579c4D2004a169c": 13.451632653811528,
        "0x863A16BA953631F6654b1FD5DF16653631835E5f": 107.16392747634939,
        "0xb77962F35603Abbe625E5Ed6892083Bb19aFBF6f": 9.402539191475944,
        "0xf55bF27Bb07714f002E6B0488690e86b1aCeFB4C": 10.473328567567346,
        "0x4A81856E683fe62aE01f7E16F906FB7c6B5fFd02": 12.381578292022146,
        "0x681E654f57551eDeA5B2AB13E92c23d12f1eBD98": 13.86795734729371,
        "0x9f2e2b06D7aC683DdBD6Ee6234C17931bEfcA3BC": 8.639458761302665,
        "0xb06c99D2A82C3e9bbA941cFc1F24fe28f03bFD5c": 9.298907315193286,
        "0xbD5FE00B0Ad590730f3BafFFE44AEc153b83adfA": 69.9083443100796,
        "0x628DC8cD9662626780137245D009dFe567DD0592": 9.793202000578233,
        "0x1ffC6fE74384f2CE30648435218D94336AC3286d": 39.98550473086901,
        "0x516F04b3f7c461b4aDd6e24Df67b7d94b14Bcf8f": 28.681383697282094,
        "0x79E77C6cD12b61CdBff48B1A36E15c6C81F07f27": 10.541704753464515,
        "0x212d269A00C5FAA82Fe942B3a10FF92a859b6970": 7.8409065218552305,
        "0x20DC7891F1723A3b3c7E1E513dcd23c0e34Fad6C": 2.053513269581291,
        "0x1Bf47C11E2dA7e1D944D07f82D22DC6919033fe9": 12.87154060816333,
        "0x15b3c05a613b07d146E4bfe6A7D3a567e95f270E": 42.548303928605456,
        "0xB018AC399491B9320A456ad0e696D2032b6bADD3": 3.792500289449844,
        "0x58AC0B0277C233e3326012829eb96c31d0e3D629": 31.189067742900555,
        "0x84B82bA093638bcF8a58502dF09ae12014035e15": 8.614195206729786,
        "0x443F76837a399f3d875f2091f3f0487da1aE3C58": 759.8072207878254,
        "0x3bD921f1EB9e0bbb61f450bcfeb14611Fd9CC8c8": 85.67356218908849,
        "0xe26e68edD85a8226A3Fd60950E27A21FbC68534e": 15.549573181030828,
        "0xfdcDD671dD1084BAe26029B83d182c186F3De0d0": 28.32361164921322,
        "0x7004fc6bE38C22DACef50585Bf6Aec34f5dCa307": 35.20629898719501,
        "0x3984332F9d2FF818558b3826f7Af16e1c0F27883": 6.914505220203873,
        "0x9aeF2490dC3FBc6C406c4Fbd468b2365fB6950F2": 6.148353558957351,
        "0x9b434e020D4549C4E076ad8A468e592dE05B65B8": 7.049977933327021,
        "0xAaD1Be0B9941bEB57c6Bbf19B139296f2fdc2253": 1.8142058817900852,
        "0x521b0dEDdd40ee4806eEcd75c614Fe6DAc08AB16": 153384.93772961447,
        "0x0fab1e91272ef605F6Ad98091648ca1c6b1588c0": 133024.97696776316,
        "0xaF6BB82C5dE6DA6EB2a6885b3Ae36bb2ef3DA857": 152911.73706236496,
        "0x69CCcaEDa7b402f0Bb32e75D4391f0220FE0226C": 66404.16984924179,
        "0x20c9b776445c11e91F46aa048d57Dd9C2F4F6Fdb": 10858745.623371275,
        "0x758EFdc4323291f4CF76d5373252748956a871AE": 39530.53707414624,
        "0x40108E09c56E071000771E547bAa190f033Df4c2": 1247.2745109798434,
        "0x23894dd02bCf6137F4d3d4D66ddA0cD87dEb6963": 3744.5316688709754,
        "0x17ADA4246E8fb104ae35C5915138188881c2A96A": 350.3343184384311,
        "0xDfa86bbD208d4918702b183D83C442C08f45d225": 353.01261187594633,
        "0x7e8c960Baba244751c382CaFFF0933af033F950E": 212147.8796317066,
        "0x0Bfd6e674e98751B1b4e9EcbC183Cb79Da16b8F0": 206002.86829617742,
        "0xACe11cFA05d568D8877dfab30669E8d18b0725d3": 6189.12701830654,
        "0x723d93Df6881fBa4A8eBeb1368132C4b210d6723": 1599.264193274394,
        "0x6611C2Ee26FCcE4ee722455269a38b20D693026E": 661109.8425616325,
        "0x7c937Ae25a6F616CdCECDbc25eA6C21B6BBDd478": 97159.11692915128,
        "0x87A7cD1469Bd7a7844220a382127c607255fc59f": 307145.22190584877,
        "0x5d490C4a0B5D12C317e24D5198becFA304F72929": 93.63016127872811,
        "0xfEB5e8e0Ea252e8fF494E2d9C1beb640a8D7428A": 9626.65349169521,
        "0x18C449e8be17bD57E4d20DBc936cA1cd2554e56d": 192002.61645869038,
        "0x03eacF88f8D1F0ff862c33377b45e2b6806FD7e7": 1501542.007999075,
        "0x7d2C48765c8552A8f15e3c07E59F97c0A6e84d36": 682540.2182611466,
        "0x4b67945A88B434f22eC1308aD89769FD35127A5F": 1596.5333555759064,
        "0x2d5E088c705e4370A6f35C4eaAa10D0E9dE6c895": 955794.3853890446,
        "0x87A9756D8eEB60E662b87DA5B895762274395c73": 15.860335764596329,
        "0x0B7DA26f2a9551DA450539f80718590B60D34Fb3": 680.2028334448654,
        "0x196862F31Cd635FEaa3a19d9344C6e1Aa1b7191E": 472.00975512604,
        "0x9c6f8dDc36F93Adb7CB9F768EA50BEdac9713963": 283.04017732874087,
        "0x3B9Cf58143F78be52435D00D403FF5BD73B3693F": 228164.55393081415
    }
};

/**
 * Generate Merkle Tree leaf from address and value
 * @param {string} address of airdrop claimee
 * @param {string} value of airdrop tokens to claimee
 * @returns {Buffer} Merkle Tree node
 */
export function generateLeaf(address: string, value: string): Buffer {
    return Buffer.from(
        // Hash in appropriate Merkle format
        solidityKeccak256(["address", "uint256"], [address, value])
            .slice(2),
        "hex"
    );
}

// Setup merkle tree
export const merkleTree = new MerkleTree(
    // Generate leafs
    Object.entries(AIRDROP_USERS_JSON.airdrop).map(([address, tokens]) =>
        generateLeaf(
            getAddress(address),
            parseUnits((tokens as any).toString(), 18).toString()
        )
    ),
    // Hashing function
    keccak256,
    { sortPairs: true }
);

